'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var querystring = require('querystring');
var require$$2 = require('react-router-dom');
var reactQuery = require('@tanstack/react-query');

function _interopNamespaceDefault(e) {
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

function _setPrototypeOf$4(o, p) {
  _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$4(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$4(subClass, superClass);
}

var Subscribable = /*#__PURE__*/function () {
  function Subscribable() {
    this.listeners = [];
  }

  var _proto = Subscribable.prototype;

  _proto.subscribe = function subscribe(listener) {
    var _this = this;

    var callback = listener || function () {
      return undefined;
    };

    this.listeners.push(callback);
    this.onSubscribe();
    return function () {
      _this.listeners = _this.listeners.filter(function (x) {
        return x !== callback;
      });

      _this.onUnsubscribe();
    };
  };

  _proto.hasListeners = function hasListeners() {
    return this.listeners.length > 0;
  };

  _proto.onSubscribe = function onSubscribe() {// Do nothing
  };

  _proto.onUnsubscribe = function onUnsubscribe() {// Do nothing
  };

  return Subscribable;
}();

function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}

// TYPES
// UTILS
var isServer = typeof window === 'undefined';
function noop$4() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function ensureQueryKeyArray(value) {
  return Array.isArray(value) ? value : [value];
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return _extends$4({}, arg3, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return _extends$4({}, arg2, {
    queryKey: arg1
  });
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [_extends$4({}, arg2, {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function mapQueryStatusFilter(active, inactive) {
  if (active === true && inactive === true || active == null && inactive == null) {
    return 'all';
  } else if (active === false && inactive === false) {
    return 'none';
  } else {
    // At this point, active|inactive can only be true|false or false|true
    // so, when only one value is provided, the missing one has to be the negated value
    var isActive = active != null ? active : !inactive;
    return isActive ? 'active' : 'inactive';
  }
}
function matchQuery(filters, query) {
  var active = filters.active,
      exact = filters.exact,
      fetching = filters.fetching,
      inactive = filters.inactive,
      predicate = filters.predicate,
      queryKey = filters.queryKey,
      stale = filters.stale;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  var queryStatusFilter = mapQueryStatusFilter(active, inactive);

  if (queryStatusFilter === 'none') {
    return false;
  } else if (queryStatusFilter !== 'all') {
    var isActive = query.isActive();

    if (queryStatusFilter === 'active' && !isActive) {
      return false;
    }

    if (queryStatusFilter === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetching === 'boolean' && query.isFetching() !== fetching) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  var exact = filters.exact,
      fetching = filters.fetching,
      predicate = filters.predicate,
      mutationKey = filters.mutationKey;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  var hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 */

function hashQueryKey(queryKey) {
  var asArray = ensureQueryKeyArray(queryKey);
  return stableValueHash(asArray);
}
/**
 * Hashes the value into a stable hash.
 */

function stableValueHash(value) {
  return JSON.stringify(value, function (_, val) {
    return isPlainObject$5(val) ? Object.keys(val).sort().reduce(function (result, key) {
      result[key] = val[key];
      return result;
    }, {}) : val;
  });
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(ensureQueryKeyArray(a), ensureQueryKeyArray(b));
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(function (key) {
      return !partialDeepEqual(a[key], b[key]);
    });
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  var array = Array.isArray(a) && Array.isArray(b);

  if (array || isPlainObject$5(a) && isPlainObject$5(b)) {
    var aSize = array ? a.length : Object.keys(a).length;
    var bItems = array ? b : Object.keys(b);
    var bSize = bItems.length;
    var copy = array ? [] : {};
    var equalItems = 0;

    for (var i = 0; i < bSize; i++) {
      var key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}

function isPlainObject$5(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  var ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  var prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return typeof value === 'string' || Array.isArray(value);
}
function sleep(timeout) {
  return new Promise(function (resolve) {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  Promise.resolve().then(callback).catch(function (error) {
    return setTimeout(function () {
      throw error;
    });
  });
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }
}

var FocusManager = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(FocusManager, _Subscribable);

  function FocusManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onFocus) {
      var _window;

      if (!isServer && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onFocus();
        }; // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }
    };

    return _this;
  }

  var _proto = FocusManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (focused) {
      if (typeof focused === 'boolean') {
        _this2.setFocused(focused);
      } else {
        _this2.onFocus();
      }
    });
  };

  _proto.setFocused = function setFocused(focused) {
    this.focused = focused;

    if (focused) {
      this.onFocus();
    }
  };

  _proto.onFocus = function onFocus() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isFocused = function isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  };

  return FocusManager;
}(Subscribable);
var focusManager = new FocusManager();

var OnlineManager = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(OnlineManager, _Subscribable);

  function OnlineManager() {
    var _this;

    _this = _Subscribable.call(this) || this;

    _this.setup = function (onOnline) {
      var _window;

      if (!isServer && ((_window = window) == null ? void 0 : _window.addEventListener)) {
        var listener = function listener() {
          return onOnline();
        }; // Listen to online


        window.addEventListener('online', listener, false);
        window.addEventListener('offline', listener, false);
        return function () {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('online', listener);
          window.removeEventListener('offline', listener);
        };
      }
    };

    return _this;
  }

  var _proto = OnlineManager.prototype;

  _proto.onSubscribe = function onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  };

  _proto.onUnsubscribe = function onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  };

  _proto.setEventListener = function setEventListener(setup) {
    var _this$cleanup2,
        _this2 = this;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(function (online) {
      if (typeof online === 'boolean') {
        _this2.setOnline(online);
      } else {
        _this2.onOnline();
      }
    });
  };

  _proto.setOnline = function setOnline(online) {
    this.online = online;

    if (online) {
      this.onOnline();
    }
  };

  _proto.onOnline = function onOnline() {
    this.listeners.forEach(function (listener) {
      listener();
    });
  };

  _proto.isOnline = function isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  };

  return OnlineManager;
}(Subscribable);
var onlineManager = new OnlineManager();

function defaultRetryDelay(failureCount) {
  return Math.min(1000 * Math.pow(2, failureCount), 30000);
}

function isCancelable(value) {
  return typeof (value == null ? void 0 : value.cancel) === 'function';
}
var CancelledError = function CancelledError(options) {
  this.revert = options == null ? void 0 : options.revert;
  this.silent = options == null ? void 0 : options.silent;
};
function isCancelledError(value) {
  return value instanceof CancelledError;
} // CLASS

var Retryer = function Retryer(config) {
  var _this = this;

  var cancelRetry = false;
  var cancelFn;
  var continueFn;
  var promiseResolve;
  var promiseReject;
  this.abort = config.abort;

  this.cancel = function (cancelOptions) {
    return cancelFn == null ? void 0 : cancelFn(cancelOptions);
  };

  this.cancelRetry = function () {
    cancelRetry = true;
  };

  this.continueRetry = function () {
    cancelRetry = false;
  };

  this.continue = function () {
    return continueFn == null ? void 0 : continueFn();
  };

  this.failureCount = 0;
  this.isPaused = false;
  this.isResolved = false;
  this.isTransportCancelable = false;
  this.promise = new Promise(function (outerResolve, outerReject) {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  var resolve = function resolve(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  var reject = function reject(value) {
    if (!_this.isResolved) {
      _this.isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  var pause = function pause() {
    return new Promise(function (continueResolve) {
      continueFn = continueResolve;
      _this.isPaused = true;
      config.onPause == null ? void 0 : config.onPause();
    }).then(function () {
      continueFn = undefined;
      _this.isPaused = false;
      config.onContinue == null ? void 0 : config.onContinue();
    });
  }; // Create loop function


  var run = function run() {
    // Do nothing if already resolved
    if (_this.isResolved) {
      return;
    }

    var promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    } // Create callback to cancel this fetch


    cancelFn = function cancelFn(cancelOptions) {
      if (!_this.isResolved) {
        reject(new CancelledError(cancelOptions));
        _this.abort == null ? void 0 : _this.abort(); // Cancel transport if supported

        if (isCancelable(promiseOrValue)) {
          try {
            promiseOrValue.cancel();
          } catch (_unused) {}
        }
      }
    }; // Check if the transport layer support cancellation


    _this.isTransportCancelable = isCancelable(promiseOrValue);
    Promise.resolve(promiseOrValue).then(resolve).catch(function (error) {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (_this.isResolved) {
        return;
      } // Do we need to retry the request?


      var retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      var retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      var delay = typeof retryDelay === 'function' ? retryDelay(_this.failureCount, error) : retryDelay;
      var shouldRetry = retry === true || typeof retry === 'number' && _this.failureCount < retry || typeof retry === 'function' && retry(_this.failureCount, error);

      if (cancelRetry || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      _this.failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(_this.failureCount, error); // Delay

      sleep(delay) // Pause if the document is not visible or when the device is offline
      .then(function () {
        if (!focusManager.isFocused() || !onlineManager.isOnline()) {
          return pause();
        }
      }).then(function () {
        if (cancelRetry) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  run();
};

// CLASS
var NotifyManager = /*#__PURE__*/function () {
  function NotifyManager() {
    this.queue = [];
    this.transactions = 0;

    this.notifyFn = function (callback) {
      callback();
    };

    this.batchNotifyFn = function (callback) {
      callback();
    };
  }

  var _proto = NotifyManager.prototype;

  _proto.batch = function batch(callback) {
    var result;
    this.transactions++;

    try {
      result = callback();
    } finally {
      this.transactions--;

      if (!this.transactions) {
        this.flush();
      }
    }

    return result;
  };

  _proto.schedule = function schedule(callback) {
    var _this = this;

    if (this.transactions) {
      this.queue.push(callback);
    } else {
      scheduleMicrotask(function () {
        _this.notifyFn(callback);
      });
    }
  }
  /**
   * All calls to the wrapped function will be batched.
   */
  ;

  _proto.batchCalls = function batchCalls(callback) {
    var _this2 = this;

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this2.schedule(function () {
        callback.apply(void 0, args);
      });
    };
  };

  _proto.flush = function flush() {
    var _this3 = this;

    var queue = this.queue;
    this.queue = [];

    if (queue.length) {
      scheduleMicrotask(function () {
        _this3.batchNotifyFn(function () {
          queue.forEach(function (callback) {
            _this3.notifyFn(callback);
          });
        });
      });
    }
  }
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */
  ;

  _proto.setNotifyFunction = function setNotifyFunction(fn) {
    this.notifyFn = fn;
  }
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */
  ;

  _proto.setBatchNotifyFunction = function setBatchNotifyFunction(fn) {
    this.batchNotifyFn = fn;
  };

  return NotifyManager;
}(); // SINGLETON

var notifyManager = new NotifyManager();

// TYPES
// FUNCTIONS
var logger$2 = console;
function getLogger() {
  return logger$2;
}
function setLogger(newLogger) {
  logger$2 = newLogger;
}

// CLASS
var Query = /*#__PURE__*/function () {
  function Query(config) {
    this.abortSignalConsumed = false;
    this.hadObservers = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || this.getDefaultState(this.options);
    this.state = this.initialState;
    this.meta = config.meta;
    this.scheduleGc();
  }

  var _proto = Query.prototype;

  _proto.setOptions = function setOptions(options) {
    var _this$options$cacheTi;

    this.options = _extends$4({}, this.defaultOptions, options);
    this.meta = options == null ? void 0 : options.meta; // Default to 5 minutes if not cache time is set

    this.cacheTime = Math.max(this.cacheTime || 0, (_this$options$cacheTi = this.options.cacheTime) != null ? _this$options$cacheTi : 5 * 60 * 1000);
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.scheduleGc = function scheduleGc() {
    var _this = this;

    this.clearGcTimeout();

    if (isValidTimeout(this.cacheTime)) {
      this.gcTimeout = setTimeout(function () {
        _this.optionalRemove();
      }, this.cacheTime);
    }
  };

  _proto.clearGcTimeout = function clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  };

  _proto.optionalRemove = function optionalRemove() {
    if (!this.observers.length) {
      if (this.state.isFetching) {
        if (this.hadObservers) {
          this.scheduleGc();
        }
      } else {
        this.cache.remove(this);
      }
    }
  };

  _proto.setData = function setData(updater, options) {
    var _this$options$isDataE, _this$options;

    var prevData = this.state.data; // Get the new data

    var data = functionalUpdate(updater, prevData); // Use prev data if an isDataEqual function is defined and returns `true`

    if ((_this$options$isDataE = (_this$options = this.options).isDataEqual) == null ? void 0 : _this$options$isDataE.call(_this$options, prevData, data)) {
      data = prevData;
    } else if (this.options.structuralSharing !== false) {
      // Structurally share data between prev and new data if needed
      data = replaceEqualDeep(prevData, data);
    } // Set data and mark it as cached


    this.dispatch({
      data: data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt
    });
    return data;
  };

  _proto.setState = function setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state: state,
      setStateOptions: setStateOptions
    });
  };

  _proto.cancel = function cancel(options) {
    var _this$retryer;

    var promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(noop$4).catch(noop$4) : Promise.resolve();
  };

  _proto.destroy = function destroy() {
    this.clearGcTimeout();
    this.cancel({
      silent: true
    });
  };

  _proto.reset = function reset() {
    this.destroy();
    this.setState(this.initialState);
  };

  _proto.isActive = function isActive() {
    return this.observers.some(function (observer) {
      return observer.options.enabled !== false;
    });
  };

  _proto.isFetching = function isFetching() {
    return this.state.isFetching;
  };

  _proto.isStale = function isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function (observer) {
      return observer.getCurrentResult().isStale;
    });
  };

  _proto.isStaleByTime = function isStaleByTime(staleTime) {
    if (staleTime === void 0) {
      staleTime = 0;
    }

    return this.state.isInvalidated || !this.state.dataUpdatedAt || !timeUntilStale(this.state.dataUpdatedAt, staleTime);
  };

  _proto.onFocus = function onFocus() {
    var _this$retryer2;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnWindowFocus();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  };

  _proto.onOnline = function onOnline() {
    var _this$retryer3;

    var observer = this.observers.find(function (x) {
      return x.shouldFetchOnReconnect();
    });

    if (observer) {
      observer.refetch();
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
      this.hadObservers = true; // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer: observer
      });
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    if (this.observers.indexOf(observer) !== -1) {
      this.observers = this.observers.filter(function (x) {
        return x !== observer;
      });

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.retryer.isTransportCancelable || this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        if (this.cacheTime) {
          this.scheduleGc();
        } else {
          this.cache.remove(this);
        }
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer: observer
      });
    }
  };

  _proto.getObserversCount = function getObserversCount() {
    return this.observers.length;
  };

  _proto.invalidate = function invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  };

  _proto.fetch = function fetch(options, fetchOptions) {
    var _this2 = this,
        _this$options$behavio,
        _context$fetchOptions,
        _abortController$abor;

    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      var observer = this.observers.find(function (x) {
        return x.options.queryFn;
      });

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    var queryKey = ensureQueryKeyArray(this.queryKey);
    var abortController = getAbortController(); // Create query function context

    var queryFnContext = {
      queryKey: queryKey,
      pageParam: undefined,
      meta: this.meta
    };
    Object.defineProperty(queryFnContext, 'signal', {
      enumerable: true,
      get: function get() {
        if (abortController) {
          _this2.abortSignalConsumed = true;
          return abortController.signal;
        }

        return undefined;
      }
    }); // Create fetch function

    var fetchFn = function fetchFn() {
      if (!_this2.options.queryFn) {
        return Promise.reject('Missing queryFn');
      }

      _this2.abortSignalConsumed = false;
      return _this2.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    var context = {
      fetchOptions: fetchOptions,
      options: this.options,
      queryKey: queryKey,
      state: this.state,
      fetchFn: fetchFn,
      meta: this.meta
    };

    if ((_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch) {
      var _this$options$behavio2;

      (_this$options$behavio2 = this.options.behavior) == null ? void 0 : _this$options$behavio2.onFetch(context);
    } // Store state in case the current fetch needs to be reverted


    this.revertState = this.state; // Set to fetching state if not already in it

    if (!this.state.isFetching || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    } // Try to fetch the data


    this.retryer = new Retryer({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : (_abortController$abor = abortController.abort) == null ? void 0 : _abortController$abor.bind(abortController),
      onSuccess: function onSuccess(data) {
        _this2.setData(data); // Notify cache callback


        _this2.cache.config.onSuccess == null ? void 0 : _this2.cache.config.onSuccess(data, _this2); // Remove query after fetching if cache time is 0

        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onError: function onError(error) {
        // Optimistically update state if needed
        if (!(isCancelledError(error) && error.silent)) {
          _this2.dispatch({
            type: 'error',
            error: error
          });
        }

        if (!isCancelledError(error)) {
          // Notify cache callback
          _this2.cache.config.onError == null ? void 0 : _this2.cache.config.onError(error, _this2); // Log error

          getLogger().error(error);
        } // Remove query after fetching if cache time is 0


        if (_this2.cacheTime === 0) {
          _this2.optionalRemove();
        }
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay
    });
    this.promise = this.retryer.promise;
    return this.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = this.reducer(this.state, action);
    notifyManager.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onQueryUpdate(action);
      });

      _this3.cache.notify({
        query: _this3,
        type: 'queryUpdated',
        action: action
      });
    });
  };

  _proto.getDefaultState = function getDefaultState(options) {
    var data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    var hasInitialData = typeof options.initialData !== 'undefined';
    var initialDataUpdatedAt = hasInitialData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    var hasData = typeof data !== 'undefined';
    return {
      data: data,
      dataUpdateCount: 0,
      dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: false,
      isInvalidated: false,
      isPaused: false,
      status: hasData ? 'success' : 'idle'
    };
  };

  _proto.reducer = function reducer(state, action) {
    var _action$meta, _action$dataUpdatedAt;

    switch (action.type) {
      case 'failed':
        return _extends$4({}, state, {
          fetchFailureCount: state.fetchFailureCount + 1
        });

      case 'pause':
        return _extends$4({}, state, {
          isPaused: true
        });

      case 'continue':
        return _extends$4({}, state, {
          isPaused: false
        });

      case 'fetch':
        return _extends$4({}, state, {
          fetchFailureCount: 0,
          fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
          isFetching: true,
          isPaused: false
        }, !state.dataUpdatedAt && {
          error: null,
          status: 'loading'
        });

      case 'success':
        return _extends$4({}, state, {
          data: action.data,
          dataUpdateCount: state.dataUpdateCount + 1,
          dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: false,
          isInvalidated: false,
          isPaused: false,
          status: 'success'
        });

      case 'error':
        var error = action.error;

        if (isCancelledError(error) && error.revert && this.revertState) {
          return _extends$4({}, this.revertState);
        }

        return _extends$4({}, state, {
          error: error,
          errorUpdateCount: state.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: state.fetchFailureCount + 1,
          isFetching: false,
          isPaused: false,
          status: 'error'
        });

      case 'invalidate':
        return _extends$4({}, state, {
          isInvalidated: true
        });

      case 'setState':
        return _extends$4({}, state, action.state);

      default:
        return state;
    }
  };

  return Query;
}();

// CLASS
var QueryCache = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(QueryCache, _Subscribable);

  function QueryCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.queries = [];
    _this.queriesMap = {};
    return _this;
  }

  var _proto = QueryCache.prototype;

  _proto.build = function build(client, options, state) {
    var _options$queryHash;

    var queryKey = options.queryKey;
    var queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : hashQueryKeyByOptions(queryKey, options);
    var query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        queryKey: queryKey,
        queryHash: queryHash,
        options: client.defaultQueryOptions(options),
        state: state,
        defaultOptions: client.getQueryDefaults(queryKey),
        meta: options.meta
      });
      this.add(query);
    }

    return query;
  };

  _proto.add = function add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'queryAdded',
        query: query
      });
    }
  };

  _proto.remove = function remove(query) {
    var queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(function (x) {
        return x !== query;
      });

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'queryRemoved',
        query: query
      });
    }
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager.batch(function () {
      _this2.queries.forEach(function (query) {
        _this2.remove(query);
      });
    });
  };

  _proto.get = function get(queryHash) {
    return this.queriesMap[queryHash];
  };

  _proto.getAll = function getAll() {
    return this.queries;
  };

  _proto.find = function find(arg1, arg2) {
    var _parseFilterArgs = parseFilterArgs(arg1, arg2),
        filters = _parseFilterArgs[0];

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(function (query) {
      return matchQuery(filters, query);
    });
  };

  _proto.findAll = function findAll(arg1, arg2) {
    var _parseFilterArgs2 = parseFilterArgs(arg1, arg2),
        filters = _parseFilterArgs2[0];

    return Object.keys(filters).length > 0 ? this.queries.filter(function (query) {
      return matchQuery(filters, query);
    }) : this.queries;
  };

  _proto.notify = function notify(event) {
    var _this3 = this;

    notifyManager.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(event);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    var _this4 = this;

    notifyManager.batch(function () {
      _this4.queries.forEach(function (query) {
        query.onFocus();
      });
    });
  };

  _proto.onOnline = function onOnline() {
    var _this5 = this;

    notifyManager.batch(function () {
      _this5.queries.forEach(function (query) {
        query.onOnline();
      });
    });
  };

  return QueryCache;
}(Subscribable);

// CLASS
var Mutation = /*#__PURE__*/function () {
  function Mutation(config) {
    this.options = _extends$4({}, config.defaultOptions, config.options);
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.meta = config.meta;
  }

  var _proto = Mutation.prototype;

  _proto.setState = function setState(state) {
    this.dispatch({
      type: 'setState',
      state: state
    });
  };

  _proto.addObserver = function addObserver(observer) {
    if (this.observers.indexOf(observer) === -1) {
      this.observers.push(observer);
    }
  };

  _proto.removeObserver = function removeObserver(observer) {
    this.observers = this.observers.filter(function (x) {
      return x !== observer;
    });
  };

  _proto.cancel = function cancel() {
    if (this.retryer) {
      this.retryer.cancel();
      return this.retryer.promise.then(noop$4).catch(noop$4);
    }

    return Promise.resolve();
  };

  _proto.continue = function _continue() {
    if (this.retryer) {
      this.retryer.continue();
      return this.retryer.promise;
    }

    return this.execute();
  };

  _proto.execute = function execute() {
    var _this = this;

    var data;
    var restored = this.state.status === 'loading';
    var promise = Promise.resolve();

    if (!restored) {
      this.dispatch({
        type: 'loading',
        variables: this.options.variables
      });
      promise = promise.then(function () {
        // Notify cache callback
        _this.mutationCache.config.onMutate == null ? void 0 : _this.mutationCache.config.onMutate(_this.state.variables, _this);
      }).then(function () {
        return _this.options.onMutate == null ? void 0 : _this.options.onMutate(_this.state.variables);
      }).then(function (context) {
        if (context !== _this.state.context) {
          _this.dispatch({
            type: 'loading',
            context: context,
            variables: _this.state.variables
          });
        }
      });
    }

    return promise.then(function () {
      return _this.executeMutation();
    }).then(function (result) {
      data = result; // Notify cache callback

      _this.mutationCache.config.onSuccess == null ? void 0 : _this.mutationCache.config.onSuccess(data, _this.state.variables, _this.state.context, _this);
    }).then(function () {
      return _this.options.onSuccess == null ? void 0 : _this.options.onSuccess(data, _this.state.variables, _this.state.context);
    }).then(function () {
      return _this.options.onSettled == null ? void 0 : _this.options.onSettled(data, null, _this.state.variables, _this.state.context);
    }).then(function () {
      _this.dispatch({
        type: 'success',
        data: data
      });

      return data;
    }).catch(function (error) {
      // Notify cache callback
      _this.mutationCache.config.onError == null ? void 0 : _this.mutationCache.config.onError(error, _this.state.variables, _this.state.context, _this); // Log error

      getLogger().error(error);
      return Promise.resolve().then(function () {
        return _this.options.onError == null ? void 0 : _this.options.onError(error, _this.state.variables, _this.state.context);
      }).then(function () {
        return _this.options.onSettled == null ? void 0 : _this.options.onSettled(undefined, error, _this.state.variables, _this.state.context);
      }).then(function () {
        _this.dispatch({
          type: 'error',
          error: error
        });

        throw error;
      });
    });
  };

  _proto.executeMutation = function executeMutation() {
    var _this2 = this,
        _this$options$retry;

    this.retryer = new Retryer({
      fn: function fn() {
        if (!_this2.options.mutationFn) {
          return Promise.reject('No mutationFn found');
        }

        return _this2.options.mutationFn(_this2.state.variables);
      },
      onFail: function onFail() {
        _this2.dispatch({
          type: 'failed'
        });
      },
      onPause: function onPause() {
        _this2.dispatch({
          type: 'pause'
        });
      },
      onContinue: function onContinue() {
        _this2.dispatch({
          type: 'continue'
        });
      },
      retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
      retryDelay: this.options.retryDelay
    });
    return this.retryer.promise;
  };

  _proto.dispatch = function dispatch(action) {
    var _this3 = this;

    this.state = reducer$3(this.state, action);
    notifyManager.batch(function () {
      _this3.observers.forEach(function (observer) {
        observer.onMutationUpdate(action);
      });

      _this3.mutationCache.notify(_this3);
    });
  };

  return Mutation;
}();
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}

function reducer$3(state, action) {
  switch (action.type) {
    case 'failed':
      return _extends$4({}, state, {
        failureCount: state.failureCount + 1
      });

    case 'pause':
      return _extends$4({}, state, {
        isPaused: true
      });

    case 'continue':
      return _extends$4({}, state, {
        isPaused: false
      });

    case 'loading':
      return _extends$4({}, state, {
        context: action.context,
        data: undefined,
        error: null,
        isPaused: false,
        status: 'loading',
        variables: action.variables
      });

    case 'success':
      return _extends$4({}, state, {
        data: action.data,
        error: null,
        status: 'success',
        isPaused: false
      });

    case 'error':
      return _extends$4({}, state, {
        data: undefined,
        error: action.error,
        failureCount: state.failureCount + 1,
        isPaused: false,
        status: 'error'
      });

    case 'setState':
      return _extends$4({}, state, action.state);

    default:
      return state;
  }
}

// CLASS
var MutationCache = /*#__PURE__*/function (_Subscribable) {
  _inheritsLoose(MutationCache, _Subscribable);

  function MutationCache(config) {
    var _this;

    _this = _Subscribable.call(this) || this;
    _this.config = config || {};
    _this.mutations = [];
    _this.mutationId = 0;
    return _this;
  }

  var _proto = MutationCache.prototype;

  _proto.build = function build(client, options, state) {
    var mutation = new Mutation({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state: state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined,
      meta: options.meta
    });
    this.add(mutation);
    return mutation;
  };

  _proto.add = function add(mutation) {
    this.mutations.push(mutation);
    this.notify(mutation);
  };

  _proto.remove = function remove(mutation) {
    this.mutations = this.mutations.filter(function (x) {
      return x !== mutation;
    });
    mutation.cancel();
    this.notify(mutation);
  };

  _proto.clear = function clear() {
    var _this2 = this;

    notifyManager.batch(function () {
      _this2.mutations.forEach(function (mutation) {
        _this2.remove(mutation);
      });
    });
  };

  _proto.getAll = function getAll() {
    return this.mutations;
  };

  _proto.find = function find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(function (mutation) {
      return matchMutation(filters, mutation);
    });
  };

  _proto.findAll = function findAll(filters) {
    return this.mutations.filter(function (mutation) {
      return matchMutation(filters, mutation);
    });
  };

  _proto.notify = function notify(mutation) {
    var _this3 = this;

    notifyManager.batch(function () {
      _this3.listeners.forEach(function (listener) {
        listener(mutation);
      });
    });
  };

  _proto.onFocus = function onFocus() {
    this.resumePausedMutations();
  };

  _proto.onOnline = function onOnline() {
    this.resumePausedMutations();
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    var pausedMutations = this.mutations.filter(function (x) {
      return x.state.isPaused;
    });
    return notifyManager.batch(function () {
      return pausedMutations.reduce(function (promise, mutation) {
        return promise.then(function () {
          return mutation.continue().catch(noop$4);
        });
      }, Promise.resolve());
    });
  };

  return MutationCache;
}(Subscribable);

function infiniteQueryBehavior() {
  return {
    onFetch: function onFetch(context) {
      context.fetchFn = function () {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        var refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        var fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        var pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        var isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        var isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        var oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        var oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        var abortController = getAbortController();
        var abortSignal = abortController == null ? void 0 : abortController.signal;
        var newPageParams = oldPageParams;
        var cancelled = false; // Get query function

        var queryFn = context.options.queryFn || function () {
          return Promise.reject('Missing queryFn');
        };

        var buildNewPages = function buildNewPages(pages, param, page, previous) {
          newPageParams = previous ? [param].concat(newPageParams) : [].concat(newPageParams, [param]);
          return previous ? [page].concat(pages) : [].concat(pages, [page]);
        }; // Create function to fetch a page


        var fetchPage = function fetchPage(pages, manual, param, previous) {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          var queryFnContext = {
            queryKey: context.queryKey,
            signal: abortSignal,
            pageParam: param,
            meta: context.meta
          };
          var queryFnResult = queryFn(queryFnContext);
          var promise = Promise.resolve(queryFnResult).then(function (page) {
            return buildNewPages(pages, param, page, previous);
          });

          if (isCancelable(queryFnResult)) {
            var promiseAsAny = promise;
            promiseAsAny.cancel = queryFnResult.cancel;
          }

          return promise;
        };

        var promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
            var manual = typeof pageParam !== 'undefined';
            var param = manual ? pageParam : getNextPageParam(context.options, oldPages);
            promise = fetchPage(oldPages, manual, param);
          } // Fetch previous page?
          else if (isFetchingPreviousPage) {
              var _manual = typeof pageParam !== 'undefined';

              var _param = _manual ? pageParam : getPreviousPageParam(context.options, oldPages);

              promise = fetchPage(oldPages, _manual, _param, true);
            } // Refetch pages
            else {
                (function () {
                  newPageParams = [];
                  var manual = typeof context.options.getNextPageParam === 'undefined';
                  var shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

                  promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

                  var _loop = function _loop(i) {
                    promise = promise.then(function (pages) {
                      var shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

                      if (shouldFetchNextPage) {
                        var _param2 = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);

                        return fetchPage(pages, manual, _param2);
                      }

                      return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                  };

                  for (var i = 1; i < oldPages.length; i++) {
                    _loop(i);
                  }
                })();
              }

        var finalPromise = promise.then(function (pages) {
          return {
            pages: pages,
            pageParams: newPageParams
          };
        });
        var finalPromiseAsAny = finalPromise;

        finalPromiseAsAny.cancel = function () {
          cancelled = true;
          abortController == null ? void 0 : abortController.abort();

          if (isCancelable(promise)) {
            promise.cancel();
          }
        };

        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}

// CLASS
var QueryClient = /*#__PURE__*/function () {
  function QueryClient(config) {
    if (config === void 0) {
      config = {};
    }

    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
  }

  var _proto = QueryClient.prototype;

  _proto.mount = function mount() {
    var _this = this;

    this.unsubscribeFocus = focusManager.subscribe(function () {
      if (focusManager.isFocused() && onlineManager.isOnline()) {
        _this.mutationCache.onFocus();

        _this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager.subscribe(function () {
      if (focusManager.isFocused() && onlineManager.isOnline()) {
        _this.mutationCache.onOnline();

        _this.queryCache.onOnline();
      }
    });
  };

  _proto.unmount = function unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
  };

  _proto.isFetching = function isFetching(arg1, arg2) {
    var _parseFilterArgs = parseFilterArgs(arg1, arg2),
        filters = _parseFilterArgs[0];

    filters.fetching = true;
    return this.queryCache.findAll(filters).length;
  };

  _proto.isMutating = function isMutating(filters) {
    return this.mutationCache.findAll(_extends$4({}, filters, {
      fetching: true
    })).length;
  };

  _proto.getQueryData = function getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  };

  _proto.getQueriesData = function getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref) {
      var queryKey = _ref.queryKey,
          state = _ref.state;
      var data = state.data;
      return [queryKey, data];
    });
  };

  _proto.setQueryData = function setQueryData(queryKey, updater, options) {
    var parsedOptions = parseQueryArgs(queryKey);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(updater, options);
  };

  _proto.setQueriesData = function setQueriesData(queryKeyOrFilters, updater, options) {
    var _this2 = this;

    return notifyManager.batch(function () {
      return _this2.getQueryCache().findAll(queryKeyOrFilters).map(function (_ref2) {
        var queryKey = _ref2.queryKey;
        return [queryKey, _this2.setQueryData(queryKey, updater, options)];
      });
    });
  };

  _proto.getQueryState = function getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  };

  _proto.removeQueries = function removeQueries(arg1, arg2) {
    var _parseFilterArgs2 = parseFilterArgs(arg1, arg2),
        filters = _parseFilterArgs2[0];

    var queryCache = this.queryCache;
    notifyManager.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        queryCache.remove(query);
      });
    });
  };

  _proto.resetQueries = function resetQueries(arg1, arg2, arg3) {
    var _this3 = this;

    var _parseFilterArgs3 = parseFilterArgs(arg1, arg2, arg3),
        filters = _parseFilterArgs3[0],
        options = _parseFilterArgs3[1];

    var queryCache = this.queryCache;

    var refetchFilters = _extends$4({}, filters, {
      active: true
    });

    return notifyManager.batch(function () {
      queryCache.findAll(filters).forEach(function (query) {
        query.reset();
      });
      return _this3.refetchQueries(refetchFilters, options);
    });
  };

  _proto.cancelQueries = function cancelQueries(arg1, arg2, arg3) {
    var _this4 = this;

    var _parseFilterArgs4 = parseFilterArgs(arg1, arg2, arg3),
        filters = _parseFilterArgs4[0],
        _parseFilterArgs4$ = _parseFilterArgs4[1],
        cancelOptions = _parseFilterArgs4$ === void 0 ? {} : _parseFilterArgs4$;

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    var promises = notifyManager.batch(function () {
      return _this4.queryCache.findAll(filters).map(function (query) {
        return query.cancel(cancelOptions);
      });
    });
    return Promise.all(promises).then(noop$4).catch(noop$4);
  };

  _proto.invalidateQueries = function invalidateQueries(arg1, arg2, arg3) {
    var _ref3,
        _filters$refetchActiv,
        _filters$refetchInact,
        _this5 = this;

    var _parseFilterArgs5 = parseFilterArgs(arg1, arg2, arg3),
        filters = _parseFilterArgs5[0],
        options = _parseFilterArgs5[1];

    var refetchFilters = _extends$4({}, filters, {
      // if filters.refetchActive is not provided and filters.active is explicitly false,
      // e.g. invalidateQueries({ active: false }), we don't want to refetch active queries
      active: (_ref3 = (_filters$refetchActiv = filters.refetchActive) != null ? _filters$refetchActiv : filters.active) != null ? _ref3 : true,
      inactive: (_filters$refetchInact = filters.refetchInactive) != null ? _filters$refetchInact : false
    });

    return notifyManager.batch(function () {
      _this5.queryCache.findAll(filters).forEach(function (query) {
        query.invalidate();
      });

      return _this5.refetchQueries(refetchFilters, options);
    });
  };

  _proto.refetchQueries = function refetchQueries(arg1, arg2, arg3) {
    var _this6 = this;

    var _parseFilterArgs6 = parseFilterArgs(arg1, arg2, arg3),
        filters = _parseFilterArgs6[0],
        options = _parseFilterArgs6[1];

    var promises = notifyManager.batch(function () {
      return _this6.queryCache.findAll(filters).map(function (query) {
        return query.fetch(undefined, _extends$4({}, options, {
          meta: {
            refetchPage: filters == null ? void 0 : filters.refetchPage
          }
        }));
      });
    });
    var promise = Promise.all(promises).then(noop$4);

    if (!(options == null ? void 0 : options.throwOnError)) {
      promise = promise.catch(noop$4);
    }

    return promise;
  };

  _proto.fetchQuery = function fetchQuery(arg1, arg2, arg3) {
    var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
    var defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    var query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  };

  _proto.prefetchQuery = function prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(noop$4).catch(noop$4);
  };

  _proto.fetchInfiniteQuery = function fetchInfiniteQuery(arg1, arg2, arg3) {
    var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
    parsedOptions.behavior = infiniteQueryBehavior();
    return this.fetchQuery(parsedOptions);
  };

  _proto.prefetchInfiniteQuery = function prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(noop$4).catch(noop$4);
  };

  _proto.cancelMutations = function cancelMutations() {
    var _this7 = this;

    var promises = notifyManager.batch(function () {
      return _this7.mutationCache.getAll().map(function (mutation) {
        return mutation.cancel();
      });
    });
    return Promise.all(promises).then(noop$4).catch(noop$4);
  };

  _proto.resumePausedMutations = function resumePausedMutations() {
    return this.getMutationCache().resumePausedMutations();
  };

  _proto.executeMutation = function executeMutation(options) {
    return this.mutationCache.build(this, options).execute();
  };

  _proto.getQueryCache = function getQueryCache() {
    return this.queryCache;
  };

  _proto.getMutationCache = function getMutationCache() {
    return this.mutationCache;
  };

  _proto.getDefaultOptions = function getDefaultOptions() {
    return this.defaultOptions;
  };

  _proto.setDefaultOptions = function setDefaultOptions(options) {
    this.defaultOptions = options;
  };

  _proto.setQueryDefaults = function setQueryDefaults(queryKey, options) {
    var result = this.queryDefaults.find(function (x) {
      return hashQueryKey(queryKey) === hashQueryKey(x.queryKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey: queryKey,
        defaultOptions: options
      });
    }
  };

  _proto.getQueryDefaults = function getQueryDefaults(queryKey) {
    var _this$queryDefaults$f;

    return queryKey ? (_this$queryDefaults$f = this.queryDefaults.find(function (x) {
      return partialMatchKey(queryKey, x.queryKey);
    })) == null ? void 0 : _this$queryDefaults$f.defaultOptions : undefined;
  };

  _proto.setMutationDefaults = function setMutationDefaults(mutationKey, options) {
    var result = this.mutationDefaults.find(function (x) {
      return hashQueryKey(mutationKey) === hashQueryKey(x.mutationKey);
    });

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey: mutationKey,
        defaultOptions: options
      });
    }
  };

  _proto.getMutationDefaults = function getMutationDefaults(mutationKey) {
    var _this$mutationDefault;

    return mutationKey ? (_this$mutationDefault = this.mutationDefaults.find(function (x) {
      return partialMatchKey(mutationKey, x.mutationKey);
    })) == null ? void 0 : _this$mutationDefault.defaultOptions : undefined;
  };

  _proto.defaultQueryOptions = function defaultQueryOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    var defaultedOptions = _extends$4({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options, {
      _defaulted: true
    });

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = hashQueryKeyByOptions(defaultedOptions.queryKey, defaultedOptions);
    }

    return defaultedOptions;
  };

  _proto.defaultQueryObserverOptions = function defaultQueryObserverOptions(options) {
    return this.defaultQueryOptions(options);
  };

  _proto.defaultMutationOptions = function defaultMutationOptions(options) {
    if (options == null ? void 0 : options._defaulted) {
      return options;
    }

    return _extends$4({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options, {
      _defaulted: true
    });
  };

  _proto.clear = function clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  };

  return QueryClient;
}();

var unstable_batchedUpdates = ReactDOM.unstable_batchedUpdates;

notifyManager.setBatchNotifyFunction(unstable_batchedUpdates);

var logger$1 = console;

setLogger(logger$1);

new QueryClient();

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var classnamesExports = {};
var classnames = {
  get exports(){ return classnamesExports; },
  set exports(v){ classnamesExports = v; },
};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}

					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
} (classnames));

var cn = classnamesExports;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var Size;
(function (Size) {
    Size["Small"] = "s";
    Size["Medium"] = "m";
    Size["Large"] = "l";
})(Size || (Size = {}));

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read$1(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread$1() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read$1(arguments[i]));
    return ar;
}

function _toConsumableArray$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Older browsers don't support event options, feature detect it.

// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi

var hasPassiveEvents = false;
if (typeof window !== 'undefined') {
  var passiveTestOptions = {
    get passive() {
      hasPassiveEvents = true;
      return undefined;
    }
  };
  window.addEventListener('testPassive', null, passiveTestOptions);
  window.removeEventListener('testPassive', null, passiveTestOptions);
}

var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);


var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPaddingRight = void 0;

// returns true if `el` should be allowed to receive touchmove events.
var allowTouchMove = function allowTouchMove(el) {
  return locks.some(function (lock) {
    if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) {
      return true;
    }

    return false;
  });
};

var preventDefault = function preventDefault(rawEvent) {
  var e = rawEvent || window.event;

  // For the case whereby consumers adds a touchmove event listener to document.
  // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
  // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
  // the touchmove event on document will break.
  if (allowTouchMove(e.target)) {
    return true;
  }

  // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
  if (e.touches.length > 1) return true;

  if (e.preventDefault) e.preventDefault();

  return false;
};

var setOverflowHidden = function setOverflowHidden(options) {
  // If previousBodyPaddingRight is already set, don't set it again.
  if (previousBodyPaddingRight === undefined) {
    var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
    var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;

    if (_reserveScrollBarGap && scrollBarGap > 0) {
      previousBodyPaddingRight = document.body.style.paddingRight;
      document.body.style.paddingRight = scrollBarGap + 'px';
    }
  }

  // If previousBodyOverflowSetting is already set, don't set it again.
  if (previousBodyOverflowSetting === undefined) {
    previousBodyOverflowSetting = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
};

var restoreOverflowSetting = function restoreOverflowSetting() {
  if (previousBodyPaddingRight !== undefined) {
    document.body.style.paddingRight = previousBodyPaddingRight;

    // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
    // can be set again.
    previousBodyPaddingRight = undefined;
  }

  if (previousBodyOverflowSetting !== undefined) {
    document.body.style.overflow = previousBodyOverflowSetting;

    // Restore previousBodyOverflowSetting to undefined
    // so setOverflowHidden knows it can be set again.
    previousBodyOverflowSetting = undefined;
  }
};

// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
  return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};

var handleScroll = function handleScroll(event, targetElement) {
  var clientY = event.targetTouches[0].clientY - initialClientY;

  if (allowTouchMove(event.target)) {
    return false;
  }

  if (targetElement && targetElement.scrollTop === 0 && clientY > 0) {
    // element is at the top of its scroll.
    return preventDefault(event);
  }

  if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) {
    // element is at the bottom of its scroll.
    return preventDefault(event);
  }

  event.stopPropagation();
  return true;
};

var disableBodyScroll = function disableBodyScroll(targetElement, options) {
  // targetElement must be provided
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
    return;
  }

  // disableBodyScroll must not have been called on this targetElement before
  if (locks.some(function (lock) {
    return lock.targetElement === targetElement;
  })) {
    return;
  }

  var lock = {
    targetElement: targetElement,
    options: options || {}
  };

  locks = [].concat(_toConsumableArray$1(locks), [lock]);

  if (isIosDevice) {
    targetElement.ontouchstart = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        initialClientY = event.targetTouches[0].clientY;
      }
    };
    targetElement.ontouchmove = function (event) {
      if (event.targetTouches.length === 1) {
        // detect single touch.
        handleScroll(event, targetElement);
      }
    };

    if (!documentListenerAdded) {
      document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = true;
    }
  } else {
    setOverflowHidden(options);
  }
};

var enableBodyScroll = function enableBodyScroll(targetElement) {
  if (!targetElement) {
    // eslint-disable-next-line no-console
    console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
    return;
  }

  locks = locks.filter(function (lock) {
    return lock.targetElement !== targetElement;
  });

  if (isIosDevice) {
    targetElement.ontouchstart = null;
    targetElement.ontouchmove = null;

    if (documentListenerAdded && locks.length === 0) {
      document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? { passive: false } : undefined);
      documentListenerAdded = false;
    }
  } else if (!locks.length) {
    restoreOverflowSetting();
  }
};

function createElement(tagName, attributes = {}) {
    const el = document.createElement(tagName);
    const { className } = attributes, attrs = __rest(attributes, ["className"]);
    if (className) {
        className.split(' ').forEach(className => el.classList.add(className));
    }
    Object.keys(attrs).forEach(name => {
        el.setAttribute(name, attributes[name]);
    });
    return el;
}
function getTargetByEvent(event) {
    return /scroll|resize/.test(event) ? window : document;
}
function removeEventListener(event, handler) {
    const target = getTargetByEvent(event);
    target.removeEventListener(event, handler);
}
function addEventListener(event, handler) {
    const target = getTargetByEvent(event);
    target.addEventListener(event, handler);
    return () => removeEventListener(event, handler);
}
function getWindowSize() {
    return {
        top: 0,
        right: window.innerWidth,
        bottom: window.innerHeight,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight,
    };
}
function getElementSize(element) {
    const { top, right, bottom, left } = element.getBoundingClientRect();
    return {
        top,
        right,
        bottom,
        left,
        width: right - left,
        height: bottom - top,
    };
}
function containsNode(parent, child) {
    return parent === child || (parent.contains && parent.contains(child));
}
const browser = typeof window !== 'undefined' && window.document && window.document.createElement;
function getElementPseudoContent(el, selector = 'before') {
    return window.getComputedStyle(el, `:${selector}`).content.replace(/"|'/g, '');
}
function getScrollWidth() {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.width = '50px';
    scrollDiv.style.position = '50px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}

function getDropdownLaunchpad() {
    return (Array.from(document.body.childNodes).find(el => el.dataset && 'dropdownLaunchpad' in el.dataset) || null);
}
const useScrollLock = (target, enabled = true, recalculateIgnore = 0) => {
    const allowedScroll = React.useRef([]);
    const dropdownLaunchpad = React.useRef(null);
    const elementsCache = React.useRef(new Map());
    const allowTouchMove = React.useCallback(el => {
        if (elementsCache.current.has(el)) {
            return elementsCache.current.get(el);
        }
        if (dropdownLaunchpad.current && containsNode(dropdownLaunchpad.current, el)) {
            elementsCache.current.set(el, true);
            return true;
        }
        if (allowedScroll.current.length === 0) {
            return;
        }
        return allowedScroll.current.some(scr => {
            const result = containsNode(scr, el);
            elementsCache.current.set(el, result);
            return result;
        });
    }, []);
    React.useEffect(() => {
        dropdownLaunchpad.current = getDropdownLaunchpad();
        if (dropdownLaunchpad.current) {
            return;
        }
        const observer = new MutationObserver(() => {
            dropdownLaunchpad.current = getDropdownLaunchpad();
            if (dropdownLaunchpad.current) {
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList: true });
        return () => {
            observer.disconnect();
        };
    }, []);
    React.useEffect(() => {
        var _a;
        allowedScroll.current = Array.from(((_a = target.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[data-scroll-lock-ignore]')) || []);
    }, [target.current, recalculateIgnore]);
    React.useEffect(() => {
        const node = target.current;
        if (enabled && node) {
            disableBodyScroll(node, { allowTouchMove });
        }
        return () => {
            if (node) {
                enableBodyScroll(node);
            }
        };
    }, [target.current, enabled]);
};

const useFocus = (initValue = false, handlers) => {
    const [focus, setFocus] = React.useState(initValue);
    const onFocus = React.useCallback((event) => {
        setFocus(true);
        if (handlers && handlers.onFocus) {
            handlers.onFocus(event);
        }
    }, [handlers]);
    const onBlur = React.useCallback((event) => {
        setFocus(false);
        if (handlers && handlers.onBlur) {
            handlers.onBlur(event);
        }
    }, [handlers]);
    React.useEffect(() => {
        setFocus(initValue);
    }, [initValue]);
    return [
        focus,
        {
            onFocus,
            onBlur,
        },
    ];
};
var useFocus$1 = useFocus;

const useHover = (initValue, handlers, disabled) => {
    const [hover, setHover] = React.useState(initValue);
    const onMouseEnter = React.useCallback((event) => {
        if (disabled) {
            return;
        }
        setHover(true);
        if (handlers.onMouseEnter) {
            handlers.onMouseEnter(event);
        }
    }, [disabled, handlers]);
    const onMouseLeave = React.useCallback((event) => {
        if (disabled) {
            return;
        }
        setHover(false);
        if (handlers.onMouseLeave) {
            handlers.onMouseLeave(event);
        }
    }, [disabled, handlers]);
    React.useEffect(() => {
        setHover(initValue);
    }, [initValue]);
    return [
        hover,
        {
            onMouseEnter,
            onMouseLeave,
        },
    ];
};
var useHover$1 = useHover;

const useEventListener = (eventName, handler, elementRef) => {
    const savedHandler = React.useRef();
    React.useEffect(() => {
        savedHandler.current = handler;
    }, [handler]);
    React.useEffect(() => {
        const element = elementRef.current;
        const isSupported = element && element.addEventListener;
        if (!isSupported) {
            return;
        }
        const eventListener = (event) => savedHandler.current(event);
        element.addEventListener(eventName, eventListener);
        return () => {
            element.removeEventListener(eventName, eventListener);
        };
    }, [eventName, elementRef]);
};
var useEventListener$1 = useEventListener;

const usePressed = (initValue, handlers) => {
    const [pressed, setPress] = React.useState(initValue);
    const onMouseDown = React.useCallback((event) => {
        if (event.button === 2) {
            return;
        }
        setPress(true);
        if (handlers.onMouseDown) {
            handlers.onMouseDown(event);
        }
    }, [handlers]);
    const onMouseUp = React.useCallback((event) => {
        if (event.button === 2) {
            return;
        }
        setPress(false);
        if (handlers.onMouseUp) {
            handlers.onMouseUp(event);
        }
    }, [handlers]);
    const documentRef = React.useRef(typeof document === 'undefined' ? null : document);
    useEventListener$1('mouseup', onMouseUp, documentRef);
    React.useEffect(() => {
        setPress(initValue);
    }, [initValue]);
    return [
        pressed,
        {
            onMouseUp,
            onMouseDown,
        },
    ];
};
var usePressed$1 = usePressed;

var ViewState;
(function (ViewState) {
    ViewState["Disabled"] = "disabled";
    ViewState["Focus"] = "focus";
    ViewState["Hover"] = "hover";
    ViewState["Press"] = "press";
})(ViewState || (ViewState = {}));
var ViewState$1 = ViewState;

const useViewState = (viewState) => {
    const state = React.useMemo(() => {
        switch (true) {
            case viewState.disabled:
                return ViewState$1.Disabled;
            case viewState.pressed:
                return ViewState$1.Press;
            case viewState.hovered:
                return ViewState$1.Hover;
            case viewState.focused:
                return ViewState$1.Focus;
            default:
                return;
        }
    }, [viewState.disabled, viewState.focused, viewState.hovered, viewState.pressed]);
    return state;
};
var useViewState$1 = useViewState;

var css_248z$1q = ".base-module_base__Pp3al{align-items:center;box-sizing:border-box;cursor:pointer;display:inline-flex;outline:none;overflow:hidden;position:relative;-webkit-text-decoration:none;text-decoration:none;touch-action:manipulation;-webkit-user-select:none;-moz-user-select:none;user-select:none;white-space:nowrap;will-change:background-color}.base-module_base-text__m9Pzf{font-family:ALS Hauss,Tahoma,Helvetica Neue,Arial,sans-serif;font-size:16px;line-height:20px}.base-module_button__KcooJ{background-color:transparent;border:none;border-radius:4px;color:#211f2e;justify-content:center;padding:8px 16px;transition:background-color 50ms linear}.base-module_text__e4Nlg{flex:1 1;overflow:hidden;pointer-events:none;resize:none;text-overflow:ellipsis}.base-module_full-width__QaEQF{width:100%}.base-module_size-s__q4GbH{height:40px}.base-module_size-m__NLEmR{height:52px}.base-module_size-l__tgOvE{height:60px}.base-module_before__rXAJ-{margin-right:16px}.base-module_after__qJFHr{margin-left:16px}.base-module_base__Pp3al.base-module_disabled__trjOd{color:#a4a1b5;cursor:default}";
var baseStyles$1 = {"base":"base-module_base__Pp3al","base-text":"base-module_base-text__m9Pzf","button":"base-module_button__KcooJ","text":"base-module_text__e4Nlg","full-width":"base-module_full-width__QaEQF","size-s":"base-module_size-s__q4GbH","size-m":"base-module_size-m__NLEmR","size-l":"base-module_size-l__tgOvE","before":"base-module_before__rXAJ-","after":"base-module_after__qJFHr","disabled":"base-module_disabled__trjOd"};
styleInject(css_248z$1q);

function isModifiedEvent(event) {
    return Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

const BaseButton = React.forwardRef((_a, ref) => {
    var { focused: focusedInit = false, hovered: hoveredInit = false, pressed: pressedInit = false, fullWidth = false, size = Size.Medium, disabled, className, styles = {}, children, before, after, dataTest, dataGtm, navigate, onClick, target } = _a, rest = __rest(_a, ["focused", "hovered", "pressed", "fullWidth", "size", "disabled", "className", "styles", "children", "before", "after", "dataTest", "dataGtm", "navigate", "onClick", "target"]);
    const Component = rest.href && rest.href.length ? 'a' : 'button';
    const buttonStyles = React.useMemo(() => (Object.assign(Object.assign({}, baseStyles$1), styles)), [styles]);
    const [focused, focusHandlers] = useFocus$1(focusedInit, rest);
    const [hovered, hoverHandlers] = useHover$1(hoveredInit, rest, disabled);
    const [pressed, pressHandlers] = usePressed$1(pressedInit, rest);
    const viewState = useViewState$1({
        disabled,
        focused,
        hovered,
        pressed,
    });
    const classNames = cn(buttonStyles.base, buttonStyles.baseText, buttonStyles.button, {
        [buttonStyles[`${viewState}`]]: viewState,
        [buttonStyles.fullWidth]: fullWidth,
        [buttonStyles[`size-${size}`]]: size,
    }, className);
    const handleClick = React.useCallback((event) => {
        if (onClick) {
            try {
                onClick(event);
            }
            catch (ex) {
                event.preventDefault();
                throw ex;
            }
        }
        if (navigate &&
            !event.defaultPrevented &&
            event.button === 0 &&
            (!target || target === '_self') &&
            !isModifiedEvent(event)) {
            event.preventDefault();
            navigate();
        }
    }, [target, navigate, onClick]);
    return (React.createElement(Component, Object.assign({}, rest, { target: target, ref: ref, className: classNames, disabled: disabled, onClick: handleClick }, focusHandlers, hoverHandlers, pressHandlers, { "data-test": dataTest || rest['data-test'], "data-gtm": dataGtm }),
        before && React.createElement("span", { className: buttonStyles.before }, before),
        React.createElement("span", { className: buttonStyles.text }, children),
        after && React.createElement("span", { className: buttonStyles.after }, after)));
});

var css_248z$1p = ".icon-module_icon__WAadn{background-repeat:no-repeat;background-size:contain;display:inline-block;line-height:1;position:relative}.icon-module_icon__WAadn svg{height:100%;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:100%}.icon-module_icon__WAadn:after{content:\"\\00A0\";display:inline-block;height:100%;vertical-align:middle;visibility:hidden}.icon-module_icon-color-white__UsMAg{fill:#fff}.icon-module_icon-color-black__ACCHv{fill:#211f2e}.icon-module_icon-color-blue__yyxd2{fill:#3416b6}.icon-module_icon-color-red__-aZaX{fill:#f44434}.icon-module_icon-color-green__PpB5g{fill:#87d232}.icon-module_icon-color-gray__5sE38{fill:#a4a1b5}.icon-module_icon-size-l__N9PSk{height:32px;width:32px}.icon-module_icon-size-m__q97d1{height:24px;width:24px}.icon-module_icon-size-s__j0hBL{height:16px;width:16px}";
var styles$z = {"icon":"icon-module_icon__WAadn","icon-color-white":"icon-module_icon-color-white__UsMAg","icon-color-black":"icon-module_icon-color-black__ACCHv","icon-color-blue":"icon-module_icon-color-blue__yyxd2","icon-color-red":"icon-module_icon-color-red__-aZaX","icon-color-green":"icon-module_icon-color-green__PpB5g","icon-color-gray":"icon-module_icon-color-gray__5sE38","icon-size-l":"icon-module_icon-size-l__N9PSk","icon-size-m":"icon-module_icon-size-m__q97d1","icon-size-s":"icon-module_icon-size-s__j0hBL"};
styleInject(css_248z$1p);

const Icon$5 = (_a) => {
    var { src, bg = false, className = null, size = Size.Small, color } = _a, props = __rest(_a, ["src", "bg", "className", "size", "color"]);
    let innerHtml;
    if (!bg && src) {
        innerHtml = { __html: src };
    }
    return (React.createElement("i", Object.assign({}, props, { className: cn(styles$z.icon, className, styles$z[`icon-size-${size}`], {
            [styles$z[`icon-color-${color}`]]: color,
        }), dangerouslySetInnerHTML: innerHtml })));
};
var Icon$6 = Icon$5;

var Color;
(function (Color) {
    Color["White"] = "white";
    Color["Black"] = "black";
    Color["Blue"] = "blue";
    Color["Red"] = "red";
    Color["Green"] = "green";
    Color["Gray"] = "gray";
})(Color || (Color = {}));

var css_248z$1o = ".paper-module_paper__V7D-P{background-color:#fff;padding:20px}.paper-module_shadow-level-5__ghOIo{box-shadow:0 20px 24px rgba(34,48,119,.12)}.paper-module_shadow-level-4__WVdG2{box-shadow:0 12px 20px rgba(34,48,119,.12)}.paper-module_shadow-level-3__oiHZI{box-shadow:0 8px 12px rgba(37,50,116,.08)}.paper-module_shadow-level-2__W0pkS{box-shadow:0 4px 8px rgba(37,50,116,.08)}.paper-module_shadow-level-1__ol378{box-shadow:0 4px 4px rgba(61,82,189,.04)}.paper-module_round-level-1__V5C8C{border-radius:4px}.paper-module_round-level-2__rhUHJ{border-radius:8px}.paper-module_round-level-3__q-FOk{border-radius:20px}";
var baseStyles = {"paper":"paper-module_paper__V7D-P","shadow-level-5":"paper-module_shadow-level-5__ghOIo","shadow-level-4":"paper-module_shadow-level-4__WVdG2","shadow-level-3":"paper-module_shadow-level-3__oiHZI","shadow-level-2":"paper-module_shadow-level-2__W0pkS","shadow-level-1":"paper-module_shadow-level-1__ol378","round-level-1":"paper-module_round-level-1__V5C8C","round-level-2":"paper-module_round-level-2__rhUHJ","round-level-3":"paper-module_round-level-3__q-FOk"};
styleInject(css_248z$1o);

const Paper = (_a) => {
    var { children, isRounded = false, isShaded = true, shadowLevel = 5, roundLevel = 1, className, styles = {}, dataTest } = _a, rest = __rest(_a, ["children", "isRounded", "isShaded", "shadowLevel", "roundLevel", "className", "styles", "dataTest"]);
    const componentStyles = Object.assign(Object.assign({}, baseStyles), styles);
    return (React.createElement("div", Object.assign({}, rest, { className: cn(componentStyles.paper, {
            [componentStyles[`shadowLevel${shadowLevel}`]]: isShaded,
            [componentStyles[`roundLevel${roundLevel}`]]: isRounded,
        }, className), "data-test": dataTest }), children));
};

var css_248z$1n = ".checkbox-module_checkbox__HduA5{align-items:flex-start;box-sizing:border-box;color:#211f2e;cursor:pointer;display:inline-flex;font-family:ALS Hauss,Tahoma,Helvetica Neue,Arial,sans-serif;font-size:16px;line-height:20px;position:relative;vertical-align:top}.checkbox-module_checkbox__HduA5>input{cursor:pointer;height:20px;left:0;margin:1px;opacity:0;padding:0;position:absolute;top:0;width:20px;z-index:1}.checkbox-module_checkbox-control__7PuzK{background-color:#fff;border:1px solid #ccc9d9;border-radius:4px;box-sizing:border-box;content:\"\";cursor:pointer;display:inline-block;flex-shrink:0;height:20px;width:20px;z-index:0}.checkbox-module_checkbox-control-hovered__OKUWd{border-color:#3416b6}.checkbox-module_checkbox-control-checked__06Y8M{align-items:center;background-color:#3416b6;border-color:#3416b6;display:inline-flex;justify-content:center}.checkbox-module_checkbox-control-shadow__FL-mO{box-shadow:0 8px 12px rgba(38,83,217,.08)}.checkbox-module_checkbox-control-disabled__Pxjgb{background-color:#eae9f2;border-color:#ccc9d9;cursor:default}.checkbox-module_checkbox-control-disabled__Pxjgb+input{cursor:default}.checkbox-module_checkbox-control-readonly__-l4uw{border-color:#a4a1b5;cursor:default}.checkbox-module_checkbox-control-readonly__-l4uw+input{cursor:default}.checkbox-module_checkbox-control-readonly-checked__hUQju{background-color:#a4a1b5}.checkbox-module_checkbox-control-disabled-cheched__MgHj9{border-color:#eae9f2}.checkbox-module_checkbox-disabled__QXsfE{color:#ccc9d9;cursor:default}.checkbox-module_checkbox-readonly__Ic7i7{color:#211f2e;cursor:default}.checkbox-module_checkbox-label__hTXJR{color:#211f2e;margin-left:8px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.checkbox-module_checkbox-label-checked__U1arm{color:#211f2e}.checkbox-module_checkbox-label-disabled__eS0tr{color:#a4a1b5}.checkbox-module_checkbox-label-hovered__RFgJA{color:#211f2e}";
var styles$y = {"checkbox":"checkbox-module_checkbox__HduA5","checkbox-control":"checkbox-module_checkbox-control__7PuzK","checkbox-control-hovered":"checkbox-module_checkbox-control-hovered__OKUWd","checkbox-control-checked":"checkbox-module_checkbox-control-checked__06Y8M","checkbox-control-shadow":"checkbox-module_checkbox-control-shadow__FL-mO","checkbox-control-disabled":"checkbox-module_checkbox-control-disabled__Pxjgb","checkbox-control-readonly":"checkbox-module_checkbox-control-readonly__-l4uw","checkbox-control-readonly-checked":"checkbox-module_checkbox-control-readonly-checked__hUQju","checkbox-control-disabled-cheched":"checkbox-module_checkbox-control-disabled-cheched__MgHj9","checkbox-disabled":"checkbox-module_checkbox-disabled__QXsfE","checkbox-readonly":"checkbox-module_checkbox-readonly__Ic7i7","checkbox-label":"checkbox-module_checkbox-label__hTXJR","checkbox-label-checked":"checkbox-module_checkbox-label-checked__U1arm","checkbox-label-disabled":"checkbox-module_checkbox-label-disabled__eS0tr","checkbox-label-hovered":"checkbox-module_checkbox-label-hovered__RFgJA"};
styleInject(css_248z$1n);

var svg$2 = "<svg viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.05 2.76l-6 6.5-4-3.08.9-1.2 2.93 2.26 5.07-5.5 1.1 1.02z\"/></svg>";

var css_248z$1m = ".styles-module_close-icon__mmINR{background-image:url(tick.svg)}";
var styles$x = {"close-icon":"styles-module_close-icon__mmINR"};
styleInject(css_248z$1m);

const TickIcon = (_a) => {
    var { bg, className } = _a, props = __rest(_a, ["bg", "className"]);
    return React.createElement(Icon$6, Object.assign({}, props, { bg: bg, className: cn(className, { [styles$x.closeIcon]: bg }), src: svg$2 }));
};
var TickIcon$1 = TickIcon;

const Checkbox$1 = (_a) => {
    var { children, checked = false, disabled = false, readOnly = false, hover: hoverInit = false, focus: focusInit = false, autoComplete = 'off', onChange, dataTest, dataGtm } = _a, rest = __rest(_a, ["children", "checked", "disabled", "readOnly", "hover", "focus", "autoComplete", "onChange", "dataTest", "dataGtm"]);
    const [hovered, hoverHandlers] = useHover$1(hoverInit, rest, disabled);
    const [, focusHandlers] = useFocus$1(focusInit, rest);
    const changeHandler = React.useCallback((event) => {
        if (readOnly) {
            return;
        }
        if (onChange) {
            onChange(event.target.checked, event);
        }
    }, [onChange, readOnly]);
    const labelStyles = {
        [styles$y.checkboxDisabled]: disabled,
        [styles$y.checkboxReadonly]: readOnly,
    };
    const controlStyles = {
        [styles$y.checkboxControlShadow]: hovered && checked,
        [styles$y.checkboxControlHovered]: hovered,
        [styles$y.checkboxControlChecked]: checked,
        [styles$y.checkboxControlDisabled]: disabled,
        [styles$y.checkboxControlDisabledCheched]: disabled && checked,
        [styles$y.checkboxControlReadonly]: readOnly,
        [styles$y.checkboxControlReadonlyChecked]: readOnly && checked,
    };
    const checkboxLabelStyles = {
        [styles$y.checkboxLabelDisabled]: disabled,
        [styles$y.checkboxLabelChecked]: checked,
        [styles$y.checkboxLabelHovered]: hovered,
    };
    return (React.createElement("label", Object.assign({ "data-test": dataTest, "data-gtm": dataGtm, className: cn(styles$y.checkbox, labelStyles, rest.className) }, hoverHandlers),
        React.createElement("input", Object.assign({ type: "checkbox" }, rest, focusHandlers, { autoComplete: autoComplete, checked: checked, readOnly: readOnly, disabled: disabled, onChange: changeHandler })),
        React.createElement("div", { className: cn(styles$y.checkboxControl, controlStyles) }, checked && React.createElement(TickIcon$1, { size: Size.Small, color: Color.White })),
        children && (React.createElement("span", { role: "presentation", className: cn(styles$y.checkboxLabel, checkboxLabelStyles) }, children))));
};

var svg$1 = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.97 18.75l9.53-9.53-1.06-1.06-8.47 8.47L3.5 8.16 2.44 9.22l9.53 9.53z\"/></svg>";

var css_248z$1l = ".styles-module_chevron-down-icon__NChVM{background-image:url(chevron-down.svg)}";
var styles$w = {"chevron-down-icon":"styles-module_chevron-down-icon__NChVM"};
styleInject(css_248z$1l);

const ChevronDownIcon = (_a) => {
    var { bg, className } = _a, props = __rest(_a, ["bg", "className"]);
    return React.createElement(Icon$6, Object.assign({}, props, { bg: bg, className: cn(className, { [styles$w.chevronDownIcon]: bg }), src: svg$1 }));
};

const mergeRefs = (source, ...targets) => {
    if (typeof window !== 'undefined') {
        requestAnimationFrame(() => {
            targets.forEach(target => {
                if (source && target) {
                    target.current = source.current;
                }
            });
        });
    }
    return source;
};
var mergeRefs$1 = mergeRefs;

var css_248z$1k = ".popup-module_popup__-p5kM{border:none;left:-99999px;position:absolute;visibility:hidden;will-change:top,left,visibility;z-index:10000}";
var styles$v = {"popup":"popup-module_popup__-p5kM"};
styleInject(css_248z$1k);

var Direction;
(function (Direction) {
    Direction["BottomLeft"] = "bottom-left";
    Direction["BottomCenter"] = "bottom-center";
    Direction["BottomRight"] = "bottom-right";
    Direction["TopLeft"] = "top-left";
    Direction["TopCenter"] = "top-center";
    Direction["TopRight"] = "top-right";
    Direction["RightTop"] = "right-top";
    Direction["RightCenter"] = "right-center";
    Direction["RightBottom"] = "right-bottom";
    Direction["LeftTop"] = "left-top";
    Direction["LeftCenter"] = "left-center";
    Direction["LeftBottom"] = "left-bottom";
})(Direction || (Direction = {}));

const getViewportFactor = (popupPosition, viewportDimensions, popupDimensions, offsets = {
    viewport: 0,
}) => {
    let viewportFactor = 0;
    const intersectionLeft = Math.max(popupPosition.left, viewportDimensions.left + offsets.viewport);
    const intersectionRight = Math.min(popupPosition.left + popupDimensions.width, viewportDimensions.right - offsets.viewport);
    const intersectionTop = Math.max(popupPosition.top, viewportDimensions.top + offsets.viewport);
    const intersectionBottom = Math.min(popupPosition.top + popupDimensions.height, viewportDimensions.bottom - offsets.viewport);
    if (intersectionLeft < intersectionRight && intersectionTop < intersectionBottom) {
        viewportFactor =
            ((intersectionRight - intersectionLeft) * (intersectionBottom - intersectionTop)) / popupDimensions.area;
    }
    return viewportFactor;
};

const checkMainDirection = (direction, mainFirstDirection, mainSecondDirection) => direction.indexOf(mainFirstDirection) === 0 ||
    (mainSecondDirection && direction.indexOf(mainSecondDirection) === 0);
const checkSecondaryDirection = (direction, secondaryDirection) => direction.indexOf('-' + secondaryDirection) > 0;

const getPopupPosition = (direction, anchorDimensions, popupDimensions, offsets = {
    secondary: 0,
    main: 0,
}) => {
    const position = { left: 0, top: 0 };
    if (checkMainDirection(direction, 'bottom')) {
        position.top = anchorDimensions.top + anchorDimensions.height + offsets.main;
    }
    else if (checkMainDirection(direction, 'top')) {
        position.top = anchorDimensions.top - popupDimensions.height - offsets.main;
    }
    else if (checkMainDirection(direction, 'left')) {
        position.left = anchorDimensions.left - popupDimensions.width - offsets.main;
    }
    else if (checkMainDirection(direction, 'right')) {
        position.left = anchorDimensions.left + anchorDimensions.width + offsets.main;
    }
    if (checkSecondaryDirection(direction, 'right')) {
        position.left = anchorDimensions.left + anchorDimensions.width - popupDimensions.width - offsets.secondary;
    }
    else if (checkSecondaryDirection(direction, 'left')) {
        position.left = anchorDimensions.left + offsets.secondary;
    }
    else if (checkSecondaryDirection(direction, 'bottom')) {
        position.top = anchorDimensions.top + anchorDimensions.height - popupDimensions.height - offsets.secondary;
    }
    else if (checkSecondaryDirection(direction, 'top')) {
        position.top = anchorDimensions.top + offsets.secondary;
    }
    else if (checkSecondaryDirection(direction, 'center')) {
        if (checkMainDirection(direction, 'top', 'bottom')) {
            position.left = anchorDimensions.left + anchorDimensions.width / 2 - popupDimensions.width / 2;
        }
        else if (checkMainDirection(direction, 'left', 'right')) {
            position.top = anchorDimensions.top + anchorDimensions.height / 2 - popupDimensions.height / 2;
        }
    }
    return position;
};

const getAnchorDimensions = (anchorRef) => {
    const dimensions = {
        left: 0,
        top: 0,
        height: 0,
        width: 0,
    };
    if (anchorRef !== undefined && anchorRef.current) {
        const { offsetWidth, offsetHeight } = anchorRef.current;
        const { left, top } = anchorRef.current.getBoundingClientRect();
        dimensions.left = left + window.pageXOffset;
        dimensions.top = top + window.pageYOffset;
        dimensions.height = offsetHeight;
        dimensions.width = offsetWidth;
    }
    return dimensions;
};
const getPopupDimensions = (popupRef) => {
    const dimensions = {
        area: 0,
        height: 0,
        width: 0,
        popupHeight: 0,
        popupWidth: 0,
    };
    if (popupRef !== undefined && popupRef.current !== null && popupRef.current !== undefined) {
        const { clientWidth, clientHeight } = popupRef.current;
        const { width, height } = popupRef.current.getBoundingClientRect();
        dimensions.area = clientWidth * clientHeight;
        dimensions.height = Math.round(height);
        dimensions.width = Math.round(width);
        dimensions.popupHeight = clientHeight;
        dimensions.popupWidth = clientWidth;
    }
    return dimensions;
};
const getViewportDimensions = () => {
    return {
        top: window.pageYOffset,
        left: window.pageXOffset,
        bottom: window.pageYOffset + window.innerHeight,
        right: window.pageXOffset + window.innerWidth,
    };
};
const getScopeDimensions = (scopeRef) => {
    const dimensions = { top: 0, left: 0 };
    if (scopeRef !== undefined && scopeRef.current !== null) {
        const { left, top } = scopeRef.current.getBoundingClientRect();
        dimensions.top = top;
        dimensions.left = left;
    }
    return dimensions;
};

const VIEWPORT_ACCURACY_FACTOR = 0.99;
const getDrawingParams = (anchor, popupRef, directions, offsets, container) => {
    const anchorDimensions = getAnchorDimensions(anchor);
    const popupDimensions = getPopupDimensions(popupRef);
    const viewportDimensions = getViewportDimensions();
    const scopeDimensions = getScopeDimensions(container);
    let viewportFactor = 0;
    const params = {
        isVisible: false,
        direction: Direction.BottomLeft,
        popupPosition: { top: 0, left: 0 },
    };
    for (const nextDirection of directions) {
        const popupPosition = getPopupPosition(nextDirection, anchorDimensions, popupDimensions, offsets);
        const nextViewportFactor = getViewportFactor(popupPosition, viewportDimensions, popupDimensions, offsets);
        if (nextViewportFactor >= viewportFactor) {
            params.direction = nextDirection;
            viewportFactor = nextViewportFactor;
            params.isVisible = true;
            params.popupPosition = {
                top: popupPosition.top - (scopeDimensions.top + window.pageYOffset),
                left: popupPosition.left - (scopeDimensions.left + window.pageXOffset),
            };
        }
        if (viewportFactor > VIEWPORT_ACCURACY_FACTOR) {
            break;
        }
    }
    return params;
};
const getOffsets = ({ mainOffset, secondaryOffset, viewportOffset, }) => {
    return {
        main: mainOffset,
        secondary: secondaryOffset,
        viewport: viewportOffset,
    };
};
const DEFAULT_DIRECTIONS = [Direction.BottomCenter];
const Popup = (_a) => {
    var { anchor, visible = false, directions = DEFAULT_DIRECTIONS, innerRef, mainOffset = 0, secondaryOffset = 0, viewportOffset = 0, keepMounted = false, container = { current: browser ? document.body : null }, dataGtm } = _a, props = __rest(_a, ["anchor", "visible", "directions", "innerRef", "mainOffset", "secondaryOffset", "viewportOffset", "keepMounted", "container", "dataGtm"]);
    const timerRef = React.useRef(0);
    const popupRef = React.useRef(null);
    const updateRefsPosition = React.useCallback(() => {
        if (timerRef.current === 0) {
            if (popupRef.current !== null) {
                if (popupRef.current && !popupRef.current.style.top) {
                    popupRef.current.style.visibility = 'hidden';
                }
            }
        }
        window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(() => {
            const offsets = getOffsets({
                mainOffset,
                secondaryOffset,
                viewportOffset,
            });
            const params = getDrawingParams(anchor, popupRef, directions, offsets, container);
            if (popupRef.current && params.popupPosition) {
                popupRef.current.style.top = `${params.popupPosition.top}px`;
                popupRef.current.style.left = `${params.popupPosition.left}px`;
                popupRef.current.style.visibility = params.isVisible ? 'visible' : 'hidden';
            }
        }, 0);
    }, [anchor, container, directions, mainOffset, secondaryOffset, viewportOffset]);
    React.useEffect(() => {
        window.removeEventListener('scroll', updateRefsPosition);
        window.removeEventListener('resize', updateRefsPosition);
        if (visible) {
            updateRefsPosition();
            window.addEventListener('scroll', updateRefsPosition);
            window.addEventListener('resize', updateRefsPosition);
        }
        else if (popupRef.current) {
            popupRef.current.style.visibility = 'hidden';
            window.removeEventListener('scroll', updateRefsPosition);
            window.removeEventListener('resize', updateRefsPosition);
        }
        return () => {
            window.clearTimeout(timerRef.current);
            window.removeEventListener('scroll', updateRefsPosition);
            window.removeEventListener('resize', updateRefsPosition);
        };
    }, [visible, directions, secondaryOffset, mainOffset, updateRefsPosition]);
    const content = (React.createElement("div", { style: props.style, ref: mergeRefs$1(popupRef, innerRef), className: cn(styles$v.popup, props.className), "data-gtm": dataGtm }, props.children));
    if ((!visible && keepMounted) || container.current === null) {
        return null;
    }
    return ReactDOM.createPortal(content, container.current);
};

function useOnClickOutside(refs, handler, flag = true) {
    React.useEffect(() => {
        const listener = (event) => {
            if (refs && refs.some(item => !item.current || item.current.contains(event.target))) {
                return;
            }
            handler(event);
        };
        if (flag) {
            document.addEventListener('mousedown', listener);
            document.addEventListener('touchstart', listener);
        }
        else {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        }
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [refs, handler, flag]);
}

var css_248z$1j = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.spinner-module_box__M6TA-{display:inline-block}.spinner-module_box__M6TA-.spinner-module_s__9NtuR{height:24px;line-height:24px;width:24px}.spinner-module_box__M6TA-.spinner-module_m__Y1Hr7{height:40px;line-height:40px;width:40px}.spinner-module_box__M6TA-.spinner-module_l__JLjHc{height:60px;line-height:60px;width:60px}.spinner-module_box__M6TA-.spinner-module_normal__TXU-1>svg{animation:spinner-module_spin__CrxVE 1s cubic-bezier(.445,.05,.55,.95) infinite}.spinner-module_box__M6TA-.spinner-module_quick__eM3-1>svg{animation:spinner-module_spin__CrxVE .6s linear infinite}.spinner-module_box__M6TA-.spinner-module_primary__J-Yrp{color:#3416b6}.spinner-module_box__M6TA-.spinner-module_secondary__CBRlV{color:rgba(150,142,190,.2)}.spinner-module_box__M6TA-.spinner-module_success__Ora-P{color:#87d232}.spinner-module_box__M6TA-.spinner-module_error__maIYT{color:#f44434}.spinner-module_box__M6TA-.spinner-module_white__CJ-xd{color:#fff}@keyframes spinner-module_spin__CrxVE{to{transform:rotate(1turn)}}";
var s$q = {"box":"spinner-module_box__M6TA-","s":"spinner-module_s__9NtuR","m":"spinner-module_m__Y1Hr7","l":"spinner-module_l__JLjHc","normal":"spinner-module_normal__TXU-1","spin":"spinner-module_spin__CrxVE","quick":"spinner-module_quick__eM3-1","primary":"spinner-module_primary__J-Yrp","secondary":"spinner-module_secondary__CBRlV","success":"spinner-module_success__Ora-P","error":"spinner-module_error__maIYT","white":"spinner-module_white__CJ-xd"};
styleInject(css_248z$1j);

const sizes$2 = {
    s: { px: 24, strokeWidth: 2, d: 'M21 12C21 7.02944 16.9706 3 12 3' },
    m: { px: 40, strokeWidth: 3, d: 'M36 20C36 11.1634 28.8366 4 20 4' },
    l: { px: 60, strokeWidth: 4, d: 'M56 30C56 15.6406 44.3594 4 30 4' },
};
const Spinner = ({ size = 'm', color = 'primary', velocity = 'normal', dataTest }) => {
    const _a = sizes$2[size], { px } = _a, path = __rest(_a, ["px"]);
    return (React.createElement("div", { "data-spinner": true, className: cn(s$q.box, s$q[color], s$q[size], s$q[velocity]), "data-test": dataTest },
        React.createElement("svg", { width: px, height: px, viewBox: `0 0 ${px} ${px}`, xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", Object.assign({ stroke: "currentColor", strokeLinecap: "round" }, path, { fill: "none" })))));
};

var propTypesExports = {};
var propTypes$1 = {
  get exports(){ return propTypesExports; },
  set exports(v){ propTypesExports = v; },
};

var reactIsExports$1 = {};
var reactIs = {
  get exports(){ return reactIsExports$1; },
  set exports(v){ reactIsExports$1 = v; },
};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIsExports$1;
	hasRequiredReactIs = 1;
	(function (module) {

		if (process.env.NODE_ENV === 'production') {
		  module.exports = requireReactIs_production_min();
		} else {
		  module.exports = requireReactIs_development();
		}
} (reactIs));
	return reactIsExports$1;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has$2;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has$2;
	hasRequiredHas = 1;
	has$2 = Function.call.bind(Object.prototype.hasOwnProperty);
	return has$2;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes$1.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$1.exports = requireFactoryWithThrowingShims()();
}

var COMMON_MIME_TYPES = new Map([
    ['avi', 'video/avi'],
    ['gif', 'image/gif'],
    ['ico', 'image/x-icon'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['mp4', 'video/mp4'],
    ['pdf', 'application/pdf'],
    ['png', 'image/png'],
    ['zip', 'application/zip'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, isDragEvt(evt) && evt.dataTransfer
                    ? getDataTransferFiles(evt.dataTransfer, evt.type)
                    : getInputFiles(evt)];
        });
    });
}
function isDragEvt(value) {
    return !!value.dataTransfer;
}
function getInputFiles(evt) {
    var files = isInput$1(evt.target)
        ? evt.target.files
            ? fromList(evt.target.files)
            : []
        : [];
    return files.map(function (file) { return toFileWithPath(file); });
}
function isInput$1(value) {
    return value !== null;
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten$2(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten$2(items) {
    return items.reduce(function (acc, files) { return __spread$1(acc, (Array.isArray(files) ? flatten$2(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var _default$1 = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$2(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }

var FILE_INVALID_TYPE = 'file-invalid-type';
var FILE_TOO_LARGE = 'file-too-large';
var FILE_TOO_SMALL = 'file-too-small';
var TOO_MANY_FILES = 'too-many-files'; // File Errors

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: 'Too many files'
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === 'application/x-moz-file' || _default$1(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple;

  if (!multiple && files.length > 1) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$2(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$2(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    return accepted && sizeMatch;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$1(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(source, true).forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$4(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone$1 = React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties$5(_ref, ["children"]);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties$5(_useDropzone, ["open"]);

  React.useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return React.createElement(React.Fragment, null, children(_objectSpread$1({}, props, {
    open: open
  })));
});
Dropzone$1.displayName = 'Dropzone';
Dropzone$1.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: propTypesExports.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: propTypesExports.oneOfType([propTypesExports.string, propTypesExports.arrayOf(propTypesExports.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: propTypesExports.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: propTypesExports.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: propTypesExports.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: propTypesExports.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: propTypesExports.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: propTypesExports.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: propTypesExports.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: propTypesExports.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: propTypesExports.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: propTypesExports.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: propTypesExports.func,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: propTypesExports.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: propTypesExports.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: propTypesExports.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are droppped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: propTypesExports.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: propTypesExports.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: propTypesExports.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are droppped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      accept = _ref2.accept,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$getFilesFromEve = _ref2.getFilesFromEvent,
      getFilesFromEvent = _ref2$getFilesFromEve === void 0 ? fromEvent : _ref2$getFilesFromEve,
      _ref2$maxSize = _ref2.maxSize,
      maxSize = _ref2$maxSize === void 0 ? Infinity : _ref2$maxSize,
      _ref2$minSize = _ref2.minSize,
      minSize = _ref2$minSize === void 0 ? 0 : _ref2$minSize,
      _ref2$multiple = _ref2.multiple,
      multiple = _ref2$multiple === void 0 ? true : _ref2$multiple,
      onDragEnter = _ref2.onDragEnter,
      onDragLeave = _ref2.onDragLeave,
      onDragOver = _ref2.onDragOver,
      onDrop = _ref2.onDrop,
      onDropAccepted = _ref2.onDropAccepted,
      onDropRejected = _ref2.onDropRejected,
      onFileDialogCancel = _ref2.onFileDialogCancel,
      _ref2$preventDropOnDo = _ref2.preventDropOnDocument,
      preventDropOnDocument = _ref2$preventDropOnDo === void 0 ? true : _ref2$preventDropOnDo,
      _ref2$noClick = _ref2.noClick,
      noClick = _ref2$noClick === void 0 ? false : _ref2$noClick,
      _ref2$noKeyboard = _ref2.noKeyboard,
      noKeyboard = _ref2$noKeyboard === void 0 ? false : _ref2$noKeyboard,
      _ref2$noDrag = _ref2.noDrag,
      noDrag = _ref2$noDrag === void 0 ? false : _ref2$noDrag,
      _ref2$noDragEventsBub = _ref2.noDragEventsBubbling,
      noDragEventsBubbling = _ref2$noDragEventsBub === void 0 ? false : _ref2$noDragEventsBub;

  var rootRef = React.useRef(null);
  var inputRef = React.useRef(null);

  var _useReducer = React.useReducer(reducer$2, initialState),
      _useReducer2 = _slicedToArray$1(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically

  var openFileDialog = React.useCallback(function () {
    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch]); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });

            if (typeof onFileDialogCancel === 'function') {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };

  React.useEffect(function () {
    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = React.useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef]); // Update focus state for the dropzone

  var onFocusCb = React.useCallback(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = React.useCallback(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = React.useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick]);
  var dragTargetsRef = React.useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  React.useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = React.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = React.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);

    if (event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (isEvtWithFiles(event) && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = React.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var onDropCb = React.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function (file) {
          var _fileAccepted = fileAccepted(file, accept),
              _fileAccepted2 = _slicedToArray$1(_fileAccepted, 2),
              accepted = _fileAccepted2[0],
              acceptError = _fileAccepted2[1];

          var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
              _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 2),
              sizeMatch = _fileMatchSize2[0],
              sizeError = _fileMatchSize2[1];

          if (accepted && sizeMatch) {
            acceptedFiles.push(file);
          } else {
            var errors = [acceptError, sizeError].filter(function (e) {
              return e;
            });
            fileRejections.push({
              file: file,
              errors: errors
            });
          }
        });

        if (!multiple && acceptedFiles.length > 1) {
          // Reject everything and empty accepted files
          acceptedFiles.forEach(function (file) {
            fileRejections.push({
              file: file,
              errors: [TOO_MANY_FILES_REJECTION]
            });
          });
          acceptedFiles.splice(0);
        }

        dispatch({
          acceptedFiles: acceptedFiles,
          fileRejections: fileRejections,
          type: 'setFiles'
        });

        if (onDrop) {
          onDrop(acceptedFiles, fileRejections, event);
        }

        if (fileRejections.length > 0 && onDropRejected) {
          onDropRejected(fileRejections, event);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }

    dispatch({
      type: 'reset'
    });
  }, [multiple, accept, minSize, maxSize, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = React.useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onKeyDown = _ref3.onKeyDown,
          onFocus = _ref3.onFocus,
          onBlur = _ref3.onBlur,
          onClick = _ref3.onClick,
          onDragEnter = _ref3.onDragEnter,
          onDragOver = _ref3.onDragOver,
          onDragLeave = _ref3.onDragLeave,
          onDrop = _ref3.onDrop,
          rest = _objectWithoutProperties$5(_ref3, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);

      return _objectSpread$1(_defineProperty$4({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}, {}, rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = React.useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = React.useMemo(function () {
    return function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$refKey = _ref4.refKey,
          refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey,
          onChange = _ref4.onChange,
          onClick = _ref4.onClick,
          rest = _objectWithoutProperties$5(_ref4, ["refKey", "onChange", "onClick"]);

      var inputProps = _defineProperty$4({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread$1({}, inputProps, {}, rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread$1({}, state, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer$2(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread$1({}, state, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread$1({}, state, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread$1({}, state, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread$1({}, state, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread$1({}, state, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread$1({}, state, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case 'reset':
      return _objectSpread$1({}, state, {
        isFileDialogActive: false,
        isDragActive: false,
        draggedFiles: [],
        acceptedFiles: [],
        fileRejections: []
      });

    default:
      return state;
  }
}

var filesize_minExports = {};
var filesize_min = {
  get exports(){ return filesize_minExports; },
  set exports(v){ filesize_minExports = v; },
};

/*
 2020 Jason Mulligan <jason.mulligan@avoidwork.com>
 @version 6.1.0
*/

(function (module, exports) {
!function(e){var x=/^(b|B)$/,M={iec:{bits:["b","Kib","Mib","Gib","Tib","Pib","Eib","Zib","Yib"],bytes:["B","KiB","MiB","GiB","TiB","PiB","EiB","ZiB","YiB"]},jedec:{bits:["b","Kb","Mb","Gb","Tb","Pb","Eb","Zb","Yb"],bytes:["B","KB","MB","GB","TB","PB","EB","ZB","YB"]}},w={iec:["","kibi","mebi","gibi","tebi","pebi","exbi","zebi","yobi"],jedec:["","kilo","mega","giga","tera","peta","exa","zetta","yotta"]};function t(e){var i,t,o,n,b,r,a,l,s,d,u,c,f,p,B,y=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{},g=[],v=0,m=void 0,h=void 0;if(isNaN(e))throw new TypeError("Invalid number");return t=!0===y.bits,u=!0===y.unix,i=y.base||2,d=void 0!==y.round?y.round:u?1:2,r=void 0!==y.locale?y.locale:"",a=y.localeOptions||{},c=void 0!==y.separator?y.separator:"",f=void 0!==y.spacer?y.spacer:u?"":" ",B=y.symbols||{},p=2===i&&y.standard||"jedec",s=y.output||"string",n=!0===y.fullform,b=y.fullforms instanceof Array?y.fullforms:[],m=void 0!==y.exponent?y.exponent:-1,o=2<i?1e3:1024,(l=(h=Number(e))<0)&&(h=-h),(-1===m||isNaN(m))&&(m=Math.floor(Math.log(h)/Math.log(o)))<0&&(m=0),8<m&&(m=8),"exponent"===s?m:(0===h?(g[0]=0,g[1]=u?"":M[p][t?"bits":"bytes"][m]):(v=h/(2===i?Math.pow(2,10*m):Math.pow(1e3,m)),t&&o<=(v*=8)&&m<8&&(v/=o,m++),g[0]=Number(v.toFixed(0<m?d:0)),g[0]===o&&m<8&&void 0===y.exponent&&(g[0]=1,m++),g[1]=10===i&&1===m?t?"kb":"kB":M[p][t?"bits":"bytes"][m],u&&(g[1]="jedec"===p?g[1].charAt(0):0<m?g[1].replace(/B$/,""):g[1],x.test(g[1])&&(g[0]=Math.floor(g[0]),g[1]=""))),l&&(g[0]=-g[0]),g[1]=B[g[1]]||g[1],!0===r?g[0]=g[0].toLocaleString():0<r.length?g[0]=g[0].toLocaleString(r,a):0<c.length&&(g[0]=g[0].toString().replace(".",c)),"array"===s?g:(n&&(g[1]=b[m]?b[m]:w[p][m]+(t?"bit":"byte")+(1===g[0]?"":"s")),"object"===s?{value:g[0],symbol:g[1],exponent:m}:g.join(f)))}t.partial=function(i){return function(e){return t(e,i)}},module.exports=t;}();
	
} (filesize_min));

var fileSize = filesize_minExports;

var svg = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.97 5.25l9.53 9.53-1.06 1.06-8.47-8.47-8.47 8.47-1.06-1.06 9.53-9.53z\"/></svg>";

var css_248z$1i = ".styles-module_chevron-up-icon__Rg3ku{background-image:url(chevron-up.svg)}";
var styles$u = {"chevron-up-icon":"styles-module_chevron-up-icon__Rg3ku"};
styleInject(css_248z$1i);

const ChevronUpIcon = (_a) => {
    var { bg, className } = _a, props = __rest(_a, ["bg", "className"]);
    return React.createElement(Icon$6, Object.assign({}, props, { bg: bg, className: cn(className, { [styles$u.chevronUpIcon]: bg }), src: svg }));
};

const handleKeyPressEnter = (func) => {
    return function (event) {
        if (event.key === 'Enter') {
            func(event);
        }
    };
};

var css_248z$1h = ".frame-module_frame__UbECB.frame-module_frame__UbECB{background-color:#fff;border-radius:4px;border-style:solid;border-width:1px}.frame-module_frame-default__dGQb-.frame-module_frame-default__dGQb-.frame-module_frame-default__dGQb-{border-color:#ccc9d9}.frame-module_frame-default__dGQb-.frame-module_frame-default__dGQb-.frame-module_frame-default-hover__e-5rf{border-color:#3416b6}.frame-module_frame-default__dGQb-.frame-module_frame-default__dGQb-.frame-module_frame-default-focus__jjQ-L{border-color:#3416b6;box-shadow:0 12px 20px rgba(38,68,217,.16)}.frame-module_frame-error__54RZe.frame-module_frame-error__54RZe{border-color:#f44434}.frame-module_frame-error__54RZe.frame-module_frame-error-focus__P0s7N{box-shadow:0 12px 20px rgba(236,19,26,.16)}.frame-module_frame-success__2i6n7.frame-module_frame-success__2i6n7{border-color:#78bc29}.frame-module_frame-success__2i6n7.frame-module_frame-success-focus__YbwiC{box-shadow:0 12px 20px rgba(50,205,70,.16)}.frame-module_frame-disable__qegxn.frame-module_frame-disable__qegxn{background-color:#eae9f2;border-color:#ccc9d9;cursor:default}";
var frameStyles = {"frame":"frame-module_frame__UbECB","frame-default":"frame-module_frame-default__dGQb-","frame-default-hover":"frame-module_frame-default-hover__e-5rf","frame-default-focus":"frame-module_frame-default-focus__jjQ-L","frame-error":"frame-module_frame-error__54RZe","frame-error-focus":"frame-module_frame-error-focus__P0s7N","frame-success":"frame-module_frame-success__2i6n7","frame-success-focus":"frame-module_frame-success-focus__YbwiC","frame-disable":"frame-module_frame-disable__qegxn"};
styleInject(css_248z$1h);

var css_248z$1g = ".select-module_select-button__i49sh.select-module_select-button__i49sh{border:1px solid;border-color:inherit;text-align:left}.select-module_fill-width__T5YE1.select-module_fill-width__T5YE1{justify-content:space-between}.select-module_hint__cHn9z{color:#6e6a81;font-size:12px;line-height:20px;overflow:hidden;text-overflow:ellipsis}.select-module_hint-alone__hI7yR{font-size:16px}.select-module_hint-error__rzaav{color:#f44434}";
var selectStyles = {"select-button":"select-module_select-button__i49sh","fill-width":"select-module_fill-width__T5YE1","hint":"select-module_hint__cHn9z","hint-alone":"select-module_hint-alone__hI7yR","hint-error":"select-module_hint-error__rzaav"};
styleInject(css_248z$1g);

const SelectButton = React.memo(React.forwardRef((_a, ref) => {
    var { hint, isError, isValid } = _a, rest = __rest(_a, ["hint", "isError", "isValid"]);
    const styles = React.useMemo(() => (Object.assign(Object.assign({}, selectStyles), { hover: frameStyles.frameDefaultHover, focus: frameStyles.frameDefaultFocus, press: frameStyles.frameDefaultFocus })), []);
    return (React.createElement(BaseButton, Object.assign({ ref: ref }, rest, { className: cn(selectStyles.selectButton, frameStyles.frame, frameStyles.frameDefault, {
            [frameStyles.frameDefaultFocus]: rest.focused,
            [frameStyles.frameError]: isError,
            [frameStyles.frameSuccess]: isValid,
            [frameStyles.frameDisable]: rest.disabled,
            [selectStyles.fillWidth]: rest.fullWidth,
        }), styles: styles }),
        React.createElement("div", { className: cn(selectStyles.hint, {
                [selectStyles.hintError]: isError,
                [selectStyles.hintAlone]: hint && !rest.children,
            }) }, hint),
        rest.children));
}));

function generateId$2(prefix) {
    return (prefix ? `${prefix}-` : '_') + Math.random().toString(36).substr(2, 9);
}

function callEventHandlers(...fns) {
    return (event, ...args) => fns.some(fn => {
        if (fn) {
            fn(event, ...args);
        }
        return event.preventUIDefault || (event.nativeEvent && event.nativeEvent.preventUIDefault);
    });
}

var Key;
(function (Key) {
    Key["Down"] = "ArrowDown";
    Key["Up"] = "ArrowUp";
    Key["Enter"] = "Enter";
    Key["Tab"] = "Tab";
    Key["Esc"] = "Escape";
})(Key || (Key = {}));
var Key$1 = Key;

var SelectMode;
(function (SelectMode) {
    SelectMode["Check"] = "check";
    SelectMode["Multiple"] = "multiple";
    SelectMode["Single"] = "single";
})(SelectMode || (SelectMode = {}));
const getNextIndex$1 = (direction, hoveredIndex, items) => {
    let start = hoveredIndex || 0;
    if (hoveredIndex === -1) {
        hoveredIndex = 0;
    }
    while (start < items.length && start > -1) {
        start++;
        hoveredIndex += direction;
        if (hoveredIndex < 0) {
            hoveredIndex = items.length - 1;
        }
        if (hoveredIndex >= items.length) {
            hoveredIndex = 0;
        }
        if (items[hoveredIndex] && !items[hoveredIndex].disabled) {
            break;
        }
        else {
            start--;
        }
    }
    return hoveredIndex;
};
const useSelect$1 = (props) => {
    const uniqTriggerId = React.useRef(generateId$2('trigger'));
    const uniqMenuId = React.useRef(generateId$2('menu'));
    const uniqLabelId = React.useRef(generateId$2('label'));
    const uniqToggleId = React.useRef(generateId$2('toggle'));
    const menuRef = React.useRef(null);
    const toggleButtonRef = React.useRef(null);
    const itemRefs = React.useRef([]);
    const [highlightedIndex, setHighlightedIndex] = React.useState(-1);
    const [isOpen, toggleOpen] = React.useState(false);
    const handleSelectItem = React.useCallback((optionValue, event) => {
        const checked = !props.selectedOptions.includes(optionValue);
        if (props.onChange) {
            if (props.mode === SelectMode.Single) {
                props.onChange(checked ? optionValue : optionValue, event);
            }
            if (props.mode === SelectMode.Check) {
                props.onChange(checked ? optionValue : null, event);
            }
            if (props.mode === SelectMode.Multiple) {
                props.onChange(checked
                    ? [optionValue, ...props.selectedOptions]
                    : props.selectedOptions.filter(item => item !== optionValue), event);
            }
        }
        if (SelectMode.Single === props.mode) {
            toggleOpen(false);
        }
    }, [props.onChange, props.selectedOptions, props.mode, toggleOpen]);
    const toggleButtonHandleClick = React.useCallback(() => {
        if (document.activeElement !== menuRef.current) {
            toggleOpen(prevState => !prevState);
        }
    }, [toggleOpen]);
    const getTriggerProps = React.useCallback((_a = {}) => {
        var { onClick, onKeyDown, refKey = 'ref', disabled } = _a, rest = __rest(_a, ["onClick", "onKeyDown", "refKey", "disabled"]);
        return (Object.assign({ ref: toggleButtonRef, [refKey]: toggleButtonRef, id: uniqToggleId.current, dataTest: props.dataTest ? `${props.dataTest}-trigger` : undefined, 'aria-haspopup': 'listbox', 'aria-expanded': isOpen, 'aria-labelledby': `${uniqMenuId.current} ${uniqTriggerId.current}`, disabled,
            onKeyDown, onClick: disabled
                ? undefined
                : event => {
                    if (onClick) {
                        onClick(event);
                    }
                    toggleButtonHandleClick();
                } }, rest));
    }, [isOpen, props.dataTest, toggleButtonHandleClick]);
    const menuHandleKeyDown = React.useCallback((event) => {
        switch (event.key) {
            case Key$1.Down:
            case Key$1.Up: {
                event.preventDefault();
                const direction = event.key === Key$1.Up ? -1 : 1;
                const nextIndex = getNextIndex$1(direction, highlightedIndex || 0, props.options);
                setHighlightedIndex(nextIndex);
                itemRefs.current[nextIndex].scrollIntoView({
                    block: 'nearest',
                });
                break;
            }
            case Key$1.Tab:
                event.preventDefault();
                break;
            case ' ':
            case Key$1.Enter:
                if (props.options[highlightedIndex] && props.options[highlightedIndex].value) {
                    handleSelectItem(props.options[highlightedIndex].value, event);
                }
                break;
            case Key$1.Esc:
                toggleOpen(false);
                break;
        }
    }, [setHighlightedIndex, highlightedIndex, props.options, handleSelectItem]);
    const menuHandleMouseLeave = React.useCallback(() => setHighlightedIndex(-1), [setHighlightedIndex]);
    const menuHandleBlur = React.useCallback((e) => {
        const nativeEvent = e.nativeEvent;
        const relatedTarget = e.relatedTarget;
        const focusableTarget = relatedTarget || (nativeEvent ? nativeEvent.explicitOriginalTarget : undefined);
        if (focusableTarget && menuRef.current && menuRef.current.contains(focusableTarget)) {
            e.preventDefault();
        }
    }, [menuRef]);
    const getListProps = React.useCallback((_a = {}) => {
        var { onKeyDown, onBlur, onMouseLeave, ref } = _a, rest = __rest(_a, ["onKeyDown", "onBlur", "onMouseLeave", "ref"]);
        return (Object.assign({ ref: mergeRefs$1(menuRef, ref), id: uniqMenuId.current, 'data-test': props.dataTest ? `${props.dataTest}-list` : undefined, role: 'listbox', 'aria-labelledby': uniqLabelId.current, tabIndex: -1, autoFocus: isOpen, 'aria-activedescendant': highlightedIndex >= 0 ? String(highlightedIndex) : undefined, onKeyDown: callEventHandlers(onKeyDown, menuHandleKeyDown), onBlur: callEventHandlers(onBlur, menuHandleBlur), onMouseLeave: callEventHandlers(onMouseLeave, menuHandleMouseLeave) }, rest));
    }, [highlightedIndex, isOpen, menuHandleBlur, menuHandleKeyDown, menuHandleMouseLeave, props.dataTest]);
    const getOptionProps = React.useCallback(({ index, option, onMouseMove, onClick }) => {
        if (index < 0) {
            throw new Error('Pass either item or item index in getItemProps!');
        }
        return {
            ref: itemNode => {
                itemRefs.current[index] = itemNode;
            },
            id: `${option.value}_${index}`,
            dataTest: props.dataTest ? `${props.dataTest}-item-${option.value}` : undefined,
            role: 'option',
            hovered: index === highlightedIndex,
            selected: props.selectedOptions.includes(option.value),
            onMouseMove: callEventHandlers(onMouseMove, () => {
                if (!option.disabled) {
                    setHighlightedIndex(index);
                }
            }),
            onClick: callEventHandlers(onClick, event => {
                if (!option.disabled) {
                    handleSelectItem(option.value, event);
                }
            }),
        };
    }, [props.dataTest, props.selectedOptions, itemRefs]);
    React.useEffect(() => {
        if (!isOpen) {
            itemRefs.current = [];
        }
    }, [isOpen]);
    React.useEffect(() => {
        if (isOpen) {
            setTimeout(() => menuRef.current && menuRef.current.focus(), 100);
        }
        else if (document.activeElement === menuRef.current && toggleButtonRef.current) {
            toggleButtonRef.current.focus();
        }
    }, [isOpen]);
    React.useEffect(() => {
        const listener = (event) => {
            const refs = [toggleButtonRef, menuRef];
            if (!refs.some(item => item.current && (item.current === event.target || item.current.contains(event.target)))) {
                toggleOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('click', listener);
        }
        return () => {
            document.removeEventListener('click', listener);
        };
    }, [isOpen, toggleOpen, toggleButtonRef, menuRef]);
    return {
        isOpen,
        toggleButtonRef,
        getOptionProps,
        getListProps,
        highlightedIndex,
        getTriggerProps,
        toggleOpen,
    };
};

var css_248z$1f = ".select-module_select__B-jy7{display:inline-flex;font-size:0;max-width:100%;position:relative;vertical-align:bottom}.select-module_select-full-width__BiqBr{width:100%}.select-module_menu__9KWqX{background-color:#fff;border:1px solid #e5e7f0;border-radius:4px;box-sizing:border-box;list-style:none;margin:0;outline:none;overflow:auto;padding:0}.select-module_menu-group__x1iI2{padding-top:14px}.select-module_menu-group-border__Vutg9{padding-top:0}.select-module_menu-group-border__Vutg9:not(:first-child){border-top:1px solid #eeeff6}.select-module_menu-group-border__Vutg9~.select-module_menu-group-border__Vutg9:not(.select-module_menu-group-border__Vutg9){border-bottom:1px solid #eeeff6}.select-module_menu-group-content__aHkNu{list-style:none;margin:0;padding:0}.select-module_menu-group-label__0iQIo{align-items:center;color:#b6b9c9;display:flex;font-size:12px;letter-spacing:.2px;line-height:20px;padding:0 0 0 20px}.select-module_option__jzHUw{align-items:center;border-radius:4px;box-sizing:border-box;cursor:pointer;display:flex;height:auto;line-height:36px;margin:4px 8px;min-height:36px;padding:0 8px}.select-module_option-label__LyarH{margin-left:12px}.select-module_option-mode-multiple__RJQDk.select-module_option-selected__y3OBt{background-color:#fff;color:#000}.select-module_option-hovered__rruWf,.select-module_option-mode-multiple__RJQDk.select-module_option-hovered__rruWf{background-color:#eeeff6}.select-module_option-disabled__Rbwx-{color:#eae9f2;cursor:default}.select-module_option-selected__y3OBt{background-color:#3416b6;color:#fff}.select-module_control__ACkug{border:0;height:0;max-width:0;visibility:hidden;width:0}.select-module_native__PC-4a .select-module_control__ACkug{bottom:0;display:block;height:100%;left:0;max-width:none;opacity:0;position:absolute;right:0;top:0;visibility:visible;width:100%;z-index:1}.select-module_select-checkbox__VULHV{line-height:20px;pointer-events:none}.select-module_icon-disabled__wPK5Z{opacity:.5}";
var styles$t = {"select":"select-module_select__B-jy7","select-full-width":"select-module_select-full-width__BiqBr","menu":"select-module_menu__9KWqX","menu-group":"select-module_menu-group__x1iI2","menu-group-border":"select-module_menu-group-border__Vutg9","menu-group-content":"select-module_menu-group-content__aHkNu","menu-group-label":"select-module_menu-group-label__0iQIo","option":"select-module_option__jzHUw","option-label":"select-module_option-label__LyarH","option-mode-multiple":"select-module_option-mode-multiple__RJQDk","option-selected":"select-module_option-selected__y3OBt","option-hovered":"select-module_option-hovered__rruWf","option-disabled":"select-module_option-disabled__Rbwx-","control":"select-module_control__ACkug","native":"select-module_native__PC-4a","select-checkbox":"select-module_select-checkbox__VULHV","icon-disabled":"select-module_icon-disabled__wPK5Z"};
styleInject(css_248z$1f);

const defaultRenderTitle = (opts) => opts.selectedOptions.map(item => item.label).join(', ');
const defaultOnChangeHandler = () => { };
const CheckBoxMemo = React.memo(Checkbox$1);
const DEFAULT_DIRECTION = [Direction.BottomLeft, Direction.TopLeft];
function defaultRenderListItem({ option, selected, hovered, mode, }) {
    var _a;
    const value = String(option.value);
    const label = (_a = option.label) !== null && _a !== void 0 ? _a : value;
    if (mode === SelectMode.Multiple) {
        return (React.createElement(CheckBoxMemo, { hover: hovered, name: value, value: value, checked: selected, disabled: option.disabled, className: styles$t.selectCheckbox }, label));
    }
    return label;
}
const renderOption = ({ getOptionProps, renderListItem = defaultRenderListItem, highlightedIndex, mode, }) => (option) => {
    const { ref, id, role, selected = false, onMouseMove, onClick, hovered } = getOptionProps({
        option,
        index: option.index ? option.index : 0,
    });
    return (React.createElement("li", { key: `${id}-${option.value}`, ref: ref, role: role, onClick: onClick, onMouseMove: onMouseMove, className: cn(styles$t.option, styles$t[`option-mode-${mode}`], {
            [styles$t.optionDisabled]: option.disabled,
            [styles$t.optionHovered]: option.index === highlightedIndex,
            [styles$t.optionSelected]: selected,
        }) }, renderListItem({ option, selected, hovered, mode })));
};
const defaultRenderTrigger = ({ getTriggerProps, isOpen, disabled, isError, isValid, title, label, size, fullWidth, }) => (React.createElement(SelectButton, Object.assign({ type: "button", size: size, isError: isError, isValid: isValid, focused: isOpen, fullWidth: fullWidth, hint: size === Size.Large ? label : undefined }, getTriggerProps({ disabled }), { after: React.createElement("span", { className: cn(disabled && styles$t.iconDisabled) }, isOpen ? React.createElement(ChevronUpIcon, null) : React.createElement(ChevronDownIcon, null)) }), title));
function defaultRenderList({ getListProps, options, getOptionProps, renderListItem, highlightedIndex, mode, menuWidth, maxHeight, cls, }) {
    const listProps = getListProps();
    return (React.createElement("ul", Object.assign({ className: cn(styles$t.menu, cls === null || cls === void 0 ? void 0 : cls.popupList) }, listProps, { style: Object.assign(Object.assign({}, listProps.style), { maxHeight: maxHeight, minWidth: menuWidth }) }), options.map((option, index) => {
        if (option.options) {
            return (React.createElement("li", { key: `group-${index}`, className: cn(styles$t.menuGroup, {
                    [styles$t.menuGroupBorder]: !option.label,
                }) },
                option.label && React.createElement("span", { className: styles$t.menuGroupLabel }, option.label),
                React.createElement("ul", { className: styles$t.menuGroupContent }, option.options.map(renderOption({
                    getOptionProps,
                    renderListItem,
                    highlightedIndex,
                    mode,
                })))));
        }
        return renderOption({ getOptionProps, renderListItem, highlightedIndex, mode })(option);
    })));
}
function isArray$d(some) {
    return Array.isArray(some);
}
const Select$1 = (_a) => {
    var _b;
    var { ref, size, label, controlRef, mode = SelectMode.Single, value, onChange = defaultOnChangeHandler, native, options: rawOptions, placeholder, renderList = defaultRenderList, renderListItem = defaultRenderListItem, renderTitle = defaultRenderTitle, fullWidth, isError, isValid = false, directions = DEFAULT_DIRECTION, renderTrigger = defaultRenderTrigger, dataTest, onOpen, onClose, container, maxHeight, className: classNameComponent, cls } = _a, rest = __rest(_a, ["ref", "size", "label", "controlRef", "mode", "value", "onChange", "native", "options", "placeholder", "renderList", "renderListItem", "renderTitle", "fullWidth", "isError", "isValid", "directions", "renderTrigger", "dataTest", "onOpen", "onClose", "container", "maxHeight", "className", "cls"]);
    if (!isArray$d(rawOptions)) {
        throw new Error(`Options should be array: ${JSON.stringify(rawOptions)}`);
    }
    if (mode === SelectMode.Multiple && value && !Array.isArray(value)) {
        throw new Error(`Value for mode ${mode} should be array: ${JSON.stringify(value)}`);
    }
    if (mode === SelectMode.Single && value && Array.isArray(value)) {
        throw new Error(`Value for mode ${mode} should not be array: ${JSON.stringify(value)}`);
    }
    const smart = { onChange, value, mode };
    const didMountRef = React.useRef(false);
    const valueForSet = Array.isArray(value) ? value : value ? [value] : [];
    const { options, flatOptions } = React.useMemo(() => {
        return rawOptions.reduce((ret, item) => {
            if (item.options) {
                const richOptions = item.options.map(option => (Object.assign(Object.assign({}, option), { index: ret.incrementIndex++ })));
                ret.flatOptions.push(...richOptions);
                ret.options.push(Object.assign(Object.assign({}, item), { options: richOptions }));
                return ret;
            }
            else {
                const option = Object.assign(Object.assign({}, item), { index: ret.incrementIndex++ });
                ret.flatOptions.push(option);
                ret.options.push(option);
            }
            return ret;
        }, {
            incrementIndex: 0,
            flatOptions: [],
            options: [],
        });
    }, [rawOptions]);
    const selectRef = React.useRef(null);
    const { isOpen, toggleOpen, toggleButtonRef, getListProps, getOptionProps, getTriggerProps, highlightedIndex, } = useSelect$1(Object.assign(Object.assign({}, smart), { dataTest, options: flatOptions, selectedOptions: valueForSet }));
    React.useEffect(() => {
        if (didMountRef.current) {
            if (isOpen) {
                if (onOpen) {
                    onOpen();
                }
            }
            else {
                if (onClose) {
                    onClose();
                }
            }
        }
        didMountRef.current = true;
    }, [isOpen, onClose, onOpen]);
    const menuWidth = React.useMemo(() => {
        var _a, _b;
        return (_b = (_a = toggleButtonRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) !== null && _b !== void 0 ? _b : 'auto';
    }, [toggleButtonRef.current]);
    const title = React.useMemo(() => {
        const selectedOptions = valueForSet.length > 0 ? flatOptions.filter(item => valueForSet.includes(item.value)) : undefined;
        return selectedOptions ? renderTitle({ selectedOptions }) : placeholder;
    }, [placeholder, flatOptions, renderTitle, valueForSet]);
    const handleNativeControlChange = React.useCallback((e) => {
        var _a;
        const selectOptions = e.target.options;
        const values = [];
        for (let i = 0, j = selectOptions.length; i < j; i++) {
            const option = selectOptions[i];
            if (option.selected) {
                const selectedItem = flatOptions.find(item => String(item.value) === option.value);
                values.push((_a = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) !== null && _a !== void 0 ? _a : option.value);
            }
        }
        if (smart.onChange) {
            if (smart.mode === SelectMode.Single && values.length > 0) {
                smart.onChange(values[0], e);
            }
            if (smart.mode === SelectMode.Check) {
                smart.onChange(values.length === 0 ? null : values[0], e);
            }
            if (smart.mode === SelectMode.Multiple) {
                smart.onChange(values, e);
            }
        }
    }, [smart.onChange, flatOptions, smart.mode]);
    const nativeSelectValue = smart.mode === SelectMode.Multiple ? smart.value.map(String) : (_b = smart.value) !== null && _b !== void 0 ? _b : undefined;
    return (React.createElement("span", { "data-test": dataTest, className: cn(styles$t.select, { [styles$t.native]: native, [styles$t.selectFullWidth]: fullWidth }, classNameComponent), ref: ref },
        renderTrigger({
            getTriggerProps,
            toggleOpen,
            isOpen,
            disabled: rest.disabled,
            isError,
            isValid,
            title,
            label,
            size,
            fullWidth,
        }),
        React.createElement(Popup, { mainOffset: 8, keepMounted: true, visible: isOpen, anchor: toggleButtonRef, directions: directions, container: container }, renderList({
            getListProps,
            getOptionProps,
            options,
            toggleOpen,
            renderListItem,
            highlightedIndex,
            mode: smart.mode,
            menuWidth,
            maxHeight,
            cls,
        })),
        React.createElement("select", Object.assign({ className: styles$t.control, ref: mergeRefs$1(selectRef, controlRef), tabIndex: -1, value: nativeSelectValue, onChange: handleNativeControlChange, multiple: mode === SelectMode.Multiple }, rest),
            React.createElement("optgroup", { key: "hidden-group", disabled: true, hidden: true }),
            options.map((option, index) => {
                if (option.options) {
                    return (React.createElement("optgroup", { key: `${index}-${option.label}`, label: option.label }, option.options.map(item => (React.createElement("option", { key: `${index}_${item.value}`, value: item.value, disabled: item.disabled }, item.label || item.value)))));
                }
                return (React.createElement("option", { key: option.value, value: option.value, disabled: option.disabled }, option.label || option.value));
            }))));
};

var css_248z$1e = ".field-module_field__HusJB{display:inline-flex;flex-direction:column}.field-module_field-label__mhq-8{color:#6e6a81;font-size:14px;line-height:20px;margin-bottom:8px}.field-module_field-note__r5hFL{color:#a4a1b5;font-size:12px;line-height:20px;margin-bottom:4px;margin-top:4px;min-height:20px}.field-module_field__HusJB.field-module_fullWidth__oLAmQ{display:flex;width:100%}.field-module_error__cSaWm{color:#f44434}";
var styles$s = {"field":"field-module_field__HusJB","field-label":"field-module_field-label__mhq-8","field-note":"field-module_field-note__r5hFL","fullWidth":"field-module_fullWidth__oLAmQ","error":"field-module_error__cSaWm"};
styleInject(css_248z$1e);

function Field$3(Component, showLabel = true, preventLabelClick = true) {
    const handlePreventLabelClick = (event) => preventLabelClick && event.preventDefault();
    return (props) => {
        const { label, note, errorMessage = '', isValid: valid, fullWidth = false, hideNoteSpace = false } = props, componentProps = __rest(props, ["label", "note", "errorMessage", "isValid", "fullWidth", "hideNoteSpace"]);
        const WrapComponent = showLabel ? 'label' : 'span';
        const isSmall = componentProps.size !== Size.Large;
        const isValid = valid === true;
        const isError = valid === false;
        const renderNote = () => (React.createElement("span", { className: cn(styles$s.fieldNote, { [styles$s.error]: isError }), "data-test": isError ? 'error' : 'note' }, isError ? errorMessage : note));
        const Note = () => {
            if (!hideNoteSpace) {
                return renderNote();
            }
            if (errorMessage || note) {
                return renderNote();
            }
            return null;
        };
        return (React.createElement(WrapComponent, { className: cn(styles$s.field, { [styles$s.fullWidth]: fullWidth }), onClick: handlePreventLabelClick },
            showLabel && isSmall && label && React.createElement("span", { className: styles$s.fieldLabel }, label),
            React.createElement(Component, Object.assign({}, props, { label: label, isValid: isValid, isError: isError })),
            React.createElement(Note, null)));
    };
}

const SelectFilteredProps = function (props) {
    const rest = __rest(props, ["errorMessage", "note", "hideNoteSpace"]);
    return React.createElement(Select$1, rest);
};
const SelectField = Field$3(SelectFilteredProps);

const CONTROL_PRIMARY_STATE_DEFAULT = 'default';
const CONTROL_PRIMARY_STATE_DISABLE = 'disable';
const CONTROL_PRIMARY_STATE_ERROR = 'error';
const CONTROL_PRIMARY_STATE_SUCCESS = 'success';
const CONTROL_SECONDARY_STATE_HOVER = 'hover';
const CONTROL_SECONDARY_STATE_FOCUS = 'focus';
const switchPrimaryState = (state) => {
    switch (true) {
        case state.disabled:
            return CONTROL_PRIMARY_STATE_DISABLE;
        case state.error:
            return CONTROL_PRIMARY_STATE_ERROR;
        case state.success:
            return CONTROL_PRIMARY_STATE_SUCCESS;
        default:
            return CONTROL_PRIMARY_STATE_DEFAULT;
    }
};
const switchSecondaryState = (state) => {
    switch (true) {
        case state.focused:
            return CONTROL_SECONDARY_STATE_FOCUS;
        case state.hovered:
            return CONTROL_SECONDARY_STATE_HOVER;
        default:
            return null;
    }
};
const useControlState = (state) => {
    return React.useMemo(() => {
        const primary = switchPrimaryState(state);
        const secondary = !state.disabled && switchSecondaryState(state);
        return [primary, secondary].filter(Boolean);
    }, [state]);
};
var useControlState$1 = useControlState;

const useFrame = (state) => {
    const [primaryState, secondaryState] = useControlState$1(state);
    return React.useMemo(() => cn(frameStyles.frame, {
        [frameStyles[`frame-${primaryState}`]]: primaryState,
        [frameStyles[`frame-${primaryState}-${secondaryState}`]]: secondaryState && primaryState,
    }), [primaryState, secondaryState]);
};
var useFrame$1 = useFrame;

const useCaret = (inputRef, value = '', formatter) => {
    const rawValue = React.useRef(value);
    const caretPositionRef = React.useRef(0);
    React.useEffect(() => {
        let newValue = value;
        const rawStr = String(rawValue.current);
        const caretPosition = caretPositionRef.current;
        const str = rawStr.substr(0, caretPosition);
        const typesWithSelectionRegexp = /text|password|search|tel|url/i;
        if (rawStr.length === value.length) {
            newValue = formatter(newValue);
        }
        const matched = String(newValue).indexOf(str);
        const index = matched === -1
            ? String(newValue).length - rawStr.length + caretPosition
            : String(newValue).indexOf(str) + caretPosition;
        if (inputRef.current &&
            typesWithSelectionRegexp.test(inputRef.current.type) &&
            index !== -1 &&
            inputRef.current.selectionStart !== undefined &&
            inputRef.current.selectionStart !== null &&
            document.activeElement === inputRef.current) {
            inputRef.current.selectionStart = inputRef.current.selectionEnd = index;
        }
    }, [formatter, value, inputRef]);
    const setCaretPosition = React.useCallback((currentValue, selectionEnd) => {
        rawValue.current = currentValue;
        caretPositionRef.current = Number(selectionEnd);
    }, []);
    return {
        value,
        inputRef,
        setCaretPosition,
    };
};

var css_248z$1d = ".input-module_input__0M39P{box-sizing:border-box;color:#211f2e;display:inline-flex;flex-direction:column;font-family:ALS Hauss,Tahoma,Helvetica Neue,Arial,sans-serif;font-size:16px;justify-content:center;line-height:20px;overflow:hidden;position:relative}.input-module_input__0M39P .input-module_control__HnTX3::-moz-placeholder{color:#a4a1b5}.input-module_input__0M39P .input-module_control__HnTX3::placeholder{color:#a4a1b5}.input-module_no-autofill__5zs6y:-webkit-autofill{-webkit-animation-fill-mode:both;-webkit-animation-name:input-module_no-autofill__5zs6y}.input-module_fullWidth__MhMWN{width:100%}.input-module_input-disabled__g55Ya{color:#a4a1b5}.input-module_input-disabled__g55Ya .input-module_control__HnTX3{background-color:#eae9f2;color:#a4a1b5}.input-module_input-disabled__g55Ya .input-module_control__HnTX3::-moz-placeholder{color:#a4a1b5}.input-module_input-disabled__g55Ya .input-module_control__HnTX3::placeholder{color:#a4a1b5}.input-module_input-disabled__g55Ya .input-module_clear-button__WuMDv{visibility:hidden}.input-module_input-disabled__g55Ya .input-module_valid__epvMn{opacity:.3}.input-module_input-readOnly__u3s3k{background-color:#eae9f2;border-color:#eae9f2;color:#6e6a81}.input-module_input-readOnly__u3s3k .input-module_control__HnTX3{color:#6e6a81;cursor:default}.input-module_input-readOnly__u3s3k .input-module_control__HnTX3::-moz-placeholder{color:#6e6a81}.input-module_input-readOnly__u3s3k .input-module_control__HnTX3::placeholder{color:#6e6a81}.input-module_input-hasValue__TzSuH{opacity:1}.input-module_input-size-s__esc-k{height:40px}.input-module_input-size-m__02O0i{height:52px}.input-module_input-size-l__qCdg6{height:60px}.input-module_box__niDn-{align-items:center;display:inline-flex;transition:opacity .2s cubic-bezier(0,0,.2,1);width:100%}.input-module_wrapper__d-IJV{align-items:center;display:inline-flex;flex:1 1;width:100%}.input-module_label__rdV0j{color:#6e6a81;display:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:90%}.input-module_input__0M39P.input-module_input-size-l__qCdg6 .input-module_label__rdV0j{display:inline-block;font-size:12px;letter-spacing:.2px;padding:0 16px;transform:translate(0) scale(1);transform-origin:top left;transition:transform .2s cubic-bezier(0,0,.2,1);width:100%;will-change:transform}.input-module_input__0M39P.input-module_input-size-l__qCdg6:not(.input-module_input-focused__B8E0B):not(.input-module_input-error__HBF7A):not(.input-module_input-hasValue__TzSuH) .input-module_label__rdV0j{transform:translateY(10px) scale(1.4)}.input-module_input__0M39P.input-module_input-size-l__qCdg6:not(.input-module_input-focused__B8E0B):not(.input-module_input-error__HBF7A):not(.input-module_input-hasValue__TzSuH) .input-module_label__rdV0j+.input-module_box__niDn-{opacity:0}.input-module_control__HnTX3{-webkit-tap-highlight-color:rgba(0,0,0,0);background:none;border-color:transparent;border-style:solid;border-width:0 16px;box-sizing:border-box;flex:1 1;font-size:100%;line-height:24px;margin:0;min-width:0;outline:0;padding:0;position:relative;vertical-align:top;width:100%}.input-module_control__HnTX3::-webkit-inner-spin-button,.input-module_control__HnTX3::-webkit-outer-spin-button{-webkit-appearance:none;appearance:none}.input-module_content__E9TS7{display:block}.input-module_content-after__sf6mh,.input-module_content-before__3O-5A{align-items:center;display:inline-flex;position:relative}.input-module_content-before__3O-5A{margin-left:16px}.input-module_content-after__sf6mh{margin-right:16px}.input-module_clear__th40X{flex:0 0 40px;opacity:0;visibility:hidden}.input-module_input__0M39P.input-module_input-size-s__esc-k .input-module_clear__th40X{flex:0 0 32px}.input-module_clear-visible__YUlk9{opacity:1;visibility:visible}.input-module_clear-button__WuMDv{background-color:transparent;border:none;border-radius:50%;box-sizing:border-box;cursor:pointer;height:24px;line-height:0;outline:none;padding:0;position:absolute;-webkit-text-decoration:none;text-decoration:none;top:50%;transform:translateY(-50%);-webkit-user-select:none;-moz-user-select:none;user-select:none;width:24px}.input-module_clear-button__WuMDv:hover{background-color:#6e6a81}.input-module_clear-button__WuMDv:hover:after,.input-module_clear-button__WuMDv:hover:before{background:#fff}.input-module_clear-button__WuMDv:after,.input-module_clear-button__WuMDv:before{background:#6e6a81;content:\"\";height:1px;left:4px;position:absolute;top:50%;transform:rotate(-45deg);width:16px}.input-module_clear-button__WuMDv:before{transform:rotate(45deg)}.input-module_valid__epvMn{flex:0 0 32px}.input-module_valid-icon__5gs8o.input-module_valid-icon__5gs8o{position:absolute;top:50%;transform:translateY(-50%)}";
var styles$r = {"input":"input-module_input__0M39P","control":"input-module_control__HnTX3","no-autofill":"input-module_no-autofill__5zs6y","fullWidth":"input-module_fullWidth__MhMWN","input-disabled":"input-module_input-disabled__g55Ya","clear-button":"input-module_clear-button__WuMDv","valid":"input-module_valid__epvMn","input-readOnly":"input-module_input-readOnly__u3s3k","input-hasValue":"input-module_input-hasValue__TzSuH","input-size-s":"input-module_input-size-s__esc-k","input-size-m":"input-module_input-size-m__02O0i","input-size-l":"input-module_input-size-l__qCdg6","box":"input-module_box__niDn-","wrapper":"input-module_wrapper__d-IJV","label":"input-module_label__rdV0j","input-focused":"input-module_input-focused__B8E0B","input-error":"input-module_input-error__HBF7A","content":"input-module_content__E9TS7","content-after":"input-module_content-after__sf6mh","content-before":"input-module_content-before__3O-5A","clear":"input-module_clear__th40X","clear-visible":"input-module_clear-visible__YUlk9","valid-icon":"input-module_valid-icon__5gs8o"};
styleInject(css_248z$1d);

const FRACTION_DELIMITER = ',';
const DEFAULT_FORMATTER = (value) => value;
const DEFAULT_PARSER = (value) => value;
const DEFAULT_AUTOCOMPLETE_VALUE = 'off';
const DIGIT_FORMATTER_REGEX = /\d(?=(\d{3})+(,|$))/g;
const DIGIT_SECTION_DELIMITER = '$& ';

const BaseInput = (_a) => {
    var { className, ref, size = Size.Medium, autoComplete = DEFAULT_AUTOCOMPLETE_VALUE, label, isError, isValid, disabled, hasClear, readOnly, contentBefore, contentAfter, onChange, parser, formatter, focused: focusedInit = false, autoFocus = false, hovered: hoveredInit = false, fullWidth = false, dataTest, dataGtm, value: v, controlRef } = _a, rest = __rest(_a, ["className", "ref", "size", "autoComplete", "label", "isError", "isValid", "disabled", "hasClear", "readOnly", "contentBefore", "contentAfter", "onChange", "parser", "formatter", "focused", "autoFocus", "hovered", "fullWidth", "dataTest", "dataGtm", "value", "controlRef"]);
    const inputRef = React.useRef(null);
    let propValue = v !== undefined ? v : '';
    if (typeof v === 'number') {
        propValue = String(v);
    }
    const initialValue = React.useMemo(() => formatter(propValue ? propValue : ''), [propValue, formatter]);
    const [value, setValue] = React.useState(initialValue);
    const [focused, focusHandlers] = useFocus$1(focusedInit || autoFocus, rest);
    const [hovered, hoverHandlers] = useHover$1(hoveredInit, rest, disabled);
    const hasValue = value.length > 0;
    const { setCaretPosition } = useCaret(inputRef, value, formatter);
    React.useEffect(() => {
        setValue(prev => {
            if (parser(propValue || '') !== parser(prev)) {
                setCaretPosition(propValue || '', (propValue && propValue.length) || 0);
                return propValue || '';
            }
            return prev;
        });
    }, [propValue, parser, setCaretPosition]);
    const handleClear = React.useCallback((e) => {
        setValue('');
        setCaretPosition('', 0);
        if (inputRef.current !== null && !e.isDefaultPrevented()) {
            inputRef.current.focus();
            if (onChange) {
                const newValue = '';
                const syntheticEvent = Object.create(e);
                syntheticEvent.target = inputRef.current;
                syntheticEvent.currentTarget = inputRef.current;
                inputRef.current.value = newValue;
                onChange(parser(newValue), syntheticEvent);
            }
        }
    }, [onChange, parser, setCaretPosition]);
    const handleChange = React.useCallback((e) => {
        if (!e.currentTarget) {
            return;
        }
        const newValue = e.currentTarget.value;
        const type = e.currentTarget.type;
        const hasSelection = ['text', 'password', 'search', 'tel', 'url'].includes(type.toLowerCase());
        setValue(newValue);
        if (hasSelection) {
            setCaretPosition(newValue, Number(e.target.selectionStart));
        }
        if (onChange) {
            onChange(parser(newValue), e);
        }
    }, [onChange, parser, setCaretPosition]);
    const handleClick = React.useCallback(() => {
        if (inputRef && inputRef.current) {
            inputRef.current.focus();
        }
    }, []);
    const frameStyle = useFrame$1({
        focused: disabled || readOnly ? false : focused,
        hovered: disabled || readOnly ? false : hovered,
        disabled,
        error: isError,
        success: !readOnly && isValid,
    });
    const formattedValue = React.useMemo(() => formatter(value), [formatter, value]);
    return (React.createElement("span", Object.assign({ "data-test": dataTest, "data-gtm": dataGtm, ref: ref, onClick: handleClick }, hoverHandlers, { className: cn(styles$r.input, className, styles$r[`input-size-${size}`], frameStyle, {
            [styles$r.inputReadOnly]: readOnly,
            [styles$r.inputValid]: !readOnly && isValid,
            [styles$r.inputFocused]: disabled || readOnly ? false : focused,
            [styles$r.inputDisabled]: disabled,
            [styles$r.inputHasValue]: hasValue,
            [styles$r.inputError]: isError,
            [styles$r.fullWidth]: fullWidth,
        }) }),
        label ? React.createElement("span", { className: cn(styles$r.label) }, label) : null,
        React.createElement("span", { className: styles$r.box },
            contentBefore ? React.createElement("span", { className: cn(styles$r.contentBefore) }, contentBefore) : null,
            React.createElement("span", { className: styles$r.wrapper },
                React.createElement("input", Object.assign({}, rest, focusHandlers, { id: rest.id, value: formattedValue, autoCorrect: "off", autoComplete: autoComplete, readOnly: readOnly, disabled: disabled, autoFocus: autoFocus, ref: mergeRefs$1(inputRef, controlRef), onChange: handleChange, placeholder: rest.placeholder, className: cn(styles$r.control, styles$r.noAutofill) })),
                !disabled && !readOnly && isValid ? (React.createElement("span", { className: styles$r.valid },
                    React.createElement(TickIcon$1, { className: styles$r.validIcon }))) : null,
                hasClear && !disabled && !readOnly && hasValue ? (React.createElement("span", { className: cn(styles$r.clear, { [styles$r.clearVisible]: Boolean(value) }) },
                    React.createElement("button", { type: "button", disabled: disabled, onClick: handleClear, className: cn(styles$r.clearButton) }))) : null),
            contentAfter ? React.createElement("span", { className: cn(styles$r.contentAfter) }, contentAfter) : null)));
};
const Input$2 = (_a) => {
    var { parser = DEFAULT_PARSER, formatter = DEFAULT_FORMATTER } = _a, rest = __rest(_a, ["parser", "formatter"]);
    return (React.createElement(BaseInput, Object.assign({ parser: parser, formatter: formatter }, rest)));
};

var reactTextMaskExports = {};
var reactTextMask = {
  get exports(){ return reactTextMaskExports; },
  set exports(v){ reactTextMaskExports = v; },
};

(function (module, exports) {
	!function(e,t){module.exports=t(React);}(commonjsGlobal,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t);}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e;}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0, y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t);}},{key:"componentDidMount",value:function(){this.initTextMask();}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0, m.isNil)(n)&&!(0, m.isNil)(e.pipe)||!(0, m.isNil)(n)&&(0, m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask();}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e);}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e);}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}};},function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function";},function(e,t,r){function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return "string"==typeof e||e instanceof String}function a(e){return "number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return "undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return {maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]";},function(e,t,r){function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0, i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0, i.processCaretTraps)(t).maskWithoutCaretTraps;}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0, i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g);}for(var M=e.split(s).map(function(e,t){return {char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1);}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--;}else V+=F;continue e}N=!0;}b===!1&&(V+=v.substr(A,C));break}V+=B;}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s;}return {conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s="";},function(e,t){function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else {var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o="";},function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return {state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0, d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0, d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0, d.convertMaskToPlaceholder)(x,g);}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0, p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0, d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0, f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D));}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y));}function a(e){if((0, d.isString)(e))return e;if((0, d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout;},function(e,t){function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n;},function(e,t,r){function n(e,t,r,n,i,a,u,s){if(!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation";}throw l.framesToPop=1,l}}e.exports=n;},function(e,t,r){var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r};},function(e,t,r){e.exports=r(8)();},function(e,t){var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r;},function(t,r){t.exports=e;}])});
} (reactTextMask));

const BRACKET_SQUARE_OPENING = '[';
const BRACKET_SQUARE_CLOSING = ']';
const DIGIT_REGEXP = /\d/;
const LOWER_CASE_CHAR_REGEXP = /[a-z]/;
const UPPER_CASE_CHAR_REGEXP = /[A-Z]/;
const DEFAULT_MASK_MAP = {
    '9': DIGIT_REGEXP,
    a: LOWER_CASE_CHAR_REGEXP,
    A: UPPER_CASE_CHAR_REGEXP,
};
const mapCharsToRegExp = (charsPattern, maskMap = DEFAULT_MASK_MAP) => {
    const resultArray = [];
    const charBlock = [];
    for (const char of charsPattern) {
        if (charBlock.length || char === BRACKET_SQUARE_OPENING) {
            charBlock.push(char);
            if (char === BRACKET_SQUARE_CLOSING) {
                const joinedChars = charBlock.join('');
                resultArray.push(new RegExp(joinedChars));
                charBlock.length = 0;
            }
            continue;
        }
        const regexp = maskMap[char] || char;
        resultArray.push(regexp);
    }
    return resultArray;
};

const withMask = (Component) => (props) => {
    const { pattern, guide = false, parser = DEFAULT_PARSER } = props, rest = __rest(props, ["pattern", "guide", "parser"]);
    const regexpPattern = React.useMemo(() => mapCharsToRegExp(pattern.split('')), [pattern]);
    const mask = React.useCallback(value => {
        const { conformedValue } = reactTextMaskExports.conformToMask(value, regexpPattern, {
            guide,
            previousConformedValue: value,
        });
        return conformedValue;
    }, [guide, regexpPattern]);
    const parse = React.useCallback(value => parser(mask(value)), [mask, parser]);
    return React.createElement(Component, Object.assign({}, rest, { parser: parse, formatter: mask }));
};

const pipe$2 = (...ops) => ops.reduce((a, b) => arg => b(a(arg)));
const takeUntill$1 = (amount) => str => str.length <= amount ? str : str.slice(0, amount);
const normalizeNumber$1 = str => str.replace(/,,|\.\.|\.,|,\.|,/, '.').replace(/[^.|\d]/g, '');
const formatNumber = (digitFraction) => str => {
    const [digit, fraction] = str.split('.');
    const base = digit.replace(DIGIT_FORMATTER_REGEX, DIGIT_SECTION_DELIMITER);
    const fractional = digitFraction && fraction !== undefined ? FRACTION_DELIMITER + fraction.slice(0, digitFraction) : '';
    return base + fractional;
};
const fractionTakeUntill = (amount) => str => {
    const [digit, fraction] = str.split('.');
    return fraction ? [digit, takeUntill$1(amount)(fraction)].join('.') : str;
};

const numberFormatter = (digitFraction) => pipe$2(normalizeNumber$1, formatNumber(digitFraction));
const numberParser = (digitFraction) => pipe$2(normalizeNumber$1, fractionTakeUntill(digitFraction));
const NumberInput$2 = (_a) => {
    var { digitFraction = 0, parser, formatter } = _a, props = __rest(_a, ["digitFraction", "parser", "formatter"]);
    const internalParser = React.useCallback((value) => {
        const trimmed = value.trim();
        const prepared = trimmed ? parseFloat(numberParser(digitFraction)(trimmed)) : NaN;
        return parser ? parser(prepared.toString()) : prepared;
    }, [parser, digitFraction]);
    const internalFormatter = React.useCallback((value) => {
        var _a;
        if (!value) {
            value = (_a = `${props.value}`) !== null && _a !== void 0 ? _a : '';
        }
        const trimmed = value.trim();
        const prepared = trimmed ? numberFormatter(digitFraction)(trimmed) : trimmed;
        return formatter ? formatter(prepared) : prepared;
    }, [formatter, digitFraction, props.value]);
    const inputMode = React.useMemo(() => (digitFraction ? 'decimal' : 'numeric'), [digitFraction]);
    return React.createElement(BaseInput, Object.assign({}, props, { formatter: internalFormatter, parser: internalParser, inputMode: inputMode }));
};
var _NumberInput = NumberInput$2;

var Currency;
(function (Currency) {
    Currency["RUB"] = "RUB";
    Currency["EUR"] = "EUR";
    Currency["USD"] = "USD";
})(Currency || (Currency = {}));
var CurrencyLabel;
(function (CurrencyLabel) {
    CurrencyLabel["RUB"] = "\u20BD";
    CurrencyLabel["EUR"] = "\u20AC";
    CurrencyLabel["USD"] = "$";
})(CurrencyLabel || (CurrencyLabel = {}));

const MoneyInput = (_a) => {
    var { currency = Currency.RUB } = _a, props = __rest(_a, ["currency"]);
    const formatter = React.useCallback((value) => (value ? `${value} ${CurrencyLabel[currency]}` : value), [
        currency,
    ]);
    return React.createElement(_NumberInput, Object.assign({}, props, { formatter: formatter }));
};
var _MoneyInput = MoneyInput;

function _typeof$4(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$4 = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof$4 = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$4(obj);
}

function _classCallCheck$5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$5(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$3(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$5(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$3(subClass, superClass);
}

function _getPrototypeOf$3(o) {
  _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$3(o);
}

function _setPrototypeOf$3(o, p) {
  _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$3(o, p);
}

function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$4(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$3(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$4(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$5(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$4(self);
}

function _createSuper$3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$3();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$3(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$3(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$5(this, result);
  };
}

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf$3(object);
    if (object === null) break;
  }

  return object;
}

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);

      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

function set$3(target, property, value, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.set) {
    set$3 = Reflect.set;
  } else {
    set$3 = function set(target, property, value, receiver) {
      var base = _superPropBase(target, property);

      var desc;

      if (base) {
        desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.set) {
          desc.set.call(receiver, value);
          return true;
        } else if (!desc.writable) {
          return false;
        }
      }

      desc = Object.getOwnPropertyDescriptor(receiver, property);

      if (desc) {
        if (!desc.writable) {
          return false;
        }

        desc.value = value;
        Object.defineProperty(receiver, property, desc);
      } else {
        _defineProperty$3(receiver, property, value);
      }

      return true;
    };
  }

  return set$3(target, property, value, receiver);
}

function _set(target, property, value, receiver, isStrict) {
  var s = set$3(target, property, value, receiver || target);

  if (!s && isStrict) {
    throw new Error('failed to set property');
  }

  return value;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/** Checks if value is string */
function isString$2(str) {
  return typeof str === 'string' || str instanceof String;
}
/**
  Direction
  @prop {string} NONE
  @prop {string} LEFT
  @prop {string} FORCE_LEFT
  @prop {string} RIGHT
  @prop {string} FORCE_RIGHT
*/

var DIRECTION = {
  NONE: 'NONE',
  LEFT: 'LEFT',
  FORCE_LEFT: 'FORCE_LEFT',
  RIGHT: 'RIGHT',
  FORCE_RIGHT: 'FORCE_RIGHT'
};
/** */

function forceDirection(direction) {
  switch (direction) {
    case DIRECTION.LEFT:
      return DIRECTION.FORCE_LEFT;

    case DIRECTION.RIGHT:
      return DIRECTION.FORCE_RIGHT;

    default:
      return direction;
  }
}
/** Escapes regular expression control chars */

function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
} // cloned from https://github.com/epoberezkin/fast-deep-equal with small changes

function objectIncludes(b, a) {
  if (a === b) return true;
  var arrA = Array.isArray(a),
      arrB = Array.isArray(b),
      i;

  if (arrA && arrB) {
    if (a.length != b.length) return false;

    for (i = 0; i < a.length; i++) {
      if (!objectIncludes(a[i], b[i])) return false;
    }

    return true;
  }

  if (arrA != arrB) return false;

  if (a && b && _typeof$4(a) === 'object' && _typeof$4(b) === 'object') {
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA && dateB) return a.getTime() == b.getTime();
    if (dateA != dateB) return false;
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA && regexpB) return a.toString() == b.toString();
    if (regexpA != regexpB) return false;
    var keys = Object.keys(a); // if (keys.length !== Object.keys(b).length) return false;

    for (i = 0; i < keys.length; i++) {
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    }

    for (i = 0; i < keys.length; i++) {
      if (!objectIncludes(b[keys[i]], a[keys[i]])) return false;
    }

    return true;
  } else if (a && b && typeof a === 'function' && typeof b === 'function') {
    return a.toString() === b.toString();
  }

  return false;
}

/** Provides details of changing input */

var ActionDetails = /*#__PURE__*/function () {
  /** Current input value */

  /** Current cursor position */

  /** Old input value */

  /** Old selection */
  function ActionDetails(value, cursorPos, oldValue, oldSelection) {
    _classCallCheck$5(this, ActionDetails);

    this.value = value;
    this.cursorPos = cursorPos;
    this.oldValue = oldValue;
    this.oldSelection = oldSelection; // double check if left part was changed (autofilling, other non-standard input triggers)

    while (this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos)) {
      --this.oldSelection.start;
    }
  }
  /**
    Start changing position
    @readonly
  */


  _createClass$5(ActionDetails, [{
    key: "startChangePos",
    get: function get() {
      return Math.min(this.cursorPos, this.oldSelection.start);
    }
    /**
      Inserted symbols count
      @readonly
    */

  }, {
    key: "insertedCount",
    get: function get() {
      return this.cursorPos - this.startChangePos;
    }
    /**
      Inserted symbols
      @readonly
    */

  }, {
    key: "inserted",
    get: function get() {
      return this.value.substr(this.startChangePos, this.insertedCount);
    }
    /**
      Removed symbols count
      @readonly
    */

  }, {
    key: "removedCount",
    get: function get() {
      // Math.max for opposite operation
      return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
      this.oldValue.length - this.value.length, 0);
    }
    /**
      Removed symbols
      @readonly
    */

  }, {
    key: "removed",
    get: function get() {
      return this.oldValue.substr(this.startChangePos, this.removedCount);
    }
    /**
      Unchanged head symbols
      @readonly
    */

  }, {
    key: "head",
    get: function get() {
      return this.value.substring(0, this.startChangePos);
    }
    /**
      Unchanged tail symbols
      @readonly
    */

  }, {
    key: "tail",
    get: function get() {
      return this.value.substring(this.startChangePos + this.insertedCount);
    }
    /**
      Remove direction
      @readonly
    */

  }, {
    key: "removeDirection",
    get: function get() {
      if (!this.removedCount || this.insertedCount) return DIRECTION.NONE; // align right if delete at right or if range removed (event with backspace)

      return this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos ? DIRECTION.RIGHT : DIRECTION.LEFT;
    }
  }]);

  return ActionDetails;
}();

/**
  Provides details of changing model value
  @param {Object} [details]
  @param {string} [details.inserted] - Inserted symbols
  @param {boolean} [details.skip] - Can skip chars
  @param {number} [details.removeCount] - Removed symbols count
  @param {number} [details.tailShift] - Additional offset if any changes occurred before tail
*/
var ChangeDetails = /*#__PURE__*/function () {
  /** Inserted symbols */

  /** Can skip chars */

  /** Additional offset if any changes occurred before tail */

  /** Raw inserted is used by dynamic mask */
  function ChangeDetails(details) {
    _classCallCheck$5(this, ChangeDetails);

    Object.assign(this, {
      inserted: '',
      rawInserted: '',
      skip: false,
      tailShift: 0
    }, details);
  }
  /**
    Aggregate changes
    @returns {ChangeDetails} `this`
  */


  _createClass$5(ChangeDetails, [{
    key: "aggregate",
    value: function aggregate(details) {
      this.rawInserted += details.rawInserted;
      this.skip = this.skip || details.skip;
      this.inserted += details.inserted;
      this.tailShift += details.tailShift;
      return this;
    }
    /** Total offset considering all changes */

  }, {
    key: "offset",
    get: function get() {
      return this.tailShift + this.inserted.length;
    }
  }]);

  return ChangeDetails;
}();

/** Provides details of continuous extracted tail */
var ContinuousTailDetails = /*#__PURE__*/function () {
  /** Tail value as string */

  /** Tail start position */

  /** Start position */
  function ContinuousTailDetails() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var stop = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck$5(this, ContinuousTailDetails);

    this.value = value;
    this.from = from;
    this.stop = stop;
  }

  _createClass$5(ContinuousTailDetails, [{
    key: "toString",
    value: function toString() {
      return this.value;
    }
  }, {
    key: "extend",
    value: function extend(tail) {
      this.value += String(tail);
    }
  }, {
    key: "appendTo",
    value: function appendTo(masked) {
      return masked.append(this.toString(), {
        tail: true
      }).aggregate(masked._appendPlaceholder());
    }
  }, {
    key: "state",
    get: function get() {
      return {
        value: this.value,
        from: this.from,
        stop: this.stop
      };
    },
    set: function set(state) {
      Object.assign(this, state);
    }
  }, {
    key: "shiftBefore",
    value: function shiftBefore(pos) {
      if (this.from >= pos || !this.value.length) return '';
      var shiftChar = this.value[0];
      this.value = this.value.slice(1);
      return shiftChar;
    }
  }]);

  return ContinuousTailDetails;
}();

/**
 * Applies mask on element.
 * @constructor
 * @param {HTMLInputElement|HTMLTextAreaElement|MaskElement} el - Element to apply mask
 * @param {Object} opts - Custom mask options
 * @return {InputMask}
 */
function IMask(el) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // currently available only for input-like elements
  return new IMask.InputMask(el, opts);
}

/** Supported mask type */

/** Provides common masking stuff */
var Masked = /*#__PURE__*/function () {
  // $Shape<MaskedOptions>; TODO after fix https://github.com/facebook/flow/issues/4773

  /** @type {Mask} */

  /** */
  // $FlowFixMe no ideas

  /** Transforms value before mask processing */

  /** Validates if value is acceptable */

  /** Does additional processing in the end of editing */

  /** Format typed value to string */

  /** Parse strgin to get typed value */

  /** Enable characters overwriting */

  /** */
  function Masked(opts) {
    _classCallCheck$5(this, Masked);

    this._value = '';

    this._update(Object.assign({}, Masked.DEFAULTS, opts));

    this.isInitialized = true;
  }
  /** Sets and applies new options */


  _createClass$5(Masked, [{
    key: "updateOptions",
    value: function updateOptions(opts) {
      if (!Object.keys(opts).length) return;
      this.withValueRefresh(this._update.bind(this, opts));
    }
    /**
      Sets new options
      @protected
    */

  }, {
    key: "_update",
    value: function _update(opts) {
      Object.assign(this, opts);
    }
    /** Mask state */

  }, {
    key: "state",
    get: function get() {
      return {
        _value: this.value
      };
    },
    set: function set(state) {
      this._value = state._value;
    }
    /** Resets value */

  }, {
    key: "reset",
    value: function reset() {
      this._value = '';
    }
    /** */

  }, {
    key: "value",
    get: function get() {
      return this._value;
    },
    set: function set(value) {
      this.resolve(value);
    }
    /** Resolve new value */

  }, {
    key: "resolve",
    value: function resolve(value) {
      this.reset();
      this.append(value, {
        input: true
      }, '');
      this.doCommit();
      return this.value;
    }
    /** */

  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.value;
    },
    set: function set(value) {
      this.reset();
      this.append(value, {}, '');
      this.doCommit();
    }
    /** */

  }, {
    key: "typedValue",
    get: function get() {
      return this.doParse(this.value);
    },
    set: function set(value) {
      this.value = this.doFormat(value);
    }
    /** Value that includes raw user input */

  }, {
    key: "rawInputValue",
    get: function get() {
      return this.extractInput(0, this.value.length, {
        raw: true
      });
    },
    set: function set(value) {
      this.reset();
      this.append(value, {
        raw: true
      }, '');
      this.doCommit();
    }
    /** */

  }, {
    key: "isComplete",
    get: function get() {
      return true;
    }
    /** Finds nearest input position in direction */

  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos, direction) {
      return cursorPos;
    }
    /** Extracts value in range considering flags */

  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      return this.value.slice(fromPos, toPos);
    }
    /** Extracts tail in range */

  }, {
    key: "extractTail",
    value: function extractTail() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      return new ContinuousTailDetails(this.extractInput(fromPos, toPos), fromPos);
    }
    /** Appends tail */
    // $FlowFixMe no ideas

  }, {
    key: "appendTail",
    value: function appendTail(tail) {
      if (isString$2(tail)) tail = new ContinuousTailDetails(String(tail));
      return tail.appendTo(this);
    }
    /** Appends char */

  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch) {
      if (!ch) return new ChangeDetails();
      this._value += ch;
      return new ChangeDetails({
        inserted: ch,
        rawInserted: ch
      });
    }
    /** Appends char */

  }, {
    key: "_appendChar",
    value: function _appendChar(ch) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var checkTail = arguments.length > 2 ? arguments[2] : undefined;
      var consistentState = this.state;

      var details = this._appendCharRaw(this.doPrepare(ch, flags), flags);

      if (details.inserted) {
        var consistentTail;
        var appended = this.doValidate(flags) !== false;

        if (appended && checkTail != null) {
          // validation ok, check tail
          var beforeTailState = this.state;

          if (this.overwrite) {
            consistentTail = checkTail.state;
            checkTail.shiftBefore(this.value.length);
          }

          var tailDetails = this.appendTail(checkTail);
          appended = tailDetails.rawInserted === checkTail.toString(); // if ok, rollback state after tail

          if (appended && tailDetails.inserted) this.state = beforeTailState;
        } // revert all if something went wrong


        if (!appended) {
          details = new ChangeDetails();
          this.state = consistentState;
          if (checkTail && consistentTail) checkTail.state = consistentTail;
        }
      }

      return details;
    }
    /** Appends optional placeholder at end */

  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder() {
      return new ChangeDetails();
    }
    /** Appends symbols considering flags */
    // $FlowFixMe no ideas

  }, {
    key: "append",
    value: function append(str, flags, tail) {
      if (!isString$2(str)) throw new Error('value should be string');
      var details = new ChangeDetails();
      var checkTail = isString$2(tail) ? new ContinuousTailDetails(String(tail)) : tail;
      if (flags && flags.tail) flags._beforeTailState = this.state;

      for (var ci = 0; ci < str.length; ++ci) {
        details.aggregate(this._appendChar(str[ci], flags, checkTail));
      } // append tail but aggregate only tailShift


      if (checkTail != null) {
        details.tailShift += this.appendTail(checkTail).tailShift; // TODO it's a good idea to clear state after appending ends
        // but it causes bugs when one append calls another (when dynamic dispatch set rawInputValue)
        // this._resetBeforeTailState();
      }

      return details;
    }
    /** */

  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      this._value = this.value.slice(0, fromPos) + this.value.slice(toPos);
      return new ChangeDetails();
    }
    /** Calls function and reapplies current value */

  }, {
    key: "withValueRefresh",
    value: function withValueRefresh(fn) {
      if (this._refreshing || !this.isInitialized) return fn();
      this._refreshing = true;
      var rawInput = this.rawInputValue;
      var value = this.value;
      var ret = fn();
      this.rawInputValue = rawInput; // append lost trailing chars at end

      if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
        this.append(value.slice(this.value.length), {}, '');
      }

      delete this._refreshing;
      return ret;
    }
    /** */

  }, {
    key: "runIsolated",
    value: function runIsolated(fn) {
      if (this._isolated || !this.isInitialized) return fn(this);
      this._isolated = true;
      var state = this.state;
      var ret = fn(this);
      this.state = state;
      delete this._isolated;
      return ret;
    }
    /**
      Prepares string before mask processing
      @protected
    */

  }, {
    key: "doPrepare",
    value: function doPrepare(str) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.prepare ? this.prepare(str, this, flags) : str;
    }
    /**
      Validates if value is acceptable
      @protected
    */

  }, {
    key: "doValidate",
    value: function doValidate(flags) {
      return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
    }
    /**
      Does additional processing in the end of editing
      @protected
    */

  }, {
    key: "doCommit",
    value: function doCommit() {
      if (this.commit) this.commit(this.value, this);
    }
    /** */

  }, {
    key: "doFormat",
    value: function doFormat(value) {
      return this.format ? this.format(value, this) : value;
    }
    /** */

  }, {
    key: "doParse",
    value: function doParse(str) {
      return this.parse ? this.parse(str, this) : str;
    }
    /** */

  }, {
    key: "splice",
    value: function splice(start, deleteCount, inserted, removeDirection) {
      var tailPos = start + deleteCount;
      var tail = this.extractTail(tailPos);
      var startChangePos = this.nearestInputPos(start, removeDirection);
      var changeDetails = new ChangeDetails({
        tailShift: startChangePos - start // adjust tailShift if start was aligned

      }).aggregate(this.remove(startChangePos)).aggregate(this.append(inserted, {
        input: true
      }, tail));
      return changeDetails;
    }
  }]);

  return Masked;
}();
Masked.DEFAULTS = {
  format: function format(v) {
    return v;
  },
  parse: function parse(v) {
    return v;
  }
};
IMask.Masked = Masked;

/** Get Masked class by mask type */

function maskedClass(mask) {
  if (mask == null) {
    throw new Error('mask property should be defined');
  } // $FlowFixMe


  if (mask instanceof RegExp) return IMask.MaskedRegExp; // $FlowFixMe

  if (isString$2(mask)) return IMask.MaskedPattern; // $FlowFixMe

  if (mask instanceof Date || mask === Date) return IMask.MaskedDate; // $FlowFixMe

  if (mask instanceof Number || typeof mask === 'number' || mask === Number) return IMask.MaskedNumber; // $FlowFixMe

  if (Array.isArray(mask) || mask === Array) return IMask.MaskedDynamic; // $FlowFixMe

  if (IMask.Masked && mask.prototype instanceof IMask.Masked) return mask; // $FlowFixMe

  if (mask instanceof Function) return IMask.MaskedFunction; // $FlowFixMe

  if (mask instanceof IMask.Masked) return mask.constructor;
  console.warn('Mask not found for mask', mask); // eslint-disable-line no-console
  // $FlowFixMe

  return IMask.Masked;
}
/** Creates new {@link Masked} depending on mask type */

function createMask(opts) {
  // $FlowFixMe
  if (IMask.Masked && opts instanceof IMask.Masked) return opts;
  opts = Object.assign({}, opts);
  var mask = opts.mask; // $FlowFixMe

  if (IMask.Masked && mask instanceof IMask.Masked) return mask;
  var MaskedClass = maskedClass(mask);
  if (!MaskedClass) throw new Error('Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.');
  return new MaskedClass(opts);
}
IMask.createMask = createMask;

var _excluded$9 = ["mask"];
var DEFAULT_INPUT_DEFINITIONS = {
  '0': /\d/,
  'a': /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  '*': /./
};
/** */

var PatternInputDefinition = /*#__PURE__*/function () {
  /** */

  /** */

  /** */

  /** */

  /** */

  /** */
  function PatternInputDefinition(opts) {
    _classCallCheck$5(this, PatternInputDefinition);

    var mask = opts.mask,
        blockOpts = _objectWithoutProperties$4(opts, _excluded$9);

    this.masked = createMask({
      mask: mask
    });
    Object.assign(this, blockOpts);
  }

  _createClass$5(PatternInputDefinition, [{
    key: "reset",
    value: function reset() {
      this._isFilled = false;
      this.masked.reset();
    }
  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;

      if (fromPos === 0 && toPos >= 1) {
        this._isFilled = false;
        return this.masked.remove(fromPos, toPos);
      }

      return new ChangeDetails();
    }
  }, {
    key: "value",
    get: function get() {
      return this.masked.value || (this._isFilled && !this.isOptional ? this.placeholderChar : '');
    }
  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.masked.unmaskedValue;
    }
  }, {
    key: "isComplete",
    get: function get() {
      return Boolean(this.masked.value) || this.isOptional;
    }
  }, {
    key: "_appendChar",
    value: function _appendChar(str) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this._isFilled) return new ChangeDetails();
      var state = this.masked.state; // simulate input

      var details = this.masked._appendChar(str, flags);

      if (details.inserted && this.doValidate(flags) === false) {
        details.inserted = details.rawInserted = '';
        this.masked.state = state;
      }

      if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) {
        details.inserted = this.placeholderChar;
      }

      details.skip = !details.inserted && !this.isOptional;
      this._isFilled = Boolean(details.inserted);
      return details;
    }
  }, {
    key: "append",
    value: function append() {
      var _this$masked;

      return (_this$masked = this.masked).append.apply(_this$masked, arguments);
    }
  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder() {
      var details = new ChangeDetails();
      if (this._isFilled || this.isOptional) return details;
      this._isFilled = true;
      details.inserted = this.placeholderChar;
      return details;
    }
  }, {
    key: "extractTail",
    value: function extractTail() {
      var _this$masked2;

      return (_this$masked2 = this.masked).extractTail.apply(_this$masked2, arguments);
    }
  }, {
    key: "appendTail",
    value: function appendTail() {
      var _this$masked3;

      return (_this$masked3 = this.masked).appendTail.apply(_this$masked3, arguments);
    }
  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      var flags = arguments.length > 2 ? arguments[2] : undefined;
      return this.masked.extractInput(fromPos, toPos, flags);
    }
  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos) {
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
      var minPos = 0;
      var maxPos = this.value.length;
      var boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);

      switch (direction) {
        case DIRECTION.LEFT:
        case DIRECTION.FORCE_LEFT:
          return this.isComplete ? boundPos : minPos;

        case DIRECTION.RIGHT:
        case DIRECTION.FORCE_RIGHT:
          return this.isComplete ? boundPos : maxPos;

        case DIRECTION.NONE:
        default:
          return boundPos;
      }
    }
  }, {
    key: "doValidate",
    value: function doValidate() {
      var _this$masked4, _this$parent;

      return (_this$masked4 = this.masked).doValidate.apply(_this$masked4, arguments) && (!this.parent || (_this$parent = this.parent).doValidate.apply(_this$parent, arguments));
    }
  }, {
    key: "doCommit",
    value: function doCommit() {
      this.masked.doCommit();
    }
  }, {
    key: "state",
    get: function get() {
      return {
        masked: this.masked.state,
        _isFilled: this._isFilled
      };
    },
    set: function set(state) {
      this.masked.state = state.masked;
      this._isFilled = state._isFilled;
    }
  }]);

  return PatternInputDefinition;
}();

var PatternFixedDefinition = /*#__PURE__*/function () {
  /** */

  /** */

  /** */

  /** */
  function PatternFixedDefinition(opts) {
    _classCallCheck$5(this, PatternFixedDefinition);

    Object.assign(this, opts);
    this._value = '';
  }

  _createClass$5(PatternFixedDefinition, [{
    key: "value",
    get: function get() {
      return this._value;
    }
  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.isUnmasking ? this.value : '';
    }
  }, {
    key: "reset",
    value: function reset() {
      this._isRawInput = false;
      this._value = '';
    }
  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
      this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
      if (!this._value) this._isRawInput = false;
      return new ChangeDetails();
    }
  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos) {
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
      var minPos = 0;
      var maxPos = this._value.length;

      switch (direction) {
        case DIRECTION.LEFT:
        case DIRECTION.FORCE_LEFT:
          return minPos;

        case DIRECTION.NONE:
        case DIRECTION.RIGHT:
        case DIRECTION.FORCE_RIGHT:
        default:
          return maxPos;
      }
    }
  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
      var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || '';
    }
  }, {
    key: "isComplete",
    get: function get() {
      return true;
    }
  }, {
    key: "_appendChar",
    value: function _appendChar(str) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var details = new ChangeDetails();
      if (this._value) return details;
      var appended = this.char === str[0];
      var isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && !flags.tail;
      if (isResolved) details.rawInserted = this.char;
      this._value = details.inserted = this.char;
      this._isRawInput = isResolved && (flags.raw || flags.input);
      return details;
    }
  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder() {
      var details = new ChangeDetails();
      if (this._value) return details;
      this._value = details.inserted = this.char;
      return details;
    }
  }, {
    key: "extractTail",
    value: function extractTail() {
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      return new ContinuousTailDetails('');
    } // $FlowFixMe no ideas

  }, {
    key: "appendTail",
    value: function appendTail(tail) {
      if (isString$2(tail)) tail = new ContinuousTailDetails(String(tail));
      return tail.appendTo(this);
    }
  }, {
    key: "append",
    value: function append(str, flags, tail) {
      var details = this._appendChar(str, flags);

      if (tail != null) {
        details.tailShift += this.appendTail(tail).tailShift;
      }

      return details;
    }
  }, {
    key: "doCommit",
    value: function doCommit() {}
  }, {
    key: "state",
    get: function get() {
      return {
        _value: this._value,
        _isRawInput: this._isRawInput
      };
    },
    set: function set(state) {
      Object.assign(this, state);
    }
  }]);

  return PatternFixedDefinition;
}();

var _excluded$8 = ["chunks"];

var ChunksTailDetails = /*#__PURE__*/function () {
  /** */
  function ChunksTailDetails() {
    var chunks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck$5(this, ChunksTailDetails);

    this.chunks = chunks;
    this.from = from;
  }

  _createClass$5(ChunksTailDetails, [{
    key: "toString",
    value: function toString() {
      return this.chunks.map(String).join('');
    } // $FlowFixMe no ideas

  }, {
    key: "extend",
    value: function extend(tailChunk) {
      if (!String(tailChunk)) return;
      if (isString$2(tailChunk)) tailChunk = new ContinuousTailDetails(String(tailChunk));
      var lastChunk = this.chunks[this.chunks.length - 1];
      var extendLast = lastChunk && (lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && // if tail chunk goes just after last chunk
      tailChunk.from === lastChunk.from + lastChunk.toString().length;

      if (tailChunk instanceof ContinuousTailDetails) {
        // check the ability to extend previous chunk
        if (extendLast) {
          // extend previous chunk
          lastChunk.extend(tailChunk.toString());
        } else {
          // append new chunk
          this.chunks.push(tailChunk);
        }
      } else if (tailChunk instanceof ChunksTailDetails) {
        if (tailChunk.stop == null) {
          // unwrap floating chunks to parent, keeping `from` pos
          var firstTailChunk;

          while (tailChunk.chunks.length && tailChunk.chunks[0].stop == null) {
            firstTailChunk = tailChunk.chunks.shift();
            firstTailChunk.from += tailChunk.from;
            this.extend(firstTailChunk);
          }
        } // if tail chunk still has value


        if (tailChunk.toString()) {
          // if chunks contains stops, then popup stop to container
          tailChunk.stop = tailChunk.blockIndex;
          this.chunks.push(tailChunk);
        }
      }
    }
  }, {
    key: "appendTo",
    value: function appendTo(masked) {
      // $FlowFixMe
      if (!(masked instanceof IMask.MaskedPattern)) {
        var tail = new ContinuousTailDetails(this.toString());
        return tail.appendTo(masked);
      }

      var details = new ChangeDetails();

      for (var ci = 0; ci < this.chunks.length && !details.skip; ++ci) {
        var chunk = this.chunks[ci];

        var lastBlockIter = masked._mapPosToBlock(masked.value.length);

        var stop = chunk.stop;
        var chunkBlock = void 0;

        if (stop != null && (!lastBlockIter || lastBlockIter.index <= stop)) {
          if (chunk instanceof ChunksTailDetails || // for continuous block also check if stop is exist
          masked._stops.indexOf(stop) >= 0) {
            details.aggregate(masked._appendPlaceholder(stop));
          }

          chunkBlock = chunk instanceof ChunksTailDetails && masked._blocks[stop];
        }

        if (chunkBlock) {
          var tailDetails = chunkBlock.appendTail(chunk);
          tailDetails.skip = false; // always ignore skip, it will be set on last

          details.aggregate(tailDetails);
          masked._value += tailDetails.inserted; // get not inserted chars

          var remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
          if (remainChars) details.aggregate(masked.append(remainChars, {
            tail: true
          }));
        } else {
          details.aggregate(masked.append(chunk.toString(), {
            tail: true
          }));
        }
      }
      return details;
    }
  }, {
    key: "state",
    get: function get() {
      return {
        chunks: this.chunks.map(function (c) {
          return c.state;
        }),
        from: this.from,
        stop: this.stop,
        blockIndex: this.blockIndex
      };
    },
    set: function set(state) {
      var chunks = state.chunks,
          props = _objectWithoutProperties$4(state, _excluded$8);

      Object.assign(this, props);
      this.chunks = chunks.map(function (cstate) {
        var chunk = "chunks" in cstate ? new ChunksTailDetails() : new ContinuousTailDetails(); // $FlowFixMe already checked above

        chunk.state = cstate;
        return chunk;
      });
    }
  }, {
    key: "shiftBefore",
    value: function shiftBefore(pos) {
      if (this.from >= pos || !this.chunks.length) return '';
      var chunkShiftPos = pos - this.from;
      var ci = 0;

      while (ci < this.chunks.length) {
        var chunk = this.chunks[ci];
        var shiftChar = chunk.shiftBefore(chunkShiftPos);

        if (chunk.toString()) {
          // chunk still contains value
          // but not shifted - means no more available chars to shift
          if (!shiftChar) break;
          ++ci;
        } else {
          // clean if chunk has no value
          this.chunks.splice(ci, 1);
        }

        if (shiftChar) return shiftChar;
      }

      return '';
    }
  }]);

  return ChunksTailDetails;
}();

/** Masking by RegExp */

var MaskedRegExp = /*#__PURE__*/function (_Masked) {
  _inherits$5(MaskedRegExp, _Masked);

  var _super = _createSuper$3(MaskedRegExp);

  function MaskedRegExp() {
    _classCallCheck$5(this, MaskedRegExp);

    return _super.apply(this, arguments);
  }

  _createClass$5(MaskedRegExp, [{
    key: "_update",
    value:
    /**
      @override
      @param {Object} opts
    */
    function _update(opts) {
      if (opts.mask) opts.validate = function (value) {
        return value.search(opts.mask) >= 0;
      };

      _get(_getPrototypeOf$3(MaskedRegExp.prototype), "_update", this).call(this, opts);
    }
  }]);

  return MaskedRegExp;
}(Masked);
IMask.MaskedRegExp = MaskedRegExp;

var _excluded$7 = ["_blocks"];

/**
  Pattern mask
  @param {Object} opts
  @param {Object} opts.blocks
  @param {Object} opts.definitions
  @param {string} opts.placeholderChar
  @param {boolean} opts.lazy
*/
var MaskedPattern = /*#__PURE__*/function (_Masked) {
  _inherits$5(MaskedPattern, _Masked);

  var _super = _createSuper$3(MaskedPattern);

  /** */

  /** */

  /** Single char for empty input */

  /** Show placeholder only when needed */
  function MaskedPattern() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck$5(this, MaskedPattern);

    // TODO type $Shape<MaskedPatternOptions>={} does not work
    opts.definitions = Object.assign({}, DEFAULT_INPUT_DEFINITIONS, opts.definitions);
    return _super.call(this, Object.assign({}, MaskedPattern.DEFAULTS, opts));
  }
  /**
    @override
    @param {Object} opts
  */


  _createClass$5(MaskedPattern, [{
    key: "_update",
    value: function _update() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      opts.definitions = Object.assign({}, this.definitions, opts.definitions);

      _get(_getPrototypeOf$3(MaskedPattern.prototype), "_update", this).call(this, opts);

      this._rebuildMask();
    }
    /** */

  }, {
    key: "_rebuildMask",
    value: function _rebuildMask() {
      var _this = this;

      var defs = this.definitions;
      this._blocks = [];
      this._stops = [];
      this._maskedBlocks = {};
      var pattern = this.mask;
      if (!pattern || !defs) return;
      var unmaskingBlock = false;
      var optionalBlock = false;

      for (var i = 0; i < pattern.length; ++i) {
        if (this.blocks) {
          var _ret = function () {
            var p = pattern.slice(i);
            var bNames = Object.keys(_this.blocks).filter(function (bName) {
              return p.indexOf(bName) === 0;
            }); // order by key length

            bNames.sort(function (a, b) {
              return b.length - a.length;
            }); // use block name with max length

            var bName = bNames[0];

            if (bName) {
              // $FlowFixMe no ideas
              var maskedBlock = createMask(Object.assign({
                parent: _this,
                lazy: _this.lazy,
                placeholderChar: _this.placeholderChar,
                overwrite: _this.overwrite
              }, _this.blocks[bName]));

              if (maskedBlock) {
                _this._blocks.push(maskedBlock); // store block index


                if (!_this._maskedBlocks[bName]) _this._maskedBlocks[bName] = [];

                _this._maskedBlocks[bName].push(_this._blocks.length - 1);
              }

              i += bName.length - 1;
              return "continue";
            }
          }();

          if (_ret === "continue") continue;
        }

        var char = pattern[i];

        var _isInput = (char in defs);

        if (char === MaskedPattern.STOP_CHAR) {
          this._stops.push(this._blocks.length);

          continue;
        }

        if (char === '{' || char === '}') {
          unmaskingBlock = !unmaskingBlock;
          continue;
        }

        if (char === '[' || char === ']') {
          optionalBlock = !optionalBlock;
          continue;
        }

        if (char === MaskedPattern.ESCAPE_CHAR) {
          ++i;
          char = pattern[i];
          if (!char) break;
          _isInput = false;
        }

        var def = _isInput ? new PatternInputDefinition({
          parent: this,
          lazy: this.lazy,
          placeholderChar: this.placeholderChar,
          mask: defs[char],
          isOptional: optionalBlock
        }) : new PatternFixedDefinition({
          char: char,
          isUnmasking: unmaskingBlock
        });

        this._blocks.push(def);
      }
    }
    /**
      @override
    */

  }, {
    key: "state",
    get: function get() {
      return Object.assign({}, _get(_getPrototypeOf$3(MaskedPattern.prototype), "state", this), {
        _blocks: this._blocks.map(function (b) {
          return b.state;
        })
      });
    },
    set: function set(state) {
      var _blocks = state._blocks,
          maskedState = _objectWithoutProperties$4(state, _excluded$7);

      this._blocks.forEach(function (b, bi) {
        return b.state = _blocks[bi];
      });

      _set(_getPrototypeOf$3(MaskedPattern.prototype), "state", maskedState, this, true);
    }
    /**
      @override
    */

  }, {
    key: "reset",
    value: function reset() {
      _get(_getPrototypeOf$3(MaskedPattern.prototype), "reset", this).call(this);

      this._blocks.forEach(function (b) {
        return b.reset();
      });
    }
    /**
      @override
    */

  }, {
    key: "isComplete",
    get: function get() {
      return this._blocks.every(function (b) {
        return b.isComplete;
      });
    }
    /**
      @override
    */

  }, {
    key: "doCommit",
    value: function doCommit() {
      this._blocks.forEach(function (b) {
        return b.doCommit();
      });

      _get(_getPrototypeOf$3(MaskedPattern.prototype), "doCommit", this).call(this);
    }
    /**
      @override
    */

  }, {
    key: "unmaskedValue",
    get: function get() {
      return this._blocks.reduce(function (str, b) {
        return str += b.unmaskedValue;
      }, '');
    },
    set: function set(unmaskedValue) {
      _set(_getPrototypeOf$3(MaskedPattern.prototype), "unmaskedValue", unmaskedValue, this, true);
    }
    /**
      @override
    */

  }, {
    key: "value",
    get: function get() {
      // TODO return _value when not in change?
      return this._blocks.reduce(function (str, b) {
        return str += b.value;
      }, '');
    },
    set: function set(value) {
      _set(_getPrototypeOf$3(MaskedPattern.prototype), "value", value, this, true);
    }
    /**
      @override
    */

  }, {
    key: "appendTail",
    value: function appendTail(tail) {
      return _get(_getPrototypeOf$3(MaskedPattern.prototype), "appendTail", this).call(this, tail).aggregate(this._appendPlaceholder());
    }
    /**
      @override
    */

  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var blockIter = this._mapPosToBlock(this.value.length);

      var details = new ChangeDetails();
      if (!blockIter) return details;

      for (var bi = blockIter.index;; ++bi) {
        var _block = this._blocks[bi];
        if (!_block) break;

        var blockDetails = _block._appendChar(ch, flags);

        var skip = blockDetails.skip;
        details.aggregate(blockDetails);
        if (skip || blockDetails.rawInserted) break; // go next char
      }

      return details;
    }
    /**
      @override
    */

  }, {
    key: "extractTail",
    value: function extractTail() {
      var _this2 = this;

      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      var chunkTail = new ChunksTailDetails();
      if (fromPos === toPos) return chunkTail;

      this._forEachBlocksInRange(fromPos, toPos, function (b, bi, bFromPos, bToPos) {
        var blockChunk = b.extractTail(bFromPos, bToPos);
        blockChunk.stop = _this2._findStopBefore(bi);
        blockChunk.from = _this2._blockStartPos(bi);
        if (blockChunk instanceof ChunksTailDetails) blockChunk.blockIndex = bi;
        chunkTail.extend(blockChunk);
      });

      return chunkTail;
    }
    /**
      @override
    */

  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (fromPos === toPos) return '';
      var input = '';

      this._forEachBlocksInRange(fromPos, toPos, function (b, _, fromPos, toPos) {
        input += b.extractInput(fromPos, toPos, flags);
      });

      return input;
    }
  }, {
    key: "_findStopBefore",
    value: function _findStopBefore(blockIndex) {
      var stopBefore;

      for (var si = 0; si < this._stops.length; ++si) {
        var stop = this._stops[si];
        if (stop <= blockIndex) stopBefore = stop;else break;
      }

      return stopBefore;
    }
    /** Appends placeholder depending on laziness */

  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder(toBlockIndex) {
      var _this3 = this;

      var details = new ChangeDetails();
      if (this.lazy && toBlockIndex == null) return details;

      var startBlockIter = this._mapPosToBlock(this.value.length);

      if (!startBlockIter) return details;
      var startBlockIndex = startBlockIter.index;
      var endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;

      this._blocks.slice(startBlockIndex, endBlockIndex).forEach(function (b) {
        if (!b.lazy || toBlockIndex != null) {
          // $FlowFixMe `_blocks` may not be present
          var args = b._blocks != null ? [b._blocks.length] : [];

          var bDetails = b._appendPlaceholder.apply(b, args);

          _this3._value += bDetails.inserted;
          details.aggregate(bDetails);
        }
      });

      return details;
    }
    /** Finds block in pos */

  }, {
    key: "_mapPosToBlock",
    value: function _mapPosToBlock(pos) {
      var accVal = '';

      for (var bi = 0; bi < this._blocks.length; ++bi) {
        var _block2 = this._blocks[bi];
        var blockStartPos = accVal.length;
        accVal += _block2.value;

        if (pos <= accVal.length) {
          return {
            index: bi,
            offset: pos - blockStartPos
          };
        }
      }
    }
    /** */

  }, {
    key: "_blockStartPos",
    value: function _blockStartPos(blockIndex) {
      return this._blocks.slice(0, blockIndex).reduce(function (pos, b) {
        return pos += b.value.length;
      }, 0);
    }
    /** */

  }, {
    key: "_forEachBlocksInRange",
    value: function _forEachBlocksInRange(fromPos) {
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      var fn = arguments.length > 2 ? arguments[2] : undefined;

      var fromBlockIter = this._mapPosToBlock(fromPos);

      if (fromBlockIter) {
        var toBlockIter = this._mapPosToBlock(toPos); // process first block


        var isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
        var fromBlockStartPos = fromBlockIter.offset;
        var fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].value.length;
        fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);

        if (toBlockIter && !isSameBlock) {
          // process intermediate blocks
          for (var bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi) {
            fn(this._blocks[bi], bi, 0, this._blocks[bi].value.length);
          } // process last block


          fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
        }
      }
    }
    /**
      @override
    */

  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;

      var removeDetails = _get(_getPrototypeOf$3(MaskedPattern.prototype), "remove", this).call(this, fromPos, toPos);

      this._forEachBlocksInRange(fromPos, toPos, function (b, _, bFromPos, bToPos) {
        removeDetails.aggregate(b.remove(bFromPos, bToPos));
      });

      return removeDetails;
    }
    /**
      @override
    */

  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos) {
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
      // TODO refactor - extract alignblock
      var beginBlockData = this._mapPosToBlock(cursorPos) || {
        index: 0,
        offset: 0
      };
      var beginBlockOffset = beginBlockData.offset,
          beginBlockIndex = beginBlockData.index;
      var beginBlock = this._blocks[beginBlockIndex];
      if (!beginBlock) return cursorPos;
      var beginBlockCursorPos = beginBlockOffset; // if position inside block - try to adjust it

      if (beginBlockCursorPos !== 0 && beginBlockCursorPos < beginBlock.value.length) {
        beginBlockCursorPos = beginBlock.nearestInputPos(beginBlockOffset, forceDirection(direction));
      }

      var cursorAtRight = beginBlockCursorPos === beginBlock.value.length;
      var cursorAtLeft = beginBlockCursorPos === 0; //  cursor is INSIDE first block (not at bounds)

      if (!cursorAtLeft && !cursorAtRight) return this._blockStartPos(beginBlockIndex) + beginBlockCursorPos;
      var searchBlockIndex = cursorAtRight ? beginBlockIndex + 1 : beginBlockIndex;

      if (direction === DIRECTION.NONE) {
        // NONE direction used to calculate start input position if no chars were removed
        // FOR NONE:
        // -
        // input|any
        // ->
        //  any|input
        // <-
        //  filled-input|any
        // check if first block at left is input
        if (searchBlockIndex > 0) {
          var blockIndexAtLeft = searchBlockIndex - 1;
          var blockAtLeft = this._blocks[blockIndexAtLeft];
          var blockInputPos = blockAtLeft.nearestInputPos(0, DIRECTION.NONE); // is input

          if (!blockAtLeft.value.length || blockInputPos !== blockAtLeft.value.length) {
            return this._blockStartPos(searchBlockIndex);
          }
        } // ->


        var firstInputAtRight = searchBlockIndex;

        for (var bi = firstInputAtRight; bi < this._blocks.length; ++bi) {
          var blockAtRight = this._blocks[bi];

          var _blockInputPos = blockAtRight.nearestInputPos(0, DIRECTION.NONE);

          if (!blockAtRight.value.length || _blockInputPos !== blockAtRight.value.length) {
            return this._blockStartPos(bi) + _blockInputPos;
          }
        } // <-
        // find first non-fixed symbol


        for (var _bi = searchBlockIndex - 1; _bi >= 0; --_bi) {
          var _block3 = this._blocks[_bi];

          var _blockInputPos2 = _block3.nearestInputPos(0, DIRECTION.NONE); // is input


          if (!_block3.value.length || _blockInputPos2 !== _block3.value.length) {
            return this._blockStartPos(_bi) + _block3.value.length;
          }
        }

        return cursorPos;
      }

      if (direction === DIRECTION.LEFT || direction === DIRECTION.FORCE_LEFT) {
        // -
        //  any|filled-input
        // <-
        //  any|first not empty is not-len-aligned
        //  not-0-aligned|any
        // ->
        //  any|not-len-aligned or end
        // check if first block at right is filled input
        var firstFilledBlockIndexAtRight;

        for (var _bi2 = searchBlockIndex; _bi2 < this._blocks.length; ++_bi2) {
          if (this._blocks[_bi2].value) {
            firstFilledBlockIndexAtRight = _bi2;
            break;
          }
        }

        if (firstFilledBlockIndexAtRight != null) {
          var filledBlock = this._blocks[firstFilledBlockIndexAtRight];

          var _blockInputPos3 = filledBlock.nearestInputPos(0, DIRECTION.RIGHT);

          if (_blockInputPos3 === 0 && filledBlock.unmaskedValue.length) {
            // filled block is input
            return this._blockStartPos(firstFilledBlockIndexAtRight) + _blockInputPos3;
          }
        } // <-
        // find this vars


        var firstFilledInputBlockIndex = -1;
        var firstEmptyInputBlockIndex; // TODO consider nested empty inputs

        for (var _bi3 = searchBlockIndex - 1; _bi3 >= 0; --_bi3) {
          var _block4 = this._blocks[_bi3];

          var _blockInputPos4 = _block4.nearestInputPos(_block4.value.length, DIRECTION.FORCE_LEFT);

          if (!_block4.value || _blockInputPos4 !== 0) firstEmptyInputBlockIndex = _bi3;

          if (_blockInputPos4 !== 0) {
            if (_blockInputPos4 !== _block4.value.length) {
              // aligned inside block - return immediately
              return this._blockStartPos(_bi3) + _blockInputPos4;
            } else {
              // found filled
              firstFilledInputBlockIndex = _bi3;
              break;
            }
          }
        }

        if (direction === DIRECTION.LEFT) {
          // try find first empty input before start searching position only when not forced
          for (var _bi4 = firstFilledInputBlockIndex + 1; _bi4 <= Math.min(searchBlockIndex, this._blocks.length - 1); ++_bi4) {
            var _block5 = this._blocks[_bi4];

            var _blockInputPos5 = _block5.nearestInputPos(0, DIRECTION.NONE);

            var blockAlignedPos = this._blockStartPos(_bi4) + _blockInputPos5;

            if (blockAlignedPos > cursorPos) break; // if block is not lazy input

            if (_blockInputPos5 !== _block5.value.length) return blockAlignedPos;
          }
        } // process overflow


        if (firstFilledInputBlockIndex >= 0) {
          return this._blockStartPos(firstFilledInputBlockIndex) + this._blocks[firstFilledInputBlockIndex].value.length;
        } // for lazy if has aligned left inside fixed and has came to the start - use start position


        if (direction === DIRECTION.FORCE_LEFT || this.lazy && !this.extractInput() && !isInput(this._blocks[searchBlockIndex])) {
          return 0;
        }

        if (firstEmptyInputBlockIndex != null) {
          return this._blockStartPos(firstEmptyInputBlockIndex);
        } // find first input


        for (var _bi5 = searchBlockIndex; _bi5 < this._blocks.length; ++_bi5) {
          var _block6 = this._blocks[_bi5];

          var _blockInputPos6 = _block6.nearestInputPos(0, DIRECTION.NONE); // is input


          if (!_block6.value.length || _blockInputPos6 !== _block6.value.length) {
            return this._blockStartPos(_bi5) + _blockInputPos6;
          }
        }

        return 0;
      }

      if (direction === DIRECTION.RIGHT || direction === DIRECTION.FORCE_RIGHT) {
        // ->
        //  any|not-len-aligned and filled
        //  any|not-len-aligned
        // <-
        //  not-0-aligned or start|any
        var firstInputBlockAlignedIndex;
        var firstInputBlockAlignedPos;

        for (var _bi6 = searchBlockIndex; _bi6 < this._blocks.length; ++_bi6) {
          var _block7 = this._blocks[_bi6];

          var _blockInputPos7 = _block7.nearestInputPos(0, DIRECTION.NONE);

          if (_blockInputPos7 !== _block7.value.length) {
            firstInputBlockAlignedPos = this._blockStartPos(_bi6) + _blockInputPos7;
            firstInputBlockAlignedIndex = _bi6;
            break;
          }
        }

        if (firstInputBlockAlignedIndex != null && firstInputBlockAlignedPos != null) {
          for (var _bi7 = firstInputBlockAlignedIndex; _bi7 < this._blocks.length; ++_bi7) {
            var _block8 = this._blocks[_bi7];

            var _blockInputPos8 = _block8.nearestInputPos(0, DIRECTION.FORCE_RIGHT);

            if (_blockInputPos8 !== _block8.value.length) {
              return this._blockStartPos(_bi7) + _blockInputPos8;
            }
          }

          return direction === DIRECTION.FORCE_RIGHT ? this.value.length : firstInputBlockAlignedPos;
        }

        for (var _bi8 = Math.min(searchBlockIndex, this._blocks.length - 1); _bi8 >= 0; --_bi8) {
          var _block9 = this._blocks[_bi8];

          var _blockInputPos9 = _block9.nearestInputPos(_block9.value.length, DIRECTION.LEFT);

          if (_blockInputPos9 !== 0) {
            var alignedPos = this._blockStartPos(_bi8) + _blockInputPos9;

            if (alignedPos >= cursorPos) return alignedPos;
            break;
          }
        }
      }

      return cursorPos;
    }
    /** Get block by name */

  }, {
    key: "maskedBlock",
    value: function maskedBlock(name) {
      return this.maskedBlocks(name)[0];
    }
    /** Get all blocks by name */

  }, {
    key: "maskedBlocks",
    value: function maskedBlocks(name) {
      var _this4 = this;

      var indices = this._maskedBlocks[name];
      if (!indices) return [];
      return indices.map(function (gi) {
        return _this4._blocks[gi];
      });
    }
  }]);

  return MaskedPattern;
}(Masked);
MaskedPattern.DEFAULTS = {
  lazy: true,
  placeholderChar: '_'
};
MaskedPattern.STOP_CHAR = '`';
MaskedPattern.ESCAPE_CHAR = '\\';
MaskedPattern.InputDefinition = PatternInputDefinition;
MaskedPattern.FixedDefinition = PatternFixedDefinition;

function isInput(block) {
  if (!block) return false;
  var value = block.value;
  return !value || block.nearestInputPos(0, DIRECTION.NONE) !== value.length;
}

IMask.MaskedPattern = MaskedPattern;

/** Pattern which accepts ranges */

var MaskedRange = /*#__PURE__*/function (_MaskedPattern) {
  _inherits$5(MaskedRange, _MaskedPattern);

  var _super = _createSuper$3(MaskedRange);

  function MaskedRange() {
    _classCallCheck$5(this, MaskedRange);

    return _super.apply(this, arguments);
  }

  _createClass$5(MaskedRange, [{
    key: "_matchFrom",
    get:
    /**
      Optionally sets max length of pattern.
      Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
    */

    /** Min bound */

    /** Max bound */

    /** */
    function get() {
      return this.maxLength - String(this.from).length;
    }
    /**
      @override
    */

  }, {
    key: "_update",
    value: function _update(opts) {
      // TODO type
      opts = Object.assign({
        to: this.to || 0,
        from: this.from || 0
      }, opts);
      var maxLength = String(opts.to).length;
      if (opts.maxLength != null) maxLength = Math.max(maxLength, opts.maxLength);
      opts.maxLength = maxLength;
      var fromStr = String(opts.from).padStart(maxLength, '0');
      var toStr = String(opts.to).padStart(maxLength, '0');
      var sameCharsCount = 0;

      while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount]) {
        ++sameCharsCount;
      }

      opts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(maxLength - sameCharsCount);

      _get(_getPrototypeOf$3(MaskedRange.prototype), "_update", this).call(this, opts);
    }
    /**
      @override
    */

  }, {
    key: "isComplete",
    get: function get() {
      return _get(_getPrototypeOf$3(MaskedRange.prototype), "isComplete", this) && Boolean(this.value);
    }
  }, {
    key: "boundaries",
    value: function boundaries(str) {
      var minstr = '';
      var maxstr = '';

      var _ref = str.match(/^(\D*)(\d*)(\D*)/) || [],
          _ref2 = _slicedToArray(_ref, 3),
          placeholder = _ref2[1],
          num = _ref2[2];

      if (num) {
        minstr = '0'.repeat(placeholder.length) + num;
        maxstr = '9'.repeat(placeholder.length) + num;
      }

      minstr = minstr.padEnd(this.maxLength, '0');
      maxstr = maxstr.padEnd(this.maxLength, '9');
      return [minstr, maxstr];
    }
    /**
      @override
    */

  }, {
    key: "doPrepare",
    value: function doPrepare(str) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      str = _get(_getPrototypeOf$3(MaskedRange.prototype), "doPrepare", this).call(this, str, flags).replace(/\D/g, '');
      if (!this.autofix) return str;
      var fromStr = String(this.from).padStart(this.maxLength, '0');
      var toStr = String(this.to).padStart(this.maxLength, '0');
      var val = this.value;
      var prepStr = '';

      for (var ci = 0; ci < str.length; ++ci) {
        var nextVal = val + prepStr + str[ci];

        var _this$boundaries = this.boundaries(nextVal),
            _this$boundaries2 = _slicedToArray(_this$boundaries, 2),
            minstr = _this$boundaries2[0],
            maxstr = _this$boundaries2[1];

        if (Number(maxstr) < this.from) prepStr += fromStr[nextVal.length - 1];else if (Number(minstr) > this.to) prepStr += toStr[nextVal.length - 1];else prepStr += str[ci];
      }

      return prepStr;
    }
    /**
      @override
    */

  }, {
    key: "doValidate",
    value: function doValidate() {
      var _get2;

      var str = this.value;
      var firstNonZero = str.search(/[^0]/);
      if (firstNonZero === -1 && str.length <= this._matchFrom) return true;

      var _this$boundaries3 = this.boundaries(str),
          _this$boundaries4 = _slicedToArray(_this$boundaries3, 2),
          minstr = _this$boundaries4[0],
          maxstr = _this$boundaries4[1];

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.from <= Number(maxstr) && Number(minstr) <= this.to && (_get2 = _get(_getPrototypeOf$3(MaskedRange.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args));
    }
  }]);

  return MaskedRange;
}(MaskedPattern);
IMask.MaskedRange = MaskedRange;

/** Date mask */

var MaskedDate = /*#__PURE__*/function (_MaskedPattern) {
  _inherits$5(MaskedDate, _MaskedPattern);

  var _super = _createSuper$3(MaskedDate);

  /** Pattern mask for date according to {@link MaskedDate#format} */

  /** Start date */

  /** End date */

  /** */

  /**
    @param {Object} opts
  */
  function MaskedDate(opts) {
    _classCallCheck$5(this, MaskedDate);

    return _super.call(this, Object.assign({}, MaskedDate.DEFAULTS, opts));
  }
  /**
    @override
  */


  _createClass$5(MaskedDate, [{
    key: "_update",
    value: function _update(opts) {
      if (opts.mask === Date) delete opts.mask;
      if (opts.pattern) opts.mask = opts.pattern;
      var blocks = opts.blocks;
      opts.blocks = Object.assign({}, MaskedDate.GET_DEFAULT_BLOCKS()); // adjust year block

      if (opts.min) opts.blocks.Y.from = opts.min.getFullYear();
      if (opts.max) opts.blocks.Y.to = opts.max.getFullYear();

      if (opts.min && opts.max && opts.blocks.Y.from === opts.blocks.Y.to) {
        opts.blocks.m.from = opts.min.getMonth() + 1;
        opts.blocks.m.to = opts.max.getMonth() + 1;

        if (opts.blocks.m.from === opts.blocks.m.to) {
          opts.blocks.d.from = opts.min.getDate();
          opts.blocks.d.to = opts.max.getDate();
        }
      }

      Object.assign(opts.blocks, blocks); // add autofix

      Object.keys(opts.blocks).forEach(function (bk) {
        var b = opts.blocks[bk];
        if (!('autofix' in b)) b.autofix = opts.autofix;
      });

      _get(_getPrototypeOf$3(MaskedDate.prototype), "_update", this).call(this, opts);
    }
    /**
      @override
    */

  }, {
    key: "doValidate",
    value: function doValidate() {
      var _get2;

      var date = this.date;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_get2 = _get(_getPrototypeOf$3(MaskedDate.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args)) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
    }
    /** Checks if date is exists */

  }, {
    key: "isDateExist",
    value: function isDateExist(str) {
      return this.format(this.parse(str, this), this).indexOf(str) >= 0;
    }
    /** Parsed Date */

  }, {
    key: "date",
    get: function get() {
      return this.typedValue;
    },
    set: function set(date) {
      this.typedValue = date;
    }
    /**
      @override
    */

  }, {
    key: "typedValue",
    get: function get() {
      return this.isComplete ? _get(_getPrototypeOf$3(MaskedDate.prototype), "typedValue", this) : null;
    },
    set: function set(value) {
      _set(_getPrototypeOf$3(MaskedDate.prototype), "typedValue", value, this, true);
    }
  }]);

  return MaskedDate;
}(MaskedPattern);
MaskedDate.DEFAULTS = {
  pattern: 'd{.}`m{.}`Y',
  format: function format(date) {
    var day = String(date.getDate()).padStart(2, '0');
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var year = date.getFullYear();
    return [day, month, year].join('.');
  },
  parse: function parse(str) {
    var _str$split = str.split('.'),
        _str$split2 = _slicedToArray(_str$split, 3),
        day = _str$split2[0],
        month = _str$split2[1],
        year = _str$split2[2];

    return new Date(year, month - 1, day);
  }
};

MaskedDate.GET_DEFAULT_BLOCKS = function () {
  return {
    d: {
      mask: MaskedRange,
      from: 1,
      to: 31,
      maxLength: 2
    },
    m: {
      mask: MaskedRange,
      from: 1,
      to: 12,
      maxLength: 2
    },
    Y: {
      mask: MaskedRange,
      from: 1900,
      to: 9999
    }
  };
};

IMask.MaskedDate = MaskedDate;

/**
  Generic element API to use with mask
  @interface
*/
var MaskElement = /*#__PURE__*/function () {
  function MaskElement() {
    _classCallCheck$5(this, MaskElement);
  }

  _createClass$5(MaskElement, [{
    key: "selectionStart",
    get:
    /** */

    /** */

    /** */

    /** Safely returns selection start */
    function get() {
      var start;

      try {
        start = this._unsafeSelectionStart;
      } catch (e) {}

      return start != null ? start : this.value.length;
    }
    /** Safely returns selection end */

  }, {
    key: "selectionEnd",
    get: function get() {
      var end;

      try {
        end = this._unsafeSelectionEnd;
      } catch (e) {}

      return end != null ? end : this.value.length;
    }
    /** Safely sets element selection */

  }, {
    key: "select",
    value: function select(start, end) {
      if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;

      try {
        this._unsafeSelect(start, end);
      } catch (e) {}
    }
    /** Should be overriden in subclasses */

  }, {
    key: "_unsafeSelect",
    value: function _unsafeSelect(start, end) {}
    /** Should be overriden in subclasses */

  }, {
    key: "isActive",
    get: function get() {
      return false;
    }
    /** Should be overriden in subclasses */

  }, {
    key: "bindEvents",
    value: function bindEvents(handlers) {}
    /** Should be overriden in subclasses */

  }, {
    key: "unbindEvents",
    value: function unbindEvents() {}
  }]);

  return MaskElement;
}();
IMask.MaskElement = MaskElement;

/** Bridge between HTMLElement and {@link Masked} */

var HTMLMaskElement = /*#__PURE__*/function (_MaskElement) {
  _inherits$5(HTMLMaskElement, _MaskElement);

  var _super = _createSuper$3(HTMLMaskElement);

  /** Mapping between HTMLElement events and mask internal events */

  /** HTMLElement to use mask on */

  /**
    @param {HTMLInputElement|HTMLTextAreaElement} input
  */
  function HTMLMaskElement(input) {
    var _this;

    _classCallCheck$5(this, HTMLMaskElement);

    _this = _super.call(this);
    _this.input = input;
    _this._handlers = {};
    return _this;
  }
  /** */
  // $FlowFixMe https://github.com/facebook/flow/issues/2839


  _createClass$5(HTMLMaskElement, [{
    key: "rootElement",
    get: function get() {
      return this.input.getRootNode ? this.input.getRootNode() : document;
    }
    /**
      Is element in focus
      @readonly
    */

  }, {
    key: "isActive",
    get: function get() {
      //$FlowFixMe
      return this.input === this.rootElement.activeElement;
    }
    /**
      Returns HTMLElement selection start
      @override
    */

  }, {
    key: "_unsafeSelectionStart",
    get: function get() {
      return this.input.selectionStart;
    }
    /**
      Returns HTMLElement selection end
      @override
    */

  }, {
    key: "_unsafeSelectionEnd",
    get: function get() {
      return this.input.selectionEnd;
    }
    /**
      Sets HTMLElement selection
      @override
    */

  }, {
    key: "_unsafeSelect",
    value: function _unsafeSelect(start, end) {
      this.input.setSelectionRange(start, end);
    }
    /**
      HTMLElement value
      @override
    */

  }, {
    key: "value",
    get: function get() {
      return this.input.value;
    },
    set: function set(value) {
      this.input.value = value;
    }
    /**
      Binds HTMLElement events to mask internal events
      @override
    */

  }, {
    key: "bindEvents",
    value: function bindEvents(handlers) {
      var _this2 = this;

      Object.keys(handlers).forEach(function (event) {
        return _this2._toggleEventHandler(HTMLMaskElement.EVENTS_MAP[event], handlers[event]);
      });
    }
    /**
      Unbinds HTMLElement events to mask internal events
      @override
    */

  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      var _this3 = this;

      Object.keys(this._handlers).forEach(function (event) {
        return _this3._toggleEventHandler(event);
      });
    }
    /** */

  }, {
    key: "_toggleEventHandler",
    value: function _toggleEventHandler(event, handler) {
      if (this._handlers[event]) {
        this.input.removeEventListener(event, this._handlers[event]);
        delete this._handlers[event];
      }

      if (handler) {
        this.input.addEventListener(event, handler);
        this._handlers[event] = handler;
      }
    }
  }]);

  return HTMLMaskElement;
}(MaskElement);
HTMLMaskElement.EVENTS_MAP = {
  selectionChange: 'keydown',
  input: 'input',
  drop: 'drop',
  click: 'click',
  focus: 'focus',
  commit: 'blur'
};
IMask.HTMLMaskElement = HTMLMaskElement;

var HTMLContenteditableMaskElement = /*#__PURE__*/function (_HTMLMaskElement) {
  _inherits$5(HTMLContenteditableMaskElement, _HTMLMaskElement);

  var _super = _createSuper$3(HTMLContenteditableMaskElement);

  function HTMLContenteditableMaskElement() {
    _classCallCheck$5(this, HTMLContenteditableMaskElement);

    return _super.apply(this, arguments);
  }

  _createClass$5(HTMLContenteditableMaskElement, [{
    key: "_unsafeSelectionStart",
    get:
    /**
      Returns HTMLElement selection start
      @override
    */
    function get() {
      var root = this.rootElement;
      var selection = root.getSelection && root.getSelection();
      return selection && selection.anchorOffset;
    }
    /**
      Returns HTMLElement selection end
      @override
    */

  }, {
    key: "_unsafeSelectionEnd",
    get: function get() {
      var root = this.rootElement;
      var selection = root.getSelection && root.getSelection();
      return selection && this._unsafeSelectionStart + String(selection).length;
    }
    /**
      Sets HTMLElement selection
      @override
    */

  }, {
    key: "_unsafeSelect",
    value: function _unsafeSelect(start, end) {
      if (!this.rootElement.createRange) return;
      var range = this.rootElement.createRange();
      range.setStart(this.input.firstChild || this.input, start);
      range.setEnd(this.input.lastChild || this.input, end);
      var root = this.rootElement;
      var selection = root.getSelection && root.getSelection();

      if (selection) {
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
    /**
      HTMLElement value
      @override
    */

  }, {
    key: "value",
    get: function get() {
      // $FlowFixMe
      return this.input.textContent;
    },
    set: function set(value) {
      this.input.textContent = value;
    }
  }]);

  return HTMLContenteditableMaskElement;
}(HTMLMaskElement);
IMask.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;

var _excluded$6 = ["mask"];
/** Listens to element events and controls changes between element and {@link Masked} */

var InputMask = /*#__PURE__*/function () {
  /**
    View element
    @readonly
  */

  /**
    Internal {@link Masked} model
    @readonly
  */

  /**
    @param {MaskElement|HTMLInputElement|HTMLTextAreaElement} el
    @param {Object} opts
  */
  function InputMask(el, opts) {
    _classCallCheck$5(this, InputMask);

    this.el = el instanceof MaskElement ? el : el.isContentEditable && el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA' ? new HTMLContenteditableMaskElement(el) : new HTMLMaskElement(el);
    this.masked = createMask(opts);
    this._listeners = {};
    this._value = '';
    this._unmaskedValue = '';
    this._saveSelection = this._saveSelection.bind(this);
    this._onInput = this._onInput.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onDrop = this._onDrop.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onClick = this._onClick.bind(this);
    this.alignCursor = this.alignCursor.bind(this);
    this.alignCursorFriendly = this.alignCursorFriendly.bind(this);

    this._bindEvents(); // refresh


    this.updateValue();

    this._onChange();
  }
  /** Read or update mask */


  _createClass$5(InputMask, [{
    key: "mask",
    get: function get() {
      return this.masked.mask;
    },
    set: function set(mask) {
      if (this.maskEquals(mask)) return;

      if (!(mask instanceof IMask.Masked) && this.masked.constructor === maskedClass(mask)) {
        this.masked.updateOptions({
          mask: mask
        });
        return;
      }

      var masked = createMask({
        mask: mask
      });
      masked.unmaskedValue = this.masked.unmaskedValue;
      this.masked = masked;
    }
    /** Raw value */

  }, {
    key: "maskEquals",
    value: function maskEquals(mask) {
      return mask == null || mask === this.masked.mask || mask === Date && this.masked instanceof MaskedDate;
    }
  }, {
    key: "value",
    get: function get() {
      return this._value;
    },
    set: function set(str) {
      this.masked.value = str;
      this.updateControl();
      this.alignCursor();
    }
    /** Unmasked value */

  }, {
    key: "unmaskedValue",
    get: function get() {
      return this._unmaskedValue;
    },
    set: function set(str) {
      this.masked.unmaskedValue = str;
      this.updateControl();
      this.alignCursor();
    }
    /** Typed unmasked value */

  }, {
    key: "typedValue",
    get: function get() {
      return this.masked.typedValue;
    },
    set: function set(val) {
      this.masked.typedValue = val;
      this.updateControl();
      this.alignCursor();
    }
    /**
      Starts listening to element events
      @protected
    */

  }, {
    key: "_bindEvents",
    value: function _bindEvents() {
      this.el.bindEvents({
        selectionChange: this._saveSelection,
        input: this._onInput,
        drop: this._onDrop,
        click: this._onClick,
        focus: this._onFocus,
        commit: this._onChange
      });
    }
    /**
      Stops listening to element events
      @protected
     */

  }, {
    key: "_unbindEvents",
    value: function _unbindEvents() {
      if (this.el) this.el.unbindEvents();
    }
    /**
      Fires custom event
      @protected
     */

  }, {
    key: "_fireEvent",
    value: function _fireEvent(ev) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var listeners = this._listeners[ev];
      if (!listeners) return;
      listeners.forEach(function (l) {
        return l.apply(void 0, args);
      });
    }
    /**
      Current selection start
      @readonly
    */

  }, {
    key: "selectionStart",
    get: function get() {
      return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
    }
    /** Current cursor position */

  }, {
    key: "cursorPos",
    get: function get() {
      return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
    },
    set: function set(pos) {
      if (!this.el || !this.el.isActive) return;
      this.el.select(pos, pos);

      this._saveSelection();
    }
    /**
      Stores current selection
      @protected
    */

  }, {
    key: "_saveSelection",
    value: function _saveSelection() {
      if (this.value !== this.el.value) {
        console.warn('Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.'); // eslint-disable-line no-console
      }

      this._selection = {
        start: this.selectionStart,
        end: this.cursorPos
      };
    }
    /** Syncronizes model value from view */

  }, {
    key: "updateValue",
    value: function updateValue() {
      this.masked.value = this.el.value;
      this._value = this.masked.value;
    }
    /** Syncronizes view from model value, fires change events */

  }, {
    key: "updateControl",
    value: function updateControl() {
      var newUnmaskedValue = this.masked.unmaskedValue;
      var newValue = this.masked.value;
      var isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue;
      this._unmaskedValue = newUnmaskedValue;
      this._value = newValue;
      if (this.el.value !== newValue) this.el.value = newValue;
      if (isChanged) this._fireChangeEvents();
    }
    /** Updates options with deep equal check, recreates @{link Masked} model if mask type changes */

  }, {
    key: "updateOptions",
    value: function updateOptions(opts) {
      var mask = opts.mask,
          restOpts = _objectWithoutProperties$4(opts, _excluded$6);

      var updateMask = !this.maskEquals(mask);
      var updateOpts = !objectIncludes(this.masked, restOpts);
      if (updateMask) this.mask = mask;
      if (updateOpts) this.masked.updateOptions(restOpts);
      if (updateMask || updateOpts) this.updateControl();
    }
    /** Updates cursor */

  }, {
    key: "updateCursor",
    value: function updateCursor(cursorPos) {
      if (cursorPos == null) return;
      this.cursorPos = cursorPos; // also queue change cursor for mobile browsers

      this._delayUpdateCursor(cursorPos);
    }
    /**
      Delays cursor update to support mobile browsers
      @private
    */

  }, {
    key: "_delayUpdateCursor",
    value: function _delayUpdateCursor(cursorPos) {
      var _this = this;

      this._abortUpdateCursor();

      this._changingCursorPos = cursorPos;
      this._cursorChanging = setTimeout(function () {
        if (!_this.el) return; // if was destroyed

        _this.cursorPos = _this._changingCursorPos;

        _this._abortUpdateCursor();
      }, 10);
    }
    /**
      Fires custom events
      @protected
    */

  }, {
    key: "_fireChangeEvents",
    value: function _fireChangeEvents() {
      this._fireEvent('accept', this._inputEvent);

      if (this.masked.isComplete) this._fireEvent('complete', this._inputEvent);
    }
    /**
      Aborts delayed cursor update
      @private
    */

  }, {
    key: "_abortUpdateCursor",
    value: function _abortUpdateCursor() {
      if (this._cursorChanging) {
        clearTimeout(this._cursorChanging);
        delete this._cursorChanging;
      }
    }
    /** Aligns cursor to nearest available position */

  }, {
    key: "alignCursor",
    value: function alignCursor() {
      this.cursorPos = this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT);
    }
    /** Aligns cursor only if selection is empty */

  }, {
    key: "alignCursorFriendly",
    value: function alignCursorFriendly() {
      if (this.selectionStart !== this.cursorPos) return; // skip if range is selected

      this.alignCursor();
    }
    /** Adds listener on custom event */

  }, {
    key: "on",
    value: function on(ev, handler) {
      if (!this._listeners[ev]) this._listeners[ev] = [];

      this._listeners[ev].push(handler);

      return this;
    }
    /** Removes custom event listener */

  }, {
    key: "off",
    value: function off(ev, handler) {
      if (!this._listeners[ev]) return this;

      if (!handler) {
        delete this._listeners[ev];
        return this;
      }

      var hIndex = this._listeners[ev].indexOf(handler);

      if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
      return this;
    }
    /** Handles view input event */

  }, {
    key: "_onInput",
    value: function _onInput(e) {
      this._inputEvent = e;

      this._abortUpdateCursor(); // fix strange IE behavior


      if (!this._selection) return this.updateValue();
      var details = new ActionDetails( // new state
      this.el.value, this.cursorPos, // old state
      this.value, this._selection);
      var oldRawValue = this.masked.rawInputValue;
      var offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection).offset; // force align in remove direction only if no input chars were removed
      // otherwise we still need to align with NONE (to get out from fixed symbols for instance)

      var removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : DIRECTION.NONE;
      var cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
      this.updateControl();
      this.updateCursor(cursorPos);
      delete this._inputEvent;
    }
    /** Handles view change event and commits model value */

  }, {
    key: "_onChange",
    value: function _onChange() {
      if (this.value !== this.el.value) {
        this.updateValue();
      }

      this.masked.doCommit();
      this.updateControl();

      this._saveSelection();
    }
    /** Handles view drop event, prevents by default */

  }, {
    key: "_onDrop",
    value: function _onDrop(ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }
    /** Restore last selection on focus */

  }, {
    key: "_onFocus",
    value: function _onFocus(ev) {
      this.alignCursorFriendly();
    }
    /** Restore last selection on focus */

  }, {
    key: "_onClick",
    value: function _onClick(ev) {
      this.alignCursorFriendly();
    }
    /** Unbind view events and removes element reference */

  }, {
    key: "destroy",
    value: function destroy() {
      this._unbindEvents(); // $FlowFixMe why not do so?


      this._listeners.length = 0; // $FlowFixMe

      delete this.el;
    }
  }]);

  return InputMask;
}();
IMask.InputMask = InputMask;

const pipe$1 = (...ops) => ops.reduce((a, b) => arg => b(a(arg)));
const empty = (str) => str.length === 0;
const trimmer = (str) => str.trim();
const toInt = (str) => (empty(str) ? NaN : parseFloat(str));
const normalizeNumber = str => str.replace(/,,|\.\.|\.,|,\.|,/, '.').replace(/[^.|\d]/g, '');
const takeUntill = (amount) => str => str.length <= amount ? str : str.slice(0, amount);
function toString$5(value) {
    let result = value;
    if (typeof value === 'number') {
        result = String(value);
    }
    if ((typeof value === 'number' && isNaN(value)) || value === null || typeof value === 'undefined') {
        result = '';
    }
    return result;
}
const clearCountryPrefix = str => {
    return str.length >= 11 ? str.replace(/^\+*[78](\d)/, '$1') : str;
};
const clearFormatting = str => str.replace(/\D/g, '');

const filterFieldProps = function (component) {
    return function (props) {
        const rest = __rest(props, ["errorMessage", "note", "hideNoteSpace"]);
        return React.createElement(component, rest);
    };
};
const MaskedInput = withMask(Input$2);
const MaskedInputField = Field$3(filterFieldProps(MaskedInput));
const MoneyInputField = Field$3(filterFieldProps(_MoneyInput));

var css_248z$1c = ".divider-module_divider__CdEbx{background-color:var(--c-separator);border:0;box-sizing:border-box;height:1px;margin:0}";
var styles$q = {"divider":"divider-module_divider__CdEbx"};
styleInject(css_248z$1c);

const Divider = () => {
    return React.createElement("hr", { className: styles$q.divider });
};
var Divider$1 = Divider;

var css_248z$1b = ".icon-module_box__JtNAE{align-items:center;display:inline-flex;font-size:inherit;vertical-align:middle}.icon-module_box__JtNAE:before{content:\"\\a0\";display:inline-block;width:0}.icon-module_svg__BZeQC{height:1em;position:relative;width:1em}";
var s$p = {"box":"icon-module_box__JtNAE","svg":"icon-module_svg__BZeQC"};
styleInject(css_248z$1b);

var meta$1 = {
	"arrow-circle-16": "0 0 16 16",
	"arrow-circle-24": "0 0 16 16",
	"arrow-down-24": "0 0 24 24",
	"arrow-left-24": "0 0 24 24",
	"arrow-right-24": "0 0 24 24",
	"arrow-right-circle-24": "0 0 24 24",
	"arrow-thick-right-16": "0 0 16 16",
	"arrow-up-24": "0 0 24 24",
	"arrow-uturn-24": "0 0 24 24",
	"arrows-apart-16": "0 0 16 16",
	"arrows-expand-24": "0 0 24 24",
	"arrows-expand-40": "0 0 40 40",
	"arrows-left-right-24": "0 0 24 24",
	"arrows-round-24": "0 0 24 24",
	"arrows-squares-16": "0 0 16 16",
	"arrows-up-down-24": "0 0 24 24",
	"bars-horizontal-asc-16": "0 0 16 16",
	"bars-horizontal-asc-24": "0 0 24 24",
	"bars-horizontal-asc-arrow-16": "0 0 16 16",
	"bars-horizontal-asc-arrow-24": "0 0 24 24",
	"bars-horizontal-desc-16": "0 0 16 16",
	"bars-horizontal-desc-24": "0 0 24 24",
	"bars-horizontal-desc-arrow-16": "0 0 16 16",
	"bars-horizontal-desc-arrow-24": "0 0 24 24",
	"bars-horizontal-thick-24": "0 0 24 24",
	"bars-vertical-asc-arrow-16": "0 0 16 16",
	"bars-vertical-asc-arrow-24": "0 0 24 24",
	"bars-vertical-desc-arrow-16": "0 0 16 16",
	"bars-vertical-desc-arrow-24": "0 0 24 24",
	"bars-vertical-thick-24": "0 0 24 24",
	"bars-vertical-thick-32": "0 0 32 32",
	"bell-16": "0 0 16 16",
	"bell-24": "0 0 24 24",
	"bell-32": "0 0 32 32",
	"bell-crossed-24": "0 0 24 24",
	"blueprint-24": "0 0 24 24",
	"blueprint-40": "0 0 40 40",
	"blueprint-crossed-24": "0 0 24 24",
	"blueprint-crossed-40": "0 0 40 40",
	"book-24": "0 0 24 24",
	"bookmark-24": "0 0 24 24",
	"briefcase-16": "0 0 16 16",
	"building-16": "0 0 16 16",
	"bus-12": "0 0 12 12",
	"bus-16": "0 0 16 16",
	"calculator-16": "0 0 16 16",
	"calculator-24": "0 0 24 24",
	"calculator-32": "0 0 32 32",
	"calendar-24": "0 0 24 24",
	"calendar-32": "0 0 32 32",
	"camera-24": "0 0 24 24",
	"camera-40": "0 0 40 40",
	"camera-crossed-24": "0 0 24 24",
	"camera-crossed-40": "0 0 40 40",
	"car-12": "0 0 12 12",
	"car-16": "0 0 16 16",
	"card-24": "0 0 24 24",
	"card-32": "0 0 32 32",
	"check-16": "0 0 16 16",
	"check-24": "0 0 24 24",
	"check-32": "0 0 32 32",
	"check-circle-12": "0 0 12 12",
	"check-circle-16": "0 0 16 16",
	"check-circle-24": "0 0 24 24",
	"check-circle-32": "0 0 32 32",
	"chevron-double-down-24": "0 0 24 24",
	"chevron-double-left-24": "0 0 24 24",
	"chevron-double-right-24": "0 0 24 24",
	"chevron-double-up-24": "0 0 24 24",
	"chevron-down-12": "0 0 12 12",
	"chevron-down-16": "0 0 16 16",
	"chevron-down-24": "0 0 24 24",
	"chevron-down-circle-24": "0 0 24 24",
	"chevron-left-12": "0 0 12 12",
	"chevron-left-16": "0 0 16 16",
	"chevron-left-24": "0 0 24 24",
	"chevron-left-40": "0 0 40 40",
	"chevron-left-circle-24": "0 0 24 24",
	"chevron-right-12": "0 0 12 12",
	"chevron-right-16": "0 0 16 16",
	"chevron-right-24": "0 0 24 24",
	"chevron-right-40": "0 0 40 40",
	"chevron-right-circle-24": "0 0 24 24",
	"chevron-up-12": "0 0 12 12",
	"chevron-up-16": "0 0 16 16",
	"chevron-up-24": "0 0 24 24",
	"chevron-up-circle-24": "0 0 24 24",
	"circle-crossed-24": "0 0 24 24",
	"circle-crossed-32": "0 0 32 32",
	"clip-24": "0 0 24 24",
	"clip-32": "0 0 32 32",
	"clipboard-24": "0 0 24 24",
	"clipboard-32": "0 0 32 32",
	"clock-24": "0 0 24 24",
	"clock-arrowed-16": "0 0 16 16",
	"clock-arrowed-24": "0 0 24 24",
	"clock-arrowed-32": "0 0 32 32",
	"compass-circle-24": "0 0 24 24",
	"compass-circle-32": "0 0 32 32",
	"copy-24": "0 0 24 24",
	"crown-circle-16": "0 0 16 16",
	"crown-circle-24": "0 0 24 24",
	"custom-deal-16": "0 0 16 16",
	"custom-deal-24": "0 0 24 24",
	"dashed-frame-24": "0 0 24 24",
	"desktop-24": "0 0 24 24",
	"document-16": "0 0 16 16",
	"document-24": "0 0 24 24",
	"document-32": "0 0 32 32",
	"document-arrow-24": "0 0 24 24",
	"document-arrow-32": "0 0 32 32",
	"document-arrow-down-24": "0 0 24 24",
	"document-check-24": "0 0 24 24",
	"document-check-32": "0 0 32 32",
	"document-clock-24": "0 0 24 24",
	"document-clock-32": "0 0 32 32",
	"document-copy-24": "0 0 24 24",
	"document-copy-32": "0 0 32 32",
	"document-doc-24": "0 0 24 24",
	"document-empty-24": "0 0 24 24",
	"document-empty-32": "0 0 32 32",
	"document-jpg-24": "0 0 24 24",
	"document-lock-32": "0 0 32 32",
	"document-minus-24": "0 0 24 24",
	"document-minus-32": "0 0 32 32",
	"document-pdf-24": "0 0 24 24",
	"document-pdf-arrow-24": "0 0 24 24",
	"document-plus-24": "0 0 24 24",
	"document-plus-32": "0 0 32 32",
	"document-png-24": "0 0 24 24",
	"document-times-24": "0 0 24 24",
	"document-times-32": "0 0 32 32",
	"document-xls-24": "0 0 24 24",
	"document-zigzag-24": "0 0 24 24",
	"document-zigzag-32": "0 0 32 32",
	"door-in-24": "0 0 24 24",
	"door-out-16": "0 0 16 16",
	"door-out-24": "0 0 24 24",
	"dots-horizontal-16": "0 0 16 16",
	"dots-horizontal-24": "0 0 24 24",
	"dots-horizontal-32": "0 0 32 32",
	"download-24": "0 0 24 24",
	"education-24": "0 0 24 24",
	"envelope-24": "0 0 24 24",
	"envelope-32": "0 0 32 32",
	"excel-24": "0 0 24 24",
	"excel-32": "0 0 32 32",
	"exclamation-circle-16": "0 0 16 16",
	"exclamation-circle-24": "0 0 24 24",
	"exclamation-triangle-16": "0 0 16 16",
	"exclamation-triangle-24": "0 0 24 24",
	"exclamation-triangle-32": "0 0 32 32",
	"eye-16": "0 0 16 16",
	"eye-24": "0 0 24 24",
	"eye-crossed-24": "0 0 24 24",
	"facebook-16": "0 0 16 16",
	"facebook-24": "0 0 24 24",
	"finger-draw-24": "0 0 24 24",
	"folder-16": "0 0 16 16",
	"folder-24": "0 0 24 24",
	"folder-32": "0 0 32 32",
	"gear-24": "0 0 24 24",
	"globe-24": "0 0 24 24",
	"grid-24": "0 0 24 24",
	"heart-16": "0 0 16 16",
	"heart-24": "0 0 24 24",
	"heart-32": "0 0 32 32",
	"heart-hollow-16": "0 0 16 16",
	"heart-hollow-24": "0 0 24 24",
	"heart-hollow-32": "0 0 32 32",
	"helmet-16": "0 0 16 16",
	"house-24": "0 0 24 24",
	"house-checked-empty-24": "0 0 24 24",
	"house-copy-24": "0 0 24 24",
	"house-copy-32": "0 0 32 32",
	"house-heart-24": "0 0 24 24",
	"house-living-24": "0 0 24 24",
	"house-lock-16": "0 0 16 16",
	"house-lock-24": "0 0 24 24",
	"house-magnifier-24": "0 0 24 24",
	"house-one-24": "0 0 24 24",
	"house-persent-24": "0 0 24 24",
	"house-plus-24": "0 0 24 24",
	"image-24": "0 0 24 24",
	"in-construction-24": "0 0 24 24",
	"information-circle-16": "0 0 16 16",
	"information-circle-24": "0 0 24 24",
	"information-circle-32": "0 0 32 32",
	"instagram-16": "0 0 16 16",
	"instagram-24": "0 0 24 24",
	"key-16": "0 0 16 16",
	"key-32": "0 0 32 32",
	"layers-24": "0 0 24 24",
	"letter-range-asc-16": "0 0 16 16",
	"letter-range-asc-24": "0 0 24 24",
	"letter-range-desc-16": "0 0 16 16",
	"letter-range-desc-24": "0 0 24 24",
	"lightbulb-24": "0 0 24 24",
	"lightbulb-32": "0 0 32 32",
	"lightning-circle-16": "0 0 24 24",
	"lightning-circle-24": "0 0 24 24",
	"link-16": "0 0 16 16",
	"link-24": "0 0 24 24",
	"link-32": "0 0 32 32",
	"list-24": "0 0 24 24",
	"lock-closed-16": "0 0 16 16",
	"lock-closed-24": "0 0 24 24",
	"lock-closed-32": "0 0 32 32",
	"lock-opened-16": "0 0 16 16",
	"lock-opened-24": "0 0 24 24",
	"lock-opened-32": "0 0 32 32",
	"m2-bookmark-24": "0 0 24 24",
	"m2-bookmark-32": "0 0 32 32",
	"m2-bookmark-circle-24": "0 0 24 24",
	"m2-building-24": "0 0 24 24",
	"m2-building-multiple-24": "0 0 24 24",
	"m2-building-multiple-32": "0 0 32 32",
	"m2-building-wing-24": "0 0 24 24",
	"m2-calendar-24": "0 0 24 24",
	"m2-calendar-32": "0 0 32 32",
	"m2-chair-24": "0 0 24 24",
	"m2-chart-asc-24": "0 0 24 24",
	"m2-chat-24": "0 0 24 24",
	"m2-chat-32": "0 0 32 32",
	"m2-chat-notified-24": "0 0 24 24",
	"m2-chat-notified-32": "0 0 32 32",
	"m2-document-check-24": "0 0 24 24",
	"m2-document-check-empty-24": "0 0 24 24",
	"m2-document-pen-16": "0 0 16 16",
	"m2-document-pen-24": "0 0 24 24",
	"m2-document-pen-32": "0 0 32 32",
	"m2-folder-clip-16": "0 0 16 16",
	"m2-folder-clip-24": "0 0 24 24",
	"m2-folder-clip-32": "0 0 32 32",
	"m2-gear-24": "0 0 24 24",
	"m2-gear-32": "0 0 32 32",
	"m2-heart-24": "0 0 24 24",
	"m2-heart-32": "0 0 32 32",
	"m2-heart-circle-24": "0 0 24 24",
	"m2-house-checked-24": "0 0 25 24",
	"m2-house-checked-32": "0 0 32 32",
	"m2-house-stroked-24": "0 0 24 24",
	"m2-house-stroked-32": "0 0 32 32",
	"m2-houses-24": "0 0 24 24",
	"m2-houses-32": "0 0 32 32",
	"m2-lock-16": "0 0 16 16",
	"m2-lock-24": "0 0 24 24",
	"m2-lock-32": "0 0 32 32",
	"m2-magnifier-24": "0 0 24 24",
	"m2-magnifier-32": "0 0 32 32",
	"m2-note-pen-24": "0 0 24 24",
	"m2-note-pen-32": "0 0 32 32",
	"m2-paintroller-24": "0 0 24 24",
	"m2-paintroller-32": "0 0 32 32",
	"m2-percentage-circle-16": "0 0 16 16",
	"m2-percentage-circle-24": "0 0 24 24",
	"m2-percentage-circle-32": "0 0 32 32",
	"m2-person-16": "0 0 16 16",
	"m2-person-24": "0 0 24 24",
	"m2-person-32": "0 0 32 32",
	"m2-person-circle-24": "0 0 24 24",
	"m2-person-circle-32": "0 0 32 32",
	"m2-person-tie-16": "0 0 16 16",
	"m2-person-tie-24": "0 0 24 24",
	"m2-person-tie-32": "0 0 32 32",
	"m2-piechart-24": "0 0 24 24",
	"m2-piechart-32": "0 0 32 32",
	"m2-receipt-24": "0 0 24 24",
	"m2-squares-24": "0 0 24 24",
	"m2-squares-32": "0 0 32 32",
	"m2-squares-quad-24": "0 0 24 24",
	"m2-squares-quad-32": "0 0 32 32",
	"m2-star-16": "0 0 16 16",
	"m2-star-24": "0 0 24 24",
	"m2-star-32": "0 0 32 32",
	"m2-tags-percent-24": "0 0 24 24",
	"m2-tags-percent-32": "0 0 32 32",
	"m2-tree-24": "0 0 24 24",
	"m2-wallet-16": "0 0 16 16",
	"m2-wallet-24": "0 0 24 24",
	"magnifier-16": "0 0 16 16",
	"magnifier-24": "0 0 24 24",
	"magnifier-32": "0 0 32 32",
	"magnifier-heart-24": "0 0 24 24",
	"magnifier-minus-24": "0 0 24 24",
	"magnifier-plus-24": "0 0 24 24",
	"magnifier-plus-32": "0 0 32 32",
	"map-16": "0 0 16 16",
	"map-24": "0 0 24 24",
	"map-32": "0 0 32 32",
	"megaphone-24": "0 0 24 24",
	"menu-24": "0 0 24 24",
	"message-16": "0 0 16 16",
	"message-24": "0 0 24 24",
	"message-32": "0 0 32 32",
	"microphone-16": "0 0 16 16",
	"microphone-24": "0 0 24 24",
	"microphone-32": "0 0 32 32",
	"minus-16": "0 0 16 16",
	"minus-24": "0 0 24 24",
	"minus-circle-16": "0 0 16 16",
	"minus-circle-24": "0 0 24 24",
	"notes-24": "0 0 24 24",
	"number-range-asc-16": "0 0 16 16",
	"number-range-asc-24": "0 0 24 24",
	"number-range-desc-16": "0 0 16 16",
	"number-range-desc-24": "0 0 24 24",
	"ok-24": "0 0 24 24",
	"panorama-24": "0 0 24 24",
	"panorama-32": "0 0 32 32",
	"pause-24": "0 0 24 24",
	"pedestrian-12": "0 0 12 12",
	"pedestrian-16": "0 0 16 16",
	"pencil-16": "0 0 16 16",
	"pencil-24": "0 0 24 24",
	"pencil-32": "0 0 32 32",
	"person-16": "0 0 16 16",
	"person-circle-24": "0 0 24 24",
	"person-rounded-16": "0 0 16 16",
	"person-tie-circle-24": "0 0 24 24",
	"persons-24": "0 0 24 24",
	"phone-16": "0 0 16 16",
	"phone-24": "0 0 24 24",
	"phone-32": "0 0 32 32",
	"phone-circle-16": "0 0 16 16",
	"phone-circle-24": "0 0 24 24",
	"phone-circle-32": "0 0 32 32",
	"phone-eye-16": "0 0 16 16",
	"phone-incoming-24": "0 0 24 24",
	"piechart-24": "0 0 24 24",
	"piechart-32": "0 0 32 32",
	"placemark-16": "0 0 16 16",
	"placemark-24": "0 0 24 24",
	"placemark-32": "0 0 32 32",
	"plus-16": "0 0 16 16",
	"plus-24": "0 0 24 24",
	"plus-circle-16": "0 0 16 16",
	"plus-circle-24": "0 0 24 24",
	"plus-circle-32": "0 0 32 32",
	"power-switch-24": "0 0 24 24",
	"presentation-24": "0 0 24 24",
	"printer-24": "0 0 24 24",
	"question-24": "0 0 24 24",
	"question-circle-16": "0 0 16 16",
	"question-circle-24": "0 0 24 24",
	"rgr-16": "0 0 16 16",
	"rocket-16": "0 0 16 16",
	"rosreestr-arrow-24": "0 0 24 24",
	"rouble-24": "0 0 24 24",
	"rouble-32": "0 0 32 32",
	"ruler-24": "0 0 24 24",
	"safe-16": "0 0 16 16",
	"safe-24": "0 0 24 24",
	"safe-32": "0 0 32 32",
	"send-16": "0 0 16 16",
	"send-24": "0 0 24 24",
	"send-32": "0 0 32 32",
	"settings-16": "0 0 16 16",
	"settings-24": "0 0 24 24",
	"settings-32": "0 0 32 32",
	"share-16": "0 0 16 16",
	"share-24": "0 0 24 24",
	"share-32": "0 0 32 32",
	"shield-24": "0 0 24 24",
	"shield-check-24": "0 0 24 24",
	"shield-check-32": "0 0 32 32",
	"signal-24": "0 0 24 24",
	"smartphone-24": "0 0 24 24",
	"square-arrow-16": "0 0 16 16",
	"square-arrow-24": "0 0 24 24",
	"square-arrow-32": "0 0 32 32",
	"star-circle-24": "0 0 24 24",
	"tag-24": "0 0 24 24",
	"tag-32": "0 0 32 32",
	"target-24": "0 0 24 24",
	"telegram-16": "0 0 16 16",
	"telegram-24": "0 0 24 24",
	"thumb-up-24": "0 0 24 24",
	"timelapse-16": "0 0 16 16",
	"timelapse-24": "0 0 24 24",
	"times-16": "0 0 16 16",
	"times-24": "0 0 24 24",
	"times-32": "0 0 32 32",
	"times-circle-16": "0 0 16 16",
	"times-circle-24": "0 0 24 24",
	"times-circle-32": "0 0 32 32",
	"traffic-light-24": "0 0 24 24",
	"trashbin-16": "0 0 16 16",
	"trashbin-24": "0 0 24 24",
	"trashbin-32": "0 0 32 32",
	"triangle-arrow-16": "0 0 16 16",
	"triangle-arrow-24": "0 0 24 24",
	"triangle-arrow-32": "0 0 32 32",
	"triangle-down-16": "0 0 16 16",
	"triangle-up-16": "0 0 16 16",
	"twitter-24": "0 0 24 24",
	"undo-16": "0 0 16 16",
	"undo-24": "0 0 24 24",
	"undo-32": "0 0 32 32",
	"upload-24": "0 0 24 24",
	"video-24": "0 0 24 24",
	"vk-16": "0 0 16 16",
	"vk-24": "0 0 24 24",
	"whatsapp-24": "0 0 24 24"
};

// will be migrated to TS in [CMS-1704]
var aliases_1$1 = {
    close: 'times',
    cross: 'times',
};

const registry$1 = meta$1;
const sizes$1 = {
    xs: 12,
    s: 16,
    m: 24,
    l: 32,
    xl: 40,
};
const Icon$4 = ({ name: externalName, size: externalSize = 'm', color }) => {
    const size = sizes$1[externalSize];
    const name = aliases_1$1[externalName] || externalName;
    const id = `${name}-${size}`;
    if (!registry$1[id]) {
        return null;
    }
    return (React.createElement("i", { className: s$p.box, style: Object.assign({ fontSize: `${size}px`, lineHeight: `${size}px` }, (color && { color })) },
        React.createElement("svg", { width: size, height: size, className: s$p.svg, viewBox: registry$1[id] },
            React.createElement("use", { xlinkHref: `#${id}` }))));
};

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements$1 = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

/*:: import type { Window } from '../types'; */

/*:: declare function getWindow(node: Node | Window): Window; */
function getWindow$1(node) {
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

/*:: declare function isElement(node: mixed): boolean %checks(node instanceof
  Element); */

function isElement(node) {
  var OwnElement = getWindow$1(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
/*:: declare function isHTMLElement(node: mixed): boolean %checks(node instanceof
  HTMLElement); */


function isHTMLElement$1(node) {
  var OwnElement = getWindow$1(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
/*:: declare function isShadowRoot(node: mixed): boolean %checks(node instanceof
  ShadowRoot); */


function isShadowRoot(node) {
  var OwnElement = getWindow$1(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement$1(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement$1(element) || !getNodeName(element)) {
        return;
      } // Flow doesn't support to extend this property, but it's the most
      // effective way to apply styles to an HTMLElement
      // $FlowFixMe


      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

// Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.
function getLayoutRect(element) {
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: element.offsetWidth,
    height: element.offsetHeight
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow$1(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe: assume body is always available
  return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

function getParentNode$1(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// $FlowFixMe: this is a quicker (but less type safe) way to save quite some bytes from the bundle
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    // $FlowFixMe: need a better way to handle this...
    element.host || // ShadowRoot detected
    // $FlowFixMe: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement$1(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  var offsetParent = element.offsetParent;

  if (offsetParent) {
    var html = getDocumentElement(offsetParent);

    if (getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static' && getComputedStyle$1(html).position !== 'static') {
      return html;
    }
  }

  return offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var currentNode = getParentNode$1(element);

  while (isHTMLElement$1(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.

    if (css.transform !== 'none' || css.perspective !== 'none' || css.willChange && css.willChange !== 'auto') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent$1(element) {
  var window = getWindow$1(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static') {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min, value, max) {
  return Math.max(min, Math.min(value, max));
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign(Object.assign({}, getFreshSideObject()), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

function arrow$2(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = state.modifiersData[name + "#persistent"].padding;
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent$1(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element,
      _options$padding = options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement$1(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
  state.modifiersData[name + "#persistent"] = {
    padding: mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements))
  };
} // eslint-disable-next-line import/no-unused-modules


var arrowModifier = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow$2,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsets(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: Math.round(x * dpr) / dpr || 0,
    y: Math.round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive;

  var _roundOffsets = roundOffsets(offsets),
      x = _roundOffsets.x,
      y = _roundOffsets.y;

  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent$1(popper);

    if (offsetParent === getWindow$1(popper)) {
      offsetParent = getDocumentElement(popper);
    } // $FlowFixMe: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

    /*:: offsetParent = (offsetParent: Element); */


    if (placement === top) {
      sideY = bottom;
      y -= offsetParent.clientHeight - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left) {
      sideX = right;
      x -= offsetParent.clientWidth - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref3) {
  var state = _ref3.state,
      options = _ref3.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign(Object.assign({}, state.styles.popper), mapToStyles(Object.assign(Object.assign({}, commonStyles), {}, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign(Object.assign({}, state.styles.arrow), mapToStyles(Object.assign(Object.assign({}, commonStyles), {}, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false
    })));
  }

  state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow$1(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement$1(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getBoundingClientRect$1(element) {
  var rect = element.getBoundingClientRect();
  return {
    width: rect.width,
    height: rect.height,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    y: rect.top
  };
}

function getWindowScroll(node) {
  var win = getWindow$1(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect$1(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow$1(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = element.ownerDocument.body;
  var width = Math.max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = Math.max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += Math.max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent$2(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement$1(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent$2(getParentNode$1(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the 
reference element's position.
*/

function listScrollParents(element, list) {
  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent$2(element);
  var isBody = getNodeName(scrollParent) === 'body';
  var win = getWindow$1(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode$1(target)));
}

function rectToClientRect(rect) {
  return Object.assign(Object.assign({}, rect), {}, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect$1(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode$1(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement$1(element) ? getOffsetParent$1(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = Math.max(rect.top, accRect.top);
    accRect.right = Math.min(rect.right, accRect.right);
    accRect.bottom = Math.min(rect.bottom, accRect.bottom);
    accRect.left = Math.max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function getVariation(placement) {
  return placement.split('-')[1];
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = Math.floor(offsets[mainAxis]) - Math.floor(reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = Math.floor(offsets[mainAxis]) + Math.ceil(reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var referenceElement = state.elements.reference;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect$1(referenceElement);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign(Object.assign({}, popperRect), popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

/*:: type OverflowsMap = { [ComputedPlacement]: number }; */

/*;; type OverflowsMap = { [key in ComputedPlacement]: number }; */
function computeAutoPlacement$1(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements$1 : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements; // $FlowFixMe

  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement$1(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip$1(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement$1(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement$1(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement$1(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement$1(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$2 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip$1,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide$1(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hideModifier = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide$1
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign(Object.assign({}, rects), {}, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset$3(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements$1.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offsetModifier = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset$3
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow$1(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign(Object.assign({}, state.rects), {}, {
    placement: state.placement
  })) : tetherOffset;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = popperOffsets[mainAxis] + overflow[mainSide];
    var max = popperOffsets[mainAxis] - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent$1(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
    var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? Math.min(min, tetherMin) : min, offset, tether ? Math.max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var _preventedOffset = within(_min, _offset, _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$2 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow$1,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow$1(node) || !isHTMLElement$1(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect$1(elementOrVirtualElement);
  var isOffsetParentAnElement = isHTMLElement$1(offsetParent);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement$1(offsetParent)) {
      offsets = getBoundingClientRect$1(offsetParent);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce$4(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format$1(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    Object.keys(modifier).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format$1(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (typeof modifier.effect !== 'function') {
            console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (!Array.isArray(modifier.requires)) {
            console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format$1(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format$1(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign(Object.assign(Object.assign({}, existing), current), {}, {
      options: Object.assign(Object.assign({}, existing.options), current.options),
      data: Object.assign(Object.assign({}, existing.data), current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS$1 = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS$1 : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign(Object.assign({}, DEFAULT_OPTIONS$1), defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(options) {
        cleanupModifierEffects();
        state.options = Object.assign(Object.assign(Object.assign({}, defaultOptions), state.options), options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle$1(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent$1(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$4(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers$1 = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1];

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offsetModifier, flip$2, preventOverflow$2, arrowModifier, hideModifier];
var createPopper$1 = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

var css_248z$1a = ".radio-module_radio__-BJLc{align-items:center;cursor:pointer;display:inline-flex;position:relative;touch-action:manipulation}.radio-module_radio__-BJLc>input{box-sizing:border-box;cursor:pointer;height:20px;left:0;margin:1px;opacity:0;padding:0;position:absolute;top:0;width:20px;z-index:1}.radio-module_radio-control__vtQCp{background-color:#fff;border:1px solid #ccc9d9;border-radius:50%;box-sizing:border-box;height:20px;min-height:20px;min-width:20px;width:20px}.radio-module_radio-control-checked__oYtCX{border-color:#3416b6;border-width:6px}.radio-module_radio-control-shadow__QMN35{box-shadow:0 8px 12px rgba(38,83,217,.08)}.radio-module_radio-control-hovered__PPrhT{background-color:#fff;border-color:#3416b6}.radio-module_radio-control-disabled__tcsWO{background-color:#eae9f2;border-color:#ccc9d9;cursor:default}.radio-module_radio-control-disabled__tcsWO+input{cursor:default}.radio-module_radio-control-disabled-checked__5d-L0{background-color:#fff}.radio-module_radio-disabled__ozxqc{color:#a4a1b5;cursor:default}.radio-module_radio-label__2Ozg4{color:#6e6a81;margin-left:8px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.radio-module_radio-label-checked__lQP9F{color:#211f2e}.radio-module_radio-label-disabled__5yDTX{color:#a4a1b5}.radio-module_radio-label-hovered__CBVXA{color:#211f2e}";
var styles$p = {"radio":"radio-module_radio__-BJLc","radio-control":"radio-module_radio-control__vtQCp","radio-control-checked":"radio-module_radio-control-checked__oYtCX","radio-control-shadow":"radio-module_radio-control-shadow__QMN35","radio-control-hovered":"radio-module_radio-control-hovered__PPrhT","radio-control-disabled":"radio-module_radio-control-disabled__tcsWO","radio-control-disabled-checked":"radio-module_radio-control-disabled-checked__5d-L0","radio-disabled":"radio-module_radio-disabled__ozxqc","radio-label":"radio-module_radio-label__2Ozg4","radio-label-checked":"radio-module_radio-label-checked__lQP9F","radio-label-disabled":"radio-module_radio-label-disabled__5yDTX","radio-label-hovered":"radio-module_radio-label-hovered__CBVXA"};
styleInject(css_248z$1a);

const Radio = (_a) => {
    var { checked, children, hover: hoverInit = false, focus: focusInit = false, disabled = false, autoComplete = 'off', onChange, dataTest, dataGtm } = _a, rest = __rest(_a, ["checked", "children", "hover", "focus", "disabled", "autoComplete", "onChange", "dataTest", "dataGtm"]);
    const [hovered, hoverHandlers] = useHover$1(hoverInit, rest, disabled);
    const [, focusHandlers] = useFocus$1(focusInit, rest);
    const changeHandler = React.useCallback((event) => {
        if (onChange) {
            onChange(event.target.checked, event);
        }
    }, [onChange]);
    const radioStyles = {
        [styles$p.radioControlShadow]: checked && hovered,
        [styles$p.radioControlHovered]: hovered,
        [styles$p.radioControlChecked]: checked,
        [styles$p.radioControlDisabled]: disabled,
        [styles$p.radioControlDisabledChecked]: disabled && checked,
    };
    return (React.createElement("label", Object.assign({ "data-test": dataTest, "data-gtm": dataGtm, className: cn(styles$p.radio, { [styles$p.radioDisabled]: disabled }) }, hoverHandlers),
        React.createElement("div", { className: cn(styles$p.radioControl, radioStyles) }),
        React.createElement("input", Object.assign({ type: "radio" }, rest, focusHandlers, { checked: checked, disabled: disabled, autoComplete: autoComplete, onChange: changeHandler })),
        children && (React.createElement("span", { className: cn(styles$p.radioLabel, {
                [styles$p.radioLabelDisabled]: disabled,
                [styles$p.radioLabelChecked]: checked,
                [styles$p.radioLabelHovered]: hovered,
            }) }, children))));
};

var css_248z$19 = ".radio-group-module_radio-group__J9mrN{box-sizing:border-box;display:inline-flex;flex-direction:column}.radio-group-module_radio-group__J9mrN .radio-group-module_radio-group-item__R7aO8{margin-bottom:20px}.radio-group-module_radio-group__J9mrN .radio-group-module_radio-group-header__sXBiN{color:#211f2e;font-size:18px;line-height:28px;margin-bottom:20px}.radio-group-module_radio-group__J9mrN .radio-group-module_radio-group-item__R7aO8:last-child{margin-bottom:0}";
var styles$o = {"radio-group":"radio-group-module_radio-group__J9mrN","radio-group-item":"radio-group-module_radio-group-item__R7aO8","radio-group-header":"radio-group-module_radio-group-header__sXBiN"};
styleInject(css_248z$19);

const RadioGroup = (_a) => {
    var { values, value, label, className, onChange, name, dataTest: radioGroupDataTest } = _a, props = __rest(_a, ["values", "value", "label", "className", "onChange", "name", "dataTest"]);
    const handleRadioChange = React.useCallback((value) => (_checked, event) => {
        if (onChange) {
            onChange(value, event);
        }
    }, [onChange]);
    return (React.createElement("div", Object.assign({ className: cn(styles$o.radioGroup, className), "data-test": radioGroupDataTest }, props),
        label != null && React.createElement("span", { className: styles$o.radioGroupHeader }, label),
        values.map((_a, index) => {
            var { value: itemValue, label } = _a, itemProps = __rest(_a, ["value", "label"]);
            return (React.createElement("div", { key: `${index}${value}`, className: styles$o.radioGroupItem },
                React.createElement(Radio, Object.assign({ name: name, value: String(itemValue), onChange: handleRadioChange(itemValue), checked: itemValue === value, dataTest: radioGroupDataTest && `${radioGroupDataTest}-${itemValue}` }, itemProps), label)));
        })));
};

const RadioGroupFilteredProps = function (props) {
    const rest = __rest(props, ["errorMessage", "isError", "isValid", "fullWidth", "label", "note", "hideNoteSpace"]);
    return React.createElement(RadioGroup, rest);
};
const RadioGroupField = Field$3(RadioGroupFilteredProps, false, false);

/** Pattern which validates enum values */

var MaskedEnum = /*#__PURE__*/function (_MaskedPattern) {
  _inherits$5(MaskedEnum, _MaskedPattern);

  var _super = _createSuper$3(MaskedEnum);

  function MaskedEnum() {
    _classCallCheck$5(this, MaskedEnum);

    return _super.apply(this, arguments);
  }

  _createClass$5(MaskedEnum, [{
    key: "_update",
    value:
    /**
      @override
      @param {Object} opts
    */
    function _update(opts) {
      // TODO type
      if (opts.enum) opts.mask = '*'.repeat(opts.enum[0].length);

      _get(_getPrototypeOf$3(MaskedEnum.prototype), "_update", this).call(this, opts);
    }
    /**
      @override
    */

  }, {
    key: "doValidate",
    value: function doValidate() {
      var _this = this,
          _get2;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.enum.some(function (e) {
        return e.indexOf(_this.unmaskedValue) >= 0;
      }) && (_get2 = _get(_getPrototypeOf$3(MaskedEnum.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args));
    }
  }]);

  return MaskedEnum;
}(MaskedPattern);
IMask.MaskedEnum = MaskedEnum;

/**
  Number mask
  @param {Object} opts
  @param {string} opts.radix - Single char
  @param {string} opts.thousandsSeparator - Single char
  @param {Array<string>} opts.mapToRadix - Array of single chars
  @param {number} opts.min
  @param {number} opts.max
  @param {number} opts.scale - Digits after point
  @param {boolean} opts.signed - Allow negative
  @param {boolean} opts.normalizeZeros - Flag to remove leading and trailing zeros in the end of editing
  @param {boolean} opts.padFractionalZeros - Flag to pad trailing zeros after point in the end of editing
*/
var MaskedNumber = /*#__PURE__*/function (_Masked) {
  _inherits$5(MaskedNumber, _Masked);

  var _super = _createSuper$3(MaskedNumber);

  /** Single char */

  /** Single char */

  /** Array of single chars */

  /** */

  /** */

  /** Digits after point */

  /** */

  /** Flag to remove leading and trailing zeros in the end of editing */

  /** Flag to pad trailing zeros after point in the end of editing */
  function MaskedNumber(opts) {
    _classCallCheck$5(this, MaskedNumber);

    return _super.call(this, Object.assign({}, MaskedNumber.DEFAULTS, opts));
  }
  /**
    @override
  */


  _createClass$5(MaskedNumber, [{
    key: "_update",
    value: function _update(opts) {
      _get(_getPrototypeOf$3(MaskedNumber.prototype), "_update", this).call(this, opts);

      this._updateRegExps();
    }
    /** */

  }, {
    key: "_updateRegExps",
    value: function _updateRegExps() {
      // use different regexp to process user input (more strict, input suffix) and tail shifting
      var start = '^' + (this.allowNegative ? '[+|\\-]?' : '');
      var midInput = '(0|([1-9]+\\d*))?';
      var mid = '\\d*';
      var end = (this.scale ? '(' + escapeRegExp(this.radix) + '\\d{0,' + this.scale + '})?' : '') + '$';
      this._numberRegExpInput = new RegExp(start + midInput + end);
      this._numberRegExp = new RegExp(start + mid + end);
      this._mapToRadixRegExp = new RegExp('[' + this.mapToRadix.map(escapeRegExp).join('') + ']', 'g');
      this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), 'g');
    }
    /** */

  }, {
    key: "_removeThousandsSeparators",
    value: function _removeThousandsSeparators(value) {
      return value.replace(this._thousandsSeparatorRegExp, '');
    }
    /** */

  }, {
    key: "_insertThousandsSeparators",
    value: function _insertThousandsSeparators(value) {
      // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
      var parts = value.split(this.radix);
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
      return parts.join(this.radix);
    }
    /**
      @override
    */

  }, {
    key: "doPrepare",
    value: function doPrepare(str) {
      var _get2;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_get2 = _get(_getPrototypeOf$3(MaskedNumber.prototype), "doPrepare", this)).call.apply(_get2, [this, this._removeThousandsSeparators(str.replace(this._mapToRadixRegExp, this.radix))].concat(args));
    }
    /** */

  }, {
    key: "_separatorsCount",
    value: function _separatorsCount(to) {
      var extendOnSeparators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var count = 0;

      for (var pos = 0; pos < to; ++pos) {
        if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
          ++count;
          if (extendOnSeparators) to += this.thousandsSeparator.length;
        }
      }

      return count;
    }
    /** */

  }, {
    key: "_separatorsCountFromSlice",
    value: function _separatorsCountFromSlice() {
      var slice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._value;
      return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
    }
    /**
      @override
    */

  }, {
    key: "extractInput",
    value: function extractInput() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
      var flags = arguments.length > 2 ? arguments[2] : undefined;

      var _this$_adjustRangeWit = this._adjustRangeWithSeparators(fromPos, toPos);

      var _this$_adjustRangeWit2 = _slicedToArray(_this$_adjustRangeWit, 2);

      fromPos = _this$_adjustRangeWit2[0];
      toPos = _this$_adjustRangeWit2[1];
      return this._removeThousandsSeparators(_get(_getPrototypeOf$3(MaskedNumber.prototype), "extractInput", this).call(this, fromPos, toPos, flags));
    }
    /**
      @override
    */

  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.thousandsSeparator) return _get(_getPrototypeOf$3(MaskedNumber.prototype), "_appendCharRaw", this).call(this, ch, flags);
      var prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;

      var prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);

      this._value = this._removeThousandsSeparators(this.value);

      var appendDetails = _get(_getPrototypeOf$3(MaskedNumber.prototype), "_appendCharRaw", this).call(this, ch, flags);

      this._value = this._insertThousandsSeparators(this._value);
      var beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;

      var beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);

      appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
      appendDetails.skip = !appendDetails.rawInserted && ch === this.thousandsSeparator;
      return appendDetails;
    }
    /** */

  }, {
    key: "_findSeparatorAround",
    value: function _findSeparatorAround(pos) {
      if (this.thousandsSeparator) {
        var searchFrom = pos - this.thousandsSeparator.length + 1;
        var separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
        if (separatorPos <= pos) return separatorPos;
      }

      return -1;
    }
  }, {
    key: "_adjustRangeWithSeparators",
    value: function _adjustRangeWithSeparators(from, to) {
      var separatorAroundFromPos = this._findSeparatorAround(from);

      if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;

      var separatorAroundToPos = this._findSeparatorAround(to);

      if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
      return [from, to];
    }
    /**
      @override
    */

  }, {
    key: "remove",
    value: function remove() {
      var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;

      var _this$_adjustRangeWit3 = this._adjustRangeWithSeparators(fromPos, toPos);

      var _this$_adjustRangeWit4 = _slicedToArray(_this$_adjustRangeWit3, 2);

      fromPos = _this$_adjustRangeWit4[0];
      toPos = _this$_adjustRangeWit4[1];
      var valueBeforePos = this.value.slice(0, fromPos);
      var valueAfterPos = this.value.slice(toPos);

      var prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);

      this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));

      var beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);

      return new ChangeDetails({
        tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
      });
    }
    /**
      @override
    */

  }, {
    key: "nearestInputPos",
    value: function nearestInputPos(cursorPos, direction) {
      if (!this.thousandsSeparator) return cursorPos;

      switch (direction) {
        case DIRECTION.NONE:
        case DIRECTION.LEFT:
        case DIRECTION.FORCE_LEFT:
          {
            var separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);

            if (separatorAtLeftPos >= 0) {
              var separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;

              if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === DIRECTION.FORCE_LEFT) {
                return separatorAtLeftPos;
              }
            }

            break;
          }

        case DIRECTION.RIGHT:
        case DIRECTION.FORCE_RIGHT:
          {
            var separatorAtRightPos = this._findSeparatorAround(cursorPos);

            if (separatorAtRightPos >= 0) {
              return separatorAtRightPos + this.thousandsSeparator.length;
            }
          }
      }

      return cursorPos;
    }
    /**
      @override
    */

  }, {
    key: "doValidate",
    value: function doValidate(flags) {
      var regexp = flags.input ? this._numberRegExpInput : this._numberRegExp; // validate as string

      var valid = regexp.test(this._removeThousandsSeparators(this.value));

      if (valid) {
        // validate as number
        var number = this.number;
        valid = valid && !isNaN(number) && (this.min == null || this.min >= 0 || this.min <= this.number) && (this.max == null || this.max <= 0 || this.number <= this.max);
      }

      return valid && _get(_getPrototypeOf$3(MaskedNumber.prototype), "doValidate", this).call(this, flags);
    }
    /**
      @override
    */

  }, {
    key: "doCommit",
    value: function doCommit() {
      if (this.value) {
        var number = this.number;
        var validnum = number; // check bounds

        if (this.min != null) validnum = Math.max(validnum, this.min);
        if (this.max != null) validnum = Math.min(validnum, this.max);
        if (validnum !== number) this.unmaskedValue = String(validnum);
        var formatted = this.value;
        if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
        if (this.padFractionalZeros) formatted = this._padFractionalZeros(formatted);
        this._value = formatted;
      }

      _get(_getPrototypeOf$3(MaskedNumber.prototype), "doCommit", this).call(this);
    }
    /** */

  }, {
    key: "_normalizeZeros",
    value: function _normalizeZeros(value) {
      var parts = this._removeThousandsSeparators(value).split(this.radix); // remove leading zeros


      parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, function (match, sign, zeros, num) {
        return sign + num;
      }); // add leading zero

      if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + '0';

      if (parts.length > 1) {
        parts[1] = parts[1].replace(/0*$/, ''); // remove trailing zeros

        if (!parts[1].length) parts.length = 1; // remove fractional
      }

      return this._insertThousandsSeparators(parts.join(this.radix));
    }
    /** */

  }, {
    key: "_padFractionalZeros",
    value: function _padFractionalZeros(value) {
      if (!value) return value;
      var parts = value.split(this.radix);
      if (parts.length < 2) parts.push('');
      parts[1] = parts[1].padEnd(this.scale, '0');
      return parts.join(this.radix);
    }
    /**
      @override
    */

  }, {
    key: "unmaskedValue",
    get: function get() {
      return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, '.');
    },
    set: function set(unmaskedValue) {
      _set(_getPrototypeOf$3(MaskedNumber.prototype), "unmaskedValue", unmaskedValue.replace('.', this.radix), this, true);
    }
    /**
      @override
    */

  }, {
    key: "typedValue",
    get: function get() {
      return Number(this.unmaskedValue);
    },
    set: function set(n) {
      _set(_getPrototypeOf$3(MaskedNumber.prototype), "unmaskedValue", String(n), this, true);
    }
    /** Parsed Number */

  }, {
    key: "number",
    get: function get() {
      return this.typedValue;
    },
    set: function set(number) {
      this.typedValue = number;
    }
    /**
      Is negative allowed
      @readonly
    */

  }, {
    key: "allowNegative",
    get: function get() {
      return this.signed || this.min != null && this.min < 0 || this.max != null && this.max < 0;
    }
  }]);

  return MaskedNumber;
}(Masked);
MaskedNumber.DEFAULTS = {
  radix: ',',
  thousandsSeparator: '',
  mapToRadix: ['.'],
  scale: 2,
  signed: false,
  normalizeZeros: true,
  padFractionalZeros: false
};
IMask.MaskedNumber = MaskedNumber;

/** Masking by custom Function */

var MaskedFunction = /*#__PURE__*/function (_Masked) {
  _inherits$5(MaskedFunction, _Masked);

  var _super = _createSuper$3(MaskedFunction);

  function MaskedFunction() {
    _classCallCheck$5(this, MaskedFunction);

    return _super.apply(this, arguments);
  }

  _createClass$5(MaskedFunction, [{
    key: "_update",
    value:
    /**
      @override
      @param {Object} opts
    */
    function _update(opts) {
      if (opts.mask) opts.validate = opts.mask;

      _get(_getPrototypeOf$3(MaskedFunction.prototype), "_update", this).call(this, opts);
    }
  }]);

  return MaskedFunction;
}(Masked);
IMask.MaskedFunction = MaskedFunction;

var _excluded$5 = ["compiledMasks", "currentMaskRef", "currentMask"];

/** Dynamic mask for choosing apropriate mask in run-time */
var MaskedDynamic = /*#__PURE__*/function (_Masked) {
  _inherits$5(MaskedDynamic, _Masked);

  var _super = _createSuper$3(MaskedDynamic);

  /** Currently chosen mask */

  /** Compliled {@link Masked} options */

  /** Chooses {@link Masked} depending on input value */

  /**
    @param {Object} opts
  */
  function MaskedDynamic(opts) {
    var _this;

    _classCallCheck$5(this, MaskedDynamic);

    _this = _super.call(this, Object.assign({}, MaskedDynamic.DEFAULTS, opts));
    _this.currentMask = null;
    return _this;
  }
  /**
    @override
  */


  _createClass$5(MaskedDynamic, [{
    key: "_update",
    value: function _update(opts) {
      _get(_getPrototypeOf$3(MaskedDynamic.prototype), "_update", this).call(this, opts);

      if ('mask' in opts) {
        // mask could be totally dynamic with only `dispatch` option
        this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map(function (m) {
          return createMask(m);
        }) : [];
      }
    }
    /**
      @override
    */

  }, {
    key: "_appendCharRaw",
    value: function _appendCharRaw(ch) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var details = this._applyDispatch(ch, flags);

      if (this.currentMask) {
        details.aggregate(this.currentMask._appendChar(ch, flags));
      }

      return details;
    }
  }, {
    key: "_applyDispatch",
    value: function _applyDispatch() {
      var appended = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
      var inputValue = this.rawInputValue;
      var insertValue = flags.tail && flags._beforeTailState != null ? // $FlowFixMe - tired to fight with type system
      flags._beforeTailState._rawInputValue : inputValue;
      var tailValue = inputValue.slice(insertValue.length);
      var prevMask = this.currentMask;
      var details = new ChangeDetails();
      var prevMaskState = prevMask && prevMask.state; // clone flags to prevent overwriting `_beforeTailState`

      this.currentMask = this.doDispatch(appended, Object.assign({}, flags)); // restore state after dispatch

      if (this.currentMask) {
        if (this.currentMask !== prevMask) {
          // if mask changed reapply input
          this.currentMask.reset();

          if (insertValue) {
            // $FlowFixMe - it's ok, we don't change current mask above
            var d = this.currentMask.append(insertValue, {
              raw: true
            });
            details.tailShift = d.inserted.length - prevValueBeforeTail.length;
          }

          if (tailValue) {
            // $FlowFixMe - it's ok, we don't change current mask above
            details.tailShift += this.currentMask.append(tailValue, {
              raw: true,
              tail: true
            }).tailShift;
          }
        } else {
          // Dispatch can do something bad with state, so
          // restore prev mask state
          this.currentMask.state = prevMaskState;
        }
      }

      return details;
    }
  }, {
    key: "_appendPlaceholder",
    value: function _appendPlaceholder() {
      var details = this._applyDispatch.apply(this, arguments);

      if (this.currentMask) {
        details.aggregate(this.currentMask._appendPlaceholder());
      }

      return details;
    }
    /**
      @override
    */

  }, {
    key: "doDispatch",
    value: function doDispatch(appended) {
      var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.dispatch(appended, this, flags);
    }
    /**
      @override
    */

  }, {
    key: "doValidate",
    value: function doValidate() {
      var _get2, _this$currentMask;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_get2 = _get(_getPrototypeOf$3(MaskedDynamic.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args)) && (!this.currentMask || (_this$currentMask = this.currentMask).doValidate.apply(_this$currentMask, args));
    }
    /**
      @override
    */

  }, {
    key: "reset",
    value: function reset() {
      if (this.currentMask) this.currentMask.reset();
      this.compiledMasks.forEach(function (m) {
        return m.reset();
      });
    }
    /**
      @override
    */

  }, {
    key: "value",
    get: function get() {
      return this.currentMask ? this.currentMask.value : '';
    },
    set: function set(value) {
      _set(_getPrototypeOf$3(MaskedDynamic.prototype), "value", value, this, true);
    }
    /**
      @override
    */

  }, {
    key: "unmaskedValue",
    get: function get() {
      return this.currentMask ? this.currentMask.unmaskedValue : '';
    },
    set: function set(unmaskedValue) {
      _set(_getPrototypeOf$3(MaskedDynamic.prototype), "unmaskedValue", unmaskedValue, this, true);
    }
    /**
      @override
    */

  }, {
    key: "typedValue",
    get: function get() {
      return this.currentMask ? this.currentMask.typedValue : '';
    } // probably typedValue should not be used with dynamic
    ,
    set: function set(value) {
      var unmaskedValue = String(value); // double check it

      if (this.currentMask) {
        this.currentMask.typedValue = value;
        unmaskedValue = this.currentMask.unmaskedValue;
      }

      this.unmaskedValue = unmaskedValue;
    }
    /**
      @override
    */

  }, {
    key: "isComplete",
    get: function get() {
      return !!this.currentMask && this.currentMask.isComplete;
    }
    /**
      @override
    */

  }, {
    key: "remove",
    value: function remove() {
      var details = new ChangeDetails();

      if (this.currentMask) {
        var _this$currentMask2;

        details.aggregate((_this$currentMask2 = this.currentMask).remove.apply(_this$currentMask2, arguments)) // update with dispatch
        .aggregate(this._applyDispatch());
      }

      return details;
    }
    /**
      @override
    */

  }, {
    key: "state",
    get: function get() {
      return Object.assign({}, _get(_getPrototypeOf$3(MaskedDynamic.prototype), "state", this), {
        _rawInputValue: this.rawInputValue,
        compiledMasks: this.compiledMasks.map(function (m) {
          return m.state;
        }),
        currentMaskRef: this.currentMask,
        currentMask: this.currentMask && this.currentMask.state
      });
    },
    set: function set(state) {
      var compiledMasks = state.compiledMasks,
          currentMaskRef = state.currentMaskRef,
          currentMask = state.currentMask,
          maskedState = _objectWithoutProperties$4(state, _excluded$5);

      this.compiledMasks.forEach(function (m, mi) {
        return m.state = compiledMasks[mi];
      });

      if (currentMaskRef != null) {
        this.currentMask = currentMaskRef;
        this.currentMask.state = currentMask;
      }

      _set(_getPrototypeOf$3(MaskedDynamic.prototype), "state", maskedState, this, true);
    }
    /**
      @override
    */

  }, {
    key: "extractInput",
    value: function extractInput() {
      var _this$currentMask3;

      return this.currentMask ? (_this$currentMask3 = this.currentMask).extractInput.apply(_this$currentMask3, arguments) : '';
    }
    /**
      @override
    */

  }, {
    key: "extractTail",
    value: function extractTail() {
      var _this$currentMask4, _get3;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.currentMask ? (_this$currentMask4 = this.currentMask).extractTail.apply(_this$currentMask4, args) : (_get3 = _get(_getPrototypeOf$3(MaskedDynamic.prototype), "extractTail", this)).call.apply(_get3, [this].concat(args));
    }
    /**
      @override
    */

  }, {
    key: "doCommit",
    value: function doCommit() {
      if (this.currentMask) this.currentMask.doCommit();

      _get(_getPrototypeOf$3(MaskedDynamic.prototype), "doCommit", this).call(this);
    }
    /**
      @override
    */

  }, {
    key: "nearestInputPos",
    value: function nearestInputPos() {
      var _this$currentMask5, _get4;

      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.currentMask ? (_this$currentMask5 = this.currentMask).nearestInputPos.apply(_this$currentMask5, args) : (_get4 = _get(_getPrototypeOf$3(MaskedDynamic.prototype), "nearestInputPos", this)).call.apply(_get4, [this].concat(args));
    }
  }, {
    key: "overwrite",
    get: function get() {
      return this.currentMask ? this.currentMask.overwrite : _get(_getPrototypeOf$3(MaskedDynamic.prototype), "overwrite", this);
    },
    set: function set(overwrite) {
      console.warn('"overwrite" option is not available in dynamic mask, use this option in siblings');
    }
  }]);

  return MaskedDynamic;
}(Masked);
MaskedDynamic.DEFAULTS = {
  dispatch: function dispatch(appended, masked, flags) {
    if (!masked.compiledMasks.length) return;
    var inputValue = masked.rawInputValue; // simulate input

    var inputs = masked.compiledMasks.map(function (m, index) {
      m.reset();
      m.append(inputValue, {
        raw: true
      });
      m.append(appended, flags);
      var weight = m.rawInputValue.length;
      return {
        weight: weight,
        index: index
      };
    }); // pop masks with longer values first

    inputs.sort(function (i1, i2) {
      return i2.weight - i1.weight;
    });
    return masked.compiledMasks[inputs[0].index];
  }
};
IMask.MaskedDynamic = MaskedDynamic;

/** Mask pipe source and destination types */

var PIPE_TYPE = {
  MASKED: 'value',
  UNMASKED: 'unmaskedValue',
  TYPED: 'typedValue'
};
/** Creates new pipe function depending on mask type, source and destination options */

function createPipe(mask) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PIPE_TYPE.MASKED;
  var to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PIPE_TYPE.MASKED;
  var masked = createMask(mask);
  return function (value) {
    return masked.runIsolated(function (m) {
      m[from] = value;
      return m[to];
    });
  };
}
/** Pipes value through mask depending on mask type, source and destination options */

function pipe(value) {
  for (var _len = arguments.length, pipeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    pipeArgs[_key - 1] = arguments[_key];
  }

  return createPipe.apply(void 0, pipeArgs)(value);
}
IMask.PIPE_TYPE = PIPE_TYPE;
IMask.createPipe = createPipe;
IMask.pipe = pipe;

try {
  globalThis.IMask = IMask;
} catch (e) {}

function _classCallCheck$4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$4(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$2(Constructor, staticProps);
  return Constructor;
}

function _inherits$4(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}

function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$2(o);
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$2(o, p);
}

function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$2(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$3(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$4(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$3(self);
}

function _createSuper$2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$2();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$2(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$2(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$4(this, result);
  };
}

var MASK_PROPS = {
  // common
  mask: propTypesExports.oneOfType([propTypesExports.array, propTypesExports.func, propTypesExports.string, propTypesExports.instanceOf(RegExp), propTypesExports.oneOf([Date, Number, IMask.Masked]), propTypesExports.instanceOf(IMask.Masked)]),
  value: propTypesExports.any,
  unmask: propTypesExports.oneOfType([propTypesExports.bool, propTypesExports.oneOf(['typed'])]),
  prepare: propTypesExports.func,
  validate: propTypesExports.func,
  commit: propTypesExports.func,
  overwrite: propTypesExports.bool,
  // events
  onAccept: propTypesExports.func,
  onComplete: propTypesExports.func,
  // pattern
  placeholderChar: propTypesExports.string,
  lazy: propTypesExports.bool,
  definitions: propTypesExports.object,
  blocks: propTypesExports.object,
  // date
  pattern: propTypesExports.string,
  format: propTypesExports.func,
  parse: propTypesExports.func,
  autofix: propTypesExports.bool,
  // number
  radix: propTypesExports.string,
  thousandsSeparator: propTypesExports.string,
  mapToRadix: propTypesExports.arrayOf(propTypesExports.string),
  scale: propTypesExports.number,
  signed: propTypesExports.bool,
  normalizeZeros: propTypesExports.bool,
  padFractionalZeros: propTypesExports.bool,
  min: propTypesExports.oneOfType([propTypesExports.number, propTypesExports.instanceOf(Date)]),
  max: propTypesExports.oneOfType([propTypesExports.number, propTypesExports.instanceOf(Date)]),
  // dynamic
  dispatch: propTypesExports.func,
  // ref
  inputRef: propTypesExports.func
};
var MASK_PROPS_NAMES = Object.keys(MASK_PROPS);
var NON_MASK_OPTIONS_PROPS_NAMES = ['value', 'unmask', 'onAccept', 'onComplete', 'inputRef'];
var MASK_OPTIONS_PROPS_NAMES = MASK_PROPS_NAMES.filter(function (pName) {
  return NON_MASK_OPTIONS_PROPS_NAMES.indexOf(pName) < 0;
});
function IMaskMixin(ComposedComponent) {
  var MaskedComponent = /*#__PURE__*/function (_React$Component) {
    _inherits$4(MaskedComponent, _React$Component);

    var _super = _createSuper$2(MaskedComponent);

    function MaskedComponent(props) {
      var _this;

      _classCallCheck$4(this, MaskedComponent);

      _this = _super.call(this, props);
      _this._inputRef = _this._inputRef.bind(_assertThisInitialized$3(_this));
      return _this;
    }

    _createClass$4(MaskedComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!this.props.mask) return;
        this.initMask();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var props = this.props;

        var maskOptions = this._extractMaskOptionsFromProps(props);

        if (maskOptions.mask) {
          if (this.maskRef) {
            this.maskRef.updateOptions(maskOptions); // TODO

            if ('value' in props && (props.value !== this.maskValue || // handle cases like Number('') === 0,
            // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
            typeof props.value !== 'string' && this.maskRef.value === '' && !this.maskRef.el.isActive)) {
              this.maskValue = props.value;
            }
          } else {
            this.initMask(maskOptions); // TODO
          }
        } else {
          this.destroyMask();
          if ('value' in props) this.element.value = props.value;
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.destroyMask();
      }
    }, {
      key: "_inputRef",
      value: function _inputRef(el) {
        this.element = el;
        if (this.props.inputRef) this.props.inputRef(el);
      }
    }, {
      key: "initMask",
      value: function initMask() {
        var maskOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._extractMaskOptionsFromProps(this.props);
        this.maskRef = IMask(this.element, maskOptions).on('accept', this._onAccept.bind(this)).on('complete', this._onComplete.bind(this));
        if ('value' in this.props) this.maskValue = this.props.value;
      }
    }, {
      key: "destroyMask",
      value: function destroyMask() {
        if (this.maskRef) {
          this.maskRef.destroy();
          delete this.maskRef;
        }
      }
    }, {
      key: "_extractMaskOptionsFromProps",
      value: function _extractMaskOptionsFromProps(props) {
        var cloneProps = Object.assign({}, props); // keep only mask options props

        Object.keys(cloneProps).filter(function (prop) {
          return MASK_OPTIONS_PROPS_NAMES.indexOf(prop) < 0;
        }).forEach(function (nonMaskProp) {
          delete cloneProps[nonMaskProp];
        });
        return cloneProps;
      }
    }, {
      key: "_extractNonMaskProps",
      value: function _extractNonMaskProps(props) {
        var cloneProps = Object.assign({}, props);
        MASK_PROPS_NAMES.forEach(function (maskProp) {
          delete cloneProps[maskProp];
        });
        return cloneProps;
      }
    }, {
      key: "maskValue",
      get: function get() {
        if (this.props.unmask === 'typed') return this.maskRef.typedValue;
        if (this.props.unmask) return this.maskRef.unmaskedValue;
        return this.maskRef.value;
      },
      set: function set(value) {
        value = value == null ? '' : value;
        if (this.props.unmask === 'typed') this.maskRef.typedValue = value;else if (this.props.unmask) this.maskRef.unmaskedValue = value;else this.maskRef.value = value;
      }
    }, {
      key: "_onAccept",
      value: function _onAccept(e) {
        if (this.props.onAccept) this.props.onAccept(this.maskValue, this.maskRef, e);
      }
    }, {
      key: "_onComplete",
      value: function _onComplete(e) {
        if (this.props.onComplete) this.props.onComplete(this.maskValue, this.maskRef, e);
      }
    }, {
      key: "render",
      value: function render() {
        return React.createElement(ComposedComponent, Object.assign({}, this._extractNonMaskProps(this.props), {
          inputRef: this._inputRef
        }));
      }
    }]);

    return MaskedComponent;
  }(React.Component);

  var nestedComponentName = ComposedComponent.displayName || ComposedComponent.name || 'Component';
  MaskedComponent.displayName = "IMask(".concat(nestedComponentName, ")");
  MaskedComponent.propTypes = MASK_PROPS;
  return MaskedComponent;
}

var _excluded$4 = ["inputRef"];

var InputComponent = function InputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties$3(_ref, _excluded$4);

  return React.createElement('input', Object.assign({}, props, {
    ref: inputRef
  }));
};

IMaskMixin(InputComponent);

function camelize(s) {
    return s.replace(/([-_][a-z])/gi, char => char.toUpperCase().replace('-', '').replace('_', ''));
}
function kebalize(s) {
    return s.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}
function normalizeCSSModules(raw) {
    return Object.keys(raw).reduce((res, key) => {
        const style = raw[key];
        res[kebalize(key)] = style;
        res[camelize(key)] = style;
        res[key] = style;
        return res;
    }, {});
}

var css_248z$18 = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.input-module_container__oT8JF,.input-module_wrapper__zs1cn{max-width:100%;width:100%}.input-module_wrapper__zs1cn.input-module_group__uYY4H{margin-left:-1px}.input-module_container__oT8JF{align-items:center;box-sizing:border-box;display:inline-flex;position:relative}.input-module_container__oT8JF.input-module_labeled__nMWhA{margin-top:24px}.input-module_control__x1YF7{background-color:hsla(0,0%,100%,0);border:none;color:#211f2e;flex:1 1;font:400 16px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;outline:none;padding:0;text-overflow:ellipsis;z-index:3}.input-module_control__x1YF7::-webkit-search-cancel-button,.input-module_control__x1YF7::-webkit-search-decoration{display:none}.input-module_control__x1YF7::-ms-reveal{display:none}.input-module_spaced__9rcVm{margin-bottom:16px}.input-module_control__x1YF7:not(:-moz-read-only):not(:disabled):focus~.input-module_bg__u86Wv{border-color:#3416b6;z-index:2}.input-module_control__x1YF7:not(:read-only):not(:disabled):focus~.input-module_bg__u86Wv{border-color:#3416b6;z-index:2}.input-module_control__x1YF7::-moz-placeholder{color:rgba(105,99,131,.6)}.input-module_control__x1YF7::placeholder{color:rgba(105,99,131,.6)}.input-module_control__x1YF7:-moz-read-only~.input-module_bg__u86Wv{background-color:rgba(150,142,190,.2);border:none}.input-module_control__x1YF7:disabled~.input-module_bg__u86Wv,.input-module_control__x1YF7:read-only~.input-module_bg__u86Wv{background-color:rgba(150,142,190,.2);border:none}.input-module_container__oT8JF.input-module_disabled__G4yD2 .input-module_postfix__RXOKL,.input-module_container__oT8JF.input-module_disabled__G4yD2 .input-module_prefix__UmQWy,.input-module_control__x1YF7:disabled{-webkit-text-fill-color:rgba(105,99,131,.6);color:rgba(105,99,131,.6)}.input-module_control__x1YF7:disabled{cursor:not-allowed;opacity:1}.input-module_control__x1YF7:disabled::-moz-placeholder{-webkit-text-fill-color:initial;opacity:1}.input-module_control__x1YF7:disabled::placeholder{-webkit-text-fill-color:initial;opacity:1}.input-module_bg__u86Wv{border:1px solid rgba(127,120,161,.4);bottom:0;left:0;pointer-events:none;position:absolute;right:0;top:0;transition:.24s cubic-bezier(.24,.1,.24,1);transition-property:border-color}.input-module_bg__u86Wv.input-module_primary__1D-ZM{background-color:#fff}.input-module_bg__u86Wv.input-module_light__ADAD4{background-color:#f8f8fc}.input-module_bg__u86Wv.input-module_rounded-left__-hQmC{border-bottom-left-radius:4px;border-top-left-radius:4px}.input-module_bg__u86Wv.input-module_rounded-right__aKSHB{border-bottom-right-radius:4px;border-top-right-radius:4px}.input-module_hint__Ylp8Y{display:block;font:400 12px/16px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;margin-top:4px;transition:color .24s cubic-bezier(.24,.1,.24,1)}.input-module_hint__Ylp8Y.input-module_error__9eXKg{color:#f44434}.input-module_hint__Ylp8Y.input-module_warning__w0zEl{color:#fac32e}.input-module_hint__Ylp8Y.input-module_success__VPv3g{color:#87d232}.input-module_container__oT8JF:not(.input-module_error__9eXKg):hover>.input-module_control__x1YF7:not(:focus):not(:-moz-read-only):not(:disabled)~.input-module_bg__u86Wv{border-color:rgba(115,108,147,.5);z-index:1}.input-module_container__oT8JF:not(.input-module_error__9eXKg):hover>.input-module_control__x1YF7:not(:focus):not(:read-only):not(:disabled)~.input-module_bg__u86Wv{border-color:rgba(115,108,147,.5);z-index:1}.input-module_container__oT8JF.input-module_s__fHdYz{padding:8px 8px 8px 16px}.input-module_container__oT8JF.input-module_m__Map8E{padding:14px 12px 14px 16px}.input-module_container__oT8JF.input-module_l__DMjYa{padding:28px 12px 8px 16px}.input-module_container__oT8JF.input-module_l__DMjYa.input-module_single__QQwpF{padding:18px 12px 18px 16px}.input-module_content__tc-qO,.input-module_icon__EAQ5i{color:rgba(115,108,147,.5);transition:color .24s cubic-bezier(.24,.1,.24,1)}.input-module_icon__EAQ5i{display:flex}.input-module_content__tc-qO.input-module_pointer__-Or9Y{cursor:pointer}.input-module_icon__EAQ5i:hover{color:#211f2e}.input-module_reset__7L-80{cursor:pointer}.input-module_status__xz2rC{display:flex}.input-module_success__VPv3g>.input-module_status__xz2rC,.input-module_success__VPv3g>span>.input-module_status__xz2rC{color:#87d232}.input-module_error__9eXKg>.input-module_status__xz2rC,.input-module_error__9eXKg>span>.input-module_status__xz2rC{color:#f44434}.input-module_error__9eXKg>.input-module_bg__u86Wv,.input-module_error__9eXKg>span>.input-module_bg__u86Wv{border-color:#f44434}.input-module_warning__w0zEl>.input-module_status__xz2rC,.input-module_warning__w0zEl>span>.input-module_status__xz2rC{color:#fac32e}.input-module_end__p4e5y,.input-module_start__7yPFd{z-index:3}.input-module_start__7yPFd+.input-module_start__7yPFd{margin-left:8px}.input-module_control__x1YF7+.input-module_end__p4e5y,.input-module_start__7yPFd+.input-module_control__x1YF7{margin-left:4px}.input-module_end__p4e5y+.input-module_end__p4e5y{margin-left:8px}.input-module_content__tc-qO.input-module_start__7yPFd{margin-left:-4px}.input-module_prefix__UmQWy{transition:opacity .24s cubic-bezier(.24,.1,.24,1)}.input-module_container__oT8JF.input-module_l__DMjYa:not(.input-module_single__QQwpF)>.input-module_end__p4e5y,.input-module_container__oT8JF.input-module_l__DMjYa:not(.input-module_single__QQwpF)>.input-module_start__7yPFd:not(.input-module_prefix__UmQWy){position:relative;top:-10px}.input-module_container__oT8JF.input-module_l__DMjYa>.input-module_prefix__UmQWy{opacity:0;pointer-events:none}.input-module_container__oT8JF.input-module_l__DMjYa.input-module_single__QQwpF>.input-module_prefix__UmQWy,.input-module_container__oT8JF.input-module_l__DMjYa:focus-within>.input-module_prefix__UmQWy:not(.input-module_readonly__zczGV),.input-module_container__oT8JF.input-module_l__DMjYa:not(.input-module_floating__I--KH)>.input-module_prefix__UmQWy:not(.input-module_active__ycIYJ),.input-module_container__oT8JF.input-module_l__DMjYa>.input-module_prefix__UmQWy.input-module_active__ycIYJ{opacity:1;pointer-events:auto}.input-module_label__vKfPo{align-items:center;color:rgba(73,68,95,.8);display:flex;font:400 14px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;position:absolute;transition:.24s cubic-bezier(.24,.1,.24,1);transition-property:top,font-size,color;z-index:3}.input-module_labeltext__VcLjY{display:inline-block;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.input-module_label__vKfPo.input-module_required__rPL4a .input-module_labeltext__VcLjY{max-width:calc(100% - 12px)}.input-module_star__WuW0y{color:#f44434;display:inline-block;margin-left:4px}.input-module_label__vKfPo.input-module_outside__kKj-h{left:0;top:-24px;width:100%}.input-module_label__vKfPo.input-module_inside__xz3D3{font:400 12px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;top:8px}.input-module_container__oT8JF.input-module_l__DMjYa:not(.input-module_single__QQwpF).input-module_floating__I--KH>.input-module_control__x1YF7:not(:focus):-moz-placeholder-shown::-moz-placeholder{color:transparent}.input-module_container__oT8JF.input-module_l__DMjYa.input-module_readonly__zczGV>.input-module_control__x1YF7.input-module_empty__yTEu5::-moz-placeholder,.input-module_container__oT8JF.input-module_l__DMjYa:not(.input-module_single__QQwpF).input-module_floating__I--KH>.input-module_control__x1YF7:not(:focus):placeholder-shown::-moz-placeholder{color:transparent}.input-module_container__oT8JF.input-module_l__DMjYa:not(.input-module_single__QQwpF).input-module_floating__I--KH>.input-module_control__x1YF7:not(:focus):-moz-placeholder-shown::placeholder{color:transparent}.input-module_container__oT8JF.input-module_l__DMjYa.input-module_readonly__zczGV>.input-module_control__x1YF7.input-module_empty__yTEu5::placeholder,.input-module_container__oT8JF.input-module_l__DMjYa:not(.input-module_single__QQwpF).input-module_floating__I--KH>.input-module_control__x1YF7:not(:focus):placeholder-shown::placeholder{color:transparent}.input-module_container__oT8JF.input-module_floating__I--KH>.input-module_control__x1YF7.input-module_empty__yTEu5[readonly]:focus~.input-module_label__vKfPo.input-module_inside__xz3D3,.input-module_container__oT8JF.input-module_floating__I--KH>.input-module_control__x1YF7:not(:focus):not(:placeholder-shown).input-module_empty__yTEu5:not(:-webkit-autofill)~.input-module_label__vKfPo.input-module_inside__xz3D3,.input-module_container__oT8JF.input-module_floating__I--KH>.input-module_control__x1YF7:not(:focus):placeholder-shown~.input-module_label__vKfPo.input-module_inside__xz3D3{color:rgba(105,99,131,.6);font:400 16px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;pointer-events:none;top:20px}.input-module_loader__DfBaa{animation:input-module_spin__Z5Kf0 1s cubic-bezier(.445,.05,.55,.95) infinite;color:#3416b6;display:inline-block;height:24px;line-height:24px;width:24px}.input-module_control__x1YF7:-moz-read-only~.input-module_loader__DfBaa{color:rgba(105,99,131,.6)}.input-module_control__x1YF7:disabled~.input-module_loader__DfBaa,.input-module_control__x1YF7:read-only~.input-module_loader__DfBaa{color:rgba(105,99,131,.6)}.input-module_fade__9Q1K8{animation:input-module_fade-in__6l71- .1s linear .9s 1 forwards;opacity:0}@keyframes input-module_spin__Z5Kf0{to{transform:rotate(1turn)}}@keyframes input-module_fade-in__6l71-{0%{opacity:0}to{opacity:1}}";
var styles$n = {"container":"input-module_container__oT8JF","wrapper":"input-module_wrapper__zs1cn","group":"input-module_group__uYY4H","labeled":"input-module_labeled__nMWhA","control":"input-module_control__x1YF7","spaced":"input-module_spaced__9rcVm","bg":"input-module_bg__u86Wv","disabled":"input-module_disabled__G4yD2","prefix":"input-module_prefix__UmQWy","postfix":"input-module_postfix__RXOKL","primary":"input-module_primary__1D-ZM","light":"input-module_light__ADAD4","rounded-left":"input-module_rounded-left__-hQmC","rounded-right":"input-module_rounded-right__aKSHB","hint":"input-module_hint__Ylp8Y","error":"input-module_error__9eXKg","warning":"input-module_warning__w0zEl","success":"input-module_success__VPv3g","s":"input-module_s__fHdYz","m":"input-module_m__Map8E","l":"input-module_l__DMjYa","single":"input-module_single__QQwpF","content":"input-module_content__tc-qO","icon":"input-module_icon__EAQ5i","pointer":"input-module_pointer__-Or9Y","reset":"input-module_reset__7L-80","status":"input-module_status__xz2rC","start":"input-module_start__7yPFd","end":"input-module_end__p4e5y","readonly":"input-module_readonly__zczGV","active":"input-module_active__ycIYJ","floating":"input-module_floating__I--KH","label":"input-module_label__vKfPo","labeltext":"input-module_labeltext__VcLjY","required":"input-module_required__rPL4a","star":"input-module_star__WuW0y","outside":"input-module_outside__kKj-h","inside":"input-module_inside__xz3D3","empty":"input-module_empty__yTEu5","loader":"input-module_loader__DfBaa","spin":"input-module_spin__Z5Kf0","fade":"input-module_fade__9Q1K8","fade-in":"input-module_fade-in__6l71-"};
styleInject(css_248z$18);

function useContent(children) {
    return React.useMemo(() => React.Children.toArray(children).reduce((res, item) => {
        var _a;
        const placement = (_a = item === null || item === void 0 ? void 0 : item.props) === null || _a === void 0 ? void 0 : _a.placement;
        return placement ? Object.assign(Object.assign({}, res), { [placement]: item }) : res;
    }, { start: null, end: null }), [children]);
}

function useInputHandlers(props) {
    const { onFocus, onBlur, onKeyDown, onKeyUp, onKeyPress } = props;
    const handlers = React.useMemo(() => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (onBlur && { onBlur })), (onFocus && { onFocus })), (onKeyDown && { onKeyDown })), (onKeyUp && { onKeyUp })), (onKeyPress && { onKeyPress }))), [onFocus, onBlur, onKeyDown, onKeyUp, onKeyPress]);
    return handlers;
}
function useTextareaHandlers(props) {
    const { onFocus, onBlur, onKeyDown, onKeyUp, onKeyPress } = props;
    const handlers = React.useMemo(() => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (onBlur && { onBlur })), (onFocus && { onFocus })), (onKeyDown && { onKeyDown })), (onKeyUp && { onKeyUp })), (onKeyPress && { onKeyPress }))), [onFocus, onBlur, onKeyDown, onKeyUp, onKeyPress]);
    return handlers;
}

const generateId$1 = () => `input_${Math.random().toString().split('.')[1].substr(-8)}`;
const useInputId = (external) => {
    const id = React.useMemo(() => {
        let result;
        if (external) {
            result = generateId$1();
        }
        if (typeof external === 'string') {
            result = external;
        }
        return result;
    }, [external]);
    return id;
};

const statusIcons = ['check-circle', 'exclamation-circle', 'exclamation-triangle'];
function useInputStatus(success, error, warning) {
    return React.useMemo(() => {
        const result = { icon: null, ref: null };
        const statuses = [success, error, warning];
        for (let i = 0; i < statuses.length; i++) {
            if (!statuses[i]) {
                continue;
            }
            result.icon = statusIcons[i];
            if (typeof statuses[i] === 'function') {
                result.ref = statuses[i];
            }
        }
        return result;
    }, [success, error, warning]);
}

function useTransformations(formatter, parser) {
    const format = React.useCallback((v) => {
        const normalized = toString$5(v);
        return formatter ? formatter(normalized) : normalized;
    }, [formatter]);
    const parse = React.useCallback((v) => (parser ? parser(v) : v), [parser]);
    return {
        format,
        parse,
    };
}

function useIMask(opts, { onAccept, onComplete, }) {
    const ref = React.useRef(null);
    const maskRef = React.useRef(null);
    const deleteMask = React.useCallback(() => {
        var _a;
        (_a = maskRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
        maskRef.current = null;
    }, []);
    const handleOnAccept = React.useCallback((event) => maskRef.current && (onAccept === null || onAccept === void 0 ? void 0 : onAccept(maskRef.current.value, maskRef.current, event)), [onAccept]);
    const handleOnComplete = React.useCallback(() => maskRef.current && (onComplete === null || onComplete === void 0 ? void 0 : onComplete(maskRef.current.value, maskRef.current)), [onComplete]);
    React.useEffect(() => {
        const el = ref.current;
        if (!el || !(opts === null || opts === void 0 ? void 0 : opts.mask)) {
            return deleteMask();
        }
        const mask = maskRef.current;
        if (!mask && el && (opts === null || opts === void 0 ? void 0 : opts.mask)) {
            maskRef.current = IMask(el, opts);
            if (el.value !== maskRef.current.value) {
                handleOnAccept();
            }
        }
        else {
            mask === null || mask === void 0 ? void 0 : mask.updateOptions(opts);
        }
    }, [opts, deleteMask, handleOnAccept]);
    React.useEffect(() => {
        if (!maskRef.current) {
            return;
        }
        const mask = maskRef.current;
        mask.on('accept', handleOnAccept);
        mask.on('complete', handleOnComplete);
        return () => {
            mask.off('accept', handleOnAccept);
            mask.off('complete', handleOnComplete);
        };
    }, [handleOnAccept, handleOnComplete]);
    React.useEffect(() => deleteMask, [deleteMask]);
    return {
        ref,
        maskRef,
    };
}

const Content$7 = ({ children, placement = 'end', onClick, pointer = false, dataTest }) => (React.createElement("span", Object.assign({}, { [`data-addon-${placement}`]: '' }, { onClick: onClick, className: cn(styles$n.content, styles$n[placement], pointer && styles$n.pointer), "data-test": dataTest }), children));
var Content$8 = Content$7;

const InputIcon = (_a) => {
    var { placement = 'end', onClick, pointer, dataTest } = _a, icon = __rest(_a, ["placement", "onClick", "pointer", "dataTest"]);
    return (React.createElement(Content$8, { placement: placement, onClick: onClick, pointer: pointer, dataTest: dataTest },
        React.createElement(Icon$4, Object.assign({}, icon))));
};
var Icon$3 = InputIcon;

function debounce$3(cb, timeout = 0, instant = true) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        if (timeout === 0 && instant) {
            cb(...args);
        }
        else {
            timer = setTimeout(() => cb(...args), timeout);
        }
    };
}
const noop$3 = () => { };

const context$5 = React.createContext({
    index: -1,
    size: 'm',
    width: '1',
    first: false,
    last: false,
});
function useGroup() {
    const data = React.useContext(context$5);
    return Object.assign(Object.assign({}, data), { present: data.index > -1 });
}

const inputMargin = 4;
const additionsMargin = 8;
const padding$3 = 16;
const Label = ({ container: container, size, content, info, reset, postfix, children, id, required, status, }) => {
    const [restrictions, setRestriction] = React.useState({ start: padding$3, end: padding$3 });
    const getAdditions = React.useCallback(() => { var _a; return Array.from(((_a = container.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[data-addon-end]')) || []); }, [
        container,
    ]);
    React.useEffect(() => {
        if (size !== 'l') {
            return;
        }
        const additions = getAdditions();
        const width = additions.reduce((res, node) => res + node.offsetWidth, 0);
        const restriction = padding$3 + width + ((additions.length - 1) * additionsMargin + Math.sign(additions.length) * inputMargin);
        setRestriction(prev => (Object.assign(Object.assign({}, prev), { end: restriction })));
    }, [status.icon, content.end, info, reset, size, postfix, getAdditions]);
    React.useEffect(() => {
        var _a, _b;
        if (size !== 'l') {
            return;
        }
        const width = ((_b = (_a = container.current) === null || _a === void 0 ? void 0 : _a.querySelector('[data-addon-start]')) === null || _b === void 0 ? void 0 : _b.offsetWidth) || 0;
        const restriction = padding$3 + width;
        setRestriction(prev => (Object.assign(Object.assign({}, prev), { start: restriction })));
    }, [content.start, size, container]);
    return (React.createElement("label", { htmlFor: id, className: cn(styles$n.label, size === 'l' ? styles$n.inside : styles$n.outside, required && styles$n.required), style: Object.assign({}, (size === 'l' && { left: restrictions.start, right: restrictions.end })) },
        React.createElement("span", { className: styles$n.labeltext }, children),
        required && React.createElement("div", { className: styles$n.star }, "*")));
};
var Label$1 = Label;

const MODAL_TRANSITION_TIME = 240 + 20;
const s$o = normalizeCSSModules(styles$n);
const defaultResolver = (v) => v;
const Loader$2 = ({ fade }) => (React.createElement("svg", { className: cn(fade && s$o.fade), width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M11 3a1 1 0 011-1 10 10 0 0110 10 1 1 0 11-2 0 7.999 7.999 0 00-8-8 1 1 0 01-1-1z", fill: "currentColor" })));
const Input = (props) => {
    const { autoComplete = 'off', autoFocus = false, background = 'primary', children, dataTest, disabled = false, error = false, floating = true, formatter, gtm, hint, id: externalId = true, info = null, inputMode = 'text', label = '', loading = false, loaderFade = false, max, maxLength, min, name, imask, onChange = () => { }, onReset = () => { }, defaultResetValue = '', parser, pattern, placeholder = '', postfix = '', prefix = '', readOnly = false, required, size: externalSize = 's', spaced = false, type = 'text', valid = false, value: externalValue, warning = false, passRequiredToHTMLInput = true, onClick, inputRef, wrapperRef, containerRef, } = props;
    let { autofocus = false, readonly = false, success = false } = props;
    const { format, parse } = useTransformations(formatter, parser);
    const handlers = useInputHandlers(props);
    const input = React.useRef(null);
    const container = React.useRef(null);
    const hasImask = imask && Object.keys(imask).length > 0;
    const initValue = React.useMemo(() => {
        let resolver = defaultResolver;
        if (hasImask) {
            const masked = IMask.createMask(imask);
            resolver = masked.resolve.bind(masked);
        }
        return resolver;
    }, [hasImask, JSON.stringify(imask)]);
    const [value, setValue] = React.useState(initValue(format(externalValue)));
    const id = useInputId(externalId);
    const group = useGroup();
    const size = (group.present && group.size) || externalSize;
    autofocus = autofocus || autoFocus;
    readonly = readonly || readOnly;
    React.useEffect(() => {
        if (!(input === null || input === void 0 ? void 0 : input.current)) {
            return;
        }
        const isAlreadyFocused = document.activeElement === input.current;
        const isShouldFocused = autofocus && !isAlreadyFocused;
        if (isShouldFocused) {
            setTimeout(() => { var _a; return (_a = input === null || input === void 0 ? void 0 : input.current) === null || _a === void 0 ? void 0 : _a.focus(); }, MODAL_TRANSITION_TIME);
        }
    }, [autofocus, input]);
    const reset = !disabled && !readonly && !!(onReset && value.length > 0);
    const handleClick = React.useCallback(event => {
        var _a;
        if (event.target === container.current) {
            (_a = input.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [onClick]);
    const handleValueChange = React.useCallback((newValue, event) => {
        const text = format(newValue);
        if (value !== text) {
            onChange(parse(newValue), event);
        }
        setValue(text);
    }, [format, parse, onChange, value]);
    const handleImaskOnAccept = React.useCallback((v, _mask, e) => handleValueChange(v, e), [handleValueChange]);
    const handleInputOnChange = React.useCallback(event => handleValueChange(event.target.value, event), [handleValueChange]);
    const { ref: masked, maskRef } = useIMask(imask, {
        onAccept: handleImaskOnAccept,
    });
    const syncValueWithMask = React.useCallback((update) => {
        if (!maskRef || !maskRef.current) {
            return update;
        }
        maskRef.current.unmaskedValue = update;
        return maskRef.current.value;
    }, [maskRef]);
    React.useEffect(() => {
        setValue(syncValueWithMask(format(externalValue)));
    }, [externalValue, format, syncValueWithMask]);
    const handleOnPaste = React.useCallback(event => {
        event.preventDefault();
        const raw = (event.clipboardData || window.clipboardData).getData('text/plain');
        const { value, selectionStart, selectionEnd } = event.target;
        const targetValue = value.slice(0, selectionStart) + raw + value.slice(selectionEnd);
        const text = syncValueWithMask(format(targetValue));
        if (value !== text) {
            onChange(parse(text), event);
        }
        setValue(text);
        return false;
    }, [format, syncValueWithMask, onChange, parse]);
    const handleReset = React.useCallback(event => {
        var _a;
        if (hasImask) {
            setValue(syncValueWithMask(defaultResetValue));
        }
        else {
            setValue(defaultResetValue);
            onChange(parse(defaultResetValue), event);
        }
        if (onReset) {
            onReset(event);
        }
        (_a = input.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [onReset, defaultResetValue, syncValueWithMask, hasImask, onChange, parse]);
    success = success || valid;
    const status = useInputStatus(success, error, warning);
    const content = useContent(children);
    const assignInputRef = React.useCallback(el => {
        input.current = el;
        if (hasImask) {
            masked.current = el;
        }
        if (inputRef) {
            inputRef.current = el;
        }
    }, [masked, hasImask, inputRef]);
    const assignContainerRef = React.useCallback(el => {
        container.current = el;
        if (containerRef) {
            containerRef.current = el;
        }
    }, [containerRef]);
    const attrs = Object.assign({}, (passRequiredToHTMLInput && { required }));
    return (React.createElement("div", { className: cn(s$o.wrapper, spaced && s$o.spaced, group.present && !group.first && s$o.group), ref: wrapperRef, style: Object.assign(Object.assign({}, (group.present && { flex: group.width })), (group.present && { maxWidth: group.maxWidth })) },
        React.createElement("span", { className: cn(s$o.container, s$o[size], warning && s$o.warning, error && s$o.error, success && s$o.success, !label && size === 'l' && s$o.single, label && size !== 'l' && s$o.labeled, floating && size === 'l' && s$o.floating, disabled && s$o.disabled, readonly && s$o.readonly), ref: assignContainerRef, "data-gtm": gtm, "data-test": dataTest, onClick: handleClick },
            content.start,
            prefix && (React.createElement("span", { className: cn(s$o.start, s$o.prefix, value.length > 0 && s$o.active, readonly && s$o.readonly) }, prefix)),
            React.createElement("input", Object.assign({ autoComplete: autoComplete, autoCorrect: "off", className: cn(s$o.control, value.length === 0 && s$o.empty), disabled: disabled, id: id, inputMode: inputMode, maxLength: maxLength, name: name, pattern: pattern, placeholder: placeholder, readOnly: readonly, size: 1, type: type, min: min, max: max, value: value, autoFocus: autofocus, ref: assignInputRef, onChange: hasImask ? noop$3 : handleInputOnChange, onPaste: handleOnPaste }, attrs, handlers)),
            postfix && (React.createElement("span", { "data-addon-end": true, className: cn(s$o.end, s$o.postfix) }, postfix)),
            (status.icon || loading) && (React.createElement("span", { "data-addon-end": true, className: cn(s$o.end, loading ? s$o.loader : s$o.status), ref: status.ref }, loading ? React.createElement(Loader$2, { fade: loaderFade }) : React.createElement(Icon$4, { name: status.icon }))),
            reset && (React.createElement("span", { "data-addon-end": true, className: cn(s$o.end, s$o.icon, s$o.reset), onClick: handleReset, onKeyPress: handleKeyPressEnter(handleReset), role: "button", tabIndex: 0, "aria-label": "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C", "data-test": "reset-icon" },
                React.createElement(Icon$4, { name: "times-circle" }))),
            info && (React.createElement("span", { "data-addon-end": true, className: cn(s$o.end, s$o.icon), ref: info },
                React.createElement(Icon$4, { name: "information-circle" }))),
            content.end,
            label && (React.createElement(Label$1, { container: container, size: size, content: content, info: info, reset: reset, postfix: postfix, id: id, required: required, status: status }, label)),
            React.createElement("span", { className: cn(s$o.bg, s$o[background], (!group.present || (group.present && group.first)) && s$o.roundedLeft, (!group.present || (group.present && group.last)) && s$o.roundedRight) })),
        hint && (React.createElement("span", { className: cn(s$o.hint, error && s$o.error, warning && s$o.warning, success && s$o.success), "data-test": error ? 'error' : warning ? 'warning' : success ? 'success-hint' : 'hint' }, hint))));
};
Input.Content = Content$8;
Input.Icon = Icon$3;
var Input$1 = Input;

const directions = ['up', 'right', 'down', 'left'];
const padding$2 = 8;
const directionAlias = {
    up: 'top',
    down: 'bottom',
    left: 'left',
    right: 'right',
};
function useTooltip() {
    const controls = React.useRef(new Set([]));
    const container = React.useRef(null);
    const registerControl = React.useCallback((el) => el && controls.current.add(el), []);
    return {
        to: controls,
        container,
        registerControl,
    };
}
function toClickOutside(popper) {
    var _a;
    return [{ current: (_a = popper.current) === null || _a === void 0 ? void 0 : _a.state.elements.reference }];
}
function fit$1({ containerEl, controlEl, tooltipEl, directionEl }) {
    const box = containerEl ? getElementSize(containerEl) : getWindowSize();
    const origin = getElementSize(document.body);
    const control = getElementSize(controlEl);
    const tooltip = getElementSize(tooltipEl);
    const cleft = control.left - origin.left;
    const cright = control.right - origin.left;
    const ctop = control.top - origin.top;
    const cbottom = control.bottom - origin.top;
    const xmin = box.left - origin.left;
    const xmax = box.right - origin.left;
    const ymin = box.top - origin.top;
    const ymax = box.bottom - origin.top;
    const controlWithin = ctop - ymin >= 0 && ymax - cbottom >= 0;
    const possibleDirections = {
        left: controlWithin && cleft - padding$2 - tooltip.width >= xmin,
        right: controlWithin && cright + padding$2 + tooltip.width <= xmax,
        up: ctop - padding$2 - tooltip.height >= ymin,
        down: cbottom + padding$2 + tooltip.height <= ymax,
    };
    const realDirection = [
        ...directions.slice(directions.indexOf(directionEl)),
        ...directions.slice(0, directions.indexOf(directionEl)),
    ].find(dir => possibleDirections[dir]) || directionEl;
    return directionAlias[realDirection];
}

const createPopper = popperGenerator({
    defaultModifiers: [...defaultModifiers$1, preventOverflow$2, offsetModifier, arrowModifier, hideModifier],
});
const arrow$1 = {
    name: 'arrow',
    options: {
        padding: 2,
    },
};
const offset$2 = {
    name: 'offset',
    options: {
        offset: [0, padding$2],
    },
};
const overflow$1 = (containerEl) => ({
    name: 'preventOverflow',
    options: {
        boundary: containerEl,
    },
});
const adaptiveDirection = (containerEl, directionEl) => ({
    name: 'direction',
    enabled: true,
    phase: 'beforeRead',
    fn({ state }) {
        state.placement = fit$1({
            containerEl,
            controlEl: state.elements.reference,
            tooltipEl: state.elements.popper,
            directionEl,
        });
    },
});
const silent$1 = [offset$2, { name: 'eventListeners', enabled: false }, { name: 'computeStyles', enabled: false }];

var css_248z$17 = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.tooltip-module_root__Iszyb{left:0;position:absolute;right:0;top:0;z-index:103}.tooltip-module_content__yZBPK{border-radius:2px;font-size:14px;line-height:20px;max-width:320px;padding:8px 12px;position:absolute;transition:.24s cubic-bezier(.24,.1,.24,1);transition-property:visibility,opacity}.tooltip-module_content__yZBPK.tooltip-module_local__0Sgbn{z-index:103}.tooltip-module_content__yZBPK.tooltip-module_visible__N6F30{opacity:1;visibility:visible}.tooltip-module_content__yZBPK,.tooltip-module_content__yZBPK[data-popper-reference-hidden]{opacity:0;visibility:hidden}.tooltip-module_content__yZBPK.tooltip-module_black__Dge-f{background-color:#211f2e;color:#fff}.tooltip-module_content__yZBPK.tooltip-module_warning__18HEG{background-color:#fac32e;color:#211f2e}.tooltip-module_content__yZBPK.tooltip-module_alert__H5uxS{background-color:#f44434;color:#fff}.tooltip-module_content__yZBPK.tooltip-module_success__ubqhs{background-color:#87d232;color:#fff}.tooltip-module_arrow__N-ce9,.tooltip-module_arrow__N-ce9:before{height:8px;position:absolute;width:8px;z-index:-1}.tooltip-module_arrow__N-ce9:before{content:\"\";transform:rotate(45deg)}.tooltip-module_content__yZBPK.tooltip-module_black__Dge-f>.tooltip-module_arrow__N-ce9:before{background-color:#211f2e}.tooltip-module_content__yZBPK.tooltip-module_warning__18HEG>.tooltip-module_arrow__N-ce9:before{background-color:#fac32e}.tooltip-module_content__yZBPK.tooltip-module_alert__H5uxS>.tooltip-module_arrow__N-ce9:before{background-color:#f44434}.tooltip-module_content__yZBPK.tooltip-module_success__ubqhs>.tooltip-module_arrow__N-ce9:before{background-color:#87d232}.tooltip-module_content__yZBPK[data-popper-placement=top]>.tooltip-module_arrow__N-ce9{bottom:-4px}.tooltip-module_content__yZBPK[data-popper-placement=bottom]>.tooltip-module_arrow__N-ce9{top:-4px}.tooltip-module_content__yZBPK[data-popper-placement=left]>.tooltip-module_arrow__N-ce9{right:-4px}.tooltip-module_content__yZBPK[data-popper-placement=right]>.tooltip-module_arrow__N-ce9{left:-4px}";
var s$n = {"root":"tooltip-module_root__Iszyb","content":"tooltip-module_content__yZBPK","local":"tooltip-module_local__0Sgbn","visible":"tooltip-module_visible__N6F30","black":"tooltip-module_black__Dge-f","warning":"tooltip-module_warning__18HEG","alert":"tooltip-module_alert__H5uxS","success":"tooltip-module_success__ubqhs","arrow":"tooltip-module_arrow__N-ce9"};
styleInject(css_248z$17);

const clearTimeouts = (timers) => timers.forEach(timer => clearTimeout(timer));
function useSafeTimeout() {
    const timers = React.useRef([]);
    React.useEffect(() => () => {
        clearTimeouts(timers.current);
    }, []);
    return (handler, timeout) => {
        const timer = setTimeout(() => {
            timers.current = timers.current.filter(item => item !== timer);
            handler();
        }, timeout);
        timers.current.push(timer);
    };
}

const appearDelay = 40;
function useTransitionState(opened, options) {
    const [state, setState] = React.useState('init');
    const { duration = 0 } = React.useMemo(() => options || {}, [options]);
    const setSafeTimeout = useSafeTimeout();
    const close = React.useCallback(() => {
        if (!/appear|show/.test(state)) {
            return;
        }
        return new Promise(resolve => {
            setState('exit');
            setSafeTimeout(() => {
                setState('idle');
                resolve(true);
            }, duration);
        });
    }, [opened, state]);
    React.useEffect(() => {
        if (opened && /init|idle/.test(state)) {
            setState('appear');
            setSafeTimeout(() => setState('show'), appearDelay);
        }
        if (!opened) {
            close();
        }
    }, [opened]);
    return [state, close];
}

const defaultContainer = browser ? { current: document.body } : { current: null };
const useDOMRoot = ({ anchor, style, container = defaultContainer }) => {
    const [root, setRoot] = React.useState(null);
    React.useEffect(() => {
        if (!container.current) {
            return;
        }
        let launchpad = container.current.querySelector(`:scope > [data-${anchor}]`);
        if (!launchpad) {
            launchpad = createElement('div', { className: style, [`data-${anchor}`]: '' });
            container.current.appendChild(launchpad);
        }
        setRoot(launchpad);
    }, [container, anchor, style]);
    return root;
};
var useDOMRoot$1 = useDOMRoot;

const closingTimeout$2 = 240;
const Launchpad$1 = ({ root, children }) => {
    return root ? ReactDOM.createPortal(children, root) : children;
};
const Tooltip$1 = ({ to = { current: new Set() }, container = { current: null }, trigger = 'hover', color = 'black', direction = 'up', placement = 'local', arrow: showArrow = true, children, }) => {
    var _a;
    const [visible, setVisible] = React.useState(false);
    const tooltip = React.useRef(null);
    const event = React.useRef();
    const [state, close] = useTransitionState(visible, { duration: closingTimeout$2 });
    const root = useDOMRoot$1({ anchor: 'tooltip-launchpad', style: s$n.root });
    const popper = React.useRef(null);
    const show = React.useCallback((evt) => __awaiter(void 0, void 0, void 0, function* () {
        if (visible) {
            return;
        }
        event.current = evt;
        setVisible(true);
    }), [visible]);
    const hide = React.useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (visible && state === 'show') {
            yield close();
        }
        setVisible(false);
    }), [visible, state, close]);
    React.useEffect(() => {
        var _a;
        if (!to.current || state !== 'appear' || !event.current) {
            return;
        }
        const ref = ((trigger === 'click' || trigger === 'static') &&
            Array.from(to.current).find(el => { var _a; return el.contains((_a = event.current) === null || _a === void 0 ? void 0 : _a.target); })) ||
            event.current.target;
        if (popper.current) {
            (_a = popper.current) === null || _a === void 0 ? void 0 : _a.destroy();
        }
        popper.current = createPopper(ref, tooltip.current, {
            placement: directionAlias[direction],
            modifiers: [
                ...(showArrow ? [arrow$1] : []),
                offset$2,
                overflow$1(container.current || document.body),
                adaptiveDirection(container.current, direction),
            ],
        });
    }, [state, to, direction, trigger, container, showArrow]);
    React.useEffect(() => {
        var _a;
        if (state !== 'idle') {
            return;
        }
        (_a = popper.current) === null || _a === void 0 ? void 0 : _a.setOptions({ modifiers: [...silent$1] });
    }, [state]);
    useOnClickOutside(toClickOutside(popper), hide, trigger === 'click');
    React.useEffect(() => {
        const controls = to.current;
        if (!controls || controls.size === 0) {
            return;
        }
        if (trigger === 'static') {
            controls.forEach((item) => {
                show({ target: item });
            });
            return;
        }
        const handlerType = trigger === 'click' ? 'click' : 'mouseover';
        controls.forEach((item) => {
            item.addEventListener(handlerType, show);
            if (trigger === 'hover') {
                item.addEventListener('mouseleave', hide);
            }
        });
        return () => {
            controls.forEach((item) => {
                item.removeEventListener(handlerType, show);
                item.removeEventListener('mouseleave', hide);
            });
        };
    }, [trigger, (_a = to.current) === null || _a === void 0 ? void 0 : _a.size]);
    if (state === 'init' || state === 'idle') {
        return null;
    }
    return (React.createElement(Launchpad$1, { root: placement === 'body' ? root : null },
        React.createElement("div", { ref: tooltip, className: cn(s$n.content, s$n[color], state === 'show' && s$n.visible, placement === 'local' && s$n.local) },
            children,
            showArrow && React.createElement("div", { className: s$n.arrow, "data-popper-arrow": true }))));
};

const imaskCurrencyMap = {
    RUB: 'num ₽',
    EUR: '€num',
    USD: '$num',
};
const imaskPropsCurrencyMap = {
    RUB: { thousandsSeparator: ' ', radix: ',', mapToRadix: ['.'] },
    EUR: { thousandsSeparator: ',', radix: '.', mapToRadix: [','] },
    USD: { thousandsSeparator: ',', radix: '.', mapToRadix: [','] },
};
const NumberInput = (_a) => {
    var { fraction = 0, min = 0, max = Infinity, separator = true, onChange, currency } = _a, props = __rest(_a, ["fraction", "min", "max", "separator", "onChange", "currency"]);
    const parser = React.useCallback(v => pipe$1(normalizeNumber, toInt)(v), []);
    const inputMode = fraction ? 'decimal' : 'numeric';
    const imask = React.useMemo(() => {
        const numberMask = {
            mask: Number,
            scale: fraction,
            thousandsSeparator: separator ? ' ' : '',
            radix: ',',
            mapToRadix: ['.'],
            min,
            max,
        };
        if (currency) {
            return {
                mask: [
                    {
                        mask: '',
                    },
                    {
                        mask: imaskCurrencyMap[currency],
                        lazy: false,
                        blocks: {
                            num: Object.assign(Object.assign(Object.assign({}, numberMask), imaskPropsCurrencyMap[currency]), { padFractionalZeros: fraction > 0 }),
                        },
                    },
                ],
            };
        }
        return numberMask;
    }, [currency, fraction, max, min, separator]);
    return (React.createElement(Input$1, Object.assign({}, props, { imask: imask, min: min, max: max, inputMode: inputMode, parser: parser, onChange: onChange })));
};
NumberInput.Content = Content$8;
NumberInput.Icon = Icon$3;
var NumberInput$1 = NumberInput;

const phoneImaskConfig = {
    mask: '000 000-00-00',
};
const phoneMask = IMask.createMask(phoneImaskConfig);
const phoneFormatter = pipe$1(trimmer, clearFormatting, clearCountryPrefix, takeUntill(10), phoneMask.resolve.bind(phoneMask));
const phoneParser = pipe$1(trimmer, clearFormatting, clearCountryPrefix, takeUntill(10), value => `7${value}`);
const Phone = (_a) => {
    var { label = 'Телефон', prefix = '+7', type = 'tel', placeholder = '000 000-00-00', value: externalValue, parser: externalParser } = _a, props = __rest(_a, ["label", "prefix", "type", "placeholder", "value", "parser"]);
    const value = React.useMemo(() => {
        return (externalValue || '').replace(/^7/, '');
    }, [externalValue]);
    const parser = React.useCallback(value => {
        const prepared = phoneParser(value);
        return externalParser ? externalParser(prepared) : prepared;
    }, [externalParser]);
    return (React.createElement(Input$1, Object.assign({}, props, { formatter: phoneFormatter, parser: parser, label: label, prefix: prefix, type: type, placeholder: placeholder, value: value, imask: phoneImaskConfig })));
};
Phone.Content = Content$8;
Phone.Icon = Icon$3;
var PhoneInput = Phone;

const msInSec = 1000;
const secInMin = 60;
const minInHour = 60;
const hoursInHalfDay = 12;
const hoursInDay = 24;
const daysInWeek = 7;
const secInHour = minInHour * secInMin;
const msInMin = msInSec * secInMin;
const msInHour = secInHour * msInSec;
const msInDay = hoursInDay * msInHour;
const timeUnits = [
    { name: 'year', getter: 'getFullYear', setter: 'setFullYear' },
    { name: 'month', getter: 'getMonth', setter: 'setMonth' },
    { name: 'day', getter: 'getDate', setter: 'setDate', start: 1, duration: msInDay },
    { name: 'hour', getter: 'getHours', setter: 'setHours', duration: msInHour },
    { name: 'minute', getter: 'getMinutes', setter: 'setMinutes', duration: msInMin },
    { name: 'second', getter: 'getSeconds', setter: 'setSeconds', duration: msInSec },
    { name: 'ms', getter: 'getMilliseconds', setter: 'setMilliseconds', duration: 1 },
];
const timeUnitsData = timeUnits.reduce((memo, _a, i) => {
    var { name } = _a, data = __rest(_a, ["name"]);
    return (Object.assign(Object.assign({}, memo), { [name]: Object.assign(Object.assign({}, data), { i }) }));
}, {});
function getDaysInMonth(date) {
    const normalized = new Date(date);
    return new Date(normalized.getFullYear(), normalized.getMonth() + 1, 0).getDate();
}
function startOfDate(date, unit) {
    const normalized = new Date(date);
    timeUnits.slice(timeUnitsData[unit].i + 1).forEach(({ setter, start = 0 }) => normalized[setter](start));
    return typeof date === 'number' ? normalized.getTime() : normalized;
}
function endOfDate(date, unit) {
    const normalized = new Date(date);
    const { getter, setter } = timeUnitsData[unit];
    const value = normalized[getter]();
    const raw = new Date(startOfDate(normalized[setter](value + 1), unit)).getTime() - 1;
    return typeof date === 'number' ? raw : new Date(raw);
}
const patternUnits = { Y: 'year', M: 'month', D: 'day', h: 'hour', m: 'minute', s: 'second' };
function parseFormat(format = '') {
    const options = format.split('').reduce((options, pattern) => {
        const unit = patternUnits[pattern];
        if (unit) {
            options[unit] = options[unit] ? '2-digit' : 'numeric';
        }
        return options;
    }, {});
    if (/MMM/.test(format)) {
        options.month = 'short';
    }
    if (/MMMM/.test(format)) {
        options.month = 'long';
    }
    return options;
}
function formatDate(value, format, locale = 'ru-RU', hour12 = true) {
    const options = Object.assign(Object.assign({}, parseFormat(format)), { hour12 });
    const formatter = new Intl.DateTimeFormat(locale, options);
    if (options.year || options.hour12) {
        const { month, year } = options;
        return formatter
            .formatToParts(value)
            .map(({ type, value }, i, arr) => {
            var _a;
            if (type === 'dayPeriod') {
                value = value.toLowerCase();
            }
            if (type === 'literal' && ((_a = arr[i + 1]) === null || _a === void 0 ? void 0 : _a.type) === 'dayPeriod') {
                value = '';
            }
            if (type === 'literal' && value === ' г.') {
                value = '';
            }
            if (type === 'year' && year === '2-digit' && month !== 'numeric' && month !== '2-digit') {
                value = `'${value}`;
            }
            return value;
        })
            .join('');
    }
    return formatter.format(value);
}
function addToDate(date, value, unit) {
    const normalized = new Date(date);
    const { getter, setter } = timeUnitsData[unit];
    if (unit === 'month' || unit === 'year') {
        const current = normalized.getDate();
        normalized.setDate(1);
        normalized[setter](normalized[getter]() + value);
        normalized.setDate(Math.min(current, getDaysInMonth(normalized)));
    }
    else {
        normalized[setter](normalized[getter]() + value);
    }
    return typeof date === 'number' ? normalized.getTime() : normalized;
}
function isDateSame(a, b, unit = 'ms') {
    const normA = new Date(a);
    const normB = new Date(b);
    return timeUnits
        .slice(0, timeUnitsData[unit].i + 1)
        .reduce((res, { getter }) => res && normA[getter]() === normB[getter](), true);
}

const preventer = (e) => e.stopPropagation();
const bubblePreventedHandlers = {
    onClick: preventer,
    onContextMenu: preventer,
    onDoubleClick: preventer,
    onDrag: preventer,
    onDragEnd: preventer,
    onDragEnter: preventer,
    onDragExit: preventer,
    onDragLeave: preventer,
    onDragOver: preventer,
    onDragStart: preventer,
    onDrop: preventer,
    onMouseDown: preventer,
    onMouseEnter: preventer,
    onMouseLeave: preventer,
    onMouseMove: preventer,
    onMouseOver: preventer,
    onMouseOut: preventer,
    onMouseUp: preventer,
    onKeyDown: preventer,
    onKeyPress: preventer,
    onKeyUp: preventer,
    onFocus: preventer,
    onBlur: preventer,
    onChange: preventer,
    onInput: preventer,
    onInvalid: preventer,
    onSubmit: preventer,
};

function useSwipe({ onLeftSwipe, onRightSwipe, onUpSwipe, onDownSwipe, yThreshold = 50, xThreshold = 30, }) {
    const area = React.useRef(null);
    const xDown = React.useRef(null);
    const yDown = React.useRef(null);
    const handleTouchStart = React.useCallback(evt => {
        const [firstTouch] = evt.touches;
        xDown.current = firstTouch.clientX;
        yDown.current = firstTouch.clientY;
    }, []);
    const handleTouchMove = React.useCallback(evt => {
        if (xDown.current === null || yDown.current === null) {
            return;
        }
        const [firstTouch] = evt.touches;
        const xUp = firstTouch.clientX;
        const yUp = firstTouch.clientY;
        const xDiff = xDown.current - xUp;
        const yDiff = yDown.current - yUp;
        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            if (xDiff > xThreshold) {
                if (onRightSwipe) {
                    onRightSwipe(evt);
                }
            }
            else if (xDiff < -xThreshold) {
                if (onLeftSwipe) {
                    onLeftSwipe(evt);
                }
            }
        }
        else {
            if (yDiff > yThreshold) {
                if (onUpSwipe) {
                    onUpSwipe(evt);
                }
            }
            else if (yDiff < -yThreshold) {
                if (onDownSwipe) {
                    onDownSwipe(evt);
                }
            }
        }
    }, [onLeftSwipe, onRightSwipe, onUpSwipe, onDownSwipe, yThreshold, xThreshold]);
    const handleTouchEnd = React.useCallback(() => {
        xDown.current = null;
        yDown.current = null;
    }, []);
    React.useEffect(() => {
        if (!area.current) {
            return;
        }
        const node = area.current;
        node.addEventListener('touchstart', handleTouchStart, false);
        node.addEventListener('touchmove', handleTouchMove, false);
        node.addEventListener('touchend', handleTouchEnd, false);
        return () => {
            node.removeEventListener('touchstart', handleTouchStart);
            node.removeEventListener('touchmove', handleTouchMove);
            node.removeEventListener('touchend', handleTouchEnd);
        };
    }, [handleTouchStart, handleTouchMove, handleTouchEnd]);
    return { area };
}

var css_248z$16 = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.button-module_control__RNaIG{align-items:center;background:none;border:none;box-sizing:border-box;color:#fff;cursor:pointer;display:inline-flex;font:400 16px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;font-weight:500;justify-content:center;margin:0;outline:none;padding:0;position:relative;-webkit-text-decoration:none;text-decoration:none;touch-action:manipulation;transition:background-color .24s cubic-bezier(.24,.1,.24,1);-webkit-user-select:none;-moz-user-select:none;user-select:none;white-space:nowrap}.button-module_control__RNaIG.button-module_xs__T1rkz{font:400 14px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;font-weight:500}.button-module_control__RNaIG.button-module_rounded-left__J2uxz{border-bottom-left-radius:4px;border-top-left-radius:4px}.button-module_control__RNaIG.button-module_rounded-right__1z4eC{border-bottom-right-radius:4px;border-top-right-radius:4px}.button-module_control__RNaIG.button-module_circle__qZkGq{border-radius:50%}.button-module_control__RNaIG:disabled{background-color:rgba(150,142,190,.2);color:rgba(105,99,131,.6);cursor:not-allowed}.button-module_content__2zdSJ.button-module_overflow__ykglt{overflow:hidden;text-overflow:ellipsis}.button-module_block__DjKEq{display:flex;width:100%}.button-module_bounded__Fk4cF{max-width:100%}.button-module_xs__T1rkz{min-width:32px;padding:6px 16px}.button-module_s__rNeSs{min-width:40px;padding:8px 16px}.button-module_m__-mocg{min-width:52px;padding:14px 16px}.button-module_l__KP4N7{min-width:60px;padding:18px 16px}.button-module_secondary__dyBBm.button-module_s__rNeSs.button-module_selected__iPv9U{padding:7px 15px}.button-module_secondary__dyBBm.button-module_m__-mocg.button-module_selected__iPv9U{padding:13px 15px}.button-module_secondary__dyBBm.button-module_l__KP4N7.button-module_selected__iPv9U{padding:17px 15px}.button-module_control__RNaIG.button-module_loading__ArK-T{pointer-events:none}.button-module_control__RNaIG.button-module_loading__ArK-T .button-module_content__2zdSJ,.button-module_control__RNaIG.button-module_loading__ArK-T .button-module_icon__dlWuF{visibility:hidden}.button-module_loader__3FbzW{align-items:center;bottom:0;display:flex;justify-content:center;left:0;position:absolute;right:0;top:0}.button-module_loader-svg__N07kT{animation:button-module_spin__FoCrc 1s cubic-bezier(.445,.05,.55,.95) infinite;height:16px;width:16px}@keyframes button-module_spin__FoCrc{to{transform:rotate(1turn)}}.button-module_icon__dlWuF{line-height:1em}.button-module_icon__dlWuF.button-module_start__TMftr{margin:0 8px 0 0}.button-module_icon__dlWuF.button-module_end__JqCUQ{margin:0 0 0 8px}.button-module_icon__dlWuF.button-module_only__4bc8Y{margin:0 -8px}.button-module_xs__T1rkz .button-module_icon__dlWuF.button-module_only__4bc8Y{display:inline-flex;margin:4px -8px}.button-module_primary__jRuqv{background-color:#3416b6}.button-module_primary__jRuqv:not(:disabled):hover{background-color:#271188}.button-module_primary__jRuqv:not(:disabled).button-module_selected__iPv9U,.button-module_primary__jRuqv:not(:disabled):active{background-color:#1b0c5f}.button-module_primary__jRuqv:not(:disabled).button-module_shadow__yh87R{box-shadow:0 8px 32px rgba(52,22,182,.16)}.button-module_primary-alt-bg__ZaaoK{background-color:#fff;color:#211f2e}.button-module_primary-alt-bg__ZaaoK:not(:disabled):hover{background-color:#f3f1f8;color:#3416b6}.button-module_primary-alt-bg__ZaaoK:not(:disabled).button-module_selected__iPv9U,.button-module_primary-alt-bg__ZaaoK:not(:disabled):active{background-color:#eae9f2}.button-module_primary-alt-bg__ZaaoK:not(:disabled).button-module_shadow__yh87R{box-shadow:0 2px 12px rgba(33,31,46,.08)}.button-module_control__RNaIG:disabled.button-module_primary-alt-bg__ZaaoK{background-color:hsla(0,0%,100%,.16);color:hsla(0,0%,100%,.64)}.button-module_secondary__dyBBm{background-color:rgba(150,142,190,.2);color:#211f2e}.button-module_secondary__dyBBm:not(:disabled):hover{background-color:rgba(127,120,161,.4)}.button-module_secondary__dyBBm:not(:disabled):active{background-color:rgba(105,99,131,.6)}.button-module_secondary-solid__wnWsd{background-color:#eae9f2;color:#211f2e}.button-module_secondary-solid__wnWsd:not(:disabled):hover{background-color:#ccc9d9}.button-module_secondary-solid__wnWsd:not(:disabled):active{background-color:#a4a1b5}.button-module_secondary-solid__wnWsd.button-module_selected__iPv9U:not(:disabled),.button-module_secondary__dyBBm.button-module_selected__iPv9U:not(:disabled){background-color:#f7f5ff;border:1px solid #3416b6}.button-module_secondary-solid__wnWsd.button-module_selected__iPv9U:disabled,.button-module_secondary__dyBBm.button-module_selected__iPv9U:disabled{border:1px solid rgba(127,120,161,.4)}.button-module_secondary-solid__wnWsd.button-module_selected__iPv9U:not(:disabled):hover,.button-module_secondary__dyBBm.button-module_selected__iPv9U:not(:disabled):hover{background-color:#e7e2fd}.button-module_secondary-solid__wnWsd.button-module_selected__iPv9U:not(:disabled):active,.button-module_secondary__dyBBm.button-module_selected__iPv9U:not(:disabled):active{background-color:#ccc2fa}.button-module_secondary-alt-bg__fa8HJ{background-color:hsla(0,0%,100%,.16)}.button-module_secondary-alt-bg__fa8HJ:not(:disabled):hover{background-color:hsla(0,0%,100%,.32)}.button-module_secondary-alt-bg__fa8HJ:not(:disabled).button-module_selected__iPv9U,.button-module_secondary-alt-bg__fa8HJ:not(:disabled):active{background-color:hsla(0,0%,100%,.64)}.button-module_control__RNaIG:disabled.button-module_secondary-alt-bg__fa8HJ{background-color:hsla(0,0%,100%,.16);color:hsla(0,0%,100%,.64)}.button-module_transparent__z95kX{background-color:hsla(0,0%,100%,0);color:#3416b6}.button-module_transparent__z95kX:not(:disabled):hover{background-color:rgba(127,120,161,.4);color:#211f2e}.button-module_transparent__z95kX:not(:disabled).button-module_selected__iPv9U,.button-module_transparent__z95kX:not(:disabled):active{background-color:rgba(105,99,131,.6)}.button-module_control__RNaIG:disabled.button-module_transparent__z95kX{background-color:hsla(0,0%,100%,0);color:rgba(105,99,131,.6)}.button-module_transparent-alt-bg__zkj5L{background-color:hsla(0,0%,100%,0)}.button-module_transparent-alt-bg__zkj5L:not(:disabled):hover{background-color:hsla(0,0%,100%,.32)}.button-module_transparent-alt-bg__zkj5L:not(:disabled).button-module_selected__iPv9U,.button-module_transparent-alt-bg__zkj5L:not(:disabled):active{background-color:var(--c-secondary-alt-bg-pressed)}.button-module_control__RNaIG:disabled.button-module_transparent-alt-bg__zkj5L{background-color:hsla(0,0%,100%,0);color:hsla(0,0%,100%,.64)}.button-module_accent__TaOt0{background-color:#ff794d}.button-module_accent__TaOt0:not(:disabled):hover{background-color:#ff4f14}.button-module_accent__TaOt0:not(:disabled).button-module_selected__iPv9U,.button-module_accent__TaOt0:not(:disabled):active{background-color:#eb3b00}.button-module_accent__TaOt0:not(:disabled).button-module_shadow__yh87R{box-shadow:0 8px 32px rgba(255,121,77,.16)}.button-module_danger__WseDi{background-color:#f44434}.button-module_danger__WseDi:not(:disabled):hover{background-color:#e91f0c}.button-module_danger__WseDi:not(:disabled).button-module_selected__iPv9U,.button-module_danger__WseDi:not(:disabled):active{background-color:#cb1b0b}.button-module_danger__WseDi:not(:disabled).button-module_shadow__yh87R{box-shadow:0 8px 32px rgba(244,68,52,.16)}.button-module_promo1__mcK1I{background-color:#8e75fa}.button-module_promo1__mcK1I:not(:disabled):hover{background-color:#6544f8}.button-module_promo1__mcK1I:not(:disabled).button-module_selected__iPv9U,.button-module_promo1__mcK1I:not(:disabled):active{background-color:#5836ec}.button-module_promo2__3FQJR{background-color:#28b8bd}.button-module_promo2__3FQJR:not(:disabled):hover{background-color:#1f8f93}.button-module_promo2__3FQJR:not(:disabled).button-module_selected__iPv9U,.button-module_promo2__3FQJR:not(:disabled):active{background-color:#1b7b7e}.button-module_warn__MJ2MD{background-color:#fac32e;color:#211f2e}.button-module_warn__MJ2MD:not(:disabled):hover{background-color:#e5a906}.button-module_warn__MJ2MD:not(:disabled).button-module_selected__iPv9U,.button-module_warn__MJ2MD:not(:disabled):active{background-color:#d19b05}.button-module_accent__TaOt0:not(:disabled).button-module_shadow__yh87R{box-shadow:0 8px 32px rgba(250,195,46,.16)}";
var styles$m = {"control":"button-module_control__RNaIG","xs":"button-module_xs__T1rkz","rounded-left":"button-module_rounded-left__J2uxz","rounded-right":"button-module_rounded-right__1z4eC","circle":"button-module_circle__qZkGq","content":"button-module_content__2zdSJ","overflow":"button-module_overflow__ykglt","block":"button-module_block__DjKEq","bounded":"button-module_bounded__Fk4cF","s":"button-module_s__rNeSs","m":"button-module_m__-mocg","l":"button-module_l__KP4N7","secondary":"button-module_secondary__dyBBm","selected":"button-module_selected__iPv9U","loading":"button-module_loading__ArK-T","icon":"button-module_icon__dlWuF","loader":"button-module_loader__3FbzW","loader-svg":"button-module_loader-svg__N07kT","spin":"button-module_spin__FoCrc","start":"button-module_start__TMftr","end":"button-module_end__JqCUQ","only":"button-module_only__4bc8Y","primary":"button-module_primary__jRuqv","shadow":"button-module_shadow__yh87R","primary-alt-bg":"button-module_primary-alt-bg__ZaaoK","secondary-solid":"button-module_secondary-solid__wnWsd","secondary-alt-bg":"button-module_secondary-alt-bg__fa8HJ","transparent":"button-module_transparent__z95kX","transparent-alt-bg":"button-module_transparent-alt-bg__zkj5L","accent":"button-module_accent__TaOt0","danger":"button-module_danger__WseDi","promo1":"button-module_promo1__mcK1I","promo2":"button-module_promo2__3FQJR","warn":"button-module_warn__MJ2MD"};
styleInject(css_248z$16);

function getIconProps(props) {
    return props.icon && (props.size === 'xs' ? { name: props.icon, size: 'xs' } : { name: props.icon, size: 'm' });
}

const s$m = normalizeCSSModules(styles$m);
const colorAliases = {
    'brand-purple': 'promo1',
    'brand-turquoise': 'promo2',
};
const Button$2 = React.forwardRef((props, ref) => {
    const { children, circle = false, dataAttrs = {}, dataTest, disabled = false, fullWidth = false, gtm, href, rel, target, iconColor, iconPosition = 'start', loading = false, onClick, overflow = true, rounded = 'all', selected = false, shadow = false, size: externalSize = 'm', type = 'button', width, form, } = props;
    let { block = false, variant = 'primary' } = props;
    const group = useGroup();
    const size = (group.present && group.size) || externalSize;
    const clearedDataAttrs = React.useMemo(() => {
        return Object.keys(dataAttrs).reduce((res, dataKey) => {
            if (/^data-+./.test(dataKey)) {
                res[dataKey] = dataAttrs[dataKey];
            }
            return res;
        }, {});
    }, [dataAttrs]);
    const handleClick = React.useCallback(event => {
        if (disabled) {
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [onClick, disabled]);
    block = block || fullWidth;
    variant = variant in colorAliases ? colorAliases[variant] : variant;
    const iconProps = getIconProps(props);
    const link = !disabled && !!href;
    const ButtonTag = link ? 'a' : 'button';
    const specificProps = link ? { href, target, rel } : { form, type };
    return (React.createElement(ButtonTag, Object.assign({ onClick: handleClick, disabled: disabled || loading, className: cn(s$m.control, s$m[variant], s$m[size], selected && s$m.selected, loading && s$m.loading, shadow && s$m.shadow, block && s$m.block, circle && s$m.circle, !!width && block && s$m.bounded, {
            [s$m.roundedLeft]: (group.present && group.first) || (!group.present && (rounded === 'all' || rounded === 'left')),
            [s$m.roundedRight]: (group.present && group.last) || (!group.present && (rounded === 'all' || rounded === 'right')),
        }), ref: ref, "data-test": dataTest, "data-gtm": gtm }, clearedDataAttrs, { style: Object.assign(Object.assign({ width }, (group.present && { flex: group.width })), (group.present && { maxWidth: group.maxWidth })) }, specificProps),
        iconProps && iconPosition === 'start' && (React.createElement("span", { className: cn(s$m.icon, s$m.start, !children && s$m.only), style: Object.assign({}, (iconColor && { color: iconColor })) },
            React.createElement(Icon$4, Object.assign({}, iconProps)))),
        React.createElement("span", { "data-gtm": gtm, className: cn(s$m.content, overflow && s$m.overflow) }, children),
        iconProps && iconPosition === 'end' && (React.createElement("span", { className: cn(s$m.icon, s$m.end, !children && s$m.only), style: Object.assign({}, (iconColor && { color: iconColor })) },
            React.createElement(Icon$4, Object.assign({}, iconProps)))),
        loading && (React.createElement("span", { className: s$m.loader },
            React.createElement("span", { className: s$m.loaderSvg },
                React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
                    React.createElement("path", { fill: "currentColor", d: "M8 2a6 6 0 00-6 6 1 1 0 01-2 0 8 8 0 018-8 1 1 0 010 2z" })))))));
});
var Button$3 = Button$2;

var css_248z$15 = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.calendar-module_box__LcyCP{box-sizing:content-box;min-width:280px;width:280px}.calendar-module_box__LcyCP.calendar-module_card__1YA-r{background:var(--c-background);box-shadow:0 4px 16px rgba(33,31,46,.12);padding:16px}.calendar-module_fraction__UgbIN{display:flex;justify-content:space-between}.calendar-module_fraction__UgbIN button:not(:hover):not(:disabled) i{color:#211f2e}.calendar-module_current__t--PI{font-weight:500;padding:10px 0;text-transform:capitalize}";
var s$l = {"box":"calendar-module_box__LcyCP","card":"calendar-module_card__1YA-r","fraction":"calendar-module_fraction__UgbIN","current":"calendar-module_current__t--PI"};
styleInject(css_248z$15);

function clamp$2(v, min, max) {
    return Math.min(Math.max(v, min), max);
}
const context$4 = React.createContext({
    state: {
        fraction: 'month',
        min: 0,
        max: Date.now(),
        current: NaN,
        units: [],
        mode: 'range',
        withApply: false,
        withReset: false,
    },
    disabledDays: {},
    apply: () => { },
    reset: () => { },
    dispatch: () => { },
});
function normalizeDate(date) {
    return typeof date === 'number'
        ? new Date(date).setHours(hoursInHalfDay, 0, 0, 0)
        : date.setHours(hoursInHalfDay, 0, 0, 0);
}
function prepareDisabledDaysRegistry(disabledDays) {
    return disabledDays.reduce((res, date) => (Object.assign(Object.assign({}, res), { [normalizeDate(date)]: true })), {});
}
function asTimestamps({ start, end, min, max }) {
    return Object.assign(Object.assign(Object.assign({}, (start && { start: start.getTime() })), (end && { end: end.getTime() })), { min: min.getTime(), max: max.getTime() });
}
function normalizeRange({ start, end, min, max }) {
    let raw = Object.assign(Object.assign({}, (start && { start: clamp$2(normalizeDate(start), min, max) })), (end && { end: clamp$2(normalizeDate(end), min, max) }));
    if (Number.isFinite(raw.start) && Number.isFinite(raw.end) && end < start) {
        raw = {
            start: raw.end,
            end: raw.start,
        };
    }
    return raw;
}
function normalizeLimits({ min, max }) {
    return {
        min: normalizeDate(min),
        max: normalizeDate(max),
    };
}
function getDecade(date) {
    const normalised = new Date(date);
    return Math.floor(normalised.getFullYear() / 10) * 10;
}
function splitUnits(array, n) {
    const [...arr] = array;
    const res = [];
    while (arr.length) {
        res.push(arr.splice(0, n));
    }
    return res;
}

const fractions = ['month', 'year', 'decade'];
const dataAttrs = {
    prev: { 'data-clndr-prev': '' },
    fraction: { 'data-clndr-fraction': '' },
    next: { 'data-clndr-next': '' },
};
const Fraction = () => {
    const _a = React.useContext(context$4), _b = _a.state, { fraction, current, units } = _b, state = __rest(_b, ["fraction", "current", "units"]), { dispatch } = _a;
    const title = React.useMemo(() => {
        let res;
        if (fraction === 'month') {
            res = formatDate(current, 'MMMMY');
        }
        if (fraction === 'year') {
            res = formatDate(current, 'Y');
        }
        if (fraction === 'decade') {
            res = `${new Date(units[1].timestamp).getFullYear()}–${new Date(units[10].timestamp).getFullYear()}`;
        }
        return res;
    }, [fraction, current, units.length]);
    const disabled = React.useMemo(() => {
        const result = { prev: false, next: false, title: false };
        if (fraction === 'decade') {
            result.prev = getDecade(current) === getDecade(state.min);
            result.next = getDecade(current) === getDecade(state.max);
            result.title = getDecade(state.min) === getDecade(state.max) && result.prev && result.next;
        }
        else {
            result.prev = isDateSame(current, state.min, fraction);
            result.next = isDateSame(current, state.max, fraction);
            result.title = isDateSame(state.min, state.max, fraction) && result.prev && result.next;
        }
        return result;
    }, [fraction, state.max, state.min, current]);
    const handleArrowClick = React.useCallback((sign) => () => {
        dispatch({
            type: 'set_current',
            payload: fraction === 'decade' ? addToDate(current, sign * 10, 'year') : addToDate(current, sign, fraction),
        });
    }, [current, fraction, dispatch]);
    const handleFractionClick = React.useCallback(() => {
        dispatch({ type: `set_fraction`, payload: fractions[fractions.indexOf(fraction) + 1] });
    }, [fraction, dispatch]);
    return (React.createElement("div", { className: s$l.fraction },
        React.createElement(Button$3, { variant: "transparent", size: "s", icon: "chevron-left", onClick: handleArrowClick(-1), disabled: disabled.prev, dataAttrs: dataAttrs.prev }),
        (fraction === 'decade' || disabled.title) && React.createElement("span", { className: s$l.current }, title),
        fraction !== 'decade' && !disabled.title && (React.createElement(Button$3, { variant: "transparent", size: "s", onClick: handleFractionClick, dataAttrs: dataAttrs.fraction },
            React.createElement("span", { className: s$l.current }, title))),
        React.createElement(Button$3, { variant: "transparent", size: "s", icon: "chevron-right", onClick: handleArrowClick(1), disabled: disabled.next, dataAttrs: dataAttrs.next })));
};
var Fraction$1 = Fraction;

var css_248z$14 = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.grid-module_week__PMtGi{color:rgba(105,99,131,.6);display:flex;font:400 14px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;font-weight:500;padding:8px 0;text-align:center}.grid-module_week__PMtGi>*{cursor:default;flex:1 1}.grid-module_weekend__8l4SQ{color:#3416b6}.grid-module_units__TQ0xr{font:400 16px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.grid-module_unit__VmdSy{align-items:center;border-radius:2px;box-sizing:border-box;cursor:pointer;display:inline-flex;justify-content:center;text-transform:capitalize}.grid-module_unit__VmdSy.grid-module_square__qqrqT{height:40px;width:40px}.grid-module_unit__VmdSy.grid-module_rect__-fsg1{height:40px;width:70px}.grid-module_today__GGan1{border:1px solid #3416b6}.grid-module_end__de96A,.grid-module_start__DJTAv{background-color:#3416b6;color:#fff}.grid-module_start__DJTAv.grid-module_first__r5Fe-{border-bottom-right-radius:0;border-top-right-radius:0}.grid-module_range__KWJPi{background-color:rgba(150,142,190,.2);border-radius:0;border-radius:initial}.grid-module_range__KWJPi+.grid-module_end__de96A,.grid-module_start__DJTAv+.grid-module_end__de96A{border-bottom-left-radius:0;border-top-left-radius:0}.grid-module_outside__mwDCN:not(.grid-module_start__DJTAv):not(.grid-module_end__de96A):not(.grid-module_disabled__HIjsB){color:rgba(73,68,95,.8)}.grid-module_disabled__HIjsB{color:rgba(105,99,131,.6);pointer-events:none}.grid-module_unit__VmdSy:hover:not(.grid-module_disabled__HIjsB){background-color:rgba(150,142,190,.2)}.grid-module_unit__VmdSy.grid-module_end__de96A:hover,.grid-module_unit__VmdSy.grid-module_start__DJTAv:hover{background-color:#271188}.grid-module_unit__VmdSy.grid-module_range__KWJPi:hover{background-color:rgba(127,120,161,.4)}.grid-module_action__7VO9R{margin-top:16px}";
var s$k = {"week":"grid-module_week__PMtGi","weekend":"grid-module_weekend__8l4SQ","units":"grid-module_units__TQ0xr","unit":"grid-module_unit__VmdSy","square":"grid-module_square__qqrqT","rect":"grid-module_rect__-fsg1","today":"grid-module_today__GGan1","start":"grid-module_start__DJTAv","end":"grid-module_end__de96A","first":"grid-module_first__r5Fe-","range":"grid-module_range__KWJPi","outside":"grid-module_outside__mwDCN","disabled":"grid-module_disabled__HIjsB","action":"grid-module_action__7VO9R"};
styleInject(css_248z$14);

const monthsSplit = 7;
const yearDecadeSplit = 4;
const Weekdays = () => (React.createElement("div", { className: s$k.week },
    React.createElement("span", null, "\u041F\u043D"),
    React.createElement("span", null, "\u0412\u0442"),
    React.createElement("span", null, "\u0421\u0440"),
    React.createElement("span", null, "\u0427\u0442"),
    React.createElement("span", null, "\u041F\u0442"),
    React.createElement("span", { className: s$k.weekend }, "\u0421\u0431"),
    React.createElement("span", { className: s$k.weekend }, "\u0412\u0441")));
const Grid = () => {
    const { state: { fraction, units, mode, start, end, withApply, withReset }, dispatch, disabledDays, apply, reset, } = React.useContext(context$4);
    const handleDayClick = React.useCallback(event => {
        const value = parseInt(event.target.dataset.timestamp);
        const hasStart = Number.isInteger(start);
        const hasEnd = Number.isInteger(end);
        const hasRangeAlready = mode === 'range' && hasStart && hasEnd;
        const hasOnlyStart = mode === 'range' && hasStart && !hasEnd;
        const empty = !hasStart && !hasEnd;
        if (mode === 'single') {
            dispatch({ type: 'set_range', payload: { start: value } });
            if (!withApply) {
                apply({ start: value });
            }
        }
        if (hasRangeAlready || empty) {
            dispatch({ type: 'set_range', payload: { start: value } });
        }
        if (hasOnlyStart) {
            dispatch({ type: 'set_range', payload: { start, end: value } });
            if (!withApply) {
                apply({ start, end: value });
            }
        }
    }, [dispatch, mode, start, end, withApply, apply]);
    const handleApplyClick = React.useCallback(() => apply({ start, end }), [apply, start, end]);
    const handleResetClick = React.useCallback(() => {
        dispatch({ type: 'set_range', payload: { start: undefined, end: undefined } });
        reset();
    }, [reset, dispatch]);
    const handleMonthClick = React.useCallback(event => {
        dispatch({
            type: 'set_fraction_by_timestamp',
            payload: { current: parseInt(event.target.dataset.timestamp), fraction: 'month' },
        });
    }, [dispatch]);
    const handleYearClick = React.useCallback(event => {
        dispatch({
            type: 'set_fraction_by_timestamp',
            payload: { current: parseInt(event.target.dataset.timestamp), fraction: 'year' },
        });
    }, [dispatch]);
    const handlers = {
        month: handleDayClick,
        year: handleMonthClick,
        decade: handleYearClick,
    };
    const disabledCondition = !Number.isFinite(start) || (mode === 'range' && !Number.isFinite(end));
    return (React.createElement(React.Fragment, null,
        fraction === 'month' && React.createElement(Weekdays, null),
        splitUnits(units, fraction === 'month' ? monthsSplit : yearDecadeSplit).map((row, i) => row.map(({ text, today, outOfCurrent, disabled, weekend, startOfRange, endOfRange, range, timestamp }, k) => (React.createElement("span", { key: `${i}-${k}`, className: cn(s$k.unit, today && s$k.today, fraction === 'month' && s$k.square, (fraction === 'year' || fraction === 'decade') && s$k.rect, startOfRange && Number.isFinite(end) && s$k.first, outOfCurrent && s$k.outside, (disabled || (fraction === 'month' && disabledDays[timestamp])) && s$k.disabled, weekend && s$k.weekend, startOfRange && s$k.start, endOfRange && s$k.end, range && s$k.range), onClick: handlers[fraction], "data-timestamp": timestamp }, text)))),
        withApply && (React.createElement("div", { className: s$k.action },
            React.createElement(Button$3, { block: true, size: "m", onClick: handleApplyClick, disabled: disabledCondition }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C"))),
        withReset && (React.createElement("div", { className: s$k.action },
            React.createElement(Button$3, { block: true, size: "m", onClick: handleResetClick, disabled: disabledCondition }, "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C")))));
};
var Grid$1 = Grid;

const cells = {
    month: 42,
    year: 12,
};
const timestampGenerators = {
    month: current => {
        const date = startOfDate(current, 'month');
        const days = getDaysInMonth(date);
        const preShift = (new Date(date).getDay() + daysInWeek - 1) % daysInWeek;
        const postShift = (cells.month - days - preShift) % daysInWeek;
        return [
            ...[...Array(preShift)].map((_, i) => normalizeDate(addToDate(date, -(preShift - i), 'day'))),
            ...[...Array(days)].map((_, i) => normalizeDate(addToDate(date, i, 'day'))),
            ...[...Array(postShift)].map((_, i) => normalizeDate(addToDate(date, days + i, 'day'))),
        ];
    },
    year: current => {
        const date = startOfDate(current, 'year');
        return [...Array(cells.year)].map((_, i) => normalizeDate(addToDate(date, i, 'month')));
    },
    decade: current => {
        const date = startOfDate(current, 'year');
        const decStart = getDecade(date) - 1;
        return [...Array(cells.year)].map((_, i) => normalizeDate(new Date(decStart + i, 0, 1).getTime()));
    },
};
const unitGenerators = {
    month: (timestamps, state) => {
        const today = Date.now();
        return timestamps.map(timestamp => {
            const date = new Date(timestamp);
            const day = date.getDate();
            const current = new Date(state.current);
            return {
                timestamp,
                weekend: [0, 6].includes(date.getDay()),
                text: String(day),
                outOfCurrent: !isDateSame(current, timestamp, 'month'),
                today: isDateSame(today, timestamp, 'day'),
                disabled: state.min > timestamp || timestamp > state.max,
                startOfRange: timestamp === state.start || (timestamp === state.end && !state.start),
                endOfRange: timestamp === state.end || (timestamp === state.start && !state.end),
                range: !!(state.start && state.end && state.start < timestamp && timestamp < state.end),
            };
        });
    },
    year: (timestamps, state) => {
        const today = Date.now();
        const min = new Date(state.min).getMonth();
        const max = new Date(state.max).getMonth();
        return timestamps.map(timestamp => {
            const date = new Date(timestamp);
            const month = date.getMonth();
            return {
                timestamp,
                text: formatDate(timestamp, 'MMM').replace('.', ''),
                today: isDateSame(today, timestamp, 'month'),
                disabled: (isDateSame(state.min, timestamp, 'year') && min > month) ||
                    (isDateSame(state.max, timestamp, 'year') && month > max),
                weekend: false,
                startOfRange: false,
                endOfRange: false,
                range: false,
                outOfCurrent: false,
            };
        });
    },
    decade: (timestamps, state) => {
        const today = new Date();
        const min = new Date(state.min).getFullYear();
        const max = new Date(state.max).getFullYear();
        return timestamps.map((timestamp, i) => {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            return {
                timestamp,
                text: String(year),
                today: year === today.getFullYear(),
                weekend: false,
                startOfRange: false,
                endOfRange: false,
                range: false,
                outOfCurrent: [0, 11].includes(i),
                disabled: min > year || year > max,
            };
        });
    },
};
function getUnitTimestamps(units) {
    return units.map(({ timestamp }) => timestamp);
}

function initState(state) {
    const { fraction } = state;
    const limits = normalizeLimits(state);
    const range = normalizeRange(Object.assign(Object.assign({}, state), limits));
    const current = range.start ? range.start : Date.now();
    const updated = Object.assign(Object.assign(Object.assign(Object.assign({}, state), limits), range), { current, fraction });
    const timestamps = timestampGenerators[fraction](current);
    const units = unitGenerators[fraction](timestamps, updated);
    return Object.assign(Object.assign({}, updated), { units });
}
const actionHandlers = {
    set_limits: (state, payload) => {
        const limits = normalizeLimits(payload);
        const timestamps = getUnitTimestamps(state.units);
        const updated = Object.assign(Object.assign({}, state), limits);
        const units = unitGenerators[state.fraction](timestamps, updated);
        return Object.assign(Object.assign({}, updated), { units });
    },
    set_range: (state, payload) => {
        const { min, max } = state;
        const range = normalizeRange(Object.assign(Object.assign({}, payload), { min, max }));
        const timestamps = getUnitTimestamps(state.units);
        delete state.start;
        delete state.end;
        const updated = Object.assign(Object.assign({}, state), range);
        const units = unitGenerators[state.fraction](timestamps, updated);
        return Object.assign(Object.assign({}, updated), { units });
    },
    set_current: (state, current) => {
        const timestamps = timestampGenerators[state.fraction](current);
        const updated = Object.assign(Object.assign({}, state), { current });
        const units = unitGenerators[state.fraction](timestamps, updated);
        return Object.assign(Object.assign({}, updated), { units });
    },
    set_fraction: (state, fraction) => {
        const timestamps = timestampGenerators[fraction](state.current);
        const updated = Object.assign(Object.assign({}, state), { fraction });
        const units = unitGenerators[fraction](timestamps, updated);
        return Object.assign(Object.assign({}, updated), { units });
    },
    set_fraction_by_timestamp: (state, payload) => {
        const current = startOfDate(payload.current, payload.fraction);
        const timestamps = timestampGenerators[payload.fraction](current);
        const updated = Object.assign(Object.assign({}, state), { fraction: payload.fraction, current: payload.current });
        const units = unitGenerators[payload.fraction](timestamps, updated);
        return Object.assign(Object.assign({}, updated), { units });
    },
};
const reducer$1 = (state, action) => {
    return actionHandlers[action.type](state, action.payload);
};

const maxDefault = new Date();
const Calendar = (_a) => {
    var { fraction = 'month', card = false, start, end, min = new Date(1900, 0, 1), max = maxDefault, withApply = false, withReset = false, onChange = () => { }, onReset = () => { }, dataTest, mode = 'range' } = _a, rest = __rest(_a, ["fraction", "card", "start", "end", "min", "max", "withApply", "withReset", "onChange", "onReset", "dataTest", "mode"]);
    const timestamps = asTimestamps({ start, end, min, max });
    const [state, dispatch] = React.useReducer(reducer$1, initState(Object.assign(Object.assign({}, timestamps), { fraction, mode, withApply, withReset })));
    const apply = React.useCallback(({ start, end }) => {
        let result = {
            start: (start || end),
            end: (end || start),
        };
        if (result.start - result.end > 0) {
            result = { start: result.end, end: result.start };
        }
        onChange(startOfDate(new Date(result.start), 'day'), endOfDate(new Date(result.end), 'day'));
    }, [onChange]);
    const reset = React.useCallback(() => {
        onReset();
    }, [onReset]);
    const contextValue = React.useMemo(() => ({
        state,
        dispatch,
        apply,
        reset,
        disabledDays: mode === 'single'
            ? prepareDisabledDaysRegistry(rest.disabledDates || [])
            : {},
    }), [state, apply, reset, mode, rest]);
    React.useEffect(() => {
        dispatch({ type: 'set_range', payload: timestamps });
    }, [timestamps.start, timestamps.end]);
    React.useEffect(() => {
        dispatch({ type: 'set_limits', payload: timestamps });
    }, [timestamps.min, timestamps.max]);
    return (React.createElement("div", { className: cn(s$l.box, card && s$l.card), "data-test": dataTest },
        React.createElement(context$4.Provider, { value: contextValue },
            React.createElement(Fraction$1, null),
            React.createElement(Grid$1, null))));
};
var Calendar$1 = Calendar;

const context$3 = React.createContext({
    opened: false,
    control: void 0,
    state: 'init',
    toggle: () => { },
    registerControl: () => { },
    content: { current: null },
    registerContent: () => { },
});
function useDropdown() {
    return React.useContext(context$3);
}

function useKeyPress(keys = [], onKeyPress) {
    React.useEffect(() => {
        if (!onKeyPress) {
            return;
        }
        const handleKeyDown = event => {
            const { keyCode } = event;
            if (keys.includes(keyCode)) {
                onKeyPress(event);
            }
        };
        const off = addEventListener('keydown', handleKeyDown);
        return () => off === null || off === void 0 ? void 0 : off();
    }, [keys, onKeyPress]);
}

var css_248z$13 = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.dropdown-module_root__BlnP9{left:0;position:absolute;right:0;top:0;z-index:102}.dropdown-module_content__7TLsK{background-color:#fff;border-radius:4px;box-shadow:0 4px 16px rgba(33,31,46,.12);display:inline-block;position:absolute;transition:.24s cubic-bezier(.24,.1,.24,1);transition-property:visibility,opacity}.dropdown-module_content__7TLsK.dropdown-module_local__ueih-{z-index:102}.dropdown-module_content__7TLsK.dropdown-module_flex__nkYIj{display:inline-flex;flex-direction:column}.dropdown-module_content__7TLsK.dropdown-module_padding__lbntp{padding:16px}.dropdown-module_content__7TLsK.dropdown-module_visible__2oIyt{opacity:1;visibility:visible}.dropdown-module_content__7TLsK,.dropdown-module_content__7TLsK.dropdown-module_hideable__U3Ggp[data-popper-reference-hidden]{opacity:0;visibility:hidden}.dropdown-module_control__YZvyT{align-items:center;cursor:pointer;display:inline-flex}.dropdown-module_control__YZvyT.dropdown-module_s__8oGvH{font:400 14px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.dropdown-module_control__YZvyT.dropdown-module_m__PZ-Ro{font:400 16px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.dropdown-module_control__YZvyT.dropdown-module_block__oJd6r{display:flex;justify-content:space-between}.dropdown-module_control__YZvyT.dropdown-module_disabled__vA9in{cursor:not-allowed}.dropdown-module_arrow__FFbIX{line-height:16px;margin-left:4px;transition:transform .24s cubic-bezier(.24,.1,.24,1)}.dropdown-module_arrow__FFbIX.dropdown-module_opened__Ugn8q{transform:rotate(-180deg)}.dropdown-module_icon__aOMfB{background:none;border:none;color:inherit;cursor:pointer;font-size:16px;line-height:16px;margin:0;outline:none;padding:0}.dropdown-module_icon__aOMfB.dropdown-module_disabled__vA9in{color:rgba(105,99,131,.6);cursor:not-allowed}.dropdown-module_icon__aOMfB.dropdown-module_xs__D1PJ4{height:12px;line-height:12px}.dropdown-module_icon__aOMfB.dropdown-module_s__8oGvH{height:16px;line-height:16px}.dropdown-module_icon__aOMfB.dropdown-module_m__PZ-Ro{height:24px;line-height:24px}.dropdown-module_icon__aOMfB.dropdown-module_l__nuTZ2{height:32px;line-height:32px}";
var s$j = {"root":"dropdown-module_root__BlnP9","content":"dropdown-module_content__7TLsK","local":"dropdown-module_local__ueih-","flex":"dropdown-module_flex__nkYIj","padding":"dropdown-module_padding__lbntp","visible":"dropdown-module_visible__2oIyt","hideable":"dropdown-module_hideable__U3Ggp","control":"dropdown-module_control__YZvyT","s":"dropdown-module_s__8oGvH","m":"dropdown-module_m__PZ-Ro","block":"dropdown-module_block__oJd6r","disabled":"dropdown-module_disabled__vA9in","arrow":"dropdown-module_arrow__FFbIX","opened":"dropdown-module_opened__Ugn8q","icon":"dropdown-module_icon__aOMfB","xs":"dropdown-module_xs__D1PJ4","l":"dropdown-module_l__nuTZ2"};
styleInject(css_248z$13);

var keyCodes = {
    tab: 9,
    enter: 13,
    escape: 27,
    space: 32,
    up: 38,
    down: 40,
};

const padding$1 = 8;
const paddings = padding$1 * 2;
const offset$1 = {
    name: 'offset',
    options: {
        offset: [0, padding$1],
    },
};
const overflow = (container) => ({
    name: 'preventOverflow',
    options: {
        boundary: container,
    },
});
const noflip = { name: 'flip', enabled: false };
const dimensions = (container) => ({
    name: 'calculateDimensions',
    enabled: true,
    phase: 'beforeRead',
    fn({ state }) {
        const controlEl = state.elements.reference;
        const contentEl = state.elements.popper;
        const containerIsBody = container === document.body;
        const box = containerIsBody ? getWindowSize() : getElementSize(container);
        const origin = getElementSize(document.body);
        const control = getElementSize(controlEl);
        const content = getElementSize(contentEl);
        const cbottom = control.bottom - origin.top;
        const ctop = control.top - origin.top;
        const ymax = box.bottom - origin.top;
        const ymin = box.top - origin.top;
        const result = state.modifiersData.dimensions || {};
        result.cbottom = cbottom;
        result.ctop = ctop;
        result.ymin = ymin;
        result.ymax = ymax;
        result.contentHeight = result.contentHeight || content.height;
        state.modifiersData.dimensions = result;
    },
});
const fit = {
    name: 'calculateFit',
    enabled: true,
    phase: 'beforeRead',
    requires: ['calculateDimensions'],
    fn({ state }) {
        const { ctop, ymin, cbottom, contentHeight, ymax } = state.modifiersData.dimensions;
        const up = ctop - paddings - contentHeight >= ymin;
        const down = cbottom + paddings + contentHeight <= ymax;
        const availableTopSpace = ctop - ymin;
        const availableBottomSpace = ymax - cbottom;
        const result = state.modifiersData.fit || { availableSpaces: {} };
        const adaptivePlacement = !!state.modifiersData.adpApplyDirection;
        let initial = 'none';
        if (up) {
            initial = 'top';
        }
        if (down) {
            initial = 'bottom';
        }
        result.initial = initial;
        result.adjusted = !adaptivePlacement || availableBottomSpace >= availableTopSpace ? 'bottom' : 'top';
        result.availableSpaces.top = availableTopSpace - paddings;
        result.availableSpaces.bottom = availableBottomSpace - paddings;
        state.modifiersData.fit = result;
    },
};
const adpApplyDirection = (container, positioning) => ({
    name: 'adpApplyDirection',
    enabled: true,
    phase: 'beforeRead',
    requires: ['calculateFit'],
    fn({ state }) {
        const box = container ? getElementSize(container) : getWindowSize();
        const origin = getElementSize(document.body);
        const control = getElementSize(state.elements.reference);
        const content = getElementSize(state.elements.popper);
        const cbottom = control.bottom - origin.top;
        const ymax = box.bottom - origin.top;
        const down = cbottom + padding$1 + content.height <= ymax;
        const placement = down ? 'bottom' : 'top';
        state.placement = `${placement}-${positioning}`;
    },
});
const adhApplyDirection = (positioning) => ({
    name: 'adhApplyDirection',
    enabled: true,
    phase: 'beforeRead',
    requires: ['calculateFit'],
    fn({ state }) {
        const { initial, adjusted } = state.modifiersData.fit;
        if (initial !== 'none') {
            return;
        }
        state.placement = `${adjusted}-${positioning}`;
    },
});
const applyHeight = {
    name: 'applyHeight',
    enabled: true,
    phase: 'write',
    fn({ state }) {
        var _a;
        const { initial, adjusted, availableSpaces } = state.modifiersData.fit;
        const adaptivePlacement = !!state.modifiersData.adpApplyDirection;
        const content = state.elements.popper;
        const customHeightLimit = (_a = content.dataset) === null || _a === void 0 ? void 0 : _a.height;
        if (initial === 'none' || !adaptivePlacement) {
            content.style.maxHeight = availableSpaces[adjusted] + 'px';
        }
        else if (initial !== 'none' && customHeightLimit) {
            content.style.maxHeight = customHeightLimit + 'px';
        }
    },
};
const silent = [offset$1, { name: 'eventListeners', enabled: false }, { name: 'computeStyles', enabled: false }];

const keys$8 = [keyCodes.escape, keyCodes.tab];
const IGNORE_GROUP_CONTEXT = { present: false };
const Launchpad = ({ root, children }) => {
    return root ? ReactDOM.createPortal(children, root) : children;
};
const Content$5 = ({ container = { current: null }, bounds = false, adjustable = true, padding = true, adaptivePlacement = true, adaptiveHeight = true, hideOnOverflow = true, flex = false, children, height, positioning = 'start', placement = 'body', dataTest: externalDataTest, }) => {
    const content = React.useRef(null);
    const { opened, control, toggle, state, registerContent, dataTest: contextDataTest } = React.useContext(context$3);
    const root = useDOMRoot$1({ anchor: 'dropdown-launchpad', style: s$j.root });
    const popper = React.useRef(null);
    const [width, setWidth] = React.useState((control === null || control === void 0 ? void 0 : control.offsetWidth) || 0);
    useOnClickOutside([content], event => {
        if (!control) {
            return;
        }
        if (opened && !containsNode(control, event.target)) {
            toggle();
        }
    });
    useKeyPress(keys$8, () => {
        if (opened) {
            toggle();
        }
    });
    React.useEffect(() => {
        registerContent(content);
    }, [registerContent]);
    React.useEffect(() => {
        var _a;
        if (!opened || !control || state !== 'show') {
            return;
        }
        const boundary = container.current || document.body;
        const modifiers = [offset$1, overflow(boundary)];
        if (adaptivePlacement || adaptiveHeight) {
            modifiers.push(dimensions(boundary), fit);
        }
        if (!adaptivePlacement) {
            modifiers.push(noflip);
        }
        if (adaptivePlacement) {
            modifiers.push(adpApplyDirection(container.current, positioning));
        }
        if (adaptiveHeight) {
            modifiers.push(adhApplyDirection(positioning), applyHeight);
        }
        if (popper.current) {
            (_a = popper.current) === null || _a === void 0 ? void 0 : _a.destroy();
        }
        popper.current = createPopper$1(control, content.current, {
            placement: `bottom-${positioning}`,
            modifiers,
        });
    }, [opened, control, container, state, adaptivePlacement, adaptiveHeight, positioning]);
    React.useEffect(() => {
        var _a;
        if (opened) {
            return;
        }
        (_a = popper.current) === null || _a === void 0 ? void 0 : _a.setOptions({ modifiers: [...silent] });
    }, [opened]);
    React.useEffect(() => {
        if (!control) {
            return;
        }
        setWidth(control.offsetWidth);
        const observer = new MutationObserver(() => setWidth(control.offsetWidth));
        observer.observe(control, { childList: true, subtree: true, characterData: true });
        return () => {
            observer.disconnect();
        };
    }, [control]);
    if (!control || state === 'init' || state === 'idle') {
        return null;
    }
    return (React.createElement(Launchpad, { root: placement === 'body' ? root : null },
        React.createElement("div", { ref: content, style: Object.assign(Object.assign(Object.assign({}, (adjustable && { minWidth: width })), (bounds && { maxWidth: width })), (height && { maxHeight: height })), className: cn(s$j.content, flex && s$j.flex, padding && s$j.padding, hideOnOverflow && s$j.hideable, state === 'show' && s$j.visible, placement === 'local' && s$j.local), "data-height": height, "data-test": contextDataTest ? `${contextDataTest}-content` : externalDataTest },
            React.createElement(context$5.Provider, { value: IGNORE_GROUP_CONTEXT }, children))));
};
var Content$6 = Content$5;

const SimpleControl = ({ children, opened, refControl, size, dataTest, disabled = false, block = false, arrow = false, onToggle, }) => {
    const handleToggle = React.useCallback((event) => {
        if (disabled) {
            return;
        }
        if (onToggle) {
            onToggle(!opened, event);
        }
    }, [opened, onToggle, disabled]);
    return (React.createElement("div", { ref: refControl, onClick: handleToggle, onKeyPress: handleKeyPressEnter(handleToggle), role: "button", tabIndex: 0, className: cn(s$j.control, size && s$j[size], block && s$j.block, disabled && s$j.disabled), "data-test": dataTest },
        children,
        arrow && (React.createElement("div", { className: cn(s$j.arrow, opened && s$j.opened) },
            React.createElement(Icon$4, { name: "chevron-down", size: "s" })))));
};
var SimpleControl$1 = SimpleControl;

const Control$1 = (_a) => {
    var { onToggle } = _a, props = __rest(_a, ["onToggle"]);
    const { opened, toggle, registerControl, dataTest: contextDataTest } = React.useContext(context$3);
    const control = React.useRef(null);
    React.useEffect(() => {
        registerControl(control.current);
    }, [registerControl]);
    const handleToggle = React.useCallback((_opened, event) => {
        toggle();
        if (onToggle) {
            onToggle(!opened, event);
        }
    }, [opened, onToggle, toggle]);
    return (React.createElement(SimpleControl$1, Object.assign({}, props, { dataTest: contextDataTest ? `${contextDataTest}-control` : props.dataTest, refControl: control, onToggle: handleToggle, opened: opened })));
};
var Control$2 = Control$1;

const Icon$1 = (_a) => {
    var { disabled, dataTest, onToggle } = _a, iconProps = __rest(_a, ["disabled", "dataTest", "onToggle"]);
    const size = iconProps.size || 'm';
    return (React.createElement(Control$2, { disabled: disabled, onToggle: onToggle },
        React.createElement("button", { type: "button", "data-test": dataTest, className: cn(s$j.icon, disabled && s$j.disabled, s$j[size]) },
            React.createElement(Icon$4, Object.assign({}, iconProps)))));
};
var Icon$2 = Icon$1;

const closingTimeout$1 = 240;
const Dropdown = ({ children, onToggle, dataTest }) => {
    const [opened, setOpened] = React.useState(false);
    const [control, registerControl] = React.useState();
    const [content, registerContent] = React.useState({ current: null });
    const [state, close] = useTransitionState(opened, { duration: closingTimeout$1 });
    const toggle = React.useCallback((update) => __awaiter(void 0, void 0, void 0, function* () {
        const directCommand = typeof update === 'boolean';
        const nextState = directCommand ? update : !opened;
        if (!directCommand && opened && state === 'show') {
            yield close();
        }
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(nextState);
        setOpened(nextState);
    }), [opened, close, state, onToggle]);
    const contextValue = React.useMemo(() => ({ opened, state, toggle, control, content, registerContent, registerControl, dataTest }), [opened, state, toggle, control, content, registerContent, registerControl, dataTest]);
    return React.createElement(context$3.Provider, { value: contextValue }, children);
};
Dropdown.Content = Content$6;
Dropdown.Control = Control$2;
Dropdown.SimpleControl = SimpleControl$1;
Dropdown.Icon = Icon$2;

const Content$4 = (_a) => {
    var { placement, adaptivePlacement, container, adjustable } = _a, calendarProps = __rest(_a, ["placement", "adaptivePlacement", "container", "adjustable"]);
    const { toggle, opened } = useDropdown();
    const { onChange, onReset, start, end } = calendarProps;
    const [state, setState] = React.useState({ start, end });
    const timestamps = Object.assign(Object.assign({}, (start && { start: start.getTime() })), (end && { end: end.getTime() }));
    React.useEffect(() => {
        setState({ start, end });
    }, [timestamps.start, timestamps.end]);
    const handleChange = React.useCallback((start, end) => {
        setState({ start, end });
        if (opened) {
            toggle();
        }
        if (onChange) {
            onChange(start, end);
        }
    }, [onChange, opened, toggle]);
    const handleReset = React.useCallback(() => {
        if (opened) {
            toggle();
        }
        onReset === null || onReset === void 0 ? void 0 : onReset();
    }, [onReset, opened, toggle]);
    return (React.createElement(Dropdown.Content, { placement: placement, adaptivePlacement: adaptivePlacement, container: container, adjustable: adjustable },
        React.createElement(Calendar$1, Object.assign({}, calendarProps, { start: state.start, end: state.end, onChange: handleChange, onReset: handleReset }))));
};
const CalendarDropdown = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Dropdown, null,
        children,
        React.createElement(Content$4, Object.assign({ adjustable: false }, props))));
};
var CalendarDropdown$1 = CalendarDropdown;

const imaskConfig = {
    mask: Date,
    pattern: 'd{.}`m{.}`Y',
    blocks: {
        d: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 31,
            maxLength: 2,
        },
        m: {
            mask: IMask.MaskedRange,
            from: 1,
            to: 12,
            maxLength: 2,
        },
        Y: {
            mask: IMask.MaskedRange,
            from: 1900,
            to: 2999,
        },
    },
};
function parseDateFromStr(str) {
    if (!str) {
        return null;
    }
    const [day, month, year] = str.split('.').map((v) => parseInt(v));
    const validDate = !str.includes('_') &&
        !!(valid.day(day) && valid.month(month) && valid.year(year) && valid.daysInMonth(day, month - 1, year));
    if (!validDate) {
        return null;
    }
    return new Date(year, month - 1, day);
}
const valid = {
    day: (v) => v <= 31,
    month: (v) => v <= 12,
    year: (v) => v >= 1900,
    daysInMonth: (day, month, year) => {
        let max = 31;
        if (month === 1) {
            max = (year % 4 == 0 && year % 100) || year % 400 == 0 ? 29 : 28;
        }
        if ([3, 5, 8, 10].includes(month)) {
            max = 30;
        }
        return day <= max;
    },
};
const Control = (_a) => {
    var { value: externalValue, onChange, onTextChange, locale = 'ru-RU', label = 'Дата', readOnly = false, readonly = false, updateCalendar, onReset, onFocus } = _a, props = __rest(_a, ["value", "onChange", "onTextChange", "locale", "label", "readOnly", "readonly", "updateCalendar", "onReset", "onFocus"]);
    const intl = React.useMemo(() => new Intl.DateTimeFormat(locale), [locale]);
    const [value, setValue] = React.useState(externalValue ? intl.format(externalValue) : '');
    const wrapper = React.useRef(null);
    const { opened, toggle, registerControl } = useDropdown();
    const defaultPlaceholder = intl.format(new Date());
    const { placeholder = defaultPlaceholder } = props;
    readonly = readonly || readOnly;
    const closeCalendar = React.useCallback(() => {
        if (opened) {
            toggle();
        }
    }, [opened, toggle]);
    const handleReset = React.useCallback(e => {
        setValue('');
        if (onReset) {
            onReset(e);
        }
    }, [onReset]);
    React.useEffect(() => {
        setValue(externalValue ? intl.format(externalValue) : '');
    }, [externalValue, intl]);
    React.useEffect(() => {
        if (!wrapper.current) {
            return;
        }
        registerControl(wrapper.current);
    }, [registerControl, wrapper]);
    const handleChange = React.useCallback((value, event) => {
        const update = parseDateFromStr(value);
        if (onTextChange) {
            onTextChange({ date: update, text: value }, event);
        }
        if (!update) {
            return;
        }
        if (onChange) {
            onChange(update, event);
        }
        if (updateCalendar) {
            updateCalendar(update);
        }
    }, [onChange, onTextChange, updateCalendar]);
    const handleToggle = React.useCallback(() => !readonly && toggle(), [readonly, toggle]);
    const handleFocus = React.useCallback(event => {
        closeCalendar();
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    }, [closeCalendar, onFocus]);
    return (React.createElement(Input$1, Object.assign({}, props, { imask: imaskConfig, onFocus: handleFocus, label: label, value: value, onReset: handleReset, onChange: handleChange, placeholder: placeholder, readonly: readonly, containerRef: wrapper }),
        React.createElement(Icon$3, { placement: "end", name: "calendar", onClick: handleToggle, pointer: !readonly, dataTest: "calendar-icon" })));
};
const DateInput = (_a) => {
    var { value: externalValue, calendarProps = {
        min: new Date(1900, 0, 1),
        max: new Date(2999, 11, 31),
    } } = _a, inputProps = __rest(_a, ["value", "calendarProps"]);
    const [value, setValue] = React.useState(externalValue);
    const { onChange } = inputProps;
    React.useEffect(() => {
        setValue(externalValue);
    }, [externalValue]);
    const handleChange = React.useCallback(start => {
        setValue(start);
        if (onChange) {
            onChange(start, {});
        }
    }, [onChange]);
    return (React.createElement(CalendarDropdown$1, Object.assign({ mode: "single" }, calendarProps, { start: value, onChange: handleChange }),
        React.createElement(Control, Object.assign({ updateCalendar: setValue }, inputProps, { value: value }))));
};
DateInput.Content = Content$8;
DateInput.Icon = Icon$3;
var DateInput$1 = DateInput;

var css_248z$12 = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.button-module_button__x6Kmx{align-items:center;background:none;border:none;border:1px solid rgba(127,120,161,.4);box-sizing:border-box;color:#211f2e;cursor:pointer;display:inline-flex;font:400 16px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;outline:none;padding:0;position:relative;text-align:left;-webkit-text-decoration:none;text-decoration:none;touch-action:manipulation;transition:border-color .24s cubic-bezier(.24,.1,.24,1)}.button-module_button__x6Kmx.button-module_primary__48qJg{background-color:#fff}.button-module_button__x6Kmx.button-module_light__afXmo{background-color:#f8f8fc}.button-module_button__x6Kmx.button-module_rounded-left__xQ5Sk{border-bottom-left-radius:4px;border-top-left-radius:4px}.button-module_button__x6Kmx.button-module_rounded-right__YYsvM{border-bottom-right-radius:4px;border-top-right-radius:4px}.button-module_wrapper__A5vE9{display:inline-flex;flex-direction:column}.button-module_wrapper__A5vE9.button-module_block__FhShd{display:flex;width:100%}.button-module_wrapper__A5vE9.button-module_spaced__dZapo{margin-bottom:16px}.button-module_wrapper__A5vE9.button-module_group__7aZXN{margin-left:-1px}.button-module_button__x6Kmx:disabled{cursor:not-allowed}.button-module_button__x6Kmx.button-module_readonly__-7N-A,.button-module_button__x6Kmx:disabled{background-color:rgba(150,142,190,.2);border-color:rgba(127,120,161,.4)}.button-module_button__x6Kmx.button-module_readonly__-7N-A{cursor:auto}.button-module_button__x6Kmx:disabled>.button-module_content__Id1YK{color:rgba(105,99,131,.6)}.button-module_button__x6Kmx.button-module_readonly__-7N-A>.button-module_content__Id1YK{color:#211f2e}.button-module_labeled__rXSb8{margin-top:24px}.button-module_block__FhShd{display:flex;width:100%}.button-module_white__uix73{background-color:#fff}.button-module_selected__eUVin{background-color:rgba(127,120,161,.4);border-color:#3416b6}.button-module_error__k0wrx{border-color:#f44434}.button-module_button__x6Kmx:not(.button-module_selected__eUVin):not(.button-module_error__k0wrx):not(:disabled):hover{border-color:rgba(115,108,147,.5);z-index:1}.button-module_button__x6Kmx:not(.button-module_selected__eUVin):not(.button-module_error__k0wrx):not(:disabled):focus{border-color:#3416b6;z-index:2}.button-module_l__ERESS{padding:7px 12px 7px 16px}.button-module_m__Gv3CA{padding:13px 12px 13px 16px}.button-module_s__GFXi9{padding:7px 12px 7px 16px}.button-module_xs__QTGvi{padding:3px 12px 3px 16px}.button-module_content__Id1YK{flex:1 1;margin-right:8px;min-width:0;white-space:nowrap}.button-module_content__Id1YK,.button-module_content__Id1YK .button-module_value__YuerQ{overflow:hidden;text-overflow:ellipsis}.button-module_labeled__rXSb8>.button-module_label__N0rq9{color:rgba(73,68,95,.8);font:400 14px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;left:0;overflow:hidden;position:absolute;right:0;text-overflow:ellipsis;top:-24px;white-space:nowrap}.button-module_label__N0rq9,.button-module_value__YuerQ{transition:.24s cubic-bezier(.24,.1,.24,1)}.button-module_label__N0rq9{transition-property:top,font-size,color}.button-module_hint__xTWkB{font:400 12px/16px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;margin-top:4px;transition:color .24s cubic-bezier(.24,.1,.24,1)}.button-module_hint__xTWkB.button-module_error__k0wrx{color:#f44434}.button-module_hint__xTWkB.button-module_warning__-URPC{color:#fac32e}.button-module_value__YuerQ{transition-property:color}.button-module_l__ERESS>.button-module_content__Id1YK{display:flex;flex-direction:column;height:44px;justify-content:flex-end;position:relative}.button-module_l__ERESS>.button-module_content__Id1YK.button-module_single__GbSol{justify-content:center}.button-module_l__ERESS>.button-module_content__Id1YK>.button-module_label__N0rq9{max-width:100%;position:absolute;top:10px}.button-module_l__ERESS>.button-module_content__Id1YK>.button-module_label__N0rq9.button-module_floating__nx2sZ{color:rgba(73,68,95,.8);font:400 12px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;top:0}.button-module_placeholder__3jtDv{color:rgba(105,99,131,.6);transition:none}.button-module_icon__P8Ko7{align-items:center;display:flex;height:24px;justify-content:center;width:24px}.button-module_arrow__TUe0g{transition:transform .24s cubic-bezier(.24,.1,.24,1)}.button-module_info__NQVR-{color:rgba(115,108,147,.5);transition:color .24s cubic-bezier(.24,.1,.24,1)}.button-module_info__NQVR-:hover{color:#211f2e}.button-module_arrow__TUe0g.button-module_opened__dUqLr{transform:rotate(-180deg)}.button-module_icon__P8Ko7+.button-module_icon__P8Ko7{margin-left:8px}.button-module_success__Q6p16>.button-module_icon__P8Ko7.button-module_status__eh1oM{color:#87d232}.button-module_error__k0wrx>.button-module_icon__P8Ko7.button-module_status__eh1oM{color:#f44434}.button-module_warning__-URPC>.button-module_icon__P8Ko7.button-module_status__eh1oM{color:#fac32e}.button-module_native__JmXlV{bottom:0;left:0;opacity:0;position:absolute;top:0;width:100%}.button-module_native__JmXlV:focus{left:10px}.button-module_star__LYYLQ{color:#f44434;display:inline-block;margin-left:4px}.button-module_star__LYYLQ.button-module_sticky__jSyQA{position:sticky;right:0}";
var styles$l = {"button":"button-module_button__x6Kmx","primary":"button-module_primary__48qJg","light":"button-module_light__afXmo","rounded-left":"button-module_rounded-left__xQ5Sk","rounded-right":"button-module_rounded-right__YYsvM","wrapper":"button-module_wrapper__A5vE9","block":"button-module_block__FhShd","spaced":"button-module_spaced__dZapo","group":"button-module_group__7aZXN","readonly":"button-module_readonly__-7N-A","content":"button-module_content__Id1YK","labeled":"button-module_labeled__rXSb8","white":"button-module_white__uix73","selected":"button-module_selected__eUVin","error":"button-module_error__k0wrx","l":"button-module_l__ERESS","m":"button-module_m__Gv3CA","s":"button-module_s__GFXi9","xs":"button-module_xs__QTGvi","value":"button-module_value__YuerQ","label":"button-module_label__N0rq9","hint":"button-module_hint__xTWkB","warning":"button-module_warning__-URPC","single":"button-module_single__GbSol","floating":"button-module_floating__nx2sZ","placeholder":"button-module_placeholder__3jtDv","icon":"button-module_icon__P8Ko7","arrow":"button-module_arrow__TUe0g","info":"button-module_info__NQVR-","opened":"button-module_opened__dUqLr","success":"button-module_success__Q6p16","status":"button-module_status__eh1oM","native":"button-module_native__JmXlV","star":"button-module_star__LYYLQ","sticky":"button-module_sticky__jSyQA"};
styleInject(css_248z$12);

const context$2 = React.createContext({
    select: void 0,
    info: {},
    mode: 'single',
    dataTest: void 0,
    native: false,
    nativeValue: null,
    onChange: () => { },
    registerInfoControl: () => { },
    registerSearchInput: () => { },
    registerSelect: () => { },
    search: {},
    setNativeValue: () => { },
    showInfo: () => { },
    showSearch: () => { },
});
function useSelectedText(values = [], texts = []) {
    const textMap = React.useMemo(() => (texts || []).reduce((res, { value, text }) => {
        res.set(value, text);
        return res;
    }, new Map()), [texts]);
    const selectedText = React.useMemo(() => [...textMap.keys()]
        .reduce((res, value) => (values.includes(value) ? [...res, textMap.get(value)] : res), [])
        .join(', '), [textMap, values]);
    return selectedText;
}
function useSelect(onChange, { selected, texts, } = {}) {
    const [value, setValue] = React.useState(selected);
    const handleChange = React.useCallback((value, _, evt) => {
        setValue(value);
        onChange(value, evt);
    }, [onChange]);
    React.useEffect(() => {
        setValue(selected);
    }, [selected]);
    const is = React.useCallback((check) => value === check, [value]);
    const selectedText = useSelectedText(typeof value !== 'undefined' ? [value] : [], texts);
    return {
        is,
        handleChange,
        selectedText,
    };
}
function convertToValuesMap(values) {
    const result = new Map();
    values.forEach(item => result.set(item, true));
    return result;
}
function useMultipleSelect(onChange, { selected = [], texts = [], } = {}) {
    const [values, setValue] = React.useState(convertToValuesMap(selected));
    const selectedText = useSelectedText([...values.keys()].filter(k => values.get(k)), texts);
    React.useEffect(() => {
        setValue(convertToValuesMap(selected));
    }, [JSON.stringify(selected)]);
    const handleChange = React.useCallback((value, checked, evt) => setValue(prev => {
        const update = new Map(prev).set(value, checked);
        onChange([...update.keys()].filter(k => update.get(k)), evt);
        return update;
    }), [onChange]);
    const is = React.useCallback((value) => !!values.get(value), [values]);
    return {
        is,
        handleChange,
        selectedText,
    };
}
function useNativeSelect() {
    const select = React.useRef(null);
    const { registerSelect, onChange, native, nativeValue } = React.useContext(context$2);
    const handleChange = React.useCallback(event => {
        const int = 'int' in event.target.options[event.target.selectedIndex].dataset;
        if (onChange) {
            onChange(int ? parseFloat(event.target.value) : event.target.value, true, event);
        }
    }, [onChange]);
    React.useEffect(() => {
        if (!native || !select.current) {
            return;
        }
        registerSelect(select.current);
    }, [native, registerSelect]);
    React.useEffect(() => {
        if (!select.current || !native || !nativeValue) {
            return;
        }
        select.current.value = nativeValue;
    }, [native, nativeValue]);
    return {
        select,
        native,
        handleChange,
        style: styles$l.native,
    };
}
function useSelectCustomControl() {
    const { toggle, registerControl, opened, content } = useDropdown();
    const control = React.useRef(null);
    React.useEffect(() => {
        if (!control.current) {
            return;
        }
        registerControl(control.current);
    }, [registerControl]);
    return {
        toggle,
        control,
        content,
        opened,
    };
}

const s$i = normalizeCSSModules(styles$l);
const getIconName = (success, error, warning) => {
    if (success) {
        return 'check-circle';
    }
    if (error) {
        return 'exclamation-circle';
    }
    if (warning) {
        return 'exclamation-triangle';
    }
    return;
};
const SimpleButton = ({ children, opened, controlRef, infoRef, native, info, nativeSelectRef, nativeHandleChange, block = true, background = 'primary', dataTest, disabled = false, empty = false, error = false, label = '', onToggle, onBlur, readonly = false, selected = false, size: externalSize = 'm', success = false, warning = false, valid = false, name, hint, spaced, required = false, }) => {
    const group = useGroup();
    const size = (group.present && group.size) || externalSize;
    success = success || valid;
    const iconName = getIconName(success, error, warning);
    const handleToggle = React.useCallback((event) => {
        if (disabled) {
            return;
        }
        if (onToggle) {
            onToggle(!opened, event);
        }
    }, [opened, onToggle, disabled]);
    return (React.createElement("div", { className: cn(s$i.wrapper, block && s$i.block, spaced && s$i.spaced, group.present && !group.first && s$i.group), style: Object.assign(Object.assign({}, (group.present && { flex: group.width })), (group.present && { maxWidth: group.maxWidth })) },
        React.createElement("button", { className: cn(s$i.button, s$i[size], s$i[background], block && s$i.block, success && s$i.success, warning && s$i.warning, error && s$i.error, selected && s$i.selected, label && size !== 'l' && s$i.labeled, readonly && s$i.readonly, (!group.present || (group.present && group.first)) && s$i.roundedLeft, (!group.present || (group.present && group.last)) && s$i.roundedRight), "data-test": dataTest, disabled: disabled || readonly, ref: controlRef, onClick: handleToggle, onKeyPress: handleKeyPressEnter(handleToggle), type: "button", name: name, onBlur: onBlur },
            size === 'l' && (React.createElement("div", { className: cn(s$i.content, (!label || !children) && s$i.single) },
                label && (React.createElement("div", { className: cn(s$i.label, {
                        [s$i.floating]: children,
                        [s$i.placeholder]: !children && empty,
                    }) },
                    label,
                    required && React.createElement("div", { className: s$i.star }, "*"))),
                children && React.createElement("div", { className: cn(s$i.value, empty && s$i.placeholder) }, children))),
            size !== 'l' && (React.createElement(React.Fragment, null,
                label && (React.createElement("div", { className: s$i.label },
                    label,
                    " ",
                    required && React.createElement("div", { className: cn(s$i.star, s$i.sticky) }, "*"))),
                React.createElement("div", { className: cn(s$i.content, s$i.value, empty && s$i.placeholder) }, children))),
            iconName && (React.createElement("span", { className: cn(s$i.icon, s$i.status) },
                React.createElement(Icon$4, { name: iconName }))),
            (info === null || info === void 0 ? void 0 : info.show) && (React.createElement("span", { className: cn(s$i.icon, s$i.info), ref: infoRef },
                React.createElement(Icon$4, { name: "information-circle" }))),
            React.createElement("span", { className: cn(s$i.icon, s$i.arrow, opened && s$i.opened) },
                React.createElement(Icon$4, { size: "s", name: "chevron-down" })),
            native && (React.createElement("select", { ref: nativeSelectRef, className: s$i.native, onChange: nativeHandleChange, disabled: disabled || readonly }))),
        hint && (React.createElement("span", { className: cn(s$i.hint, error && s$i.error, warning && s$i.warning), "data-test": error ? 'error' : 'hint' }, hint))));
};
var SimpleButton$1 = SimpleButton;

const Button = (_a) => {
    var { dataTest: externalDataTest, onClick } = _a, props = __rest(_a, ["dataTest", "onClick"]);
    const controlRef = React.useRef(null);
    const infoRef = React.useRef(null);
    const { select, handleChange } = useNativeSelect();
    const { opened, registerControl, toggle } = useDropdown();
    const { info, registerInfoControl, native, dataTest: contextDataTest } = React.useContext(context$2);
    React.useEffect(() => {
        if (!controlRef.current) {
            return;
        }
        registerControl(controlRef.current);
    }, [registerControl, registerInfoControl]);
    React.useEffect(() => {
        if (!infoRef.current) {
            return;
        }
        registerInfoControl(infoRef.current);
    }, [registerInfoControl, info.show]);
    const handleClick = React.useCallback(evt => {
        if (infoRef.current && containsNode(infoRef.current, evt.target)) {
            evt.preventDefault();
            evt.stopPropagation();
            return;
        }
        toggle();
        if (onClick) {
            onClick(evt);
        }
    }, [toggle, onClick]);
    return (React.createElement(SimpleButton$1, Object.assign({}, props, { dataTest: contextDataTest ? `${contextDataTest}-button` : externalDataTest, controlRef: controlRef, onToggle: (_v, ev) => (native ? void 0 : handleClick(ev)), opened: opened, info: info, infoRef: infoRef, native: native, nativeSelectRef: select, nativeHandleChange: handleChange })));
};
var Button$1 = Button;

var css_248z$11 = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.select-module_wrapper__79W1Y{margin:8px 0;overflow:auto}.select-module_list__TxPMm{flex:1 1}.select-module_search__hhtL9{margin:8px 8px 4px}.select-module_option__dSBAj{cursor:pointer}.select-module_emptyOption__wBhPj,.select-module_option__dSBAj{align-items:flex-start;border-radius:4px;display:flex;font:400 16px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;margin:0 8px;padding:8px;position:relative}.select-module_option__dSBAj+.select-module_option__dSBAj{margin-top:4px}.select-module_wrapper__79W1Y.select-module_single__fsmZ1 .select-module_option__dSBAj[data-selected],.select-module_wrapper__79W1Y:not([data-keyboard]) .select-module_option__dSBAj:not([data-disabled]):hover,.select-module_wrapper__79W1Y[data-keyboard] .select-module_option__dSBAj[data-focus]{background-color:#f3f1f8}.select-module_wrapper__79W1Y:not([data-keyboard]) .select-module_option__dSBAj:not([data-disabled]):hover,.select-module_wrapper__79W1Y[data-keyboard] .select-module_option__dSBAj[data-focus]{color:#3416b6}.select-module_wrapper__79W1Y:not([data-keyboard]) .select-module_option__dSBAj:not([data-disabled]):hover>.select-module_checkbox__xQEux [data-checkbox-control],.select-module_wrapper__79W1Y[data-keyboard] .select-module_option__dSBAj[data-focus]>.select-module_checkbox__xQEux [data-checkbox-control]{border-color:#3416b6}.select-module_option__dSBAj[data-disabled]{color:rgba(105,99,131,.6);cursor:not-allowed}.select-module_option__dSBAj.select-module_divider__I-DZm{margin-bottom:9px}.select-module_option__dSBAj.select-module_divider__I-DZm:after{background-color:rgba(150,142,190,.2);bottom:-5px;content:\"\";height:1px;left:8px;position:absolute;right:8px}.select-module_section__A8yFv{color:rgba(73,68,95,.8);font:400 12px/16px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;margin:16px 16px 4px}.select-module_checkbox__xQEux{margin-right:8px;pointer-events:none}.select-module_checkbox__xQEux+.select-module_content__vlmsj{margin-top:2px}.select-module_content__vlmsj{align-items:center;display:flex;flex:1 1}.select-module_group__PQqZt{margin:9px 0;position:relative}.select-module_group__PQqZt:first-child{margin-top:0}.select-module_group__PQqZt:last-child{margin-bottom:0}.select-module_group__PQqZt:after,.select-module_group__PQqZt:before{background-color:rgba(150,142,190,.2);content:\"\";display:block;height:1px;left:8px;position:absolute;right:8px}.select-module_group__PQqZt:before{top:-5px}.select-module_group__PQqZt:after{bottom:-5px}.select-module_group__PQqZt+.select-module_group__PQqZt:before,.select-module_group__PQqZt:first-child:before,.select-module_group__PQqZt:last-child:after{display:none}";
var s$h = {"wrapper":"select-module_wrapper__79W1Y","list":"select-module_list__TxPMm","search":"select-module_search__hhtL9","option":"select-module_option__dSBAj","emptyOption":"select-module_emptyOption__wBhPj","single":"select-module_single__fsmZ1","checkbox":"select-module_checkbox__xQEux","divider":"select-module_divider__I-DZm","section":"select-module_section__A8yFv","content":"select-module_content__vlmsj","group":"select-module_group__PQqZt"};
styleInject(css_248z$11);

const keys$7 = [keyCodes.up, keyCodes.down, keyCodes.space, keyCodes.enter];
const allOptions = `[data-option]:not([data-disabled])`;
const focusedOption = `[data-option][data-focus]`;
const hoveredOption = `[data-option]:hover:not([data-disabled])`;
const selectedOption = `[data-option][data-selected]`;
function focus(children, i) {
    children.forEach(el => {
        delete el.dataset.focus;
    });
    if (i === null) {
        return;
    }
    if (children[i]) {
        children[i].dataset.focus = 'true';
    }
}
function keyboard(container, state) {
    delete container.dataset.keyboard;
    if (!state) {
        return;
    }
    container.dataset.keyboard = 'true';
}
const Content$2 = (_a) => {
    var { children, dataTest: externalDataTest } = _a, props = __rest(_a, ["children", "dataTest"]);
    const { opened } = useDropdown();
    const { mode, search, registerSearchInput, dataTest: contextDataTest } = React.useContext(context$2);
    const listRef = React.useRef(null);
    const searchRef = React.useRef(null);
    const getOptions = React.useCallback(() => { var _a; return Array.from(((_a = listRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll(allOptions)) || []); }, []);
    const handleMouseMove = React.useCallback(() => {
        var _a;
        if (!((_a = listRef.current) === null || _a === void 0 ? void 0 : _a.dataset.keyboard)) {
            return;
        }
        keyboard(listRef.current, false);
        const focused = listRef.current.querySelector(focusedOption);
        delete focused.dataset.focus;
    }, []);
    React.useEffect(() => {
        if (listRef.current && !opened) {
            focus(getOptions(), null);
        }
    }, [opened, getOptions]);
    React.useEffect(() => {
        if (!searchRef.current) {
            return;
        }
        registerSearchInput(searchRef.current);
    }, [registerSearchInput, search.show]);
    useKeyPress(keys$7, event => {
        const children = getOptions();
        const count = children.length;
        let current;
        let i;
        if (!opened || count === 0 || !listRef.current) {
            return;
        }
        current = listRef.current.querySelector(focusedOption);
        const input = searchRef.current && searchRef.current.querySelector('input');
        if (!current) {
            current = listRef.current.querySelector(hoveredOption);
        }
        if (!current && mode === 'single') {
            current = listRef.current.querySelector(selectedOption);
        }
        i = children.findIndex(node => node === current);
        switch (event.keyCode) {
            case keyCodes.up:
                event.preventDefault();
                i = current ? (i - 1 + count) % count : count - 1;
                focus(children, i);
                keyboard(listRef.current, true);
                break;
            case keyCodes.down:
                event.preventDefault();
                i = current ? (i + 1) % count : 0;
                focus(children, i);
                keyboard(listRef.current, true);
                break;
            case keyCodes.space:
            case keyCodes.enter:
                if (children[i] && document.activeElement !== input) {
                    event.preventDefault();
                    children[i].click();
                    if (mode !== 'standalone') {
                        focus(children, i);
                    }
                    if (mode !== 'multiple') {
                        keyboard(listRef.current, false);
                    }
                }
                break;
        }
    });
    return (React.createElement(Dropdown.Content, Object.assign({ padding: false, flex: true, dataTest: contextDataTest ? `${contextDataTest}-content` : externalDataTest }, props),
        search.show && React.createElement("div", { ref: searchRef, className: s$h.search }),
        React.createElement("div", { ref: listRef, className: cn(s$h.wrapper, mode !== 'multiple' && s$h.single), onMouseMove: handleMouseMove }, children)));
};
const ContentNative = ({ children }) => {
    const { select } = React.useContext(context$2);
    if (!select) {
        return null;
    }
    return ReactDOM.createPortal(React.createElement(React.Fragment, null, children), select);
};
const SelectContent = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const { native } = React.useContext(context$2);
    return native ? React.createElement(ContentNative, null, children) : React.createElement(Content$2, Object.assign({}, props), children);
};
var Content$3 = SelectContent;

const Info = ({ children, container }) => {
    const { showInfo, info } = React.useContext(context$2);
    const to = React.useMemo(() => {
        const node = new Set();
        if (info.control) {
            node.add(info.control);
        }
        return { current: node };
    }, [info]);
    React.useEffect(() => {
        showInfo(true);
        return () => showInfo(false);
    }, [showInfo]);
    if (!info.control) {
        return null;
    }
    return ReactDOM.createPortal(React.createElement(Tooltip$1, { to: to, direction: "up", trigger: "hover", container: container }, children), info.control);
};
var Info$1 = Info;

var css_248z$10 = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.checkbox-module_label__Hp-T6{align-items:flex-start;cursor:pointer;display:inline-flex;padding:2px;position:relative;text-align:left;-webkit-user-select:none;-moz-user-select:none;user-select:none;vertical-align:middle}.checkbox-module_label__Hp-T6.checkbox-module_button__pMxUG{border-radius:4px;box-sizing:border-box;padding:16px}.checkbox-module_label__Hp-T6.checkbox-module_filter__n-f5D{border-radius:4px;box-sizing:border-box;display:flex;height:40px;justify-content:center;padding:8px 16px}.checkbox-module_label__Hp-T6.checkbox-module_filter__n-f5D>.checkbox-module_text__JgLIs{font-size:16px;font-weight:500;line-height:24px}.checkbox-module_label__Hp-T6.checkbox-module_block__Cb-3f{display:flex;flex:1 1;width:100%}.checkbox-module_label__Hp-T6.checkbox-module_disabled__gRlrJ{cursor:not-allowed}.checkbox-module_control__y6mvI{border:1px solid hsla(0,0%,100%,0);border-radius:2px;box-sizing:border-box;flex-shrink:0;height:20px;position:relative;transition:.24s cubic-bezier(.24,.1,.24,1);transition-property:border-color,background-color;width:20px}.checkbox-module_control__y6mvI.checkbox-module_gap__ABVNQ{margin-right:8px}.checkbox-module_text__JgLIs{color:#211f2e;font:400 16px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.checkbox-module_input__39sOM{opacity:0;outline:none;position:absolute;z-index:-1}.checkbox-module_border__gyB2r{border-radius:2px;height:20px;opacity:.24;position:absolute;transition:box-shadow .24s cubic-bezier(.24,.1,.24,1);width:20px}.checkbox-module_label__Hp-T6.checkbox-module_radio__OKR4i>.checkbox-module_border__gyB2r,.checkbox-module_label__Hp-T6.checkbox-module_radio__OKR4i>.checkbox-module_control__y6mvI{border-radius:50%}.checkbox-module_icon__VuIAa{height:20px;line-height:20px;pointer-events:none;position:absolute}.checkbox-module_minus__nXJ-p{height:20px}.checkbox-module_circle__MxCUN,.checkbox-module_minus__nXJ-p{opacity:0;transition:opacity .24s cubic-bezier(.24,.1,.24,1)}.checkbox-module_check__tNaSu{stroke-dasharray:14,15;stroke-dashoffset:15}.checkbox-module_input__39sOM:checked~.checkbox-module_icon__VuIAa .checkbox-module_check__tNaSu{stroke-dashoffset:0}.checkbox-module_input__39sOM:checked~.checkbox-module_icon__VuIAa .checkbox-module_circle__MxCUN,.checkbox-module_input__39sOM:checked~.checkbox-module_icon__VuIAa .checkbox-module_minus__nXJ-p{opacity:1}.checkbox-module_check__tNaSu.checkbox-module_in__jkura{animation:checkbox-module_dash-in__I8Uhw .24s cubic-bezier(.24,.1,.24,1) forwards}.checkbox-module_check__tNaSu.checkbox-module_out__g-rm6{animation:checkbox-module_dash-out__Li68F .24s cubic-bezier(.24,.1,.24,1) forwards}@keyframes checkbox-module_dash-in__I8Uhw{0%{stroke-dashoffset:14}to{stroke-dashoffset:0}}@keyframes checkbox-module_dash-out__Li68F{0%{stroke-dashoffset:0}to{stroke-dashoffset:-14}}.checkbox-module_primary__cq9ci.checkbox-module_button__pMxUG{background-color:#f8f8fc;border:1px solid rgba(127,120,161,.4)}.checkbox-module_primary__cq9ci.checkbox-module_button__pMxUG:not(.checkbox-module_checked__5FD8w):hover{border-color:rgba(115,108,147,.5)}.checkbox-module_primary__cq9ci.checkbox-module_button__pMxUG.checkbox-module_checked__5FD8w{border-color:#3416b6}.checkbox-module_primary__cq9ci>.checkbox-module_control__y6mvI{background-color:#fff}.checkbox-module_primary__cq9ci>.checkbox-module_icon__VuIAa{color:#fff}.checkbox-module_primary__cq9ci>.checkbox-module_input__39sOM:checked~.checkbox-module_control__y6mvI{background-color:#3416b6}.checkbox-module_primary__cq9ci>.checkbox-module_input__39sOM:checked~.checkbox-module_control__y6mvI:hover{background-color:#271188}.checkbox-module_primary__cq9ci>.checkbox-module_input__39sOM:not(:checked)~.checkbox-module_control__y6mvI{border-color:rgba(127,120,161,.4)}.checkbox-module_primary__cq9ci>.checkbox-module_input__39sOM:not(:checked)~.checkbox-module_control__y6mvI:hover{border-color:#3416b6}.checkbox-module_primary__cq9ci>.checkbox-module_input__39sOM:disabled~.checkbox-module_text__JgLIs{color:rgba(105,99,131,.6)}.checkbox-module_primary__cq9ci>.checkbox-module_input__39sOM:checked:disabled~.checkbox-module_control__y6mvI{background-color:rgba(150,142,190,.2)}.checkbox-module_primary__cq9ci>.checkbox-module_input__39sOM:checked:disabled~.checkbox-module_icon__VuIAa{color:rgba(105,99,131,.6)}.checkbox-module_primary__cq9ci>.checkbox-module_input__39sOM:not(:checked):disabled~.checkbox-module_control__y6mvI{border-color:rgba(127,120,161,.4)}.checkbox-module_primary__cq9ci>.checkbox-module_input__39sOM:focus~.checkbox-module_border__gyB2r{box-shadow:0 0 0 2px rgba(127,120,161,.4)}.checkbox-module_primary__cq9ci>.checkbox-module_input__39sOM:checked:focus~.checkbox-module_border__gyB2r{box-shadow:0 0 0 2px #3416b6}.checkbox-module_primary__cq9ci.checkbox-module_filter__n-f5D{background-color:rgba(150,142,190,.2);border:none;color:#211f2e}.checkbox-module_primary__cq9ci.checkbox-module_filter__n-f5D:not(:disabled):hover{background-color:rgba(127,120,161,.4)}.checkbox-module_primary__cq9ci.checkbox-module_filter__n-f5D:not(:disabled):checked{background-color:rgba(105,99,131,.6)}.checkbox-module_primary__cq9ci.checkbox-module_filter__n-f5D.checkbox-module_checked__5FD8w:not(:disabled){background-color:#f7f5ff;border:1px solid #3416b6;padding:7px 15px}.checkbox-module_primary__cq9ci.checkbox-module_filter__n-f5D.checkbox-module_checked__5FD8w:disabled{border:1px solid rgba(127,120,161,.4);padding:7px 15px}.checkbox-module_primary__cq9ci.checkbox-module_filter__n-f5D.checkbox-module_checked__5FD8w:not(:disabled):hover{background-color:#e7e2fd}.checkbox-module_primary__cq9ci.checkbox-module_filter__n-f5D.checkbox-module_checked__5FD8w:not(:disabled):checked{background-color:#ccc2fa}.checkbox-module_primary__cq9ci.checkbox-module_filter__n-f5D>.checkbox-module_border__gyB2r,.checkbox-module_primary__cq9ci.checkbox-module_filter__n-f5D>.checkbox-module_control__y6mvI,.checkbox-module_primary__cq9ci.checkbox-module_filter__n-f5D>.checkbox-module_icon__VuIAa{display:none}.checkbox-module_primary__cq9ci.checkbox-module_alt__lzzka.checkbox-module_button__pMxUG{background-color:hsla(0,0%,100%,.08);border:1px solid hsla(0,0%,100%,.64)}.checkbox-module_primary__cq9ci.checkbox-module_alt__lzzka.checkbox-module_button__pMxUG.checkbox-module_checked__5FD8w,.checkbox-module_primary__cq9ci.checkbox-module_alt__lzzka.checkbox-module_button__pMxUG:not(.checkbox-module_checked__5FD8w):hover{border-color:#fff}.checkbox-module_primary__cq9ci.checkbox-module_alt__lzzka>.checkbox-module_icon__VuIAa,.checkbox-module_primary__cq9ci.checkbox-module_alt__lzzka>.checkbox-module_text__JgLIs{color:#fff}.checkbox-module_primary__cq9ci.checkbox-module_alt__lzzka>.checkbox-module_input__39sOM:checked~.checkbox-module_control__y6mvI{background-color:hsla(0,0%,100%,.16)}.checkbox-module_primary__cq9ci.checkbox-module_alt__lzzka>.checkbox-module_input__39sOM:checked~.checkbox-module_control__y6mvI:hover{background-color:hsla(0,0%,100%,.32)}.checkbox-module_primary__cq9ci.checkbox-module_alt__lzzka>.checkbox-module_input__39sOM:not(:checked)~.checkbox-module_control__y6mvI{background-color:hsla(0,0%,100%,0);border-color:hsla(0,0%,100%,.64)}.checkbox-module_primary__cq9ci.checkbox-module_alt__lzzka>.checkbox-module_input__39sOM:not(:checked):disabled~.checkbox-module_control__y6mvI{border-color:rgba(115,108,147,.5)}.checkbox-module_primary__cq9ci.checkbox-module_alt__lzzka>.checkbox-module_input__39sOM:not(:checked)~.checkbox-module_control__y6mvI:hover{border-color:#fff}.checkbox-module_primary__cq9ci.checkbox-module_alt__lzzka>.checkbox-module_input__39sOM:checked:disabled~.checkbox-module_control__y6mvI{background-color:hsla(0,0%,100%,.16)}.checkbox-module_primary__cq9ci.checkbox-module_alt__lzzka>.checkbox-module_input__39sOM:focus~.checkbox-module_border__gyB2r{box-shadow:0 0 0 2px hsla(0,0%,100%,.64)}.checkbox-module_primary__cq9ci.checkbox-module_alt__lzzka>.checkbox-module_input__39sOM:checked:focus~.checkbox-module_border__gyB2r{box-shadow:0 0 0 2px hsla(0,0%,100%,.32)}.checkbox-module_error__EJn2j.checkbox-module_button__pMxUG{background-color:#f8f8fc;border:1px solid rgba(127,120,161,.4)}.checkbox-module_error__EJn2j:not(.checkbox-module_checked__5FD8w).checkbox-module_button__pMxUG:hover{border-color:rgba(115,108,147,.5)}.checkbox-module_error__EJn2j.checkbox-module_button__pMxUG.checkbox-module_checked__5FD8w{border-color:#f44434}.checkbox-module_error__EJn2j>.checkbox-module_control__y6mvI{background-color:#fff}.checkbox-module_error__EJn2j>.checkbox-module_text__JgLIs{color:#f44434}.checkbox-module_error__EJn2j>.checkbox-module_input__39sOM:disabled~.checkbox-module_text__JgLIs{color:rgba(105,99,131,.6)}.checkbox-module_error__EJn2j>.checkbox-module_icon__VuIAa{color:#fff}.checkbox-module_error__EJn2j>.checkbox-module_input__39sOM:checked~.checkbox-module_control__y6mvI{background-color:#f44434}.checkbox-module_error__EJn2j>.checkbox-module_input__39sOM:checked~.checkbox-module_control__y6mvI:hover{background-color:#e91f0c}.checkbox-module_error__EJn2j>.checkbox-module_input__39sOM:not(:checked)~.checkbox-module_control__y6mvI,.checkbox-module_error__EJn2j>.checkbox-module_input__39sOM:not(:checked)~.checkbox-module_control__y6mvI:hover{border-color:#f44434}.checkbox-module_error__EJn2j>.checkbox-module_input__39sOM:checked:disabled~.checkbox-module_control__y6mvI{background-color:rgba(150,142,190,.2)}.checkbox-module_error__EJn2j>.checkbox-module_input__39sOM:checked:disabled~.checkbox-module_icon__VuIAa{color:rgba(105,99,131,.6)}.checkbox-module_error__EJn2j>.checkbox-module_input__39sOM:not(:checked):disabled~.checkbox-module_control__y6mvI{border-color:rgba(127,120,161,.4)}.checkbox-module_error__EJn2j>.checkbox-module_input__39sOM:focus~.checkbox-module_border__gyB2r{box-shadow:0 0 0 2px #b8b4ca}.checkbox-module_error__EJn2j>.checkbox-module_input__39sOM:checked:focus~.checkbox-module_border__gyB2r{box-shadow:0 0 0 2px #f44434}";
var s$g = {"label":"checkbox-module_label__Hp-T6","button":"checkbox-module_button__pMxUG","filter":"checkbox-module_filter__n-f5D","text":"checkbox-module_text__JgLIs","block":"checkbox-module_block__Cb-3f","disabled":"checkbox-module_disabled__gRlrJ","control":"checkbox-module_control__y6mvI","gap":"checkbox-module_gap__ABVNQ","input":"checkbox-module_input__39sOM","border":"checkbox-module_border__gyB2r","radio":"checkbox-module_radio__OKR4i","icon":"checkbox-module_icon__VuIAa","minus":"checkbox-module_minus__nXJ-p","circle":"checkbox-module_circle__MxCUN","check":"checkbox-module_check__tNaSu","in":"checkbox-module_in__jkura","dash-in":"checkbox-module_dash-in__I8Uhw","out":"checkbox-module_out__g-rm6","dash-out":"checkbox-module_dash-out__Li68F","primary":"checkbox-module_primary__cq9ci","checked":"checkbox-module_checked__5FD8w","alt":"checkbox-module_alt__lzzka","error":"checkbox-module_error__EJn2j"};
styleInject(css_248z$10);

const colorRegexp = /(primary)|(error)|(alt)/g;
const MarkCheck = ({ value, dirty }) => (React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M6 10.5L9.11111 13L14 7", className: cn(s$g.check, dirty ? (value ? s$g.in : s$g.out) : ''), stroke: "currentColor", fill: "none", strokeWidth: "2" })));
const MarkIndeterminate = () => (React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M7 10H13", fill: "none", stroke: "currentColor", strokeWidth: "2" })));
const RadioCircle = () => (React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("circle", { className: s$g.circle, cx: "10", cy: "10", r: "4", fill: "currentColor" })));
const Checkbox = ({ value = false, indeterminate = false, disabled = false, color = 'primary', children, onChange, dataTest, block = false, button = false, radio = false, name, gtm, variant, }) => {
    const [on, setValue] = React.useState(value);
    const [dirty, setDirty] = React.useState(false);
    const handleToggleValue = (event) => {
        setValue(event.target.checked);
        setDirty(true);
        if (onChange) {
            onChange(event.target.checked, event);
        }
    };
    const colors = React.useMemo(() => color.match(colorRegexp) || [], [color]);
    React.useEffect(() => setValue(value), [value]);
    return (React.createElement("label", { "data-test": dataTest, "data-gtm": gtm, className: cn(s$g.label, ...colors.map((v) => s$g[v]), disabled && s$g.disabled, block && s$g.block, (button || variant === 'button') && s$g.button, radio && s$g.radio, on && s$g.checked, variant === 'filter' && s$g.filter) },
        React.createElement("input", { type: radio ? 'radio' : 'checkbox', className: s$g.input, checked: on, disabled: disabled, onChange: handleToggleValue, name: name }),
        React.createElement("div", { className: s$g.border }),
        React.createElement("div", { className: cn(s$g.control, children && s$g.gap), "data-checkbox-control": true }),
        React.createElement("div", { className: s$g.icon },
            !radio && !indeterminate && React.createElement(MarkCheck, { value: on, dirty: dirty }),
            !radio && indeterminate && (React.createElement("div", { className: s$g.minus },
                React.createElement(MarkIndeterminate, null))),
            radio && React.createElement(RadioCircle, null)),
        children && React.createElement("div", { className: s$g.text }, children)));
};

const getStringFromReactNode = (children) => {
    let label = '';
    React.Children.map(children, child => {
        if (typeof child === 'string') {
            label += child;
            return;
        }
        if (React.isValidElement(child) && child.props.children) {
            label += getStringFromReactNode(child.props.children);
            return;
        }
    });
    return label;
};

const Option = ({ value, children, checkbox = true, disabled = false, divider = false, dataTest: externalDataTest, selected = false, }) => {
    const { toggle } = useDropdown();
    const { mode, onChange, dataTest: contextDataTest } = React.useContext(context$2);
    const [check, setCheck] = React.useState(selected);
    const handleClick = React.useCallback(event => {
        const update = mode === 'standalone' ? false : !check;
        setCheck(update);
        onChange(value, update, event);
        if (mode !== 'multiple') {
            toggle();
        }
    }, [value, mode, toggle, onChange, check]);
    React.useEffect(() => setCheck(selected), [selected]);
    const attrs = Object.assign(Object.assign(Object.assign({ 'data-option': '' }, ((contextDataTest || externalDataTest) && {
        'data-test': contextDataTest ? `${contextDataTest}-option:${value}` : externalDataTest,
    })), (check && { 'data-selected': '' })), (disabled
        ? { 'data-disabled': '' }
        : {
            onClick: handleClick,
            onKeyPress: handleKeyPressEnter(handleClick),
            role: 'button',
            tabIndex: 0,
        }));
    return (React.createElement("div", Object.assign({ className: cn(s$h.option, divider && s$h.divider, mode === 'multiple' && s$h.multiple) }, attrs),
        mode === 'multiple' && checkbox && (React.createElement("div", { className: s$h.checkbox },
            React.createElement(Checkbox, { value: check, disabled: disabled }))),
        React.createElement("div", { className: s$h.content }, children)));
};
const NativeOption = ({ value, children, selected, disabled, dataTest, }) => {
    const { setNativeValue } = React.useContext(context$2);
    React.useEffect(() => {
        if (selected) {
            setNativeValue(value);
        }
    }, [setNativeValue, value, selected]);
    return (React.createElement("option", Object.assign({ value: value, disabled: disabled, "data-test": dataTest }, (typeof value === 'number' && { 'data-int': '' })), getStringFromReactNode(children)));
};
const SelectOption$1 = (_a) => {
    var props = __rest(_a, []);
    const { native } = React.useContext(context$2);
    return native ? React.createElement(NativeOption, Object.assign({}, props)) : React.createElement(Option, Object.assign({}, props));
};
var Option$1 = SelectOption$1;

const SelectOptionEmpty = ({ emptyText = 'Ничего не найдено' }) => {
    return React.createElement("div", { className: s$h.emptyOption }, emptyText);
};
var OptionEmpty = SelectOptionEmpty;

const Section = ({ children }) => {
    const { native } = React.useContext(context$2);
    if (native) {
        return React.createElement("optgroup", { label: getStringFromReactNode(children) });
    }
    return React.createElement("div", { className: s$h.section }, children);
};
var Section$1 = Section;

const Group = ({ label, children }) => {
    return (React.createElement("div", { className: cn(s$h.group) },
        label && label.length ? React.createElement("div", { className: cn(s$h.section) }, label) : null,
        React.createElement(React.Fragment, null, children)));
};
const NativeGroup = ({ label, children }) => {
    return React.createElement("optgroup", { label: label }, children);
};
const SelectGroup = (_a) => {
    var props = __rest(_a, []);
    const { native } = React.useContext(context$2);
    return native ? React.createElement(NativeGroup, Object.assign({}, props)) : React.createElement(Group, Object.assign({}, props));
};
var Group$1 = SelectGroup;

const Search = (_a) => {
    var props = __rest(_a, []);
    const { search, showSearch } = React.useContext(context$2);
    React.useEffect(() => {
        showSearch(true);
        return () => showSearch(false);
    }, [showSearch]);
    if (!search.control) {
        return null;
    }
    return ReactDOM.createPortal(React.createElement(Input$1, Object.assign({}, props, { size: props.size || 's' })), search.control);
};
var Search$1 = Search;

const Select = ({ children, mode = 'single', onChange = () => { }, native = false, dataTest, onToggle = () => { }, }) => {
    const [info, setInfo] = React.useState({});
    const [search, setSearch] = React.useState({});
    const [nativeValue, setNativeValue] = React.useState(null);
    const [list, registerList] = React.useState(null);
    const [select, registerSelect] = React.useState();
    const showInfo = React.useCallback((show) => setInfo(prev => (Object.assign(Object.assign({}, prev), { show }))), []);
    const showSearch = React.useCallback((show) => setSearch(prev => (Object.assign(Object.assign({}, prev), { show }))), []);
    const registerInfoControl = React.useCallback((control) => setInfo(prev => (Object.assign(Object.assign({}, prev), { control }))), []);
    const registerSearchInput = React.useCallback((control) => setSearch(prev => (Object.assign(Object.assign({}, prev), { control }))), []);
    const contextValue = React.useMemo(() => ({
        list,
        select,
        info,
        mode,
        native,
        nativeValue,
        onChange,
        registerInfoControl,
        registerList,
        registerSearchInput,
        registerSelect,
        search,
        setNativeValue,
        showInfo,
        showSearch,
        dataTest,
    }), [
        list,
        select,
        info,
        mode,
        native,
        nativeValue,
        onChange,
        registerInfoControl,
        registerList,
        registerSearchInput,
        registerSelect,
        search,
        setNativeValue,
        showInfo,
        showSearch,
        dataTest,
    ]);
    if (native) {
        return React.createElement(SelectProvider, { value: contextValue }, children);
    }
    return (React.createElement(Dropdown, { onToggle: onToggle },
        React.createElement(SelectProvider, { value: contextValue }, children)));
};
function SelectProvider({ value, children, }) {
    return React.createElement(context$2.Provider, { value: value }, children);
}
Select.Button = Button$1;
Select.SimpleButton = SimpleButton$1;
Select.Content = Content$3;
Select.Info = Info$1;
Select.Option = Option$1;
Select.OptionEmpty = OptionEmpty;
Select.Section = Section$1;
Select.Group = Group$1;
Select.Search = Search$1;

const Suggest$1 = (_a) => {
    var { loading: externalLoading = true, debounce: timeout = 800, onBlur, onChange, onTextChange, toggleOnFocus } = _a, props = __rest(_a, ["loading", "debounce", "onBlur", "onChange", "onTextChange", "toggleOnFocus"]);
    const { control, toggle, opened } = useSelectCustomControl();
    const [loading, setLoading] = React.useState(false);
    const toggleRef = React.useRef(toggle);
    React.useEffect(() => {
        toggleRef.current = toggle;
    }, [toggle]);
    const handleOnChange = React.useCallback((value, event) => __awaiter(void 0, void 0, void 0, function* () {
        if (value) {
            setLoading(true);
        }
        const state = yield (onChange === null || onChange === void 0 ? void 0 : onChange(value, opened, event));
        setLoading(false);
        if (value && typeof state === 'boolean') {
            toggleRef.current(state);
        }
    }), [onChange, opened]);
    const debouncedEventHandler = React.useMemo(() => debounce$3(handleOnChange, timeout), [handleOnChange, timeout]);
    const handleBlur = React.useCallback(event => {
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    }, [onBlur]);
    const handleFocus = React.useCallback(() => {
        if (!toggleOnFocus) {
            return;
        }
        toggleRef.current(true);
    }, [toggleOnFocus]);
    const onChangeHandler = React.useCallback((value, event) => {
        onTextChange === null || onTextChange === void 0 ? void 0 : onTextChange(value, event);
        debouncedEventHandler(value, event);
    }, [debouncedEventHandler, onTextChange]);
    return (React.createElement(Input$1, Object.assign({}, props, { containerRef: control, onChange: onChangeHandler, onBlur: handleBlur, onFocus: handleFocus, loaderFade: true, loading: externalLoading && loading })));
};
Suggest$1.Content = Content$8;
Suggest$1.Icon = Icon$3;
var SuggestInput$1 = Suggest$1;

var css_248z$$ = ".suggest-module_suggest__wiw63{display:inline-block;position:relative}.suggest-module_empty-list__lPW6Y{background:#fff;margin-top:8px;padding:16px;position:absolute;text-align:center;z-index:1}.suggest-module_list-box__rKYZF{background:#fff;border:1px solid #ccc9d9;border-radius:4px;box-shadow:0 8px 12px rgba(150,142,190,.2);box-sizing:border-box;left:0;margin-top:8px;min-width:100%;overflow:hidden;overflow-y:scroll;padding:8px;position:absolute;top:100%;z-index:1}.suggest-module_list-item__OA-bu{border-radius:4px;cursor:pointer;padding:8px}.suggest-module_list-item-hovered__VKIVd{background:#eae9f2}.suggest-module_full-width__65uV2{width:100%}";
var suggestStyles = {"suggest":"suggest-module_suggest__wiw63","empty-list":"suggest-module_empty-list__lPW6Y","list-box":"suggest-module_list-box__rKYZF","list-item":"suggest-module_list-item__OA-bu","list-item-hovered":"suggest-module_list-item-hovered__VKIVd","full-width":"suggest-module_full-width__65uV2"};
styleInject(css_248z$$);

const getNextIndex = (direction, hoveredIndex, items) => {
    let start = hoveredIndex || 0;
    if (hoveredIndex === -1) {
        hoveredIndex = 0;
    }
    while (start < items.length && start > -1) {
        start++;
        hoveredIndex += direction;
        if (hoveredIndex < 0) {
            hoveredIndex = items.length - 1;
        }
        if (hoveredIndex >= items.length) {
            hoveredIndex = 0;
        }
        if (items[hoveredIndex] && !items[hoveredIndex].disabled) {
            break;
        }
        else {
            start--;
        }
    }
    return hoveredIndex;
};

var ACTIONS$1;
(function (ACTIONS) {
    ACTIONS["BLUR"] = "BLUR";
    ACTIONS["CLEAR"] = "CLEAR";
    ACTIONS["CHANGE"] = "CHANGE";
    ACTIONS["SELECT"] = "SELECT";
    ACTIONS["FOCUSED"] = "FOCUSED";
    ACTIONS["HIGHLIGHTED_INDEX"] = "HIGHLIGHTED_INDEX";
    ACTIONS["UPDATE_SUGGESTIONS"] = "UPDATE_SUGGESTIONS";
})(ACTIONS$1 || (ACTIONS$1 = {}));
const reducer = (state, action) => {
    switch (action.type) {
        case ACTIONS$1.FOCUSED: {
            const newState = Object.assign(Object.assign({}, state), { isInputFocused: true });
            if (state.checkListShowing) {
                newState.isListShowed = state.checkListShowing(newState);
            }
            if (!newState.isListShowed) {
                newState.highlightedIndex = -1;
            }
            return newState;
        }
        case ACTIONS$1.BLUR: {
            const newState = Object.assign(Object.assign({}, state), { isInputFocused: false });
            if (state.checkListShowing) {
                newState.isListShowed = state.checkListShowing(newState);
            }
            if (!newState.isListShowed) {
                newState.highlightedIndex = -1;
            }
            return newState;
        }
        case ACTIONS$1.CHANGE: {
            const { payload } = action;
            const newState = Object.assign(Object.assign(Object.assign({}, state), payload), { suggestion: undefined });
            if (state.checkListShowing) {
                newState.isListShowed = state.checkListShowing(newState);
            }
            return newState;
        }
        case ACTIONS$1.HIGHLIGHTED_INDEX: {
            const { payload } = action;
            return Object.assign(Object.assign({}, state), { highlightedIndex: payload.index });
        }
        case ACTIONS$1.UPDATE_SUGGESTIONS: {
            const { payload } = action;
            if (payload.suggestions !== state.suggestions && !payload.suggestions.length && state.label) {
                return Object.assign(Object.assign(Object.assign({}, state), payload), { isEmpty: true });
            }
            if (payload.suggestions === state.suggestions) {
                return state;
            }
            const newState = Object.assign(Object.assign({}, state), { isEmpty: false, highlightedIndex: -1, suggestions: payload.suggestions });
            if (state.checkListShowing) {
                newState.isListShowed = state.checkListShowing(newState);
            }
            return newState;
        }
        case ACTIONS$1.SELECT: {
            const { payload } = action;
            const newState = Object.assign(Object.assign({}, state), { highlightedIndex: -1 });
            if (state.clearOnSelect) {
                newState.label = '';
                newState.suggestion = undefined;
            }
            else if (payload.suggestion) {
                newState.suggestion = payload.suggestion;
                newState.label = payload.suggestion.label;
            }
            else {
                newState.suggestion = undefined;
                newState.label = '';
            }
            if (state.checkListShowing) {
                newState.isListShowed = state.checkListShowing(newState);
            }
            return newState;
        }
        default:
            return state;
    }
};
const DEFAULT_CHECK_LIST_SHOWING = state => {
    const suggestionLabel = state.suggestion && state.suggestion.label;
    return Boolean(state.label &&
        Array.isArray(state.suggestions) &&
        state.suggestions.length &&
        state.isInputFocused &&
        suggestionLabel !== state.label);
};
const useSuggest = ({ minTextLength = 1, suggestions, onTextChange, clearOnSelect, onChange, suggestion, checkListShowing = DEFAULT_CHECK_LIST_SHOWING, }) => {
    const [state, dispatch] = React.useReducer(reducer, {
        suggestions,
        suggestion,
        label: suggestion ? suggestion.label : '',
        isEmpty: false,
        isListShowed: false,
        isInputFocused: false,
        highlightedIndex: -1,
        clearOnSelect,
        checkListShowing,
    });
    const listRef = React.useRef(null);
    const inputRef = React.useRef(null);
    const didMountRef = React.useRef(false);
    const suggestionsMap = React.useRef({});
    const listItemsRef = React.useRef([]);
    React.useEffect(() => {
        if (didMountRef.current) {
            listItemsRef.current = [];
            suggestionsMap.current = {};
            if (suggestions) {
                dispatch({ type: ACTIONS$1.UPDATE_SUGGESTIONS, payload: { suggestions } });
            }
        }
        didMountRef.current = true;
    }, [suggestions]);
    React.useEffect(() => {
        if (state.isListShowed) {
            listItemsRef.current = [];
            suggestionsMap.current = {};
        }
    }, [state.isListShowed]);
    React.useEffect(() => {
        if (didMountRef.current) {
            dispatch({ type: ACTIONS$1.SELECT, payload: { suggestion } });
        }
    }, [suggestion]);
    const handleSelect = (e, index) => {
        e.preventDefault();
        e.persist();
        const suggestion = suggestionsMap.current[index];
        if (!suggestion) {
            return;
        }
        dispatch({ type: ACTIONS$1.SELECT, payload: { suggestion } });
        if (onChange) {
            onChange(suggestion, e);
        }
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    const handleInputChange = (text, e) => {
        e.persist();
        const trimmedText = text.trim();
        if (state.label !== trimmedText && trimmedText.length >= minTextLength && onTextChange) {
            onTextChange(trimmedText);
        }
        if (!trimmedText) {
            onChange(undefined, e);
        }
        dispatch({ type: ACTIONS$1.CHANGE, payload: { label: trimmedText } });
    };
    const handleInputFocused = () => dispatch({ type: ACTIONS$1.FOCUSED });
    const handleKeyDown = (event) => {
        switch (event.key) {
            case Key.Up:
            case Key.Down: {
                event.preventDefault();
                event.stopPropagation();
                const direction = event.key === Key.Up ? -1 : 1;
                const nextIndex = getNextIndex(direction, state.highlightedIndex, state.suggestions || []);
                if (listItemsRef.current[nextIndex]) {
                    listItemsRef.current[nextIndex].scrollIntoView({
                        block: 'nearest',
                    });
                }
                dispatch({ type: ACTIONS$1.HIGHLIGHTED_INDEX, payload: { index: nextIndex } });
                break;
            }
            case Key.Enter: {
                event.preventDefault();
                event.stopPropagation();
                handleSelect(event, state.highlightedIndex);
                break;
            }
        }
    };
    const handleInputBlur = () => {
        const ownerDocument = document;
        requestAnimationFrame(() => {
            if (listRef.current && ownerDocument.activeElement !== inputRef.current) {
                if (!listRef.current.contains(ownerDocument.activeElement)) {
                    dispatch({ type: ACTIONS$1.BLUR });
                }
            }
        });
    };
    const getInputProps = (opts = {}) => {
        return Object.assign(Object.assign({}, opts), { 'data-test': `${opts.dataTest}-input`, wrapperRef: mergeRefs$1(inputRef, opts.wrapperRef), onBlur: callEventHandlers(opts.onBlur, opts.onBlur, handleInputBlur), onFocus: callEventHandlers(opts.onFocus, handleInputFocused), onChange: callEventHandlers(opts.onChange, handleInputChange), onKeyDown: callEventHandlers(opts.onKeyDown, handleKeyDown) });
    };
    const getListProps = (listProps = {}) => {
        return {
            ref: mergeRefs$1(listRef, listProps.ref),
            style: listProps.style,
            className: cn(suggestStyles.listBox),
            'data-test': `${listProps.dataTest}-list`,
            'aria-haspopup': 'listbox',
            'aria-expanded': state.isListShowed,
        };
    };
    let localIndex = 0;
    const getListItemProps = (_a) => {
        var { item } = _a, rest = __rest(_a, ["item"]);
        const currentIndex = localIndex++;
        const hovered = currentIndex === state.highlightedIndex;
        suggestionsMap.current[currentIndex] = item;
        return {
            ref: (itemNode) => {
                listItemsRef.current[currentIndex] = itemNode;
            },
            hovered,
            role: 'option',
            index: currentIndex,
            className: cn(suggestStyles.listItem, { [suggestStyles.listItemHovered]: hovered }),
            'data-test': `${rest.dataTest}-item-${currentIndex}`,
            onMouseEnter: callEventHandlers(rest.onMouseEnter, () => dispatch({ type: ACTIONS$1.HIGHLIGHTED_INDEX, payload: { index: currentIndex } })),
            onMouseDown: callEventHandlers(rest.onMouseDown, (e) => handleSelect(e, currentIndex)),
        };
    };
    return {
        suggestState: state,
        getListProps,
        getInputProps,
        getListItemProps,
    };
};

const DEFAULT_SUGGESTIONS = [];
const DEFAULT_INPUT_PROPS = {};
const DEFAULT_LIST_PROPS = {
    maxHeight: 400,
};
const DEFAULT_EMPTY_LIST_PROPS = {
    emptyText: 'Ничего не найдено',
};
const renderEmptyListDefault = props => {
    const { suggestRef, container, emptyListProps = {} } = props;
    return (React.createElement(Popup, { anchor: suggestRef, visible: true, directions: [Direction.BottomLeft], container: container },
        React.createElement("div", { className: cn(suggestStyles.listBox, suggestStyles.emptyList, emptyListProps.className), style: emptyListProps.style, "data-test": emptyListProps.dataTest }, emptyListProps.emptyText)));
};
const renderListDefault = ({ suggestRef, listProps, suggestions, getListItemProps, getListProps, container }) => {
    const injectListProps = getListProps(listProps);
    return (React.createElement(Popup, { anchor: suggestRef, visible: true, directions: [Direction.BottomLeft], container: container },
        React.createElement("div", Object.assign({}, injectListProps), suggestions.map((item, index) => {
            const _a = getListItemProps({ item, dataTest: listProps.dataTest }), { hovered } = _a, itemProps = __rest(_a, ["hovered"]);
            return (React.createElement("div", Object.assign({}, itemProps, { key: `${item.label}-${index}`, className: cn(suggestStyles.listItem, {
                    [suggestStyles.listItemHovered]: hovered,
                }) }), item.label));
        }))));
};
const renderInputDefault = ({ suggestState, inputProps, getInputProps }) => {
    const _a = getInputProps(inputProps), { wrapperRef, containerRef } = _a, rest = __rest(_a, ["wrapperRef", "containerRef"]);
    return (React.createElement(Input$1, Object.assign({}, inputProps, { dataTest: rest['data-test'], wrapperRef: wrapperRef, onBlur: rest.onBlur, onFocus: rest.onFocus, onChange: rest.onChange, onKeyDown: rest.onKeyDown, value: suggestState.label, containerRef: containerRef })));
};
const Suggest = ({ name, styles = {}, minTextLength = 1, onTextChange, className, value, dataTest, onChange, checkListShowing, clearOnSelect, container, emptyListProps = DEFAULT_EMPTY_LIST_PROPS, listProps = DEFAULT_LIST_PROPS, inputProps = DEFAULT_INPUT_PROPS, suggestions = DEFAULT_SUGGESTIONS, renderList = renderListDefault, renderEmptyList = renderEmptyListDefault, renderInput = renderInputDefault, }) => {
    const suggestRef = React.useRef(null);
    const suggestInputContainerRef = React.useRef(null);
    const { suggestState, getInputProps, getListItemProps, getListProps } = useSuggest({
        onChange,
        onTextChange,
        minTextLength,
        suggestions,
        suggestion: value,
        checkListShowing,
        clearOnSelect,
    });
    const suggestWidth = (suggestRef.current && suggestRef.current.getBoundingClientRect().width) || 0;
    const showEmptyList = suggestState.isListShowed && suggestState.isEmpty;
    return (React.createElement("div", { ref: suggestRef, "data-test": dataTest, className: cn(suggestStyles.suggest, suggestStyles.fullWidth, className, {
            [cn(styles.focused)]: suggestState.isInputFocused,
        }) },
        React.createElement("input", { type: "text", hidden: true, readOnly: true, name: name, value: (suggestState.suggestion && suggestState.suggestion.value) || '' }),
        renderInput({
            inputProps: Object.assign({ dataTest, containerRef: suggestInputContainerRef }, inputProps),
            suggestState,
            getInputProps,
        }),
        suggestState.isListShowed &&
            !showEmptyList &&
            renderList({
                listProps: Object.assign(Object.assign({ dataTest }, listProps), { style: Object.assign(Object.assign({}, listProps.style), { maxHeight: listProps.maxHeight, minWidth: suggestWidth }) }),
                suggestRef: suggestInputContainerRef,
                suggestions,
                suggestState,
                getListProps,
                getListItemProps,
                container,
            }),
        showEmptyList &&
            renderEmptyList({
                state: suggestState,
                emptyListProps: Object.assign(Object.assign({ dataTest }, emptyListProps), { style: Object.assign(Object.assign({}, emptyListProps.style), { minWidth: suggestWidth }) }),
                suggestRef,
                container,
            })));
};

var css_248z$_ = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.toggle-module_label__qk4DI{align-items:flex-start;border-radius:12px;cursor:pointer;display:inline-flex;min-height:24px;position:relative}.toggle-module_checkbox__h8ohw{opacity:0;position:absolute;z-index:-1}.toggle-module_control__Oeb8I{border-radius:12px;box-sizing:border-box;display:inline-block;height:24px;padding:4px;position:relative;transition:var(--animation);transition-property:padding,background-color,border;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:40px}.toggle-module_control__Oeb8I:after{border-radius:8px;content:\"\";display:block;height:16px;transition:background-color var(--animation);width:16px}.toggle-module_checkbox__h8ohw:checked~.toggle-module_control__Oeb8I{padding-left:20px}.toggle-module_border__-IYKt{border-radius:20px;bottom:0;left:0;opacity:.48;position:absolute;right:0;top:0;transition:box-shadow var(--animation)}.toggle-module_checkbox__h8ohw:disabled~.toggle-module_control__Oeb8I,.toggle-module_checkbox__h8ohw:disabled~.toggle-module_text__fl41-{cursor:not-allowed}.toggle-module_text__fl41-{font:400 16px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;margin:2px 0 0 8px}.toggle-module_primary__fRNRO>.toggle-module_control__Oeb8I{background-color:rgba(150,142,190,.2)}.toggle-module_primary__fRNRO>.toggle-module_control__Oeb8I:after{background-color:#fff}.toggle-module_primary__fRNRO>.toggle-module_checkbox__h8ohw:not(:disabled)~.toggle-module_control__Oeb8I:after{box-shadow:0 2px 8px 0 rgba(33,31,46,.16)}.toggle-module_primary__fRNRO>.toggle-module_checkbox__h8ohw:checked~.toggle-module_control__Oeb8I{background-color:#3416b6}.toggle-module_primary__fRNRO>.toggle-module_checkbox__h8ohw:focus~.toggle-module_control__Oeb8I .toggle-module_border__-IYKt{box-shadow:0 0 0 2px #3416b6}.toggle-module_primary__fRNRO>.toggle-module_checkbox__h8ohw:not(:checked):not(:disabled)~.toggle-module_control__Oeb8I:hover{background-color:rgba(127,120,161,.4)}.toggle-module_primary__fRNRO>.toggle-module_checkbox__h8ohw:checked:not(:disabled)~.toggle-module_control__Oeb8I:hover{background-color:#271188}.toggle-module_primary__fRNRO>.toggle-module_checkbox__h8ohw:checked:disabled~.toggle-module_control__Oeb8I{background-color:rgba(150,142,190,.2)}.toggle-module_primary__fRNRO>.toggle-module_checkbox__h8ohw:checked:disabled~.toggle-module_control__Oeb8I:after{background-color:rgba(105,99,131,.6)}.toggle-module_primary__fRNRO>.toggle-module_checkbox__h8ohw:disabled~.toggle-module_text__fl41-{color:rgba(105,99,131,.6)}.toggle-module_primary__fRNRO>.toggle-module_checkbox__h8ohw:not(:checked):disabled~.toggle-module_control__Oeb8I{background-color:rgba(150,142,190,.2)}.toggle-module_primary__fRNRO>.toggle-module_checkbox__h8ohw:not(:checked):disabled~.toggle-module_control__Oeb8I:after{background-color:rgba(105,99,131,.6)}.toggle-module_primary__fRNRO>.toggle-module_text__fl41-{color:#211f2e}.toggle-module_alt-bg__UKmph>.toggle-module_control__Oeb8I{background-color:hsla(0,0%,100%,.16)}.toggle-module_alt-bg__UKmph>.toggle-module_control__Oeb8I:after{background-color:#fff}.toggle-module_alt-bg__UKmph>.toggle-module_checkbox__h8ohw:not(:disabled)~.toggle-module_control__Oeb8I:after{box-shadow:0 2px 8px rgba(34,31,46,.16)}.toggle-module_alt-bg__UKmph>.toggle-module_checkbox__h8ohw:checked~.toggle-module_control__Oeb8I{background-color:#a391f3}.toggle-module_alt-bg__UKmph>.toggle-module_checkbox__h8ohw:focus~.toggle-module_control__Oeb8I .toggle-module_border__-IYKt{box-shadow:0 0 0 2px hsla(0,0%,100%,.32)}.toggle-module_alt-bg__UKmph>.toggle-module_checkbox__h8ohw:not(:checked):not(:disabled)~.toggle-module_control__Oeb8I:hover{background-color:hsla(0,0%,100%,.32)}.toggle-module_alt-bg__UKmph>.toggle-module_checkbox__h8ohw:checked:not(:disabled)~.toggle-module_control__Oeb8I:hover{background-color:#6b4fe8}.toggle-module_alt-bg__UKmph>.toggle-module_checkbox__h8ohw:checked:disabled~.toggle-module_control__Oeb8I{background-color:hsla(0,0%,100%,.16)}.toggle-module_alt-bg__UKmph>.toggle-module_checkbox__h8ohw:checked:disabled~.toggle-module_control__Oeb8I:after{background-color:hsla(0,0%,100%,.64)}.toggle-module_alt-bg__UKmph>.toggle-module_checkbox__h8ohw:disabled~.toggle-module_text__fl41-{color:hsla(0,0%,100%,.32)}.toggle-module_alt-bg__UKmph>.toggle-module_checkbox__h8ohw:not(:checked):disabled~.toggle-module_control__Oeb8I{background-color:hsla(0,0%,100%,.16)}.toggle-module_alt-bg__UKmph>.toggle-module_checkbox__h8ohw:not(:checked):disabled~.toggle-module_control__Oeb8I:after{background-color:hsla(0,0%,100%,.64)}.toggle-module_alt-bg__UKmph>.toggle-module_text__fl41-{color:#fff}";
var styles$k = {"label":"toggle-module_label__qk4DI","checkbox":"toggle-module_checkbox__h8ohw","control":"toggle-module_control__Oeb8I","border":"toggle-module_border__-IYKt","text":"toggle-module_text__fl41-","primary":"toggle-module_primary__fRNRO","alt-bg":"toggle-module_alt-bg__UKmph"};
styleInject(css_248z$_);

const s$f = normalizeCSSModules(styles$k);
const waitTimeout = 500;
const Toggle = ({ value, disabled = false, children, onChange = () => { }, name, color = 'primary', }) => {
    const wait = React.useRef(false);
    const timer = React.useRef();
    const handleToggleValue = React.useCallback(event => {
        if (wait.current) {
            return;
        }
        wait.current = true;
        timer.current = setTimeout(() => {
            wait.current = false;
        }, waitTimeout);
        onChange(!value, event);
    }, [value, onChange]);
    React.useEffect(() => () => timer.current && clearTimeout(timer.current), []);
    return (React.createElement("label", { className: cn(s$f.label, s$f[color]) },
        React.createElement("input", { type: "checkbox", className: s$f.checkbox, checked: value, disabled: disabled, onChange: handleToggleValue, name: name }),
        React.createElement("div", { className: s$f.control },
            React.createElement("div", { className: s$f.border })),
        children && React.createElement("div", { className: s$f.text }, children)));
};

var css_248z$Z = ".actions-dropdown-module_more__M-qhF{background:var(--c-secondary);border-radius:50%;box-sizing:border-box;height:24px;padding:0 4px;width:24px}.actions-dropdown-module_more__M-qhF:hover{background:var(--c-secondary-hover);cursor:pointer}.actions-dropdown-module_dropdownContent__Yl14W{background:var(--c-primary-alt-bg);border-radius:5px;box-shadow:0 2px 12px rgba(10,37,92,.08);box-sizing:border-box;width:205px}.actions-dropdown-module_listItem__-tMo2{cursor:pointer;padding:var(--padding-m);width:calc(100% - var(--padding-m)*2)}.actions-dropdown-module_listItem__-tMo2:hover{background:var(--color-black-75-alpha)}";
styleInject(css_248z$Z);

const defaultValue$1 = {
    isCreatedFromDC: false,
};
React.createContext(defaultValue$1);

const defaultValue = {
    disabled: false,
};
const DisableableFormContext = React.createContext(defaultValue);

function convertToSelectOptions$1(dict) {
    const values = Object.keys(dict);
    return values.map((value) => ({ value, label: dict[value] }));
}

//      
var fieldSubscriptionItems = ['active', 'data', 'dirty', 'dirtySinceLastSubmit', 'error', 'initial', 'invalid', 'length', 'modified', 'modifiedSinceLastSubmit', 'pristine', 'submitError', 'submitFailed', 'submitSucceeded', 'submitting', 'touched', 'valid', 'value', 'visited', 'validating'];

//      
var formSubscriptionItems = ['active', 'dirty', 'dirtyFields', 'dirtyFieldsSinceLastSubmit', 'dirtySinceLastSubmit', 'error', 'errors', 'hasSubmitErrors', 'hasValidationErrors', 'initialValues', 'invalid', 'modified', 'modifiedSinceLastSubmit', 'pristine', 'submitting', 'submitError', 'submitErrors', 'submitFailed', 'submitSucceeded', 'touched', 'valid', 'validating', 'values', 'visited'];

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

const bytesToMegabytes = (fileSize) => {
    if (!fileSize)
        return '';
    return (Number(fileSize) / (1024 * 1024)).toFixed(2);
};

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || _typeof$3(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

var formatDistance$1 = formatDistance;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

var formatRelative$1 = formatRelative;

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex$2(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex$2(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};

var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};

var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var defaultOptions$3 = {};
function getDefaultOptions() {
  return defaultOptions$3;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;

  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate$2(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof$2(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate$2(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$2 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */
var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters$3.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters$3.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters$3.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var formatters$1 = formatters;

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;

  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }

      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);

  if (!matched) {
    return input;
  }

  return matched[1].replace(doubleQuoteRegExp, "'");
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString$2 = Object.prototype.toString;
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString$2.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject$4(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof global == 'object' && isGlobalObj(global)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}

/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!('console' in GLOBAL_OBJ)) {
    return callback();
  }

  const originalConsole = GLOBAL_OBJ.console ;
  const wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    const originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in originalConsole && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            GLOBAL_OBJ.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger = getGlobalSingleton('logger', makeLogger);
} else {
  logger = makeLogger();
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if (isPlainObject$4(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = GLOBAL_OBJ ;
  const crypto = gbl.crypto || gbl.msCrypto;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !isBrowserBundle() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if (isThenable(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}

// eslint-disable-next-line deprecation/deprecation
const WINDOW = getGlobalObject();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = dynamicRequire(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = isNodeEnv() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
(() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      return performance.timeOrigin;
    } else {
      return navigationStart;
    }
  }
  return dateNow;
})();

const DEFAULT_ENVIRONMENT = 'production';

/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = timestampInSeconds();

  const session = {
    sid: uuid4(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || timestampInSeconds();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : uuid4();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return dropUndefinedKeys({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}

/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
let Scope$1 = class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      updateSession(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if (isPlainObject$4(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: dateTimestampInSeconds(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transactionName = this._span.transaction && this._span.transaction.name;
      if (transactionName) {
        event.tags = { transaction: transactionName, ...event.tags };
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new SyncPromise((resolve, reject) => {
      const processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        const result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          logger.log(`Event processor "${processor.id}" dropped event`);

        if (isThenable(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? arrayify(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
};

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return getGlobalSingleton('globalEventProcessors', () => []);
}

/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * A layer in the process stack.
 * @hidden
 */

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new Scope$1(),   _version = API_VERSION) {this._version = _version;
    this._stack = [{ scope }];
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = Scope$1.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : uuid4();
    if (!event.type) {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = dateTimestampInSeconds();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? (consoleSandbox(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    if (client.emit) {
      client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    }

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this.getScope().setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this.getScope().setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this.getScope().setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.getScope().setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this.getScope().setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    this.getScope().setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    return this._callExtensionMethod('startTransaction', context, customSamplingContext);
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer.scope;
    const session = scope.getSession();
    if (session) {
      closeSession(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    scope.setSession();
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment = DEFAULT_ENVIRONMENT } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = GLOBAL_OBJ.navigator || {};

    const session = makeSession({
      release,
      environment,
      user: scope.getUser(),
      ...(userAgent && { userAgent }),
      ...context,
    });

    // End existing session if there's one
    const currentSession = scope.getSession && scope.getSession();
    if (currentSession && currentSession.status === 'ok') {
      updateSession(currentSession, { status: 'exited' });
    }
    this.endSession();

    // Afterwards we set the new session on the scope
    scope.setSession(session);

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();
    if (!scope) return;

    const session = scope.getSession();
    if (session) {
      if (client && client.captureSession) {
        client.captureSession(session);
      }
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  GLOBAL_OBJ.__SENTRY__ = GLOBAL_OBJ.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return GLOBAL_OBJ;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Prefer domains over global if they are there (applicable only to Node environment)
  if (isNodeEnv()) {
    return getHubFromActiveDomain(registry);
  }
  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
  try {
    const sentry = getMainCarrier().__SENTRY__;
    const activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;

    // If there's no active domain, just return global hub
    if (!activeDomain) {
      return getHubFromCarrier(registry);
    }

    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
      const registryHubTopStack = getHubFromCarrier(registry).getStackTop();
      setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, Scope$1.clone(registryHubTopStack.scope)));
    }

    // Return hub that lives on a domain
    return getHubFromCarrier(activeDomain);
  } catch (_Oo) {
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
  }
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return getGlobalSingleton('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}

// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
  return getCurrentHub().captureException(exception, { captureContext });
}

var css_248z$Y = ".error-message-module_errorMessage__Fi2Sp p{margin:0}.error-message-module_title__3GsHk{font-weight:700}";
styleInject(css_248z$Y);

var distExports = {};
var dist$1 = {
  get exports(){ return distExports; },
  set exports(v){ distExports = v; },
};

(function (module, exports) {
	!function(t,r){r(exports);}(commonjsGlobal,(function(t){	/*! *****************************************************************************
	    Copyright (c) Microsoft Corporation. All rights reserved.
	    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
	    this file except in compliance with the License. You may obtain a copy of the
	    License at http://www.apache.org/licenses/LICENSE-2.0

	    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
	    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
	    MERCHANTABLITY OR NON-INFRINGEMENT.

	    See the Apache Version 2.0 License for specific language governing permissions
	    and limitations under the License.
	    ***************************************************************************** */var r=function(t,e){return (r=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,r){t.__proto__=r;}||function(t,r){for(var e in r)r.hasOwnProperty(e)&&(t[e]=r[e]);})(t,e)};function e(t,e){function n(){this.constructor=t;}r(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n);}var n=function(){return (n=Object.assign||function(t){for(var r,e=1,n=arguments.length;e<n;e++)for(var o in r=arguments[e])Object.prototype.hasOwnProperty.call(r,o)&&(t[o]=r[o]);return t}).apply(this,arguments)};function o(t){return "function"==typeof t}var i=!1,s={Promise:void 0,set useDeprecatedSynchronousErrorHandling(t){t&&(new Error).stack;i=t;},get useDeprecatedSynchronousErrorHandling(){return i}};function u(t){setTimeout((function(){throw t}),0);}var c={closed:!0,next:function(t){},error:function(t){if(s.useDeprecatedSynchronousErrorHandling)throw t;u(t);},complete:function(){}},h=function(){return Array.isArray||function(t){return t&&"number"==typeof t.length}}();var a=function(){function t(t){return Error.call(this),this.message=t?t.length+" errors occurred during unsubscription:\n"+t.map((function(t,r){return r+1+") "+t.toString()})).join("\n  "):"",this.name="UnsubscriptionError",this.errors=t,this}return t.prototype=Object.create(Error.prototype),t}(),p=function(){function t(t){this.closed=!1,this._parentOrParents=null,this._subscriptions=null,t&&(this._unsubscribe=t);}return t.prototype.unsubscribe=function(){var r;if(!this.closed){var e,n=this._parentOrParents,i=this._unsubscribe,s=this._subscriptions;if(this.closed=!0,this._parentOrParents=null,this._subscriptions=null,n instanceof t)n.remove(this);else if(null!==n)for(var u=0;u<n.length;++u){n[u].remove(this);}if(o(i))try{i.call(this);}catch(t){r=t instanceof a?f(t.errors):[t];}if(h(s)){u=-1;for(var c=s.length;++u<c;){var p=s[u];if(null!==(e=p)&&"object"==typeof e)try{p.unsubscribe();}catch(t){r=r||[],t instanceof a?r=r.concat(f(t.errors)):r.push(t);}}}if(r)throw new a(r)}},t.prototype.add=function(r){var e=r;if(!r)return t.EMPTY;switch(typeof r){case"function":e=new t(r);case"object":if(e===this||e.closed||"function"!=typeof e.unsubscribe)return e;if(this.closed)return e.unsubscribe(),e;if(!(e instanceof t)){var n=e;(e=new t)._subscriptions=[n];}break;default:throw new Error("unrecognized teardown "+r+" added to Subscription.")}var o=e._parentOrParents;if(null===o)e._parentOrParents=this;else if(o instanceof t){if(o===this)return e;e._parentOrParents=[o,this];}else {if(-1!==o.indexOf(this))return e;o.push(this);}var i=this._subscriptions;return null===i?this._subscriptions=[e]:i.push(e),e},t.prototype.remove=function(t){var r=this._subscriptions;if(r){var e=r.indexOf(t);-1!==e&&r.splice(e,1);}},t.EMPTY=function(t){return t.closed=!0,t}(new t),t}();function f(t){return t.reduce((function(t,r){return t.concat(r instanceof a?r.errors:r)}),[])}var l=function(){return "function"==typeof Symbol?Symbol("rxSubscriber"):"@@rxSubscriber_"+Math.random()}(),b=function(t){function r(e,n,o){var i=t.call(this)||this;switch(i.syncErrorValue=null,i.syncErrorThrown=!1,i.syncErrorThrowable=!1,i.isStopped=!1,arguments.length){case 0:i.destination=c;break;case 1:if(!e){i.destination=c;break}if("object"==typeof e){e instanceof r?(i.syncErrorThrowable=e.syncErrorThrowable,i.destination=e,e.add(i)):(i.syncErrorThrowable=!0,i.destination=new y(i,e));break}default:i.syncErrorThrowable=!0,i.destination=new y(i,e,n,o);}return i}return e(r,t),r.prototype[l]=function(){return this},r.create=function(t,e,n){var o=new r(t,e,n);return o.syncErrorThrowable=!1,o},r.prototype.next=function(t){this.isStopped||this._next(t);},r.prototype.error=function(t){this.isStopped||(this.isStopped=!0,this._error(t));},r.prototype.complete=function(){this.isStopped||(this.isStopped=!0,this._complete());},r.prototype.unsubscribe=function(){this.closed||(this.isStopped=!0,t.prototype.unsubscribe.call(this));},r.prototype._next=function(t){this.destination.next(t);},r.prototype._error=function(t){this.destination.error(t),this.unsubscribe();},r.prototype._complete=function(){this.destination.complete(),this.unsubscribe();},r.prototype._unsubscribeAndRecycle=function(){var t=this._parentOrParents;return this._parentOrParents=null,this.unsubscribe(),this.closed=!1,this.isStopped=!1,this._parentOrParents=t,this},r}(p),y=function(t){function r(r,e,n,i){var s,u=t.call(this)||this;u._parentSubscriber=r;var h=u;return o(e)?s=e:e&&(s=e.next,n=e.error,i=e.complete,e!==c&&(o((h=Object.create(e)).unsubscribe)&&u.add(h.unsubscribe.bind(h)),h.unsubscribe=u.unsubscribe.bind(u))),u._context=h,u._next=s,u._error=n,u._complete=i,u}return e(r,t),r.prototype.next=function(t){if(!this.isStopped&&this._next){var r=this._parentSubscriber;s.useDeprecatedSynchronousErrorHandling&&r.syncErrorThrowable?this.__tryOrSetError(r,this._next,t)&&this.unsubscribe():this.__tryOrUnsub(this._next,t);}},r.prototype.error=function(t){if(!this.isStopped){var r=this._parentSubscriber,e=s.useDeprecatedSynchronousErrorHandling;if(this._error)e&&r.syncErrorThrowable?(this.__tryOrSetError(r,this._error,t),this.unsubscribe()):(this.__tryOrUnsub(this._error,t),this.unsubscribe());else if(r.syncErrorThrowable)e?(r.syncErrorValue=t,r.syncErrorThrown=!0):u(t),this.unsubscribe();else {if(this.unsubscribe(),e)throw t;u(t);}}},r.prototype.complete=function(){var t=this;if(!this.isStopped){var r=this._parentSubscriber;if(this._complete){var e=function(){return t._complete.call(t._context)};s.useDeprecatedSynchronousErrorHandling&&r.syncErrorThrowable?(this.__tryOrSetError(r,e),this.unsubscribe()):(this.__tryOrUnsub(e),this.unsubscribe());}else this.unsubscribe();}},r.prototype.__tryOrUnsub=function(t,r){try{t.call(this._context,r);}catch(t){if(this.unsubscribe(),s.useDeprecatedSynchronousErrorHandling)throw t;u(t);}},r.prototype.__tryOrSetError=function(t,r,e){if(!s.useDeprecatedSynchronousErrorHandling)throw new Error("bad call");try{r.call(this._context,e);}catch(r){return s.useDeprecatedSynchronousErrorHandling?(t.syncErrorValue=r,t.syncErrorThrown=!0,!0):(u(r),!0)}return !1},r.prototype._unsubscribe=function(){var t=this._parentSubscriber;this._context=null,this._parentSubscriber=null,t.unsubscribe();},r}(b);var d=function(){return "function"==typeof Symbol&&Symbol.observable||"@@observable"}();function v(){}function _(t){return t?1===t.length?t[0]:function(r){return t.reduce((function(t,r){return r(t)}),r)}:v}var w=function(){function t(t){this._isScalar=!1,t&&(this._subscribe=t);}return t.prototype.lift=function(r){var e=new t;return e.source=this,e.operator=r,e},t.prototype.subscribe=function(t,r,e){var n=this.operator,o=function(t,r,e){if(t){if(t instanceof b)return t;if(t[l])return t[l]()}return t||r||e?new b(t,r,e):new b(c)}(t,r,e);if(n?o.add(n.call(o,this.source)):o.add(this.source||s.useDeprecatedSynchronousErrorHandling&&!o.syncErrorThrowable?this._subscribe(o):this._trySubscribe(o)),s.useDeprecatedSynchronousErrorHandling&&o.syncErrorThrowable&&(o.syncErrorThrowable=!1,o.syncErrorThrown))throw o.syncErrorValue;return o},t.prototype._trySubscribe=function(t){try{return this._subscribe(t)}catch(r){s.useDeprecatedSynchronousErrorHandling&&(t.syncErrorThrown=!0,t.syncErrorValue=r),!function(t){for(;t;){var r=t,e=r.closed,n=r.destination,o=r.isStopped;if(e||o)return !1;t=n&&n instanceof b?n:null;}return !0}(t)?console.warn(r):t.error(r);}},t.prototype.forEach=function(t,r){var e=this;return new(r=E(r))((function(r,n){var o;o=e.subscribe((function(r){try{t(r);}catch(t){n(t),o&&o.unsubscribe();}}),n,r);}))},t.prototype._subscribe=function(t){var r=this.source;return r&&r.subscribe(t)},t.prototype[d]=function(){return this},t.prototype.pipe=function(){for(var t=[],r=0;r<arguments.length;r++)t[r]=arguments[r];return 0===t.length?this:_(t)(this)},t.prototype.toPromise=function(t){var r=this;return new(t=E(t))((function(t,e){var n;r.subscribe((function(t){return n=t}),(function(t){return e(t)}),(function(){return t(n)}));}))},t.create=function(r){return new t(r)},t}();function E(t){if(t||(t=Promise),!t)throw new Error("no Promise impl found");return t}var g=function(){function t(){return Error.call(this),this.message="object unsubscribed",this.name="ObjectUnsubscribedError",this}return t.prototype=Object.create(Error.prototype),t}(),S=function(t){function r(r,e){var n=t.call(this)||this;return n.subject=r,n.subscriber=e,n.closed=!1,n}return e(r,t),r.prototype.unsubscribe=function(){if(!this.closed){this.closed=!0;var t=this.subject,r=t.observers;if(this.subject=null,r&&0!==r.length&&!t.isStopped&&!t.closed){var e=r.indexOf(this.subscriber);-1!==e&&r.splice(e,1);}}},r}(p),m=function(t){function r(r){var e=t.call(this,r)||this;return e.destination=r,e}return e(r,t),r}(b),x=function(t){function r(){var r=t.call(this)||this;return r.observers=[],r.closed=!1,r.isStopped=!1,r.hasError=!1,r.thrownError=null,r}return e(r,t),r.prototype[l]=function(){return new m(this)},r.prototype.lift=function(t){var r=new O(this,this);return r.operator=t,r},r.prototype.next=function(t){if(this.closed)throw new g;if(!this.isStopped)for(var r=this.observers,e=r.length,n=r.slice(),o=0;o<e;o++)n[o].next(t);},r.prototype.error=function(t){if(this.closed)throw new g;this.hasError=!0,this.thrownError=t,this.isStopped=!0;for(var r=this.observers,e=r.length,n=r.slice(),o=0;o<e;o++)n[o].error(t);this.observers.length=0;},r.prototype.complete=function(){if(this.closed)throw new g;this.isStopped=!0;for(var t=this.observers,r=t.length,e=t.slice(),n=0;n<r;n++)e[n].complete();this.observers.length=0;},r.prototype.unsubscribe=function(){this.isStopped=!0,this.closed=!0,this.observers=null;},r.prototype._trySubscribe=function(r){if(this.closed)throw new g;return t.prototype._trySubscribe.call(this,r)},r.prototype._subscribe=function(t){if(this.closed)throw new g;return this.hasError?(t.error(this.thrownError),p.EMPTY):this.isStopped?(t.complete(),p.EMPTY):(this.observers.push(t),new S(this,t))},r.prototype.asObservable=function(){var t=new w;return t.source=this,t},r.create=function(t,r){return new O(t,r)},r}(w),O=function(t){function r(r,e){var n=t.call(this)||this;return n.destination=r,n.source=e,n}return e(r,t),r.prototype.next=function(t){var r=this.destination;r&&r.next&&r.next(t);},r.prototype.error=function(t){var r=this.destination;r&&r.error&&this.destination.error(t);},r.prototype.complete=function(){var t=this.destination;t&&t.complete&&this.destination.complete();},r.prototype._subscribe=function(t){return this.source?this.source.subscribe(t):p.EMPTY},r}(x),T=function(t){function r(r){var e=t.call(this)||this;return e._value=r,e}return e(r,t),Object.defineProperty(r.prototype,"value",{get:function(){return this.getValue()},enumerable:!0,configurable:!0}),r.prototype._subscribe=function(r){var e=t.prototype._subscribe.call(this,r);return e&&!e.closed&&r.next(this._value),e},r.prototype.getValue=function(){if(this.hasError)throw this.thrownError;if(this.closed)throw new g;return this._value},r.prototype.next=function(r){t.prototype.next.call(this,this._value=r);},r}(x);var P=function(){function t(t,r){this.predicate=t,this.thisArg=r;}return t.prototype.call=function(t,r){return r.subscribe(new j(t,this.predicate,this.thisArg))},t}(),j=function(t){function r(r,e,n){var o=t.call(this,r)||this;return o.predicate=e,o.thisArg=n,o.count=0,o}return e(r,t),r.prototype._next=function(t){var r;try{r=this.predicate.call(this.thisArg,t,this.count++);}catch(t){return void this.destination.error(t)}r&&this.destination.next(t);},r}(b);function D(t,r,e){return function(n){return n.lift(new H(t,r,e))}}var H=function(){function t(t,r,e){this.nextOrObserver=t,this.error=r,this.complete=e;}return t.prototype.call=function(t,r){return r.subscribe(new B(t,this.nextOrObserver,this.error,this.complete))},t}(),B=function(t){function r(r,e,n,i){var s=t.call(this,r)||this;return s._tapNext=v,s._tapError=v,s._tapComplete=v,s._tapError=n||v,s._tapComplete=i||v,o(e)?(s._context=s,s._tapNext=e):e&&(s._context=e,s._tapNext=e.next||v,s._tapError=e.error||v,s._tapComplete=e.complete||v),s}return e(r,t),r.prototype._next=function(t){try{this._tapNext.call(this._context,t);}catch(t){return void this.destination.error(t)}this.destination.next(t);},r.prototype._error=function(t){try{this._tapError.call(this._context,t);}catch(t){return void this.destination.error(t)}this.destination.error(t);},r.prototype._complete=function(){try{this._tapComplete.call(this._context);}catch(t){return void this.destination.error(t)}return this.destination.complete()},r}(b),M=function(t,r,e){void 0===t&&(t="default"),void 0===r&&(r=void 0),void 0===e&&(e="behavior"),this.type=t,this.data=r,this.category=e;},V="undefined"!=typeof window&&"undefined"!=typeof document?window:{},A=function(){function t(){this.subs=new Map,this.behaviorSubs=new Map,this.options={enableLogging:!1};}return t.getInstance=function(r){var e=V.__EVENT_BUS__;return e||(e=V.__EVENT_BUS__=new t),r&&e.setOptions(r),e},t.prototype.publish=function(t){switch(this.options.enableLogging&&console.log("publishing event ",t),this.validateEventType(t.type),t.category){case"behavior":this.ensureBehaviorSub(t.type),this.behaviorSubs.get(t.type).next(t);break;default:this.ensureSub(t.type),this.subs.get(t.type).next(t);}},t.prototype.subscribe=function(t,r,e){switch(void 0===e&&(e={eventCategory:"simple"}),this.validateEventType(t),e.eventCategory){case"behavior":return this.subscribeBehavior(t,r);default:return this.subscribeDefault(t,r)}},t.prototype.setOptions=function(t){this.options=n(n({},this.options),t);},t.prototype.subscribeBehavior=function(t,r){var e,n,o=this;return this.ensureBehaviorSub(t),this.behaviorSubs.get(t).asObservable().pipe((e=function(t){return !(t instanceof M)},function(t){return t.lift(new P(e,n))}),D((function(t){return o.options.enableLogging&&console.log("handling behavior event ",t)}))).subscribe(r)},t.prototype.subscribeDefault=function(t,r){var e=this;return this.ensureSub(t),this.subs.get(t).asObservable().pipe(D((function(t){return e.options.enableLogging&&console.log("handling event ",t)}))).subscribe(r)},t.prototype.validateEventType=function(t){if(!t)throw new Error("Event with an empty type.")},t.prototype.ensureSub=function(t){this.subs.has(t)||this.subs.set(t,new x);},t.prototype.ensureBehaviorSub=function(t){this.behaviorSubs.has(t)||this.behaviorSubs.set(t,new T(new M));},t}();t.DefaultBehaviorEvent=M,t.EventBus=A,Object.defineProperty(t,"__esModule",{value:!0});}));
} (dist$1, distExports));

const publishNotification$1 = (data) => {
    const errorNotification = {
        type: 'app:notification',
        data,
        category: 'simple',
    };
    distExports.EventBus.getInstance().publish(errorNotification);
};
const publishErrorNotification$1 = (message) => {
    const data = {
        type: 'error',
        message,
        options: { autoClose: false },
    };
    publishNotification$1(data);
};

var Feature$2;
(function (Feature) {
    Feature["ApproveByBank"] = "contract-kit-approve-by-bank";
    Feature["BirthCertificate"] = "dc-alternative-birth-certificate";
    Feature["LinkedDealsTab"] = "sbr-linked-deals-tab";
    Feature["DealNavigation"] = "dc-deal-navigation";
    Feature["ElectronicMortgage"] = "alternative-electronic-mortgage-available";
    Feature["SuburbanDeals"] = "alternative-suburban-deals";
})(Feature$2 || (Feature$2 = {}));
React.createContext(null);

const withDisabled = (Component) => {
    const DisableableField = (props) => (React.createElement(DisableableFormContext.Consumer, null, ({ disabled }) => (React.createElement(Component, { ...props, disabled: props.importantDisabled !== undefined ? props.importantDisabled : disabled || props.disabled }))));
    DisableableField.displayName = `withDisabled(${getDisplayName(Component)})`;
    return DisableableField;
};

const withWarning = (FieldComponent) => {
    const FieldWithWarning = (props) => {
        var _a, _b, _c, _d, _e;
        const error = props.meta.submitError || props.meta.error || props.errorMessage;
        const isModified = props.meta.touched && props.meta.dirtySinceLastSubmit;
        const showWarning = ((_a = props.meta) === null || _a === void 0 ? void 0 : _a.touched) && ((_c = (_b = props.meta) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.warning);
        const showError = error && !isModified;
        const isActive = props.meta.active && !showError;
        const isValid = !showError && !showWarning;
        const errorMessage = ((_e = (_d = props.meta) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.warning) || error;
        const touched = props.meta.touched || !!error;
        return (React.createElement(FieldComponent, { ...props, label: props.label, input: props.input, meta: { ...props.meta, touched, active: isActive, error: errorMessage, valid: isValid } }));
    };
    FieldWithWarning.displayName = `withWarning(${getDisplayName(FieldComponent)})`;
    return FieldWithWarning;
};

var css_248z$X = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.badge-module_container__9d5OX{align-items:center;border-radius:2px;box-sizing:border-box;color:#fff;display:inline-flex;font:400 12px/16px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.badge-module_clickable__su984{background:none;border:none;cursor:pointer}.badge-module_s__Xo17D{padding:2px 8px}.badge-module_m__w549N{padding:4px 8px}.badge-module_l__K1-NJ{font:400 14px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;padding:6px 12px}.badge-module_icon__Yt3JU{line-height:1em}.badge-module_icon__Yt3JU.badge-module_start__36Uyx{margin:0 4px 0 0}.badge-module_icon__Yt3JU.badge-module_end__aeaPX{margin:0 0 0 4px}.badge-module_icon__Yt3JU.badge-module_only__x6pHm{margin:0 -4px;padding:2px 0}.badge-module_container__9d5OX.badge-module_m__w549N .badge-module_icon__Yt3JU.badge-module_only__x6pHm{margin:0 -2px}.badge-module_primary__MEOYc.badge-module_solid__IvPsY{background-color:#3416b6;color:#fff}.badge-module_primary__MEOYc.badge-module_light__O26aZ{background-color:#a391f3;color:#3416b6}.badge-module_accent__zJEaM.badge-module_solid__IvPsY{background-color:#ff794d;color:#fff}.badge-module_accent__zJEaM.badge-module_light__O26aZ{background-color:#ffc9b8;color:#eb3b00}.badge-module_error__VrlJd.badge-module_solid__IvPsY{background-color:#f44434;color:#fff}.badge-module_error__VrlJd.badge-module_light__O26aZ{background-color:#fdb1aa;color:#cb1b0b}.badge-module_warn__IlALj.badge-module_solid__IvPsY{background-color:#fac32e;color:#211f2e}.badge-module_warn__IlALj.badge-module_light__O26aZ{background-color:#fee7a9;color:#d19b05}.badge-module_success__cDjM1.badge-module_solid__IvPsY{background-color:#87d232;color:#fff}.badge-module_success__cDjM1.badge-module_light__O26aZ{background-color:#caf49a;color:#6dab26}.badge-module_blue__P31RU.badge-module_solid__IvPsY{background-color:#3416b6}.badge-module_blue__P31RU.badge-module_light__O26aZ{background-color:#ccc2fa;color:#271188}.badge-module_orange__pCuLU.badge-module_solid__IvPsY{background-color:#ff794d}.badge-module_orange__pCuLU.badge-module_light__O26aZ{background-color:#ffc9b8;color:#eb3b00}.badge-module_red__HHoMz.badge-module_solid__IvPsY{background-color:#f44434}.badge-module_red__HHoMz.badge-module_light__O26aZ{background-color:#fdb1aa;color:#cb1b0b}.badge-module_yellow__6fmN9.badge-module_solid__IvPsY{background-color:#fac32e;color:#211f2e}.badge-module_yellow__6fmN9.badge-module_light__O26aZ{background-color:#fee7a9;color:#d19b05}.badge-module_turquoise__ynDqB.badge-module_solid__IvPsY{background-color:#28b8bd}.badge-module_turquoise__ynDqB.badge-module_light__O26aZ{background-color:#9bf0f3;color:#1f8f93}.badge-module_purple__BeUWI.badge-module_solid__IvPsY{background-color:#6544f8}.badge-module_purple__BeUWI.badge-module_light__O26aZ{background-color:#e3dcfe;color:#8e75fa}.badge-module_green__kOf0j.badge-module_solid__IvPsY{background-color:#87d232}.badge-module_green__kOf0j.badge-module_light__O26aZ{background-color:#caf49a;color:#6dab26}.badge-module_black__9m4-7.badge-module_light__O26aZ,.badge-module_gray__xspHg.badge-module_solid__IvPsY{background-color:#6e6a81}.badge-module_lightgray__2SD7X.badge-module_solid__IvPsY{background-color:rgba(150,142,190,.2);color:#211f2e}.badge-module_lightgray-solid__nuqKM.badge-module_solid__IvPsY{background-color:#eae9f2;color:#211f2e}.badge-module_gray__xspHg.badge-module_light__O26aZ,.badge-module_lightgray__2SD7X.badge-module_light__O26aZ{background-color:rgba(150,142,190,.2);color:rgba(73,68,95,.8)}.badge-module_lightgray-solid__nuqKM.badge-module_light__O26aZ{background-color:#eae9f2;color:#6e6a81}.badge-module_black__9m4-7.badge-module_solid__IvPsY{background-color:#211f2e}.badge-module_white__hm9jB.badge-module_solid__IvPsY{background-color:hsla(0,0%,100%,.32);color:#fff}.badge-module_white__hm9jB.badge-module_light__O26aZ{background-color:hsla(0,0%,100%,.16);color:hsla(0,0%,100%,.64)}";
var s$e = {"container":"badge-module_container__9d5OX","clickable":"badge-module_clickable__su984","s":"badge-module_s__Xo17D","m":"badge-module_m__w549N","l":"badge-module_l__K1-NJ","icon":"badge-module_icon__Yt3JU","start":"badge-module_start__36Uyx","end":"badge-module_end__aeaPX","only":"badge-module_only__x6pHm","primary":"badge-module_primary__MEOYc","solid":"badge-module_solid__IvPsY","light":"badge-module_light__O26aZ","accent":"badge-module_accent__zJEaM","error":"badge-module_error__VrlJd","warn":"badge-module_warn__IlALj","success":"badge-module_success__cDjM1","blue":"badge-module_blue__P31RU","orange":"badge-module_orange__pCuLU","red":"badge-module_red__HHoMz","yellow":"badge-module_yellow__6fmN9","turquoise":"badge-module_turquoise__ynDqB","purple":"badge-module_purple__BeUWI","green":"badge-module_green__kOf0j","gray":"badge-module_gray__xspHg","black":"badge-module_black__9m4-7","lightgray":"badge-module_lightgray__2SD7X","lightgray-solid":"badge-module_lightgray-solid__nuqKM","white":"badge-module_white__hm9jB"};
styleInject(css_248z$X);

const Badge$1 = ({ size = 'm', color, variant = 'solid', children, onClick, dataTest, icon, tag, iconPosition = 'start', }) => {
    const BadgeTag = tag || (onClick ? 'button' : 'span');
    return (React.createElement(BadgeTag, { "data-test": dataTest, "data-badge": true, onClick: onClick, className: cn(s$e.container, s$e[size], s$e[color], s$e[variant], onClick && s$e.clickable) },
        icon && iconPosition === 'start' && (React.createElement("span", { className: cn(s$e.icon, s$e.start, !children && s$e.only) },
            React.createElement(Icon$4, { name: icon, size: "s" }))),
        children,
        icon && iconPosition === 'end' && (React.createElement("span", { className: cn(s$e.icon, s$e.end, !children && s$e.only) },
            React.createElement(Icon$4, { name: icon, size: "s" })))));
};

const CheckboxFilteredProps = function (props) {
    const rest = __rest(props, ["isValid", "isError", "errorMessage", "fullWidth", "label", "note", "hideNoteSpace"]);
    return React.createElement(Checkbox$1, rest);
};
const CheckboxField = Field$3(CheckboxFilteredProps, true, false);

function useSlots(component, children) {
    return React.useMemo(() => React.Children.toArray(children).reduce((res, el) => {
        var _a, _b;
        const [target, slot] = ((_b = (_a = el === null || el === void 0 ? void 0 : el.type) === null || _a === void 0 ? void 0 : _a.slot) === null || _b === void 0 ? void 0 : _b.split(':')) || [];
        if (!target || target !== component) {
            res['children'] = [...(res['children'] || []), el];
        }
        if (target === component && slot) {
            res[slot] = [...(res[slot] || []), el];
        }
        return res;
    }, {}), [children, component]);
}

var css_248z$W = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.link-module_reset__aEH-m{color:currentColor;cursor:pointer;-webkit-text-decoration:none;text-decoration:none}.link-module_body__ndBeH{align-items:center;display:inline-flex;font:400 16px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.link-module_external__kugB5{line-height:1;margin-left:4px}.link-module_body__ndBeH{color:#3416b6}.link-module_body__ndBeH:hover{color:#ff794d}.link-module_body__ndBeH.link-module_visited__Pg-Mj:visited{color:#271188}.link-module_body__ndBeH.link-module_minor__UUU2X{color:#6b4fe8}.link-module_body__ndBeH.link-module_minor__UUU2X:hover{color:#ffa78a}.link-module_body__ndBeH.link-module_minor__UUU2X.link-module_visited__Pg-Mj:visited{color:#6b4fe8}.link-module_body__ndBeH.link-module_text__YiS0D{color:#211f2e}.link-module_body__ndBeH.link-module_text__YiS0D:hover{color:#3416b6}.link-module_body__ndBeH.link-module_text__YiS0D.link-module_visited__Pg-Mj:visited{color:#211f2e}.link-module_body__ndBeH.link-module_alt-bg__UGOpf{color:#ff794d}.link-module_body__ndBeH.link-module_alt-bg__UGOpf:hover{color:var(--c-text-link-hover-alt-bg)}.link-module_body__ndBeH.link-module_alt-bg__UGOpf.link-module_visited__Pg-Mj:visited{color:#ff794d}.link-module_body__ndBeH.link-module_minor__UUU2X.link-module_alt-bg__UGOpf{color:#ffa78a}.link-module_body__ndBeH.link-module_minor__UUU2X.link-module_alt-bg__UGOpf:hover{color:var(--c-text-link-minor-hover-alt-bg)}.link-module_body__ndBeH.link-module_minor__UUU2X.link-module_alt-bg__UGOpf.link-module_visited__Pg-Mj:visited{color:#ffa78a}.link-module_body__ndBeH.link-module_text__YiS0D.link-module_alt-bg__UGOpf{color:#fff}.link-module_body__ndBeH.link-module_text__YiS0D.link-module_alt-bg__UGOpf:hover{color:var(--c-text-link-minor-hover-alt-bg)}.link-module_body__ndBeH.link-module_text__YiS0D.link-module_alt-bg__UGOpf.link-module_visited__Pg-Mj:visited{color:#ffa78a}.link-module_body__ndBeH.link-module_secondary__cvhno{color:rgba(73,68,95,.8)}.link-module_body__ndBeH.link-module_secondary__cvhno:hover{color:#ff794d}.link-module_body__ndBeH.link-module_secondary__cvhno.link-module_visited__Pg-Mj:visited{color:#6e6a81}";
var s$d = {"reset":"link-module_reset__aEH-m","body":"link-module_body__ndBeH","external":"link-module_external__kugB5","visited":"link-module_visited__Pg-Mj","minor":"link-module_minor__UUU2X","text":"link-module_text__YiS0D","alt-bg":"link-module_alt-bg__UGOpf","secondary":"link-module_secondary__cvhno"};
styleInject(css_248z$W);

const variantRegexp = /(primary)|(minor)|(alt-bg)|(text)|(secondary)/g;
const useVariant = (variant) => React.useMemo(() => variant.match(variantRegexp) || [], [variant]);
const useRel = (rel, target) => {
    var _a;
    const prefix = target === 'blank' && !(rel === null || rel === void 0 ? void 0 : rel.includes('noopener')) ? `noopener ` : '';
    return `${prefix}${(_a = rel === null || rel === void 0 ? void 0 : rel.join('  ')) !== null && _a !== void 0 ? _a : ''}`;
};

var lib = {};

var HashLink_1;

Object.defineProperty(lib, "__esModule", {
  value: true
});
lib.NavHashLink = HashLink_1 = lib.HashLink = undefined;

var _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

lib.genericHashLink = genericHashLink;

var _react = React;

var _react2 = _interopRequireDefault$1(_react);

var _propTypes = propTypesExports;

var _propTypes2 = _interopRequireDefault$1(_propTypes);

var _reactRouterDom = require$$2;

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$2(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var hashFragment = '';
var observer = null;
var asyncTimerId = null;
var scrollFunction = null;

function reset() {
  hashFragment = '';
  if (observer !== null) observer.disconnect();
  if (asyncTimerId !== null) {
    window.clearTimeout(asyncTimerId);
    asyncTimerId = null;
  }
}

function getElAndScroll() {
  var element = document.getElementById(hashFragment);
  if (element !== null) {
    scrollFunction(element);
    reset();
    return true;
  }
  return false;
}

function hashLinkScroll() {
  // Push onto callback queue so it runs after the DOM is updated
  window.setTimeout(function () {
    if (getElAndScroll() === false) {
      if (observer === null) {
        observer = new MutationObserver(getElAndScroll);
      }
      observer.observe(document, {
        attributes: true,
        childList: true,
        subtree: true
      });
      // if the element doesn't show up in 10 seconds, stop checking
      asyncTimerId = window.setTimeout(function () {
        reset();
      }, 10000);
    }
  }, 0);
}

function genericHashLink(As) {
  return _react2.default.forwardRef(function (props, ref) {
    function handleClick(e) {
      reset();
      if (props.onClick) props.onClick(e);
      if (typeof props.to === 'string') {
        hashFragment = props.to.split('#').slice(1).join('#');
      } else if (_typeof$1(props.to) === 'object' && typeof props.to.hash === 'string') {
        hashFragment = props.to.hash.replace('#', '');
      }
      if (hashFragment !== '') {
        scrollFunction = props.scroll || function (el) {
          return props.smooth ? el.scrollIntoView({ behavior: "smooth" }) : el.scrollIntoView();
        };
        hashLinkScroll();
      }
    }

    props.scroll;
        props.smooth;
        var filteredProps = _objectWithoutProperties$2(props, ['scroll', 'smooth']);

    return _react2.default.createElement(
      As,
      _extends$3({}, filteredProps, { onClick: handleClick, ref: ref }),
      props.children
    );
  });
}

var HashLink = HashLink_1 = lib.HashLink = genericHashLink(_reactRouterDom.Link);

var NavHashLink = lib.NavHashLink = genericHashLink(_reactRouterDom.NavLink);

var propTypes = {
  onClick: _propTypes2.default.func,
  children: _propTypes2.default.node,
  scroll: _propTypes2.default.func,
  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
};

HashLink.propTypes = propTypes;
NavHashLink.propTypes = propTypes;

const RouterHashLink = (props) => React.createElement(HashLink_1, Object.assign({}, props, { smooth: true }));
const RRLink = ({ href = '', target = 'self', children, text: body = true, variant = 'primary', external = false, rel: externalRel, dataTest, onClick, gtm, visited, to: toProp, }) => {
    const to = toProp || href;
    const isHashLink = React.useMemo(() => (typeof to === 'string' && to.indexOf('#') > -1) || (typeof to === 'object' && to.hash), [to]);
    const LinkComponent = (isHashLink ? RouterHashLink : require$$2.Link);
    const variants = useVariant(variant);
    const rel = useRel(externalRel, target);
    return (React.createElement(LinkComponent, { target: '_' + target, className: cn(s$d.reset, body && s$d.body, visited && s$d.visited, ...variants.map(v => s$d[v])), to: to, rel: rel, "data-test": dataTest, "data-gtm": gtm, onClick: onClick },
        children,
        body && external && (React.createElement("span", { className: s$d.external },
            React.createElement(Icon$4, { name: "square-arrow", size: "s" })))));
};
var RRLink$1 = RRLink;

const RRLinkButton = (_a) => {
    var { href, children, dataTest, onClick, gtm, target, rel, disabled } = _a, buttonProps = __rest(_a, ["href", "children", "dataTest", "onClick", "gtm", "target", "rel", "disabled"]);
    return disabled ? (React.createElement(Button$3, Object.assign({}, buttonProps, { disabled: true, dataTest: dataTest, gtm: gtm, type: "button" }), children)) : (React.createElement(RRLink$1, { href: href, target: target, rel: rel, text: false, external: false, dataTest: dataTest, gtm: gtm, onClick: onClick },
        React.createElement(Button$3, Object.assign({}, buttonProps, { dataTest: dataTest, gtm: gtm, type: "button" }), children)));
};
var RRLinkButton$1 = RRLinkButton;

var css_248z$V = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.modal-module_root__tL-13{position:absolute;z-index:101}.modal-module_container__46v4m{align-items:center;bottom:0;display:flex;flex-direction:column;justify-content:center;left:0;opacity:0;position:fixed;right:0;top:0;transition:.24s cubic-bezier(.24,.1,.24,1) .16s;transition-property:opacity,visibility;visibility:hidden}.modal-module_container__46v4m.modal-module_in__J7Jpw{opacity:1;transition-delay:0ms;transition-duration:.4s;visibility:visible}.modal-module_overlay__PsIQk{background-color:rgba(105,99,131,.6);bottom:0;left:0;position:absolute;right:0;top:0}.modal-module_scrollable__zhwEV{-webkit-overflow-scrolling:touch;-ms-overflow-style:none;overflow-y:scroll;scrollbar-width:none;width:100%}.modal-module_scrollable__zhwEV::-webkit-scrollbar{display:none}.modal-module_scrollable__zhwEV:before{position:absolute;visibility:hidden}.modal-module_content__qxxqC{opacity:0;transform:scale(.88)}.modal-module_content__qxxqC.modal-module_overflow__CBJHO{overflow:hidden}.modal-module_container__46v4m.modal-module_in__J7Jpw .modal-module_content__qxxqC{animation:modal-module_modal-in__KGrpd .4s cubic-bezier(.24,.1,.24,1) .16s forwards}.modal-module_container__46v4m.modal-module_out__zYtFm .modal-module_content__qxxqC{animation:modal-module_modal-out__FGgDL .24s cubic-bezier(.24,.1,.24,1) forwards}.modal-module_close__d9xj-{background:none;border:none;color:rgba(73,68,95,.8);cursor:pointer;padding:0;position:absolute}@keyframes modal-module_modal-in__KGrpd{0%{opacity:0;transform:scale(.88)}to{opacity:1;transform:scale(1)}}@keyframes modal-module_modal-out__FGgDL{0%{opacity:1;transform:scale(1)}to{opacity:0;transform:scale(.88)}}@media screen and (max-width:767px){.modal-module_scrollable__zhwEV{position:relative}.modal-module_scrollable__zhwEV:before{content:\"xs\"}.modal-module_container__46v4m{justify-content:flex-end}.modal-module_container__46v4m.modal-module_mobile__fQCi-{justify-content:flex-start}.modal-module_container__46v4m.modal-module_mobile__fQCi- .modal-module_scrollable__zhwEV{display:flex;flex:1 1}.modal-module_container__46v4m.modal-module_mobile__fQCi- .modal-module_content__qxxqC{border-radius:0;border-radius:initial;flex:1 1;margin:0;max-height:100vh;overflow:hidden}.modal-module_closable__9msQi{display:flex;height:44px;justify-content:flex-end;left:0;padding:10px;position:absolute;right:0;top:0}.modal-module_close__d9xj-{color:#fff;display:flex;flex-direction:column;justify-content:center;position:static;width:16px}}@media screen and (min-width:768px) and (max-width:959px){.modal-module_container__46v4m.modal-module_s__Ox0zu .modal-module_content__qxxqC{width:480px}.modal-module_container__46v4m.modal-module_l__NE276 .modal-module_content__qxxqC,.modal-module_container__46v4m.modal-module_m__yewyr .modal-module_content__qxxqC,.modal-module_container__46v4m.modal-module_xl__chrWJ .modal-module_content__qxxqC,.modal-module_container__46v4m.modal-module_xxl__oxJta .modal-module_content__qxxqC{width:640px}}@media screen and (min-width:768px){.modal-module_close__d9xj-{background-color:#fff;border-radius:50%;box-sizing:border-box;display:flex;height:32px;padding:8px;right:8px;top:8px;transition:background-color .24s cubic-bezier(.24,.1,.24,1);width:32px}.modal-module_close__d9xj-:hover{background-color:#f3f1f8}}@media screen and (min-width:960px){.modal-module_container__46v4m.modal-module_s__Ox0zu .modal-module_content__qxxqC{width:480px}.modal-module_container__46v4m.modal-module_m__yewyr .modal-module_content__qxxqC{width:640px}.modal-module_container__46v4m.modal-module_l__NE276 .modal-module_content__qxxqC,.modal-module_container__46v4m.modal-module_xl__chrWJ .modal-module_content__qxxqC,.modal-module_container__46v4m.modal-module_xxl__oxJta .modal-module_content__qxxqC{width:800px}}@media screen and (min-width:1200px){.modal-module_container__46v4m.modal-module_xl__chrWJ .modal-module_content__qxxqC,.modal-module_container__46v4m.modal-module_xxl__oxJta .modal-module_content__qxxqC{width:1024px}}@media screen and (min-width:1420px){.modal-module_container__46v4m.modal-module_xxl__oxJta .modal-module_content__qxxqC{width:var(--s-unit-max)}}";
var s$c = {"root":"modal-module_root__tL-13","container":"modal-module_container__46v4m","in":"modal-module_in__J7Jpw","overlay":"modal-module_overlay__PsIQk","scrollable":"modal-module_scrollable__zhwEV","content":"modal-module_content__qxxqC","overflow":"modal-module_overflow__CBJHO","modal-in":"modal-module_modal-in__KGrpd","out":"modal-module_out__zYtFm","modal-out":"modal-module_modal-out__FGgDL","close":"modal-module_close__d9xj-","mobile":"modal-module_mobile__fQCi-","closable":"modal-module_closable__9msQi","s":"modal-module_s__Ox0zu","m":"modal-module_m__yewyr","l":"modal-module_l__NE276","xl":"modal-module_xl__chrWJ","xxl":"modal-module_xxl__oxJta"};
styleInject(css_248z$V);

const resizeHandlers = new Set();
const handleResize = (event) => resizeHandlers.forEach(handler => handler(event));
function useResize({ handler, debounce: time = 0, enabled = true }) {
    React.useEffect(() => {
        const prepared = time ? debounce$3(handler, time) : handler;
        let off = () => { };
        if (enabled) {
            resizeHandlers.add(prepared);
        }
        if (resizeHandlers.size === 1) {
            off = addEventListener('resize', handleResize);
        }
        return () => {
            resizeHandlers.delete(prepared);
            if (resizeHandlers.size === 0) {
                off();
            }
        };
    }, [handler, time, enabled]);
}

const context$1 = React.createContext({
    close: () => Promise.resolve(),
    closable: false,
    mobile: false,
    size: 'm',
});
function measureTextNode(node) {
    const range = document.createRange();
    range.selectNodeContents(node);
    const rects = range.getClientRects();
    return rects[0].height;
}
const margin = (raw) => Math.max(0, parseInt(raw, 10));
const origin = 8;
const limit = 24;
const padding = 48;
const paddingMobile = 24;
const TEXT_NODE = 3;
function useScrollShift(state, scrollable) {
    const bodyPadding = React.useRef(browser ? document.body.style.paddingRight : '0');
    const scrollPadding = React.useMemo(() => {
        if (!browser || state !== 'show' || !scrollable) {
            return null;
        }
        const modalOverflow = scrollable.scrollHeight > document.documentElement.clientHeight;
        const rect = document.body.getBoundingClientRect();
        const bodyOverflow = Math.round(rect.left + rect.right) < window.innerWidth;
        const scrollWidth = getScrollWidth();
        return (bodyOverflow && !modalOverflow) || (!bodyOverflow && modalOverflow) ? scrollWidth : null;
    }, [state, scrollable]);
    React.useEffect(() => {
        document.body.style.paddingRight = bodyPadding.current;
        if (!scrollPadding) {
            return;
        }
        const calculatedValue = Number.parseFloat(window.getComputedStyle(document.body).paddingRight);
        document.body.style.paddingRight = `${calculatedValue + scrollPadding}px`;
    }, [scrollPadding]);
    return scrollPadding;
}
function useMobile(el, enabled) {
    const [mobile, setMobile] = React.useState(false);
    const checkMobile = React.useCallback(() => {
        if (!el.current) {
            return;
        }
        setMobile(getElementPseudoContent(el.current) == 'xs');
    }, [el.current]);
    React.useEffect(() => checkMobile(), [checkMobile]);
    useResize({ handler: checkMobile, debounce: 200, enabled: !!enabled });
    return mobile;
}
function useFit({ scrollable, content, enabled, mobile }) {
    const [fit, setFit] = React.useState(true);
    const checkFit = React.useCallback(() => {
        if (!scrollable.current || !content.current) {
            return;
        }
        const availableHeight = getElementSize(scrollable.current).height;
        const contentHeight = Array.from(content.current.childNodes || []).reduce((res, item) => {
            const text = item.nodeType === TEXT_NODE;
            if (!text && item.classList.contains(s$c.close)) {
                return res;
            }
            const style = (!text && window.getComputedStyle(item));
            const height = text ? measureTextNode(item) : parseInt(style.height, 10);
            const margins = text ? 0 : margin(style.marginTop) + margin(style.marginBottom);
            return res + height + margins;
        }, 0);
        setFit(availableHeight - (contentHeight + (mobile ? paddingMobile : padding)) >= 0);
    }, [scrollable.current, content.current, mobile]);
    React.useEffect(() => checkFit(), [checkFit]);
    useResize({ handler: checkFit, debounce: 200, enabled: !!enabled });
    return fit;
}
function position(scrollable) {
    const current = scrollable.scrollTop;
    if (current <= limit) {
        return origin;
    }
    const offset = current - limit;
    return origin + offset;
}

var css_248z$U = "@media screen and (max-width:767px){.wide-content-module_box__ylG1e{margin:0 -16px}.wide-content-module_box__ylG1e.wide-content-module_scrollable__5C4VH.wide-content-module_mobile__v6tpz{flex-shrink:1;max-height:100%;min-height:0;overflow-y:auto}.wide-content-module_header__ygJ1Y{margin-top:-24px}.wide-content-module_footer__oDj-2{margin-bottom:-24px}}@media screen and (min-width:768px){.wide-content-module_box__ylG1e{margin:0 -48px}.wide-content-module_header__ygJ1Y{margin-top:-48px}.wide-content-module_footer__oDj-2{margin-bottom:-48px}}";
var s$b = {"box":"wide-content-module_box__ylG1e","scrollable":"wide-content-module_scrollable__5C4VH","mobile":"wide-content-module_mobile__v6tpz","header":"wide-content-module_header__ygJ1Y","footer":"wide-content-module_footer__oDj-2"};
styleInject(css_248z$U);

const WideContent = ({ children, onScroll, scrollable = false, header = false, footer = false }) => {
    const { size, mobile, dataTest } = React.useContext(context$1);
    const ignoreScroll = scrollable ? { 'data-scroll-lock-ignore': '' } : {};
    return (React.createElement("div", Object.assign({ className: cn(s$b.box, s$b[size], {
            [s$b.header]: header,
            [s$b.footer]: footer,
            [s$b.scrollable]: scrollable,
            [s$b.mobile]: mobile,
        }), "data-test": dataTest && `${dataTest}-wide-content`, onScroll: onScroll }, ignoreScroll), children));
};
var WideContent$1 = WideContent;

var css_248z$T = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.header-module_box__KznIs{align-items:center;border-bottom:1px solid rgba(127,120,161,.4);display:flex;padding:14px 16px;position:relative}.header-module_content__bFXR-{flex:1 1}.header-module_close__6Bffc{background:none;border:none;color:rgba(105,99,131,.6);cursor:pointer;padding:0;position:absolute;right:16px}";
var s$a = {"box":"header-module_box__KznIs","content":"header-module_content__bFXR-","close":"header-module_close__6Bffc"};
styleInject(css_248z$T);

const Header = ({ children }) => {
    const { close, closable, dataTest } = React.useContext(context$1);
    return (React.createElement(WideContent$1, { header: true },
        React.createElement("div", { className: s$a.box, "data-test": dataTest && `${dataTest}-header` },
            React.createElement("div", { className: s$a.content }, children),
            closable && (React.createElement("button", { className: s$a.close, onClick: close, "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C", "data-test": dataTest && `${dataTest}-close` },
                React.createElement(Icon$4, { name: "times", size: "s" }))))));
};
var Header$1 = Header;

var css_248z$S = "@media screen and (max-width:767px){.content-module_box__3NpRi{margin:0 -16px;padding:0 16px}.content-module_box__3NpRi.content-module_scrollable__tBZTu.content-module_mobile__n6eZk{flex-shrink:1;max-height:100%;min-height:0;overflow-y:auto}}@media screen and (min-width:768px){.content-module_box__3NpRi{margin:0 -48px;padding:0 48px}}";
var s$9 = {"box":"content-module_box__3NpRi","scrollable":"content-module_scrollable__tBZTu","mobile":"content-module_mobile__n6eZk"};
styleInject(css_248z$S);

const Content = ({ children, scrollable = false, onScroll }) => {
    const { mobile, dataTest } = React.useContext(context$1);
    const ignoreScroll = scrollable ? { 'data-scroll-lock-ignore': '' } : {};
    return (React.createElement("div", Object.assign({ className: cn(s$9.box, {
            [s$9.scrollable]: scrollable,
            [s$9.mobile]: mobile,
        }), onScroll: onScroll, "data-test": dataTest && `${dataTest}-content` }, ignoreScroll), children));
};
var Content$1 = Content;

var css_248z$R = ".picture-module_image__1eMHl{-o-object-fit:cover;object-fit:cover;width:100%}@media screen and (max-width:767px){.picture-module_image__1eMHl,.picture-module_wrapper__Am9gg{height:200px}}@media screen and (min-width:768px){.picture-module_image__1eMHl,.picture-module_wrapper__Am9gg{height:240px}}";
var s$8 = {"image":"picture-module_image__1eMHl","wrapper":"picture-module_wrapper__Am9gg"};
styleInject(css_248z$R);

const Source = (props) => {
    const { src, src2dpr, mimeType } = props;
    const srcSet = src && src2dpr ? `${src} 1x, ${src2dpr} 2x` : src;
    return React.createElement("source", { srcSet: srcSet, type: mimeType });
};
const Picture$1 = (props) => {
    const { alt, className } = props;
    const [src, src2dpr] = props.src;
    const [webp, webp2dpr] = props.webp || [];
    const fallbackImage = src2dpr || src;
    return (React.createElement("picture", null,
        props.webp && React.createElement(Source, { mimeType: "image/webp", src: webp, src2dpr: webp2dpr }),
        React.createElement(Source, { src: src, src2dpr: src2dpr }),
        React.createElement("img", { src: fallbackImage, alt: alt, className: className })));
};

const ModalPicture = (_a) => {
    var { header = true, footer = false } = _a, picture = __rest(_a, ["header", "footer"]);
    const { dataTest } = React.useContext(context$1);
    return (React.createElement(WideContent$1, { header: header, footer: footer },
        React.createElement("div", { className: s$8.wrapper, "data-test": dataTest && `${dataTest}-picture` },
            React.createElement(Picture$1, Object.assign({}, picture, { className: s$8.image })))));
};
var Picture = ModalPicture;

var css_248z$Q = ".title-module_text__5iD2S{font:500 22px/32px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;margin-bottom:16px}.title-module_text__5iD2S.title-module_picture__nwxko{margin-top:24px}";
var s$7 = {"text":"title-module_text__5iD2S","picture":"title-module_picture__nwxko"};
styleInject(css_248z$Q);

const Title$1 = ({ children, picture = false }) => {
    return React.createElement("div", { className: cn(s$7.text, picture && s$7.picture) }, children);
};
var Title$2 = Title$1;

var css_248z$P = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.actions-module_box__YB-0U{grid-column-gap:24px;grid-row-gap:16px;display:grid;grid-template-columns:1fr;justify-content:center}.actions-module_sticky__KeH8m{background-color:#fff;bottom:24px;margin-top:24px;position:sticky;z-index:10}.actions-module_sticky__KeH8m:before{background-color:#fff;content:\"\";height:24px;left:-48px;position:absolute;right:-48px;top:-24px}.actions-module_sticky__KeH8m.actions-module_shadow__3GfIn:before{box-shadow:0 -8px 8px rgba(41,48,61,.08)}.actions-module_sticky__KeH8m:after{background-color:#fff;content:\"\";height:48px;position:absolute;top:52px;width:100%}.actions-module_cover__2VhPT{height:1px;position:relative;top:76px;width:100%}@media screen and (min-width:768px){.actions-module_box__YB-0U:not(.actions-module_single__OLxld){grid-template-columns:repeat(2,1fr)}}@media screen and (max-width:767px){.actions-module_sticky__KeH8m:before{left:-16px;right:-16px}}";
var s$6 = {"box":"actions-module_box__YB-0U","sticky":"actions-module_sticky__KeH8m","shadow":"actions-module_shadow__3GfIn","cover":"actions-module_cover__2VhPT","single":"actions-module_single__OLxld"};
styleInject(css_248z$P);

const Actions$1 = ({ children }) => {
    const { dataTest } = React.useContext(context$1);
    const single = React.useMemo(() => React.Children.count(children) === 1, [children]);
    return (React.createElement("div", { className: cn(s$6.box, single && s$6.single), "data-test": dataTest && `${dataTest}-actions` }, children));
};
const isLegacyBrowser = typeof IntersectionObserver === 'undefined';
const StickyActions = ({ children }) => {
    const { dataTest } = React.useContext(context$1);
    const [shadow, setShadow] = React.useState(false);
    const coverRef = React.useRef(null);
    React.useEffect(() => {
        if (isLegacyBrowser) {
            return;
        }
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                setShadow(!entry.isIntersecting);
            });
        });
        if (coverRef && coverRef.current) {
            observer.observe(coverRef.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [setShadow]);
    if (isLegacyBrowser) {
        return React.createElement(Actions$1, null, children);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: coverRef, className: cn(s$6.cover) }),
        React.createElement("div", { className: cn(s$6.sticky, shadow && s$6.shadow), "data-test": dataTest && `${dataTest}-sticky-actions` },
            React.createElement(Actions$1, null, children))));
};
var Actions$2 = Actions$1;

var css_248z$O = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.modal-content-layout-module_container__79RFy{background-color:#fff;border-radius:8px;box-shadow:0 8px 32px rgba(33,31,46,.16);box-sizing:border-box;font-size:16px;font-weight:400;line-height:24px;margin:24px auto;padding:48px;position:relative}@media screen and (max-width:767px){.modal-content-layout-module_container__79RFy{-ms-overflow-style:none;border-bottom-left-radius:0;border-bottom-right-radius:0;margin:44px auto 0;max-height:calc(100vh - 44px);overflow-y:scroll;padding:24px 16px;scrollbar-width:none;width:100%}.modal-content-layout-module_container__79RFy::-webkit-scrollbar{display:none}@supports(-webkit-touch-callout:none){.modal-content-layout-module_container__79RFy{padding:24px 16px calc(env(safe-area-inset-bottom) + 32px);transition:padding-bottom .5s}}}";
var s$5 = {"container":"modal-content-layout-module_container__79RFy"};
styleInject(css_248z$O);

const ModalPreview = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (React.createElement("div", Object.assign({}, props, { className: cn(s$5.container, className) }), children));
};

const keys$6 = [keyCodes.escape];
const closingTimeout = 400;
const swipeThreshold = 90;
const Modal = ({ opened, onClose = noop$3, onBeforeClose = noop$3, size = 'm', closable = true, children, dataTest, mobile: mobileView = false, swipeToClose = true, preventionFilter = [], overflow = true, zIndex, }) => {
    const [key, setKey] = React.useState();
    const [top, setTop] = React.useState(origin);
    const modalRoot = useDOMRoot$1({ anchor: 'modal-launchpad', style: s$c.root });
    const containerRef = React.useRef(null);
    const scrollableRef = React.useRef(null);
    const contentRef = React.useRef(null);
    const mobile = useMobile(scrollableRef, opened);
    const fit = useFit({ scrollable: scrollableRef, content: contentRef, enabled: opened, mobile });
    const needRecalculation = React.useMemo(() => opened && !mobile && !fit, [opened, mobile, fit]);
    const [state, close] = useTransitionState(opened, { duration: closingTimeout });
    const ignoreScroll = fit ? {} : { 'data-scroll-lock-ignore': '' };
    const scrollShift = useScrollShift(state, scrollableRef.current);
    const prevention = React.useMemo(() => Object.entries(bubblePreventedHandlers)
        .filter(([key]) => !preventionFilter.includes(key))
        .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
    }, {}), [preventionFilter]);
    const preventor = React.useCallback(e => {
        e.preventDefault();
        e.stopPropagation();
    }, []);
    const handleClose = React.useCallback((event) => __awaiter(void 0, void 0, void 0, function* () {
        if (state !== 'show') {
            return;
        }
        preventor(event);
        onBeforeClose(event);
        yield close();
        onClose(event);
    }), [onClose, onBeforeClose, state, close, preventor]);
    const contextValue = React.useMemo(() => ({
        close: handleClose,
        closable,
        size,
        mobile: mobileView,
        dataTest,
    }), [handleClose, closable, size, mobileView, dataTest]);
    const calculateCloseTop = React.useCallback(() => {
        if (!scrollableRef.current) {
            return;
        }
        setTop(position(scrollableRef.current));
    }, []);
    const handleSwipeDown = React.useCallback(evt => {
        var _a;
        if (closable && ((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop) === 0) {
            handleClose(evt);
        }
    }, [closable, handleClose]);
    React.useEffect(() => {
        if (opened) {
            setKey(Math.random());
        }
    }, [opened]);
    React.useEffect(() => {
        if (!modalRoot || !zIndex) {
            return;
        }
        if (state === 'appear') {
            modalRoot.style.zIndex = String(zIndex);
        }
        return () => {
            if (state === 'exit') {
                modalRoot.style.zIndex = '';
            }
        };
    }, [state, modalRoot, zIndex]);
    React.useEffect(() => {
        if (!scrollableRef.current) {
            return;
        }
        if (needRecalculation) {
            setTop(position(scrollableRef.current));
        }
    }, [needRecalculation]);
    React.useEffect(() => {
        if (!scrollableRef.current || !contentRef.current) {
            return;
        }
        const container = scrollableRef.current;
        if (needRecalculation) {
            container.addEventListener('scroll', calculateCloseTop);
        }
        return () => {
            container.removeEventListener('scroll', calculateCloseTop);
        };
    }, [calculateCloseTop, needRecalculation]);
    useKeyPress(keys$6, closable ? handleClose : void 0);
    useScrollLock(scrollableRef, state === 'show' || state === 'exit', Number(fit));
    const { area } = useSwipe({ onDownSwipe: handleSwipeDown, yThreshold: swipeThreshold });
    const attachContentRefs = React.useCallback(node => {
        if (swipeToClose) {
            area.current = node;
        }
        scrollableRef.current = node;
    }, [area, swipeToClose]);
    if (!modalRoot || state === 'init' || state === 'idle') {
        return null;
    }
    const containerStyles = Object.assign({}, (!!scrollShift && { paddingRight: scrollShift }));
    return ReactDOM.createPortal(React.createElement("div", Object.assign({ className: cn(s$c.container, s$c[size], {
            [s$c.in]: state === 'show',
            [s$c.out]: state === 'exit',
            [s$c.mobile]: mobileView,
        }), style: Object.assign({}, containerStyles), ref: containerRef }, prevention),
        React.createElement("div", { className: s$c.overlay, onClick: closable ? handleClose : undefined }),
        React.createElement("div", { ref: attachContentRefs, className: cn(s$c.scrollable, !fit && s$c.scroll) },
            closable && mobile && !mobileView && (React.createElement("div", { className: s$c.closable, onClick: handleClose, onKeyPress: handleKeyPressEnter(handleClose), tabIndex: 0, "data-test": dataTest && `${dataTest}-close`, role: "button", "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C" },
                React.createElement("div", { className: s$c.close },
                    React.createElement(Icon$4, { name: "times", size: "s" })))),
            React.createElement(ModalPreview, Object.assign({ ref: contentRef, className: cn(s$c.content, overflow && s$c.overflow), "data-test": dataTest }, ignoreScroll),
                React.createElement(context$1.Provider, { key: key, value: contextValue }, children),
                closable && !mobile && (React.createElement("button", { className: s$c.close, onClick: handleClose, style: { top }, "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C", "data-test": dataTest && `${dataTest}-close` },
                    React.createElement(Icon$4, { name: "times", size: "s" })))))), modalRoot);
};
Modal.WideContent = WideContent$1;
Modal.Content = Content$1;
Modal.Picture = Picture;
Modal.Title = Title$2;
Modal.Actions = Actions$2;
Modal.StickyActions = StickyActions;
Modal.Header = Header$1;

function usePrevious(state) {
    const ref = React.useRef();
    React.useEffect(() => {
        ref.current = state;
    });
    return ref.current;
}

const useAutoResizable = ({ textArea, counterRef, autoHeight, maxRows, initRows, value }) => {
    const [rows, setRows] = React.useState(initRows);
    const prevRows = usePrevious(rows);
    const calculateRowsCount = React.useCallback(() => {
        if (!textArea.current || !autoHeight || !counterRef.current) {
            return;
        }
        const computedStyle = getComputedStyle(textArea.current);
        const value = textArea.current.value;
        counterRef.current.style.width = computedStyle.width;
        counterRef.current.value = value;
        if (counterRef.current.value.slice(-1) === '\n') {
            counterRef.current.value += ' ';
        }
        const innerHeight = counterRef.current.scrollHeight;
        counterRef.current.value = 'x';
        const singleRowHeight = counterRef.current.scrollHeight;
        let outerHeight = innerHeight;
        if (initRows) {
            outerHeight = Math.max(Number(initRows) * singleRowHeight, outerHeight);
        }
        if (maxRows) {
            outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        }
        outerHeight = Math.max(outerHeight, singleRowHeight);
        const rowCount = Math.ceil(outerHeight / singleRowHeight);
        if (prevRows !== rowCount) {
            setRows(rowCount);
        }
    }, [textArea, autoHeight, prevRows, maxRows, initRows, counterRef]);
    React.useEffect(calculateRowsCount, [textArea, calculateRowsCount, value]);
    return rows;
};

var css_248z$N = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.textarea-module_control__9uG5m{box-sizing:content-box;min-height:24px;resize:vertical;width:100%}.textarea-module_control__9uG5m.textarea-module_s__v6Mob{padding:4px 4px 4px 12px}.textarea-module_control__9uG5m.textarea-module_m__XygYk{padding:10px 8px 10px 12px}.textarea-module_control__9uG5m.textarea-module_l__F7OW3{padding:0 8px 4px 12px}.textarea-module_control__9uG5m.textarea-module_l__F7OW3.textarea-module_controlSingle__aT-Fl{padding:14px 8px 14px 12px}.textarea-module_control__9uG5m.textarea-module_none__ZLsx4{resize:none}.textarea-module_control__9uG5m.textarea-module_vertical__pRaaS{resize:vertical}.textarea-module_container__nWJzP{align-items:flex-start}.textarea-module_container__nWJzP.textarea-module_l__F7OW3,.textarea-module_container__nWJzP.textarea-module_l__F7OW3.textarea-module_single__AqKAY,.textarea-module_container__nWJzP.textarea-module_m__XygYk,.textarea-module_container__nWJzP.textarea-module_s__v6Mob{padding:4px}.textarea-module_container__nWJzP.textarea-module_l__F7OW3{padding-top:28px}.textarea-module_control__9uG5m::-webkit-scrollbar{width:calc(var(--step)*2)}.textarea-module_control__9uG5m::-webkit-scrollbar-thumb{background-color:rgba(127,120,161,.4);border-radius:calc(var(--step)*2);min-height:calc(var(--step)*4);width:calc(var(--step)*2)}.textarea-module_containerRigth__6PF9a{display:flex;position:absolute;right:16px;top:0;z-index:3}.textarea-module_containerRigth__6PF9a.textarea-module_s__v6Mob{padding:8px 0 0}.textarea-module_containerRigth__6PF9a.textarea-module_m__XygYk{padding:14px 0 0}.textarea-module_containerRigth__6PF9a.textarea-module_l__F7OW3{padding:18px 0 0}.textarea-module_shadow__6iVWR{height:0;left:0;overflow:hidden;position:absolute;top:0;transform:translateZ(0);visibility:hidden}";
var textareaStyles = {"control":"textarea-module_control__9uG5m","s":"textarea-module_s__v6Mob","m":"textarea-module_m__XygYk","l":"textarea-module_l__F7OW3","controlSingle":"textarea-module_controlSingle__aT-Fl","none":"textarea-module_none__ZLsx4","vertical":"textarea-module_vertical__pRaaS","container":"textarea-module_container__nWJzP","single":"textarea-module_single__AqKAY","containerRigth":"textarea-module_containerRigth__6PF9a","shadow":"textarea-module_shadow__6iVWR"};
styleInject(css_248z$N);

const s$4 = normalizeCSSModules(styles$n);
const sTextarea = normalizeCSSModules(textareaStyles);
const Loader$1 = ({ fade }) => (React.createElement("svg", { className: cn(fade && s$4.fade), width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M11 3a1 1 0 011-1 10 10 0 0110 10 1 1 0 11-2 0 7.999 7.999 0 00-8-8 1 1 0 01-1-1z", fill: "currentColor" })));
const Textarea = (props) => {
    const { autoComplete = 'off', autoFocus = false, background = 'primary', children, dataTest, disabled = false, error = false, floating = true, formatter, gtm, hint, id: externalId = true, info = null, inputMode = 'text', label = '', loading = false, loaderFade = false, maxLength, name, onChange = () => { }, parser, placeholder = '', readOnly = false, required, size: externalSize = 's', spaced = false, valid = false, value: externalValue, warning = false, passRequiredToHTMLInput = true, onClick, inputRef, wrapperRef, rows = 3, resize = 'vertical', autoHeight = false, maxRows = 6, } = props;
    let { autofocus = false, readonly = false, success = false } = props;
    const { format, parse } = useTransformations(formatter, parser);
    const handlers = useTextareaHandlers(props);
    const input = React.useRef(null);
    const container = React.useRef(null);
    const counterRef = React.useRef(null);
    const [value, setValue] = React.useState(format(externalValue));
    const autoRows = useAutoResizable({
        value,
        initRows: rows,
        textArea: input,
        counterRef,
        autoHeight,
        maxRows,
    });
    const id = useInputId(externalId);
    const group = useGroup();
    const size = (group.present && group.size) || externalSize;
    autofocus = autofocus || autoFocus;
    readonly = readonly || readOnly;
    const handleClick = React.useCallback(event => {
        var _a;
        if (event.target === container.current) {
            (_a = input.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [onClick]);
    const handleValueChange = React.useCallback((newValue, event) => {
        const text = format(newValue);
        if (value !== text) {
            onChange(parse(newValue), event);
        }
        setValue(text);
    }, [format, parse, onChange, value]);
    const handleInputOnChange = React.useCallback(event => handleValueChange(event.target.value, event), [handleValueChange]);
    React.useEffect(() => {
        setValue(format(externalValue));
    }, [externalValue, format]);
    success = success || valid;
    const status = useInputStatus(success, error, warning);
    const content = useContent(children);
    const assignInputRef = React.useCallback(el => {
        input.current = el;
        if (inputRef) {
            inputRef.current = el;
        }
    }, [inputRef]);
    const attrs = Object.assign({}, (passRequiredToHTMLInput && { required }));
    return (React.createElement("div", { className: cn(s$4.wrapper, spaced && s$4.spaced, group.present && !group.first && s$4.group), ref: wrapperRef, style: Object.assign(Object.assign({}, (group.present && { flex: group.width })), (group.present && { maxWidth: group.maxWidth })) },
        React.createElement("span", { className: cn(s$4.container, s$4[size], sTextarea.container, sTextarea[size], warning && s$4.warning, error && s$4.error, success && s$4.success, !label && size === 'l' && s$4.single, !label && size === 'l' && sTextarea.single, label && size !== 'l' && s$4.labeled, floating && size === 'l' && s$4.floating, disabled && s$4.disabled), ref: container, "data-gtm": gtm, "data-test": dataTest, onClick: handleClick },
            content.start,
            React.createElement("textarea", Object.assign({ autoComplete: autoComplete, autoCorrect: "off", autoFocus: autofocus, className: cn(s$4.control, sTextarea[size], sTextarea.control, sTextarea[resize], !label && size === 'l' && sTextarea.controlSingle, value.length === 0 && s$4.empty), disabled: disabled, id: id, inputMode: inputMode, maxLength: maxLength, name: name, placeholder: placeholder, readOnly: readonly, value: value, ref: assignInputRef, onChange: handleInputOnChange, rows: autoRows }, attrs, handlers)),
            autoHeight && (React.createElement("textarea", { "aria-hidden": true, tabIndex: -1, readOnly: true, ref: counterRef, className: textareaStyles.shadow })),
            React.createElement("span", { className: cn(sTextarea.containerRigth, sTextarea[size]) },
                (status.icon || loading) && (React.createElement("span", { "data-addon-end": true, className: cn(s$4.end, loading ? s$4.loader : s$4.status), ref: status.ref }, loading ? React.createElement(Loader$1, { fade: loaderFade }) : React.createElement(Icon$4, { name: status.icon }))),
                content.end ||
                    (info && (React.createElement("span", { "data-addon-end": true, className: cn(s$4.end, s$4.icon), ref: info },
                        React.createElement(Icon$4, { name: "information-circle" }))))),
            label && (React.createElement(Label$1, { container: container, size: size, content: content, info: info, reset: false, postfix: "", id: id, required: required, status: status }, label)),
            React.createElement("span", { className: cn(s$4.bg, s$4[background], (!group.present || (group.present && group.first)) && s$4.roundedLeft, (!group.present || (group.present && group.last)) && s$4.roundedRight) })),
        hint && (React.createElement("span", { className: cn(s$4.hint, error && s$4.error, warning && s$4.warning), "data-test": error ? 'error' : warning ? 'warning' : 'hint' }, hint))));
};

var css_248z$M = ".color-primitives-module_black-50__JnDDA{color:#f8f8fc}.color-primitives-module_black-75__NsIK2{color:#f3f1f8}.color-primitives-module_black-100__zU5-s{color:#eae9f2}.color-primitives-module_black-200__iLJcc{color:#ccc9d9}.color-primitives-module_black-250__M4Kno{color:#b8b4ca}.color-primitives-module_black-300__VOK8c{color:#a4a1b5}.color-primitives-module_black-350__VffVN{color:#8a869c}.color-primitives-module_black-400__QRs1N{color:#6e6a81}.color-primitives-module_black-450__8dApQ{color:#464257}.color-primitives-module_black-500__1R-cb{color:#211f2e}.color-primitives-module_black-50-alpha__EPqYR{color:rgba(186,176,227,.1)}.color-primitives-module_black-75-alpha__EdW1N{color:rgba(194,189,219,.2)}.color-primitives-module_black-100-alpha__NoP17{color:rgba(150,142,190,.2)}.color-primitives-module_black-200-alpha__GksPE{color:rgba(127,120,161,.4)}.color-primitives-module_black-250-alpha__XopSk{color:rgba(115,108,147,.5)}.color-primitives-module_black-300-alpha__Fqg-y{color:rgba(105,99,131,.6)}.color-primitives-module_black-400-alpha__gFPO-{color:rgba(73,68,95,.8)}.color-primitives-module_black-500-alpha__E1DfD{color:#211f2e}.color-primitives-module_white-0__g7RJZ{color:hsla(0,0%,100%,0)}.color-primitives-module_white-500__b2Gp5{color:#fff}.color-primitives-module_white-100-alpha__WGF42{color:hsla(0,0%,100%,.08)}.color-primitives-module_white-200-alpha__3cIlk{color:hsla(0,0%,100%,.16)}.color-primitives-module_white-300-alpha__48ttI{color:hsla(0,0%,100%,.32)}.color-primitives-module_white-400-alpha__FcOjn{color:hsla(0,0%,100%,.64)}.color-primitives-module_white-500-alpha__EaqdS{color:#fff}.color-primitives-module_blue-50__tOL-c{color:#f7f5ff}.color-primitives-module_blue-100__G9MGd{color:#e7e2fd}.color-primitives-module_blue-200__T-vw2{color:#ccc2fa}.color-primitives-module_blue-300__AeRYk{color:#a391f3}.color-primitives-module_blue-400__WA7Om{color:#6b4fe8}.color-primitives-module_blue-500__Ki4uh{color:#3416b6}.color-primitives-module_blue-600__x-Yro{color:#271188}.color-primitives-module_blue-700__ClMkd{color:#1b0c5f}.color-primitives-module_blue-800__4SDli{color:#150949}.color-primitives-module_orange-50__Svk3V{color:#fff7f5}.color-primitives-module_orange-100__oZ9x3{color:#fff0eb}.color-primitives-module_orange-200__vxZ5w{color:#ffe4db}.color-primitives-module_orange-300__kvoVB{color:#ffc9b8}.color-primitives-module_orange-400__o2DEp{color:#ffa78a}.color-primitives-module_orange-500__sUoP6{color:#ff794d}.color-primitives-module_orange-600__Lgsxw{color:#ff4f14}.color-primitives-module_orange-700__5-klx{color:#eb3b00}.color-primitives-module_purple-50__kBoVH{color:#f7f5ff}.color-primitives-module_purple-100__ZX0yK{color:#eeebff}.color-primitives-module_purple-200__-QZ1S{color:#e3dcfe}.color-primitives-module_purple-300__GDL5d{color:#cec4fd}.color-primitives-module_purple-400__TmDaP{color:#b6a6fc}.color-primitives-module_purple-500__cUkdm{color:#8e75fa}.color-primitives-module_purple-600__QLVN3{color:#6544f8}.color-primitives-module_purple-700__7J5l5{color:#5836ec}.color-primitives-module_turquoise-50__cLe8u{color:#f5ffff}.color-primitives-module_turquoise-100__9A-Ca{color:#e7fdfe}.color-primitives-module_turquoise-200__Xh77a{color:#c6f9fb}.color-primitives-module_turquoise-300__2g-qj{color:#9bf0f3}.color-primitives-module_turquoise-400__i7-v6{color:#65e2e6}.color-primitives-module_turquoise-500__b9aMZ{color:#28b8bd}.color-primitives-module_turquoise-600__wicRn{color:#1f8f93}.color-primitives-module_turquoise-700__gGdXv{color:#1b7b7e}.color-primitives-module_yellow-50__O1lHi{color:#fffbf5}.color-primitives-module_yellow-100__T0i45{color:#fff5e6}.color-primitives-module_yellow-200__bb0WI{color:#feeccd}.color-primitives-module_yellow-300__goYDI{color:#fee7a9}.color-primitives-module_yellow-400__3Vl9b{color:#fccc78}.color-primitives-module_yellow-500__4q1BX{color:#fac32e}.color-primitives-module_yellow-600__p-xUi{color:#e5a906}.color-primitives-module_yellow-700__kJ8GF{color:#d19b05}.color-primitives-module_green-50__kWV4t{color:#fafff5}.color-primitives-module_green-100__BU3hK{color:#f3fee7}.color-primitives-module_green-200__taO0U{color:#e4fbcb}.color-primitives-module_green-300__wnDwA{color:#caf49a}.color-primitives-module_green-400__hcdG2{color:#b4e878}.color-primitives-module_green-500__ot6YX{color:#87d232}.color-primitives-module_green-600__nxHPk{color:#78bc29}.color-primitives-module_green-700__nh7Vt{color:#6dab26}.color-primitives-module_red-50__pXqxQ{color:#fff6f5}.color-primitives-module_red-100__ERQUv{color:#ffe8e6}.color-primitives-module_red-200__Hg59q{color:#ffdad6}.color-primitives-module_red-300__a4vsm{color:#fdb1aa}.color-primitives-module_red-400__ZS2Nn{color:#fa857a}.color-primitives-module_red-500__2xvLg{color:#f44434}.color-primitives-module_red-600__yVfPT{color:#e91f0c}.color-primitives-module_red-700__ilUlg{color:#cb1b0b}.color-primitives-module_white__ZQLCL{color:#fff}.color-primitives-module_black__-vdns{color:#211f2e}.color-primitives-module_blue__Jgar6{color:#3416b6}.color-primitives-module_red__FxlWX{color:#f44434}.color-primitives-module_green__pYXCl{color:#87d232}.color-primitives-module_orange__sVC-k{color:#ff794d}";
var _colors = {"black-50":"color-primitives-module_black-50__JnDDA","black-75":"color-primitives-module_black-75__NsIK2","black-100":"color-primitives-module_black-100__zU5-s","black-200":"color-primitives-module_black-200__iLJcc","black-250":"color-primitives-module_black-250__M4Kno","black-300":"color-primitives-module_black-300__VOK8c","black-350":"color-primitives-module_black-350__VffVN","black-400":"color-primitives-module_black-400__QRs1N","black-450":"color-primitives-module_black-450__8dApQ","black-500":"color-primitives-module_black-500__1R-cb","black-50-alpha":"color-primitives-module_black-50-alpha__EPqYR","black-75-alpha":"color-primitives-module_black-75-alpha__EdW1N","black-100-alpha":"color-primitives-module_black-100-alpha__NoP17","black-200-alpha":"color-primitives-module_black-200-alpha__GksPE","black-250-alpha":"color-primitives-module_black-250-alpha__XopSk","black-300-alpha":"color-primitives-module_black-300-alpha__Fqg-y","black-400-alpha":"color-primitives-module_black-400-alpha__gFPO-","black-500-alpha":"color-primitives-module_black-500-alpha__E1DfD","white-0":"color-primitives-module_white-0__g7RJZ","white-500":"color-primitives-module_white-500__b2Gp5","white-100-alpha":"color-primitives-module_white-100-alpha__WGF42","white-200-alpha":"color-primitives-module_white-200-alpha__3cIlk","white-300-alpha":"color-primitives-module_white-300-alpha__48ttI","white-400-alpha":"color-primitives-module_white-400-alpha__FcOjn","white-500-alpha":"color-primitives-module_white-500-alpha__EaqdS","blue-50":"color-primitives-module_blue-50__tOL-c","blue-100":"color-primitives-module_blue-100__G9MGd","blue-200":"color-primitives-module_blue-200__T-vw2","blue-300":"color-primitives-module_blue-300__AeRYk","blue-400":"color-primitives-module_blue-400__WA7Om","blue-500":"color-primitives-module_blue-500__Ki4uh","blue-600":"color-primitives-module_blue-600__x-Yro","blue-700":"color-primitives-module_blue-700__ClMkd","blue-800":"color-primitives-module_blue-800__4SDli","orange-50":"color-primitives-module_orange-50__Svk3V","orange-100":"color-primitives-module_orange-100__oZ9x3","orange-200":"color-primitives-module_orange-200__vxZ5w","orange-300":"color-primitives-module_orange-300__kvoVB","orange-400":"color-primitives-module_orange-400__o2DEp","orange-500":"color-primitives-module_orange-500__sUoP6","orange-600":"color-primitives-module_orange-600__Lgsxw","orange-700":"color-primitives-module_orange-700__5-klx","purple-50":"color-primitives-module_purple-50__kBoVH","purple-100":"color-primitives-module_purple-100__ZX0yK","purple-200":"color-primitives-module_purple-200__-QZ1S","purple-300":"color-primitives-module_purple-300__GDL5d","purple-400":"color-primitives-module_purple-400__TmDaP","purple-500":"color-primitives-module_purple-500__cUkdm","purple-600":"color-primitives-module_purple-600__QLVN3","purple-700":"color-primitives-module_purple-700__7J5l5","turquoise-50":"color-primitives-module_turquoise-50__cLe8u","turquoise-100":"color-primitives-module_turquoise-100__9A-Ca","turquoise-200":"color-primitives-module_turquoise-200__Xh77a","turquoise-300":"color-primitives-module_turquoise-300__2g-qj","turquoise-400":"color-primitives-module_turquoise-400__i7-v6","turquoise-500":"color-primitives-module_turquoise-500__b9aMZ","turquoise-600":"color-primitives-module_turquoise-600__wicRn","turquoise-700":"color-primitives-module_turquoise-700__gGdXv","yellow-50":"color-primitives-module_yellow-50__O1lHi","yellow-100":"color-primitives-module_yellow-100__T0i45","yellow-200":"color-primitives-module_yellow-200__bb0WI","yellow-300":"color-primitives-module_yellow-300__goYDI","yellow-400":"color-primitives-module_yellow-400__3Vl9b","yellow-500":"color-primitives-module_yellow-500__4q1BX","yellow-600":"color-primitives-module_yellow-600__p-xUi","yellow-700":"color-primitives-module_yellow-700__kJ8GF","green-50":"color-primitives-module_green-50__kWV4t","green-100":"color-primitives-module_green-100__BU3hK","green-200":"color-primitives-module_green-200__taO0U","green-300":"color-primitives-module_green-300__wnDwA","green-400":"color-primitives-module_green-400__hcdG2","green-500":"color-primitives-module_green-500__ot6YX","green-600":"color-primitives-module_green-600__nxHPk","green-700":"color-primitives-module_green-700__nh7Vt","red-50":"color-primitives-module_red-50__pXqxQ","red-100":"color-primitives-module_red-100__ERQUv","red-200":"color-primitives-module_red-200__Hg59q","red-300":"color-primitives-module_red-300__a4vsm","red-400":"color-primitives-module_red-400__ZS2Nn","red-500":"color-primitives-module_red-500__2xvLg","red-600":"color-primitives-module_red-600__yVfPT","red-700":"color-primitives-module_red-700__ilUlg","white":"color-primitives-module_white__ZQLCL","black":"color-primitives-module_black__-vdns","blue":"color-primitives-module_blue__Jgar6","red":"color-primitives-module_red__FxlWX","green":"color-primitives-module_green__pYXCl","orange":"color-primitives-module_orange__sVC-k"};
styleInject(css_248z$M);

var css_248z$L = ".fonts-module_promo-h1__kpPkS{font:500 52px/64px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_promo-h2__jrjuc{font:500 36px/44px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_promo-h3__cPf1g{font:500 28px/36px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_promo-h4__K18f5{font:500 24px/32px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_promo-h5__B3n0B{font:500 20px/28px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_promo-subheader__uMW0U{font:400 22px/32px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_promo-subheader-alone__aQyqa{font:400 22px/28px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_promo-primary__HuTQH{font:400 18px/28px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_promo-primary-alone__xHxQq{font:400 18px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_h1__Ndw1x{font:500 32px/40px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_h2__JhZ1T{font:500 28px/36px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_h3__DK4-E{font:500 22px/32px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_h4__4PfpR{font:500 18px/28px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_primary-alone__upjjs{font:400 16px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_primary__kbsSB{font:400 16px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_secondary-alone__fWIR6{font:400 14px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_secondary__7unBl{font:400 14px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_small-alone__bnGdS{font:400 12px/16px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_small__cyw9Z{font:400 12px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_tiny-alone__xVgis{font:400 10px/14px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_tiny__-h1qW{font:400 10px/18px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_bold__hsZ0Z{font-weight:700}@media screen and (max-width:959px){.fonts-module_promo-h1__kpPkS.fonts-module_responsive__r78I3{font:500 28px/36px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_promo-h2__jrjuc.fonts-module_responsive__r78I3{font:500 24px/32px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_promo-h3__cPf1g.fonts-module_responsive__r78I3{font:500 20px/28px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_promo-h4__K18f5.fonts-module_responsive__r78I3{font:500 18px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_promo-subheader__uMW0U.fonts-module_responsive__r78I3{font:400 18px/28px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_promo-primary__HuTQH.fonts-module_responsive__r78I3{font:400 16px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_h1__Ndw1x.fonts-module_responsive__r78I3{font:500 22px/32px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_h2__JhZ1T.fonts-module_responsive__r78I3{font:500 18px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.fonts-module_h3__DK4-E.fonts-module_responsive__r78I3,.fonts-module_h4__4PfpR.fonts-module_responsive__r78I3{font:500 16px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}}";
var _variants = {"promo-h1":"fonts-module_promo-h1__kpPkS","promo-h2":"fonts-module_promo-h2__jrjuc","promo-h3":"fonts-module_promo-h3__cPf1g","promo-h4":"fonts-module_promo-h4__K18f5","promo-h5":"fonts-module_promo-h5__B3n0B","promo-subheader":"fonts-module_promo-subheader__uMW0U","promo-subheader-alone":"fonts-module_promo-subheader-alone__aQyqa","promo-primary":"fonts-module_promo-primary__HuTQH","promo-primary-alone":"fonts-module_promo-primary-alone__xHxQq","h1":"fonts-module_h1__Ndw1x","h2":"fonts-module_h2__JhZ1T","h3":"fonts-module_h3__DK4-E","h4":"fonts-module_h4__4PfpR","primary-alone":"fonts-module_primary-alone__upjjs","primary":"fonts-module_primary__kbsSB","secondary-alone":"fonts-module_secondary-alone__fWIR6","secondary":"fonts-module_secondary__7unBl","small-alone":"fonts-module_small-alone__bnGdS","small":"fonts-module_small__cyw9Z","tiny-alone":"fonts-module_tiny-alone__xVgis","tiny":"fonts-module_tiny__-h1qW","bold":"fonts-module_bold__hsZ0Z","responsive":"fonts-module_responsive__r78I3"};
styleInject(css_248z$L);

var css_248z$K = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.colors-named-module_primary__HZQNU{color:#211f2e}.colors-named-module_secondary__NeRg9{color:rgba(73,68,95,.8)}.colors-named-module_minor__X1qZH{color:rgba(105,99,131,.6)}.colors-named-module_link__aQ8N9{color:#3416b6}.colors-named-module_link-hover__y6FHt{color:#ff794d}.colors-named-module_link-visited__AZZue{color:#271188}.colors-named-module_link-minor__UPGE4{color:#6b4fe8}.colors-named-module_link-minor-hover__hUDLL{color:#ffa78a}.colors-named-module_link-minor-visited__z1-Jp{color:#6b4fe8}.colors-named-module_link-secondary-visited__c4WwI{color:#6e6a81}.colors-named-module_primary-alt-bg__GIjTO{color:#fff}.colors-named-module_secondary-alt-bg__Z-M9W{color:hsla(0,0%,100%,.64)}.colors-named-module_minor-alt-bg__cmhZk{color:hsla(0,0%,100%,.32)}.colors-named-module_link-alt-bg__6y49y{color:#ff794d}.colors-named-module_link-alt-bg-hover__YPIi-{color:#f44434}.colors-named-module_link-alt-bg-visited__Ai6yy{color:#ff794d}.colors-named-module_link-minor-alt-bg__LqPTf{color:#ffa78a}.colors-named-module_link-minor-alt-bg-hover__lqL3M{color:#ff794d}.colors-named-module_link-minor-alt-bg-visited__-Fyyt{color:#ffa78a}.colors-named-module_disabled__ghp4Z{color:#b8b4ca}.colors-named-module_disabled-transparent__oOv-P{color:rgba(105,99,131,.6)}.colors-named-module_disabled-transparent-alt-bg__BDkcy{color:hsla(0,0%,100%,.32)}";
var _colorsNamed = {"primary":"colors-named-module_primary__HZQNU","secondary":"colors-named-module_secondary__NeRg9","minor":"colors-named-module_minor__X1qZH","link":"colors-named-module_link__aQ8N9","link-hover":"colors-named-module_link-hover__y6FHt","link-visited":"colors-named-module_link-visited__AZZue","link-minor":"colors-named-module_link-minor__UPGE4","link-minor-hover":"colors-named-module_link-minor-hover__hUDLL","link-minor-visited":"colors-named-module_link-minor-visited__z1-Jp","link-secondary-visited":"colors-named-module_link-secondary-visited__c4WwI","primary-alt-bg":"colors-named-module_primary-alt-bg__GIjTO","secondary-alt-bg":"colors-named-module_secondary-alt-bg__Z-M9W","minor-alt-bg":"colors-named-module_minor-alt-bg__cmhZk","link-alt-bg":"colors-named-module_link-alt-bg__6y49y","link-alt-bg-hover":"colors-named-module_link-alt-bg-hover__YPIi-","link-alt-bg-visited":"colors-named-module_link-alt-bg-visited__Ai6yy","link-minor-alt-bg":"colors-named-module_link-minor-alt-bg__LqPTf","link-minor-alt-bg-hover":"colors-named-module_link-minor-alt-bg-hover__lqL3M","link-minor-alt-bg-visited":"colors-named-module_link-minor-alt-bg-visited__-Fyyt","disabled":"colors-named-module_disabled__ghp4Z","disabled-transparent":"colors-named-module_disabled-transparent__oOv-P","disabled-transparent-alt-bg":"colors-named-module_disabled-transparent-alt-bg__BDkcy"};
styleInject(css_248z$K);

const variants = normalizeCSSModules(_variants);
const colors = Object.assign(Object.assign({}, normalizeCSSModules(_colors)), normalizeCSSModules(_colorsNamed));
const Typography = (_a) => {
    var { tag = 'div', className, color, variant, responsive, bold, children } = _a, props = __rest(_a, ["tag", "className", "color", "variant", "responsive", "bold", "children"]);
    return React.createElement(tag, Object.assign({ className: cn(color && colors[color], variant && variants[variant], responsive && variants.responsive, bold && variants.bold, className) }, props), children);
};

var css_248z$J = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.overlay-module_root__WREfB{position:absolute;z-index:1030}.overlay-module_overlay__XRf-c{align-items:center;background-color:rgba(105,99,131,.6);bottom:0;color:#fff;display:flex;flex-direction:column;justify-content:center;left:0;opacity:0;pointer-events:none;position:fixed;right:0;top:0;transition:opacity .24s cubic-bezier(.24,.1,.24,1)}.overlay-module_overlay__XRf-c.overlay-module_active__9A5zg{opacity:1;pointer-events:all}.overlay-module_upload__Jhrve{pointer-events:none}";
var s$3 = {"root":"overlay-module_root__WREfB","overlay":"overlay-module_overlay__XRf-c","active":"overlay-module_active__9A5zg","upload":"overlay-module_upload__Jhrve"};
styleInject(css_248z$J);

const Overlay$1 = ({ getRootProps, getInputProps, children }) => {
    const zoneRoot = useDOMRoot$1({ anchor: 'uploader-area', style: s$3.root });
    const [active, setActive] = React.useState(false);
    const handleDragEnter = React.useCallback(event => {
        const { dataTransfer } = event || {};
        const file = dataTransfer && dataTransfer.types && dataTransfer.types.length == 1 && dataTransfer.types[0] == 'Files';
        if (file) {
            setActive(true);
        }
    }, []);
    const handleDragLeave = React.useCallback(event => {
        if (!event) {
            return;
        }
        if (active) {
            setActive(false);
        }
    }, [active]);
    const handleDrop = React.useCallback(event => {
        event.preventDefault();
        setActive(false);
    }, []);
    useScrollLock({ current: zoneRoot }, active);
    React.useEffect(() => {
        if (!zoneRoot) {
            return;
        }
        window.addEventListener('dragenter', handleDragEnter);
        return () => {
            window.removeEventListener('dragenter', handleDragEnter);
        };
    }, [zoneRoot, handleDragEnter, handleDragLeave]);
    if (!zoneRoot) {
        return null;
    }
    return ReactDOM.createPortal(React.createElement("div", Object.assign({}, getRootProps({
        onDragLeave: handleDragLeave,
        onDrop: handleDrop,
        className: cn(s$3.overlay, active && s$3.active),
    })),
        React.createElement("input", Object.assign({}, getInputProps())),
        React.createElement("div", { className: s$3.upload }, children)), zoneRoot);
};
var Overlay$2 = Overlay$1;

var css_248z$I = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.uploader-module_box__md2Uw,.uploader-module_wrapper__LTD8U{box-sizing:border-box}.uploader-module_box__md2Uw{border:1px dashed rgba(127,120,161,.4);border-radius:4px;cursor:pointer;display:flex;flex:1 1;transition:border-color .24s cubic-bezier(.24,.1,.24,1),background-color .24s cubic-bezier(.24,.1,.24,1);width:100%}.uploader-module_box__md2Uw.uploader-module_horizontal__lLRMt{align-items:flex-start;flex-direction:row}.uploader-module_box__md2Uw.uploader-module_dragging__m5rgW .uploader-module_cloud__f8-eZ,.uploader-module_box__md2Uw.uploader-module_horizontal__lLRMt .uploader-module_cloud__f8-eZ{margin-right:16px}.uploader-module_box__md2Uw.uploader-module_vertical__6Bwsg{align-items:center;flex-direction:column}.uploader-module_box__md2Uw.uploader-module_light__ttDsW{background-color:var(--c-background)}.uploader-module_box__md2Uw.uploader-module_dark__-Y7Uk{background-color:#f8f8fc}.uploader-module_box__md2Uw.uploader-module_dragging__m5rgW{background-color:#f3f1f8;border-color:#3416b6;flex-direction:row;justify-content:center}.uploader-module_box__md2Uw.uploader-module_s__bYwvg{padding:7px 16px}.uploader-module_box__md2Uw.uploader-module_m__co4ti{padding:15px 16px}.uploader-module_box__md2Uw.uploader-module_l__Rc5V0{padding:23px 16px}.uploader-module_box__md2Uw:not(.uploader-module_dragging__m5rgW):hover{background-color:#f8f8fc;border-color:#3416b6}.uploader-module_placeholder__z40fz{display:inline-block;font:400 14px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.uploader-module_placeholder__z40fz .uploader-module_action__-0k60{color:#211f2e}.uploader-module_placeholder__z40fz .uploader-module_upload__JH-L0{color:#3416b6}.uploader-module_placeholder__z40fz .uploader-module_formats__o9GJx{color:rgba(73,68,95,.8)}.uploader-module_box__md2Uw .uploader-module_cloud__f8-eZ{color:rgba(115,108,147,.5);flex-shrink:0;transition:color .24s cubic-bezier(.24,.1,.24,1)}.uploader-module_box__md2Uw.uploader-module_dragging__m5rgW .uploader-module_cloud__f8-eZ,.uploader-module_box__md2Uw:hover .uploader-module_cloud__f8-eZ,.uploader-module_release__MhIAR{color:#3416b6}.uploader-module_content__nBqfP{display:flex;flex-direction:column;justify-content:center;min-height:40px}";
var s$2 = {"wrapper":"uploader-module_wrapper__LTD8U","box":"uploader-module_box__md2Uw","horizontal":"uploader-module_horizontal__lLRMt","cloud":"uploader-module_cloud__f8-eZ","dragging":"uploader-module_dragging__m5rgW","vertical":"uploader-module_vertical__6Bwsg","light":"uploader-module_light__ttDsW","dark":"uploader-module_dark__-Y7Uk","s":"uploader-module_s__bYwvg","m":"uploader-module_m__co4ti","l":"uploader-module_l__Rc5V0","placeholder":"uploader-module_placeholder__z40fz","action":"uploader-module_action__-0k60","upload":"uploader-module_upload__JH-L0","formats":"uploader-module_formats__o9GJx","release":"uploader-module_release__MhIAR","content":"uploader-module_content__nBqfP"};
styleInject(css_248z$I);

const powers = [
    ['B', 'б'],
    ['Kb', 'кб'],
    ['Mb', 'мб'],
];
const powersArray = powers.map(([power]) => power);
const size$1 = fileSize.partial({
    standard: 'jedec',
    symbols: powers.reduce((res, [power, symbol]) => (Object.assign(Object.assign({}, res), { [power.toUpperCase()]: symbol })), {}),
});
const resolveFileSize = (size = 1) => {
    if (typeof size === 'number') {
        return size;
    }
    const [amount, power] = size;
    return amount * Math.pow(2, (powersArray.indexOf(power) * 10));
};

const Dropzone = ({ children }) => {
    return React.createElement(React.Fragment, null, children);
};
Dropzone.slot = 'Uploader:dropzone';
const Overlay = ({ children }) => {
    return React.createElement(React.Fragment, null, children);
};
Overlay.slot = 'Uploader:overlay';

const Placeholder = ({ accept, maxSize, overlay, }) => {
    const formats = React.useMemo(() => (Array.isArray(accept) ? accept.join(', ') : accept || ''), [accept]);
    return (React.createElement("div", { className: s$2.placeholder },
        React.createElement("div", { className: s$2.action },
            React.createElement("span", { className: s$2.upload }, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B"),
            " \u0438\u043B\u0438 \u043F\u0435\u0440\u0435\u0442\u044F\u043D\u0438\u0442\u0435 \u0438\u0445",
            ' ',
            overlay ? 'на окно браузера' : 'в эту область'),
        React.createElement("div", { className: s$2.formats },
            formats && `${formats}. `,
            "\u041D\u0435 \u0431\u043E\u043B\u0435\u0435 ",
            size$1(maxSize))));
};
const Cloud = () => (React.createElement("svg", { className: s$2.cloud, width: "40", height: "40", viewBox: "0 0 40 40", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M30.348 30.77c4.056 0 7.344-3.12 7.344-6.969 0-3.635-2.933-6.62-6.676-6.94v-.028c0-4.199-3.587-7.602-8.012-7.602-3.336 0-6.195 1.935-7.4 4.686a5.246 5.246 0 0 0-1.613-.252c-2.653 0-4.824 1.958-4.996 4.435h-.011c-3.687 0-6.676 2.836-6.676 6.335 0 3.498 2.989 6.334 6.676 6.334h6.27c1.7 0 3.077-1.377 3.077-3.076v-3.258h-2.67l4.673-6.335 4.673 6.335h-2.67v3.258c0 1.699 1.377 3.076 3.077 3.076h4.934Z", fill: "currentColor" })));
const Uploader = (_a) => {
    var { overlay = false, accept = ['.jpg', '.jpeg', '.pdf', '.png', '.doc', '.docx'], children, size = 'm', background = 'light', orientation = 'horizontal', onDrop, maxSize = resolveFileSize([10, 'Mb']), dataTest, gtm } = _a, fileInputProps = __rest(_a, ["overlay", "accept", "children", "size", "background", "orientation", "onDrop", "maxSize", "dataTest", "gtm"]);
    const resolvedMaxSize = resolveFileSize(maxSize);
    const slots = useSlots('Uploader', children);
    const { getRootProps, getInputProps, isDragActive } = useDropzone(Object.assign(Object.assign({ onDrop,
        accept, maxSize: resolvedMaxSize, minSize: 1 }, fileInputProps), { noKeyboard: true }));
    const wrapperProps = Object.assign(Object.assign(Object.assign({}, (dataTest && { 'data-test': dataTest })), (gtm && { 'data-gtm': gtm })), { className: s$2.wrapper });
    const wrapper = overlay ? wrapperProps : getRootProps(wrapperProps);
    return (React.createElement("div", Object.assign({}, wrapper),
        overlay && React.createElement(Overlay$2, Object.assign({}, { getRootProps, getInputProps }), slots['overlay']),
        !overlay && React.createElement("input", Object.assign({}, getInputProps())),
        React.createElement("div", { className: cn(s$2.box, s$2[size], s$2[background], s$2[orientation], isDragActive && s$2.dragging) },
            React.createElement(Cloud, null),
            React.createElement("div", { className: s$2.content },
                isDragActive && React.createElement("span", { className: s$2.release }, "\u041E\u0442\u043F\u0443\u0441\u0442\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B"),
                !isDragActive &&
                    (slots['dropzone'] || (React.createElement(Placeholder, { accept: accept, maxSize: resolvedMaxSize, overlay: overlay })))))));
};
Uploader.Dropzone = Dropzone;
Uploader.Overlay = Overlay;

var css_248z$H = ":root{--c-primary-bg:#a391f3;--c-primary:#3416b6;--c-primary-hover:#271188;--c-primary-active:#1b0c5f;--c-accent-bg:#ffc9b8;--c-accent:#ff794d;--c-accent-hover:#ff4f14;--c-accent-active:#eb3b00;--c-secondary:rgba(150,142,190,.2);--c-secondary-hover:rgba(127,120,161,.4);--c-secondary-active:rgba(105,99,131,.6);--c-promo1:#8e75fa;--c-promo1-hover:#6544f8;--c-promo1-active:#5836ec;--c-promo2:#28b8bd;--c-promo2-hover:#1f8f93;--c-promo2-active:#1b7b7e;--c-transparent:hsla(0,0%,100%,0);--c-text-primary:#211f2e;--c-text-secondary:rgba(73,68,95,.8);--c-text-minor:rgba(105,99,131,.6);--c-text-link:#3416b6;--c-text-link-hover:#ff794d;--c-text-link-visited:#271188;--c-text-link-minor:#6b4fe8;--c-text-link-minor-hover:#ffa78a;--c-text-link-minor-visited:#6b4fe8;--c-text-link-secondary-visited:#6e6a81;--c-background-primary:#fff;--c-background-primary-selected:#f7f5ff;--c-background-secondary:#f3f1f8;--c-background-secondary-selected:#e7e2fd;--c-background-tooltip:#211f2e;--c-background-primary-alt:#3416b6;--c-background-light:#f8f8fc;--c-background-light-alt:hsla(0,0%,100%,.08);--c-error-bg:#fdb1aa;--c-error:#f44434;--c-error-hover:#e91f0c;--c-error-text:#e91f0c;--c-error-active:#cb1b0b;--c-warn-bg:#fee7a9;--c-warn:#fac32e;--c-warn-hover:#e5a906;--c-warn-text:#e5a906;--c-warn-active:#d19b05;--c-success-bg:#caf49a;--c-success:#87d232;--c-success-hover:#78bc29;--c-success-text:#78bc29;--c-success-active:#6dab26;--c-border:rgba(127,120,161,.4);--c-border-hover:rgba(115,108,147,.5);--c-border-focus:#3416b6;--c-separator:rgba(150,142,190,.2);--c-disabled:rgba(150,142,190,.2);--c-disabled-text:rgba(105,99,131,.6);--c-disabled-border:rgba(127,120,161,.4);--c-icon:rgba(115,108,147,.5);--c-icon-hover:#211f2e;--c-icon-alt-bg:hsla(0,0%,100%,.32);--c-icon-alt-bg-hover:#fff;--c-primary-alt-bg:#fff;--c-primary-alt-bg-hover:#f3f1f8;--c-primary-alt-bg-active:#eae9f2;--c-secondary-alt-bg:hsla(0,0%,100%,.16);--c-secondary-alt-bg-hover:hsla(0,0%,100%,.32);--c-secondary-alt-bg-active:hsla(0,0%,100%,.64);--c-text-primary-alt-bg:#fff;--c-text-secondary-alt-bg:hsla(0,0%,100%,.64);--c-text-minor-alt-bg:hsla(0,0%,100%,.32);--c-text-link-alt-bg:#ff794d;--c-text-link-alt-bg-hover:#f44434;--c-text-link-alt-bg-visited:#ff794d;--c-text-link-minor-alt-bg:#ffa78a;--c-text-link-minor-alt-bg-hover:#ff794d;--c-text-link-minor-alt-bg-visited:#ffa78a;--c-border-alt-bg:hsla(0,0%,100%,.64);--c-border-alt-bg-hover:#fff;--c-border-alt-bg-focus:#fff;--c-overlay:rgba(105,99,131,.6);--c-separator-alt-bg:hsla(0,0%,100%,.32);--c-disabled-alt-bg:hsla(0,0%,100%,.16);--c-disabled-text-alt-bg:hsla(0,0%,100%,.64);--c-disabled-border-alt-bg:rgba(115,108,147,.5);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:#78bc29;--c-toast-warning-bg:#e5a906;--c-toast-error-bg:#e91f0c;--c-toast-default-bg:#464257;--c-primary-pressed:#1b0c5f;--c-primary-alt-bg-pressed:#eae9f2;--c-secondary-pressed:rgba(105,99,131,.6);--c-accent-pressed:#eb3b00;--c-error-pressed:#cb1b0b;--c-warn-pressed:#d19b05;--c-success-pressed:#6dab26;--c-text-disabled:#b8b4ca;--c-text-disabled-transparent:rgba(105,99,131,.6);--c-text-disabled-transparent-alt-bg:hsla(0,0%,100%,.32);--c-brand-purple:#8e75fa;--c-brand-orange:#ff794d;--c-brand-yellow:#fac32e;--c-brand-cyan:#28b8bd;--c-brand-turquoise:#28b8bd}.file-module_box__QvNri{align-items:center;display:flex;padding:8px 0}.file-module_box__QvNri+.file-module_box__QvNri{margin-top:16px}.file-module_block__XG5Uj+.file-module_block__XG5Uj{margin-left:8px}.file-module_box__QvNri.file-module_success__uruml .file-module_icon__43tYt{color:#87d232}.file-module_box__QvNri.file-module_error__8fBHV .file-module_desc__6XHy3,.file-module_box__QvNri.file-module_error__8fBHV .file-module_icon__43tYt{color:#f44434}.file-module_box__QvNri.file-module_readonly__gCsan .file-module_desc__6XHy3,.file-module_box__QvNri.file-module_readonly__gCsan .file-module_title__UxczD{color:rgba(105,99,131,.6)}.file-module_content__jcOTX{align-items:center;display:flex;flex:1 1;min-width:0}.file-module_content__jcOTX.file-module_interactive__ZuVDt:hover{cursor:pointer}.file-module_content__jcOTX.file-module_interactive__ZuVDt:hover .file-module_icon__43tYt{color:#211f2e}.file-module_content__jcOTX.file-module_interactive__ZuVDt:hover .file-module_title__UxczD{color:#3416b6}.file-module_info__N5J19{flex:1 1;margin-left:8px;min-width:0}.file-module_progress__txp-2{background-color:#f3f1f8;border-bottom-left-radius:4px;border-bottom-right-radius:4px;border-top-left-radius:4px;border-top-right-radius:4px;height:4px;margin-top:4px;overflow:hidden;position:relative;width:100%}.file-module_progress__txp-2 .file-module_bar__pMSEv{background-color:#87d232;border-bottom-right-radius:4px;border-top-right-radius:4px;bottom:0;left:0;position:absolute;top:0;transition:right .24s cubic-bezier(.24,.1,.24,1)}.file-module_title__UxczD{color:#211f2e;font:400 16px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;font-weight:700;transition:color .24s cubic-bezier(.24,.1,.24,1)}.file-module_desc__6XHy3{color:rgba(73,68,95,.8);font:400 14px/20px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}.file-module_text__hPbAT{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.file-module_actions__53VXq{flex-shrink:0}.file-module_actions__53VXq .file-module_item__dtDxE+.file-module_item__dtDxE{margin-left:16px}.file-module_actions__53VXq .file-module_item__dtDxE{color:rgba(115,108,147,.5);cursor:pointer}.file-module_actions__53VXq .file-module_item__dtDxE:hover{color:#211f2e}.file-module_icon__43tYt{align-items:center;color:rgba(115,108,147,.5);display:flex;height:32px;justify-content:center;transition:color .24s cubic-bezier(.24,.1,.24,1);width:32px}";
var s$1 = {"box":"file-module_box__QvNri","block":"file-module_block__XG5Uj","success":"file-module_success__uruml","icon":"file-module_icon__43tYt","error":"file-module_error__8fBHV","desc":"file-module_desc__6XHy3","readonly":"file-module_readonly__gCsan","title":"file-module_title__UxczD","content":"file-module_content__jcOTX","interactive":"file-module_interactive__ZuVDt","info":"file-module_info__N5J19","progress":"file-module_progress__txp-2","bar":"file-module_bar__pMSEv","text":"file-module_text__hPbAT","actions":"file-module_actions__53VXq","item":"file-module_item__dtDxE"};
styleInject(css_248z$H);

var context = React.createContext({
    dataTest: void 0,
});

const Badge = (_a) => {
    var props = __rest(_a, []);
    return (React.createElement("div", { className: s$1.block },
        React.createElement(Badge$1, Object.assign({}, props, { size: "m" }))));
};
Badge.slot = 'File:badge';
const Title = ({ children }) => {
    const { dataTest } = React.useContext(context);
    return (React.createElement("div", { "data-test": dataTest && `${dataTest}-title`, className: cn(s$1.title, s$1.text) }, children));
};
Title.slot = 'File:title';
const Description = ({ children }) => {
    const { dataTest } = React.useContext(context);
    return (React.createElement("div", { "data-test": dataTest && `${dataTest}-description`, className: cn(s$1.desc, s$1.text) }, children));
};
Description.slot = 'File:description';

const Action$1 = (_a) => {
    var props = __rest(_a, []);
    return React.createElement(Option$1, Object.assign({}, props));
};
Action$1.slot = 'File:actions';
const Actions = ({ onAction, children }) => {
    const { dataTest } = React.useContext(context);
    return (React.createElement(Select, { mode: "standalone", onChange: onAction, dataTest: dataTest && `${dataTest}-actions` },
        React.createElement("span", { className: s$1.item },
            React.createElement(Icon$2, { dataTest: dataTest && `${dataTest}-actions-dots`, name: "dots-horizontal", size: "m" })),
        React.createElement(Select.Content, { positioning: "end" }, children)));
};

function clamp$1(v, min, max) {
    return Math.min(Math.max(v, min), max);
}
const glyphs = ['document-check', 'document-times', 'document-lock'];
const File = ({ loading, progress, success, error, children, onClick, readonly, onDownload, onDelete, onAction, dataTest, }) => {
    const slots = useSlots('File', children);
    const uploading = Number.isInteger(progress);
    const interactive = !uploading && !readonly;
    const icon = glyphs[[success, error, readonly].findIndex(s => s)] || 'document';
    const contextValue = React.useMemo(() => ({ dataTest }), [dataTest]);
    return (React.createElement("div", { "data-test": dataTest, className: cn(s$1.box, success && s$1.success, error && s$1.error, readonly && s$1.readonly) },
        React.createElement(context.Provider, { value: contextValue },
            React.createElement("div", { className: cn(s$1.block, s$1.content, interactive && onClick && s$1.interactive), onClick: interactive ? onClick : void 0 },
                React.createElement("div", { className: s$1.icon },
                    (!loading || uploading) && React.createElement(Icon$4, { name: icon, size: "l" }),
                    loading && !uploading && React.createElement(Spinner, { size: "s" })),
                React.createElement("div", { className: s$1.info },
                    slots['title'],
                    uploading && (React.createElement("div", { className: s$1.progress },
                        React.createElement("div", { className: s$1.bar, style: { right: `${100 - clamp$1(progress, 0, 100)}%` } }))),
                    !uploading && slots['description'])),
            slots['badge'],
            !loading && (React.createElement("div", { className: cn(s$1.block, s$1.actions) },
                onDownload && !uploading && !error && (React.createElement("span", { className: s$1.item, onClick: onDownload, "data-test": dataTest && `${dataTest}-download` },
                    React.createElement(Icon$4, { name: "download", size: "m" }))),
                onDelete && !readonly && (React.createElement("span", { className: s$1.item, onClick: onDelete, "data-test": dataTest && `${dataTest}-delete` },
                    React.createElement(Icon$4, { name: "trashbin", size: "m" }))),
                !uploading && slots['actions'] && React.createElement(Actions, { onAction: onAction }, slots['actions']))))));
};
File.Badge = Badge;
File.Title = Title;
File.Description = Description;
File.Action = Action$1;

var css_248z$G = ".item-module_file__geXwp{padding:0 var(--padding-xl)}.item-module_file__geXwp:hover{background-color:var(--color-black-50)}.item-module_file__geXwp.item-module_disabled__G-NDU:hover{background-color:transparent;background-color:initial;cursor:default}.item-module_file__geXwp.item-module_withoutPadding__j4uNS{padding:0}.item-module_errorMessage__7BemG{color:var(--color-red)}.item-module_extra__zQNqR{padding-right:var(--padding-xs)}";
var styles$j = {"file":"item-module_file__geXwp","disabled":"item-module_disabled__G-NDU","withoutPadding":"item-module_withoutPadding__j4uNS","errorMessage":"item-module_errorMessage__7BemG","extra":"item-module_extra__zQNqR"};
styleInject(css_248z$G);

const uploadedStatus = ['UPLOADED', 'SUCCESS'];
const DEFAULT_BADGE_COLOR = 'gray';
const DocumentItem = (props) => {
    var _a;
    const { data, onDelete, onDownload, onClick, disabled, readonly, badge, note, withoutPadding, errorMessage, extra, className, index, withoutContextMenu, withoutDownloadOnClick, withFileSize, } = props;
    const isLoadingError = data.status === 'ERROR';
    const isUploaded = uploadedStatus.some((status) => status === data.status);
    const isLoading = data.status === 'LOADING';
    const handleDelete = React.useCallback(() => {
        onDelete === null || onDelete === void 0 ? void 0 : onDelete(index === undefined ? data.id : index);
    }, [onDelete, index, data]);
    const handleDownload = React.useCallback(() => {
        if (isUploaded && onDownload) {
            onDownload === null || onDownload === void 0 ? void 0 : onDownload(data);
        }
    }, [isUploaded, onDownload, data]);
    const contextMenuOptions = React.useMemo(() => {
        const options = [];
        if (onDelete && !readonly && !disabled && !withoutContextMenu) {
            options.push({
                value: data,
                label: 'Удалить',
                onClick: handleDelete,
            });
        }
        return options;
    }, [disabled, onDelete, data, handleDelete, readonly, withoutContextMenu]);
    const handleAction = React.useCallback((actionName) => {
        if (withoutContextMenu)
            return void 0;
        const currentAction = contextMenuOptions.find((option) => option.label === actionName);
        return currentAction === null || currentAction === void 0 ? void 0 : currentAction.onClick(currentAction.value);
    }, [contextMenuOptions, withoutContextMenu]);
    const badgeColor = (badge === null || badge === void 0 ? void 0 : badge.color) || DEFAULT_BADGE_COLOR;
    return (React.createElement("div", { className: cn(styles$j.file, { [styles$j.withoutPadding]: withoutPadding }, className), onClick: onClick },
        React.createElement(File, { readonly: disabled, loading: isLoading, error: !!errorMessage, onClick: !withoutDownloadOnClick ? handleDownload : undefined, onDelete: withoutContextMenu ? handleDelete : undefined, onDownload: withoutContextMenu ? handleDownload : undefined, onAction: handleAction },
            React.createElement(File.Title, null, data.name),
            !errorMessage && (React.createElement(File.Description, null, note || (withFileSize && ((_a = data === null || data === void 0 ? void 0 : data.file) === null || _a === void 0 ? void 0 : _a.size) && `${bytesToMegabytes(data.file.size)} мб`))),
            errorMessage && (React.createElement(File.Description, null,
                React.createElement("div", { className: styles$j.errorMessage }, isLoadingError ? 'Не удалось загрузить файл' : errorMessage))),
            badge && !extra && (React.createElement(File.Badge, { color: badgeColor },
                React.createElement(Badge$1, { color: badgeColor }, badge.label))),
            extra && (React.createElement(File.Badge, { color: "white" },
                React.createElement("div", { className: styles$j.extra }, extra))),
            contextMenuOptions.map((option, id) => (React.createElement(File.Action, { key: id, value: String(option.label) }, option.label))))));
};

function mapMeta$3(value, meta) {
    const { submitError, dirtySinceLastSubmit } = meta;
    const hint = (meta.touched && meta.error) || (!dirtySinceLastSubmit && submitError);
    if (!hint) {
        return {
            spaced: true,
        };
    }
    const error = !!hint;
    const valid = meta.touched && !isEmptyValue(value) && !error;
    const spaced = !error;
    return {
        hint,
        error,
        valid,
        spaced,
    };
}
function isEmptyValue(value) {
    return value === undefined || value === '' || Number.isNaN(value);
}

const InputField = (_a) => {
    var { input: { onChange: fieldOnChange, onFocus, onBlur, value, name }, meta, onChange: userOnChange, onBlur: userOnBlur, onFocus: userOnFocus, size = 'l' } = _a, props = __rest(_a, ["input", "meta", "onChange", "onBlur", "onFocus", "size"]);
    const state = mapMeta$3(value, meta);
    const handleInputChange = React.useCallback((v, event) => {
        userOnChange === null || userOnChange === void 0 ? void 0 : userOnChange(v, event);
        fieldOnChange(v);
    }, [fieldOnChange, userOnChange]);
    const handleInputBlur = React.useCallback(e => {
        userOnBlur === null || userOnBlur === void 0 ? void 0 : userOnBlur(e);
        onBlur(e);
    }, [onBlur, userOnBlur]);
    const handleInputFocus = React.useCallback(e => {
        userOnFocus === null || userOnFocus === void 0 ? void 0 : userOnFocus(e);
        onFocus(e);
    }, [onFocus, userOnFocus]);
    return (React.createElement(Input$1, Object.assign({}, props, state, { value: value, name: name, onFocus: handleInputFocus, onBlur: handleInputBlur, onChange: handleInputChange, onReset: false, size: size })));
};

const NumberInputField = (_a) => {
    var { input: { onChange: fieldOnChange, onFocus, onBlur, value, name }, meta, onChange: userOnChange, onBlur: userOnBlur, onFocus: userOnFocus, size = 'l' } = _a, props = __rest(_a, ["input", "meta", "onChange", "onBlur", "onFocus", "size"]);
    const state = mapMeta$3(value, meta);
    const handleInputChange = React.useCallback((v, event) => {
        userOnChange === null || userOnChange === void 0 ? void 0 : userOnChange(v, event);
        fieldOnChange(v);
    }, [fieldOnChange, userOnChange]);
    const handleInputBlur = React.useCallback(e => {
        userOnBlur === null || userOnBlur === void 0 ? void 0 : userOnBlur(e);
        onBlur(e);
    }, [onBlur, userOnBlur]);
    const handleInputFocus = React.useCallback(e => {
        userOnFocus === null || userOnFocus === void 0 ? void 0 : userOnFocus(e);
        onFocus(e);
    }, [onFocus, userOnFocus]);
    return (React.createElement(NumberInput$1, Object.assign({}, props, state, { value: value, name: name, onFocus: handleInputFocus, onBlur: handleInputBlur, onChange: handleInputChange, onReset: false, size: size })));
};

const PhoneInputField = (_a) => {
    var { input: { onChange: fieldOnChange, onFocus, onBlur, value, name }, meta, onChange: userOnChange, onBlur: userOnBlur, onFocus: userOnFocus, size = 'l' } = _a, props = __rest(_a, ["input", "meta", "onChange", "onBlur", "onFocus", "size"]);
    const state = mapMeta$3(value, meta);
    const handleInputChange = React.useCallback((v, event) => {
        userOnChange === null || userOnChange === void 0 ? void 0 : userOnChange(v, event);
        fieldOnChange(v);
    }, [fieldOnChange, userOnChange]);
    const handleInputBlur = React.useCallback(e => {
        userOnBlur === null || userOnBlur === void 0 ? void 0 : userOnBlur(e);
        onBlur(e);
    }, [onBlur, userOnBlur]);
    const handleInputFocus = React.useCallback(e => {
        userOnFocus === null || userOnFocus === void 0 ? void 0 : userOnFocus(e);
        onFocus(e);
    }, [onFocus, userOnFocus]);
    return (React.createElement(PhoneInput, Object.assign({}, props, state, { value: value, name: name, onFocus: handleInputFocus, onBlur: handleInputBlur, onChange: handleInputChange, onReset: false, size: size })));
};

var ReactFinalFormContext = /*#__PURE__*/React__namespace.createContext();
formSubscriptionItems.reduce(function (result, key) {
  result[key] = true;
  return result;
}, {});

function useForm$1(componentName) {
  var form = React__namespace.useContext(ReactFinalFormContext);

  if (!form) {
    throw new Error((componentName || 'useForm') + " must be used inside of a <Form> component");
  }

  return form;
}

fieldSubscriptionItems.reduce(function (result, key) {
  result[key] = true;
  return result;
}, {});

var css_248z$F = ":root{--border-radius-normal:4px;--border-radius-large:8px;--border-radius-rounded:20px;--border-radius-circle:50%;--screen-xs-start:0px;--screen-xs-end:767px;--screen-s-start:768px;--screen-s-end:959px;--screen-m-start:960px;--screen-m-end:1199px;--screen-l-start:1200px;--screen-l-end:1419px;--screen-xl-start:1420px;--screen-sidebar-xs-start:0px;--screen-sidebar-xs-end:831px;--screen-sidebar-s-start:832px;--screen-sidebar-s-end:1024px;--screen-sidebar-m-start:1025px;--screen-sidebar-m-end:1439px;--screen-sidebar-l-start:1440px;--screen-sidebar-l-end:1659px;--screen-sidebar-xl-start:1660px;--color-input-border:var(--color-black-200);--color-input-placeholder:var(--color-black-300);--color-input-border-disabled:var(--color-black-100-alpha);--color-input-text-disabled:var(--color-black-300);--color-input-bg-disabled:var(--color-black-100);--color-input-bg-readonly:var(--color-black-100);--color-input-text-readonly:var(--color-black-400);--color-input-border-error:var(--color-red-500);--color-input-border-hovered:rgba(38,68,217,.92);--color-input-border-focused:rgba(38,68,217,.92);--color-input-border-valid:rgba(50,205,70,.92);--control-paddings:8px 16px;--control-height-s:40px;--control-height-m:52px;--control-height-l:60px;--font-family:\"ALS Hauss\",\"Tahoma\",\"Helvetica Neue\",\"Arial\",sans-serif;--font-size-4xl:44px;--font-size-3xl:32px;--font-size-xxl:28px;--font-size-xl:22px;--font-size-l:18px;--font-size-m:16px;--font-size-s:14px;--font-size-xs:12px;--line-height-4xl:56px;--line-height-3xl:46px;--line-height-2xl:40px;--line-height-xxl:36px;--line-height-xl:28px;--line-height-l:24px;--line-height-m:20px;--line-height-s:16px;--l-drawer:100;--l-modal:101;--l-dropdown:102;--l-tooltip:103;--l-notification:103;--shadow-size-z1:0px 4px 4px;--shadow-size-z2:0px 4px 8px;--shadow-size-z3:0px 8px 12px;--shadow-size-z4:0px 12px 20px;--shadow-size-z5:0px 20px 24px;--mobile-s:320px;--mobile-m:375px;--mobile-l:413px;--tablet-s:600px;--tablet-m:768px;--desktop-s:1024px;--desktop-m:1280px;--desktop-l:1440px;--desktop-xl:1920px;--animation-duration:0.24s;--animation-timing-function:cubic-bezier(0.24,0.1,0.24,1);--animation:var(--animation-duration) var(--animation-timing-function);--color-black-50:#f8f8fc;--color-black-75:#f3f1f8;--color-black-100:#eae9f2;--color-black-200:#ccc9d9;--color-black-250:#b8b4ca;--color-black-300:#a4a1b5;--color-black-350:#8a869c;--color-black-400:#6e6a81;--color-black-450:#464257;--color-black-500:#211f2e;--color-black-50-alpha:rgba(186,176,227,.1);--color-black-75-alpha:rgba(194,189,219,.2);--color-black-100-alpha:rgba(150,142,190,.2);--color-black-200-alpha:rgba(127,120,161,.4);--color-black-250-alpha:rgba(115,108,147,.5);--color-black-300-alpha:rgba(105,99,131,.6);--color-black-400-alpha:rgba(73,68,95,.8);--color-black-500-alpha:#211f2e;--color-white-0:hsla(0,0%,100%,0);--color-white-500:#fff;--color-white-100-alpha:hsla(0,0%,100%,.08);--color-white-200-alpha:hsla(0,0%,100%,.16);--color-white-300-alpha:hsla(0,0%,100%,.32);--color-white-400-alpha:hsla(0,0%,100%,.64);--color-white-500-alpha:#fff;--color-blue-50:#f7f5ff;--color-blue-100:#e7e2fd;--color-blue-200:#ccc2fa;--color-blue-300:#a391f3;--color-blue-400:#6b4fe8;--color-blue-500:#3416b6;--color-blue-600:#271188;--color-blue-700:#1b0c5f;--color-blue-800:#150949;--color-orange-50:#fff7f5;--color-orange-100:#fff0eb;--color-orange-200:#ffe4db;--color-orange-300:#ffc9b8;--color-orange-400:#ffa78a;--color-orange-500:#ff794d;--color-orange-600:#ff4f14;--color-orange-700:#eb3b00;--color-purple-50:#f7f5ff;--color-purple-100:#eeebff;--color-purple-200:#e3dcfe;--color-purple-300:#cec4fd;--color-purple-400:#b6a6fc;--color-purple-500:#8e75fa;--color-purple-600:#6544f8;--color-purple-700:#5836ec;--color-turquoise-50:#f5ffff;--color-turquoise-100:#e7fdfe;--color-turquoise-200:#c6f9fb;--color-turquoise-300:#9bf0f3;--color-turquoise-400:#65e2e6;--color-turquoise-500:#28b8bd;--color-turquoise-600:#1f8f93;--color-turquoise-700:#1b7b7e;--color-yellow-50:#fffbf5;--color-yellow-100:#fff5e6;--color-yellow-200:#feeccd;--color-yellow-300:#fee7a9;--color-yellow-400:#fccc78;--color-yellow-500:#fac32e;--color-yellow-600:#e5a906;--color-yellow-700:#d19b05;--color-green-50:#fafff5;--color-green-100:#f3fee7;--color-green-200:#e4fbcb;--color-green-300:#caf49a;--color-green-400:#b4e878;--color-green-500:#87d232;--color-green-600:#78bc29;--color-green-700:#6dab26;--color-red-50:#fff6f5;--color-red-100:#ffe8e6;--color-red-200:#ffdad6;--color-red-300:#fdb1aa;--color-red-400:#fa857a;--color-red-500:#f44434;--color-red-600:#e91f0c;--color-red-700:#cb1b0b;--color-white:var(--color-white-500);--color-black:var(--color-black-500);--color-blue:var(--color-blue-500);--color-red:var(--color-red-500);--color-green:var(--color-green-500);--color-orange:var(--color-orange-500);--c-primary-bg:var(--color-blue-300);--c-primary:var(--color-blue-500);--c-primary-hover:var(--color-blue-600);--c-primary-active:var(--color-blue-700);--c-accent-bg:var(--color-orange-300);--c-accent:var(--color-orange-500);--c-accent-hover:var(--color-orange-600);--c-accent-active:var(--color-orange-700);--c-secondary:var(--color-black-100-alpha);--c-secondary-hover:var(--color-black-200-alpha);--c-secondary-active:var(--color-black-300-alpha);--c-promo1:var(--color-purple-500);--c-promo1-hover:var(--color-purple-600);--c-promo1-active:var(--color-purple-700);--c-promo2:var(--color-turquoise-500);--c-promo2-hover:var(--color-turquoise-600);--c-promo2-active:var(--color-turquoise-700);--c-transparent:var(--color-white-0);--c-text-primary:var(--color-black-500);--c-text-secondary:var(--color-black-400-alpha);--c-text-minor:var(--color-black-300-alpha);--c-text-link:var(--color-blue-500);--c-text-link-hover:var(--color-orange-500);--c-text-link-visited:var(--color-blue-600);--c-text-link-minor:var(--color-blue-400);--c-text-link-minor-hover:var(--color-orange-400);--c-text-link-minor-visited:var(--color-blue-400);--c-text-link-secondary-visited:var(--color-black-400);--c-background-primary:var(--color-white-500);--c-background-primary-selected:var(--color-blue-50);--c-background-secondary:var(--color-black-75);--c-background-secondary-selected:var(--color-blue-100);--c-background-tooltip:var(--color-black-500);--c-background-primary-alt:var(--color-blue-500);--c-background-light:var(--color-black-50);--c-background-light-alt:var(--color-white-100-alpha);--c-error-bg:var(--color-red-300);--c-error:var(--color-red-500);--c-error-hover:var(--color-red-600);--c-error-text:var(--color-red-600);--c-error-active:var(--color-red-700);--c-warn-bg:var(--color-yellow-300);--c-warn:var(--color-yellow-500);--c-warn-hover:var(--color-yellow-600);--c-warn-text:var(--color-yellow-600);--c-warn-active:var(--color-yellow-700);--c-success-bg:var(--color-green-300);--c-success:var(--color-green-500);--c-success-hover:var(--color-green-600);--c-success-text:var(--color-green-600);--c-success-active:var(--color-green-700);--c-border:var(--color-black-200-alpha);--c-border-hover:var(--color-black-250-alpha);--c-border-focus:var(--color-blue-500);--c-separator:var(--color-black-100-alpha);--c-disabled:var(--color-black-100-alpha);--c-disabled-text:var(--color-black-300-alpha);--c-disabled-border:var(--color-black-200-alpha);--c-icon:var(--color-black-250-alpha);--c-icon-hover:var(--color-black-500);--c-icon-alt-bg:var(--color-white-300-alpha);--c-icon-alt-bg-hover:var(--color-white-500);--c-primary-alt-bg:var(--color-white-500);--c-primary-alt-bg-hover:var(--color-black-75);--c-primary-alt-bg-active:var(--color-black-100);--c-secondary-alt-bg:var(--color-white-200-alpha);--c-secondary-alt-bg-hover:var(--color-white-300-alpha);--c-secondary-alt-bg-active:var(--color-white-400-alpha);--c-text-primary-alt-bg:var(--color-white-500);--c-text-secondary-alt-bg:var(--color-white-400-alpha);--c-text-minor-alt-bg:var(--color-white-300-alpha);--c-text-link-alt-bg:var(--color-orange-500);--c-text-link-alt-bg-hover:var(--color-red-500);--c-text-link-alt-bg-visited:var(--color-orange-500);--c-text-link-minor-alt-bg:var(--color-orange-400);--c-text-link-minor-alt-bg-hover:var(--color-orange-500);--c-text-link-minor-alt-bg-visited:var(--color-orange-400);--c-border-alt-bg:var(--color-white-400-alpha);--c-border-alt-bg-hover:var(--color-white-500);--c-border-alt-bg-focus:var(--color-white-500);--c-overlay:var(--color-black-300-alpha);--c-separator-alt-bg:var(--color-white-300-alpha);--c-disabled-alt-bg:var(--color-white-200-alpha);--c-disabled-text-alt-bg:var(--color-white-400-alpha);--c-disabled-border-alt-bg:var(--color-black-250-alpha);--c-shadow-hsl:251,20%,15%;--c-primary-hsl:251,78%,40%;--c-accent-hsl:15,100%,65%;--c-error-hsl:5,90%,58%;--c-warn-hsl:44,95%,58%;--c-success-hsl:88,64%,51%;--c-toast-success-bg:var(--color-green-600);--c-toast-warning-bg:var(--color-yellow-600);--c-toast-error-bg:var(--color-red-600);--c-toast-default-bg:var(--color-black-450);--c-primary-pressed:var(--color-blue-700);--c-primary-alt-bg-pressed:var(--color-black-100);--c-secondary-pressed:var(--color-black-300-alpha);--c-accent-pressed:var(--color-orange-700);--c-error-pressed:var(--color-red-700);--c-warn-pressed:var(--color-yellow-700);--c-success-pressed:var(--color-green-700);--c-text-disabled:var(--color-black-250);--c-text-disabled-transparent:var(--color-black-300-alpha);--c-text-disabled-transparent-alt-bg:var(--color-white-300-alpha);--c-brand-purple:var(--color-purple-500);--c-brand-orange:var(--color-orange-500);--c-brand-yellow:var(--color-yellow-500);--c-brand-cyan:var(--color-turquoise-500);--c-brand-turquoise:var(--color-turquoise-500);--font-family:\"ALS Hauss\",\"Helvetica Neue\",\"Tahoma\",\"Arial\",sans-serif;--t-promo-h1:500 52px/64px var(--font-family);--t-promo-h1-mobile:500 28px/36px var(--font-family);--t-promo-h2:500 36px/44px var(--font-family);--t-promo-h2-mobile:500 24px/32px var(--font-family);--t-promo-h3:500 28px/36px var(--font-family);--t-promo-h3-mobile:500 20px/28px var(--font-family);--t-promo-h4:500 24px/32px var(--font-family);--t-promo-h4-mobile:500 18px/24px var(--font-family);--t-promo-h5:500 20px/28px var(--font-family);--t-promo-subheader:400 22px/32px var(--font-family);--t-promo-subheader-alone:400 22px/28px var(--font-family);--t-promo-subheader-mobile:400 18px/28px var(--font-family);--t-promo-primary:400 18px/28px var(--font-family);--t-promo-primary-alone:400 18px/24px var(--font-family);--t-promo-primary-mobile:400 16px/24px var(--font-family);--t-h1:500 32px/40px var(--font-family);--t-h1-mobile:500 22px/32px var(--font-family);--t-h2:500 28px/36px var(--font-family);--t-h2-mobile:500 18px/24px var(--font-family);--t-h3:500 22px/32px var(--font-family);--t-h3-mobile:500 16px/24px var(--font-family);--t-h4:500 18px/28px var(--font-family);--t-h4-mobile:500 16px/24px var(--font-family);--t-primary-alone:400 16px/20px var(--font-family);--t-primary:400 16px/24px var(--font-family);--t-secondary-alone:400 14px/20px var(--font-family);--t-secondary:400 14px/24px var(--font-family);--t-small-alone:400 12px/16px var(--font-family);--t-small:400 12px/20px var(--font-family);--t-tiny-alone:400 10px/14px var(--font-family);--t-tiny:400 10px/18px var(--font-family);--l-drawer:1000;--l-sticky:1010;--l-fixed:1020;--l-overlay:1030;--l-offcanvas:1040;--l-modal:1050;--l-dropdown:1060;--l-popover:1070;--l-tooltip:1080;--l-notification:1090;--step:4px;--padding-xxs:4px;--padding-xs:8px;--padding-s:12px;--padding-m:16px;--padding-l:20px;--padding-xl:24px;--padding-xxl:32px;--padding-xxxl:64px;--shadow-spread-z1:0px 2px 12px;--shadow-spread-z2:0px 4px 16px;--shadow-spread-z3:0px 8px 32px;--shadow-spread-z3-mobile:0px -2px 12px;--shadow-opacity-z1:0.08;--shadow-opacity-z2:0.12;--shadow-opacity-z3:0.16;--shadow-opacity-z3-mobile:0.08;--sh-z1:var(--shadow-spread-z1) hsla(var(--c-shadow-hsl),var(--shadow-opacity-z1));--sh-z2:var(--shadow-spread-z2) hsla(var(--c-shadow-hsl),var(--shadow-opacity-z2));--sh-z3:var(--shadow-spread-z3) hsla(var(--c-shadow-hsl),var(--shadow-opacity-z3));--sh-z3-mobile:var(--shadow-spread-z3-mobile) hsla(var(--c-shadow-hsl),var(--shadow-opacity-z3-mobile));--sh-z1-primary:var(--shadow-spread-z1) hsla(var(--c-primary-hsl),var(--shadow-opacity-z1));--sh-z2-primary:var(--shadow-spread-z2) hsla(var(--c-primary-hsl),var(--shadow-opacity-z2));--sh-z3-primary:var(--shadow-spread-z3) hsla(var(--c-primary-hsl),var(--shadow-opacity-z3));--sh-z3-primary-mobile:var(--shadow-spread-z3-mobile) hsla(var(--c-primary-hsl),var(--shadow-opacity-z3-mobile));--sh-z1-accent:var(--shadow-spread-z1) hsla(var(--c-accent-hsl),var(--shadow-opacity-z1));--sh-z2-accent:var(--shadow-spread-z2) hsla(var(--c-accent-hsl),var(--shadow-opacity-z2));--sh-z3-accent:var(--shadow-spread-z3) hsla(var(--c-accent-hsl),var(--shadow-opacity-z3));--sh-z3-accent-mobile:var(--shadow-spread-z3-mobile) hsla(var(--c-accent-hsl),var(--shadow-opacity-z3-mobile));--sh-z1-success:var(--shadow-spread-z1) hsla(var(--c-success-hsl),var(--shadow-opacity-z1));--sh-z2-success:var(--shadow-spread-z2) hsla(var(--c-success-hsl),var(--shadow-opacity-z2));--sh-z3-success:var(--shadow-spread-z3) hsla(var(--c-success-hsl),var(--shadow-opacity-z3));--sh-z3-success-mobile:var(--shadow-spread-z3-mobile) hsla(var(--c-success-hsl),var(--shadow-opacity-z3-mobile));--sh-z1-error:var(--shadow-spread-z1) hsla(var(--c-error-hsl),var(--shadow-opacity-z1));--sh-z2-error:var(--shadow-spread-z2) hsla(var(--c-error-hsl),var(--shadow-opacity-z2));--sh-z3-error:var(--shadow-spread-z3) hsla(var(--c-error-hsl),var(--shadow-opacity-z3));--sh-z3-error-mobile:var(--shadow-spread-z3-mobile) hsla(var(--c-error-hsl),var(--shadow-opacity-z3-mobile));--sh-z1-warn:var(--shadow-spread-z1) hsla(var(--c-warn-hsl),var(--shadow-opacity-z1));--sh-z2-warn:var(--shadow-spread-z2) hsla(var(--c-warn-hsl),var(--shadow-opacity-z2));--sh-z3-warn:var(--shadow-spread-z3) hsla(var(--c-warn-hsl),var(--shadow-opacity-z3));--sh-z3-warn-mobile:var(--shadow-spread-z3-mobile) hsla(var(--c-warn-hsl),var(--shadow-opacity-z3-mobile));--s-unit-05x:4px;--s-unit:8px;--s-unit-2x:16px;--s-unit-3x:24px;--s-unit-4x:32px;--s-unit-5x:40px;--s-unit-6x:48px;--s-unit-7x:56px;--s-unit-8x:64px;--s-unit-9x:72px;--s-unit-10x:80px;--s-unit-11x:88px;--s-unit-12x:96px;--s-unit-13x:104px;--s-unit-14x:112px;--s-unit-15x:120px;--s-unit-16x:128px;--s-unit-05x-neg:-4px;--s-unit-neg:-8px;--s-unit-2x-neg:-16px;--s-unit-3x-neg:-24px;--s-unit-4x-neg:-32px;--s-unit-5x-neg:-40px;--s-unit-6x-neg:-48px;--s-unit-7x-neg:-56px;--s-unit-8x-neg:-64px;--s-unit-9x-neg:-72px;--s-unit-10x-neg:-80px;--s-unit-11x-neg:-88px;--s-unit-12x-neg:-96px;--s-unit-13x-neg:-104px;--s-unit-14x-neg:-112px;--s-unit-15x-neg:-120px;--s-unit-16x-neg:-128px;--s-unit-max:1308px;--s-unit-max-promo:1128px}@font-face{font-display:swap;font-family:ALS Hauss;font-style:normal;font-weight:400;src:url(https://cdn.m2.ru/assets/media/ALS_Hauss-Regular.eot);src:url(https://cdn.m2.ru/assets/media/ALS_Hauss-Regular.woff2) format(\"woff2\"),url(https://cdn.m2.ru/assets/media/ALS_Hauss-Regular.eot?#iefix) format(\"embedded-opentype\"),url(https://cdn.m2.ru/assets/media/ALS_Hauss-Regular.woff) format(\"woff\"),url(https://cdn.m2.ru/assets/media/ALS_Hauss-Regular.ttf) format(\"truetype\")}@font-face{font-display:swap;font-family:ALS Hauss;font-style:normal;font-weight:700;src:url(https://cdn.m2.ru/assets/media/ALS_Hauss-Medium.eot);src:url(https://cdn.m2.ru/assets/media/ALS_Hauss-Medium.eot?#iefix) format(\"embedded-opentype\"),url(https://cdn.m2.ru/assets/media/ALS_Hauss-Medium.woff2) format(\"woff2\"),url(https://cdn.m2.ru/assets/media/ALS_Hauss-Medium.woff) format(\"woff\"),url(https://cdn.m2.ru/assets/media/ALS_Hauss-Medium.ttf) format(\"truetype\")}@font-face{font-display:swap;font-family:ALS Hauss;font-style:normal;font-weight:500;src:url(https://cdn.m2.ru/assets/media/ALS_Hauss-Medium.eot);src:url(https://cdn.m2.ru/assets/media/ALS_Hauss-Medium.eot?#iefix) format(\"embedded-opentype\"),url(https://cdn.m2.ru/assets/media/ALS_Hauss-Medium.woff2) format(\"woff2\"),url(https://cdn.m2.ru/assets/media/ALS_Hauss-Medium.woff) format(\"woff\"),url(https://cdn.m2.ru/assets/media/ALS_Hauss-Medium.ttf) format(\"truetype\")}.checkbox-field-module_checkboxWrapper__LRzqh{align-items:flex-start;display:flex}.checkbox-field-module_checkboxWrapper__LRzqh>label{-webkit-tap-highlight-color:transparent}.checkbox-field-module_icon__po1Ub{color:#ccc9d9;margin-left:8px;margin-top:-2px}.checkbox-field-module_checkbox__SArIv{pointer-events:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}";
var styles$i = {"checkboxWrapper":"checkbox-field-module_checkboxWrapper__LRzqh","icon":"checkbox-field-module_icon__po1Ub","checkbox":"checkbox-field-module_checkbox__SArIv"};
styleInject(css_248z$F);

const FinalFormCheckboxField = (_a) => {
    var { input: { onChange, checked, name }, meta: { touched, error, valid }, label, tooltip, onChange: additionalOnChange } = _a, props = __rest(_a, ["input", "meta", "label", "tooltip", "onChange"]);
    const { to, registerControl } = useTooltip();
    const formApi = useForm$1();
    React.useEffect(() => {
        formApi.change(name, checked);
    }, [checked, formApi, name]);
    return (React.createElement("div", { className: styles$i.checkboxWrapper },
        React.createElement(CheckboxField, Object.assign({}, props, { errorMessage: touched ? error : undefined, isValid: valid === false && touched ? false : undefined, checked: checked, name: name, onChange: () => {
                if (additionalOnChange) {
                    additionalOnChange(!checked);
                }
                return onChange(!checked);
            }, className: styles$i.checkbox }), label),
        tooltip && (React.createElement(React.Fragment, null,
            React.createElement("span", { ref: registerControl, className: styles$i.icon },
                React.createElement(Icon$4, { name: "question-circle" })),
            React.createElement(Tooltip$1, { to: to }, tooltip)))));
};

const FinalFormMaskedField = (_a) => {
    var { input: { onChange, onFocus, onBlur, value, name }, meta: { touched, error, valid }, onChange: userOnChange } = _a, props = __rest(_a, ["input", "meta", "onChange"]);
    const showValidation = error && touched;
    return (React.createElement(MaskedInputField, Object.assign({}, props, { fullWidth: true, size: props.size || Size.Large, errorMessage: showValidation ? error : '', isValid: valid === false && showValidation ? false : undefined, value: value ? value + '' : '', name: name, onFocus: onFocus, onChange: (valueInput, event) => {
            if (userOnChange != null) {
                userOnChange(valueInput, event);
            }
            onChange(valueInput);
        }, onBlur: onBlur })));
};

const FinalFormMoneyField = (_a) => {
    var { input: { onChange, onFocus, onBlur, value, name }, meta: { touched, error, valid }, onChange: userOnChange } = _a, props = __rest(_a, ["input", "meta", "onChange"]);
    const showValidation = error && touched;
    return (React.createElement(MoneyInputField, Object.assign({}, props, { fullWidth: true, size: props.size || Size.Large, errorMessage: showValidation ? error : '', isValid: valid === false && showValidation ? false : undefined, value: value, name: name, onFocus: onFocus, onChange: (valueInput, event) => {
            if (userOnChange != null) {
                userOnChange(valueInput, event);
            }
            onChange(valueInput);
        }, onBlur: onBlur })));
};

const FinalFormRadioGroupField = (_a) => {
    var { input: { onChange, value, name }, meta: { touched, error, valid } } = _a, props = __rest(_a, ["input", "meta"]);
    return (React.createElement(RadioGroupField, Object.assign({}, props, { errorMessage: touched ? error : undefined, isValid: valid === false && touched ? false : undefined, value: value, name: name, onChange: onChange })));
};

const FinalFormSelectField = (_a) => {
    var { input: { onChange, onFocus, onBlur, value, name }, meta: { error, touched, initial, valid }, onChange: userOnChange, options, emptyValue = 'undefined' } = _a, props = __rest(_a, ["input", "meta", "onChange", "options", "emptyValue"]);
    const initialValue = React.useMemo(() => {
        if (initial !== undefined) {
            return initial;
        }
        const initialSelectedOption = options.find(option => option.selected) || options[0];
        return initialSelectedOption ? initialSelectedOption.value : undefined;
    }, [initial, options]);
    const [state, setState] = React.useState(initialValue);
    const handleChange = React.useCallback((v) => {
        if (userOnChange != null) {
            userOnChange(v);
        }
        onChange(v);
        setState(v);
    }, [onChange, userOnChange]);
    const formApi = useForm$1();
    React.useEffect(() => {
        setState(initialValue);
    }, [initialValue]);
    React.useEffect(() => {
        if (value) {
            setState(value);
        }
    }, [value]);
    React.useEffect(() => {
        if (value !== undefined && value !== '') {
            return;
        }
        if (initialValue && initialValue !== initial) {
            formApi.change(name, initialValue);
        }
    }, [formApi, initial, initialValue, name, value]);
    const showValidation = error && touched;
    return (React.createElement(SelectField, Object.assign({}, props, { name: name, fullWidth: true, size: props.size || Size.Large, errorMessage: showValidation ? error : undefined, isValid: valid === false && showValidation ? false : undefined, onChange: handleChange, onFocus: onFocus, onBlur: onBlur, value: state === emptyValue || state === undefined ? '' : state, options: options })));
};

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$g(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$g;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$a = freeGlobal || freeSelf || Function('return this')();

var _root = root$a;

var root$9 = _root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$3 = function() {
  return root$9.Date.now();
};

var now_1 = now$3;

/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;

var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim$1;

var root$8 = _root;

/** Built-in value references. */
var Symbol$7 = root$8.Symbol;

var _Symbol = Symbol$7;

var Symbol$6 = _Symbol;

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$f.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$6 ? Symbol$6.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$d.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$e = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$e.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$5 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$5 ? Symbol$5.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$7(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$7;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$9(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$9;

var baseGetTag$6 = _baseGetTag,
    isObjectLike$8 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$3 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$5(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$8(value) && baseGetTag$6(value) == symbolTag$3);
}

var isSymbol_1 = isSymbol$5;

var baseTrim = _baseTrim,
    isObject$f = isObject_1,
    isSymbol$4 = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$4(value)) {
    return NAN;
  }
  if (isObject$f(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$f(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber$1;

var isObject$e = isObject_1,
    now$2 = now_1,
    toNumber = toNumber_1;

/** Error message constants. */
var FUNC_ERROR_TEXT$3 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$2(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  wait = toNumber(wait) || 0;
  if (isObject$e(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$2();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$2());
  }

  function debounced() {
    var time = now$2(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce$2;

function useFirstMountState() {
    var isFirst = React.useRef(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}

var useUpdateEffect = function (effect, deps) {
    var isFirstMount = useFirstMountState();
    React.useEffect(function () {
        if (!isFirstMount) {
            return effect();
        }
    }, deps);
};
var useUpdateEffect$1 = useUpdateEffect;

function useMountedState() {
    var mountedRef = React.useRef(false);
    var get = React.useCallback(function () { return mountedRef.current; }, []);
    React.useEffect(function () {
        mountedRef.current = true;
        return function () {
            mountedRef.current = false;
        };
    }, []);
    return get;
}

var noop$2 = function () { };
var isBrowser$1 = typeof window !== 'undefined';

var js_cookieExports = {};
var js_cookie = {
  get exports(){ return js_cookieExports; },
  set exports(v){ js_cookieExports = v; },
};

/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */

(function (module, exports) {
(function (factory) {
		var registeredInModuleLoader;
		{
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}

		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}

		function init (converter) {
			function api() {}

			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}

				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}

					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}

				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}

				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;

				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');

					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}

					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);

						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}

						jar[name] = cookie;

						if (key === name) {
							break;
						}
					} catch (e) {}
				}

				return key ? jar[key] : jar;
			}

			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};

			api.defaults = {};

			api.withConverter = init;

			return api;
		}

		return init(function () {});
	}));
} (js_cookie));

var Cookies = js_cookieExports;

var useCookie = function (cookieName) {
    var _a = React.useState(function () { return Cookies.get(cookieName) || null; }), value = _a[0], setValue = _a[1];
    var updateCookie = React.useCallback(function (newValue, options) {
        Cookies.set(cookieName, newValue, options);
        setValue(newValue);
    }, [cookieName]);
    var deleteCookie = React.useCallback(function () {
        Cookies.remove(cookieName);
        setValue(null);
    }, [cookieName]);
    return [value, updateCookie, deleteCookie];
};
var useCookie$1 = useCookie;

var useEffectOnce = function (effect) {
    React.useEffect(effect, []);
};
var useEffectOnce$1 = useEffectOnce;

var useLocalStorage = function (key, initialValue, options) {
    if (!isBrowser$1) {
        return [initialValue, noop$2, noop$2];
    }
    if (!key) {
        throw new Error('useLocalStorage key may not be falsy');
    }
    var deserializer = options
        ? options.raw
            ? function (value) { return value; }
            : options.deserializer
        : JSON.parse;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var initializer = React.useRef(function (key) {
        try {
            var serializer = options ? (options.raw ? String : options.serializer) : JSON.stringify;
            var localStorageValue = localStorage.getItem(key);
            if (localStorageValue !== null) {
                return deserializer(localStorageValue);
            }
            else {
                initialValue && localStorage.setItem(key, serializer(initialValue));
                return initialValue;
            }
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw. JSON.parse and JSON.stringify
            // can throw, too.
            return initialValue;
        }
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var _a = React.useState(function () { return initializer.current(key); }), state = _a[0], setState = _a[1];
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useLayoutEffect(function () { return setState(initializer.current(key)); }, [key]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var set = React.useCallback(function (valOrFunc) {
        try {
            var newState = typeof valOrFunc === 'function' ? valOrFunc(state) : valOrFunc;
            if (typeof newState === 'undefined')
                return;
            var value = void 0;
            if (options)
                if (options.raw)
                    if (typeof newState === 'string')
                        value = newState;
                    else
                        value = JSON.stringify(newState);
                else if (options.serializer)
                    value = options.serializer(newState);
                else
                    value = JSON.stringify(newState);
            else
                value = JSON.stringify(newState);
            localStorage.setItem(key, value);
            setState(deserializer(value));
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw. Also JSON.stringify can throw.
        }
    }, [key, setState]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var remove = React.useCallback(function () {
        try {
            localStorage.removeItem(key);
            setState(undefined);
        }
        catch (_a) {
            // If user is in private mode or has storage restriction
            // localStorage can throw.
        }
    }, [key, setState]);
    return [state, set, remove];
};
var useLocalStorage$1 = useLocalStorage;

var getInitialState = function (query, defaultState) {
    // Prevent a React hydration mismatch when a default value is provided by not defaulting to window.matchMedia(query).matches.
    if (defaultState !== undefined) {
        return defaultState;
    }
    if (isBrowser$1) {
        return window.matchMedia(query).matches;
    }
    // A default value has not been provided, and you are rendering on the server, warn of a possible hydration mismatch when defaulting to false.
    if (process.env.NODE_ENV !== 'production') {
        console.warn('`useMedia` When server side rendering, defaultState should be defined to prevent a hydration mismatches.');
    }
    return false;
};
var useMedia = function (query, defaultState) {
    var _a = React.useState(getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
    React.useEffect(function () {
        var mounted = true;
        var mql = window.matchMedia(query);
        var onChange = function () {
            if (!mounted) {
                return;
            }
            setState(!!mql.matches);
        };
        mql.addListener(onChange);
        setState(mql.matches);
        return function () {
            mounted = false;
            mql.removeListener(onChange);
        };
    }, [query]);
    return state;
};
var useMedia$1 = useMedia;

var useMount = function (fn) {
    useEffectOnce$1(function () {
        fn();
    });
};
var useMount$1 = useMount;

var useUnmount = function (fn) {
    var fnRef = React.useRef(fn);
    // update the ref each render so if it change the newest callback will be invoked
    fnRef.current = fn;
    useEffectOnce$1(function () { return function () { return fnRef.current(); }; });
};
var useUnmount$1 = useUnmount;

const FinalFormDigitsOnlyMaskedField = (props) => {
    const { pattern, ...restProps } = props;
    const patternWithZeros = pattern.replace(/9/g, '0');
    const mask = IMask.createMask({
        mask: patternWithZeros,
    });
    const clearFormatting = (str) => str.replace(/\D/g, '');
    const trimAndClear = (str) => {
        const trimmed = str.trim();
        return clearFormatting(trimmed);
    };
    const formatter = (value) => {
        const cleared = trimAndClear(value);
        return mask.resolve(cleared);
    };
    return (React.createElement(FinalFormMaskedField, { ...restProps, formatter: formatter, parser: trimAndClear, pattern: pattern, placeholder: patternWithZeros, inputMode: "numeric" }));
};

function mapMeta$2(value, meta) {
    const { submitError, dirtySinceLastSubmit } = meta;
    const hint = !dirtySinceLastSubmit && ((meta.touched && meta.error) || (!dirtySinceLastSubmit ? submitError : undefined));
    const error = !!hint;
    const valid = meta.touched && value !== undefined && value !== '' && !error;
    return {
        hint,
        error,
        valid,
    };
}
const FinalFormSuggestInput = ({ input: { onChange: fieldOnChange, onFocus, onBlur, value, name }, meta, onChange: userOnChange, ...props }) => {
    const state = mapMeta$2(value, meta);
    const handleInputChange = React.useCallback((v, event) => {
        fieldOnChange(v);
        return userOnChange === null || userOnChange === void 0 ? void 0 : userOnChange(v, event);
    }, [fieldOnChange, userOnChange]);
    return (React.createElement(SuggestInput$1, { ...props, ...state, onChange: handleInputChange, value: value, onBlur: onBlur, onFocus: onFocus, onReset: false, size: "l", spaced: true, name: name }));
};

var css_248z$E = ".error-message-module_errorMessage__Ft-mM{color:var(--c-error);cursor:default;font-size:var(--font-size-xs);line-height:var(--line-height-m);margin:0;margin-bottom:var(--padding-xs);margin-top:var(--padding-xxs);min-height:var(--line-height-m);transition:color var(--animation)}";
var style$2 = {"errorMessage":"error-message-module_errorMessage__Ft-mM"};
styleInject(css_248z$E);

const ErrorMessage$1 = (props) => {
    const { text, className } = props;
    return React.createElement("p", { className: cn(style$2.errorMessage, className) }, text);
};

var css_248z$D = ".toggle-input-field-module_container__1kdHs{display:flex;flex-direction:column;width:100%}.toggle-input-field-module_errorMessage__--b9X{padding-left:50px}";
var styles$h = {"container":"toggle-input-field-module_container__1kdHs","errorMessage":"toggle-input-field-module_errorMessage__--b9X"};
styleInject(css_248z$D);

function mapMeta$1(value, meta) {
    const { submitError, dirtySinceLastSubmit } = meta;
    const hint = !dirtySinceLastSubmit && ((meta.touched && meta.error) || (!dirtySinceLastSubmit ? submitError : undefined));
    const error = !!hint;
    const valid = meta.touched && value !== undefined && value !== '' && !error;
    return {
        hint,
        error,
        valid,
    };
}
const FinalFormToggleInput = ({ input: { onChange: fieldOnChange, value, name }, meta, onChange: userOnChange, ...props }) => {
    const state = mapMeta$1(value, meta);
    const handleInputChange = React.useCallback((v, event) => {
        fieldOnChange(v);
        return userOnChange === null || userOnChange === void 0 ? void 0 : userOnChange(v, event);
    }, [fieldOnChange, userOnChange]);
    return (React.createElement("div", { className: styles$h.container },
        React.createElement(Toggle, { ...props, ...state, onChange: handleInputChange, value: value, name: name }, props.label && React.createElement("span", null, props.label)),
        React.createElement(ErrorMessage$1, { className: styles$h.errorMessage, text: state.hint })));
};

var css_248z$C = ".select-search-field-module_container__RTxy-{display:flex;flex-direction:column;width:100%}";
var styles$g = {"container":"select-search-field-module_container__RTxy-"};
styleInject(css_248z$C);

function mapMeta(value, meta) {
    const { submitError, dirtySinceLastSubmit } = meta;
    const hint = !dirtySinceLastSubmit && ((meta.touched && meta.error) || (!dirtySinceLastSubmit ? submitError : undefined));
    const error = !!hint;
    const valid = meta.touched && value !== undefined && value !== '' && !error;
    return {
        hint,
        error,
        valid,
    };
}
const FinalFormSelectSearchField = ({ input: { onChange: fieldOnChange, value, name }, meta, onChange: userOnChange, options, disabled, label, onSearch: userOnSearch, limit, bounds = true, dataTest, }) => {
    const metaState = mapMeta(value, meta);
    const form = useForm$1();
    const [searchResults, setResults] = React.useState(limit ? options.slice(0, limit) : options);
    const [filter, updateFilter] = React.useState('');
    const initialValue = React.useMemo(() => {
        return meta.initial !== undefined ? meta.initial : options[0];
    }, [meta.initial, options]);
    const prepared = React.useMemo(() => options.map((option) => ({ value: option.value, text: option.label })), [options]);
    const onSearch = React.useCallback((val) => {
        const suggestions = options.filter((item) => item.label.toLowerCase().indexOf(val.trim().toLowerCase()) !== -1);
        return suggestions;
    }, [options]);
    const handleSearch = React.useCallback((val) => (userOnSearch ? userOnSearch(val) : onSearch(val)), [userOnSearch, onSearch]);
    const handleTextChange = React.useCallback((val) => {
        updateFilter(val);
        const searchResults = handleSearch(val);
        setResults(limit ? searchResults.slice(0, limit) : searchResults);
    }, [handleSearch, limit]);
    React.useEffect(() => {
        setResults(options);
    }, [options]);
    const { is, handleChange, selectedText } = useSelect((val) => {
        const data = searchResults.find((result) => result.value === val);
        userOnChange === null || userOnChange === void 0 ? void 0 : userOnChange(data.value);
        fieldOnChange(data.value);
    }, { selected: initialValue, texts: prepared });
    React.useEffect(() => {
        if (value !== undefined && value !== '') {
            return;
        }
        if (initialValue && initialValue !== meta.initial) {
            form.change(name, initialValue);
        }
    }, [form, meta.initial, initialValue, name, value]);
    return (React.createElement("div", { className: styles$g.container },
        React.createElement(Select, { dataTest: dataTest, onChange: handleChange, mode: "single" },
            React.createElement(Select.Button, { size: "l", disabled: disabled }, selectedText || label),
            React.createElement(Select.Content, { bounds: bounds, height: 400 },
                React.createElement(Select.Search, { value: filter, onChange: handleTextChange }),
                searchResults.map((item) => (React.createElement(Select.Option, { dataTest: dataTest, value: item.value, key: item.value, selected: is(item.value) }, item.label))))),
        React.createElement(ErrorMessage$1, { text: metaState.hint })));
};

var css_248z$B = ".date-field-module_container__hwhUM{display:flex;flex-direction:column;width:100%}";
var styles$f = {"container":"date-field-module_container__hwhUM"};
styleInject(css_248z$B);

const getMinCalendarDate = () => {
    const date = new Date(0);
    date.setFullYear(1900);
    return date;
};
const getMaxCalendarDate = () => {
    const date = new Date(0);
    date.setFullYear(2050);
    return date;
};
const DateField = ({ input: { onChange, onFocus, onBlur, value, name }, meta, size = 'l', minDate, maxDate, ...props }) => {
    const calendarProps = React.useMemo(() => ({
        min: minDate || getMinCalendarDate(),
        max: maxDate || getMaxCalendarDate(),
    }), [minDate, maxDate]);
    const [shownErrorMessage, setShownErrorMessage] = React.useState();
    const overriddenMeta = shownErrorMessage ? { ...meta, error: shownErrorMessage } : meta;
    const handleTextChange = React.useCallback((val) => {
        const fieldLevelErrorMessage = val.text && !val.date ? 'Неверная дата' : undefined;
        setShownErrorMessage(fieldLevelErrorMessage);
        if (!val.text) {
            onChange(undefined);
        }
    }, [onChange]);
    const dateInputProps = {
        ...props,
        type: 'text',
        size,
        value,
        name,
        onChange: onChange,
        onTextChange: handleTextChange,
        onFocus,
        onBlur,
        onReset: false,
        calendarProps,
        spaced: true,
        error: overriddenMeta.touched ? overriddenMeta.error : undefined,
        hint: overriddenMeta.touched ? overriddenMeta.error : undefined,
    };
    return (React.createElement("div", { className: styles$f.container },
        React.createElement(DateInput$1, { ...dateInputProps })));
};

const FinalFormTextAreaField = ({ input: { onChange, onFocus, onBlur, value, name }, meta: { touched, error, valid }, disabled = false, ...props }) => {
    const showValidation = error && touched;
    return (React.createElement(Textarea, { ...props, warning: !valid, error: showValidation ? error : undefined, value: value, name: name, onChange: onChange, onFocus: onFocus, onBlur: onBlur, disabled: disabled }));
};

var css_248z$A = ".with-tooltip-module_tooltip__SNvSN div{max-width:none}.with-tooltip-module_wrapper__AKz9w{width:100%}";
var styles$e = {"tooltip":"with-tooltip-module_tooltip__SNvSN","wrapper":"with-tooltip-module_wrapper__AKz9w"};
styleInject(css_248z$A);

const withTooltip = (Component) => {
    const TooltippedField = (props) => {
        var _a, _b;
        const { options, disabled, input, withTooltip } = props;
        const relation = useTooltip();
        if (disabled && withTooltip) {
            let inputValueLabel;
            if (options) {
                inputValueLabel = (_a = options === null || options === void 0 ? void 0 : options.find((el) => el.value === input.value)) === null || _a === void 0 ? void 0 : _a.label;
            }
            else {
                inputValueLabel = (_b = input.value) === null || _b === void 0 ? void 0 : _b.toString();
            }
            if ((inputValueLabel === null || inputValueLabel === void 0 ? void 0 : inputValueLabel.length) >= 20) {
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { ref: relation.registerControl, className: styles$e.wrapper },
                        React.createElement(Component, { ...props })),
                    React.createElement("div", { className: styles$e.tooltip },
                        React.createElement(Tooltip$1, { to: relation.to, direction: "down" }, inputValueLabel))));
            }
        }
        return React.createElement(Component, { ...props });
    };
    TooltippedField.displayName = `withTooltip(${getDisplayName(Component)})`;
    return TooltippedField;
};

withDisabled(withWarning(withTooltip(InputField)));
withDisabled(withWarning(FinalFormTextAreaField));
withDisabled(withWarning(withTooltip(FinalFormSuggestInput)));
withDisabled(withWarning(withTooltip(FinalFormToggleInput)));
withDisabled(withWarning(withTooltip(FinalFormMaskedField)));
withDisabled(withWarning(withTooltip(PhoneInputField)));
withDisabled(withWarning(withTooltip(FinalFormMoneyField)));
withDisabled(withWarning(withTooltip(FinalFormCheckboxField)));
withDisabled(withWarning(withTooltip(NumberInputField)));
withDisabled(withWarning(withTooltip(FinalFormSelectField)));
withDisabled(withWarning(withTooltip(FinalFormDigitsOnlyMaskedField)));
withDisabled(withWarning(DateField));
withDisabled(withWarning(withTooltip(FinalFormRadioGroupField)));
withDisabled(withTooltip(InputField));
withDisabled(FinalFormTextAreaField);
withDisabled(withTooltip(FinalFormSuggestInput));
withDisabled(withTooltip(FinalFormToggleInput));
withDisabled(withTooltip(FinalFormMaskedField));
withDisabled(withTooltip(PhoneInputField));
withDisabled(withTooltip(FinalFormMoneyField));
withDisabled(withTooltip(FinalFormCheckboxField));
withDisabled(withTooltip(NumberInputField));
withDisabled(withTooltip(FinalFormSelectField));
withDisabled(FinalFormSelectSearchField);
withDisabled(withTooltip(FinalFormDigitsOnlyMaskedField));
withDisabled(DateField);
withDisabled(FinalFormRadioGroupField);

const SUGGEST_LIST_ZINDEX = 4;
const SuggestInput = (props) => {
    const { fetchSuggestions, label, onChange, suggestZIndex, dropdownHeight, clearOnSelect } = props;
    const [dropdownSuggestions, setDropdownSuggestions] = React.useState([]);
    const debouncedFetchSuggestions = React.useMemo(() => debounce_1(async (text) => {
        const suggestions = await fetchSuggestions(text);
        setDropdownSuggestions(suggestions);
    }, 1000), [fetchSuggestions]);
    return (React.createElement(Suggest, { inputProps: {
            disabled: props.disabled,
            size: Size.Medium,
            placeholder: label,
        }, clearOnSelect: clearOnSelect, onChange: (suggestion) => {
            if (onChange && suggestion !== undefined) {
                onChange(suggestion.value);
            }
        }, suggestions: dropdownSuggestions, onTextChange: debouncedFetchSuggestions, renderList: ({ listProps, getListProps, getListItemProps }) => {
            const injectListProps = getListProps(listProps);
            return (React.createElement("div", { ...injectListProps, style: { zIndex: suggestZIndex || SUGGEST_LIST_ZINDEX, maxHeight: dropdownHeight } }, dropdownSuggestions.map((item, index) => {
                const { ...itemProps } = getListItemProps({
                    item,
                    dataTest: listProps.dataTest,
                });
                const sublabelData = item.subLabel || [item.value.inn, item.value.address].filter(Boolean).join(', ');
                return (React.createElement("div", { ...itemProps, key: index },
                    React.createElement("strong", null, item.label),
                    sublabelData && React.createElement("p", null, sublabelData)));
            })));
        } }));
};

var dist = {};

var customAxios = {};

var axiosExports$1 = {};
var axios$3 = {
  get exports(){ return axiosExports$1; },
  set exports(v){ axiosExports$1 = v; },
};

var axiosExports = {};
var axios$2 = {
  get exports(){ return axiosExports; },
  set exports(v){ axiosExports = v; },
};

var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var bind$1 = bind$2;

// utils is a library of generic helper functions non-specific to axios

var toString$4 = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray$c(val) {
  return toString$4.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined$4(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer$4(val) {
  return val !== null && !isUndefined$4(val) && val.constructor !== null && !isUndefined$4(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString$4.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString$1(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber$2(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject$d(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject$3(val) {
  if (toString$4.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate$1(val) {
  return toString$4.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString$4.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString$4.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction$6(val) {
  return toString$4.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject$d(val) && isFunction$6(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach$1(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$c(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject$3(result[key]) && isPlainObject$3(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject$3(val)) {
      result[key] = merge({}, val);
    } else if (isArray$c(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach$1(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach$1(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$8 = {
  isArray: isArray$c,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer$4,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString$1,
  isNumber: isNumber$2,
  isObject: isObject$d,
  isPlainObject: isPlainObject$3,
  isUndefined: isUndefined$4,
  isDate: isDate$1,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction$6,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach$1,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

var utils$7 = utils$8;

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$1 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$7.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$7.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$7.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$7.forEach(val, function parseValue(v) {
        if (utils$7.isDate(v)) {
          v = v.toISOString();
        } else if (utils$7.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$6 = utils$8;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$6.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$5 = utils$8;

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils$5.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};

var createError;
var hasRequiredCreateError;

function requireCreateError () {
	if (hasRequiredCreateError) return createError;
	hasRequiredCreateError = 1;

	var enhanceError$1 = enhanceError;

	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	createError = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError$1(error, config, code, request, response);
	};
	return createError;
}

var settle;
var hasRequiredSettle;

function requireSettle () {
	if (hasRequiredSettle) return settle;
	hasRequiredSettle = 1;

	var createError = requireCreateError();

	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	settle = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};
	return settle;
}

var cookies;
var hasRequiredCookies;

function requireCookies () {
	if (hasRequiredCookies) return cookies;
	hasRequiredCookies = 1;

	var utils = utils$8;

	cookies = (
	  utils.isStandardBrowserEnv() ?

	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));

	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }

	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }

	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }

	          if (secure === true) {
	            cookie.push('secure');
	          }

	          document.cookie = cookie.join('; ');
	        },

	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },

	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :

	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);
	return cookies;
}

var isAbsoluteURL;
var hasRequiredIsAbsoluteURL;

function requireIsAbsoluteURL () {
	if (hasRequiredIsAbsoluteURL) return isAbsoluteURL;
	hasRequiredIsAbsoluteURL = 1;

	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	isAbsoluteURL = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};
	return isAbsoluteURL;
}

var combineURLs;
var hasRequiredCombineURLs;

function requireCombineURLs () {
	if (hasRequiredCombineURLs) return combineURLs;
	hasRequiredCombineURLs = 1;

	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	combineURLs = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};
	return combineURLs;
}

var buildFullPath;
var hasRequiredBuildFullPath;

function requireBuildFullPath () {
	if (hasRequiredBuildFullPath) return buildFullPath;
	hasRequiredBuildFullPath = 1;

	var isAbsoluteURL = requireIsAbsoluteURL();
	var combineURLs = requireCombineURLs();

	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	buildFullPath = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};
	return buildFullPath;
}

var parseHeaders;
var hasRequiredParseHeaders;

function requireParseHeaders () {
	if (hasRequiredParseHeaders) return parseHeaders;
	hasRequiredParseHeaders = 1;

	var utils = utils$8;

	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];

	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	parseHeaders = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;

	  if (!headers) { return parsed; }

	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));

	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });

	  return parsed;
	};
	return parseHeaders;
}

var isURLSameOrigin;
var hasRequiredIsURLSameOrigin;

function requireIsURLSameOrigin () {
	if (hasRequiredIsURLSameOrigin) return isURLSameOrigin;
	hasRequiredIsURLSameOrigin = 1;

	var utils = utils$8;

	isURLSameOrigin = (
	  utils.isStandardBrowserEnv() ?

	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;

	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;

	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }

	        urlParsingNode.setAttribute('href', href);

	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }

	      originURL = resolveURL(window.location.href);

	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :

	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);
	return isURLSameOrigin;
}

var Cancel_1;
var hasRequiredCancel;

function requireCancel () {
	if (hasRequiredCancel) return Cancel_1;
	hasRequiredCancel = 1;

	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}

	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};

	Cancel.prototype.__CANCEL__ = true;

	Cancel_1 = Cancel;
	return Cancel_1;
}

var xhr;
var hasRequiredXhr;

function requireXhr () {
	if (hasRequiredXhr) return xhr;
	hasRequiredXhr = 1;

	var utils = utils$8;
	var settle = requireSettle();
	var cookies = requireCookies();
	var buildURL = buildURL$1;
	var buildFullPath = requireBuildFullPath();
	var parseHeaders = requireParseHeaders();
	var isURLSameOrigin = requireIsURLSameOrigin();
	var createError = requireCreateError();
	var defaults = requireDefaults();
	var Cancel = requireCancel();

	xhr = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	    var responseType = config.responseType;
	    var onCanceled;
	    function done() {
	      if (config.cancelToken) {
	        config.cancelToken.unsubscribe(onCanceled);
	      }

	      if (config.signal) {
	        config.signal.removeEventListener('abort', onCanceled);
	      }
	    }

	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }

	    var request = new XMLHttpRequest();

	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }

	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

	    // Set the request timeout in MS
	    request.timeout = config.timeout;

	    function onloadend() {
	      if (!request) {
	        return;
	      }
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
	        request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };

	      settle(function _resolve(value) {
	        resolve(value);
	        done();
	      }, function _reject(err) {
	        reject(err);
	        done();
	      }, response);

	      // Clean up request
	      request = null;
	    }

	    if ('onloadend' in request) {
	      // Use onloadend if available
	      request.onloadend = onloadend;
	    } else {
	      // Listen for ready state to emulate onloadend
	      request.onreadystatechange = function handleLoad() {
	        if (!request || request.readyState !== 4) {
	          return;
	        }

	        // The request errored out and we didn't get a response, this will be
	        // handled by onerror instead
	        // With one exception: request that using file: protocol, most browsers
	        // will return status as 0 even though it's a successful request
	        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	          return;
	        }
	        // readystate handler is calling before onerror or ontimeout handlers,
	        // so we should call onloadend on the next 'tick'
	        setTimeout(onloadend);
	      };
	    }

	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }

	      reject(createError('Request aborted', config, 'ECONNABORTED', request));

	      // Clean up request
	      request = null;
	    };

	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));

	      // Clean up request
	      request = null;
	    };

	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      var transitional = config.transitional || defaults.transitional;
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(
	        timeoutErrorMessage,
	        config,
	        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
	        request));

	      // Clean up request
	      request = null;
	    };

	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;

	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }

	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }

	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }

	    // Add responseType to request if needed
	    if (responseType && responseType !== 'json') {
	      request.responseType = config.responseType;
	    }

	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }

	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }

	    if (config.cancelToken || config.signal) {
	      // Handle cancellation
	      // eslint-disable-next-line func-names
	      onCanceled = function(cancel) {
	        if (!request) {
	          return;
	        }
	        reject(!cancel || (cancel && cancel.type) ? new Cancel('canceled') : cancel);
	        request.abort();
	        request = null;
	      };

	      config.cancelToken && config.cancelToken.subscribe(onCanceled);
	      if (config.signal) {
	        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
	      }
	    }

	    if (!requestData) {
	      requestData = null;
	    }

	    // Send the request
	    request.send(requestData);
	  });
	};
	return xhr;
}

var defaults_1;
var hasRequiredDefaults;

function requireDefaults () {
	if (hasRequiredDefaults) return defaults_1;
	hasRequiredDefaults = 1;

	var utils = utils$8;
	var normalizeHeaderName$1 = normalizeHeaderName;
	var enhanceError$1 = enhanceError;

	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};

	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}

	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = requireXhr();
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = requireXhr();
	  }
	  return adapter;
	}

	function stringifySafely(rawValue, parser, encoder) {
	  if (utils.isString(rawValue)) {
	    try {
	      (parser || JSON.parse)(rawValue);
	      return utils.trim(rawValue);
	    } catch (e) {
	      if (e.name !== 'SyntaxError') {
	        throw e;
	      }
	    }
	  }

	  return (encoder || JSON.stringify)(rawValue);
	}

	var defaults = {

	  transitional: {
	    silentJSONParsing: true,
	    forcedJSONParsing: true,
	    clarifyTimeoutError: false
	  },

	  adapter: getDefaultAdapter(),

	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName$1(headers, 'Accept');
	    normalizeHeaderName$1(headers, 'Content-Type');

	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
	      setContentTypeIfUnset(headers, 'application/json');
	      return stringifySafely(data);
	    }
	    return data;
	  }],

	  transformResponse: [function transformResponse(data) {
	    var transitional = this.transitional || defaults.transitional;
	    var silentJSONParsing = transitional && transitional.silentJSONParsing;
	    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
	    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

	    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
	      try {
	        return JSON.parse(data);
	      } catch (e) {
	        if (strictJSONParsing) {
	          if (e.name === 'SyntaxError') {
	            throw enhanceError$1(e, this, 'E_JSON_PARSE');
	          }
	          throw e;
	        }
	      }
	    }

	    return data;
	  }],

	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,

	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',

	  maxContentLength: -1,
	  maxBodyLength: -1,

	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  },

	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    }
	  }
	};

	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});

	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});

	defaults_1 = defaults;
	return defaults_1;
}

var utils$4 = utils$8;
var defaults$2 = requireDefaults();

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$2;
  /*eslint no-param-reassign:0*/
  utils$4.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel$1;
var hasRequiredIsCancel;

function requireIsCancel () {
	if (hasRequiredIsCancel) return isCancel$1;
	hasRequiredIsCancel = 1;

	isCancel$1 = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};
	return isCancel$1;
}

var utils$3 = utils$8;
var transformData = transformData$1;
var isCancel = requireIsCancel();
var defaults$1 = requireDefaults();
var Cancel = requireCancel();

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$3.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$3.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

var utils$2 = utils$8;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils$2.isPlainObject(target) && utils$2.isPlainObject(source)) {
      return utils$2.merge(target, source);
    } else if (utils$2.isPlainObject(source)) {
      return utils$2.merge({}, source);
    } else if (utils$2.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils$2.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils$2.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils$2.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils$2.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};

var data;
var hasRequiredData;

function requireData () {
	if (hasRequiredData) return data;
	hasRequiredData = 1;
	data = {
	  "version": "0.22.0"
	};
	return data;
}

var VERSION = requireData().version;

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator$1 = {
  assertOptions: assertOptions,
  validators: validators$1
};

var utils$1 = utils$8;
var buildURL = buildURL$1;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$1.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$1.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios$1;

var CancelToken_1;
var hasRequiredCancelToken;

function requireCancelToken () {
	if (hasRequiredCancelToken) return CancelToken_1;
	hasRequiredCancelToken = 1;

	var Cancel = requireCancel();

	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }

	  var resolvePromise;

	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });

	  var token = this;

	  // eslint-disable-next-line func-names
	  this.promise.then(function(cancel) {
	    if (!token._listeners) return;

	    var i;
	    var l = token._listeners.length;

	    for (i = 0; i < l; i++) {
	      token._listeners[i](cancel);
	    }
	    token._listeners = null;
	  });

	  // eslint-disable-next-line func-names
	  this.promise.then = function(onfulfilled) {
	    var _resolve;
	    // eslint-disable-next-line func-names
	    var promise = new Promise(function(resolve) {
	      token.subscribe(resolve);
	      _resolve = resolve;
	    }).then(onfulfilled);

	    promise.cancel = function reject() {
	      token.unsubscribe(_resolve);
	    };

	    return promise;
	  };

	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }

	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}

	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};

	/**
	 * Subscribe to the cancel signal
	 */

	CancelToken.prototype.subscribe = function subscribe(listener) {
	  if (this.reason) {
	    listener(this.reason);
	    return;
	  }

	  if (this._listeners) {
	    this._listeners.push(listener);
	  } else {
	    this._listeners = [listener];
	  }
	};

	/**
	 * Unsubscribe from the cancel signal
	 */

	CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
	  if (!this._listeners) {
	    return;
	  }
	  var index = this._listeners.indexOf(listener);
	  if (index !== -1) {
	    this._listeners.splice(index, 1);
	  }
	};

	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};

	CancelToken_1 = CancelToken;
	return CancelToken_1;
}

var spread;
var hasRequiredSpread;

function requireSpread () {
	if (hasRequiredSpread) return spread;
	hasRequiredSpread = 1;

	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	spread = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};
	return spread;
}

var isAxiosError$1;
var hasRequiredIsAxiosError;

function requireIsAxiosError () {
	if (hasRequiredIsAxiosError) return isAxiosError$1;
	hasRequiredIsAxiosError = 1;

	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	isAxiosError$1 = function isAxiosError(payload) {
	  return (typeof payload === 'object') && (payload.isAxiosError === true);
	};
	return isAxiosError$1;
}

var utils = utils$8;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = requireDefaults();

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios;

// Expose Cancel & CancelToken
axios$1.Cancel = requireCancel();
axios$1.CancelToken = requireCancelToken();
axios$1.isCancel = requireIsCancel();
axios$1.VERSION = requireData().version;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = requireSpread();

// Expose isAxiosError
axios$1.isAxiosError = requireIsAxiosError();

axios$2.exports = axios$1;

// Allow use of default import syntax in TypeScript
axiosExports.default = axios$1;

(function (module) {
	module.exports = axiosExports;
} (axios$3));

var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(customAxios, "__esModule", { value: true });
customAxios.createCustomAxios = void 0;
var axios_1 = __importDefault(axiosExports$1);
var createCustomAxios = function (handleInstance) {
    return Object.assign(handleInstance(axios_1.default.create()), {
        Axios: axios_1.default.Axios,
        Cancel: axios_1.default.Cancel,
        CancelToken: axios_1.default.CancelToken,
        isCancel: axios_1.default.isCancel,
        VERSION: axios_1.default.VERSION,
        isAxiosError: axios_1.default.isAxiosError,
        all: axios_1.default.all,
        spread: axios_1.default.spread,
        create: function (config) { return handleInstance(axios_1.default.create(config)); },
    });
};
customAxios.createCustomAxios = createCustomAxios;

var stackTracePatch = {};

Object.defineProperty(stackTracePatch, "__esModule", { value: true });
stackTracePatch.applyStackTracePatch = void 0;
var STACK_TRACE_PATCH = Symbol('StackTracePatch');
var isAxiosError = function (error) {
    return Boolean(error === null || error === void 0 ? void 0 : error.isAxiosError);
};
var applyStackTracePatch = function (instance) {
    if (instance[STACK_TRACE_PATCH]) {
        return instance;
    }
    instance.interceptors.request.use(function stackTracePatchInterceptor(config) {
        config._stack = new Error('StackTracePatch').stack;
        return config;
    }, undefined, { synchronous: true });
    instance.interceptors.response.use(function (response) {
        delete response.config._stack;
        return response;
    }, function (error) {
        if (isAxiosError(error) && error.config._stack) {
            error.stack = "".concat(error.stack, "\n").concat(error.config._stack);
            delete error.config._stack;
        }
        return Promise.reject(error);
    });
    instance[STACK_TRACE_PATCH] = true;
    return instance;
};
stackTracePatch.applyStackTracePatch = applyStackTracePatch;

var applyRetry = {};

var axiosRetryExports = {};
var axiosRetry$2 = {
  get exports(){ return axiosRetryExports; },
  set exports(v){ axiosRetryExports = v; },
};

var cjs$1 = {};

var interopRequireDefaultExports = {};
var interopRequireDefault = {
  get exports(){ return interopRequireDefaultExports; },
  set exports(v){ interopRequireDefaultExports = v; },
};

(function (module) {
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (interopRequireDefault));

var regeneratorRuntimeExports = {};
var regeneratorRuntime$1 = {
  get exports(){ return regeneratorRuntimeExports; },
  set exports(v){ regeneratorRuntimeExports = v; },
};

var _typeofExports = {};
var _typeof = {
  get exports(){ return _typeofExports; },
  set exports(v){ _typeofExports = v; },
};

var hasRequired_typeof;

function require_typeof () {
	if (hasRequired_typeof) return _typeofExports;
	hasRequired_typeof = 1;
	(function (module) {
		function _typeof(obj) {
		  "@babel/helpers - typeof";

		  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
		    return typeof obj;
		  } : function (obj) {
		    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
		}
		module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (_typeof));
	return _typeofExports;
}

var hasRequiredRegeneratorRuntime;

function requireRegeneratorRuntime () {
	if (hasRequiredRegeneratorRuntime) return regeneratorRuntimeExports;
	hasRequiredRegeneratorRuntime = 1;
	(function (module) {
		var _typeof = require_typeof()["default"];
		function _regeneratorRuntime() {
		  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
		    return exports;
		  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
		  var exports = {},
		    Op = Object.prototype,
		    hasOwn = Op.hasOwnProperty,
		    defineProperty = Object.defineProperty || function (obj, key, desc) {
		      obj[key] = desc.value;
		    },
		    $Symbol = "function" == typeof Symbol ? Symbol : {},
		    iteratorSymbol = $Symbol.iterator || "@@iterator",
		    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
		    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
		  function define(obj, key, value) {
		    return Object.defineProperty(obj, key, {
		      value: value,
		      enumerable: !0,
		      configurable: !0,
		      writable: !0
		    }), obj[key];
		  }
		  try {
		    define({}, "");
		  } catch (err) {
		    define = function define(obj, key, value) {
		      return obj[key] = value;
		    };
		  }
		  function wrap(innerFn, outerFn, self, tryLocsList) {
		    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
		      generator = Object.create(protoGenerator.prototype),
		      context = new Context(tryLocsList || []);
		    return defineProperty(generator, "_invoke", {
		      value: makeInvokeMethod(innerFn, self, context)
		    }), generator;
		  }
		  function tryCatch(fn, obj, arg) {
		    try {
		      return {
		        type: "normal",
		        arg: fn.call(obj, arg)
		      };
		    } catch (err) {
		      return {
		        type: "throw",
		        arg: err
		      };
		    }
		  }
		  exports.wrap = wrap;
		  var ContinueSentinel = {};
		  function Generator() {}
		  function GeneratorFunction() {}
		  function GeneratorFunctionPrototype() {}
		  var IteratorPrototype = {};
		  define(IteratorPrototype, iteratorSymbol, function () {
		    return this;
		  });
		  var getProto = Object.getPrototypeOf,
		    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
		  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
		  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
		  function defineIteratorMethods(prototype) {
		    ["next", "throw", "return"].forEach(function (method) {
		      define(prototype, method, function (arg) {
		        return this._invoke(method, arg);
		      });
		    });
		  }
		  function AsyncIterator(generator, PromiseImpl) {
		    function invoke(method, arg, resolve, reject) {
		      var record = tryCatch(generator[method], generator, arg);
		      if ("throw" !== record.type) {
		        var result = record.arg,
		          value = result.value;
		        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
		          invoke("next", value, resolve, reject);
		        }, function (err) {
		          invoke("throw", err, resolve, reject);
		        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
		          result.value = unwrapped, resolve(result);
		        }, function (error) {
		          return invoke("throw", error, resolve, reject);
		        });
		      }
		      reject(record.arg);
		    }
		    var previousPromise;
		    defineProperty(this, "_invoke", {
		      value: function value(method, arg) {
		        function callInvokeWithMethodAndArg() {
		          return new PromiseImpl(function (resolve, reject) {
		            invoke(method, arg, resolve, reject);
		          });
		        }
		        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
		      }
		    });
		  }
		  function makeInvokeMethod(innerFn, self, context) {
		    var state = "suspendedStart";
		    return function (method, arg) {
		      if ("executing" === state) throw new Error("Generator is already running");
		      if ("completed" === state) {
		        if ("throw" === method) throw arg;
		        return doneResult();
		      }
		      for (context.method = method, context.arg = arg;;) {
		        var delegate = context.delegate;
		        if (delegate) {
		          var delegateResult = maybeInvokeDelegate(delegate, context);
		          if (delegateResult) {
		            if (delegateResult === ContinueSentinel) continue;
		            return delegateResult;
		          }
		        }
		        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
		          if ("suspendedStart" === state) throw state = "completed", context.arg;
		          context.dispatchException(context.arg);
		        } else "return" === context.method && context.abrupt("return", context.arg);
		        state = "executing";
		        var record = tryCatch(innerFn, self, context);
		        if ("normal" === record.type) {
		          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
		          return {
		            value: record.arg,
		            done: context.done
		          };
		        }
		        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
		      }
		    };
		  }
		  function maybeInvokeDelegate(delegate, context) {
		    var methodName = context.method,
		      method = delegate.iterator[methodName];
		    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
		    var record = tryCatch(method, delegate.iterator, context.arg);
		    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
		    var info = record.arg;
		    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
		  }
		  function pushTryEntry(locs) {
		    var entry = {
		      tryLoc: locs[0]
		    };
		    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
		  }
		  function resetTryEntry(entry) {
		    var record = entry.completion || {};
		    record.type = "normal", delete record.arg, entry.completion = record;
		  }
		  function Context(tryLocsList) {
		    this.tryEntries = [{
		      tryLoc: "root"
		    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
		  }
		  function values(iterable) {
		    if (iterable) {
		      var iteratorMethod = iterable[iteratorSymbol];
		      if (iteratorMethod) return iteratorMethod.call(iterable);
		      if ("function" == typeof iterable.next) return iterable;
		      if (!isNaN(iterable.length)) {
		        var i = -1,
		          next = function next() {
		            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
		            return next.value = undefined, next.done = !0, next;
		          };
		        return next.next = next;
		      }
		    }
		    return {
		      next: doneResult
		    };
		  }
		  function doneResult() {
		    return {
		      value: undefined,
		      done: !0
		    };
		  }
		  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
		    value: GeneratorFunctionPrototype,
		    configurable: !0
		  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
		    value: GeneratorFunction,
		    configurable: !0
		  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
		    var ctor = "function" == typeof genFun && genFun.constructor;
		    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
		  }, exports.mark = function (genFun) {
		    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
		  }, exports.awrap = function (arg) {
		    return {
		      __await: arg
		    };
		  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
		    return this;
		  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
		    void 0 === PromiseImpl && (PromiseImpl = Promise);
		    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
		    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
		      return result.done ? result.value : iter.next();
		    });
		  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
		    return this;
		  }), define(Gp, "toString", function () {
		    return "[object Generator]";
		  }), exports.keys = function (val) {
		    var object = Object(val),
		      keys = [];
		    for (var key in object) keys.push(key);
		    return keys.reverse(), function next() {
		      for (; keys.length;) {
		        var key = keys.pop();
		        if (key in object) return next.value = key, next.done = !1, next;
		      }
		      return next.done = !0, next;
		    };
		  }, exports.values = values, Context.prototype = {
		    constructor: Context,
		    reset: function reset(skipTempReset) {
		      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
		    },
		    stop: function stop() {
		      this.done = !0;
		      var rootRecord = this.tryEntries[0].completion;
		      if ("throw" === rootRecord.type) throw rootRecord.arg;
		      return this.rval;
		    },
		    dispatchException: function dispatchException(exception) {
		      if (this.done) throw exception;
		      var context = this;
		      function handle(loc, caught) {
		        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
		      }
		      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
		        var entry = this.tryEntries[i],
		          record = entry.completion;
		        if ("root" === entry.tryLoc) return handle("end");
		        if (entry.tryLoc <= this.prev) {
		          var hasCatch = hasOwn.call(entry, "catchLoc"),
		            hasFinally = hasOwn.call(entry, "finallyLoc");
		          if (hasCatch && hasFinally) {
		            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
		            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
		          } else if (hasCatch) {
		            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
		          } else {
		            if (!hasFinally) throw new Error("try statement without catch or finally");
		            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
		          }
		        }
		      }
		    },
		    abrupt: function abrupt(type, arg) {
		      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
		        var entry = this.tryEntries[i];
		        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
		          var finallyEntry = entry;
		          break;
		        }
		      }
		      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
		      var record = finallyEntry ? finallyEntry.completion : {};
		      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
		    },
		    complete: function complete(record, afterLoc) {
		      if ("throw" === record.type) throw record.arg;
		      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
		    },
		    finish: function finish(finallyLoc) {
		      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
		        var entry = this.tryEntries[i];
		        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
		      }
		    },
		    "catch": function _catch(tryLoc) {
		      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
		        var entry = this.tryEntries[i];
		        if (entry.tryLoc === tryLoc) {
		          var record = entry.completion;
		          if ("throw" === record.type) {
		            var thrown = record.arg;
		            resetTryEntry(entry);
		          }
		          return thrown;
		        }
		      }
		      throw new Error("illegal catch attempt");
		    },
		    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
		      return this.delegate = {
		        iterator: values(iterable),
		        resultName: resultName,
		        nextLoc: nextLoc
		      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
		    }
		  }, exports;
		}
		module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (regeneratorRuntime$1));
	return regeneratorRuntimeExports;
}

var regenerator;
var hasRequiredRegenerator;

function requireRegenerator () {
	if (hasRequiredRegenerator) return regenerator;
	hasRequiredRegenerator = 1;
	// TODO(Babel 8): Remove this file.

	var runtime = requireRegeneratorRuntime()();
	regenerator = runtime;

	// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
	try {
	  regeneratorRuntime = runtime;
	} catch (accidentalStrictMode) {
	  if (typeof globalThis === "object") {
	    globalThis.regeneratorRuntime = runtime;
	  } else {
	    Function("r", "regeneratorRuntime = r")(runtime);
	  }
	}
	return regenerator;
}

var asyncToGeneratorExports = {};
var asyncToGenerator = {
  get exports(){ return asyncToGeneratorExports; },
  set exports(v){ asyncToGeneratorExports = v; },
};

var hasRequiredAsyncToGenerator;

function requireAsyncToGenerator () {
	if (hasRequiredAsyncToGenerator) return asyncToGeneratorExports;
	hasRequiredAsyncToGenerator = 1;
	(function (module) {
		function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
		  try {
		    var info = gen[key](arg);
		    var value = info.value;
		  } catch (error) {
		    reject(error);
		    return;
		  }
		  if (info.done) {
		    resolve(value);
		  } else {
		    Promise.resolve(value).then(_next, _throw);
		  }
		}
		function _asyncToGenerator(fn) {
		  return function () {
		    var self = this,
		      args = arguments;
		    return new Promise(function (resolve, reject) {
		      var gen = fn.apply(self, args);
		      function _next(value) {
		        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
		      }
		      function _throw(err) {
		        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
		      }
		      _next(undefined);
		    });
		  };
		}
		module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (asyncToGenerator));
	return asyncToGeneratorExports;
}

var definePropertyExports = {};
var defineProperty$4 = {
  get exports(){ return definePropertyExports; },
  set exports(v){ definePropertyExports = v; },
};

var toPropertyKeyExports = {};
var toPropertyKey = {
  get exports(){ return toPropertyKeyExports; },
  set exports(v){ toPropertyKeyExports = v; },
};

var toPrimitiveExports = {};
var toPrimitive = {
  get exports(){ return toPrimitiveExports; },
  set exports(v){ toPrimitiveExports = v; },
};

var hasRequiredToPrimitive;

function requireToPrimitive () {
	if (hasRequiredToPrimitive) return toPrimitiveExports;
	hasRequiredToPrimitive = 1;
	(function (module) {
		var _typeof = require_typeof()["default"];
		function _toPrimitive(input, hint) {
		  if (_typeof(input) !== "object" || input === null) return input;
		  var prim = input[Symbol.toPrimitive];
		  if (prim !== undefined) {
		    var res = prim.call(input, hint || "default");
		    if (_typeof(res) !== "object") return res;
		    throw new TypeError("@@toPrimitive must return a primitive value.");
		  }
		  return (hint === "string" ? String : Number)(input);
		}
		module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (toPrimitive));
	return toPrimitiveExports;
}

var hasRequiredToPropertyKey;

function requireToPropertyKey () {
	if (hasRequiredToPropertyKey) return toPropertyKeyExports;
	hasRequiredToPropertyKey = 1;
	(function (module) {
		var _typeof = require_typeof()["default"];
		var toPrimitive = requireToPrimitive();
		function _toPropertyKey(arg) {
		  var key = toPrimitive(arg, "string");
		  return _typeof(key) === "symbol" ? key : String(key);
		}
		module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (toPropertyKey));
	return toPropertyKeyExports;
}

var hasRequiredDefineProperty;

function requireDefineProperty () {
	if (hasRequiredDefineProperty) return definePropertyExports;
	hasRequiredDefineProperty = 1;
	(function (module) {
		var toPropertyKey = requireToPropertyKey();
		function _defineProperty(obj, key, value) {
		  key = toPropertyKey(key);
		  if (key in obj) {
		    Object.defineProperty(obj, key, {
		      value: value,
		      enumerable: true,
		      configurable: true,
		      writable: true
		    });
		  } else {
		    obj[key] = value;
		  }
		  return obj;
		}
		module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (defineProperty$4));
	return definePropertyExports;
}

var isRetryAllowed;
var hasRequiredIsRetryAllowed;

function requireIsRetryAllowed () {
	if (hasRequiredIsRetryAllowed) return isRetryAllowed;
	hasRequiredIsRetryAllowed = 1;

	const denyList = new Set([
		'ENOTFOUND',
		'ENETUNREACH',

		// SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
		'UNABLE_TO_GET_ISSUER_CERT',
		'UNABLE_TO_GET_CRL',
		'UNABLE_TO_DECRYPT_CERT_SIGNATURE',
		'UNABLE_TO_DECRYPT_CRL_SIGNATURE',
		'UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY',
		'CERT_SIGNATURE_FAILURE',
		'CRL_SIGNATURE_FAILURE',
		'CERT_NOT_YET_VALID',
		'CERT_HAS_EXPIRED',
		'CRL_NOT_YET_VALID',
		'CRL_HAS_EXPIRED',
		'ERROR_IN_CERT_NOT_BEFORE_FIELD',
		'ERROR_IN_CERT_NOT_AFTER_FIELD',
		'ERROR_IN_CRL_LAST_UPDATE_FIELD',
		'ERROR_IN_CRL_NEXT_UPDATE_FIELD',
		'OUT_OF_MEM',
		'DEPTH_ZERO_SELF_SIGNED_CERT',
		'SELF_SIGNED_CERT_IN_CHAIN',
		'UNABLE_TO_GET_ISSUER_CERT_LOCALLY',
		'UNABLE_TO_VERIFY_LEAF_SIGNATURE',
		'CERT_CHAIN_TOO_LONG',
		'CERT_REVOKED',
		'INVALID_CA',
		'PATH_LENGTH_EXCEEDED',
		'INVALID_PURPOSE',
		'CERT_UNTRUSTED',
		'CERT_REJECTED',
		'HOSTNAME_MISMATCH'
	]);

	// TODO: Use `error?.code` when targeting Node.js 14
	isRetryAllowed = error => !denyList.has(error && error.code);
	return isRetryAllowed;
}

var _interopRequireDefault = interopRequireDefaultExports;

Object.defineProperty(cjs$1, "__esModule", {
  value: true
});
cjs$1.isNetworkError = isNetworkError;
cjs$1.isRetryableError = isRetryableError;
cjs$1.isSafeRequestError = isSafeRequestError;
cjs$1.isIdempotentRequestError = isIdempotentRequestError;
cjs$1.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
cjs$1.exponentialDelay = exponentialDelay;
cjs$1.default = axiosRetry$1;

var _regenerator = _interopRequireDefault(requireRegenerator());

var _typeof2 = _interopRequireDefault(require_typeof());

var _asyncToGenerator2 = _interopRequireDefault(requireAsyncToGenerator());

var _defineProperty2 = _interopRequireDefault(requireDefineProperty());

var _isRetryAllowed = _interopRequireDefault(requireIsRetryAllowed());

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var namespace = 'axios-retry';
/**
 * @param  {Error}  error
 * @return {boolean}
 */

function isNetworkError(error) {
  return !error.response && Boolean(error.code) && // Prevents retrying cancelled requests
  error.code !== 'ECONNABORTED' && // Prevents retrying timed out requests
  (0, _isRetryAllowed.default)(error); // Prevents retrying unsafe errors
}

var SAFE_HTTP_METHODS = ['get', 'head', 'options'];
var IDEMPOTENT_HTTP_METHODS = SAFE_HTTP_METHODS.concat(['put', 'delete']);
/**
 * @param  {Error}  error
 * @return {boolean}
 */

function isRetryableError(error) {
  return error.code !== 'ECONNABORTED' && (!error.response || error.response.status >= 500 && error.response.status <= 599);
}
/**
 * @param  {Error}  error
 * @return {boolean}
 */


function isSafeRequestError(error) {
  if (!error.config) {
    // Cannot determine if the request can be retried
    return false;
  }

  return isRetryableError(error) && SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
/**
 * @param  {Error}  error
 * @return {boolean}
 */


function isIdempotentRequestError(error) {
  if (!error.config) {
    // Cannot determine if the request can be retried
    return false;
  }

  return isRetryableError(error) && IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
/**
 * @param  {Error}  error
 * @return {boolean | Promise}
 */


function isNetworkOrIdempotentRequestError(error) {
  return isNetworkError(error) || isIdempotentRequestError(error);
}
/**
 * @return {number} - delay in milliseconds, always 0
 */


function noDelay() {
  return 0;
}
/**
 * @param  {number} [retryNumber=0]
 * @return {number} - delay in milliseconds
 */


function exponentialDelay() {
  var retryNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var delay = Math.pow(2, retryNumber) * 100;
  var randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay

  return delay + randomSum;
}
/**
 * Initializes and returns the retry state for the given request/config
 * @param  {AxiosRequestConfig} config
 * @return {Object}
 */


function getCurrentState(config) {
  var currentState = config[namespace] || {};
  currentState.retryCount = currentState.retryCount || 0;
  config[namespace] = currentState;
  return currentState;
}
/**
 * Returns the axios-retry options for the current request
 * @param  {AxiosRequestConfig} config
 * @param  {AxiosRetryConfig} defaultOptions
 * @return {AxiosRetryConfig}
 */


function getRequestOptions(config, defaultOptions) {
  return _objectSpread(_objectSpread({}, defaultOptions), config[namespace]);
}
/**
 * @param  {Axios} axios
 * @param  {AxiosRequestConfig} config
 */


function fixConfig(axios, config) {
  if (axios.defaults.agent === config.agent) {
    delete config.agent;
  }

  if (axios.defaults.httpAgent === config.httpAgent) {
    delete config.httpAgent;
  }

  if (axios.defaults.httpsAgent === config.httpsAgent) {
    delete config.httpsAgent;
  }
}
/**
 * Checks retryCondition if request can be retried. Handles it's retruning value or Promise.
 * @param  {number} retries
 * @param  {Function} retryCondition
 * @param  {Object} currentState
 * @param  {Error} error
 * @return {boolean}
 */


function shouldRetry(_x, _x2, _x3, _x4) {
  return _shouldRetry.apply(this, arguments);
}
/**
 * Adds response interceptors to an axios instance to retry requests failed due to network issues
 *
 * @example
 *
 * import axios from 'axios';
 *
 * axiosRetry(axios, { retries: 3 });
 *
 * axios.get('http://example.com/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Exponential back-off retry delay between requests
 * axiosRetry(axios, { retryDelay : axiosRetry.exponentialDelay});
 *
 * // Custom retry delay
 * axiosRetry(axios, { retryDelay : (retryCount) => {
 *   return retryCount * 1000;
 * }});
 *
 * // Also works with custom axios instances
 * const client = axios.create({ baseURL: 'http://example.com' });
 * axiosRetry(client, { retries: 3 });
 *
 * client.get('/test') // The first request fails and the second returns 'ok'
 *   .then(result => {
 *     result.data; // 'ok'
 *   });
 *
 * // Allows request-specific configuration
 * client
 *   .get('/test', {
 *     'axios-retry': {
 *       retries: 0
 *     }
 *   })
 *   .catch(error => { // The first request fails
 *     error !== undefined
 *   });
 *
 * @param {Axios} axios An axios instance (the axios object or one created from axios.create)
 * @param {Object} [defaultOptions]
 * @param {number} [defaultOptions.retries=3] Number of retries
 * @param {boolean} [defaultOptions.shouldResetTimeout=false]
 *        Defines if the timeout should be reset between retries
 * @param {Function} [defaultOptions.retryCondition=isNetworkOrIdempotentRequestError]
 *        A function to determine if the error can be retried
 * @param {Function} [defaultOptions.retryDelay=noDelay]
 *        A function to determine the delay between retry requests
 */


function _shouldRetry() {
  _shouldRetry = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(retries, retryCondition, currentState, error) {
    var shouldRetryOrPromise;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            shouldRetryOrPromise = currentState.retryCount < retries && retryCondition(error); // This could be a promise

            if (!((0, _typeof2.default)(shouldRetryOrPromise) === 'object')) {
              _context2.next = 11;
              break;
            }

            _context2.prev = 2;
            _context2.next = 5;
            return shouldRetryOrPromise;

          case 5:
            return _context2.abrupt("return", true);

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", false);

          case 11:
            return _context2.abrupt("return", shouldRetryOrPromise);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 8]]);
  }));
  return _shouldRetry.apply(this, arguments);
}

function axiosRetry$1(axios, defaultOptions) {
  axios.interceptors.request.use(function (config) {
    var currentState = getCurrentState(config);
    currentState.lastRequestTime = Date.now();
    return config;
  });
  axios.interceptors.response.use(null, /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(error) {
      var config, _getRequestOptions, _getRequestOptions$re, retries, _getRequestOptions$re2, retryCondition, _getRequestOptions$re3, retryDelay, _getRequestOptions$sh, shouldResetTimeout, currentState, delay, lastRequestDuration;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              config = error.config; // If we have no information to retry the request

              if (config) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", Promise.reject(error));

            case 3:
              _getRequestOptions = getRequestOptions(config, defaultOptions), _getRequestOptions$re = _getRequestOptions.retries, retries = _getRequestOptions$re === void 0 ? 3 : _getRequestOptions$re, _getRequestOptions$re2 = _getRequestOptions.retryCondition, retryCondition = _getRequestOptions$re2 === void 0 ? isNetworkOrIdempotentRequestError : _getRequestOptions$re2, _getRequestOptions$re3 = _getRequestOptions.retryDelay, retryDelay = _getRequestOptions$re3 === void 0 ? noDelay : _getRequestOptions$re3, _getRequestOptions$sh = _getRequestOptions.shouldResetTimeout, shouldResetTimeout = _getRequestOptions$sh === void 0 ? false : _getRequestOptions$sh;
              currentState = getCurrentState(config);
              _context.next = 7;
              return shouldRetry(retries, retryCondition, currentState, error);

            case 7:
              if (!_context.sent) {
                _context.next = 14;
                break;
              }

              currentState.retryCount += 1;
              delay = retryDelay(currentState.retryCount, error); // Axios fails merging this configuration to the default configuration because it has an issue
              // with circular structures: https://github.com/mzabriskie/axios/issues/370

              fixConfig(axios, config);

              if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
                lastRequestDuration = Date.now() - currentState.lastRequestTime; // Minimum 1ms timeout (passing 0 or less to XHR means no timeout)

                config.timeout = Math.max(config.timeout - lastRequestDuration - delay, 1);
              }

              config.transformRequest = [function (data) {
                return data;
              }];
              return _context.abrupt("return", new Promise(function (resolve) {
                return setTimeout(function () {
                  return resolve(axios(config));
                }, delay);
              }));

            case 14:
              return _context.abrupt("return", Promise.reject(error));

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x5) {
      return _ref.apply(this, arguments);
    };
  }());
} // Compatibility with CommonJS


axiosRetry$1.isNetworkError = isNetworkError;
axiosRetry$1.isSafeRequestError = isSafeRequestError;
axiosRetry$1.isIdempotentRequestError = isIdempotentRequestError;
axiosRetry$1.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
axiosRetry$1.exponentialDelay = exponentialDelay;
axiosRetry$1.isRetryableError = isRetryableError;

const axiosRetry = cjs$1.default;

axiosRetry$2.exports = axiosRetry;
axiosRetryExports.default = axiosRetry;

(function (exports) {
	var __assign = (commonjsGlobal && commonjsGlobal.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
	    Object.defineProperty(o, "default", { enumerable: true, value: v });
	}) : function(o, v) {
	    o["default"] = v;
	});
	var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	    __setModuleDefault(result, mod);
	    return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.applyRetry = exports.DEFAULT_RETRIES_CONFIG = void 0;
	var axios_retry_1 = __importStar(axiosRetryExports);
	var isRequestNotPassedToOurBalancer = function (error) {
	    var _a;
	    var traceId = (((_a = error.response) === null || _a === void 0 ? void 0 : _a.headers) || {})['x-trace-id'];
	    return (0, axios_retry_1.isRetryableError)(error) && !traceId;
	};
	exports.DEFAULT_RETRIES_CONFIG = {
	    retries: 3,
	    retryCondition: function (error) {
	        return (0, axios_retry_1.isNetworkOrIdempotentRequestError)(error) || isRequestNotPassedToOurBalancer(error);
	    },
	};
	var applyRetry = function (instance, externalConfig) {
	    var config = externalConfig || exports.DEFAULT_RETRIES_CONFIG;
	    (0, axios_retry_1.default)(instance, __assign({ retryDelay: axios_retry_1.exponentialDelay }, config));
	    return instance;
	};
	exports.applyRetry = applyRetry;
	
} (applyRetry));

(function (exports) {
	var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    var desc = Object.getOwnPropertyDescriptor(m, k);
	    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
	      desc = { enumerable: true, get: function() { return m[k]; } };
	    }
	    Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var custom_axios_1 = customAxios;
	var stack_trace_patch_1 = stackTracePatch;
	var apply_retry_1 = applyRetry;
	var axios = (0, custom_axios_1.createCustomAxios)(function (instance) {
	    (0, stack_trace_patch_1.applyStackTracePatch)(instance);
	    (0, apply_retry_1.applyRetry)(instance, instance.defaults.retriesConfig);
	    return instance;
	});
	__exportStar(axiosExports$1, exports);
	exports.default = axios;
	
} (dist));

var axios = /*@__PURE__*/getDefaultExportFromCjs(dist);

const uploadFile = async (file, token) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('token', token);
    const { data } = await axios.post('/api/document-storage/upload', formData);
    return data;
};

class DaDataProvider {
    constructor(params) {
        this.transport = params.transport;
        this.url = params.url;
    }
    async fetch(query, limit, requestParams) {
        const params = JSON.stringify({
            query,
            limit,
            count: limit,
            ...requestParams,
        });
        const response = await this.transport.post(this.url, params);
        const { suggestions = [] } = response.data;
        const list = suggestions.map(({ value, unrestricted_value, data }) => ({
            value,
            unrestricted_value,
            ...data,
        }));
        return {
            list,
        };
    }
}

function createAxios$1(config, onResult = (response) => response, onReject = (error) => Promise.reject(error), onRequest = (request) => request) {
    const instance = axios.create(config);
    instance.interceptors.request.use(onRequest);
    instance.interceptors.response.use(onResult, onReject);
    return instance;
}
const transport$1 = createAxios$1({
    baseURL: '/api/dadata',
    headers: {
        'Content-Type': 'application/json',
    },
});

const client$8 = axios.create();
client$8.defaults.paramsSerializer = querystring.encode;
client$8.defaults.baseURL = "/api/realty-check";

const FMS_UNIT_URL = '/suggestions/api/4_1/rs/suggest/fms_unit';
new DaDataProvider({ transport: transport$1, url: FMS_UNIT_URL });

const BANK_URL = '/suggestions/api/4_1/rs/findById/bank';
const dataProviderBank = new DaDataProvider({ transport: transport$1, url: BANK_URL });
const fetchSuggestions$1 = async (text) => {
    const fetchedSuggestions = await dataProviderBank.fetch(text, 10, {});
    return fetchedSuggestions.list.map((option) => ({
        value: {
            inn: option.inn,
            bic: option.bic,
            address: option.address.value,
            bankName: option.name.payment,
            correspondingNumber: option.correspondent_account,
        },
        label: option.unrestricted_value,
    }));
};
withDisabled((props) => {
    return (React.createElement("div", { style: { marginBottom: '28px' } },
        React.createElement(SuggestInput, { label: "\u041F\u043E\u0438\u0441\u043A \u0431\u0430\u043D\u043A\u0430 (\u0411\u0418\u041A, SWIFT, \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440)", fetchSuggestions: fetchSuggestions$1, ...props })));
});

const ORGANIZATION_URL = '/suggestions/api/4_1/rs/suggest/party';
const dataProviderOrganization = new DaDataProvider({ transport: transport$1, url: ORGANIZATION_URL });
const fetchSuggestions = async (text) => {
    const fetchedSuggestions = await dataProviderOrganization.fetch(text, 10, {});
    return fetchedSuggestions.list.map((option) => {
        var _a, _b, _c, _d, _e;
        return ({
            value: {
                inn: option.inn,
                kpp: option.kpp,
                ogrn: option.ogrn,
                name: ((_a = option.name) === null || _a === void 0 ? void 0 : _a.short_with_opf) || ((_b = option.name) === null || _b === void 0 ? void 0 : _b.full_with_opf),
                address: ['1125260001734', '1025203739120'].includes(option.ogrn)
                    ? (_d = (_c = option.address) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.source
                    : (_e = option.address) === null || _e === void 0 ? void 0 : _e.value,
            },
            label: option.unrestricted_value,
        });
    });
};
withDisabled((props) => {
    return (React.createElement("div", { style: { marginBottom: 28 } },
        React.createElement(SuggestInput, { label: "\u041F\u043E\u0438\u0441\u043A \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 (\u0418\u041D\u041D, \u041A\u041F\u041F, \u041E\u0413\u0420\u041D, \u0430\u0434\u0440\u0435\u0441 \u0434\u043E \u0443\u043B\u0438\u0446\u044B, \u0424\u0418\u041E \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0435\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438)", fetchSuggestions: fetchSuggestions, ...props })));
});

const useModal = (initialState = false) => {
    const [isModalOpened, setIsModalOpened] = React.useState(initialState);
    const openModal = React.useCallback(() => setIsModalOpened(true), []);
    const closeModal = React.useCallback(() => setIsModalOpened(false), []);
    const hookResult = [isModalOpened, openModal, closeModal];
    hookResult.isModalOpened = hookResult[0];
    hookResult.openModal = hookResult[1];
    hookResult.closeModal = hookResult[2];
    return hookResult;
};

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$5(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$5;

var eq$4 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$4(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var baseGetTag$5 = _baseGetTag,
    isObject$c = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$5(value) {
  if (!isObject$c(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$5(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$5;

var root$7 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$7['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$2 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$4 = isFunction_1,
    isMasked = _isMasked,
    isObject$b = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype,
    objectProto$d = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$d.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString$1.call(hasOwnProperty$c).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$b(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$4(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative,
    root$6 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$6(root$6, 'Map');

var _Map = Map$4;

var getNative$5 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$5(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$c.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$b.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$b.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$a.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$3 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$3 || ListCache$2),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;

var _MapCache = MapCache$3;

var ListCache$1 = _ListCache,
    Map$2 = _Map,
    MapCache$2 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$3(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$3.prototype.clear = stackClear;
Stack$3.prototype['delete'] = stackDelete;
Stack$3.prototype.get = stackGet;
Stack$3.prototype.has = stackHas;
Stack$3.prototype.set = stackSet;

var _Stack = Stack$3;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache$1 = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$1(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache$1;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;

var _SetCache = SetCache$1;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$1(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

var root$5 = _root;

/** Built-in value references. */
var Uint8Array$3 = root$5.Uint8Array;

var _Uint8Array = Uint8Array$3;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$1;

var Symbol$4 = _Symbol,
    Uint8Array$2 = _Uint8Array,
    eq$3 = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    mapTag$5 = '[object Map]',
    numberTag$4 = '[object Number]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$4 ? Symbol$4.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$4:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$3:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }
      return true;

    case boolTag$3:
    case dateTag$3:
    case numberTag$4:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$3(+object, +other);

    case errorTag$2:
      return object.name == other.name && object.message == other.message;

    case regexpTag$3:
    case stringTag$3:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$5:
      var convert = mapToArray;

    case setTag$5:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$2:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$3(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$3;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$b = Array.isArray;

var isArray_1 = isArray$b;

var arrayPush$2 = _arrayPush,
    isArray$a = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$a(object) ? result : arrayPush$2(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter = _arrayFilter,
    stubArray$1 = stubArray_1;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$a.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols$3;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

var baseGetTag$4 = _baseGetTag,
    isObjectLike$7 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$7(value) && baseGetTag$4(value) == argsTag$3;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$6 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$9.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$9.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$3 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$6(value) && hasOwnProperty$9.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments$3;

var isBufferExports = {};
var isBuffer$3 = {
  get exports(){ return isBufferExports; },
  set exports(v){ isBufferExports = v; },
};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

(function (module, exports) {
	var root = _root,
	    stubFalse = stubFalse_1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	module.exports = isBuffer;
} (isBuffer$3, isBufferExports));

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$4(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$4;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength$3;

var baseGetTag$3 = _baseGetTag,
    isLength$2 = isLength_1,
    isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$4 = '[object Map]',
    numberTag$3 = '[object Number]',
    objectTag$4 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] =
typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] =
typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$4] = typedArrayTags[numberTag$3] =
typedArrayTags[objectTag$4] = typedArrayTags[regexpTag$2] =
typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] =
typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$5(value) &&
    isLength$2(value.length) && !!typedArrayTags[baseGetTag$3(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$4(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$4;

var _nodeUtilExports = {};
var _nodeUtil = {
  get exports(){ return _nodeUtilExports; },
  set exports(v){ _nodeUtilExports = v; },
};

(function (module, exports) {
	var freeGlobal = _freeGlobal;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil;
} (_nodeUtil, _nodeUtilExports));

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary$3 = _baseUnary,
    nodeUtil$2 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$2 = nodeIsTypedArray ? baseUnary$3(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$2;

var baseTimes = _baseTimes,
    isArguments$2 = isArguments_1,
    isArray$9 = isArray_1,
    isBuffer$2 = isBufferExports,
    isIndex$3 = _isIndex,
    isTypedArray$1 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$8.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$9(value),
      isArg = !isArr && isArguments$2(value),
      isBuff = !isArr && !isArg && isBuffer$2(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$8.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$3(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

/** Used for built-in method references. */

var objectProto$7 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$3(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$7;

  return value === proto;
}

var _isPrototype = isPrototype$3;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg$1(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype$2 = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$6.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype$2(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$1;

var isFunction$3 = isFunction_1,
    isLength$1 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$5(value) {
  return value != null && isLength$1(value.length) && !isFunction$3(value);
}

var isArrayLike_1 = isArrayLike$5;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike$4 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$5(object) {
  return isArrayLike$4(object) ? arrayLikeKeys$1(object) : baseKeys(object);
}

var keys_1 = keys$5;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols$2 = _getSymbols,
    keys$4 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$4, getSymbols$2);
}

var _getAllKeys = getAllKeys$2;

var getAllKeys$1 = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$5.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys$1(object),
      objLength = objProps.length,
      othProps = getAllKeys$1(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$6.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var getNative$4 = _getNative,
    root$4 = _root;

/* Built-in method references that are verified to be native. */
var DataView$2 = getNative$4(root$4, 'DataView');

var _DataView = DataView$2;

var getNative$3 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$3(root$3, 'Promise');

var _Promise = Promise$2;

var getNative$2 = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var Set$2 = getNative$2(root$2, 'Set');

var _Set = Set$2;

var getNative$1 = _getNative,
    root$1 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = getNative$1(root$1, 'WeakMap');

var _WeakMap = WeakMap$2;

var DataView$1 = _DataView,
    Map$1 = _Map,
    Promise$1 = _Promise,
    Set$1 = _Set,
    WeakMap$1 = _WeakMap,
    baseGetTag$2 = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
    objectTag$3 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$4 = baseGetTag$2;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$1 && getTag$4(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2) ||
    (Map$1 && getTag$4(new Map$1) != mapTag$3) ||
    (Promise$1 && getTag$4(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag$4(new Set$1) != setTag$3) ||
    (WeakMap$1 && getTag$4(new WeakMap$1) != weakMapTag$1)) {
  getTag$4 = function(value) {
    var result = baseGetTag$2(value),
        Ctor = result == objectTag$3 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$3;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$3;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag$4;

var Stack$2 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag$3 = _getTag,
    isArray$8 = isArray_1,
    isBuffer$1 = isBufferExports,
    isTypedArray = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$2 = '[object Object]';

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$4.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$8(object),
      othIsArr = isArray$8(other),
      objTag = objIsArr ? arrayTag$1 : getTag$3(object),
      othTag = othIsArr ? arrayTag$1 : getTag$3(other);

  objTag = objTag == argsTag$1 ? objectTag$2 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$2 : othTag;

  var objIsObj = objTag == objectTag$2,
      othIsObj = othTag == objectTag$2,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$2);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$5.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$5.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$2);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$2);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$4 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$4(value) && !isObjectLike$4(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}

var _baseIsEqual = baseIsEqual$2;

var Stack$1 = _Stack,
    baseIsEqual$1 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$1;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$a = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$a(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys$3 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$3(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

var isArray$7 = isArray_1,
    isSymbol$3 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$4(value, object) {
  if (isArray$7(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$4;

var MapCache = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache;

var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$2 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$2;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$4(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$4;

var Symbol$3 = _Symbol,
    arrayMap$3 = _arrayMap,
    isArray$6 = isArray_1,
    isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$6(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$3(value, baseToString$1) + '';
  }
  if (isSymbol$2(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$3(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$3;

var isArray$5 = isArray_1,
    isKey$3 = _isKey,
    stringToPath$1 = _stringToPath,
    toString$2 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$6(value, object) {
  if (isArray$5(value)) {
    return value;
  }
  return isKey$3(value, object) ? [value] : stringToPath$1(toString$2(value));
}

var _castPath = castPath$6;

var isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$6(value) {
  if (typeof value == 'string' || isSymbol$1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _toKey = toKey$6;

var castPath$5 = _castPath,
    toKey$5 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$6(object, path) {
  path = castPath$5(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$5(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$6;

var baseGet$5 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$4(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$5(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$4;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var castPath$4 = _castPath,
    isArguments$1 = isArguments_1,
    isArray$4 = isArray_1,
    isIndex$2 = _isIndex,
    isLength = isLength_1,
    toKey$4 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath$4(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$4(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex$2(key, length) &&
    (isArray$4(object) || isArguments$1(object));
}

var _hasPath = hasPath$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$1;

var baseIsEqual = _baseIsEqual,
    get$3 = get_1,
    hasIn = hasIn_1,
    isKey$2 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$3 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$2(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$3(path), srcValue);
  }
  return function(object) {
    var objValue = get$3(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$4(value) {
  return value;
}

var identity_1 = identity$4;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet$4 = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet$4(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey$1 = _isKey,
    toKey$2 = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey$1(path) ? baseProperty(toKey$2(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity$3 = identity_1,
    isArray$3 = isArray_1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$3(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$3;
  }
  if (typeof value == 'object') {
    return isArray$3(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$3;

/** Error message constants. */

var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate$1(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

var negate_1 = negate$1;

var getNative = _getNative;

var defineProperty$3 = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$2 = defineProperty$3;

var defineProperty$2 = _defineProperty$2;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$2(object, key, value) {
  if (key == '__proto__' && defineProperty$2) {
    defineProperty$2(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$2;

var baseAssignValue$1 = _baseAssignValue,
    eq$2 = eq_1;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$3.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$3(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$4.call(object, key) && eq$2(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$1(object, key, value);
  }
}

var _assignValue = assignValue$3;

var assignValue$2 = _assignValue,
    castPath$3 = _castPath,
    isIndex$1 = _isIndex,
    isObject$9 = isObject_1,
    toKey$1 = _toKey;

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet$1(object, path, value, customizer) {
  if (!isObject$9(object)) {
    return object;
  }
  path = castPath$3(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey$1(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject$9(objValue)
          ? objValue
          : (isIndex$1(path[index + 1]) ? [] : {});
      }
    }
    assignValue$2(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

var _baseSet = baseSet$1;

var baseGet$3 = _baseGet,
    baseSet = _baseSet,
    castPath$2 = _castPath;

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy$1(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet$3(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath$2(path, object), value);
    }
  }
  return result;
}

var _basePickBy = basePickBy$1;

var overArg = _overArg;

/** Built-in value references. */
var getPrototype$3 = overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$3;

var arrayPush$1 = _arrayPush,
    getPrototype$2 = _getPrototype,
    getSymbols$1 = _getSymbols,
    stubArray = stubArray_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush$1(result, getSymbols$1(object));
    object = getPrototype$2(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn$2;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject$8 = isObject_1,
    isPrototype$1 = _isPrototype,
    nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$2.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$8(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike$3 = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$3(object) {
  return isArrayLike$3(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$3;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn$1 = _getSymbolsIn,
    keysIn$2 = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$3(object) {
  return baseGetAllKeys(object, keysIn$2, getSymbolsIn$1);
}

var _getAllKeysIn = getAllKeysIn$3;

var arrayMap$2 = _arrayMap,
    baseIteratee$2 = _baseIteratee,
    basePickBy = _basePickBy,
    getAllKeysIn$2 = _getAllKeysIn;

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy$1(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap$2(getAllKeysIn$2(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee$2(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

var pickBy_1 = pickBy$1;

var baseIteratee$1 = _baseIteratee,
    negate = negate_1,
    pickBy = pickBy_1;

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee$1(predicate)));
}

var omitBy_1 = omitBy;

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */

function isNil(value) {
  return value == null;
}

var isNil_1 = isNil;

var baseGetTag$1 = _baseGetTag,
    isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var numberTag$2 = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber$1(value) {
  return typeof value == 'number' ||
    (isObjectLike$3(value) && baseGetTag$1(value) == numberTag$2);
}

var isNumber_1 = isNumber$1;

var isNumber = isNumber_1;

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN$2(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

var _isNaN = isNaN$2;

const isEmptyObject$1 = (value) => isObject_1(value) && Object.keys(value).length === 0;
const cleaner = (dto) => omitBy_1(dto, (value) => value === '' || isNil_1(value) || isEmptyObject$1(value) || _isNaN(value));
const objectSanitizer = (value) => {
    if (!isObject_1(value))
        return value;
    if (Array.isArray(value)) {
        return value.filter(Boolean);
    }
    const copyValue = { ...value };
    for (const [key, value] of Object.entries(copyValue)) {
        copyValue[key] = objectSanitizer(value);
    }
    return cleaner(copyValue);
};

var css_248z$z = ".field-with-suggestions-module_banner__8JnNE{height:60px;margin-top:0;padding:0 var(--padding-m);width:100%}.field-with-suggestions-module_suggestion__MDEoQ{border-radius:var(--step);cursor:pointer;line-height:36px;margin:4px 8px;min-height:36px;padding:0 8px}.field-with-suggestions-module_suggestion__MDEoQ:hover{background-color:#eeeff6}.field-with-suggestions-module_dropdown__CVGPn *{box-sizing:border-box}.field-with-suggestions-module_dropdownContent__nal8Q{max-height:250px;overflow:scroll}.field-with-suggestions-module_dropdownContent__nal8Q *{box-sizing:border-box}";
styleInject(css_248z$z);

const CITIZENSHIPS = {
    RUSSIA: 'Россия',
};
convertToSelectOptions$1(CITIZENSHIPS);
const IDENTICATES = {
    PASSPORT: 'Паспорт',
    BIRTH_CERTIFICATE: 'Свидетельство о рождении',
};
convertToSelectOptions$1(IDENTICATES);
const GENDERS = {
    MALE: 'Мужской',
    FEMALE: 'Женский',
};
convertToSelectOptions$1(GENDERS);
const MARRIED_STATUS = {
    MARRIED: 'Состоит в браке',
    NOT_MARRIED: 'Не состоит в браке',
};
convertToSelectOptions$1(MARRIED_STATUS);
const PERSON_REGISTRATION_ADDRESS_TYPES = {
    PERMANENT: 'Постоянно зарегистрирован по адресу',
    PREVIOUS: 'Ранее был зарегистрирован по адресу',
    TEMPORARY: 'Проживает по адресу',
};
convertToSelectOptions$1(PERSON_REGISTRATION_ADDRESS_TYPES);

var css_248z$y = ".suggest-field-module_loader__yzYL1{align-items:center;background:hsla(0,0%,100%,.502);bottom:0;display:flex;justify-content:center;left:0;position:absolute;right:0;top:0}.suggest-field-module_empty__dVgKa{align-items:center;display:flex;height:48px;padding:8px}.suggest-field-module_suggest-list__za9m3{z-index:10}.suggest-field-module_field__P7x-R{margin-bottom:16px}.suggest-field-module_emptyList__9aMNG{background:#fff;border:1px solid var(--color-black-200);border-radius:var(--border-radius-normal);box-shadow:var(--sh-z1-primary);box-sizing:border-box;left:0;margin-top:8px;min-width:100%;overflow:hidden;overflow-y:scroll;padding:8px;position:absolute;text-align:center;top:100%;z-index:5}";
styleInject(css_248z$y);

const ADDRESS_URL$1 = '/suggestions/api/4_1/rs/suggest/address';
new DaDataProvider({ transport: transport$1, url: ADDRESS_URL$1 });

const FileUpload = (props) => {
    const { maxSize } = props;
    const handleDropReject = React.useCallback((rejections) => {
        rejections.forEach((rejection) => {
            rejection.errors.forEach((fileError) => {
                switch (true) {
                    case fileError.code === 'file-too-large':
                        publishErrorNotification$1(`Размер файла ${rejection.file.name} превышает допустимый размер${Array.isArray(maxSize)
                            ? `: ${maxSize[0]} ${maxSize[1]}`
                            : `: ${maxSize / (1024 * 1024)} МБ`}`);
                        break;
                    case fileError.code === 'file-too-small':
                        publishErrorNotification$1(`Размер файла ${rejection.file.name} слишком маленький, возможно вы грузите пустой файл?`);
                        break;
                    case fileError.code === 'file-invalid-type':
                        publishErrorNotification$1('Недопустимый формат файла');
                        break;
                    default:
                        publishErrorNotification$1(`Ошибка при загрузке файла ${rejection.file.name}. Подробнее: ${JSON.stringify(rejection)}`);
                }
            });
        });
    }, [maxSize]);
    return (React.createElement(Uploader, { ...props, onDropRejected: handleDropReject }, props.children));
};

var css_248z$x = ".file-upload-module_documents__2rOA1{margin:14px calc(var(--padding-m)*-1) 0}.file-upload-module_disabled__5Sncu{background-color:var(--c-disabled);border-color:var(--c-disabled-border);pointer-events:none}.file-upload-module_container__b6Hff{display:flex;flex-direction:column}.file-upload-module_isReverse__rC6BX{flex-direction:column-reverse}.file-upload-module_divider__Hz17L{padding:0 var(--padding-xl)}";
var styles$d = {"documents":"file-upload-module_documents__2rOA1","disabled":"file-upload-module_disabled__5Sncu","container":"file-upload-module_container__b6Hff","isReverse":"file-upload-module_isReverse__rC6BX","divider":"file-upload-module_divider__Hz17L"};
styleInject(css_248z$x);

const FileUploader = (props) => {
    const { values, showUploadArea = true, DocumentItemComponent = DocumentItem, readonly = false, className, placeholder, errorMessage, isReverse, withDivider, withoutContextMenu, withoutDownloadOnClick, withFileSize, extraSection, size, customDropzoneContent, documentsClassName = '', ...uploaderProps } = props;
    const { disabled = false } = uploaderProps;
    const isHideUploaderInSingleMode = !uploaderProps.multiple && values.length > 0;
    const isShowUploader = !isHideUploaderInSingleMode && showUploadArea;
    const isShowFilesList = values.length > 0;
    const isShowPlaceholder = values.length === 0 && readonly;
    return (React.createElement("div", { className: cn(className, styles$d.container, { [styles$d.isReverse]: isReverse }) },
        React.createElement("div", null,
            isShowUploader && (React.createElement("div", { className: cn({ [styles$d.disabled]: disabled }) },
                React.createElement(FileUpload, { size: size, ...uploaderProps }, customDropzoneContent && React.createElement(Uploader.Dropzone, null, customDropzoneContent)))),
            errorMessage && React.createElement("div", { style: { color: 'red' } }, errorMessage)),
        React.createElement("div", null,
            isShowFilesList && (React.createElement("div", { className: (documentsClassName) }, values.map((data, index) => {
                const showDivider = withDivider && values.length - 1 !== index;
                return (React.createElement(React.Fragment, { key: data.id || data.documentStorageId || index },
                    React.createElement(DocumentItemComponent, { data: data, index: index, errorMessage: data.status === 'ERROR' ? 'Не удалось загрузить файл' : undefined, readonly: readonly, disabled: disabled, onDelete: uploaderProps.onDelete, onDownload: uploaderProps.onDownload, withoutContextMenu: withoutContextMenu, withoutDownloadOnClick: withoutDownloadOnClick, withFileSize: withFileSize }),
                    extraSection && extraSection(index),
                    showDivider && (React.createElement("div", { className: styles$d.divider },
                        React.createElement(Divider$1, null)))));
            }))),
            isShowPlaceholder && placeholder)));
};

var css_248z$w = ":root{--color-black-50:#f8f8fc;--color-black-75:#f3f1f8;--color-black-100:#eae9f2;--color-black-200:#ccc9d9;--color-black-250:#b8b4ca;--color-black-300:#a4a1b5;--color-black-350:#8a869c;--color-black-400:#6e6a81;--color-black-450:#464257;--color-black-500:#211f2e;--color-black-50-alpha:rgba(186,176,227,.1);--color-black-75-alpha:rgba(194,189,219,.2);--color-black-100-alpha:rgba(150,142,190,.2);--color-black-200-alpha:rgba(127,120,161,.4);--color-black-250-alpha:rgba(115,108,147,.5);--color-black-300-alpha:rgba(105,99,131,.6);--color-black-400-alpha:rgba(73,68,95,.8);--color-black-500-alpha:#211f2e;--color-white-0:hsla(0,0%,100%,0);--color-white-500:#fff;--color-white-100-alpha:hsla(0,0%,100%,.08);--color-white-200-alpha:hsla(0,0%,100%,.16);--color-white-300-alpha:hsla(0,0%,100%,.32);--color-white-400-alpha:hsla(0,0%,100%,.64);--color-white-500-alpha:#fff;--color-blue-50:#f7f5ff;--color-blue-100:#e7e2fd;--color-blue-200:#ccc2fa;--color-blue-300:#a391f3;--color-blue-400:#6b4fe8;--color-blue-500:#3416b6;--color-blue-600:#271188;--color-blue-700:#1b0c5f;--color-blue-800:#150949;--color-orange-50:#fff7f5;--color-orange-100:#fff0eb;--color-orange-200:#ffe4db;--color-orange-300:#ffc9b8;--color-orange-400:#ffa78a;--color-orange-500:#ff794d;--color-orange-600:#ff4f14;--color-orange-700:#eb3b00;--color-purple-50:#f7f5ff;--color-purple-100:#eeebff;--color-purple-200:#e3dcfe;--color-purple-300:#cec4fd;--color-purple-400:#b6a6fc;--color-purple-500:#8e75fa;--color-purple-600:#6544f8;--color-purple-700:#5836ec;--color-turquoise-50:#f5ffff;--color-turquoise-100:#e7fdfe;--color-turquoise-200:#c6f9fb;--color-turquoise-300:#9bf0f3;--color-turquoise-400:#65e2e6;--color-turquoise-500:#28b8bd;--color-turquoise-600:#1f8f93;--color-turquoise-700:#1b7b7e;--color-yellow-50:#fffbf5;--color-yellow-100:#fff5e6;--color-yellow-200:#feeccd;--color-yellow-300:#fee7a9;--color-yellow-400:#fccc78;--color-yellow-500:#fac32e;--color-yellow-600:#e5a906;--color-yellow-700:#d19b05;--color-green-50:#fafff5;--color-green-100:#f3fee7;--color-green-200:#e4fbcb;--color-green-300:#caf49a;--color-green-400:#b4e878;--color-green-500:#87d232;--color-green-600:#78bc29;--color-green-700:#6dab26;--color-red-50:#fff6f5;--color-red-100:#ffe8e6;--color-red-200:#ffdad6;--color-red-300:#fdb1aa;--color-red-400:#fa857a;--color-red-500:#f44434;--color-red-600:#e91f0c;--color-red-700:#cb1b0b;--color-white:#fff;--color-black:#211f2e;--color-blue:#3416b6;--color-red:#f44434;--color-green:#87d232;--color-orange:#ff794d}.loading-overlay-module_overlay__332SG{background-color:#f8f8fc;bottom:0;display:none;left:0;opacity:.8;position:absolute;right:0;top:0;z-index:1;z-index:10}.loading-overlay-module_loading__EmTNe{display:block}.loading-overlay-module_spinner__nkts-{display:none;left:30%;position:absolute;top:50%}";
styleInject(css_248z$w);

var css_248z$v = ":root{--color-black-50:#f8f8fc;--color-black-75:#f3f1f8;--color-black-100:#eae9f2;--color-black-200:#ccc9d9;--color-black-250:#b8b4ca;--color-black-300:#a4a1b5;--color-black-350:#8a869c;--color-black-400:#6e6a81;--color-black-450:#464257;--color-black-500:#211f2e;--color-black-50-alpha:rgba(186,176,227,.1);--color-black-75-alpha:rgba(194,189,219,.2);--color-black-100-alpha:rgba(150,142,190,.2);--color-black-200-alpha:rgba(127,120,161,.4);--color-black-250-alpha:rgba(115,108,147,.5);--color-black-300-alpha:rgba(105,99,131,.6);--color-black-400-alpha:rgba(73,68,95,.8);--color-black-500-alpha:#211f2e;--color-white-0:hsla(0,0%,100%,0);--color-white-500:#fff;--color-white-100-alpha:hsla(0,0%,100%,.08);--color-white-200-alpha:hsla(0,0%,100%,.16);--color-white-300-alpha:hsla(0,0%,100%,.32);--color-white-400-alpha:hsla(0,0%,100%,.64);--color-white-500-alpha:#fff;--color-blue-50:#f7f5ff;--color-blue-100:#e7e2fd;--color-blue-200:#ccc2fa;--color-blue-300:#a391f3;--color-blue-400:#6b4fe8;--color-blue-500:#3416b6;--color-blue-600:#271188;--color-blue-700:#1b0c5f;--color-blue-800:#150949;--color-orange-50:#fff7f5;--color-orange-100:#fff0eb;--color-orange-200:#ffe4db;--color-orange-300:#ffc9b8;--color-orange-400:#ffa78a;--color-orange-500:#ff794d;--color-orange-600:#ff4f14;--color-orange-700:#eb3b00;--color-purple-50:#f7f5ff;--color-purple-100:#eeebff;--color-purple-200:#e3dcfe;--color-purple-300:#cec4fd;--color-purple-400:#b6a6fc;--color-purple-500:#8e75fa;--color-purple-600:#6544f8;--color-purple-700:#5836ec;--color-turquoise-50:#f5ffff;--color-turquoise-100:#e7fdfe;--color-turquoise-200:#c6f9fb;--color-turquoise-300:#9bf0f3;--color-turquoise-400:#65e2e6;--color-turquoise-500:#28b8bd;--color-turquoise-600:#1f8f93;--color-turquoise-700:#1b7b7e;--color-yellow-50:#fffbf5;--color-yellow-100:#fff5e6;--color-yellow-200:#feeccd;--color-yellow-300:#fee7a9;--color-yellow-400:#fccc78;--color-yellow-500:#fac32e;--color-yellow-600:#e5a906;--color-yellow-700:#d19b05;--color-green-50:#fafff5;--color-green-100:#f3fee7;--color-green-200:#e4fbcb;--color-green-300:#caf49a;--color-green-400:#b4e878;--color-green-500:#87d232;--color-green-600:#78bc29;--color-green-700:#6dab26;--color-red-50:#fff6f5;--color-red-100:#ffe8e6;--color-red-200:#ffdad6;--color-red-300:#fdb1aa;--color-red-400:#fa857a;--color-red-500:#f44434;--color-red-600:#e91f0c;--color-red-700:#cb1b0b;--color-white:#fff;--color-black:#211f2e;--color-blue:#3416b6;--color-red:#f44434;--color-green:#87d232;--color-orange:#ff794d}.page-module_container__APw5Y{display:flex;flex-direction:column;position:relative}.page-module_header__YXHaW{display:flex;justify-content:space-between;margin-bottom:24px;margin-top:14px}.page-module_titleCell__qB-qM{color:#211f2e;font-size:28px;font-weight:700;justify-content:flex-start;line-height:36px}.page-module_rightCell__RPBl2,.page-module_titleCell__qB-qM{align-items:flex-start;display:flex}.page-module_title__z8Tb2{font-size:32px;line-height:40px;margin:0 20px 0 0}.page-module_children__bdq-v{flex:1 1 auto;min-height:0;position:relative}";
styleInject(css_248z$v);

const SubmitButton = (props) => {
    const { disabled = false, children, dataTest, isSubmitting } = props;
    return (React.createElement(Button$3, { "data-test": `button-submit`, variant: "primary", type: "submit", disabled: disabled, block: true, dataTest: dataTest, loading: isSubmitting }, children));
};

var css_248z$u = ".title-module_h2__Ybl4Z{color:var(--color-black-500);font:var(--t-primary-alone);font-weight:500}.title-module_h3__50w5n{color:var(--color-black-500);font:var(--t-secondary-alone);font-weight:500}";
styleInject(css_248z$u);

var css_248z$t = ".info-view-module_infoView__Hlmoa{padding-right:var(--padding-xxs)}.info-view-module_nameWrapper__RWlLx{align-items:flex-start;display:flex}.info-view-module_nameWrapper__RWlLx:last-child{margin-bottom:var(--padding-m)}.info-view-module_nameIcon__sC8-X{margin-right:var(--padding-xs)}.info-view-module_name__xV27Z{word-wrap:anywhere;font-size:var(--font-size-m);font-weight:500;line-height:var(--padding-xl);margin-bottom:0;margin-top:0}.info-view-module_additionalTextsWrapper__9YyYA{margin-bottom:var(--padding-m);margin-top:5px}.info-view-module_additionalTextParagraph__VGV1b{word-wrap:anywhere;color:var(--c-text-secondary);font:var(--t-secondary-alone);margin:0}.info-view-module_additionalTextParagraphError__BmlR1{color:var(--c-error);cursor:default;font-size:var(--font-size-xs);line-height:var(--line-height-m);margin-bottom:var(--padding-xs);min-height:var(--line-height-m);transition:color var(--animation)}";
styleInject(css_248z$t);

var css_248z$s = ".banner-subheader-module_bannerSubheader__TejN-{margin-bottom:var(--padding-xs)}";
styleInject(css_248z$s);

var css_248z$r = ".loader-module_loader__Xm-K5{display:flex;justify-content:center;padding:50px}.loader-module_withoutPadding__D3CS0{padding:0}";
var style$1 = {"loader":"loader-module_loader__Xm-K5","withoutPadding":"loader-module_withoutPadding__D3CS0"};
styleInject(css_248z$r);

const Loader = ({ isWithoutPadding, dataTest }) => (React.createElement("div", { className: cn(style$1.loader, { [style$1.withoutPadding]: isWithoutPadding }) },
    React.createElement(Spinner, { size: "m", dataTest: dataTest })));

var css_248z$q = ".table-module_tableRow__gMwCc{border-bottom:2px solid #eef0f6;border-radius:0;box-shadow:none;cursor:pointer;margin:0;padding:20px 10px}.table-module_tableRow__gMwCc:hover{background-color:#eef0f6}.table-module_tableHead__4ZuMp{border-bottom:2px solid #eef0f6}.table-module_tableRowHead__6xLBw{padding:0}";
styleInject(css_248z$q);

var css_248z$p = ".tooltip-module_icon__0NJU6{color:var(--color-black-300);cursor:pointer;transition:color .2s}.tooltip-module_icon__0NJU6:hover{color:var(--color-black-500)}.tooltip-module_tooltip__GwxyU{z-index:10}";
styleInject(css_248z$p);

var css_248z$o = ".download-link-module_downloadLink__tc4OS{color:var(--c-text-link);cursor:pointer;display:flex;position:relative}.download-link-module_downloadLinkWithIcons__UKZEM{align-items:center;display:flex}.download-link-module_downloadIconContainer__lO9mV{margin-right:var(--padding-xxs);min-width:var(--s-unit-3x);position:relative;width:var(--s-unit-3x)}.download-link-module_downloadIconV2__y1w8H,.download-link-module_downloadIcon__C-F1R{left:0;position:absolute;top:0}.download-link-module_textV2__Jz4Ww,.download-link-module_text__sicgr{font-size:14px;font-weight:400;line-height:24px}.download-link-module_textV2__Jz4Ww{font-size:16px}.download-link-module_copyContainer__GPdUV,.download-link-module_downloadIconContainerV2__bO4ZA{cursor:pointer;margin-left:var(--padding-xs);position:relative}.download-link-module_copyIconContainer__fVijF,.download-link-module_downloadIconContainerV2__bO4ZA,.download-link-module_downloadIconV2__y1w8H{height:var(--s-unit-3x);width:var(--s-unit-2x)}.download-link-module_copyIcon__mk6aQ svg,.download-link-module_downloadIconV2__y1w8H svg{color:var(--color-black-400);max-height:var(--s-unit-2x);max-width:var(--s-unit-2x)}";
styleInject(css_248z$o);

var css_248z$n = ".copy-text-module_copyTextContainer__hhYm4{color:var(--c-text-link);cursor:pointer;display:flex;position:relative;width:-moz-max-content;width:max-content}.copy-text-module_isReverse__dJ8YZ{flex-direction:row-reverse}.copy-text-module_copyContainerWithTitle__WFRab{min-width:var(--s-unit-2x);padding-right:var(--s-unit)}.copy-text-module_copyTextContainer__hhYm4:hover{color:var(--c-text-link-hover);cursor:pointer;position:relative}.copy-text-module_text__C4pWQ{font-size:14px;font-weight:400;line-height:24px}.copy-text-module_iconContainer__2dXeP{position:relative}.copy-text-module_toggleOut__rPLkt{animation:copy-text-module_fadeout__F9aHH .15s;opacity:0}.copy-text-module_toggleIn__I94yE{animation:copy-text-module_fadein__dy0WV .15s;opacity:1}.copy-text-module_toggleIn__I94yE,.copy-text-module_toggleOut__rPLkt{left:0;position:absolute;top:0}@keyframes copy-text-module_fadeout__F9aHH{0%{opacity:1}to{opacity:0}}@keyframes copy-text-module_fadein__dy0WV{0%{opacity:0}to{opacity:1}}";
styleInject(css_248z$n);

var css_248z$m = ".block-module_block__joMaM{background-color:#fff;padding:var(--padding-xl)}.block-module_baseBlock__ToLZQ{margin:var(--padding-xl) 0}.block-module_withoutTopMargin__x-Tzs{margin-top:0}.block-module_title__Y8Sdl{font:var(--t-h3);margin-top:0}";
styleInject(css_248z$m);

var css_248z$l = ".banner-module_baseBanner__e5pJh{align-items:center;border-radius:var(--s-unit-05x);display:flex;margin-top:var(--padding-l)}.banner-module_warningBanner__NnpP4{background:var(--c-warn-bg)}.banner-module_errorBanner__vMclb{background:var(--c-error-bg)}.banner-module_infoBanner__-6Ggv{background:var(--color-purple-200)}.banner-module_grayBanner__zfkzg{background:var(--color-black-450);color:var(--color-white)}.banner-module_sizeLarge__k-moK{padding:var(--padding-xl) var(--padding-l)}.banner-module_sizeSmall__bUJkT{padding:var(--padding-s) var(--padding-m)}.banner-module_icon__fT5KE{margin-right:var(--padding-s)}.banner-module_warningIconColor__oZpxy{color:var(--c-warn)}.banner-module_errorIconColor__5-E73{color:var(--c-error)}.banner-module_infoIconColor__hCV8v{color:var(--color-purple-500)}.banner-module_grayIconColor__YQkrb{color:var(--color-white)}";
styleInject(css_248z$l);

var css_248z$k = ".form-banner-module_formBanner__dXjg8{background-color:var(--color-black-50);border-radius:4px;height:calc(100% - var(--padding-m)*3);margin-bottom:var(--padding-m);padding:var(--padding-m)}.form-banner-module_formBannerRow__X4dC-{display:flex;justify-content:space-between}";
styleInject(css_248z$k);

var css_248z$j = ".form-error-label-module_formErrorLabel__nDdXs{color:var(--c-error);cursor:default;font:var(--t-small);margin-bottom:var(--padding-xs);margin-top:var(--padding-xxs);transition:color var(--animation)}";
styleInject(css_248z$j);

class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            hasError: false,
        };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return this.props.fallback || React.createElement("h1", null, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.");
        }
        return this.props.children;
    }
}

/** MobX - (c) Michel Weststrate 2015, 2016 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$1 = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

















function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var OBFUSCATED_ERROR$$1 = "An invariant failed, however the error is obfuscated because this is an production build.";
var EMPTY_ARRAY$$1 = [];
Object.freeze(EMPTY_ARRAY$$1);
var EMPTY_OBJECT$$1 = {};
Object.freeze(EMPTY_OBJECT$$1);
function getGlobal$$1() {
    return typeof window !== "undefined" ? window : global;
}
function getNextId$$1() {
    return ++globalState$$1.mobxGuid;
}
function fail$$1(message) {
    invariant$$1(false, message);
    throw "X"; // unreachable
}
function invariant$$1(check, message) {
    if (!check)
        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR$$1));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated$$1(msg, thing) {
    if (process.env.NODE_ENV === "production")
        return false;
    if (thing) {
        return deprecated$$1("'" + msg + "', use '" + thing + "' instead.");
    }
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once$$1(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop$$1 = function () { };
function unique$$1(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function isObject$$1(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject$$1(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}
function makeNonEnumerable$$1(object, propNames) {
    for (var i = 0; i < propNames.length; i++) {
        addHiddenProp$$1(object, propNames[i], object[propNames[i]]);
    }
}
function addHiddenProp$$1(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp$$1(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable$$1(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable$$1(object, prop) {
    if (process.env.NODE_ENV !== "production" && !isPropertyConfigurable$$1(object, prop))
        fail$$1("Cannot make property '" + prop + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate$$1(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject$$1(x) && x[propName] === true;
    };
}
function areBothNaN$$1(a, b) {
    return typeof a === "number" && typeof b === "number" && isNaN(a) && isNaN(b);
}
function isES6Map$$1(thing) {
    if (getGlobal$$1().Map !== undefined && thing instanceof getGlobal$$1().Map)
        return true;
    return false;
}
function isES6Set$$1(thing) {
    return thing instanceof Set;
}
function getMapLikeKeys$$1(map) {
    if (isPlainObject$$1(map))
        return Object.keys(map);
    if (Array.isArray(map))
        return map.map(function (_a) {
            var _b = __read(_a, 1), key = _b[0];
            return key;
        });
    if (isES6Map$$1(map) || isObservableMap$$1(map))
        return iteratorToArray$$1(map.keys());
    return fail$$1("Cannot get keys from '" + map + "'");
}
// use Array.from in Mobx 5
function iteratorToArray$$1(it) {
    var res = [];
    while (true) {
        var r = it.next();
        if (r.done)
            break;
        res.push(r.value);
    }
    return res;
}
function primitiveSymbol$$1() {
    // es-disable-next-line
    return (typeof Symbol === "function" && Symbol.toPrimitive) || "@@toPrimitive";
}
function toPrimitive$$1(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}

function iteratorSymbol$$1() {
    return (typeof Symbol === "function" && Symbol.iterator) || "@@iterator";
}

function declareIterator$$1(prototType, iteratorFactory) {
    addHiddenFinalProp$$1(prototType, iteratorSymbol$$1(), iteratorFactory);
}
function makeIterable$$1(iterator) {
    iterator[iteratorSymbol$$1()] = self$1;
    return iterator;
}
function toStringTagSymbol$$1() {
    return (typeof Symbol === "function" && Symbol.toStringTag) || "@@toStringTag";
}
function self$1() {
    return this;
}

/**
 * Anything that can be used to _store_ state is an Atom in mobx. Atoms have two important jobs
 *
 * 1) detect when they are being _used_ and report this (using reportObserved). This allows mobx to make the connection between running functions and the data they used
 * 2) they should notify mobx whenever they have _changed_. This way mobx can re-run any functions (derivations) that are using this atom.
 */
var Atom$$1 = /** @class */ (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom$$1(name) {
        if (name === void 0) { name = "Atom@" + getNextId$$1(); }
        this.name = name;
        this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.isBeingObserved = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    Atom$$1.prototype.onBecomeUnobserved = function () {
        // noop
    };
    Atom$$1.prototype.onBecomeObserved = function () {
        /* noop */
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     * Returns true if there is currently a reactive context.
     */
    Atom$$1.prototype.reportObserved = function () {
        return reportObserved$$1(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    Atom$$1.prototype.reportChanged = function () {
        startBatch$$1();
        propagateChanged$$1(this);
        endBatch$$1();
    };
    Atom$$1.prototype.toString = function () {
        return this.name;
    };
    return Atom$$1;
}());
var isAtom$$1 = createInstanceofPredicate$$1("Atom", Atom$$1);
function createAtom$$1(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop$$1; }
    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop$$1; }
    var atom = new Atom$$1(name);
    onBecomeObserved$$1(atom, onBecomeObservedHandler);
    onBecomeUnobserved$$1(atom, onBecomeUnobservedHandler);
    return atom;
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual$$1(a, b);
}
function defaultComparer(a, b) {
    return areBothNaN$$1(a, b) || identityComparer(a, b);
}
var comparer$$1 = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer
};

var enumerableDescriptorCache = {};
var nonEnumerableDescriptorCache = {};
function createPropertyInitializerDescriptor(prop, enumerable) {
    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
    return (cache[prop] ||
        (cache[prop] = {
            configurable: true,
            enumerable: enumerable,
            get: function () {
                initializeInstance$$1(this);
                return this[prop];
            },
            set: function (value) {
                initializeInstance$$1(this);
                this[prop] = value;
            }
        }));
}
function initializeInstance$$1(target) {
    if (target.__mobxDidRunLazyInitializers === true)
        return;
    var decorators = target.__mobxDecorators;
    if (decorators) {
        addHiddenProp$$1(target, "__mobxDidRunLazyInitializers", true);
        for (var key in decorators) {
            var d = decorators[key];
            d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
        }
    }
}
function createPropDecorator$$1(propertyInitiallyEnumerable, propertyCreator) {
    return function decoratorFactory() {
        var decoratorArguments;
        var decorator = function decorate$$1(target, prop, descriptor, applyImmediately
        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
        // as the instance to apply the decorator to equals the target
        ) {
            if (applyImmediately === true) {
                propertyCreator(target, prop, descriptor, target, decoratorArguments);
                return null;
            }
            if (process.env.NODE_ENV !== "production" && !quacksLikeADecorator$$1(arguments))
                fail$$1("This function is a decorator, but it wasn't invoked like a decorator");
            if (!Object.prototype.hasOwnProperty.call(target, "__mobxDecorators")) {
                var inheritedDecorators = target.__mobxDecorators;
                addHiddenProp$$1(target, "__mobxDecorators", __assign$1({}, inheritedDecorators));
            }
            target.__mobxDecorators[prop] = {
                prop: prop,
                propertyCreator: propertyCreator,
                descriptor: descriptor,
                decoratorTarget: target,
                decoratorArguments: decoratorArguments
            };
            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
        };
        if (quacksLikeADecorator$$1(arguments)) {
            // @decorator
            decoratorArguments = EMPTY_ARRAY$$1;
            return decorator.apply(null, arguments);
        }
        else {
            // @decorator(args)
            decoratorArguments = Array.prototype.slice.call(arguments);
            return decorator;
        }
    };
}
function quacksLikeADecorator$$1(args) {
    return (((args.length === 2 || args.length === 3) && typeof args[1] === "string") ||
        (args.length === 4 && args[3] === true));
}

function deepEnhancer$$1(v, _, name) {
    // it is an observable already, done
    if (isObservable$$1(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable$$1.array(v, { name: name });
    if (isPlainObject$$1(v))
        return observable$$1.object(v, undefined, { name: name });
    if (isES6Map$$1(v))
        return observable$$1.map(v, { name: name });
    if (isES6Set$$1(v))
        return observable$$1.set(v, { name: name });
    return v;
}
function shallowEnhancer$$1(v, _, name) {
    if (v === undefined || v === null)
        return v;
    if (isObservableObject$$1(v) || isObservableArray$$1(v) || isObservableMap$$1(v) || isObservableSet$$1(v))
        return v;
    if (Array.isArray(v))
        return observable$$1.array(v, { name: name, deep: false });
    if (isPlainObject$$1(v))
        return observable$$1.object(v, undefined, { name: name, deep: false });
    if (isES6Map$$1(v))
        return observable$$1.map(v, { name: name, deep: false });
    if (isES6Set$$1(v))
        return observable$$1.set(v, { name: name, deep: false });
    return fail$$1(process.env.NODE_ENV !== "production" &&
        "The shallow modifier / decorator can only used in combination with arrays, objects, maps and sets");
}
function referenceEnhancer$$1(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer$$1(v, oldValue, name) {
    if (process.env.NODE_ENV !== "production" && isObservable$$1(v))
        throw "observable.struct should not be used with observable values";
    if (deepEqual$$1(v, oldValue))
        return oldValue;
    return v;
}

function createDecoratorForEnhancer$$1(enhancer) {
    var decorator = createPropDecorator$$1(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
        if (process.env.NODE_ENV !== "production") {
            invariant$$1(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + propertyName + "\"), use @computed instead.");
        }
        var initialValue = descriptor
            ? descriptor.initializer
                ? descriptor.initializer.call(target)
                : descriptor.value
            : undefined;
        defineObservableProperty$$1(target, propertyName, initialValue, enhancer);
    });
    var res = 
    // Extra process checks, as this happens during module initialization
    typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production"
        ? function observableDecorator() {
            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
            // and simply return the created prop decorator
            if (arguments.length < 2)
                return fail$$1("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
            return decorator.apply(null, arguments);
        }
        : decorator;
    res.enhancer = enhancer;
    return res;
}

// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions$$1 = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined
};
Object.freeze(defaultCreateObservableOptions$$1);
function assertValidOption(key) {
    if (!/^(deep|name|equals|defaultDecorator)$/.test(key))
        fail$$1("invalid option for (extend)observable: " + key);
}
function asCreateObservableOptions$$1(thing) {
    if (thing === null || thing === undefined)
        return defaultCreateObservableOptions$$1;
    if (typeof thing === "string")
        return { name: thing, deep: true };
    if (process.env.NODE_ENV !== "production") {
        if (typeof thing !== "object")
            return fail$$1("expected options object");
        Object.keys(thing).forEach(assertValidOption);
    }
    return thing;
}
function getEnhancerFromOptions(options) {
    return options.defaultDecorator
        ? options.defaultDecorator.enhancer
        : options.deep === false
            ? referenceEnhancer$$1
            : deepEnhancer$$1;
}
var deepDecorator$$1 = createDecoratorForEnhancer$$1(deepEnhancer$$1);
var shallowDecorator = createDecoratorForEnhancer$$1(shallowEnhancer$$1);
var refDecorator$$1 = createDecoratorForEnhancer$$1(referenceEnhancer$$1);
var refStructDecorator = createDecoratorForEnhancer$$1(refStructEnhancer$$1);
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (typeof arguments[1] === "string") {
        return deepDecorator$$1.apply(null, arguments);
    }
    // it is an observable already, done
    if (isObservable$$1(v))
        return v;
    // something that can be converted and mutated?
    var res = isPlainObject$$1(v)
        ? observable$$1.object(v, arg2, arg3)
        : Array.isArray(v)
            ? observable$$1.array(v, arg2)
            : isES6Map$$1(v)
                ? observable$$1.map(v, arg2)
                : isES6Set$$1(v)
                    ? observable$$1.set(v, arg2)
                    : v;
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    fail$$1(process.env.NODE_ENV !== "production" &&
        "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
}
var observableFactories = {
    box: function (value, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        var o = asCreateObservableOptions$$1(options);
        return new ObservableValue$$1(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    shallowBox: function (value, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowBox");
        deprecated$$1("observable.shallowBox", "observable.box(value, { deep: false })");
        return observable$$1.box(value, { name: name, deep: false });
    },
    array: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        var o = asCreateObservableOptions$$1(options);
        return new ObservableArray$$1(initialValues, getEnhancerFromOptions(o), o.name);
    },
    shallowArray: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowArray");
        deprecated$$1("observable.shallowArray", "observable.array(values, { deep: false })");
        return observable$$1.array(initialValues, { name: name, deep: false });
    },
    map: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        var o = asCreateObservableOptions$$1(options);
        return new ObservableMap$$1(initialValues, getEnhancerFromOptions(o), o.name);
    },
    shallowMap: function (initialValues, name) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("shallowMap");
        deprecated$$1("observable.shallowMap", "observable.map(values, { deep: false })");
        return observable$$1.map(initialValues, { name: name, deep: false });
    },
    set: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("set");
        var o = asCreateObservableOptions$$1(options);
        return new ObservableSet$$1(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function (props, decorators, options) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("object");
        var o = asCreateObservableOptions$$1(options);
        return extendObservable$$1({}, props, decorators, o);
    },
    shallowObject: function (props, name) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("shallowObject");
        deprecated$$1("observable.shallowObject", "observable.object(values, {}, { deep: false })");
        return observable$$1.object(props, {}, { name: name, deep: false });
    },
    ref: refDecorator$$1,
    shallow: shallowDecorator,
    deep: deepDecorator$$1,
    struct: refStructDecorator
};
var observable$$1 = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable$$1[name] = observableFactories[name]); });
function incorrectlyUsedAsDecorator(methodName) {
    fail$$1(
    // process.env.NODE_ENV !== "production" &&
    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

var computedDecorator$$1 = createPropDecorator$$1(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
    var get$$1 = descriptor.get, set$$1 = descriptor.set; // initialValue is the descriptor for get / set props
    // Optimization: faster on decorator target or instance? Assuming target
    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
    // Forcing instance now, fixes hot reloadig issues on React Native:
    var options = decoratorArgs[0] || {};
    defineComputedProperty$$1(instance, propertyName, __assign$1({ get: get$$1, set: set$$1 }, options));
});
var computedStructDecorator = computedDecorator$$1({ equals: comparer$$1.structural });
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed$$1 = function computed$$1(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        // @computed
        return computedDecorator$$1.apply(null, arguments);
    }
    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
        // @computed({ options })
        return computedDecorator$$1.apply(null, arguments);
    }
    // computed(expr, options?)
    if (process.env.NODE_ENV !== "production") {
        invariant$$1(typeof arg1 === "function", "First argument to `computed` should be an expression.");
        invariant$$1(arguments.length < 3, "Computed takes one or two arguments if used as function");
    }
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.get = arg1;
    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
    opts.name = opts.name || arg1.name || ""; /* for generated name */
    return new ComputedValue$$1(opts);
};
computed$$1.struct = computedStructDecorator;

function createAction$$1(actionName, fn) {
    if (process.env.NODE_ENV !== "production") {
        invariant$$1(typeof fn === "function", "`action` can only be invoked on functions");
        if (typeof actionName !== "string" || !actionName)
            fail$$1("actions should have valid names, got: '" + actionName + "'");
    }
    var res = function () {
        return executeAction$$1(actionName, fn, this, arguments);
    };
    res.isMobxAction = true;
    return res;
}
function executeAction$$1(actionName, fn, scope, args) {
    var runInfo = startAction(actionName, fn, scope, args);
    var shouldSupressReactionError = true;
    try {
        var res = fn.apply(scope, args);
        shouldSupressReactionError = false;
        return res;
    }
    finally {
        if (shouldSupressReactionError) {
            globalState$$1.suppressReactionErrors = shouldSupressReactionError;
            endAction(runInfo);
            globalState$$1.suppressReactionErrors = false;
        }
        else {
            endAction(runInfo);
        }
    }
}
function startAction(actionName, fn, scope, args) {
    var notifySpy = isSpyEnabled$$1() && !!actionName;
    var startTime = 0;
    if (notifySpy) {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart$$1({
            type: "action",
            name: actionName,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart$$1();
    startBatch$$1();
    var prevAllowStateChanges = allowStateChangesStart$$1(true);
    return {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        notifySpy: notifySpy,
        startTime: startTime
    };
}
function endAction(runInfo) {
    allowStateChangesEnd$$1(runInfo.prevAllowStateChanges);
    endBatch$$1();
    untrackedEnd$$1(runInfo.prevDerivation);
    if (runInfo.notifySpy)
        spyReportEnd$$1({ time: Date.now() - runInfo.startTime });
}
function allowStateChangesStart$$1(allowStateChanges$$1) {
    var prev = globalState$$1.allowStateChanges;
    globalState$$1.allowStateChanges = allowStateChanges$$1;
    return prev;
}
function allowStateChangesEnd$$1(prev) {
    globalState$$1.allowStateChanges = prev;
}

var ObservableValue$$1 = /** @class */ (function (_super) {
    __extends(ObservableValue$$1, _super);
    function ObservableValue$$1(value, enhancer, name, notifySpy, equals) {
        if (name === void 0) { name = "ObservableValue@" + getNextId$$1(); }
        if (notifySpy === void 0) { notifySpy = true; }
        if (equals === void 0) { equals = comparer$$1.default; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.name = name;
        _this.equals = equals;
        _this.hasUnreportedChange = false;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled$$1()) {
            // only notify spy if this is a stand-alone observable
            spyReport$$1({ type: "create", name: _this.name, newValue: "" + _this.value });
        }
        return _this;
    }
    ObservableValue$$1.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue$$1.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== globalState$$1.UNCHANGED) {
            var notifySpy = isSpyEnabled$$1();
            if (notifySpy) {
                spyReportStart$$1({
                    type: "update",
                    name: this.name,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy)
                spyReportEnd$$1();
        }
    };
    ObservableValue$$1.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed$$1(this);
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return globalState$$1.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.equals(this.value, newValue) ? globalState$$1.UNCHANGED : newValue;
    };
    ObservableValue$$1.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners$$1(this)) {
            notifyListeners$$1(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue$$1.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue$$1.prototype.intercept = function (handler) {
        return registerInterceptor$$1(this, handler);
    };
    ObservableValue$$1.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener$$1(this, listener);
    };
    ObservableValue$$1.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue$$1.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue$$1.prototype.valueOf = function () {
        return toPrimitive$$1(this.get());
    };
    return ObservableValue$$1;
}(Atom$$1));
ObservableValue$$1.prototype[primitiveSymbol$$1()] = ObservableValue$$1.prototype.valueOf;
createInstanceofPredicate$$1("ObservableValue", ObservableValue$$1);

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue$$1 = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce a new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue$$1(options) {
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isBeingObserved = false;
        this.isPendingUnobservation = false;
        this.observers = [];
        this.observersIndexes = {};
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId$$1();
        this.value = new CaughtException$$1(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode$$1.NONE;
        if (process.env.NODE_ENV !== "production" && !options.get)
            return fail$$1("missing option for computed: get");
        this.derivation = options.get;
        this.name = options.name || "ComputedValue@" + getNextId$$1();
        if (options.set)
            this.setter = createAction$$1(this.name + "-setter", options.set);
        this.equals =
            options.equals ||
                (options.compareStructural || options.struct
                    ? comparer$$1.structural
                    : comparer$$1.default);
        this.scope = options.context;
        this.requiresReaction = !!options.requiresReaction;
        this.keepAlive = !!options.keepAlive;
    }
    ComputedValue$$1.prototype.onBecomeStale = function () {
        propagateMaybeChanged$$1(this);
    };
    ComputedValue$$1.prototype.onBecomeUnobserved = function () { };
    ComputedValue$$1.prototype.onBecomeObserved = function () { };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue$$1.prototype.get = function () {
        if (this.isComputing)
            fail$$1("Cycle detected in computation " + this.name + ": " + this.derivation);
        if (globalState$$1.inBatch === 0 && this.observers.length === 0 && !this.keepAlive) {
            if (shouldCompute$$1(this)) {
                this.warnAboutUntrackedRead();
                startBatch$$1(); // See perf test 'computed memoization'
                this.value = this.computeValue(false);
                endBatch$$1();
            }
        }
        else {
            reportObserved$$1(this);
            if (shouldCompute$$1(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed$$1(this);
        }
        var result = this.value;
        if (isCaughtException$$1(result))
            throw result.cause;
        return result;
    };
    ComputedValue$$1.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException$$1(res))
            throw res.cause;
        return res;
    };
    ComputedValue$$1.prototype.set = function (value) {
        if (this.setter) {
            invariant$$1(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant$$1(false, process.env.NODE_ENV !== "production" &&
                "[ComputedValue '" + this.name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue$$1.prototype.trackAndCompute = function () {
        if (isSpyEnabled$$1()) {
            spyReport$$1({
                object: this.scope,
                type: "compute",
                name: this.name
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = this.computeValue(true);
        var changed = wasSuspended ||
            isCaughtException$$1(oldValue) ||
            isCaughtException$$1(newValue) ||
            !this.equals(oldValue, newValue);
        if (changed) {
            this.value = newValue;
        }
        return changed;
    };
    ComputedValue$$1.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState$$1.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction$$1(this, this.derivation, this.scope);
        }
        else {
            if (globalState$$1.disableErrorBoundaries === true) {
                res = this.derivation.call(this.scope);
            }
            else {
                try {
                    res = this.derivation.call(this.scope);
                }
                catch (e) {
                    res = new CaughtException$$1(e);
                }
            }
        }
        globalState$$1.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue$$1.prototype.suspend = function () {
        if (!this.keepAlive) {
            clearObserving$$1(this);
            this.value = undefined; // don't hold on to computed value!
        }
    };
    ComputedValue$$1.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun$$1(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart$$1();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd$$1(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue$$1.prototype.warnAboutUntrackedRead = function () {
        if (process.env.NODE_ENV === "production")
            return;
        if (this.requiresReaction === true) {
            fail$$1("[mobx] Computed value " + this.name + " is read outside a reactive context");
        }
        if (this.isTracing !== TraceMode$$1.NONE) {
            console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
        }
        if (globalState$$1.computedRequiresReaction) {
            console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
        }
    };
    ComputedValue$$1.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue$$1.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue$$1.prototype.valueOf = function () {
        return toPrimitive$$1(this.get());
    };
    return ComputedValue$$1;
}());
ComputedValue$$1.prototype[primitiveSymbol$$1()] = ComputedValue$$1.prototype.valueOf;
var isComputedValue$$1 = createInstanceofPredicate$$1("ComputedValue", ComputedValue$$1);

var IDerivationState;
(function (IDerivationState$$1) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState$$1[IDerivationState$$1["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState$$1[IDerivationState$$1["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState$$1[IDerivationState$$1["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState$$1[IDerivationState$$1["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode$$1;
(function (TraceMode$$1) {
    TraceMode$$1[TraceMode$$1["NONE"] = 0] = "NONE";
    TraceMode$$1[TraceMode$$1["LOG"] = 1] = "LOG";
    TraceMode$$1[TraceMode$$1["BREAK"] = 2] = "BREAK";
})(TraceMode$$1 || (TraceMode$$1 = {}));
var CaughtException$$1 = /** @class */ (function () {
    function CaughtException$$1(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException$$1;
}());
function isCaughtException$$1(e) {
    return e instanceof CaughtException$$1;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute$$1(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            var prevUntracked = untrackedStart$$1(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue$$1(obj)) {
                    if (globalState$$1.disableErrorBoundaries) {
                        obj.get();
                    }
                    else {
                        try {
                            obj.get();
                        }
                        catch (e) {
                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                            untrackedEnd$$1(prevUntracked);
                            return true;
                        }
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd$$1(prevUntracked);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0$$1(derivation);
            untrackedEnd$$1(prevUntracked);
            return false;
        }
    }
}
function checkIfStateModificationsAreAllowed$$1(atom) {
    var hasObservers$$1 = atom.observers.length > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState$$1.computationDepth > 0 && hasObservers$$1)
        fail$$1(process.env.NODE_ENV !== "production" &&
            "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState$$1.allowStateChanges && (hasObservers$$1 || globalState$$1.enforceActions === "strict"))
        fail$$1(process.env.NODE_ENV !== "production" &&
            (globalState$$1.enforceActions
                ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: "
                : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") +
                atom.name);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction$$1(derivation, f, context) {
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0$$1(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState$$1.runId;
    var prevTracking = globalState$$1.trackingDerivation;
    globalState$$1.trackingDerivation = derivation;
    var result;
    if (globalState$$1.disableErrorBoundaries === true) {
        result = f.call(context);
    }
    else {
        try {
            result = f.call(context);
        }
        catch (e) {
            result = new CaughtException$$1(e);
        }
    }
    globalState$$1.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    return result;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver$$1(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver$$1(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving$$1(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver$$1(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked$$1(action$$1) {
    var prev = untrackedStart$$1();
    var res = action$$1();
    untrackedEnd$$1(prev);
    return res;
}
function untrackedStart$$1() {
    var prev = globalState$$1.trackingDerivation;
    globalState$$1.trackingDerivation = null;
    return prev;
}
function untrackedEnd$$1(prev) {
    globalState$$1.trackingDerivation = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0$$1(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}
var MobXGlobals$$1 = /** @class */ (function () {
    function MobXGlobals$$1() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         *
         * N.B: this version is unrelated to the package version of MobX, and is only the version of the
         * internal state storage of MobX, and can be the same across many different package versions
         */
        this.version = 5;
        /**
         * globally unique token to signal unchanged
         */
        this.UNCHANGED = {};
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.enforceActions = false;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
        /**
         * Warn if computed values are accessed outside a reactive context
         */
        this.computedRequiresReaction = false;
        /*
         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
         * the stack when an exception occurs while debugging.
         */
        this.disableErrorBoundaries = false;
        /*
         * If true, we are already handling an exception in an action. Any errors in reactions should be supressed, as
         * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
         */
        this.suppressReactionErrors = false;
    }
    return MobXGlobals$$1;
}());
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState$$1 = (function () {
    var global = getGlobal$$1();
    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals)
        canMergeGlobalState = false;
    if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals$$1().version)
        canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        setTimeout(function () {
            if (!isolateCalled) {
                fail$$1("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
            }
        }, 1);
        return new MobXGlobals$$1();
    }
    else if (global.__mobxGlobals) {
        global.__mobxInstanceCount += 1;
        if (!global.__mobxGlobals.UNCHANGED)
            global.__mobxGlobals.UNCHANGED = {}; // make merge backward compatible
        return global.__mobxGlobals;
    }
    else {
        global.__mobxInstanceCount = 1;
        return (global.__mobxGlobals = new MobXGlobals$$1());
    }
})();
function isolateGlobalState$$1() {
    if (globalState$$1.pendingReactions.length ||
        globalState$$1.inBatch ||
        globalState$$1.isRunningReactions)
        fail$$1("isolateGlobalState should be called before MobX is running any reactions");
    isolateCalled = true;
    if (canMergeGlobalState) {
        if (--getGlobal$$1().__mobxInstanceCount === 0)
            getGlobal$$1().__mobxGlobals = undefined;
        globalState$$1 = new MobXGlobals$$1();
    }
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver$$1(observable$$1, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    var l = observable$$1.observers.length;
    if (l) {
        // because object assignment is relatively expensive, let's not store data about index 0.
        observable$$1.observersIndexes[node.__mapid] = l;
    }
    observable$$1.observers[l] = node;
    if (observable$$1.lowestObserverState > node.dependenciesState)
        observable$$1.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver$$1(observable$$1, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    if (observable$$1.observers.length === 1) {
        // deleting last observer
        observable$$1.observers.length = 0;
        queueForUnobservation$$1(observable$$1);
    }
    else {
        // deleting from _observersIndexes is straight forward, to delete from _observers, let's swap `node` with last element
        var list = observable$$1.observers;
        var map = observable$$1.observersIndexes;
        var filler = list.pop(); // get last element, which should fill the place of `node`, so the array doesn't have holes
        if (filler !== node) {
            // otherwise node was the last element, which already got removed from array
            var index = map[node.__mapid] || 0; // getting index of `node`. this is the only place we actually use map.
            if (index) {
                // map store all indexes but 0, see comment in `addObserver`
                map[filler.__mapid] = index;
            }
            else {
                delete map[filler.__mapid];
            }
            list[index] = filler;
        }
        delete map[node.__mapid];
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation$$1(observable$$1) {
    if (observable$$1.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable$$1.isPendingUnobservation = true;
        globalState$$1.pendingUnobservations.push(observable$$1);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch$$1() {
    globalState$$1.inBatch++;
}
function endBatch$$1() {
    if (--globalState$$1.inBatch === 0) {
        runReactions$$1();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState$$1.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable$$1 = list[i];
            observable$$1.isPendingUnobservation = false;
            if (observable$$1.observers.length === 0) {
                if (observable$$1.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable$$1.isBeingObserved = false;
                    observable$$1.onBecomeUnobserved();
                }
                if (observable$$1 instanceof ComputedValue$$1) {
                    // computed values are automatically teared down when the last observer leaves
                    // this process happens recursively, this computed might be the last observabe of another, etc..
                    observable$$1.suspend();
                }
            }
        }
        globalState$$1.pendingUnobservations = [];
    }
}
function reportObserved$$1(observable$$1) {
    var derivation = globalState$$1.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable$$1.lastAccessedBy) {
            observable$$1.lastAccessedBy = derivation.runId;
            derivation.newObserving[derivation.unboundDepsCount++] = observable$$1;
            if (!observable$$1.isBeingObserved) {
                observable$$1.isBeingObserved = true;
                observable$$1.onBecomeObserved();
            }
        }
        return true;
    }
    else if (observable$$1.observers.length === 0 && globalState$$1.inBatch > 0) {
        queueForUnobservation$$1(observable$$1);
    }
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged$$1(observable$$1) {
    // invariantLOS(observable, "changed start");
    if (observable$$1.lowestObserverState === IDerivationState.STALE)
        return;
    observable$$1.lowestObserverState = IDerivationState.STALE;
    var observers = observable$$1.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode$$1.NONE) {
                logTraceInfo(d, observable$$1);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    }
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed$$1(observable$$1) {
    // invariantLOS(observable, "confirmed start");
    if (observable$$1.lowestObserverState === IDerivationState.STALE)
        return;
    observable$$1.lowestObserverState = IDerivationState.STALE;
    var observers = observable$$1.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable$$1.lowestObserverState = IDerivationState.UP_TO_DATE;
    }
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged$$1(observable$$1) {
    // invariantLOS(observable, "maybe start");
    if (observable$$1.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable$$1.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    var observers = observable$$1.observers;
    var i = observers.length;
    while (i--) {
        var d = observers[i];
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode$$1.NONE) {
                logTraceInfo(d, observable$$1);
            }
            d.onBecomeStale();
        }
    }
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable$$1) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable$$1.name + "'");
    if (derivation.isTracing === TraceMode$$1.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree$$1(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable$$1.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue$$1 ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var Reaction$$1 = /** @class */ (function () {
    function Reaction$$1(name, onInvalidate, errorHandler) {
        if (name === void 0) { name = "Reaction@" + getNextId$$1(); }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.errorHandler = errorHandler;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId$$1();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode$$1.NONE;
    }
    Reaction$$1.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction$$1.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState$$1.pendingReactions.push(this);
            runReactions$$1();
        }
    };
    Reaction$$1.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction$$1.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch$$1();
            this._isScheduled = false;
            if (shouldCompute$$1(this)) {
                this._isTrackPending = true;
                try {
                    this.onInvalidate();
                    if (this._isTrackPending && isSpyEnabled$$1()) {
                        // onInvalidate didn't trigger track right away..
                        spyReport$$1({
                            name: this.name,
                            type: "scheduled-reaction"
                        });
                    }
                }
                catch (e) {
                    this.reportExceptionInDerivation(e);
                }
            }
            endBatch$$1();
        }
    };
    Reaction$$1.prototype.track = function (fn) {
        startBatch$$1();
        var notify = isSpyEnabled$$1();
        var startTime;
        if (notify) {
            startTime = Date.now();
            spyReportStart$$1({
                name: this.name,
                type: "reaction"
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction$$1(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving$$1(this);
        }
        if (isCaughtException$$1(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify) {
            spyReportEnd$$1({
                time: Date.now() - startTime
            });
        }
        endBatch$$1();
    };
    Reaction$$1.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        if (globalState$$1.disableErrorBoundaries)
            throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this + "'";
        if (globalState$$1.suppressReactionErrors) {
            console.warn("[mobx] (error in reaction '" + this.name + "' suppressed, fix error of causing action below)"); // prettier-ignore
        }
        else {
            console.error(message, error);
            /** If debugging brought you here, please, read the above message :-). Tnx! */
        }
        if (isSpyEnabled$$1()) {
            spyReport$$1({
                type: "error",
                name: this.name,
                message: message,
                error: "" + error
            });
        }
        globalState$$1.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction$$1.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch$$1();
                clearObserving$$1(this);
                endBatch$$1();
            }
        }
    };
    Reaction$$1.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r.$mobx = this;
        return r;
    };
    Reaction$$1.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction$$1.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace$$1(this, enterBreakPoint);
    };
    return Reaction$$1;
}());
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions$$1() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState$$1.inBatch > 0 || globalState$$1.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState$$1.isRunningReactions = true;
    var allReactions = globalState$$1.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState$$1.isRunningReactions = false;
}
var isReaction$$1 = createInstanceofPredicate$$1("Reaction", Reaction$$1);
function setReactionScheduler$$1(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function isSpyEnabled$$1() {
    return !!globalState$$1.spyListeners.length;
}
function spyReport$$1(event) {
    if (!globalState$$1.spyListeners.length)
        return;
    var listeners = globalState$$1.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart$$1(event) {
    var change = __assign$1({}, event, { spyReportStart: true });
    spyReport$$1(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd$$1(change) {
    if (change)
        spyReport$$1(__assign$1({}, change, { spyReportEnd: true }));
    else
        spyReport$$1(END_EVENT);
}
function spy$$1(listener) {
    globalState$$1.spyListeners.push(listener);
    return once$$1(function () {
        globalState$$1.spyListeners = globalState$$1.spyListeners.filter(function (l) { return l !== listener; });
    });
}

function dontReassignFields() {
    fail$$1(process.env.NODE_ENV !== "production" && "@action fields are not reassignable");
}
function namedActionDecorator$$1(name) {
    return function (target, prop, descriptor) {
        if (descriptor) {
            if (process.env.NODE_ENV !== "production" && descriptor.get !== undefined) {
                return fail$$1("@action cannot be used with getters");
            }
            // babel / typescript
            // @action method() { }
            if (descriptor.value) {
                // typescript
                return {
                    value: createAction$$1(name, descriptor.value),
                    enumerable: false,
                    configurable: true,
                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
                };
            }
            // babel only: @action method = () => {}
            var initializer_1 = descriptor.initializer;
            return {
                enumerable: false,
                configurable: true,
                writable: true,
                initializer: function () {
                    // N.B: we can't immediately invoke initializer; this would be wrong
                    return createAction$$1(name, initializer_1.call(this));
                }
            };
        }
        // bound instance methods
        return actionFieldDecorator$$1(name).apply(this, arguments);
    };
}
function actionFieldDecorator$$1(name) {
    // Simple property that writes on first invocation to the current instance
    return function (target, prop, descriptor) {
        Object.defineProperty(target, prop, {
            configurable: true,
            enumerable: false,
            get: function () {
                return undefined;
            },
            set: function (value) {
                addHiddenProp$$1(this, prop, action$$1(name, value));
            }
        });
    };
}
function boundActionDecorator$$1(target, propertyName, descriptor, applyToInstance) {
    if (applyToInstance === true) {
        defineBoundAction$$1(target, propertyName, descriptor.value);
        return null;
    }
    if (descriptor) {
        // if (descriptor.value)
        // Typescript / Babel: @action.bound method() { }
        // also: babel @action.bound method = () => {}
        return {
            configurable: true,
            enumerable: false,
            get: function () {
                defineBoundAction$$1(this, propertyName, descriptor.value || descriptor.initializer.call(this));
                return this[propertyName];
            },
            set: dontReassignFields
        };
    }
    // field decorator Typescript @action.bound method = () => {}
    return {
        enumerable: false,
        configurable: true,
        set: function (v) {
            defineBoundAction$$1(this, propertyName, v);
        },
        get: function () {
            return undefined;
        }
    };
}

var action$$1 = function action$$1(arg1, arg2, arg3, arg4) {
    // action(fn() {})
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction$$1(arg1.name || "<unnamed action>", arg1);
    // action("name", fn() {})
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction$$1(arg1, arg2);
    // @action("name") fn() {}
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator$$1(arg1);
    // @action fn() {}
    if (arg4 === true) {
        // apply to instance immediately
        arg1[arg2] = createAction$$1(arg1.name || arg2, arg3.value);
    }
    else {
        return namedActionDecorator$$1(arg2).apply(null, arguments);
    }
};
action$$1.bound = boundActionDecorator$$1;
function isAction$$1(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction$$1(target, propertyName, fn) {
    addHiddenProp$$1(target, propertyName, createAction$$1(propertyName, fn.bind(target)));
}

/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */
function autorun$$1(view, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT$$1; }
    if (process.env.NODE_ENV !== "production") {
        invariant$$1(typeof view === "function", "Autorun expects a function as first argument");
        invariant$$1(isAction$$1(view) === false, "Autorun does not accept actions since actions are untrackable");
    }
    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId$$1();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction$$1;
    if (runSync) {
        // normal autorun
        reaction$$1 = new Reaction$$1(name, function () {
            this.track(reactionRunner);
        }, opts.onError);
    }
    else {
        var scheduler_1 = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled_1 = false;
        reaction$$1 = new Reaction$$1(name, function () {
            if (!isScheduled_1) {
                isScheduled_1 = true;
                scheduler_1(function () {
                    isScheduled_1 = false;
                    if (!reaction$$1.isDisposed)
                        reaction$$1.track(reactionRunner);
                });
            }
        }, opts.onError);
    }
    function reactionRunner() {
        view(reaction$$1);
    }
    reaction$$1.schedule();
    return reaction$$1.getDisposer();
}
var run = function (f) { return f(); };
function createSchedulerFromOptions(opts) {
    return opts.scheduler
        ? opts.scheduler
        : opts.delay
            ? function (f) { return setTimeout(f, opts.delay); }
            : run;
}

function onBecomeObserved$$1(thing, arg2, arg3) {
    return interceptHook("onBecomeObserved", thing, arg2, arg3);
}
function onBecomeUnobserved$$1(thing, arg2, arg3) {
    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg2 === "string" ? getAtom$$1(thing, arg2) : getAtom$$1(thing);
    var cb = typeof arg2 === "string" ? arg3 : arg2;
    var orig = atom[hook];
    if (typeof orig !== "function")
        return fail$$1(process.env.NODE_ENV !== "production" && "Not an atom that can be (un)observed");
    atom[hook] = function () {
        orig.call(this);
        cb.call(this);
    };
    return function () {
        atom[hook] = orig;
    };
}

function configure$$1(options) {
    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, disableErrorBoundaries = options.disableErrorBoundaries, arrayBuffer = options.arrayBuffer, reactionScheduler = options.reactionScheduler;
    if (options.isolateGlobalState === true) {
        isolateGlobalState$$1();
    }
    if (enforceActions !== undefined) {
        if (typeof enforceActions === "boolean" || enforceActions === "strict")
            deprecated$$1("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
        var ea = void 0;
        switch (enforceActions) {
            case true:
            case "observed":
                ea = true;
                break;
            case false:
            case "never":
                ea = false;
                break;
            case "strict":
            case "always":
                ea = "strict";
                break;
            default:
                fail$$1("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
        }
        globalState$$1.enforceActions = ea;
        globalState$$1.allowStateChanges = ea === true || ea === "strict" ? false : true;
    }
    if (computedRequiresReaction !== undefined) {
        globalState$$1.computedRequiresReaction = !!computedRequiresReaction;
    }
    if (disableErrorBoundaries !== undefined) {
        if (disableErrorBoundaries === true)
            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors if this is on.");
        globalState$$1.disableErrorBoundaries = !!disableErrorBoundaries;
    }
    if (typeof arrayBuffer === "number") {
        reserveArrayBuffer$$1(arrayBuffer);
    }
    if (reactionScheduler) {
        setReactionScheduler$$1(reactionScheduler);
    }
}
function extendObservable$$1(target, properties, decorators, options) {
    if (process.env.NODE_ENV !== "production") {
        invariant$$1(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
        invariant$$1(typeof target === "object", "'extendObservable' expects an object as first argument");
        invariant$$1(!isObservableMap$$1(target), "'extendObservable' should not be used on maps, use map.merge instead");
        invariant$$1(!isObservable$$1(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
        if (decorators)
            for (var key in decorators)
                if (!(key in properties))
                    fail$$1("Trying to declare a decorator for unspecified property '" + key + "'");
    }
    options = asCreateObservableOptions$$1(options);
    var defaultDecorator = options.defaultDecorator || (options.deep === false ? refDecorator$$1 : deepDecorator$$1);
    initializeInstance$$1(target);
    asObservableObject$$1(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
    startBatch$$1();
    try {
        for (var key in properties) {
            var descriptor = Object.getOwnPropertyDescriptor(properties, key);
            if (process.env.NODE_ENV !== "production") {
                if (Object.getOwnPropertyDescriptor(target, key))
                    fail$$1("'extendObservable' can only be used to introduce new properties. Use 'set' or 'decorate' instead. The property '" + key + "' already exists on '" + target + "'");
                if (isComputed$$1(descriptor.value))
                    fail$$1("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
            }
            var decorator = decorators && key in decorators
                ? decorators[key]
                : descriptor.get
                    ? computedDecorator$$1
                    : defaultDecorator;
            if (process.env.NODE_ENV !== "production" && typeof decorator !== "function")
                return fail$$1("Not a valid decorator for '" + key + "', got: " + decorator);
            var resultDescriptor = decorator(target, key, descriptor, true);
            if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
            )
                Object.defineProperty(target, key, resultDescriptor);
        }
    }
    finally {
        endBatch$$1();
    }
    return target;
}

function getDependencyTree$$1(thing, property) {
    return nodeToDependencyTree(getAtom$$1(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique$$1(node.observing).map(nodeToDependencyTree);
    return result;
}

function _isComputed$$1(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject$$1(value) === false)
            return false;
        if (!value.$mobx.values[property])
            return false;
        var atom = getAtom$$1(value, property);
        return isComputedValue$$1(atom);
    }
    return isComputedValue$$1(value);
}
function isComputed$$1(value) {
    if (arguments.length > 1)
        return fail$$1(process.env.NODE_ENV !== "production" &&
            "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isComputed$$1(value);
}

function _isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (process.env.NODE_ENV !== "production" &&
            (isObservableMap$$1(value) || isObservableArray$$1(value)))
            return fail$$1("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
        if (isObservableObject$$1(value)) {
            var o = value.$mobx;
            return o.values && !!o.values[property];
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject$$1(value) ||
        !!value.$mobx ||
        isAtom$$1(value) ||
        isReaction$$1(value) ||
        isComputedValue$$1(value));
}
function isObservable$$1(value) {
    if (arguments.length !== 1)
        fail$$1(process.env.NODE_ENV !== "production" &&
            "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isObservable(value);
}

function trace$$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail$$1(process.env.NODE_ENV !== "production" &&
            "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode$$1.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode$$1.BREAK : TraceMode$$1.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState$$1.trackingDerivation;
        case 1:
            return getAtom$$1(args[0]);
        case 2:
            return getAtom$$1(args[0], args[1]);
    }
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction$$1(action$$1, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch$$1();
    try {
        return action$$1.apply(thisArg);
    }
    finally {
        endBatch$$1();
    }
}

function hasInterceptors$$1(interceptable) {
    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
}
function registerInterceptor$$1(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once$$1(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange$$1(interceptable, change) {
    var prevU = untrackedStart$$1();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant$$1(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd$$1(prevU);
    }
}

function hasListeners$$1(listenable) {
    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
}
function registerListener$$1(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once$$1(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners$$1(listenable, change) {
    var prevU = untrackedStart$$1();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd$$1(prevU);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
// Detects bug in safari 9.1.1 (or iOS 9 safari mobile). See #364
var safariPrototypeSetterInheritanceBug = (function () {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function () {
            v = true;
        }
    });
    Object.create(p)["0"] = 1;
    return v === false;
})();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray$$1 = /** @class */ (function () {
    function StubArray$$1() {
    }
    return StubArray$$1;
}());
function inherit(ctor, proto) {
    if (typeof Object["setPrototypeOf"] !== "undefined") {
        Object["setPrototypeOf"](ctor.prototype, proto);
    }
    else if (typeof ctor.prototype.__proto__ !== "undefined") {
        ctor.prototype.__proto__ = proto;
    }
    else {
        ctor["prototype"] = proto;
    }
}
inherit(StubArray$$1, Array.prototype);
// Weex freeze Array.prototype
// Make them writeable and configurable in prototype chain
// https://github.com/alibaba/weex/pull/1529
if (Object.isFrozen(Array)) {
    
    [
        "constructor",
        "push",
        "shift",
        "concat",
        "pop",
        "unshift",
        "replace",
        "find",
        "findIndex",
        "splice",
        "reverse",
        "sort"
    ].forEach(function (key) {
        Object.defineProperty(StubArray$$1.prototype, key, {
            configurable: true,
            writable: true,
            value: Array.prototype[key]
        });
    });
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, array, owned) {
        this.array = array;
        this.owned = owned;
        this.values = [];
        this.lastKnownLength = 0;
        this.atom = new Atom$$1(name || "ObservableArray@" + getNextId$$1());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values$$1) {
        if (this.dehancer !== undefined && values$$1.length > 0)
            return values$$1.map(this.dehancer);
        return values$$1;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor$$1(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.array,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener$$1(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    // adds / removes the necessary numeric properties to this object
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed. Did you use peek() to change it?");
        this.lastKnownLength += delta;
        if (delta > 0 && oldLength + delta + 1 > OBSERVABLE_ARRAY_BUFFER_SIZE)
            reserveArrayBuffer$$1(oldLength + delta + 1);
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed$$1(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = EMPTY_ARRAY$$1;
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                object: this.array,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY$$1;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems =
            newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
        var lengthDelta = newItems.length - deleteCount;
        this.updateArrayLength(length, lengthDelta); // create or remove new entries
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        var _a;
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled$$1();
        var notify = hasListeners$$1(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        if (notifySpy)
            spyReportStart$$1(__assign$1({}, change, { name: this.atom.name }));
        this.atom.reportChanged();
        if (notify)
            notifyListeners$$1(this, change);
        if (notifySpy)
            spyReportEnd$$1();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled$$1();
        var notify = hasListeners$$1(this);
        var change = notify || notifySpy
            ? {
                object: this.array,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy)
            spyReportStart$$1(__assign$1({}, change, { name: this.atom.name }));
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners$$1(this, change);
        if (notifySpy)
            spyReportEnd$$1();
    };
    return ObservableArrayAdministration;
}());
var ObservableArray$$1 = /** @class */ (function (_super) {
    __extends(ObservableArray$$1, _super);
    function ObservableArray$$1(initialValues, enhancer, name, owned) {
        if (name === void 0) { name = "ObservableArray@" + getNextId$$1(); }
        if (owned === void 0) { owned = false; }
        var _this = _super.call(this) || this;
        var adm = new ObservableArrayAdministration(name, enhancer, _this, owned);
        addHiddenFinalProp$$1(_this, "$mobx", adm);
        if (initialValues && initialValues.length) {
            var prev = allowStateChangesStart$$1(true);
            _this.spliceWithArray(0, 0, initialValues);
            allowStateChangesEnd$$1(prev);
        }
        if (safariPrototypeSetterInheritanceBug) {
            // Seems that Safari won't use numeric prototype setter untill any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(adm.array, "0", ENTRY_0);
        }
        return _this;
    }
    ObservableArray$$1.prototype.intercept = function (handler) {
        return this.$mobx.intercept(handler);
    };
    ObservableArray$$1.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        return this.$mobx.observe(listener, fireImmediately);
    };
    ObservableArray$$1.prototype.clear = function () {
        return this.splice(0);
    };
    ObservableArray$$1.prototype.concat = function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        this.$mobx.atom.reportObserved();
        return Array.prototype.concat.apply(this.peek(), arrays.map(function (a) { return (isObservableArray$$1(a) ? a.peek() : a); }));
    };
    ObservableArray$$1.prototype.replace = function (newItems) {
        return this.$mobx.spliceWithArray(0, this.$mobx.values.length, newItems);
    };
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    ObservableArray$$1.prototype.toJS = function () {
        return this.slice();
    };
    ObservableArray$$1.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toJS();
    };
    ObservableArray$$1.prototype.peek = function () {
        this.$mobx.atom.reportObserved();
        return this.$mobx.dehanceValues(this.$mobx.values);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
    ObservableArray$$1.prototype.find = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        if (arguments.length === 3)
            deprecated$$1("The array.find fromIndex argument to find will not be supported anymore in the next major");
        var idx = this.findIndex.apply(this, arguments);
        return idx === -1 ? undefined : this.get(idx);
    };
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
    ObservableArray$$1.prototype.findIndex = function (predicate, thisArg, fromIndex) {
        if (fromIndex === void 0) { fromIndex = 0; }
        if (arguments.length === 3)
            deprecated$$1("The array.findIndex fromIndex argument to find will not be supported anymore in the next major");
        var items = this.peek(), l = items.length;
        for (var i = fromIndex; i < l; i++)
            if (predicate.call(thisArg, items[i], i, this))
                return i;
        return -1;
    };
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    ObservableArray$$1.prototype.splice = function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return this.$mobx.spliceWithArray(index);
            case 2:
                return this.$mobx.spliceWithArray(index, deleteCount);
        }
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray$$1.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        return this.$mobx.spliceWithArray(index, deleteCount, newItems);
    };
    ObservableArray$$1.prototype.push = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    };
    ObservableArray$$1.prototype.pop = function () {
        return this.splice(Math.max(this.$mobx.values.length - 1, 0), 1)[0];
    };
    ObservableArray$$1.prototype.shift = function () {
        return this.splice(0, 1)[0];
    };
    ObservableArray$$1.prototype.unshift = function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this.$mobx;
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    };
    ObservableArray$$1.prototype.reverse = function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    };
    ObservableArray$$1.prototype.sort = function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    };
    ObservableArray$$1.prototype.remove = function (value) {
        var idx = this.$mobx.dehanceValues(this.$mobx.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    };
    ObservableArray$$1.prototype.move = function (fromIndex, toIndex) {
        deprecated$$1("observableArray.move is deprecated, use .slice() & .replace() instead");
        function checkIndex(index) {
            if (index < 0) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is negative");
            }
            var length = this.$mobx.values.length;
            if (index >= length) {
                throw new Error("[mobx.array] Index out of bounds: " + index + " is not smaller than " + length);
            }
        }
        checkIndex.call(this, fromIndex);
        checkIndex.call(this, toIndex);
        if (fromIndex === toIndex) {
            return;
        }
        var oldItems = this.$mobx.values;
        var newItems;
        if (fromIndex < toIndex) {
            newItems = __spread(oldItems.slice(0, fromIndex), oldItems.slice(fromIndex + 1, toIndex + 1), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex + 1));
        }
        else {
            // toIndex < fromIndex
            newItems = __spread(oldItems.slice(0, toIndex), [
                oldItems[fromIndex]
            ], oldItems.slice(toIndex, fromIndex), oldItems.slice(fromIndex + 1));
        }
        this.replace(newItems);
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray$$1.prototype.get = function (index) {
        var impl = this.$mobx;
        if (impl) {
            if (index < impl.values.length) {
                impl.atom.reportObserved();
                return impl.dehanceValue(impl.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + impl.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    };
    // See #734, in case property accessors are unreliable...
    ObservableArray$$1.prototype.set = function (index, newValue) {
        var adm = this.$mobx;
        var values$$1 = adm.values;
        if (index < values$$1.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed$$1(adm.atom);
            var oldValue = values$$1[index];
            if (hasInterceptors$$1(adm)) {
                var change = interceptChange$$1(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values$$1[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values$$1.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values$$1.length);
        }
    };
    return ObservableArray$$1;
}(StubArray$$1));
declareIterator$$1(ObservableArray$$1.prototype, function () {
    
    this.$mobx.atom.reportObserved();
    var self = this;
    var nextIndex = 0;
    return makeIterable$$1({
        next: function () {
            return nextIndex < self.length
                ? { value: self[nextIndex++], done: false }
                : { done: true, value: undefined };
        }
    });
});
Object.defineProperty(ObservableArray$$1.prototype, "length", {
    enumerable: false,
    configurable: true,
    get: function () {
        return this.$mobx.getArrayLength();
    },
    set: function (newLength) {
        this.$mobx.setArrayLength(newLength);
    }
});
addHiddenProp$$1(ObservableArray$$1.prototype, toStringTagSymbol$$1(), "Array");
[
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    var baseFunc = Array.prototype[funcName];
    invariant$$1(typeof baseFunc === "function", "Base function not defined on Array prototype: '" + funcName + "'");
    addHiddenProp$$1(ObservableArray$$1.prototype, funcName, function () {
        return baseFunc.apply(this.peek(), arguments);
    });
});
/**
 * We don't want those to show up in `for (const key in ar)` ...
 */
makeNonEnumerable$$1(ObservableArray$$1.prototype, [
    "constructor",
    "intercept",
    "observe",
    "clear",
    "concat",
    "get",
    "replace",
    "toJS",
    "toJSON",
    "peek",
    "find",
    "findIndex",
    "splice",
    "spliceWithArray",
    "push",
    "pop",
    "set",
    "shift",
    "unshift",
    "reverse",
    "sort",
    "remove",
    "move",
    "toString",
    "toLocaleString"
]);
// See #364
var ENTRY_0 = createArrayEntryDescriptor(0);
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: false,
        get: function () {
            return this.get(index);
        },
        set: function (value) {
            this.set(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    Object.defineProperty(ObservableArray$$1.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer$$1(max) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max; index++)
        createArrayBufferItem(index);
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
}
reserveArrayBuffer$$1(1000);
var isObservableArrayAdministration = createInstanceofPredicate$$1("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray$$1(thing) {
    return isObject$$1(thing) && isObservableArrayAdministration(thing.$mobx);
}

var ObservableMapMarker = {};
var ObservableMap$$1 = /** @class */ (function () {
    function ObservableMap$$1(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer$$1; }
        if (name === void 0) { name = "ObservableMap@" + getNextId$$1(); }
        this.enhancer = enhancer;
        this.name = name;
        this.$mobx = ObservableMapMarker;
        this._keys = (new ObservableArray$$1(undefined, referenceEnhancer$$1, this.name + ".keys()", true));
        if (typeof Map !== "function") {
            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
        }
        this._data = new Map();
        this._hasMap = new Map();
        this.merge(initialData);
    }
    ObservableMap$$1.prototype._has = function (key) {
        return this._data.has(key);
    };
    ObservableMap$$1.prototype.has = function (key) {
        if (this._hasMap.has(key))
            return this._hasMap.get(key).get();
        return this._updateHasMapEntry(key, false).get();
    };
    ObservableMap$$1.prototype.set = function (key, value) {
        var hasKey = this._has(key);
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap$$1.prototype.delete = function (key) {
        var _this = this;
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled$$1();
            var notify = hasListeners$$1(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data.get(key).value,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart$$1(__assign$1({}, change, { name: this.name, key: key }));
            transaction$$1(function () {
                _this._keys.remove(key);
                _this._updateHasMapEntry(key, false);
                var observable$$1 = _this._data.get(key);
                observable$$1.setNewValue(undefined);
                _this._data.delete(key);
            });
            if (notify)
                notifyListeners$$1(this, change);
            if (notifySpy)
                spyReportEnd$$1();
            return true;
        }
        return false;
    };
    ObservableMap$$1.prototype._updateHasMapEntry = function (key, value) {
        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
        var entry = this._hasMap.get(key);
        if (entry) {
            entry.setNewValue(value);
        }
        else {
            entry = new ObservableValue$$1(value, referenceEnhancer$$1, this.name + "." + key + "?", false);
            this._hasMap.set(key, entry);
        }
        return entry;
    };
    ObservableMap$$1.prototype._updateValue = function (key, newValue) {
        var observable$$1 = this._data.get(key);
        newValue = observable$$1.prepareNewValue(newValue);
        if (newValue !== globalState$$1.UNCHANGED) {
            var notifySpy = isSpyEnabled$$1();
            var notify = hasListeners$$1(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable$$1.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart$$1(__assign$1({}, change, { name: this.name, key: key }));
            observable$$1.setNewValue(newValue);
            if (notify)
                notifyListeners$$1(this, change);
            if (notifySpy)
                spyReportEnd$$1();
        }
    };
    ObservableMap$$1.prototype._addValue = function (key, newValue) {
        var _this = this;
        transaction$$1(function () {
            var observable$$1 = new ObservableValue$$1(newValue, _this.enhancer, _this.name + "." + key, false);
            _this._data.set(key, observable$$1);
            newValue = observable$$1.value; // value might have been changed
            _this._updateHasMapEntry(key, true);
            _this._keys.push(key);
        });
        var notifySpy = isSpyEnabled$$1();
        var notify = hasListeners$$1(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: key,
                newValue: newValue
            }
            : null;
        if (notifySpy)
            spyReportStart$$1(__assign$1({}, change, { name: this.name, key: key }));
        if (notify)
            notifyListeners$$1(this, change);
        if (notifySpy)
            spyReportEnd$$1();
    };
    ObservableMap$$1.prototype.get = function (key) {
        if (this.has(key))
            return this.dehanceValue(this._data.get(key).get());
        return this.dehanceValue(undefined);
    };
    ObservableMap$$1.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap$$1.prototype.keys = function () {
        return this._keys[iteratorSymbol$$1()]();
    };
    ObservableMap$$1.prototype.values = function () {
        var self = this;
        var nextIndex = 0;
        return makeIterable$$1({
            next: function () {
                return nextIndex < self._keys.length
                    ? { value: self.get(self._keys[nextIndex++]), done: false }
                    : { value: undefined, done: true };
            }
        });
    };
    ObservableMap$$1.prototype.entries = function () {
        var self = this;
        var nextIndex = 0;
        return makeIterable$$1({
            next: function () {
                if (nextIndex < self._keys.length) {
                    var key = self._keys[nextIndex++];
                    return {
                        value: [key, self.get(key)],
                        done: false
                    };
                }
                return { done: true };
            }
        });
    };
    ObservableMap$$1.prototype.forEach = function (callback, thisArg) {
        var _this = this;
        this._keys.forEach(function (key) { return callback.call(thisArg, _this.get(key), key, _this); });
    };
    /** Merge another object into this object, returns this. */
    ObservableMap$$1.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap$$1(other)) {
            other = other.toJS();
        }
        transaction$$1(function () {
            if (isPlainObject$$1(other))
                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_a) {
                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                    return _this.set(key, value);
                });
            else if (isES6Map$$1(other)) {
                if (other.constructor !== Map)
                    fail$$1("Cannot initialize from classes that inherit from Map: " + other.constructor.name); // prettier-ignore
                else
                    other.forEach(function (value, key) { return _this.set(key, value); });
            }
            else if (other !== null && other !== undefined)
                fail$$1("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap$$1.prototype.clear = function () {
        var _this = this;
        transaction$$1(function () {
            untracked$$1(function () {
                _this._keys.slice().forEach(function (key) { return _this.delete(key); });
            });
        });
    };
    ObservableMap$$1.prototype.replace = function (values$$1) {
        var _this = this;
        transaction$$1(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys$$1(values$$1);
            var oldKeys = _this._keys;
            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
            missingKeys.forEach(function (k) { return _this.delete(k); });
            _this.merge(values$$1);
        });
        return this;
    };
    Object.defineProperty(ObservableMap$$1.prototype, "size", {
        get: function () {
            return this._keys.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a plain object that represents this map.
     * Note that all the keys being stringified.
     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
     */
    ObservableMap$$1.prototype.toPOJO = function () {
        var _this = this;
        var res = {};
        this._keys.forEach(function (key) { return (res["" + key] = _this.get(key)); });
        return res;
    };
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap$$1.prototype.toJS = function () {
        var _this = this;
        var res = new Map();
        this._keys.forEach(function (key) { return res.set(key, _this.get(key)); });
        return res;
    };
    ObservableMap$$1.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toPOJO();
    };
    ObservableMap$$1.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            this._keys.map(function (key) { return key + ": " + ("" + _this.get(key)); }).join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap$$1.prototype.observe = function (listener, fireImmediately) {
        process.env.NODE_ENV !== "production" &&
            invariant$$1(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
        return registerListener$$1(this, listener);
    };
    ObservableMap$$1.prototype.intercept = function (handler) {
        return registerInterceptor$$1(this, handler);
    };
    return ObservableMap$$1;
}());
declareIterator$$1(ObservableMap$$1.prototype, function () {
    return this.entries();
});
addHiddenFinalProp$$1(ObservableMap$$1.prototype, toStringTagSymbol$$1(), "Map");
/* 'var' fixes small-build issue */
var isObservableMap$$1 = createInstanceofPredicate$$1("ObservableMap", ObservableMap$$1);

var ObservableSetMarker = {};
var ObservableSet$$1 = /** @class */ (function () {
    function ObservableSet$$1(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer$$1; }
        if (name === void 0) { name = "ObservableSet@" + getNextId$$1(); }
        this.name = name;
        this.$mobx = ObservableSetMarker;
        this._data = new Set();
        this._atom = createAtom$$1(this.name);
        if (typeof Set !== "function") {
            throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");
        }
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name); };
        if (initialData) {
            this.replace(initialData);
        }
    }
    ObservableSet$$1.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableSet$$1.prototype.clear = function () {
        var _this = this;
        transaction$$1(function () {
            untracked$$1(function () {
                _this._data.forEach(function (value) {
                    _this.delete(value);
                });
            });
        });
    };
    ObservableSet$$1.prototype.forEach = function (callbackFn, thisArg) {
        var _this = this;
        this._data.forEach(function (value) {
            callbackFn.call(thisArg, value, value, _this);
        });
    };
    Object.defineProperty(ObservableSet$$1.prototype, "size", {
        get: function () {
            this._atom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    ObservableSet$$1.prototype.add = function (value) {
        var _this = this;
        checkIfStateModificationsAreAllowed$$1(this._atom);
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                type: "add",
                object: this,
                newValue: value
            });
            if (!change)
                return this;
            // TODO: ideally, value = change.value would be done here, so that values can be
            // changed by interceptor. Same applies for other Set and Map api's.
        }
        if (!this.has(value)) {
            transaction$$1(function () {
                _this._data.add(_this.enhancer(value, undefined));
                _this._atom.reportChanged();
            });
            var notifySpy = isSpyEnabled$$1();
            var notify = hasListeners$$1(this);
            var change = notify || notifySpy
                ? {
                    type: "add",
                    object: this,
                    newValue: value
                }
                : null;
            if (notifySpy && process.env.NODE_ENV !== "production")
                spyReportStart$$1(change);
            if (notify)
                notifyListeners$$1(this, change);
            if (notifySpy && process.env.NODE_ENV !== "production")
                spyReportEnd$$1();
        }
        return this;
    };
    ObservableSet$$1.prototype.delete = function (value) {
        var _this = this;
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                type: "delete",
                object: this,
                oldValue: value
            });
            if (!change)
                return false;
        }
        if (this.has(value)) {
            var notifySpy = isSpyEnabled$$1();
            var notify = hasListeners$$1(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: value
                }
                : null;
            if (notifySpy && process.env.NODE_ENV !== "production")
                spyReportStart$$1(__assign$1({}, change, { name: this.name }));
            transaction$$1(function () {
                _this._atom.reportChanged();
                _this._data.delete(value);
            });
            if (notify)
                notifyListeners$$1(this, change);
            if (notifySpy && process.env.NODE_ENV !== "production")
                spyReportEnd$$1();
            return true;
        }
        return false;
    };
    ObservableSet$$1.prototype.has = function (value) {
        this._atom.reportObserved();
        return this._data.has(this.dehanceValue(value));
    };
    ObservableSet$$1.prototype.entries = function () {
        var nextIndex = 0;
        var keys$$1 = iteratorToArray$$1(this.keys());
        var values$$1 = iteratorToArray$$1(this.values());
        return makeIterable$$1({
            next: function () {
                var index = nextIndex;
                nextIndex += 1;
                return index < values$$1.length
                    ? { value: [keys$$1[index], values$$1[index]], done: false }
                    : { done: true };
            }
        });
    };
    ObservableSet$$1.prototype.keys = function () {
        return this.values();
    };
    ObservableSet$$1.prototype.values = function () {
        this._atom.reportObserved();
        var self = this;
        var nextIndex = 0;
        var observableValues;
        if (this._data.values !== undefined) {
            observableValues = iteratorToArray$$1(this._data.values());
        }
        else {
            // There is no values function in IE11
            observableValues = [];
            this._data.forEach(function (e) { return observableValues.push(e); });
        }
        return makeIterable$$1({
            next: function () {
                return nextIndex < observableValues.length
                    ? { value: self.dehanceValue(observableValues[nextIndex++]), done: false }
                    : { done: true };
            }
        });
    };
    ObservableSet$$1.prototype.replace = function (other) {
        var _this = this;
        if (isObservableSet$$1(other)) {
            other = other.toJS();
        }
        transaction$$1(function () {
            if (Array.isArray(other)) {
                _this.clear();
                other.forEach(function (value) { return _this.add(value); });
            }
            else if (isES6Set$$1(other)) {
                _this.clear();
                other.forEach(function (value) { return _this.add(value); });
            }
            else if (other !== null && other !== undefined) {
                fail$$1("Cannot initialize set from " + other);
            }
        });
        return this;
    };
    ObservableSet$$1.prototype.observe = function (listener, fireImmediately) {
        // TODO 'fireImmediately' can be true?
        process.env.NODE_ENV !== "production" &&
            invariant$$1(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with sets.");
        return registerListener$$1(this, listener);
    };
    ObservableSet$$1.prototype.intercept = function (handler) {
        return registerInterceptor$$1(this, handler);
    };
    ObservableSet$$1.prototype.toJS = function () {
        return new Set(this);
    };
    ObservableSet$$1.prototype.toString = function () {
        return this.name + "[ " + iteratorToArray$$1(this.keys()).join(", ") + " ]";
    };
    return ObservableSet$$1;
}());
declareIterator$$1(ObservableSet$$1.prototype, function () {
    return this.values();
});
addHiddenFinalProp$$1(ObservableSet$$1.prototype, toStringTagSymbol$$1(), "Set");
var isObservableSet$$1 = createInstanceofPredicate$$1("ObservableSet", ObservableSet$$1);

var ObservableObjectAdministration$$1 = /** @class */ (function () {
    function ObservableObjectAdministration$$1(target, name, defaultEnhancer) {
        this.target = target;
        this.name = name;
        this.defaultEnhancer = defaultEnhancer;
        this.values = {};
    }
    ObservableObjectAdministration$$1.prototype.read = function (owner, key) {
        if (process.env.NODE_ENV === "production" && this.target !== owner) {
            this.illegalAccess(owner, key);
            if (!this.values[key])
                return undefined;
        }
        return this.values[key].get();
    };
    ObservableObjectAdministration$$1.prototype.write = function (owner, key, newValue) {
        var instance = this.target;
        if (process.env.NODE_ENV === "production" && instance !== owner) {
            this.illegalAccess(owner, key);
        }
        var observable$$1 = this.values[key];
        if (observable$$1 instanceof ComputedValue$$1) {
            observable$$1.set(newValue);
            return;
        }
        // intercept
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                type: "update",
                object: instance,
                name: key,
                newValue: newValue
            });
            if (!change)
                return;
            newValue = change.newValue;
        }
        newValue = observable$$1.prepareNewValue(newValue);
        // notify spy & observers
        if (newValue !== globalState$$1.UNCHANGED) {
            var notify = hasListeners$$1(this);
            var notifySpy = isSpyEnabled$$1();
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: instance,
                    oldValue: observable$$1.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy)
                spyReportStart$$1(__assign$1({}, change, { name: this.name, key: key }));
            observable$$1.setNewValue(newValue);
            if (notify)
                notifyListeners$$1(this, change);
            if (notifySpy)
                spyReportEnd$$1();
        }
    };
    ObservableObjectAdministration$$1.prototype.remove = function (key) {
        if (!this.values[key])
            return;
        var target = this.target;
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                object: target,
                name: key,
                type: "remove"
            });
            if (!change)
                return;
        }
        try {
            startBatch$$1();
            var notify = hasListeners$$1(this);
            var notifySpy = isSpyEnabled$$1();
            var oldValue = this.values[key].get();
            if (this.keys)
                this.keys.remove(key);
            delete this.values[key];
            delete this.target[key];
            var change = notify || notifySpy
                ? {
                    type: "remove",
                    object: target,
                    oldValue: oldValue,
                    name: key
                }
                : null;
            if (notifySpy)
                spyReportStart$$1(__assign$1({}, change, { name: this.name, key: key }));
            if (notify)
                notifyListeners$$1(this, change);
            if (notifySpy)
                spyReportEnd$$1();
        }
        finally {
            endBatch$$1();
        }
    };
    ObservableObjectAdministration$$1.prototype.illegalAccess = function (owner, propName) {
        /**
         * This happens if a property is accessed through the prototype chain, but the property was
         * declared directly as own property on the prototype.
         *
         * E.g.:
         * class A {
         * }
         * extendObservable(A.prototype, { x: 1 })
         *
         * classB extens A {
         * }
         * console.log(new B().x)
         *
         * It is unclear whether the property should be considered 'static' or inherited.
         * Either use `console.log(A.x)`
         * or: decorate(A, { x: observable })
         *
         * When using decorate, the property will always be redeclared as own property on the actual instance
         */
        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration$$1.prototype.observe = function (callback, fireImmediately) {
        process.env.NODE_ENV !== "production" &&
            invariant$$1(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener$$1(this, callback);
    };
    ObservableObjectAdministration$$1.prototype.intercept = function (handler) {
        return registerInterceptor$$1(this, handler);
    };
    ObservableObjectAdministration$$1.prototype.getKeys = function () {
        var _this = this;
        if (this.keys === undefined) {
            this.keys = (new ObservableArray$$1(Object.keys(this.values).filter(function (key) { return _this.values[key] instanceof ObservableValue$$1; }), referenceEnhancer$$1, "keys(" + this.name + ")", true));
        }
        return this.keys.slice();
    };
    return ObservableObjectAdministration$$1;
}());
function asObservableObject$$1(target, name, defaultEnhancer) {
    if (name === void 0) { name = ""; }
    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer$$1; }
    var adm = target.$mobx;
    if (adm)
        return adm;
    process.env.NODE_ENV !== "production" &&
        invariant$$1(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
    if (!isPlainObject$$1(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId$$1();
    if (!name)
        name = "ObservableObject@" + getNextId$$1();
    adm = new ObservableObjectAdministration$$1(target, name, defaultEnhancer);
    addHiddenFinalProp$$1(target, "$mobx", adm);
    return adm;
}
function defineObservableProperty$$1(target, propName, newValue, enhancer) {
    var adm = asObservableObject$$1(target);
    assertPropertyConfigurable$$1(target, propName);
    if (hasInterceptors$$1(adm)) {
        var change = interceptChange$$1(adm, {
            object: target,
            name: propName,
            type: "add",
            newValue: newValue
        });
        if (!change)
            return;
        newValue = change.newValue;
    }
    var observable$$1 = (adm.values[propName] = new ObservableValue$$1(newValue, enhancer, adm.name + "." + propName, false));
    newValue = observable$$1.value; // observableValue might have changed it
    Object.defineProperty(target, propName, generateObservablePropConfig$$1(propName));
    if (adm.keys)
        adm.keys.push(propName);
    notifyPropertyAddition(adm, target, propName, newValue);
}
function defineComputedProperty$$1(target, // which objects holds the observable and provides `this` context?
propName, options) {
    var adm = asObservableObject$$1(target);
    options.name = adm.name + "." + propName;
    options.context = target;
    adm.values[propName] = new ComputedValue$$1(options);
    Object.defineProperty(target, propName, generateComputedPropConfig$$1(propName));
}
var observablePropertyConfigs = Object.create(null);
var computedPropertyConfigs = Object.create(null);
function generateObservablePropConfig$$1(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this.$mobx.read(this, propName);
            },
            set: function (v) {
                this.$mobx.write(this, propName, v);
            }
        }));
}
function getAdministrationForComputedPropOwner(owner) {
    var adm = owner.$mobx;
    if (!adm) {
        // because computed props are declared on proty,
        // the current instance might not have been initialized yet
        initializeInstance$$1(owner);
        return owner.$mobx;
    }
    return adm;
}
function generateComputedPropConfig$$1(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: false,
            enumerable: false,
            get: function () {
                return getAdministrationForComputedPropOwner(this).read(this, propName);
            },
            set: function (v) {
                getAdministrationForComputedPropOwner(this).write(this, propName, v);
            }
        }));
}
function notifyPropertyAddition(adm, object, key, newValue) {
    var notify = hasListeners$$1(adm);
    var notifySpy = isSpyEnabled$$1();
    var change = notify || notifySpy
        ? {
            type: "add",
            object: object,
            name: key,
            newValue: newValue
        }
        : null;
    if (notifySpy)
        spyReportStart$$1(__assign$1({}, change, { name: adm.name, key: key }));
    if (notify)
        notifyListeners$$1(adm, change);
    if (notifySpy)
        spyReportEnd$$1();
}
var isObservableObjectAdministration = createInstanceofPredicate$$1("ObservableObjectAdministration", ObservableObjectAdministration$$1);
function isObservableObject$$1(thing) {
    if (isObject$$1(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance$$1(thing);
        return isObservableObjectAdministration(thing.$mobx);
    }
    return false;
}

function getAtom$$1(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray$$1(thing)) {
            if (property !== undefined)
                fail$$1(process.env.NODE_ENV !== "production" &&
                    "It is not possible to get index atoms from arrays");
            return thing.$mobx.atom;
        }
        if (isObservableSet$$1(thing)) {
            return thing.$mobx;
        }
        if (isObservableMap$$1(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return getAtom$$1(anyThing._keys);
            var observable$$1 = anyThing._data.get(property) || anyThing._hasMap.get(property);
            if (!observable$$1)
                fail$$1(process.env.NODE_ENV !== "production" &&
                    "the entry '" + property + "' does not exist in the observable map '" + getDebugName$$1(thing) + "'");
            return observable$$1;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance$$1(thing);
        if (property && !thing.$mobx)
            thing[property]; // See #1072
        if (isObservableObject$$1(thing)) {
            if (!property)
                return fail$$1(process.env.NODE_ENV !== "production" && "please specify a property");
            var observable$$1 = thing.$mobx.values[property];
            if (!observable$$1)
                fail$$1(process.env.NODE_ENV !== "production" &&
                    "no observable property '" + property + "' found on the observable object '" + getDebugName$$1(thing) + "'");
            return observable$$1;
        }
        if (isAtom$$1(thing) || isComputedValue$$1(thing) || isReaction$$1(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction$$1(thing.$mobx)) {
            // disposer function
            return thing.$mobx;
        }
    }
    return fail$$1(process.env.NODE_ENV !== "production" && "Cannot obtain atom from " + thing);
}
function getAdministration$$1(thing, property) {
    if (!thing)
        fail$$1("Expecting some object");
    if (property !== undefined)
        return getAdministration$$1(getAtom$$1(thing, property));
    if (isAtom$$1(thing) || isComputedValue$$1(thing) || isReaction$$1(thing))
        return thing;
    if (isObservableMap$$1(thing) || isObservableSet$$1(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    initializeInstance$$1(thing);
    if (thing.$mobx)
        return thing.$mobx;
    fail$$1(process.env.NODE_ENV !== "production" && "Cannot obtain administration from " + thing);
}
function getDebugName$$1(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom$$1(thing, property);
    else if (isObservableObject$$1(thing) || isObservableMap$$1(thing) || isObservableSet$$1(thing))
        named = getAdministration$$1(thing);
    else
        named = getAtom$$1(thing); // valid for arrays as well
    return named.name;
}

var toString$1 = Object.prototype.toString;
function deepEqual$$1(a, b) {
    return eq$1(a, b);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq$1(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    return deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `isEqual`.
function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString$1.call(a);
    if (className !== toString$1.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (
            // eslint-disable-next-line
            typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq$1(a[length], b[length], aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys$$1 = Object.keys(a);
        var key = void 0;
        length = keys$$1.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys$$1[length];
            if (!(has$1$1(b, key) && eq$1(a[key], b[key], aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray$$1(a))
        return a.peek();
    if (isES6Map$$1(a) || isObservableMap$$1(a))
        return iteratorToArray$$1(a.entries());
    if (isES6Set$$1(a) || isObservableSet$$1(a))
        return iteratorToArray$$1(a.entries());
    return a;
}
function has$1$1(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

/*
The only reason for this file to exist is pure horror:
Without it rollup can make the bundling fail at any point in time; when it rolls up the files in the wrong order
it will cause undefined errors (for example because super classes or local variables not being hosted).
With this file that will still happen,
but at least in this file we can magically reorder the imports with trial and error until the build succeeds again.
*/

/**
 * (c) Michel Weststrate 2015 - 2019
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
try {
    // define process.env if needed
    // if this is not a production build in the first place
    // (in which case the expression below would be substituted with 'production')
    // tslint:disable-next-line
    process.env.NODE_ENV;
}
catch (e) {
    var g$1 = typeof window !== "undefined" ? window : global;
    if (typeof process === "undefined")
        g$1.process = {};
    g$1.process.env = {};
}

(function () {
    function testCodeMinification() { }
    if (testCodeMinification.name !== "testCodeMinification" &&
        process.env.NODE_ENV !== "production" &&
        process.env.IGNORE_MOBX_MINIFY_WARNING !== "true") {
        console.warn(
        // Template literal(backtick) is used for fix issue with rollup-plugin-commonjs https://github.com/rollup/rollup-plugin-commonjs/issues/344
        "[mobx] you are running a minified build, but 'process.env.NODE_ENV' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
    }
})();
// forward compatibility with mobx, so that packages can easily support mobx 4 & 5
var $mobx = "$mobx";
// Devtools support
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    // See: https://github.com/andykog/mobx-devtools/
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
        spy: spy$$1,
        extras: {
            getDebugName: getDebugName$$1
        },
        $mobx: $mobx
    });
}
// TODO: remove in some future build
if (process.env.NODE_ENV !== "production" &&
    typeof module !== "undefined" &&
    typeof module.exports !== "undefined") {
    var warnedAboutDefaultExport_1 = false;
    Object.defineProperty(module.exports, "default", {
        enumerable: false,
        get: function () {
            if (!warnedAboutDefaultExport_1) {
                warnedAboutDefaultExport_1 = true;
                console.warn("The MobX package does not have a default export. Use 'import { thing } from \"mobx\"' (recommended) or 'import * as mobx from \"mobx\"' instead.\"");
            }
            return undefined;
        }
    });
    [
        "extras",
        "Atom",
        "BaseAtom",
        "asFlat",
        "asMap",
        "asReference",
        "asStructure",
        "autorunAsync",
        "createTranformer",
        "expr",
        "isModifierDescriptor",
        "isStrictModeEnabled",
        "map",
        "useStrict",
        "whyRun"
    ].forEach(function (prop) {
        Object.defineProperty(module.exports, prop, {
            enumerable: false,
            get: function () {
                fail$$1("'" + prop + "' is no longer part of the public MobX api. Please consult the changelog to find out where this functionality went");
            },
            set: function () { }
        });
    });
}

var RoleType;
(function (RoleType) {
    RoleType["Client"] = "CLIENT";
    RoleType["Developer"] = "DEVELOPER";
    RoleType["Realtor"] = "REALTOR";
    RoleType["Employee"] = "EMPLOYEE";
    RoleType["Makler"] = "MAKLER";
    RoleType["Professional"] = "PROFESSIONAL";
    RoleType["Contractor"] = "CONTRACTOR";
    RoleType["Designer"] = "DESIGNER";
    RoleType["Bank"] = "BANK";
    RoleType["Partner"] = "PARTNER";
})(RoleType || (RoleType = {}));

/**
 * Список фич для которых может быть онбординг.
 * При добавлении новых фич, необходиммо поддержать их в onboarding-bff( в том числе и onboarding-бекенд ),
 * а так же в ROOT-компоненте DynamicOnboarding который подписан на данный eventBus
 */
var OnboardingFeatureEnum;
(function (OnboardingFeatureEnum) {
    OnboardingFeatureEnum["MenuItemMortage"] = "MenuItemMortage";
    OnboardingFeatureEnum["MenuItemPlacement"] = "MenuItemPlacement";
    OnboardingFeatureEnum["MenuItemFavorites"] = "MenuItemFavorites";
    OnboardingFeatureEnum["MenuItemProfSearch"] = "MenuItemProfSearch";
    OnboardingFeatureEnum["MenuItemProfCustomers"] = "MenuItemProfCustomers";
    OnboardingFeatureEnum["MenuItemProfFavorites"] = "MenuItemProfFavorites";
    OnboardingFeatureEnum["MenuItemProfSavedSearch"] = "MenuItemProfSavedSearch";
    OnboardingFeatureEnum["ProfSearchSnippetPresentation"] = "ProfSearchSnippetPresentation";
    OnboardingFeatureEnum["ProfSearchToolsPresentation"] = "ProfSearchToolsPresentation";
    OnboardingFeatureEnum["ProfSearchToolsSaveSearch"] = "ProfSearchToolsSaveSearch";
    OnboardingFeatureEnum["ProfSearchToolsToggleMapView"] = "ProfSearchToolsToggleMapView";
    OnboardingFeatureEnum["ProfSearchFilterClusterEnable"] = "ProfSearchFilterClusterEnable";
})(OnboardingFeatureEnum || (OnboardingFeatureEnum = {}));

var RemontCustomEventTypes;
(function (RemontCustomEventTypes) {
    RemontCustomEventTypes["SendMeetingRequest"] = "remont:landingEvent:sendMeetingRequest";
    RemontCustomEventTypes["SendMeetingResponse"] = "remont:landingEvent:sendMeetingResponse";
    RemontCustomEventTypes["SendMaintanceTicketRequest"] = "remont:landingEvent:sendMaintanceTicketRequest";
    RemontCustomEventTypes["SendMaintanceTicketResponse"] = "remont:landingEvent:sendMaintanceTicketResponse";
    RemontCustomEventTypes["CreateInvoiceRequest"] = "remont:landingEvent:createInvoiceRequest";
    RemontCustomEventTypes["CreateInvoiceResponse"] = "remont:landingEvent:createInvoiceResponse";
    RemontCustomEventTypes["GetPackageServicesRequest"] = "remont:landingEvent:getPackageServicesRequest";
    RemontCustomEventTypes["GetPackageServicesResponse"] = "remont:landingEvent:getPackageServicesResponse";
    RemontCustomEventTypes["ApplyPromocodeRequest"] = "remont:landingEvent:applyPromocodeRequest";
    RemontCustomEventTypes["ApplyPromocodeResponse"] = "remont:landingEvent:applyPromocodeResponse";
})(RemontCustomEventTypes || (RemontCustomEventTypes = {}));

var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
class BaseRootStore {
    get userCanSeeApp() {
        throw new Error('redefine userCanSeeApp in your app rootStore');
    }
    constructor() {
        this.subs = [];
        this.eventBus = distExports.EventBus.getInstance();
        this.handleAppContextChanged = ({ data }) => {
            this.authInfo = data.authInfo;
            this.config = data.config;
        };
        this.subscribeAppContextChanged();
    }
    cleanUp() {
        this.subs.forEach((sub) => sub.unsubscribe());
    }
    subscribeAppContextChanged() {
        const subscription = this.eventBus.subscribe('app:contextChanged', this.handleAppContextChanged, { eventCategory: 'behavior' });
        this.subs.push(subscription);
    }
    get isUserIndividualClient() {
        var _a;
        return this.authInfo.isAuthenticated && ((_a = this.authInfo.user) === null || _a === void 0 ? void 0 : _a.currentRoleType) === RoleType.Client;
    }
}
__decorate([
    observable$$1,
    __metadata("design:type", Object)
], BaseRootStore.prototype, "authInfo", void 0);
__decorate([
    observable$$1,
    __metadata("design:type", Object)
], BaseRootStore.prototype, "config", void 0);
__decorate([
    action$$1,
    __metadata("design:type", Object)
], BaseRootStore.prototype, "handleAppContextChanged", void 0);
__decorate([
    computed$$1,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BaseRootStore.prototype, "isUserIndividualClient", null);

var css_248z$i = ".field-info-wrapper-module_info__21B28{align-items:center;display:flex;height:60px}";
styleInject(css_248z$i);

var css_248z$h = ".card-module_wrapper__UndLn{border-radius:var(--s-unit-05x);display:flex;flex-direction:column;margin-top:var(--padding-xs);padding:var(--padding-m);position:relative}.card-module_bgColorSecondary__1Tmr9{background-color:var(--c-secondary)}.card-module_bgColorPrimary__u-2g8{background-color:var(--c-background-primary)}.card-module_main__HIOb3{display:flex}.card-module_content__qK9UP{flex:1 1}";
styleInject(css_248z$h);

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

//      
function moveFieldState(state, source, destKey, oldState) {
  if (oldState === void 0) {
    oldState = state;
  }

  delete state.fields[source.name];
  state.fields[destKey] = _extends$2({}, source, {
    name: destKey,
    // prevent functions from being overwritten
    // if the state.fields[destKey] does not exist, it will be created
    // when that field gets registered, with its own change/blur/focus callbacks
    change: oldState.fields[destKey] && oldState.fields[destKey].change,
    blur: oldState.fields[destKey] && oldState.fields[destKey].blur,
    focus: oldState.fields[destKey] && oldState.fields[destKey].focus,
    lastFieldState: undefined // clearing lastFieldState forces renotification

  });

  if (!state.fields[destKey].change) {
    delete state.fields[destKey].change;
  }

  if (!state.fields[destKey].blur) {
    delete state.fields[destKey].blur;
  }

  if (!state.fields[destKey].focus) {
    delete state.fields[destKey].focus;
  }
}

//      
// From MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
var escapeRegexTokens = function escapeRegexTokens(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}; // $& means the whole matched string

var insert$1 = function insert(_ref, state, _ref2) {
  var name = _ref[0],
      index = _ref[1],
      value = _ref[2];
  var changeValue = _ref2.changeValue;
      _ref2.resetFieldState;
  changeValue(state, name, function (array) {
    var copy = [].concat(array || []);
    copy.splice(index, 0, value);
    return copy;
  });

  var backup = _extends$2({}, state.fields); // now we have increment any higher indexes


  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)"); // we need to increment high indices first so
  // lower indices won't overlap

  Object.keys(state.fields).sort().reverse().forEach(function (key) {
    var tokens = pattern.exec(key);

    if (tokens) {
      var fieldIndex = Number(tokens[1]);

      if (fieldIndex >= index) {
        // inc index one higher
        var incrementedKey = name + "[" + (fieldIndex + 1) + "]" + tokens[2];
        moveFieldState(state, backup[key], incrementedKey);
      }
    }
  });
};

//      
var concat = function concat(_ref, state, _ref2) {
  var name = _ref[0],
      value = _ref[1];
  var changeValue = _ref2.changeValue;
  changeValue(state, name, function (array) {
    return array ? [].concat(array, value) : value;
  });
};

//      

function moveFields(name, matchPrefix, destIndex, state) {
  Object.keys(state.fields).forEach(function (key) {
    if (key.substring(0, matchPrefix.length) === matchPrefix) {
      var suffix = key.substring(matchPrefix.length);
      var destKey = name + "[" + destIndex + "]" + suffix;
      moveFieldState(state, state.fields[key], destKey);
    }
  });
}

//      
function restoreFunctions(state, backupState) {
  Object.keys(state.fields).forEach(function (key) {
    state.fields[key] = _extends$2({}, state.fields[key], {
      change: state.fields[key].change || backupState.fields[key] && backupState.fields[key].change,
      blur: state.fields[key].blur || backupState.fields[key] && backupState.fields[key].blur,
      focus: state.fields[key].focus || backupState.fields[key] && backupState.fields[key].focus
    });

    if (!state.fields[key].change) {
      delete state.fields[key].change;
    }

    if (!state.fields[key].blur) {
      delete state.fields[key].blur;
    }

    if (!state.fields[key].focus) {
      delete state.fields[key].focus;
    }
  });
}

var TMP = 'tmp';

var move = function move(_ref, state, _ref2) {
  var name = _ref[0],
      from = _ref[1],
      to = _ref[2];
  var changeValue = _ref2.changeValue;

  if (from === to) {
    return;
  }

  changeValue(state, name, function (array) {
    var copy = [].concat(array || []);
    var value = copy[from];
    copy.splice(from, 1);
    copy.splice(to, 0, value);
    return copy;
  }); //make a copy of a state for further functions restore

  var backupState = _extends$2({}, state, {
    fields: _extends$2({}, state.fields) // move this row to tmp index

  });

  var fromPrefix = name + "[" + from + "]";
  moveFields(name, fromPrefix, TMP, state);

  if (from < to) {
    // moving to a higher index
    // decrement all indices between from and to
    for (var i = from + 1; i <= to; i++) {
      var innerFromPrefix = name + "[" + i + "]";
      moveFields(name, innerFromPrefix, "" + (i - 1), state);
    }
  } else {
    // moving to a lower index
    // increment all indices between to and from
    for (var _i = from - 1; _i >= to; _i--) {
      var _innerFromPrefix = name + "[" + _i + "]";

      moveFields(name, _innerFromPrefix, "" + (_i + 1), state);
    }
  } // move from tmp index to destination


  var tmpPrefix = name + "[" + TMP + "]";
  moveFields(name, tmpPrefix, to, state);
  restoreFunctions(state, backupState);
};

//      

var pop = function pop(_ref, state, _ref2) {
  var name = _ref[0];
  var changeValue = _ref2.changeValue;
  var result;
  var removedIndex;
  changeValue(state, name, function (array) {
    if (array) {
      if (!array.length) {
        return [];
      }

      removedIndex = array.length - 1;
      result = array[removedIndex];
      return array.slice(0, removedIndex);
    }
  }); // now we have to remove any subfields for our index,

  if (removedIndex !== undefined) {
    var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[" + removedIndex + "].*");
    Object.keys(state.fields).forEach(function (key) {
      if (pattern.test(key)) {
        delete state.fields[key];
      }
    });
  }

  return result;
};

//      
var push = function push(_ref, state, _ref2) {
  var name = _ref[0],
      value = _ref[1];
  var changeValue = _ref2.changeValue;
  changeValue(state, name, function (array) {
    return array ? [].concat(array, [value]) : [value];
  });
};

var remove = function remove(_ref, state, _ref2) {
  var name = _ref[0],
      index = _ref[1];
  var changeValue = _ref2.changeValue,
      renameField = _ref2.renameField;
  var returnValue;
  changeValue(state, name, function (array) {
    var copy = [].concat(array || []);
    returnValue = copy[index];
    copy.splice(index, 1);
    return copy;
  }); // now we have to remove any subfields for our index,
  // and decrement all higher indexes.

  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");

  var backup = _extends$2({}, state, {
    fields: _extends$2({}, state.fields)
  });

  Object.keys(state.fields).forEach(function (key) {
    var tokens = pattern.exec(key);

    if (tokens) {
      var fieldIndex = Number(tokens[1]);

      if (fieldIndex === index) {
        // delete any subfields for this array item
        delete state.fields[key];
      } else if (fieldIndex > index) {
        // shift all higher ones down
        delete state.fields[key];
        var decrementedKey = name + "[" + (fieldIndex - 1) + "]" + tokens[2];

        if (backup.fields[decrementedKey]) {
          moveFieldState(state, backup.fields[key], decrementedKey, backup);
        } else {
          // take care of setting the correct change, blur, focus, validators on new field
          renameField(state, key, decrementedKey);
        }
      }
    }
  });
  return returnValue;
};

var countBelow = function countBelow(array, value) {
  return array.reduce(function (count, item) {
    return item < value ? count + 1 : count;
  }, 0);
};

var removeBatch = function removeBatch(_ref, state, _ref2) {
  var name = _ref[0],
      indexes = _ref[1];
  var changeValue = _ref2.changeValue;
  var sortedIndexes = [].concat(indexes);
  sortedIndexes.sort(); // remove duplicates

  for (var i = 0; i < sortedIndexes.length; i++) {
    if (i > 0 && sortedIndexes[i] === sortedIndexes[i - 1]) {
      sortedIndexes.splice(i--, 1);
    }
  }

  var returnValue = [];
  changeValue(state, name, function (array) {
    // use original order of indexes for return value
    returnValue = indexes.map(function (index) {
      return array && array[index];
    });

    if (!array || !sortedIndexes.length) {
      return array;
    }

    var copy = [].concat(array);
    var removed = [];
    sortedIndexes.forEach(function (index) {
      copy.splice(index - removed.length, 1);
      removed.push(array && array[index]);
    });
    return copy;
  }); // now we have to remove any subfields for our indexes,
  // and decrement all higher indexes.

  var pattern = new RegExp("^" + escapeRegexTokens(name) + "\\[(\\d+)\\](.*)");

  var newState = _extends$2({}, state, {
    fields: {}
  });

  Object.keys(state.fields).forEach(function (key) {
    var tokens = pattern.exec(key);

    if (tokens) {
      var fieldIndex = Number(tokens[1]);

      if (!~sortedIndexes.indexOf(fieldIndex)) {
        // not one of the removed indexes
        // shift all higher ones down
        var decrementedKey = name + "[" + (fieldIndex - countBelow(sortedIndexes, fieldIndex)) + "]" + tokens[2];
        moveFieldState(newState, state.fields[key], decrementedKey, state);
      }
    } else {
      newState.fields[key] = state.fields[key];
    }
  });
  state.fields = newState.fields;
  return returnValue;
};

//      

var shift$1 = function shift(_ref, state, tools) {
  var name = _ref[0];
  return remove([name, 0], state, tools);
};

var TMP$1 = 'tmp';

var swap = function swap(_ref, state, _ref2) {
  var name = _ref[0],
      indexA = _ref[1],
      indexB = _ref[2];
  var changeValue = _ref2.changeValue;

  if (indexA === indexB) {
    return;
  }

  changeValue(state, name, function (array) {
    var copy = [].concat(array || []);
    var a = copy[indexA];
    copy[indexA] = copy[indexB];
    copy[indexB] = a;
    return copy;
  }); //make a copy of a state for further functions restore

  var backupState = _extends$2({}, state, {
    fields: _extends$2({}, state.fields) // swap all field state that begin with "name[indexA]" with that under "name[indexB]"

  });

  var aPrefix = name + "[" + indexA + "]";
  var bPrefix = name + "[" + indexB + "]";
  var tmpPrefix = name + "[" + TMP$1 + "]";
  moveFields(name, aPrefix, TMP$1, state);
  moveFields(name, bPrefix, indexA, state);
  moveFields(name, tmpPrefix, indexB, state);
  restoreFunctions(state, backupState);
};

//      

var unshift = function unshift(_ref, state, tools) {
  var name = _ref[0],
      value = _ref[1];
  return insert$1([name, 0, value], state, tools);
};

//      
var update$1 = function update(_ref, state, _ref2) {
  var name = _ref[0],
      index = _ref[1],
      value = _ref[2];
  var changeValue = _ref2.changeValue;
  changeValue(state, name, function (array) {
    var copy = [].concat(array || []);
    copy.splice(index, 1, value);
    return copy;
  });
};

//      
var mutators = {
  insert: insert$1,
  concat: concat,
  move: move,
  pop: pop,
  push: push,
  remove: remove,
  removeBatch: removeBatch,
  shift: shift$1,
  swap: swap,
  unshift: unshift,
  update: update$1
};

if (!React.useState) {
    throw new Error("mobx-react-lite requires React with Hooks support");
}
if (!spy$$1) {
    throw new Error("mobx-react-lite requires mobx at least version 4 to be available");
}

(undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function getSymbol(name) {
    if (typeof Symbol === "function") {
        return Symbol.for(name);
    }
    return "__$mobx-react " + name + "__";
}
var mockGlobal = {};
function getGlobal() {
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    return mockGlobal;
}

var observerBatchingConfiguredSymbol = getSymbol("observerBatching");
function defaultNoopBatch(callback) {
    callback();
}
function observerBatching(reactionScheduler) {
    if (!reactionScheduler) {
        reactionScheduler = defaultNoopBatch;
        if ("production" !== process.env.NODE_ENV) {
            console.warn("[MobX] Failed to get unstable_batched updates from react-dom / react-native");
        }
    }
    configure$$1({ reactionScheduler: reactionScheduler });
    getGlobal()[observerBatchingConfiguredSymbol] = true;
}

var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

(undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

observerBatching(ReactDOM.unstable_batchedUpdates);

var b$1=function(){return (b$1=Object.assign||function(t){for(var e,r=1,n=arguments.length;r<n;r++)for(var i in e=arguments[r])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}).apply(this,arguments)};function S$1(t,e,r,n){var i,o=arguments.length,s=o<3?e:null===n?n=Object.getOwnPropertyDescriptor(e,r):n;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(t,e,r,n);else for(var u=t.length-1;u>=0;u--)(i=t[u])&&(s=(o<3?i(s):o>3?i(e,r,s):i(e,r))||s);return o>3&&s&&Object.defineProperty(e,r,s),s}function I$1(t,e){if("object"==typeof Reflect&&"function"==typeof Reflect.metadata)return Reflect.metadata(t,e)}b$1({},mutators);var T$1=function(){function t(e,r,n){this.initialValues=n,t.checkFlow(r),t.checkSteps(e,r),this.steps=e,this.flow=r,this.stepIndex=0,this.stepId=t.getFirstStep(this.flow),this.values=this.initialValues;}return Object.defineProperty(t.prototype,"currentStep",{get:function(){return this.steps[this.stepId]},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isFirstStep",{get:function(){return t.isFlowTypeArray(this.flow)?0===this.stepIndex:this.stepId===this.flow.initialState},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isLastStep",{get:function(){return t.isFlowTypeArray(this.flow)?this.stepIndex===this.flow.length-1:void 0===this.flow.states[this.stepId].getNextStep(this.values)},enumerable:!0,configurable:!0}),t.prototype.prevStep=function(){if(t.isFlowTypeArray(this.flow)){if(0===this.stepIndex)throw new Error("Cannot go to the prev step: current step is the first");--this.stepIndex,this.stepId=this.flow[this.stepIndex];}else {var e=this.flow.states[this.stepId].getPrevStep(this.values);this.checkStepId(e),e&&(this.stepId=e);}return this.currentStep},t.prototype.submit=function(t){return this.values=b$1(b$1({},this.values),t),this.values},t.prototype.nextStep=function(){if(t.isFlowTypeArray(this.flow)){if(this.stepIndex===this.flow.length-1)throw new Error("Cannot go to the next step: current step is the last");++this.stepIndex,this.stepId=this.flow[this.stepIndex];}else {var e=this.flow.states[this.stepId].getNextStep(this.values);this.checkStepId(e),e&&(this.stepId=e);}return this.currentStep},t.prototype.goToStep=function(e){if(t.isFlowTypeArray(this.flow))throw new Error("Currently unavailable for array flows");return this.checkStepId(e),this.stepId=e,this.currentStep},t.prototype.reset=function(){this.stepIndex=0,this.stepId=t.getFirstStep(this.flow),this.values=this.initialValues;},t.prototype.checkStepId=function(t){if(!t)throw new Error("Empty step id: "+t);if(!(t in this.steps))throw new Error("Invalid step id: "+t)},t.getFirstStep=function(e){return t.isFlowTypeArray(e)?e[0]:e.initialState},t.isFlowTypeArray=function(t){return isArray_1(t)},t.checkFlow=function(e){if(t.isFlowEmpty(e))throw new Error("Empty flow is not allowed");if(!isArray_1(e)){var r=e.initialState,n=e.states;if(!(r&&r in n))throw new Error("Invalid initial state in the flow graph")}},t.isFlowEmpty=function(t){return isArray_1(t)?0===t.length:0===Object.keys(t.states).length},t.checkSteps=function(t,e){var r=isArray_1(e)?e:Object.keys(e.states),n=Object.keys(t),i=r.find((function(t){return !n.includes(t)}));if(i)throw new Error("Step with id "+i+" exists in the flow but did not found in the steps array")},t}();(function(){function t(t,e,r){void 0===r&&(r={}),this.model=new T$1(t,e,r),this.modelStep=this.model.currentStep,this.modelValues=this.model.values;}return Object.defineProperty(t.prototype,"step",{get:function(){return this.modelStep},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"stepId",{get:function(){return this.model.stepId},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"values",{get:function(){return this.modelValues},enumerable:!0,configurable:!0}),t.prototype.setValues=function(t){this.modelValues=this.model.submit(t);},t.prototype.prevStep=function(){this.isFirstStep?this.onReset&&this.onReset():this.modelStep=this.model.prevStep();},t.prototype.submitStep=function(t){this.modelValues=this.model.submit(t),this.isLastStep?this.onComplete&&this.onComplete():this.modelStep=this.model.nextStep();},t.prototype.goToStep=function(t){this.modelStep=this.model.goToStep(t);},Object.defineProperty(t.prototype,"isFirstStep",{get:function(){return this.model.isFirstStep},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isLastStep",{get:function(){return this.model.isLastStep},enumerable:!0,configurable:!0}),t.prototype.reset=function(){this.model.reset();},S$1([observable$$1.ref,I$1("design:type",T$1)],t.prototype,"model",void 0),S$1([observable$$1.ref,I$1("design:type",Object)],t.prototype,"modelStep",void 0),S$1([observable$$1.ref,I$1("design:type",Object)],t.prototype,"modelValues",void 0),S$1([computed$$1,I$1("design:type",Object),I$1("design:paramtypes",[])],t.prototype,"step",null),S$1([computed$$1,I$1("design:type",String),I$1("design:paramtypes",[])],t.prototype,"stepId",null),S$1([computed$$1,I$1("design:type",Object),I$1("design:paramtypes",[])],t.prototype,"values",null),S$1([action$$1,I$1("design:type",Function),I$1("design:paramtypes",[Object]),I$1("design:returntype",void 0)],t.prototype,"setValues",null),S$1([action$$1,I$1("design:type",Function),I$1("design:paramtypes",[]),I$1("design:returntype",void 0)],t.prototype,"prevStep",null),S$1([action$$1,I$1("design:type",Function),I$1("design:paramtypes",[Object]),I$1("design:returntype",void 0)],t.prototype,"submitStep",null),S$1([action$$1,I$1("design:type",Function),I$1("design:paramtypes",[String]),I$1("design:returntype",void 0)],t.prototype,"goToStep",null),S$1([computed$$1,I$1("design:type",Boolean),I$1("design:paramtypes",[])],t.prototype,"isFirstStep",null),S$1([computed$$1,I$1("design:type",Boolean),I$1("design:paramtypes",[])],t.prototype,"isLastStep",null),S$1([action$$1,I$1("design:type",Function),I$1("design:paramtypes",[]),I$1("design:returntype",void 0)],t.prototype,"reset",null),t})();

var _a;
const getDefaultReactQueryInstance = () => new reactQuery.QueryClient({
    defaultOptions: {
        queries: {
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            staleTime: 60000,
        },
    },
});
const RQClient = getDefaultReactQueryInstance();
if (typeof window !== 'undefined') {
    (_a = window.__RQ_CLIENT) !== null && _a !== void 0 ? _a : (window.__RQ_CLIENT = RQClient);
}

var css_248z$g = ".styles-module_quickActionIcon__Pibm8{background:#eeeef6;border-radius:50%;box-sizing:border-box;cursor:pointer;height:24px;padding:1px 4px;width:24px}";
var styles$c = {"quickActionIcon":"styles-module_quickActionIcon__Pibm8"};
styleInject(css_248z$g);

const DropdownControl = ({ toggle }) => {
    const { toggle: toggleAction } = useDropdown();
    useUpdateEffect$1(() => {
        toggleAction();
    }, [toggle]);
    return (React.createElement("div", { className: styles$c.quickActionIcon },
        React.createElement(Dropdown.Icon, { name: "dots-horizontal", dataTest: "quickActionsControl", size: "s", color: "grey" })));
};

var css_248z$f = ".styles-module_tooltip__ryeXH>div{max-width:100%}";
var styles$b = {"tooltip":"styles-module_tooltip__ryeXH"};
styleInject(css_248z$f);

const ErrorTooltip = ({ to, message }) => {
    return (React.createElement("div", { className: styles$b.tooltip },
        React.createElement(Tooltip$1, { color: "alert", to: to }, message)));
};

const useDisableBodyScroll$1 = (condition) => {
    React.useEffect(() => {
        if (condition && (document === null || document === void 0 ? void 0 : document.documentElement)) {
            document.documentElement.style.overflow = 'hidden';
            return () => {
                document.documentElement.style.overflow = 'unset';
            };
        }
    }, [condition]);
};

var debounce$1 = debounce_1,
    isObject$7 = isObject_1;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject$7(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce$1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var throttle_1 = throttle;

var throttle$1 = throttle_1;

// eslint-disable-next-line @typescript-eslint/ban-types
function isOfType$2(type) {
    return function (value) { return typeof value === type; };
}
// eslint-disable-next-line @typescript-eslint/ban-types
var isFunction$2 = isOfType$2('function');
var isNull = function (value) {
    return value === null;
};
var isRegex$1 = function (value) {
    return Object.prototype.toString.call(value).slice(8, -1) === 'RegExp';
};
var isObject$6 = function (value) {
    return !isUndefined$3(value) && !isNull(value) && (isFunction$2(value) || typeof value === 'object');
};
var isUndefined$3 = isOfType$2('undefined');

var __values = (undefined && undefined.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function equalArray(left, right) {
    var length = left.length;
    if (length !== right.length) {
        return false;
    }
    for (var index = length; index-- !== 0;) {
        if (!equal(left[index], right[index])) {
            return false;
        }
    }
    return true;
}
function equalArrayBuffer(left, right) {
    if (left.byteLength !== right.byteLength) {
        return false;
    }
    var view1 = new DataView(left.buffer);
    var view2 = new DataView(right.buffer);
    var index = left.byteLength;
    while (index--) {
        if (view1.getUint8(index) !== view2.getUint8(index)) {
            return false;
        }
    }
    return true;
}
function equalMap(left, right) {
    var e_1, _a, e_2, _b;
    if (left.size !== right.size) {
        return false;
    }
    try {
        for (var _c = __values(left.entries()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var index = _d.value;
            if (!right.has(index[0])) {
                return false;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var _e = __values(left.entries()), _f = _e.next(); !_f.done; _f = _e.next()) {
            var index = _f.value;
            if (!equal(index[1], right.get(index[0]))) {
                return false;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return true;
}
function equalSet(left, right) {
    var e_3, _a;
    if (left.size !== right.size) {
        return false;
    }
    try {
        for (var _b = __values(left.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var index = _c.value;
            if (!right.has(index[0])) {
                return false;
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return true;
}
function equal(left, right) {
    if (left === right) {
        return true;
    }
    if (left && isObject$6(left) && right && isObject$6(right)) {
        if (left.constructor !== right.constructor) {
            return false;
        }
        if (Array.isArray(left) && Array.isArray(right)) {
            return equalArray(left, right);
        }
        if (left instanceof Map && right instanceof Map) {
            return equalMap(left, right);
        }
        if (left instanceof Set && right instanceof Set) {
            return equalSet(left, right);
        }
        if (ArrayBuffer.isView(left) && ArrayBuffer.isView(right)) {
            return equalArrayBuffer(left, right);
        }
        if (isRegex$1(left) && isRegex$1(right)) {
            return left.source === right.source && left.flags === right.flags;
        }
        if (left.valueOf !== Object.prototype.valueOf) {
            return left.valueOf() === right.valueOf();
        }
        if (left.toString !== Object.prototype.toString) {
            return left.toString() === right.toString();
        }
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) {
            return false;
        }
        for (var index = leftKeys.length; index-- !== 0;) {
            if (!Object.prototype.hasOwnProperty.call(right, leftKeys[index])) {
                return false;
            }
        }
        for (var index = leftKeys.length; index-- !== 0;) {
            var key = leftKeys[index];
            if (key === '_owner' && left.$$typeof) {
                // React-specific: avoid traversing React elements' _owner.
                //  _owner contains circular references
                // and is not needed when comparing the actual elements (and not their owners)
                // eslint-disable-next-line no-continue
                continue;
            }
            if (!equal(left[key], right[key])) {
                return false;
            }
        }
        return true;
    }
    if (Number.isNaN(left) && Number.isNaN(right)) {
        return true;
    }
    return left === right;
}

var DOM_PROPERTIES_TO_CHECK$1 = [
    'innerHTML',
    'ownerDocument',
    'style',
    'attributes',
    'nodeValue',
];
var objectTypes$1 = [
    'Array',
    'ArrayBuffer',
    'AsyncFunction',
    'AsyncGenerator',
    'AsyncGeneratorFunction',
    'Date',
    'Error',
    'Function',
    'Generator',
    'GeneratorFunction',
    'HTMLElement',
    'Map',
    'Object',
    'Promise',
    'RegExp',
    'Set',
    'WeakMap',
    'WeakSet',
];
var primitiveTypes$1 = [
    'bigint',
    'boolean',
    'null',
    'number',
    'string',
    'symbol',
    'undefined',
];
function getObjectType$2(value) {
    var objectTypeName = Object.prototype.toString.call(value).slice(8, -1);
    if (/HTML\w+Element/.test(objectTypeName)) {
        return 'HTMLElement';
    }
    if (isObjectType$2(objectTypeName)) {
        return objectTypeName;
    }
    return undefined;
}
function isObjectOfType$1(type) {
    return function (value) { return getObjectType$2(value) === type; };
}
function isObjectType$2(name) {
    return objectTypes$1.includes(name);
}
// eslint-disable-next-line @typescript-eslint/ban-types
function isOfType$1(type) {
    return function (value) { return typeof value === type; };
}
function isPrimitiveType$1(name) {
    return primitiveTypes$1.includes(name);
}
function is$1(value) {
    if (value === null) {
        return 'null';
    }
    switch (typeof value) {
        case 'bigint':
            return 'bigint';
        case 'boolean':
            return 'boolean';
        case 'number':
            return 'number';
        case 'string':
            return 'string';
        case 'symbol':
            return 'symbol';
        case 'undefined':
            return 'undefined';
    }
    if (is$1.array(value)) {
        return 'Array';
    }
    if (is$1.plainFunction(value)) {
        return 'Function';
    }
    var tagType = getObjectType$2(value);
    /* istanbul ignore else */
    if (tagType) {
        return tagType;
    }
    /* istanbul ignore next */
    return 'Object';
}
is$1.array = Array.isArray;
is$1.arrayOf = function (target, predicate) {
    if (!is$1.array(target) && !is$1.function(predicate)) {
        return false;
    }
    return target.every(function (d) { return predicate(d); });
};
is$1.asyncGeneratorFunction = function (value) {
    return getObjectType$2(value) === 'AsyncGeneratorFunction';
};
// eslint-disable-next-line @typescript-eslint/ban-types
is$1.asyncFunction = isObjectOfType$1('AsyncFunction');
is$1.bigint = isOfType$1('bigint');
is$1.boolean = function (value) {
    return value === true || value === false;
};
is$1.date = isObjectOfType$1('Date');
is$1.defined = function (value) { return !is$1.undefined(value); };
is$1.domElement = function (value) {
    return (is$1.object(value) &&
        !is$1.plainObject(value) &&
        value.nodeType === 1 &&
        is$1.string(value.nodeName) &&
        DOM_PROPERTIES_TO_CHECK$1.every(function (property) { return property in value; }));
};
is$1.empty = function (value) {
    return ((is$1.string(value) && value.length === 0) ||
        (is$1.array(value) && value.length === 0) ||
        (is$1.object(value) && !is$1.map(value) && !is$1.set(value) && Object.keys(value).length === 0) ||
        (is$1.set(value) && value.size === 0) ||
        (is$1.map(value) && value.size === 0));
};
is$1.error = isObjectOfType$1('Error');
// eslint-disable-next-line @typescript-eslint/ban-types
is$1.function = isOfType$1('function');
is$1.generator = function (value) {
    return (is$1.iterable(value) &&
        is$1.function(value.next) &&
        is$1.function(value.throw));
};
is$1.generatorFunction = isObjectOfType$1('GeneratorFunction');
is$1.instanceOf = function (instance, class_) {
    if (!instance || !class_) {
        return false;
    }
    return Object.getPrototypeOf(instance) === class_.prototype;
};
is$1.iterable = function (value) {
    return (!is$1.nullOrUndefined(value) && is$1.function(value[Symbol.iterator]));
};
is$1.map = isObjectOfType$1('Map');
is$1.nan = function (value) {
    return Number.isNaN(value);
};
is$1.null = function (value) {
    return value === null;
};
is$1.nullOrUndefined = function (value) {
    return is$1.null(value) || is$1.undefined(value);
};
is$1.number = function (value) {
    return isOfType$1('number')(value) && !is$1.nan(value);
};
is$1.numericString = function (value) {
    return is$1.string(value) && value.length > 0 && !Number.isNaN(Number(value));
};
// eslint-disable-next-line @typescript-eslint/ban-types
is$1.object = function (value) {
    return !is$1.nullOrUndefined(value) && (is$1.function(value) || typeof value === 'object');
};
is$1.oneOf = function (target, value) {
    if (!is$1.array(target)) {
        return false;
    }
    // eslint-disable-next-line unicorn/prefer-includes
    return target.indexOf(value) > -1;
};
// eslint-disable-next-line @typescript-eslint/ban-types
is$1.plainFunction = isObjectOfType$1('Function');
is$1.plainObject = function (value) {
    if (getObjectType$2(value) !== 'Object') {
        return false;
    }
    var prototype = Object.getPrototypeOf(value);
    return prototype === null || prototype === Object.getPrototypeOf({});
};
is$1.primitive = function (value) {
    return is$1.null(value) || isPrimitiveType$1(typeof value);
};
is$1.promise = isObjectOfType$1('Promise');
is$1.propertyOf = function (target, key, predicate) {
    if (!is$1.object(target) || !key) {
        return false;
    }
    var value = target[key];
    if (is$1.function(predicate)) {
        return predicate(value);
    }
    return is$1.defined(value);
};
is$1.regexp = isObjectOfType$1('RegExp');
is$1.set = isObjectOfType$1('Set');
is$1.string = isOfType$1('string');
is$1.symbol = isOfType$1('symbol');
is$1.undefined = isOfType$1('undefined');
is$1.weakMap = isObjectOfType$1('WeakMap');
is$1.weakSet = isObjectOfType$1('WeakSet');

function canHaveLength() {
    var arguments_ = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arguments_[_i] = arguments[_i];
    }
    return arguments_.every(function (d) { return is$1.string(d) || is$1.array(d) || is$1.plainObject(d); });
}
function checkEquality(left, right, value) {
    if (!isSameType(left, right)) {
        return false;
    }
    if ([left, right].every(is$1.array)) {
        return !left.some(hasValue(value)) && right.some(hasValue(value));
    }
    /* istanbul ignore else */
    if ([left, right].every(is$1.plainObject)) {
        return (!Object.entries(left).some(hasEntry(value)) && Object.entries(right).some(hasEntry(value)));
    }
    return right === value;
}
function compareNumbers(previousData, data, options) {
    var actual = options.actual, key = options.key, previous = options.previous, type = options.type;
    var left = nested(previousData, key);
    var right = nested(data, key);
    var changed = [left, right].every(is$1.number) && (type === 'increased' ? left < right : left > right);
    if (!is$1.undefined(actual)) {
        changed = changed && right === actual;
    }
    if (!is$1.undefined(previous)) {
        changed = changed && left === previous;
    }
    return changed;
}
function compareValues(previousData, data, options) {
    var key = options.key, type = options.type, value = options.value;
    var left = nested(previousData, key);
    var right = nested(data, key);
    var primary = type === 'added' ? left : right;
    var secondary = type === 'added' ? right : left;
    // console.log({ primary, secondary });
    if (!is$1.nullOrUndefined(value)) {
        if (is$1.defined(primary)) {
            // check if nested data matches
            if (is$1.array(primary) || is$1.plainObject(primary)) {
                return checkEquality(primary, secondary, value);
            }
        }
        else {
            return equal(secondary, value);
        }
        return false;
    }
    if ([left, right].every(is$1.array)) {
        return !secondary.every(isEqualPredicate(primary));
    }
    if ([left, right].every(is$1.plainObject)) {
        return hasExtraKeys(Object.keys(primary), Object.keys(secondary));
    }
    return (![left, right].every(function (d) { return is$1.primitive(d) && is$1.defined(d); }) &&
        (type === 'added'
            ? !is$1.defined(left) && is$1.defined(right)
            : is$1.defined(left) && !is$1.defined(right)));
}
function getIterables(previousData, data, _a) {
    var _b = _a === void 0 ? {} : _a, key = _b.key;
    var left = nested(previousData, key);
    var right = nested(data, key);
    if (!isSameType(left, right)) {
        throw new TypeError('Inputs have different types');
    }
    if (!canHaveLength(left, right)) {
        throw new TypeError("Inputs don't have length");
    }
    if ([left, right].every(is$1.plainObject)) {
        left = Object.keys(left);
        right = Object.keys(right);
    }
    return [left, right];
}
function hasEntry(input) {
    return function (_a) {
        var key = _a[0], value = _a[1];
        if (is$1.array(input)) {
            return (equal(input, value) ||
                input.some(function (d) { return equal(d, value) || (is$1.array(value) && isEqualPredicate(value)(d)); }));
        }
        /* istanbul ignore else */
        if (is$1.plainObject(input) && input[key]) {
            return !!input[key] && equal(input[key], value);
        }
        return equal(input, value);
    };
}
function hasExtraKeys(left, right) {
    return right.some(function (d) { return !left.includes(d); });
}
function hasValue(input) {
    return function (value) {
        if (is$1.array(input)) {
            return input.some(function (d) { return equal(d, value) || (is$1.array(value) && isEqualPredicate(value)(d)); });
        }
        return equal(input, value);
    };
}
function includesOrEqualsTo(previousValue, value) {
    return is$1.array(previousValue)
        ? previousValue.some(function (d) { return equal(d, value); })
        : equal(previousValue, value);
}
function isEqualPredicate(data) {
    return function (value) { return data.some(function (d) { return equal(d, value); }); };
}
function isSameType() {
    var arguments_ = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        arguments_[_i] = arguments[_i];
    }
    return (arguments_.every(is$1.array) ||
        arguments_.every(is$1.number) ||
        arguments_.every(is$1.plainObject) ||
        arguments_.every(is$1.string));
}
function nested(data, property) {
    /* istanbul ignore else */
    if (is$1.plainObject(data) || is$1.array(data)) {
        /* istanbul ignore else */
        if (is$1.string(property)) {
            var props = property.split('.');
            return props.reduce(function (acc, d) { return acc && acc[d]; }, data);
        }
        /* istanbul ignore else */
        if (is$1.number(property)) {
            return data[property];
        }
        return data;
    }
    return data;
}

function treeChanges(previousData, data) {
    if ([previousData, data].some(is$1.nullOrUndefined)) {
        throw new Error('Missing required parameters');
    }
    if (![previousData, data].every(function (d) { return is$1.plainObject(d) || is$1.array(d); })) {
        throw new Error('Expected plain objects or array');
    }
    var added = function (key, value) {
        try {
            return compareValues(previousData, data, { key: key, type: 'added', value: value });
        }
        catch (_a) {
            /* istanbul ignore next */
            return false;
        }
    };
    var changed = function (key, actual, previous) {
        try {
            var left = nested(previousData, key);
            var right = nested(data, key);
            var hasActual = is$1.defined(actual);
            var hasPrevious = is$1.defined(previous);
            if (hasActual || hasPrevious) {
                var leftComparator = hasPrevious
                    ? includesOrEqualsTo(previous, left)
                    : !includesOrEqualsTo(actual, left);
                var rightComparator = includesOrEqualsTo(actual, right);
                return leftComparator && rightComparator;
            }
            if ([left, right].every(is$1.array) || [left, right].every(is$1.plainObject)) {
                return !equal(left, right);
            }
            return left !== right;
        }
        catch (_a) {
            /* istanbul ignore next */
            return false;
        }
    };
    var changedFrom = function (key, previous, actual) {
        if (!is$1.defined(key)) {
            return false;
        }
        try {
            var left = nested(previousData, key);
            var right = nested(data, key);
            var hasActual = is$1.defined(actual);
            return (includesOrEqualsTo(previous, left) &&
                (hasActual ? includesOrEqualsTo(actual, right) : !hasActual));
        }
        catch (_a) {
            /* istanbul ignore next */
            return false;
        }
    };
    /**
     * @deprecated
     * Use "changed" instead
     */
    var changedTo = function (key, actual) {
        if (!is$1.defined(key)) {
            return false;
        }
        /* istanbul ignore next */
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn('`changedTo` is deprecated! Replace it with `change`');
        }
        return changed(key, actual);
    };
    var decreased = function (key, actual, previous) {
        if (!is$1.defined(key)) {
            return false;
        }
        try {
            return compareNumbers(previousData, data, { key: key, actual: actual, previous: previous, type: 'decreased' });
        }
        catch (_a) {
            /* istanbul ignore next */
            return false;
        }
    };
    var emptied = function (key) {
        try {
            var _a = getIterables(previousData, data, { key: key }), left = _a[0], right = _a[1];
            return !!left.length && !right.length;
        }
        catch (_b) {
            /* istanbul ignore next */
            return false;
        }
    };
    var filled = function (key) {
        try {
            var _a = getIterables(previousData, data, { key: key }), left = _a[0], right = _a[1];
            return !left.length && !!right.length;
        }
        catch (_b) {
            /* istanbul ignore next */
            return false;
        }
    };
    var increased = function (key, actual, previous) {
        if (!is$1.defined(key)) {
            return false;
        }
        try {
            return compareNumbers(previousData, data, { key: key, actual: actual, previous: previous, type: 'increased' });
        }
        catch (_a) {
            /* istanbul ignore next */
            return false;
        }
    };
    var removed = function (key, value) {
        try {
            return compareValues(previousData, data, { key: key, type: 'removed', value: value });
        }
        catch (_a) {
            /* istanbul ignore next */
            return false;
        }
    };
    return { added: added, changed: changed, changedFrom: changedFrom, changedTo: changedTo, decreased: decreased, emptied: emptied, filled: filled, increased: increased, removed: removed };
}

// src/index.ts
var DOM_PROPERTIES_TO_CHECK = [
  "innerHTML",
  "ownerDocument",
  "style",
  "attributes",
  "nodeValue"
];
var objectTypes = [
  "Array",
  "ArrayBuffer",
  "AsyncFunction",
  "AsyncGenerator",
  "AsyncGeneratorFunction",
  "Date",
  "Error",
  "Function",
  "Generator",
  "GeneratorFunction",
  "HTMLElement",
  "Map",
  "Object",
  "Promise",
  "RegExp",
  "Set",
  "WeakMap",
  "WeakSet"
];
var primitiveTypes = [
  "bigint",
  "boolean",
  "null",
  "number",
  "string",
  "symbol",
  "undefined"
];
function getObjectType$1(value) {
  const objectTypeName = Object.prototype.toString.call(value).slice(8, -1);
  if (/HTML\w+Element/.test(objectTypeName)) {
    return "HTMLElement";
  }
  if (isObjectType$1(objectTypeName)) {
    return objectTypeName;
  }
  return void 0;
}
function isObjectOfType(type) {
  return (value) => getObjectType$1(value) === type;
}
function isObjectType$1(name) {
  return objectTypes.includes(name);
}
function isOfType(type) {
  return (value) => typeof value === type;
}
function isPrimitiveType(name) {
  return primitiveTypes.includes(name);
}
function is(value) {
  if (value === null) {
    return "null";
  }
  switch (typeof value) {
    case "bigint":
      return "bigint";
    case "boolean":
      return "boolean";
    case "number":
      return "number";
    case "string":
      return "string";
    case "symbol":
      return "symbol";
    case "undefined":
      return "undefined";
  }
  if (is.array(value)) {
    return "Array";
  }
  if (is.plainFunction(value)) {
    return "Function";
  }
  const tagType = getObjectType$1(value);
  if (tagType) {
    return tagType;
  }
  return "Object";
}
is.array = Array.isArray;
is.arrayOf = (target, predicate) => {
  if (!is.array(target) && !is.function(predicate)) {
    return false;
  }
  return target.every((d) => predicate(d));
};
is.asyncGeneratorFunction = (value) => getObjectType$1(value) === "AsyncGeneratorFunction";
is.asyncFunction = isObjectOfType("AsyncFunction");
is.bigint = isOfType("bigint");
is.boolean = (value) => {
  return value === true || value === false;
};
is.date = isObjectOfType("Date");
is.defined = (value) => !is.undefined(value);
is.domElement = (value) => {
  return is.object(value) && !is.plainObject(value) && value.nodeType === 1 && is.string(value.nodeName) && DOM_PROPERTIES_TO_CHECK.every((property) => property in value);
};
is.empty = (value) => {
  return is.string(value) && value.length === 0 || is.array(value) && value.length === 0 || is.object(value) && !is.map(value) && !is.set(value) && Object.keys(value).length === 0 || is.set(value) && value.size === 0 || is.map(value) && value.size === 0;
};
is.error = isObjectOfType("Error");
is.function = isOfType("function");
is.generator = (value) => {
  return is.iterable(value) && is.function(value.next) && is.function(value.throw);
};
is.generatorFunction = isObjectOfType("GeneratorFunction");
is.instanceOf = (instance, class_) => {
  if (!instance || !class_) {
    return false;
  }
  return Object.getPrototypeOf(instance) === class_.prototype;
};
is.iterable = (value) => {
  return !is.nullOrUndefined(value) && is.function(value[Symbol.iterator]);
};
is.map = isObjectOfType("Map");
is.nan = (value) => {
  return Number.isNaN(value);
};
is.null = (value) => {
  return value === null;
};
is.nullOrUndefined = (value) => {
  return is.null(value) || is.undefined(value);
};
is.number = (value) => {
  return isOfType("number")(value) && !is.nan(value);
};
is.numericString = (value) => {
  return is.string(value) && value.length > 0 && !Number.isNaN(Number(value));
};
is.object = (value) => {
  return !is.nullOrUndefined(value) && (is.function(value) || typeof value === "object");
};
is.oneOf = (target, value) => {
  if (!is.array(target)) {
    return false;
  }
  return target.indexOf(value) > -1;
};
is.plainFunction = isObjectOfType("Function");
is.plainObject = (value) => {
  if (getObjectType$1(value) !== "Object") {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return prototype === null || prototype === Object.getPrototypeOf({});
};
is.primitive = (value) => is.null(value) || isPrimitiveType(typeof value);
is.promise = isObjectOfType("Promise");
is.propertyOf = (target, key, predicate) => {
  if (!is.object(target) || !key) {
    return false;
  }
  const value = target[key];
  if (is.function(predicate)) {
    return predicate(value);
  }
  return is.defined(value);
};
is.regexp = isObjectOfType("RegExp");
is.set = isObjectOfType("Set");
is.string = isOfType("string");
is.symbol = isOfType("symbol");
is.undefined = isOfType("undefined");
is.weakMap = isObjectOfType("WeakMap");
is.weakSet = isObjectOfType("WeakSet");
var src_default = is;

var exenvExports = {};
var exenv = {
  get exports(){ return exenvExports; },
  set exports(v){ exenvExports = v; },
};

/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function (module) {
	/* global define */

	(function () {

		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);

		var ExecutionEnvironment = {

			canUseDOM: canUseDOM,

			canUseWorkers: typeof Worker !== 'undefined',

			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),

			canUseViewport: canUseDOM && !!window.screen

		};

		if (module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}

	}());
} (exenv));

var ExecutionEnvironment = exenvExports;

var E_NOSCROLL = new Error('Element already at target scroll position');
var E_CANCELLED = new Error('Scroll cancelled');
var min = Math.min;
var ms = Date.now;

var scroll$1 = {
  left: make('scrollLeft'),
  top: make('scrollTop')
};

function make (prop) {
  return function scroll (el, to, opts, cb) {
    opts = opts || {};

    if (typeof opts == 'function') cb = opts, opts = {};
    if (typeof cb != 'function') cb = noop$1;

    var start = ms();
    var from = el[prop];
    var ease = opts.ease || inOutSine;
    var duration = !isNaN(opts.duration) ? +opts.duration : 350;
    var cancelled = false;

    return from === to ?
      cb(E_NOSCROLL, el[prop]) :
      requestAnimationFrame(animate), cancel

    function cancel () {
      cancelled = true;
    }

    function animate (timestamp) {
      if (cancelled) return cb(E_CANCELLED, el[prop])

      var now = ms();
      var time = min(1, ((now - start) / duration));
      var eased = ease(time);

      el[prop] = (eased * (to - from)) + from;

      time < 1 ?
        requestAnimationFrame(animate) :
        requestAnimationFrame(function () {
          cb(null, el[prop]);
        });
    }
  }
}

function inOutSine (n) {
  return 0.5 * (1 - Math.cos(Math.PI * n))
}

function noop$1 () {}

var scrollparentExports = {};
var scrollparent = {
  get exports(){ return scrollparentExports; },
  set exports(v){ scrollparentExports = v; },
};

(function (module) {
	(function (root, factory) {
	  if (module.exports) {
	    module.exports = factory();
	  } else {
	    root.Scrollparent = factory();
	  }
	}(commonjsGlobal, function () {
	  var regex = /(auto|scroll)/;

	  var parents = function (node, ps) {
	    if (node.parentNode === null) { return ps; }

	    return parents(node.parentNode, ps.concat([node]));
	  };

	  var style = function (node, prop) {
	    return getComputedStyle(node, null).getPropertyValue(prop);
	  };

	  var overflow = function (node) {
	    return style(node, "overflow") + style(node, "overflow-y") + style(node, "overflow-x");
	  };

	  var scroll = function (node) {
	   return regex.test(overflow(node));
	  };

	  var scrollParent = function (node) {
	    if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
	      return ;
	    }

	    var ps = parents(node.parentNode, []);

	    for (var i = 0; i < ps.length; i += 1) {
	      if (scroll(ps[i])) {
	        return ps[i];
	      }
	    }

	    return document.scrollingElement || document.documentElement;
	  };

	  return scrollParent;
	}));
} (scrollparent));

var scrollParent = scrollparentExports;

var reactIsExports = requireReactIs();

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

var cjs = deepmerge_1;

var isRequiredIf$1 = {};

Object.defineProperty(isRequiredIf$1,'__esModule',{value:!0});var VALIDATOR_ARG_ERROR_MESSAGE='The typeValidator argument must be a function with the signature function(props, propName, componentName).',MESSAGE_ARG_ERROR_MESSAGE='The error message is optional, but must be a string if provided.',propIsRequired=function propIsRequired(a,b,c,d){if('boolean'==typeof a)return a;return 'function'==typeof a?a(b,c,d):!(!0!==!!a)&&!!a},propExists=function propExists(a,b){return Object.hasOwnProperty.call(a,b)},missingPropError=function missingPropError(a,b,c,d){return d?new Error(d):new Error('Required '+a[b]+' `'+b+'`'+(' was not specified in `'+c+'`.'))},guardAgainstInvalidArgTypes=function guardAgainstInvalidArgTypes(a,b){if('function'!=typeof a)throw new TypeError(VALIDATOR_ARG_ERROR_MESSAGE);if(!!b&&'string'!=typeof b)throw new TypeError(MESSAGE_ARG_ERROR_MESSAGE)},isRequiredIf=function isRequiredIf(a,b,c){return guardAgainstInvalidArgTypes(a,c),function(d,e,f){for(var _len=arguments.length,g=Array(3<_len?_len-3:0),_key=3;_key<_len;_key++)g[_key-3]=arguments[_key];return propIsRequired(b,d,e,f)?propExists(d,e)?a.apply(void 0,[d,e,f].concat(g)):missingPropError(d,e,f,c):a.apply(void 0,[d,e,f].concat(g));// Is not required, so just run typeValidator.
}};var _default = isRequiredIf$1.default=isRequiredIf;

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction$1(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty$1(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent$1(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty$1(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent$1(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty$1(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty$1 = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect$1(offsets) {
  return _extends$1({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty$1(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect$1(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent$1(children);

  var styles = getStyleComputedProperty$1(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect$1({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect$1(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty$1(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty$1(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent$1(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends$1({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex$1(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex$1(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction$1(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect$1(data.offsets.popper);
      data.offsets.reference = getClientRect$1(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent$1(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent$1(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends$1({}, attributes, data.attributes);
  data.styles = _extends$1({}, styles, data.styles);
  data.arrowStyles = _extends$1({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect$1(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty$1(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty$1(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty$1(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends$1({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect$1(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty$1({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty$1({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends$1({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty$1({}, side, reference[side]),
      end: defineProperty$1({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends$1({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect$1(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends$1({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends$1({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends$1({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends$1({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction$1(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

var Popper$1 = Popper;

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$1(o, p);
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$3(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$2(self);
}

function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$3(this, result);
  };
}

var DEFAULTS$1 = {flip:{padding:20},preventOverflow:{padding:10}};

var STATUS$1 = {INIT:'init',IDLE:'idle',OPENING:'opening',OPEN:'open',CLOSING:'closing',ERROR:'error'};

var canUseDOM$2=ExecutionEnvironment.canUseDOM;var isReact16$1=ReactDOM.createPortal!==undefined;function isMobile(){return 'ontouchstart'in window&&/Mobi/.test(navigator.userAgent);}/**
 * Log method calls if debug is enabled
 *
 * @private
 * @param {Object}       arg
 * @param {string}       arg.title    - The title the logger was called from
 * @param {Object|Array} [arg.data]   - The data to be logged
 * @param {boolean}      [arg.warn]  - If true, the message will be a warning
 * @param {boolean}      [arg.debug] - Nothing will be logged unless debug is true
 */function log$1(_ref){var title=_ref.title,data=_ref.data,_ref$warn=_ref.warn,warn=_ref$warn===void 0?false:_ref$warn,_ref$debug=_ref.debug,debug=_ref$debug===void 0?false:_ref$debug;/* eslint-disable no-console */var logFn=warn?console.warn||console.error:console.log;if(debug&&title&&data){console.groupCollapsed("%creact-floater: ".concat(title),'color: #9b00ff; font-weight: bold; font-size: 12px;');if(Array.isArray(data)){data.forEach(function(d){if(is$1.plainObject(d)&&d.key){logFn.apply(console,[d.key,d.value]);}else {logFn.apply(console,[d]);}});}else {logFn.apply(console,[data]);}console.groupEnd();}/* eslint-enable */}function on(element,event,cb){var capture=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;element.addEventListener(event,cb,capture);}function off(element,event,cb){var capture=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;element.removeEventListener(event,cb,capture);}function once(element,event,cb){var capture=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var _nextCB;// eslint-disable-next-line prefer-const
_nextCB=function nextCB(e){cb(e);off(element,event,_nextCB);};on(element,event,_nextCB,capture);}function noop(){}

var ReactFloaterPortal=/*#__PURE__*/function(_React$Component){_inherits$3(ReactFloaterPortal,_React$Component);var _super=_createSuper$1(ReactFloaterPortal);function ReactFloaterPortal(){_classCallCheck$3(this,ReactFloaterPortal);return _super.apply(this,arguments);}_createClass$3(ReactFloaterPortal,[{key:"componentDidMount",value:function componentDidMount(){if(!canUseDOM$2)return;if(!this.node){this.appendNode();}if(!isReact16$1){this.renderPortal();}}},{key:"componentDidUpdate",value:function componentDidUpdate(){if(!canUseDOM$2)return;if(!isReact16$1){this.renderPortal();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(!canUseDOM$2||!this.node)return;if(!isReact16$1){ReactDOM.unmountComponentAtNode(this.node);}if(this.node&&this.node.parentNode===document.body){document.body.removeChild(this.node);this.node=undefined;}}},{key:"appendNode",value:function appendNode(){var _this$props=this.props,id=_this$props.id,zIndex=_this$props.zIndex;if(!this.node){this.node=document.createElement('div');/* istanbul ignore else */if(id){this.node.id=id;}if(zIndex){this.node.style.zIndex=zIndex;}document.body.appendChild(this.node);}}},{key:"renderPortal",value:function renderPortal(){if(!canUseDOM$2)return null;var _this$props2=this.props,children=_this$props2.children,setRef=_this$props2.setRef;if(!this.node){this.appendNode();}/* istanbul ignore else */if(isReact16$1){return/*#__PURE__*/ReactDOM.createPortal(children,this.node);}var portal=ReactDOM.unstable_renderSubtreeIntoContainer(this,children.length>1?/*#__PURE__*/React.createElement("div",null,children):children[0],this.node);setRef(portal);return null;}},{key:"renderReact16",value:function renderReact16(){var _this$props3=this.props,hasChildren=_this$props3.hasChildren,placement=_this$props3.placement,target=_this$props3.target;if(!hasChildren){if(target||placement==='center'){return this.renderPortal();}return null;}return this.renderPortal();}},{key:"render",value:function render(){if(!isReact16$1){return null;}return this.renderReact16();}}]);return ReactFloaterPortal;}(React.Component);_defineProperty$1(ReactFloaterPortal,"propTypes",{children:propTypesExports.oneOfType([propTypesExports.element,propTypesExports.array]),hasChildren:propTypesExports.bool,id:propTypesExports.oneOfType([propTypesExports.string,propTypesExports.number]),placement:propTypesExports.string,setRef:propTypesExports.func.isRequired,target:propTypesExports.oneOfType([propTypesExports.object,propTypesExports.string]),zIndex:propTypesExports.number});

var FloaterArrow=/*#__PURE__*/function(_React$Component){_inherits$3(FloaterArrow,_React$Component);var _super=_createSuper$1(FloaterArrow);function FloaterArrow(){_classCallCheck$3(this,FloaterArrow);return _super.apply(this,arguments);}_createClass$3(FloaterArrow,[{key:"parentStyle",get:function get(){var _this$props=this.props,placement=_this$props.placement,styles=_this$props.styles;var length=styles.arrow.length;var arrow={pointerEvents:'none',position:'absolute',width:'100%'};/* istanbul ignore else */if(placement.startsWith('top')){arrow.bottom=0;arrow.left=0;arrow.right=0;arrow.height=length;}else if(placement.startsWith('bottom')){arrow.left=0;arrow.right=0;arrow.top=0;arrow.height=length;}else if(placement.startsWith('left')){arrow.right=0;arrow.top=0;arrow.bottom=0;}else if(placement.startsWith('right')){arrow.left=0;arrow.top=0;}return arrow;}},{key:"render",value:function render(){var _this$props2=this.props,placement=_this$props2.placement,setArrowRef=_this$props2.setArrowRef,styles=_this$props2.styles;var _styles$arrow=styles.arrow,color=_styles$arrow.color,display=_styles$arrow.display,length=_styles$arrow.length,margin=_styles$arrow.margin,position=_styles$arrow.position,spread=_styles$arrow.spread;var arrowStyles={display:display,position:position};var points;var x=spread;var y=length;/* istanbul ignore else */if(placement.startsWith('top')){points="0,0 ".concat(x/2,",").concat(y," ").concat(x,",0");arrowStyles.bottom=0;arrowStyles.marginLeft=margin;arrowStyles.marginRight=margin;}else if(placement.startsWith('bottom')){points="".concat(x,",").concat(y," ").concat(x/2,",0 0,").concat(y);arrowStyles.top=0;arrowStyles.marginLeft=margin;arrowStyles.marginRight=margin;}else if(placement.startsWith('left')){y=spread;x=length;points="0,0 ".concat(x,",").concat(y/2," 0,").concat(y);arrowStyles.right=0;arrowStyles.marginTop=margin;arrowStyles.marginBottom=margin;}else if(placement.startsWith('right')){y=spread;x=length;points="".concat(x,",").concat(y," ").concat(x,",0 0,").concat(y/2);arrowStyles.left=0;arrowStyles.marginTop=margin;arrowStyles.marginBottom=margin;}return/*#__PURE__*/React.createElement("div",{className:"__floater__arrow",style:this.parentStyle},/*#__PURE__*/React.createElement("span",{ref:setArrowRef,style:arrowStyles},/*#__PURE__*/React.createElement("svg",{width:x,height:y,version:"1.1",xmlns:"http://www.w3.org/2000/svg"},/*#__PURE__*/React.createElement("polygon",{points:points,fill:color}))));}}]);return FloaterArrow;}(React.Component);_defineProperty$1(FloaterArrow,"propTypes",{placement:propTypesExports.string.isRequired,setArrowRef:propTypesExports.func.isRequired,styles:propTypesExports.object.isRequired});

var _excluded$1$1=["color","height","width"];var FloaterCloseBtn=function FloaterCloseBtn(_ref){var handleClick=_ref.handleClick,styles=_ref.styles;var color=styles.color,height=styles.height,width=styles.width,style=_objectWithoutProperties$1(styles,_excluded$1$1);return/*#__PURE__*/React.createElement("button",{"aria-label":"close",onClick:handleClick,style:style,type:"button"},/*#__PURE__*/React.createElement("svg",{width:"".concat(width,"px"),height:"".concat(height,"px"),viewBox:"0 0 18 18",version:"1.1",xmlns:"http://www.w3.org/2000/svg",preserveAspectRatio:"xMidYMid"},/*#__PURE__*/React.createElement("g",null,/*#__PURE__*/React.createElement("path",{d:"M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z",fill:color}))));};FloaterCloseBtn.propTypes={handleClick:propTypesExports.func.isRequired,styles:propTypesExports.object.isRequired};

var FloaterContainer=function FloaterContainer(_ref){var content=_ref.content,footer=_ref.footer,handleClick=_ref.handleClick,open=_ref.open,positionWrapper=_ref.positionWrapper,showCloseButton=_ref.showCloseButton,title=_ref.title,styles=_ref.styles;var output={content:/*#__PURE__*/React.isValidElement(content)?content:/*#__PURE__*/React.createElement("div",{className:"__floater__content",style:styles.content},content)};if(title){output.title=/*#__PURE__*/React.isValidElement(title)?title:/*#__PURE__*/React.createElement("div",{className:"__floater__title",style:styles.title},title);}if(footer){output.footer=/*#__PURE__*/React.isValidElement(footer)?footer:/*#__PURE__*/React.createElement("div",{className:"__floater__footer",style:styles.footer},footer);}if((showCloseButton||positionWrapper)&&!is$1["boolean"](open)){output.close=/*#__PURE__*/React.createElement(FloaterCloseBtn,{styles:styles.close,handleClick:handleClick});}return/*#__PURE__*/React.createElement("div",{className:"__floater__container",style:styles.container},output.close,output.title,output.content,output.footer);};FloaterContainer.propTypes={content:propTypesExports.node.isRequired,footer:propTypesExports.node,handleClick:propTypesExports.func.isRequired,open:propTypesExports.bool,positionWrapper:propTypesExports.bool.isRequired,showCloseButton:propTypesExports.bool.isRequired,styles:propTypesExports.object.isRequired,title:propTypesExports.node};

var Floater=/*#__PURE__*/function(_React$Component){_inherits$3(Floater,_React$Component);var _super=_createSuper$1(Floater);function Floater(){_classCallCheck$3(this,Floater);return _super.apply(this,arguments);}_createClass$3(Floater,[{key:"style",get:function get(){var _this$props=this.props,disableAnimation=_this$props.disableAnimation,component=_this$props.component,placement=_this$props.placement,hideArrow=_this$props.hideArrow,status=_this$props.status,styles=_this$props.styles;var length=styles.arrow.length,floater=styles.floater,floaterCentered=styles.floaterCentered,floaterClosing=styles.floaterClosing,floaterOpening=styles.floaterOpening,floaterWithAnimation=styles.floaterWithAnimation,floaterWithComponent=styles.floaterWithComponent;var element={};if(!hideArrow){if(placement.startsWith('top')){element.padding="0 0 ".concat(length,"px");}else if(placement.startsWith('bottom')){element.padding="".concat(length,"px 0 0");}else if(placement.startsWith('left')){element.padding="0 ".concat(length,"px 0 0");}else if(placement.startsWith('right')){element.padding="0 0 0 ".concat(length,"px");}}if([STATUS$1.OPENING,STATUS$1.OPEN].indexOf(status)!==-1){element=_objectSpread2$1(_objectSpread2$1({},element),floaterOpening);}if(status===STATUS$1.CLOSING){element=_objectSpread2$1(_objectSpread2$1({},element),floaterClosing);}if(status===STATUS$1.OPEN&&!disableAnimation){element=_objectSpread2$1(_objectSpread2$1({},element),floaterWithAnimation);}if(placement==='center'){element=_objectSpread2$1(_objectSpread2$1({},element),floaterCentered);}if(component){element=_objectSpread2$1(_objectSpread2$1({},element),floaterWithComponent);}return _objectSpread2$1(_objectSpread2$1({},floater),element);}},{key:"render",value:function render(){var _this$props2=this.props,component=_this$props2.component,closeFn=_this$props2.handleClick,hideArrow=_this$props2.hideArrow,setFloaterRef=_this$props2.setFloaterRef,status=_this$props2.status;var output={};var classes=['__floater'];if(component){if(/*#__PURE__*/React.isValidElement(component)){output.content=/*#__PURE__*/React.cloneElement(component,{closeFn:closeFn});}else {output.content=component({closeFn:closeFn});}}else {output.content=/*#__PURE__*/React.createElement(FloaterContainer,this.props);}if(status===STATUS$1.OPEN){classes.push('__floater__open');}if(!hideArrow){output.arrow=/*#__PURE__*/React.createElement(FloaterArrow,this.props);}return/*#__PURE__*/React.createElement("div",{ref:setFloaterRef,className:classes.join(' '),style:this.style},/*#__PURE__*/React.createElement("div",{className:"__floater__body"},output.content,output.arrow));}}]);return Floater;}(React.Component);_defineProperty$1(Floater,"propTypes",{component:propTypesExports.oneOfType([propTypesExports.func,propTypesExports.element]),content:propTypesExports.node,disableAnimation:propTypesExports.bool.isRequired,footer:propTypesExports.node,handleClick:propTypesExports.func.isRequired,hideArrow:propTypesExports.bool.isRequired,open:propTypesExports.bool,placement:propTypesExports.string.isRequired,positionWrapper:propTypesExports.bool.isRequired,setArrowRef:propTypesExports.func.isRequired,setFloaterRef:propTypesExports.func.isRequired,showCloseButton:propTypesExports.bool,status:propTypesExports.string.isRequired,styles:propTypesExports.object.isRequired,title:propTypesExports.node});

var ReactFloaterWrapper=/*#__PURE__*/function(_React$Component){_inherits$3(ReactFloaterWrapper,_React$Component);var _super=_createSuper$1(ReactFloaterWrapper);function ReactFloaterWrapper(){_classCallCheck$3(this,ReactFloaterWrapper);return _super.apply(this,arguments);}_createClass$3(ReactFloaterWrapper,[{key:"render",value:function render(){var _this$props=this.props,children=_this$props.children,handleClick=_this$props.handleClick,handleMouseEnter=_this$props.handleMouseEnter,handleMouseLeave=_this$props.handleMouseLeave,setChildRef=_this$props.setChildRef,setWrapperRef=_this$props.setWrapperRef,style=_this$props.style,styles=_this$props.styles;var element;/* istanbul ignore else */if(children){if(React.Children.count(children)===1){if(!/*#__PURE__*/React.isValidElement(children)){element=/*#__PURE__*/React.createElement("span",null,children);}else {var refProp=is$1["function"](children.type)?'innerRef':'ref';element=/*#__PURE__*/React.cloneElement(React.Children.only(children),_defineProperty$1({},refProp,setChildRef));}}else {element=children;}}if(!element){return null;}return/*#__PURE__*/React.createElement("span",{ref:setWrapperRef,style:_objectSpread2$1(_objectSpread2$1({},styles),style),onClick:handleClick,onMouseEnter:handleMouseEnter,onMouseLeave:handleMouseLeave},element);}}]);return ReactFloaterWrapper;}(React.Component);_defineProperty$1(ReactFloaterWrapper,"propTypes",{children:propTypesExports.node,handleClick:propTypesExports.func.isRequired,handleMouseEnter:propTypesExports.func.isRequired,handleMouseLeave:propTypesExports.func.isRequired,setChildRef:propTypesExports.func.isRequired,setWrapperRef:propTypesExports.func.isRequired,style:propTypesExports.object,styles:propTypesExports.object.isRequired});

var defaultOptions$2={zIndex:100};function getStyles$1(styles){var options=cjs(defaultOptions$2,styles.options||{});return {wrapper:{cursor:'help',display:'inline-flex',flexDirection:'column',zIndex:options.zIndex},wrapperPosition:{left:-1000,position:'absolute',top:-1000,visibility:'hidden'},floater:{display:'inline-block',filter:'drop-shadow(0 0 3px rgba(0, 0, 0, 0.3))',maxWidth:300,opacity:0,position:'relative',transition:'opacity 0.3s',visibility:'hidden',zIndex:options.zIndex},floaterOpening:{opacity:1,visibility:'visible'},floaterWithAnimation:{opacity:1,transition:'opacity 0.3s, transform 0.2s',visibility:'visible'},floaterWithComponent:{maxWidth:'100%'},floaterClosing:{opacity:0,visibility:'visible'},floaterCentered:{left:'50%',position:'fixed',top:'50%',transform:'translate(-50%, -50%)'},container:{backgroundColor:'#fff',color:'#666',minHeight:60,minWidth:200,padding:20,position:'relative',zIndex:10},title:{borderBottom:'1px solid #555',color:'#555',fontSize:18,marginBottom:5,paddingBottom:6,paddingRight:18},content:{fontSize:15},close:{backgroundColor:'transparent',border:0,borderRadius:0,color:'#555',fontSize:0,height:15,outline:'none',padding:10,position:'absolute',right:0,top:0,width:15,WebkitAppearance:'none'},footer:{borderTop:'1px solid #ccc',fontSize:13,marginTop:10,paddingTop:5},arrow:{color:'#fff',display:'inline-flex',length:16,margin:8,position:'absolute',spread:32},options:options};}

var _excluded$3=["arrow","flip","offset"];var POSITIONING_PROPS=['position','top','right','bottom','left'];var ReactFloater=/*#__PURE__*/function(_React$Component){_inherits$3(ReactFloater,_React$Component);var _super=_createSuper$1(ReactFloater);function ReactFloater(props){var _this;_classCallCheck$3(this,ReactFloater);_this=_super.call(this,props);/* istanbul ignore else */_defineProperty$1(_assertThisInitialized$2(_this),"setArrowRef",function(ref){_this.arrowRef=ref;});_defineProperty$1(_assertThisInitialized$2(_this),"setChildRef",function(ref){_this.childRef=ref;});_defineProperty$1(_assertThisInitialized$2(_this),"setFloaterRef",function(ref){_this.floaterRef=ref;});_defineProperty$1(_assertThisInitialized$2(_this),"setWrapperRef",function(ref){_this.wrapperRef=ref;});_defineProperty$1(_assertThisInitialized$2(_this),"handleTransitionEnd",function(){var status=_this.state.status;var callback=_this.props.callback;/* istanbul ignore else */if(_this.wrapperPopper){_this.wrapperPopper.instance.update();}_this.setState({status:status===STATUS$1.OPENING?STATUS$1.OPEN:STATUS$1.IDLE},function(){var newStatus=_this.state.status;callback(newStatus===STATUS$1.OPEN?'open':'close',_this.props);});});_defineProperty$1(_assertThisInitialized$2(_this),"handleClick",function(){var _this$props=_this.props,event=_this$props.event,open=_this$props.open;if(is$1["boolean"](open))return;var _this$state=_this.state,positionWrapper=_this$state.positionWrapper,status=_this$state.status;/* istanbul ignore else */if(_this.event==='click'||_this.event==='hover'&&positionWrapper){log$1({title:'click',data:[{event:event,status:status===STATUS$1.OPEN?'closing':'opening'}],debug:_this.debug});_this.toggle();}});_defineProperty$1(_assertThisInitialized$2(_this),"handleMouseEnter",function(){var _this$props2=_this.props,event=_this$props2.event,open=_this$props2.open;if(is$1["boolean"](open)||isMobile())return;var status=_this.state.status;/* istanbul ignore else */if(_this.event==='hover'&&status===STATUS$1.IDLE){log$1({title:'mouseEnter',data:[{key:'originalEvent',value:event}],debug:_this.debug});clearTimeout(_this.eventDelayTimeout);_this.toggle();}});_defineProperty$1(_assertThisInitialized$2(_this),"handleMouseLeave",function(){var _this$props3=_this.props,event=_this$props3.event,eventDelay=_this$props3.eventDelay,open=_this$props3.open;if(is$1["boolean"](open)||isMobile())return;var _this$state2=_this.state,status=_this$state2.status,positionWrapper=_this$state2.positionWrapper;/* istanbul ignore else */if(_this.event==='hover'){log$1({title:'mouseLeave',data:[{key:'originalEvent',value:event}],debug:_this.debug});if(!eventDelay){_this.toggle(STATUS$1.IDLE);}else if([STATUS$1.OPENING,STATUS$1.OPEN].indexOf(status)!==-1&&!positionWrapper&&!_this.eventDelayTimeout){_this.eventDelayTimeout=setTimeout(function(){delete _this.eventDelayTimeout;_this.toggle();},eventDelay*1000);}}});_this.state={currentPlacement:props.placement,needsUpdate:false,positionWrapper:props.wrapperOptions.position&&!!props.target,status:STATUS$1.INIT,statusWrapper:STATUS$1.INIT};_this._isMounted=false;_this.hasMounted=false;if(canUseDOM$2){window.addEventListener('load',function(){if(_this.popper){_this.popper.instance.update();}if(_this.wrapperPopper){_this.wrapperPopper.instance.update();}});}return _this;}_createClass$3(ReactFloater,[{key:"componentDidMount",value:function componentDidMount(){if(!canUseDOM$2)return;var positionWrapper=this.state.positionWrapper;var _this$props5=this.props,children=_this$props5.children,open=_this$props5.open,target=_this$props5.target;this._isMounted=true;log$1({title:'init',data:{hasChildren:!!children,hasTarget:!!target,isControlled:is$1["boolean"](open),positionWrapper:positionWrapper,target:this.target,floater:this.floaterRef},debug:this.debug});if(!this.hasMounted){this.initPopper();this.hasMounted=true;}if(!children&&target&&!is$1["boolean"](open));}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){if(!canUseDOM$2)return;var _this$props6=this.props,autoOpen=_this$props6.autoOpen,open=_this$props6.open,target=_this$props6.target,wrapperOptions=_this$props6.wrapperOptions;var _treeChanges=treeChanges(prevState,this.state),changedFrom=_treeChanges.changedFrom,changed=_treeChanges.changed;if(prevProps.open!==open){var forceStatus;// always follow `open` in controlled mode
if(is$1["boolean"](open)){forceStatus=open?STATUS$1.OPENING:STATUS$1.CLOSING;}this.toggle(forceStatus);}if(prevProps.wrapperOptions.position!==wrapperOptions.position||prevProps.target!==target){this.changeWrapperPosition(this.props);}if(changed('status',STATUS$1.IDLE)&&open){this.toggle(STATUS$1.OPEN);}else if(changedFrom('status',STATUS$1.INIT,STATUS$1.IDLE)&&autoOpen){this.toggle(STATUS$1.OPEN);}if(this.popper&&changed('status',STATUS$1.OPENING)){this.popper.instance.update();}if(this.floaterRef&&(changed('status',STATUS$1.OPENING)||changed('status',STATUS$1.CLOSING))){once(this.floaterRef,'transitionend',this.handleTransitionEnd);}if(changed('needsUpdate',true)){this.rebuildPopper();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(!canUseDOM$2)return;this._isMounted=false;if(this.popper){this.popper.instance.destroy();}if(this.wrapperPopper){this.wrapperPopper.instance.destroy();}}},{key:"initPopper",value:function initPopper(){var _this2=this;var target=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.target;var positionWrapper=this.state.positionWrapper;var _this$props7=this.props,disableFlip=_this$props7.disableFlip,getPopper=_this$props7.getPopper,hideArrow=_this$props7.hideArrow,offset=_this$props7.offset,placement=_this$props7.placement,wrapperOptions=_this$props7.wrapperOptions;var flipBehavior=placement==='top'||placement==='bottom'?'flip':['right','bottom-end','top-end','left','top-start','bottom-start'];/* istanbul ignore else */if(placement==='center'){this.setState({status:STATUS$1.IDLE});}else if(target&&this.floaterRef){var _this$options=this.options,arrow=_this$options.arrow,flip=_this$options.flip,offsetOptions=_this$options.offset,rest=_objectWithoutProperties$1(_this$options,_excluded$3);new Popper$1(target,this.floaterRef,{placement:placement,modifiers:_objectSpread2$1({arrow:_objectSpread2$1({enabled:!hideArrow,element:this.arrowRef},arrow),flip:_objectSpread2$1({enabled:!disableFlip,behavior:flipBehavior},flip),offset:_objectSpread2$1({offset:"0, ".concat(offset,"px")},offsetOptions)},rest),onCreate:function onCreate(data){var _this2$floaterRef;_this2.popper=data;if(!((_this2$floaterRef=_this2.floaterRef)!==null&&_this2$floaterRef!==void 0&&_this2$floaterRef.isConnected)){_this2.setState({needsUpdate:true});return;}getPopper(data,'floater');if(_this2._isMounted){_this2.setState({currentPlacement:data.placement,status:STATUS$1.IDLE});}if(placement!==data.placement){setTimeout(function(){data.instance.update();},1);}},onUpdate:function onUpdate(data){_this2.popper=data;var currentPlacement=_this2.state.currentPlacement;if(_this2._isMounted&&data.placement!==currentPlacement){_this2.setState({currentPlacement:data.placement});}}});}if(positionWrapper){var wrapperOffset=!is$1.undefined(wrapperOptions.offset)?wrapperOptions.offset:0;new Popper$1(this.target,this.wrapperRef,{placement:wrapperOptions.placement||placement,modifiers:{arrow:{enabled:false},offset:{offset:"0, ".concat(wrapperOffset,"px")},flip:{enabled:false}},onCreate:function onCreate(data){_this2.wrapperPopper=data;if(_this2._isMounted){_this2.setState({statusWrapper:STATUS$1.IDLE});}getPopper(data,'wrapper');if(placement!==data.placement){setTimeout(function(){data.instance.update();},1);}}});}}},{key:"rebuildPopper",value:function rebuildPopper(){var _this3=this;this.floaterRefInterval=setInterval(function(){var _this3$floaterRef;if((_this3$floaterRef=_this3.floaterRef)!==null&&_this3$floaterRef!==void 0&&_this3$floaterRef.isConnected){clearInterval(_this3.floaterRefInterval);_this3.setState({needsUpdate:false});_this3.initPopper();}},50);}},{key:"changeWrapperPosition",value:function changeWrapperPosition(_ref){var target=_ref.target,wrapperOptions=_ref.wrapperOptions;this.setState({positionWrapper:wrapperOptions.position&&!!target});}},{key:"toggle",value:function toggle(forceStatus){var status=this.state.status;var nextStatus=status===STATUS$1.OPEN?STATUS$1.CLOSING:STATUS$1.OPENING;if(!is$1.undefined(forceStatus)){nextStatus=forceStatus;}this.setState({status:nextStatus});}},{key:"debug",get:function get(){var debug=this.props.debug;return debug||!!global.ReactFloaterDebug;}},{key:"event",get:function get(){var _this$props8=this.props,disableHoverToClick=_this$props8.disableHoverToClick,event=_this$props8.event;if(event==='hover'&&isMobile()&&!disableHoverToClick){return 'click';}return event;}},{key:"options",get:function get(){var options=this.props.options;return cjs(DEFAULTS$1,options||{});}},{key:"styles",get:function get(){var _this4=this;var _this$state3=this.state,status=_this$state3.status,positionWrapper=_this$state3.positionWrapper,statusWrapper=_this$state3.statusWrapper;var styles=this.props.styles;var nextStyles=cjs(getStyles$1(styles),styles);if(positionWrapper){var wrapperStyles;if(!([STATUS$1.IDLE].indexOf(status)!==-1)||!([STATUS$1.IDLE].indexOf(statusWrapper)!==-1)){wrapperStyles=nextStyles.wrapperPosition;}else {wrapperStyles=this.wrapperPopper.styles;}nextStyles.wrapper=_objectSpread2$1(_objectSpread2$1({},nextStyles.wrapper),wrapperStyles);}/* istanbul ignore else */if(this.target){var targetStyles=window.getComputedStyle(this.target);/* istanbul ignore else */if(this.wrapperStyles){nextStyles.wrapper=_objectSpread2$1(_objectSpread2$1({},nextStyles.wrapper),this.wrapperStyles);}else if(!(['relative','static'].indexOf(targetStyles.position)!==-1)){this.wrapperStyles={};if(!positionWrapper){POSITIONING_PROPS.forEach(function(d){_this4.wrapperStyles[d]=targetStyles[d];});nextStyles.wrapper=_objectSpread2$1(_objectSpread2$1({},nextStyles.wrapper),this.wrapperStyles);this.target.style.position='relative';this.target.style.top='auto';this.target.style.right='auto';this.target.style.bottom='auto';this.target.style.left='auto';}}}return nextStyles;}},{key:"target",get:function get(){if(!canUseDOM$2)return null;var target=this.props.target;if(target){if(is$1.domElement(target)){return target;}return document.querySelector(target);}return this.childRef||this.wrapperRef;}},{key:"render",value:function render(){var _this$state4=this.state,currentPlacement=_this$state4.currentPlacement,positionWrapper=_this$state4.positionWrapper,status=_this$state4.status;var _this$props9=this.props,children=_this$props9.children,component=_this$props9.component,content=_this$props9.content,disableAnimation=_this$props9.disableAnimation,footer=_this$props9.footer,hideArrow=_this$props9.hideArrow,id=_this$props9.id,open=_this$props9.open,showCloseButton=_this$props9.showCloseButton,style=_this$props9.style,target=_this$props9.target,title=_this$props9.title;var wrapper=/*#__PURE__*/React.createElement(ReactFloaterWrapper,{handleClick:this.handleClick,handleMouseEnter:this.handleMouseEnter,handleMouseLeave:this.handleMouseLeave,setChildRef:this.setChildRef,setWrapperRef:this.setWrapperRef,style:style,styles:this.styles.wrapper},children);var output={};if(positionWrapper){output.wrapperInPortal=wrapper;}else {output.wrapperAsChildren=wrapper;}return/*#__PURE__*/React.createElement("span",null,/*#__PURE__*/React.createElement(ReactFloaterPortal,{hasChildren:!!children,id:id,placement:currentPlacement,setRef:this.setFloaterRef,target:target,zIndex:this.styles.options.zIndex},/*#__PURE__*/React.createElement(Floater,{component:component,content:content,disableAnimation:disableAnimation,footer:footer,handleClick:this.handleClick,hideArrow:hideArrow||currentPlacement==='center',open:open,placement:currentPlacement,positionWrapper:positionWrapper,setArrowRef:this.setArrowRef,setFloaterRef:this.setFloaterRef,showCloseButton:showCloseButton,status:status,styles:this.styles,title:title}),output.wrapperInPortal),output.wrapperAsChildren);}}]);return ReactFloater;}(React.Component);_defineProperty$1(ReactFloater,"propTypes",{autoOpen:propTypesExports.bool,callback:propTypesExports.func,children:propTypesExports.node,component:_default(propTypesExports.oneOfType([propTypesExports.func,propTypesExports.element]),function(props){return !props.content;}),content:_default(propTypesExports.node,function(props){return !props.component;}),debug:propTypesExports.bool,disableAnimation:propTypesExports.bool,disableFlip:propTypesExports.bool,disableHoverToClick:propTypesExports.bool,event:propTypesExports.oneOf(['hover','click']),eventDelay:propTypesExports.number,footer:propTypesExports.node,getPopper:propTypesExports.func,hideArrow:propTypesExports.bool,id:propTypesExports.oneOfType([propTypesExports.string,propTypesExports.number]),offset:propTypesExports.number,open:propTypesExports.bool,options:propTypesExports.object,placement:propTypesExports.oneOf(['top','top-start','top-end','bottom','bottom-start','bottom-end','left','left-start','left-end','right','right-start','right-end','auto','center']),showCloseButton:propTypesExports.bool,style:propTypesExports.object,styles:propTypesExports.object,target:propTypesExports.oneOfType([propTypesExports.object,propTypesExports.string]),title:propTypesExports.node,wrapperOptions:propTypesExports.shape({offset:propTypesExports.number,placement:propTypesExports.oneOf(['top','top-start','top-end','bottom','bottom-start','bottom-end','left','left-start','left-end','right','right-start','right-end','auto']),position:propTypesExports.bool})});_defineProperty$1(ReactFloater,"defaultProps",{autoOpen:false,callback:noop,debug:false,disableAnimation:false,disableFlip:false,disableHoverToClick:false,event:'click',eventDelay:0.4,getPopper:noop,hideArrow:false,offset:15,placement:'bottom',showCloseButton:false,styles:{},target:null,wrapperOptions:{position:false}});

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$2(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$1(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$2(this, result);
  };
}

var ACTIONS = {
  INIT: 'init',
  START: 'start',
  STOP: 'stop',
  RESET: 'reset',
  PREV: 'prev',
  NEXT: 'next',
  GO: 'go',
  CLOSE: 'close',
  SKIP: 'skip',
  UPDATE: 'update'
};

var EVENTS$1 = {
  TOUR_START: 'tour:start',
  STEP_BEFORE: 'step:before',
  BEACON: 'beacon',
  TOOLTIP: 'tooltip',
  STEP_AFTER: 'step:after',
  TOUR_END: 'tour:end',
  TOUR_STATUS: 'tour:status',
  TARGET_NOT_FOUND: 'error:target_not_found',
  ERROR: 'error'
};

var LIFECYCLE = {
  INIT: 'init',
  READY: 'ready',
  BEACON: 'beacon',
  TOOLTIP: 'tooltip',
  COMPLETE: 'complete',
  ERROR: 'error'
};

var STATUS = {
  IDLE: 'idle',
  READY: 'ready',
  WAITING: 'waiting',
  RUNNING: 'running',
  PAUSED: 'paused',
  SKIPPED: 'skipped',
  FINISHED: 'finished',
  ERROR: 'error'
};

var canUseDOM$1 = ExecutionEnvironment.canUseDOM;
var isReact16 = ReactDOM.createPortal !== undefined;
/**
 * Get the current browser
 *
 * @param {string} userAgent
 *
 * @returns {String}
 */

function getBrowser() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.userAgent;
  var browser = userAgent;

  if (typeof window === 'undefined') {
    browser = 'node';
  } else if (document.documentMode) {
    browser = 'ie';
  } else if (/Edge/.test(userAgent)) {
    browser = 'edge';
  } // Opera 8.0+
  else if (Boolean(window.opera) || userAgent.indexOf(' OPR/') >= 0) {
    browser = 'opera';
  } // Firefox 1.0+
  else if (typeof window.InstallTrigger !== 'undefined') {
    browser = 'firefox';
  } // Chrome 1+
  else if (window.chrome) {
    browser = 'chrome';
  } // Safari (and Chrome iOS, Firefox iOS)
  else if (/(Version\/([0-9._]+).*Safari|CriOS|FxiOS| Mobile\/)/.test(userAgent)) {
    browser = 'safari';
  }

  return browser;
}
/**
 * Get the toString Object type
 * @param {*} value
 * @returns {string}
 */

function getObjectType(value) {
  return Object.prototype.toString.call(value).slice(8, -1).toLowerCase();
}
/**
 * Get text from React components
 *
 * @param {*} root
 *
 * @returns {string}
 */

function getText(root) {
  var content = [];

  var recurse = function recurse(child) {
    /* istanbul ignore else */
    if (typeof child === 'string' || typeof child === 'number') {
      content.push(child);
    } else if (Array.isArray(child)) {
      child.forEach(function (c) {
        return recurse(c);
      });
    } else if (child && child.props) {
      var children = child.props.children;

      if (Array.isArray(children)) {
        children.forEach(function (c) {
          return recurse(c);
        });
      } else {
        recurse(children);
      }
    }
  };

  recurse(root);
  return content.join(' ').trim();
}
function hasOwnProperty$2(value, key) {
  return Object.prototype.hasOwnProperty.call(value, key);
}
function hasValidKeys(value, keys) {
  if (!src_default.plainObject(value) || !src_default.array(keys)) {
    return false;
  }

  return Object.keys(value).every(function (d) {
    return keys.indexOf(d) !== -1;
  });
}
/**
 * Convert hex to RGB
 *
 * @param {string} hex
 * @returns {Array}
 */

function hexToRGB(hex) {
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  var properHex = hex.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(properHex);
  return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : [];
}
/**
 * Decide if the step shouldn't skip the beacon
 * @param {Object} step
 *
 * @returns {boolean}
 */

function hideBeacon(step) {
  return step.disableBeacon || step.placement === 'center';
}
/**
 * Compare if two variables are equal
 *
 * @param {*} left
 * @param {*} right
 *
 * @returns {boolean}
 */

function isEqual$1(left, right) {
  var type;
  var hasReactElement = /*#__PURE__*/React.isValidElement(left) || /*#__PURE__*/React.isValidElement(right);
  var hasUndefined = src_default.undefined(left) || src_default.undefined(right);

  if (getObjectType(left) !== getObjectType(right) || hasReactElement || hasUndefined) {
    return false;
  }

  if (src_default.domElement(left)) {
    return left.isSameNode(right);
  }

  if (src_default.number(left)) {
    return left === right;
  }

  if (src_default["function"](left)) {
    return left.toString() === right.toString();
  }

  for (var key in left) {
    /* istanbul ignore else */
    if (hasOwnProperty$2(left, key)) {
      if (typeof left[key] === 'undefined' || typeof right[key] === 'undefined') {
        return false;
      }

      type = getObjectType(left[key]);

      if (['object', 'array'].indexOf(type) !== -1 && isEqual$1(left[key], right[key])) {
        continue;
      }

      if (type === 'function' && isEqual$1(left[key], right[key])) {
        continue;
      }

      if (left[key] !== right[key]) {
        return false;
      }
    }
  }

  for (var p in right) {
    /* istanbul ignore else */
    if (hasOwnProperty$2(right, p)) {
      if (typeof left[p] === 'undefined') {
        return false;
      }
    }
  }

  return true;
}
/**
 * Detect legacy browsers
 *
 * @returns {boolean}
 */

function isLegacy() {
  return !(['chrome', 'safari', 'firefox', 'opera'].indexOf(getBrowser()) !== -1);
}
/**
 * Log method calls if debug is enabled
 *
 * @private
 * @param {Object}       arg
 * @param {string}       arg.title    - The title the logger was called from
 * @param {Object|Array} [arg.data]   - The data to be logged
 * @param {boolean}      [arg.warn]  - If true, the message will be a warning
 * @param {boolean}      [arg.debug] - Nothing will be logged unless debug is true
 */

function log(_ref) {
  var title = _ref.title,
      data = _ref.data,
      _ref$warn = _ref.warn,
      warn = _ref$warn === void 0 ? false : _ref$warn,
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug;

  /* eslint-disable no-console */
  var logFn = warn ? console.warn || console.error : console.log;

  if (debug) {
    if (title && data) {
      console.groupCollapsed("%creact-joyride: ".concat(title), 'color: #ff0044; font-weight: bold; font-size: 12px;');

      if (Array.isArray(data)) {
        data.forEach(function (d) {
          if (src_default.plainObject(d) && d.key) {
            logFn.apply(console, [d.key, d.value]);
          } else {
            logFn.apply(console, [d]);
          }
        });
      } else {
        logFn.apply(console, [data]);
      }

      console.groupEnd();
    } else {
      console.error('Missing title or data props');
    }
  }
  /* eslint-enable */

}

var defaultState = {
  action: '',
  controlled: false,
  index: 0,
  lifecycle: LIFECYCLE.INIT,
  size: 0,
  status: STATUS.IDLE
};
var validKeys = ['action', 'index', 'lifecycle', 'status'];
function createStore(props) {
  var store = new Map();
  var data = new Map();

  var Store = /*#__PURE__*/function () {
    function Store() {
      var _this = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$continuous = _ref.continuous,
          continuous = _ref$continuous === void 0 ? false : _ref$continuous,
          stepIndex = _ref.stepIndex,
          _ref$steps = _ref.steps,
          _steps = _ref$steps === void 0 ? [] : _ref$steps;

      _classCallCheck$2(this, Store);

      _defineProperty(this, "listener", void 0);

      _defineProperty(this, "setSteps", function (steps) {
        var _this$getState = _this.getState(),
            size = _this$getState.size,
            status = _this$getState.status;

        var state = {
          size: steps.length,
          status: status
        };
        data.set('steps', steps);

        if (status === STATUS.WAITING && !size && steps.length) {
          state.status = STATUS.RUNNING;
        }

        _this.setState(state);
      });

      _defineProperty(this, "addListener", function (listener) {
        _this.listener = listener;
      });

      _defineProperty(this, "update", function (state) {
        if (!hasValidKeys(state, validKeys)) {
          throw new Error("State is not valid. Valid keys: ".concat(validKeys.join(', ')));
        }

        _this.setState(_objectSpread2({}, _this.getNextState(_objectSpread2(_objectSpread2(_objectSpread2({}, _this.getState()), state), {}, {
          action: state.action || ACTIONS.UPDATE
        }), true)));
      });

      _defineProperty(this, "start", function (nextIndex) {
        var _this$getState2 = _this.getState(),
            index = _this$getState2.index,
            size = _this$getState2.size;

        _this.setState(_objectSpread2(_objectSpread2({}, _this.getNextState({
          action: ACTIONS.START,
          index: src_default.number(nextIndex) ? nextIndex : index
        }, true)), {}, {
          status: size ? STATUS.RUNNING : STATUS.WAITING
        }));
      });

      _defineProperty(this, "stop", function () {
        var advance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var _this$getState3 = _this.getState(),
            index = _this$getState3.index,
            status = _this$getState3.status;

        if ([STATUS.FINISHED, STATUS.SKIPPED].indexOf(status) !== -1) return;

        _this.setState(_objectSpread2(_objectSpread2({}, _this.getNextState({
          action: ACTIONS.STOP,
          index: index + (advance ? 1 : 0)
        })), {}, {
          status: STATUS.PAUSED
        }));
      });

      _defineProperty(this, "close", function () {
        var _this$getState4 = _this.getState(),
            index = _this$getState4.index,
            status = _this$getState4.status;

        if (status !== STATUS.RUNNING) return;

        _this.setState(_objectSpread2({}, _this.getNextState({
          action: ACTIONS.CLOSE,
          index: index + 1
        })));
      });

      _defineProperty(this, "go", function (nextIndex) {
        var _this$getState5 = _this.getState(),
            controlled = _this$getState5.controlled,
            status = _this$getState5.status;

        if (controlled || status !== STATUS.RUNNING) return;

        var step = _this.getSteps()[nextIndex];

        _this.setState(_objectSpread2(_objectSpread2({}, _this.getNextState({
          action: ACTIONS.GO,
          index: nextIndex
        })), {}, {
          status: step ? status : STATUS.FINISHED
        }));
      });

      _defineProperty(this, "info", function () {
        return _this.getState();
      });

      _defineProperty(this, "next", function () {
        var _this$getState6 = _this.getState(),
            index = _this$getState6.index,
            status = _this$getState6.status;

        if (status !== STATUS.RUNNING) return;

        _this.setState(_this.getNextState({
          action: ACTIONS.NEXT,
          index: index + 1
        }));
      });

      _defineProperty(this, "open", function () {
        var _this$getState7 = _this.getState(),
            status = _this$getState7.status;

        if (status !== STATUS.RUNNING) return;

        _this.setState(_objectSpread2({}, _this.getNextState({
          action: ACTIONS.UPDATE,
          lifecycle: LIFECYCLE.TOOLTIP
        })));
      });

      _defineProperty(this, "prev", function () {
        var _this$getState8 = _this.getState(),
            index = _this$getState8.index,
            status = _this$getState8.status;

        if (status !== STATUS.RUNNING) return;

        _this.setState(_objectSpread2({}, _this.getNextState({
          action: ACTIONS.PREV,
          index: index - 1
        })));
      });

      _defineProperty(this, "reset", function () {
        var restart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var _this$getState9 = _this.getState(),
            controlled = _this$getState9.controlled;

        if (controlled) return;

        _this.setState(_objectSpread2(_objectSpread2({}, _this.getNextState({
          action: ACTIONS.RESET,
          index: 0
        })), {}, {
          status: restart ? STATUS.RUNNING : STATUS.READY
        }));
      });

      _defineProperty(this, "skip", function () {
        var _this$getState10 = _this.getState(),
            status = _this$getState10.status;

        if (status !== STATUS.RUNNING) return;

        _this.setState({
          action: ACTIONS.SKIP,
          lifecycle: LIFECYCLE.INIT,
          status: STATUS.SKIPPED
        });
      });

      this.setState({
        action: ACTIONS.INIT,
        controlled: src_default.number(stepIndex),
        continuous: continuous,
        index: src_default.number(stepIndex) ? stepIndex : 0,
        lifecycle: LIFECYCLE.INIT,
        status: _steps.length ? STATUS.READY : STATUS.IDLE
      }, true);
      this.setSteps(_steps);
    }

    _createClass$2(Store, [{
      key: "setState",
      value: function setState(nextState) {
        var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var state = this.getState();

        var _state$nextState = _objectSpread2(_objectSpread2({}, state), nextState),
            action = _state$nextState.action,
            index = _state$nextState.index,
            lifecycle = _state$nextState.lifecycle,
            size = _state$nextState.size,
            status = _state$nextState.status;

        store.set('action', action);
        store.set('index', index);
        store.set('lifecycle', lifecycle);
        store.set('size', size);
        store.set('status', status);

        if (initial) {
          store.set('controlled', nextState.controlled);
          store.set('continuous', nextState.continuous);
        }
        /* istanbul ignore else */


        if (this.listener && this.hasUpdatedState(state)) {
          // console.log('▶ ▶ ▶ NEW STATE', this.getState());
          this.listener(this.getState());
        }
      }
    }, {
      key: "getState",
      value: function getState() {
        if (!store.size) {
          return _objectSpread2({}, defaultState);
        }

        return {
          action: store.get('action') || '',
          controlled: store.get('controlled') || false,
          index: parseInt(store.get('index'), 10),
          lifecycle: store.get('lifecycle') || '',
          size: store.get('size') || 0,
          status: store.get('status') || ''
        };
      }
    }, {
      key: "getNextState",
      value: function getNextState(state) {
        var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var _this$getState11 = this.getState(),
            action = _this$getState11.action,
            controlled = _this$getState11.controlled,
            index = _this$getState11.index,
            size = _this$getState11.size,
            status = _this$getState11.status;

        var newIndex = src_default.number(state.index) ? state.index : index;
        var nextIndex = controlled && !force ? index : Math.min(Math.max(newIndex, 0), size);
        return {
          action: state.action || action,
          controlled: controlled,
          index: nextIndex,
          lifecycle: state.lifecycle || LIFECYCLE.INIT,
          size: state.size || size,
          status: nextIndex === size ? STATUS.FINISHED : state.status || status
        };
      }
    }, {
      key: "hasUpdatedState",
      value: function hasUpdatedState(oldState) {
        var before = JSON.stringify(oldState);
        var after = JSON.stringify(this.getState());
        return before !== after;
      }
    }, {
      key: "getSteps",
      value: function getSteps() {
        var steps = data.get('steps');
        return Array.isArray(steps) ? steps : [];
      }
    }, {
      key: "getHelpers",
      value: function getHelpers() {
        return {
          close: this.close,
          go: this.go,
          info: this.info,
          next: this.next,
          open: this.open,
          prev: this.prev,
          reset: this.reset,
          skip: this.skip
        };
      }
    }]);

    return Store;
  }();

  return new Store(props);
}

/**
 * Find the bounding client rect
 *
 * @private
 * @param {HTMLElement} element - The target element
 * @returns {Object}
 */

function getClientRect(element) {
  if (!element) {
    return {};
  }

  return element.getBoundingClientRect();
}
/**
 * Helper function to get the browser-normalized "document height"
 * @returns {Number}
 */

function getDocumentHeight() {
  var _document = document,
      body = _document.body,
      html = _document.documentElement;

  if (!body || !html) {
    return 0;
  }

  return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
}
/**
 * Find and return the target DOM element based on a step's 'target'.
 *
 * @private
 * @param {string|HTMLElement} element
 *
 * @returns {HTMLElement|null}
 */

function getElement(element) {
  /* istanbul ignore else */
  if (typeof element === 'string') {
    return document.querySelector(element);
  }

  return element;
}
/**
 *  Get computed style property
 *
 * @param {HTMLElement} el
 *
 * @returns {Object}
 */

function getStyleComputedProperty(el) {
  if (!el || el.nodeType !== 1) {
    return {};
  }

  return getComputedStyle(el);
}
/**
 * Get scroll parent with fix
 *
 * @param {HTMLElement} element
 * @param {boolean} skipFix
 * @param {boolean} [forListener]
 *
 * @returns {*}
 */

function getScrollParent(element, skipFix, forListener) {
  var parent = scrollParent(element);

  if (parent.isSameNode(scrollDoc())) {
    if (forListener) {
      return document;
    }

    return scrollDoc();
  }

  var hasScrolling = parent.scrollHeight > parent.offsetHeight;
  /* istanbul ignore else */

  if (!hasScrolling && !skipFix) {
    parent.style.overflow = 'initial';
    return scrollDoc();
  }

  return parent;
}
/**
 * Check if the element has custom scroll parent
 *
 * @param {HTMLElement} element
 * @param {boolean} skipFix
 *
 * @returns {boolean}
 */

function hasCustomScrollParent(element, skipFix) {
  if (!element) return false;
  var parent = getScrollParent(element, skipFix);
  return !parent.isSameNode(scrollDoc());
}
/**
 * Check if the element has custom offset parent
 *
 * @param {HTMLElement} element
 *
 * @returns {boolean}
 */

function hasCustomOffsetParent(element) {
  return element.offsetParent !== document.body;
}
/**
 * Check if an element has fixed/sticky position
 * @param {HTMLElement|Node} el
 * @param {string} [type]
 *
 * @returns {boolean}
 */

function hasPosition(el) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fixed';

  if (!el || !(el instanceof HTMLElement)) {
    return false;
  }

  var nodeName = el.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }

  if (getStyleComputedProperty(el).position === type) {
    return true;
  }

  return hasPosition(el.parentNode, type);
}
/**
 * Check if the element is visible
 *
 * @param {HTMLElement} element
 *
 * @returns {boolean}
 */

function isElementVisible(element) {
  if (!element) return false;
  var parentElement = element;

  while (parentElement) {
    if (parentElement === document.body) break;
    /* istanbul ignore else */

    if (parentElement instanceof HTMLElement) {
      var _getComputedStyle = getComputedStyle(parentElement),
          display = _getComputedStyle.display,
          visibility = _getComputedStyle.visibility;

      if (display === 'none' || visibility === 'hidden') {
        return false;
      }
    }

    parentElement = parentElement.parentNode;
  }

  return true;
}
/**
 * Find and return the target DOM element based on a step's 'target'.
 *
 * @private
 * @param {string|HTMLElement} element
 * @param {number} offset
 * @param {boolean} skipFix
 *
 * @returns {HTMLElement|undefined}
 */

function getElementPosition(element, offset, skipFix) {
  var elementRect = getClientRect(element);
  var parent = getScrollParent(element, skipFix);
  var hasScrollParent = hasCustomScrollParent(element, skipFix);
  var parentTop = 0;
  /* istanbul ignore else */

  if (parent instanceof HTMLElement) {
    parentTop = parent.scrollTop;
  }

  var top = elementRect.top + (!hasScrollParent && !hasPosition(element) ? parentTop : 0);
  return Math.floor(top - offset);
}
/**
 * Get the offsetTop of each element up to the body
 *
 * @param {HTMLElement} element
 *
 * @returns {number}
 */

function getTopOffset(element) {
  if (element instanceof HTMLElement) {
    if (element.offsetParent instanceof HTMLElement) {
      return getTopOffset(element.offsetParent) + element.offsetTop;
    }

    return element.offsetTop;
  }

  return 0;
}
/**
 * Get the scrollTop position
 *
 * @param {HTMLElement} element
 * @param {number} offset
 * @param {boolean} skipFix
 *
 * @returns {number}
 */

function getScrollTo(element, offset, skipFix) {
  if (!element) {
    return 0;
  }

  var parent = scrollParent(element);
  var top = getTopOffset(element);

  if (hasCustomScrollParent(element, skipFix) && !hasCustomOffsetParent(element)) {
    top -= getTopOffset(parent);
  }

  return Math.floor(top - offset);
}
function scrollDoc() {
  return document.scrollingElement || document.createElement('body');
}
/**
 * Scroll to position
 * @param {number} value
 * @param {HTMLElement} element
 * @param {number} scrollDuration
 * @returns {Promise<*>}
 */

function scrollTo(value) {
  var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scrollDoc();
  var scrollDuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
  return new Promise(function (resolve, reject) {
    var scrollTop = element.scrollTop;
    var limit = value > scrollTop ? value - scrollTop : scrollTop - value;
    scroll$1.top(element, value, {
      duration: limit < 100 ? 50 : scrollDuration
    }, function (error) {
      if (error && error.message !== 'Element already at target scroll position') {
        return reject(error);
      }

      return resolve();
    });
  });
}

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;
    /* istanbul ignore else */

    if (props[propName] == null) {
      if (isRequired) {
        return new Error("Required ".concat(location, " `").concat(propFullNameSafe, "` was not specified in `").concat(componentNameSafe, "`."));
      }

      return null;
    }

    for (var _len = arguments.length, args = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(void 0, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
}

createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var Component = propValue;

  if (! /*#__PURE__*/React.isValidElement(propValue) && reactIsExports.isValidElementType(propValue)) {
    var ownProps = {
      ref: function ref() {},
      step: {}
    };
    Component = /*#__PURE__*/React.createElement(Component, ownProps);
  }

  if (src_default.string(propValue) || src_default.number(propValue) || !reactIsExports.isValidElementType(propValue) || !([reactIsExports.Element, reactIsExports.ForwardRef].indexOf(reactIsExports.typeOf(Component)) !== -1)) {
    return new Error("Invalid ".concat(location, " `").concat(propFullName, "` supplied to `").concat(componentName, "`. Expected a React class or forwardRef."));
  }

  return undefined;
});

var defaultOptions$1 = {
  arrowColor: '#fff',
  backgroundColor: '#fff',
  beaconSize: 36,
  overlayColor: 'rgba(0, 0, 0, 0.5)',
  primaryColor: '#f04',
  spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
  textColor: '#333',
  zIndex: 100
};
var buttonBase = {
  backgroundColor: 'transparent',
  border: 0,
  borderRadius: 0,
  color: '#555',
  cursor: 'pointer',
  fontSize: 16,
  lineHeight: 1,
  padding: 8,
  WebkitAppearance: 'none'
};
var spotlight = {
  borderRadius: 4,
  position: 'absolute'
};
function getStyles() {
  var stepStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = cjs(defaultOptions$1, stepStyles.options || {});
  var width = 290;

  if (window.innerWidth > 480) {
    width = 380;
  }

  if (options.width) {
    if (window.innerWidth < options.width) {
      width = window.innerWidth - 30;
    } else {
      width = options.width; //eslint-disable-line prefer-destructuring
    }
  }

  var overlay = {
    bottom: 0,
    left: 0,
    overflow: 'hidden',
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: options.zIndex
  };
  var defaultStyles = {
    beacon: _objectSpread2(_objectSpread2({}, buttonBase), {}, {
      display: 'inline-block',
      height: options.beaconSize,
      position: 'relative',
      width: options.beaconSize,
      zIndex: options.zIndex
    }),
    beaconInner: {
      animation: 'joyride-beacon-inner 1.2s infinite ease-in-out',
      backgroundColor: options.primaryColor,
      borderRadius: '50%',
      display: 'block',
      height: '50%',
      left: '50%',
      opacity: 0.7,
      position: 'absolute',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: '50%'
    },
    beaconOuter: {
      animation: 'joyride-beacon-outer 1.2s infinite ease-in-out',
      backgroundColor: "rgba(".concat(hexToRGB(options.primaryColor).join(','), ", 0.2)"),
      border: "2px solid ".concat(options.primaryColor),
      borderRadius: '50%',
      boxSizing: 'border-box',
      display: 'block',
      height: '100%',
      left: 0,
      opacity: 0.9,
      position: 'absolute',
      top: 0,
      transformOrigin: 'center',
      width: '100%'
    },
    tooltip: {
      backgroundColor: options.backgroundColor,
      borderRadius: 5,
      boxSizing: 'border-box',
      color: options.textColor,
      fontSize: 16,
      maxWidth: '100%',
      padding: 15,
      position: 'relative',
      width: width
    },
    tooltipContainer: {
      lineHeight: 1.4,
      textAlign: 'center'
    },
    tooltipTitle: {
      fontSize: 18,
      margin: 0
    },
    tooltipContent: {
      padding: '20px 10px'
    },
    tooltipFooter: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: 15
    },
    tooltipFooterSpacer: {
      flex: 1
    },
    buttonNext: _objectSpread2(_objectSpread2({}, buttonBase), {}, {
      backgroundColor: options.primaryColor,
      borderRadius: 4,
      color: '#fff'
    }),
    buttonBack: _objectSpread2(_objectSpread2({}, buttonBase), {}, {
      color: options.primaryColor,
      marginLeft: 'auto',
      marginRight: 5
    }),
    buttonClose: _objectSpread2(_objectSpread2({}, buttonBase), {}, {
      color: options.textColor,
      height: 14,
      padding: 15,
      position: 'absolute',
      right: 0,
      top: 0,
      width: 14
    }),
    buttonSkip: _objectSpread2(_objectSpread2({}, buttonBase), {}, {
      color: options.textColor,
      fontSize: 14
    }),
    overlay: _objectSpread2(_objectSpread2({}, overlay), {}, {
      backgroundColor: options.overlayColor,
      mixBlendMode: 'hard-light'
    }),
    overlayLegacy: _objectSpread2({}, overlay),
    overlayLegacyCenter: _objectSpread2(_objectSpread2({}, overlay), {}, {
      backgroundColor: options.overlayColor
    }),
    spotlight: _objectSpread2(_objectSpread2({}, spotlight), {}, {
      backgroundColor: 'gray'
    }),
    spotlightLegacy: _objectSpread2(_objectSpread2({}, spotlight), {}, {
      boxShadow: "0 0 0 9999px ".concat(options.overlayColor, ", ").concat(options.spotlightShadow)
    }),
    floaterStyles: {
      arrow: {
        color: options.arrowColor
      },
      options: {
        zIndex: options.zIndex + 100
      }
    },
    options: options
  };
  return cjs(defaultStyles, stepStyles);
}

var DEFAULTS = {
  floaterProps: {
    options: {
      preventOverflow: {
        boundariesElement: 'scrollParent'
      }
    },
    wrapperOptions: {
      offset: -18,
      position: true
    }
  },
  locale: {
    back: 'Back',
    close: 'Close',
    last: 'Last',
    next: 'Next',
    open: 'Open the dialog',
    skip: 'Skip'
  },
  step: {
    event: 'click',
    placement: 'bottom',
    offset: 10
  }
};

function getTourProps(props) {
  var sharedTourProps = ['beaconComponent', 'disableCloseOnEsc', 'disableOverlay', 'disableOverlayClose', 'disableScrolling', 'disableScrollParentFix', 'floaterProps', 'hideBackButton', 'hideCloseButton', 'locale', 'showProgress', 'showSkipButton', 'spotlightClicks', 'spotlightPadding', 'styles', 'tooltipComponent'];
  return Object.keys(props).filter(function (d) {
    return sharedTourProps.indexOf(d) !== -1;
  }).reduce(function (acc, i) {
    acc[i] = props[i]; //eslint-disable-line react/destructuring-assignment

    return acc;
  }, {});
}

function getMergedStep(step, props) {
  if (!step) return null;
  var mergedStep = cjs.all([getTourProps(props), DEFAULTS.step, step], {
    isMergeableObject: src_default.plainObject
  });
  var mergedStyles = getStyles(cjs(props.styles || {}, step.styles || {}));
  var scrollParent = hasCustomScrollParent(getElement(step.target), mergedStep.disableScrollParentFix);
  var floaterProps = cjs.all([props.floaterProps || {}, DEFAULTS.floaterProps, mergedStep.floaterProps || {}]); // Set react-floater props

  floaterProps.offset = mergedStep.offset;
  floaterProps.styles = cjs(floaterProps.styles || {}, mergedStyles.floaterStyles || {});
  delete mergedStyles.floaterStyles;
  floaterProps.offset += props.spotlightPadding || step.spotlightPadding || 0;

  if (step.placementBeacon) {
    floaterProps.wrapperOptions.placement = step.placementBeacon;
  }

  if (scrollParent) {
    floaterProps.options.preventOverflow.boundariesElement = 'window';
  }

  return _objectSpread2(_objectSpread2({}, mergedStep), {}, {
    locale: cjs.all([DEFAULTS.locale, props.locale || {}, mergedStep.locale || {}]),
    floaterProps: floaterProps,
    styles: mergedStyles
  });
}
/**
 * Validate if a step is valid
 *
 * @param {Object} step - A step object
 * @param {boolean} debug
 *
 * @returns {boolean} - True if the step is valid, false otherwise
 */

function validateStep(step) {
  var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!src_default.plainObject(step)) {
    log({
      title: 'validateStep',
      data: 'step must be an object',
      warn: true,
      debug: debug
    });
    return false;
  }

  if (!step.target) {
    log({
      title: 'validateStep',
      data: 'target is missing from the step',
      warn: true,
      debug: debug
    });
    return false;
  }

  return true;
}
/**
 * Validate if steps is valid
 *
 * @param {Array} steps - A steps array
 * @param {boolean} debug
 *
 * @returns {boolean} - True if the steps are valid, false otherwise
 */

function validateSteps(steps) {
  var debug = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!src_default.array(steps)) {
    log({
      title: 'validateSteps',
      data: 'steps must be an array',
      warn: true,
      debug: debug
    });
    return false;
  }

  return steps.every(function (d) {
    return validateStep(d, debug);
  });
}

var Scope = /*#__PURE__*/_createClass$2(function Scope(_element) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck$2(this, Scope);

  _defineProperty(this, "element", void 0);

  _defineProperty(this, "options", void 0);

  _defineProperty(this, "canBeTabbed", function (element) {
    var tabIndex = element.tabIndex;
    if (tabIndex === null || tabIndex < 0) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return !isTabIndexNaN && _this.canHaveFocus(element);
  });

  _defineProperty(this, "canHaveFocus", function (element) {
    var validTabNodes = /input|select|textarea|button|object/;
    var nodeName = element.nodeName.toLowerCase();
    var res = validTabNodes.test(nodeName) && !element.getAttribute('disabled') || nodeName === 'a' && !!element.getAttribute('href');
    return res && _this.isVisible(element);
  });

  _defineProperty(this, "findValidTabElements", function () {
    return [].slice.call(_this.element.querySelectorAll('*'), 0).filter(_this.canBeTabbed);
  });

  _defineProperty(this, "handleKeyDown", function (e) {
    var _this$options$keyCode = _this.options.keyCode,
        keyCode = _this$options$keyCode === void 0 ? 9 : _this$options$keyCode;
    /* istanbul ignore else */

    if (e.keyCode === keyCode) {
      _this.interceptTab(e);
    }
  });

  _defineProperty(this, "interceptTab", function (event) {
    var elements = _this.findValidTabElements();

    if (!elements.length) {
      return;
    }

    event.preventDefault();
    var shiftKey = event.shiftKey;
    var x = elements.indexOf(document.activeElement);

    if (x === -1 || !shiftKey && x + 1 === elements.length) {
      x = 0;
    } else if (shiftKey && x === 0) {
      x = elements.length - 1;
    } else {
      x += shiftKey ? -1 : 1;
    }

    elements[x].focus();
  });

  _defineProperty(this, "isHidden", function (element) {
    var noSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    var style = window.getComputedStyle(element);
    if (noSize && !element.innerHTML) return true;
    return noSize && style.getPropertyValue('overflow') !== 'visible' || style.getPropertyValue('display') === 'none';
  });

  _defineProperty(this, "isVisible", function (element) {
    var parentElement = element;

    while (parentElement) {
      /* istanbul ignore else */
      if (parentElement instanceof HTMLElement) {
        if (parentElement === document.body) break;
        /* istanbul ignore else */

        if (_this.isHidden(parentElement)) return false;
        parentElement = parentElement.parentNode;
      }
    }

    return true;
  });

  _defineProperty(this, "removeScope", function () {
    window.removeEventListener('keydown', _this.handleKeyDown);
  });

  _defineProperty(this, "checkFocus", function (target) {
    if (document.activeElement !== target) {
      target.focus();
      window.requestAnimationFrame(function () {
        return _this.checkFocus(target);
      });
    }
  });

  _defineProperty(this, "setFocus", function () {
    var selector = _this.options.selector;
    if (!selector) return;

    var target = _this.element.querySelector(selector);
    /* istanbul ignore else */


    if (target) {
      window.requestAnimationFrame(function () {
        return _this.checkFocus(target);
      });
    }
  });

  if (!(_element instanceof HTMLElement)) {
    throw new TypeError('Invalid parameter: element must be an HTMLElement');
  }

  this.element = _element;
  this.options = options;
  window.addEventListener('keydown', this.handleKeyDown, false);
  this.setFocus();
});

var JoyrideBeacon = /*#__PURE__*/function (_React$Component) {
  _inherits$2(JoyrideBeacon, _React$Component);

  var _super = _createSuper(JoyrideBeacon);

  function JoyrideBeacon(props) {
    var _this;

    _classCallCheck$2(this, JoyrideBeacon);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized$1(_this), "setBeaconRef", function (c) {
      _this.beacon = c;
    });

    if (!props.beaconComponent) {
      var head = document.head || document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      var css = "\n        @keyframes joyride-beacon-inner {\n          20% {\n            opacity: 0.9;\n          }\n        \n          90% {\n            opacity: 0.7;\n          }\n        }\n        \n        @keyframes joyride-beacon-outer {\n          0% {\n            transform: scale(1);\n          }\n        \n          45% {\n            opacity: 0.7;\n            transform: scale(0.75);\n          }\n        \n          100% {\n            opacity: 0.9;\n            transform: scale(1);\n          }\n        }\n      ";
      style.type = 'text/css';
      style.id = 'joyride-beacon-animation';

      if (props.nonce !== undefined) {
        style.setAttribute('nonce', props.nonce);
      }

      style.appendChild(document.createTextNode(css));
      head.appendChild(style);
    }

    return _this;
  }

  _createClass$2(JoyrideBeacon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var shouldFocus = this.props.shouldFocus;

      setTimeout(function () {
        if (src_default.domElement(_this2.beacon) && shouldFocus) {
          _this2.beacon.focus();
        }
      }, 0);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var style = document.getElementById('joyride-beacon-animation');

      if (style) {
        style.parentNode.removeChild(style);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          beaconComponent = _this$props.beaconComponent,
          locale = _this$props.locale,
          onClickOrHover = _this$props.onClickOrHover,
          styles = _this$props.styles;
      var props = {
        'aria-label': locale.open,
        onClick: onClickOrHover,
        onMouseEnter: onClickOrHover,
        ref: this.setBeaconRef,
        title: locale.open
      };
      var component;

      if (beaconComponent) {
        var BeaconComponent = beaconComponent;
        component = /*#__PURE__*/React.createElement(BeaconComponent, props);
      } else {
        component = /*#__PURE__*/React.createElement("button", _extends({
          key: "JoyrideBeacon",
          className: "react-joyride__beacon",
          style: styles.beacon,
          type: "button"
        }, props), /*#__PURE__*/React.createElement("span", {
          style: styles.beaconInner
        }), /*#__PURE__*/React.createElement("span", {
          style: styles.beaconOuter
        }));
      }

      return component;
    }
  }]);

  return JoyrideBeacon;
}(React.Component);

function JoyrideSpotlight(_ref) {
  var styles = _ref.styles;
  return /*#__PURE__*/React.createElement("div", {
    key: "JoyrideSpotlight",
    className: "react-joyride__spotlight",
    style: styles
  });
}

var _excluded$2 = ["mixBlendMode", "zIndex"];

var JoyrideOverlay = /*#__PURE__*/function (_React$Component) {
  _inherits$2(JoyrideOverlay, _React$Component);

  var _super = _createSuper(JoyrideOverlay);

  function JoyrideOverlay() {
    var _this;

    _classCallCheck$2(this, JoyrideOverlay);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized$1(_this), "_isMounted", false);

    _defineProperty(_assertThisInitialized$1(_this), "state", {
      mouseOverSpotlight: false,
      isScrolling: false,
      showSpotlight: true
    });

    _defineProperty(_assertThisInitialized$1(_this), "handleMouseMove", function (e) {
      var mouseOverSpotlight = _this.state.mouseOverSpotlight;
      var _this$spotlightStyles = _this.spotlightStyles,
          height = _this$spotlightStyles.height,
          left = _this$spotlightStyles.left,
          position = _this$spotlightStyles.position,
          top = _this$spotlightStyles.top,
          width = _this$spotlightStyles.width;
      var offsetY = position === 'fixed' ? e.clientY : e.pageY;
      var offsetX = position === 'fixed' ? e.clientX : e.pageX;
      var inSpotlightHeight = offsetY >= top && offsetY <= top + height;
      var inSpotlightWidth = offsetX >= left && offsetX <= left + width;
      var inSpotlight = inSpotlightWidth && inSpotlightHeight;

      if (inSpotlight !== mouseOverSpotlight) {
        _this.updateState({
          mouseOverSpotlight: inSpotlight
        });
      }
    });

    _defineProperty(_assertThisInitialized$1(_this), "handleScroll", function () {
      var target = _this.props.target;
      var element = getElement(target);

      if (_this.scrollParent !== document) {
        var isScrolling = _this.state.isScrolling;

        if (!isScrolling) {
          _this.updateState({
            isScrolling: true,
            showSpotlight: false
          });
        }

        clearTimeout(_this.scrollTimeout);
        _this.scrollTimeout = setTimeout(function () {
          _this.updateState({
            isScrolling: false,
            showSpotlight: true
          });
        }, 50);
      } else if (hasPosition(element, 'sticky')) {
        _this.updateState({});
      }
    });

    _defineProperty(_assertThisInitialized$1(_this), "handleResize", function () {
      clearTimeout(_this.resizeTimeout);
      _this.resizeTimeout = setTimeout(function () {
        if (!_this._isMounted) {
          return;
        }

        _this.forceUpdate();
      }, 100);
    });

    return _this;
  }

  _createClass$2(JoyrideOverlay, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props;
          _this$props.debug;
          _this$props.disableScrolling;
          var disableScrollParentFix = _this$props.disableScrollParentFix,
          target = _this$props.target;
      var element = getElement(target);
      this.scrollParent = getScrollParent(element, disableScrollParentFix, true);
      this._isMounted = true;

      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var _this$props2 = this.props,
          lifecycle = _this$props2.lifecycle,
          spotlightClicks = _this$props2.spotlightClicks;

      var _treeChanges = treeChanges(prevProps, this.props),
          changed = _treeChanges.changed;
      /* istanbul ignore else */


      if (changed('lifecycle', LIFECYCLE.TOOLTIP)) {
        this.scrollParent.addEventListener('scroll', this.handleScroll, {
          passive: true
        });
        setTimeout(function () {
          var isScrolling = _this2.state.isScrolling;

          if (!isScrolling) {
            _this2.updateState({
              showSpotlight: true
            });
          }
        }, 100);
      }

      if (changed('spotlightClicks') || changed('disableOverlay') || changed('lifecycle')) {
        if (spotlightClicks && lifecycle === LIFECYCLE.TOOLTIP) {
          window.addEventListener('mousemove', this.handleMouseMove, false);
        } else if (lifecycle !== LIFECYCLE.TOOLTIP) {
          window.removeEventListener('mousemove', this.handleMouseMove);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      window.removeEventListener('mousemove', this.handleMouseMove);
      window.removeEventListener('resize', this.handleResize);
      clearTimeout(this.resizeTimeout);
      clearTimeout(this.scrollTimeout);
      this.scrollParent.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: "spotlightStyles",
    get: function get() {
      var showSpotlight = this.state.showSpotlight;
      var _this$props3 = this.props,
          disableScrollParentFix = _this$props3.disableScrollParentFix,
          spotlightClicks = _this$props3.spotlightClicks,
          spotlightPadding = _this$props3.spotlightPadding,
          styles = _this$props3.styles,
          target = _this$props3.target;
      var element = getElement(target);
      var elementRect = getClientRect(element);
      var isFixedTarget = hasPosition(element);
      var top = getElementPosition(element, spotlightPadding, disableScrollParentFix);
      return _objectSpread2(_objectSpread2({}, isLegacy() ? styles.spotlightLegacy : styles.spotlight), {}, {
        height: Math.round(elementRect.height + spotlightPadding * 2),
        left: Math.round(elementRect.left - spotlightPadding),
        opacity: showSpotlight ? 1 : 0,
        pointerEvents: spotlightClicks ? 'none' : 'auto',
        position: isFixedTarget ? 'fixed' : 'absolute',
        top: top,
        transition: 'opacity 0.2s',
        width: Math.round(elementRect.width + spotlightPadding * 2)
      });
    }
  }, {
    key: "updateState",
    value: function updateState(state) {
      if (!this._isMounted) {
        return;
      }

      this.setState(state);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          mouseOverSpotlight = _this$state.mouseOverSpotlight,
          showSpotlight = _this$state.showSpotlight;
      var _this$props4 = this.props,
          disableOverlay = _this$props4.disableOverlay,
          disableOverlayClose = _this$props4.disableOverlayClose,
          lifecycle = _this$props4.lifecycle,
          onClickOverlay = _this$props4.onClickOverlay,
          placement = _this$props4.placement,
          styles = _this$props4.styles;

      if (disableOverlay || lifecycle !== LIFECYCLE.TOOLTIP) {
        return null;
      }

      var baseStyles = styles.overlay;
      /* istanbul ignore else */

      if (isLegacy()) {
        baseStyles = placement === 'center' ? styles.overlayLegacyCenter : styles.overlayLegacy;
      }

      var stylesOverlay = _objectSpread2({
        cursor: disableOverlayClose ? 'default' : 'pointer',
        height: getDocumentHeight(),
        pointerEvents: mouseOverSpotlight ? 'none' : 'auto'
      }, baseStyles);

      var spotlight = placement !== 'center' && showSpotlight && /*#__PURE__*/React.createElement(JoyrideSpotlight, {
        styles: this.spotlightStyles
      }); // Hack for Safari bug with mix-blend-mode with z-index

      if (getBrowser() === 'safari') {
        stylesOverlay.mixBlendMode;
            stylesOverlay.zIndex;
            var safarOverlay = _objectWithoutProperties(stylesOverlay, _excluded$2);

        spotlight = /*#__PURE__*/React.createElement("div", {
          style: _objectSpread2({}, safarOverlay)
        }, spotlight);
        delete stylesOverlay.backgroundColor;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "react-joyride__overlay",
        style: stylesOverlay,
        onClick: onClickOverlay
      }, spotlight);
    }
  }]);

  return JoyrideOverlay;
}(React.Component);

var _excluded$1 = ["styles"],
    _excluded2 = ["color", "height", "width"];

function JoyrideTooltipCloseBtn(_ref) {
  var styles = _ref.styles,
      props = _objectWithoutProperties(_ref, _excluded$1);

  var color = styles.color,
      height = styles.height,
      width = styles.width,
      style = _objectWithoutProperties(styles, _excluded2);

  return /*#__PURE__*/React.createElement("button", _extends({
    style: style,
    type: "button"
  }, props), /*#__PURE__*/React.createElement("svg", {
    width: typeof width === 'number' ? "".concat(width, "px") : width,
    height: typeof height === 'number' ? "".concat(height, "px") : height,
    viewBox: "0 0 18 18",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z",
    fill: color
  }))));
}

var JoyrideTooltipContainer = /*#__PURE__*/function (_React$Component) {
  _inherits$2(JoyrideTooltipContainer, _React$Component);

  var _super = _createSuper(JoyrideTooltipContainer);

  function JoyrideTooltipContainer() {
    _classCallCheck$2(this, JoyrideTooltipContainer);

    return _super.apply(this, arguments);
  }

  _createClass$2(JoyrideTooltipContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          backProps = _this$props.backProps,
          closeProps = _this$props.closeProps,
          continuous = _this$props.continuous,
          index = _this$props.index,
          isLastStep = _this$props.isLastStep,
          primaryProps = _this$props.primaryProps,
          size = _this$props.size,
          skipProps = _this$props.skipProps,
          step = _this$props.step,
          tooltipProps = _this$props.tooltipProps;
      var content = step.content,
          hideBackButton = step.hideBackButton,
          hideCloseButton = step.hideCloseButton,
          hideFooter = step.hideFooter,
          showProgress = step.showProgress,
          showSkipButton = step.showSkipButton,
          title = step.title,
          styles = step.styles;
      var _step$locale = step.locale,
          back = _step$locale.back,
          close = _step$locale.close,
          last = _step$locale.last,
          next = _step$locale.next,
          skip = _step$locale.skip;
      var output = {
        primary: close
      };

      if (continuous) {
        output.primary = isLastStep ? last : next;

        if (showProgress) {
          output.primary = /*#__PURE__*/React.createElement("span", null, output.primary, " (", index + 1, "/", size, ")");
        }
      }

      if (showSkipButton && !isLastStep) {
        output.skip = /*#__PURE__*/React.createElement("button", _extends({
          style: styles.buttonSkip,
          type: "button",
          "aria-live": "off"
        }, skipProps), skip);
      }

      if (!hideBackButton && index > 0) {
        output.back = /*#__PURE__*/React.createElement("button", _extends({
          style: styles.buttonBack,
          type: "button"
        }, backProps), back);
      }

      output.close = !hideCloseButton && /*#__PURE__*/React.createElement(JoyrideTooltipCloseBtn, _extends({
        styles: styles.buttonClose
      }, closeProps));
      return /*#__PURE__*/React.createElement("div", _extends({
        key: "JoyrideTooltip",
        className: "react-joyride__tooltip",
        style: styles.tooltip
      }, tooltipProps), /*#__PURE__*/React.createElement("div", {
        style: styles.tooltipContainer
      }, title && /*#__PURE__*/React.createElement("h4", {
        style: styles.tooltipTitle,
        "aria-label": title
      }, title), /*#__PURE__*/React.createElement("div", {
        style: styles.tooltipContent
      }, content)), !hideFooter && /*#__PURE__*/React.createElement("div", {
        style: styles.tooltipFooter
      }, /*#__PURE__*/React.createElement("div", {
        style: styles.tooltipFooterSpacer
      }, output.skip), output.back, /*#__PURE__*/React.createElement("button", _extends({
        style: styles.buttonNext,
        type: "button"
      }, primaryProps), output.primary)), output.close);
    }
  }]);

  return JoyrideTooltipContainer;
}(React.Component);

var _excluded = ["beaconComponent", "tooltipComponent"];

var JoyrideTooltip = /*#__PURE__*/function (_React$Component) {
  _inherits$2(JoyrideTooltip, _React$Component);

  var _super = _createSuper(JoyrideTooltip);

  function JoyrideTooltip() {
    var _this;

    _classCallCheck$2(this, JoyrideTooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized$1(_this), "handleClickBack", function (e) {
      e.preventDefault();
      var helpers = _this.props.helpers;
      helpers.prev();
    });

    _defineProperty(_assertThisInitialized$1(_this), "handleClickClose", function (e) {
      e.preventDefault();
      var helpers = _this.props.helpers;
      helpers.close();
    });

    _defineProperty(_assertThisInitialized$1(_this), "handleClickPrimary", function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          continuous = _this$props.continuous,
          helpers = _this$props.helpers;

      if (!continuous) {
        helpers.close();
        return;
      }

      helpers.next();
    });

    _defineProperty(_assertThisInitialized$1(_this), "handleClickSkip", function (e) {
      e.preventDefault();
      var helpers = _this.props.helpers;
      helpers.skip();
    });

    _defineProperty(_assertThisInitialized$1(_this), "getElementsProps", function () {
      var _this$props2 = _this.props,
          continuous = _this$props2.continuous,
          isLastStep = _this$props2.isLastStep,
          setTooltipRef = _this$props2.setTooltipRef,
          step = _this$props2.step;
      var back = getText(step.locale.back);
      var close = getText(step.locale.close);
      var last = getText(step.locale.last);
      var next = getText(step.locale.next);
      var skip = getText(step.locale.skip);
      var primaryText = continuous ? next : close;

      if (isLastStep) {
        primaryText = last;
      }

      return {
        backProps: {
          'aria-label': back,
          'data-action': 'back',
          onClick: _this.handleClickBack,
          role: 'button',
          title: back
        },
        closeProps: {
          'aria-label': close,
          'data-action': 'close',
          onClick: _this.handleClickClose,
          role: 'button',
          title: close
        },
        primaryProps: {
          'aria-label': primaryText,
          'data-action': 'primary',
          onClick: _this.handleClickPrimary,
          role: 'button',
          title: primaryText
        },
        skipProps: {
          'aria-label': skip,
          'data-action': 'skip',
          onClick: _this.handleClickSkip,
          role: 'button',
          title: skip
        },
        tooltipProps: {
          'aria-modal': true,
          ref: setTooltipRef,
          role: 'alertdialog'
        }
      };
    });

    return _this;
  }

  _createClass$2(JoyrideTooltip, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          continuous = _this$props3.continuous,
          index = _this$props3.index,
          isLastStep = _this$props3.isLastStep,
          size = _this$props3.size,
          step = _this$props3.step;

      step.beaconComponent;
          var tooltipComponent = step.tooltipComponent,
          cleanStep = _objectWithoutProperties(step, _excluded);

      var component;

      if (tooltipComponent) {
        var renderProps = _objectSpread2(_objectSpread2({}, this.getElementsProps()), {}, {
          continuous: continuous,
          index: index,
          isLastStep: isLastStep,
          size: size,
          step: cleanStep
        });

        var TooltipComponent = tooltipComponent;
        component = /*#__PURE__*/React.createElement(TooltipComponent, renderProps);
      } else {
        component = /*#__PURE__*/React.createElement(JoyrideTooltipContainer, _extends({}, this.getElementsProps(), {
          continuous: continuous,
          index: index,
          isLastStep: isLastStep,
          size: size,
          step: step
        }));
      }

      return component;
    }
  }]);

  return JoyrideTooltip;
}(React.Component);

var JoyridePortal = /*#__PURE__*/function (_React$Component) {
  _inherits$2(JoyridePortal, _React$Component);

  var _super = _createSuper(JoyridePortal);

  function JoyridePortal() {
    _classCallCheck$2(this, JoyridePortal);

    return _super.apply(this, arguments);
  }

  _createClass$2(JoyridePortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!canUseDOM$1) return;

      if (!isReact16) {
        this.renderReact15();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (!canUseDOM$1) return;

      if (!isReact16) {
        this.renderReact15();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!canUseDOM$1 || !this.node) return;

      if (!isReact16) {
        ReactDOM.unmountComponentAtNode(this.node);
      }

      if (this.node.parentNode === document.body) {
        document.body.removeChild(this.node);
        this.node = undefined;
      }
    }
  }, {
    key: "appendNode",
    value: function appendNode() {
      var id = this.props.id;

      if (!this.node) {
        this.node = document.createElement('div');
        /* istanbul ignore else */

        if (id) {
          this.node.id = id;
        }

        document.body.appendChild(this.node);
      }
    }
  }, {
    key: "renderReact15",
    value: function renderReact15() {
      if (!canUseDOM$1) return null;
      var children = this.props.children;

      if (!this.node) {
        this.appendNode();
      }

      ReactDOM.unstable_renderSubtreeIntoContainer(this, children, this.node);
      return null;
    }
  }, {
    key: "renderReact16",
    value: function renderReact16() {
      if (!canUseDOM$1 || !isReact16) return null;
      var children = this.props.children;

      if (!this.node) {
        this.appendNode();
      }

      return /*#__PURE__*/ReactDOM.createPortal(children, this.node);
    }
  }, {
    key: "render",
    value: function render() {
      if (!isReact16) {
        return null;
      }

      return this.renderReact16();
    }
  }]);

  return JoyridePortal;
}(React.Component);

var JoyrideStep = /*#__PURE__*/function (_React$Component) {
  _inherits$2(JoyrideStep, _React$Component);

  var _super = _createSuper(JoyrideStep);

  function JoyrideStep() {
    var _this;

    _classCallCheck$2(this, JoyrideStep);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized$1(_this), "scope", {
      removeScope: function removeScope() {}
    });

    _defineProperty(_assertThisInitialized$1(_this), "handleClickHoverBeacon", function (e) {
      var _this$props = _this.props,
          step = _this$props.step,
          update = _this$props.update;

      if (e.type === 'mouseenter' && step.event !== 'hover') {
        return;
      }

      update({
        lifecycle: LIFECYCLE.TOOLTIP
      });
    });

    _defineProperty(_assertThisInitialized$1(_this), "handleClickOverlay", function () {
      var _this$props2 = _this.props,
          helpers = _this$props2.helpers,
          step = _this$props2.step;

      if (!step.disableOverlayClose) {
        helpers.close();
      }
    });

    _defineProperty(_assertThisInitialized$1(_this), "setTooltipRef", function (c) {
      _this.tooltip = c;
    });

    _defineProperty(_assertThisInitialized$1(_this), "setPopper", function (popper, type) {
      var _this$props3 = _this.props,
          action = _this$props3.action,
          setPopper = _this$props3.setPopper,
          update = _this$props3.update;

      if (type === 'wrapper') {
        _this.beaconPopper = popper;
      } else {
        _this.tooltipPopper = popper;
      }

      setPopper(popper, type);

      if (_this.beaconPopper && _this.tooltipPopper) {
        update({
          action: action === ACTIONS.CLOSE ? ACTIONS.CLOSE : action,
          lifecycle: LIFECYCLE.READY
        });
      }
    });

    return _this;
  }

  _createClass$2(JoyrideStep, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props4 = this.props,
          debug = _this$props4.debug,
          index = _this$props4.index;
      log({
        title: "step:".concat(index),
        data: [{
          key: 'props',
          value: this.props
        }],
        debug: debug
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props5 = this.props,
          action = _this$props5.action,
          callback = _this$props5.callback,
          continuous = _this$props5.continuous,
          controlled = _this$props5.controlled,
          debug = _this$props5.debug,
          index = _this$props5.index,
          lifecycle = _this$props5.lifecycle,
          size = _this$props5.size,
          status = _this$props5.status,
          step = _this$props5.step,
          update = _this$props5.update;

      var _treeChanges = treeChanges(prevProps, this.props),
          changed = _treeChanges.changed,
          changedFrom = _treeChanges.changedFrom;

      var state = {
        action: action,
        controlled: controlled,
        index: index,
        lifecycle: lifecycle,
        size: size,
        status: status
      };
      var skipBeacon = continuous && action !== ACTIONS.CLOSE && (index > 0 || action === ACTIONS.PREV);
      var hasStoreChanged = changed('action') || changed('index') || changed('lifecycle') || changed('status');
      var hasStarted = changedFrom('lifecycle', [LIFECYCLE.TOOLTIP, LIFECYCLE.INIT], LIFECYCLE.INIT);
      var isAfterAction = changed('action', [ACTIONS.NEXT, ACTIONS.PREV, ACTIONS.SKIP, ACTIONS.CLOSE]);

      if (isAfterAction && (hasStarted || controlled)) {
        callback(_objectSpread2(_objectSpread2({}, state), {}, {
          index: prevProps.index,
          lifecycle: LIFECYCLE.COMPLETE,
          step: prevProps.step,
          type: EVENTS$1.STEP_AFTER
        }));
      }

      if (step.placement === 'center' && status === STATUS.RUNNING && changed('index') && action !== ACTIONS.START && lifecycle === LIFECYCLE.INIT) {
        update({
          lifecycle: LIFECYCLE.READY
        });
      } // There's a step to use, but there's no target in the DOM


      if (hasStoreChanged) {
        var element = getElement(step.target);
        var elementExists = !!element;
        var hasRenderedTarget = elementExists && isElementVisible(element);

        if (hasRenderedTarget) {
          if (changedFrom('status', STATUS.READY, STATUS.RUNNING) || changedFrom('lifecycle', LIFECYCLE.INIT, LIFECYCLE.READY)) {
            callback(_objectSpread2(_objectSpread2({}, state), {}, {
              step: step,
              type: EVENTS$1.STEP_BEFORE
            }));
          }
        } else {
          console.warn(elementExists ? 'Target not visible' : 'Target not mounted', step); //eslint-disable-line no-console

          callback(_objectSpread2(_objectSpread2({}, state), {}, {
            type: EVENTS$1.TARGET_NOT_FOUND,
            step: step
          }));

          if (!controlled) {
            update({
              index: index + ([ACTIONS.PREV].indexOf(action) !== -1 ? -1 : 1)
            });
          }
        }
      }

      if (changedFrom('lifecycle', LIFECYCLE.INIT, LIFECYCLE.READY)) {
        update({
          lifecycle: hideBeacon(step) || skipBeacon ? LIFECYCLE.TOOLTIP : LIFECYCLE.BEACON
        });
      }

      if (changed('index')) {
        log({
          title: "step:".concat(lifecycle),
          data: [{
            key: 'props',
            value: this.props
          }],
          debug: debug
        });
      }
      /* istanbul ignore else */


      if (changed('lifecycle', LIFECYCLE.BEACON)) {
        callback(_objectSpread2(_objectSpread2({}, state), {}, {
          step: step,
          type: EVENTS$1.BEACON
        }));
      }

      if (changed('lifecycle', LIFECYCLE.TOOLTIP)) {
        callback(_objectSpread2(_objectSpread2({}, state), {}, {
          step: step,
          type: EVENTS$1.TOOLTIP
        }));
        this.scope = new Scope(this.tooltip, {
          selector: '[data-action=primary]'
        });
        this.scope.setFocus();
      }

      if (changedFrom('lifecycle', [LIFECYCLE.TOOLTIP, LIFECYCLE.INIT], LIFECYCLE.INIT)) {
        this.scope.removeScope();
        delete this.beaconPopper;
        delete this.tooltipPopper;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.scope.removeScope();
    }
    /**
     * Beacon click/hover event listener
     *
     * @param {Event} e
     */

  }, {
    key: "open",
    get: function get() {
      var _this$props6 = this.props,
          step = _this$props6.step,
          lifecycle = _this$props6.lifecycle;
      return !!(hideBeacon(step) || lifecycle === LIFECYCLE.TOOLTIP);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          continuous = _this$props7.continuous,
          debug = _this$props7.debug,
          helpers = _this$props7.helpers,
          index = _this$props7.index,
          lifecycle = _this$props7.lifecycle,
          nonce = _this$props7.nonce,
          shouldScroll = _this$props7.shouldScroll,
          size = _this$props7.size,
          step = _this$props7.step;
      var target = getElement(step.target);

      if (!validateStep(step) || !src_default.domElement(target)) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        key: "JoyrideStep-".concat(index),
        className: "react-joyride__step"
      }, /*#__PURE__*/React.createElement(JoyridePortal, {
        id: "react-joyride-portal"
      }, /*#__PURE__*/React.createElement(JoyrideOverlay, _extends({}, step, {
        debug: debug,
        lifecycle: lifecycle,
        onClickOverlay: this.handleClickOverlay
      }))), /*#__PURE__*/React.createElement(ReactFloater, _extends({
        component: /*#__PURE__*/React.createElement(JoyrideTooltip, {
          continuous: continuous,
          helpers: helpers,
          index: index,
          isLastStep: index + 1 === size,
          setTooltipRef: this.setTooltipRef,
          size: size,
          step: step
        }),
        debug: debug,
        getPopper: this.setPopper,
        id: "react-joyride-step-".concat(index),
        isPositioned: step.isFixed || hasPosition(target),
        open: this.open,
        placement: step.placement,
        target: step.target
      }, step.floaterProps), /*#__PURE__*/React.createElement(JoyrideBeacon, {
        beaconComponent: step.beaconComponent,
        locale: step.locale,
        nonce: nonce,
        onClickOrHover: this.handleClickHoverBeacon,
        shouldFocus: shouldScroll,
        styles: step.styles
      })));
    }
  }]);

  return JoyrideStep;
}(React.Component);

var Joyride = /*#__PURE__*/function (_React$Component) {
  _inherits$2(Joyride, _React$Component);

  var _super = _createSuper(Joyride);

  function Joyride(props) {
    var _this;

    _classCallCheck$2(this, Joyride);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized$1(_this), "initStore", function () {
      var _this$props = _this.props,
          debug = _this$props.debug,
          getHelpers = _this$props.getHelpers,
          run = _this$props.run,
          stepIndex = _this$props.stepIndex;
      _this.store = new createStore(_objectSpread2(_objectSpread2({}, _this.props), {}, {
        controlled: run && src_default.number(stepIndex)
      }));
      _this.helpers = _this.store.getHelpers();
      var addListener = _this.store.addListener;
      log({
        title: 'init',
        data: [{
          key: 'props',
          value: _this.props
        }, {
          key: 'state',
          value: _this.state
        }],
        debug: debug
      }); // Sync the store to this component's state.

      addListener(_this.syncState);
      getHelpers(_this.helpers);
      return _this.store.getState();
    });

    _defineProperty(_assertThisInitialized$1(_this), "callback", function (data) {
      var callback = _this.props.callback;
      /* istanbul ignore else */

      if (src_default["function"](callback)) {
        callback(data);
      }
    });

    _defineProperty(_assertThisInitialized$1(_this), "handleKeyboard", function (e) {
      var _this$state = _this.state,
          index = _this$state.index,
          lifecycle = _this$state.lifecycle;
      var steps = _this.props.steps;
      var step = steps[index];
      var intKey = window.Event ? e.which : e.keyCode;

      if (lifecycle === LIFECYCLE.TOOLTIP) {
        if (intKey === 27 && step && !step.disableCloseOnEsc) {
          _this.store.close();
        }
      }
    });

    _defineProperty(_assertThisInitialized$1(_this), "syncState", function (state) {
      _this.setState(state);
    });

    _defineProperty(_assertThisInitialized$1(_this), "setPopper", function (popper, type) {
      if (type === 'wrapper') {
        _this.beaconPopper = popper;
      } else {
        _this.tooltipPopper = popper;
      }
    });

    _defineProperty(_assertThisInitialized$1(_this), "shouldScroll", function (disableScrolling, index, scrollToFirstStep, lifecycle, step, target, prevState) {
      return !disableScrolling && (index !== 0 || scrollToFirstStep || lifecycle === LIFECYCLE.TOOLTIP) && step.placement !== 'center' && (!step.isFixed || !hasPosition(target)) && // fixed steps don't need to scroll
      prevState.lifecycle !== lifecycle && [LIFECYCLE.BEACON, LIFECYCLE.TOOLTIP].indexOf(lifecycle) !== -1;
    });

    _this.state = _this.initStore();
    return _this;
  }

  _createClass$2(Joyride, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!canUseDOM$1) return;
      var _this$props2 = this.props,
          disableCloseOnEsc = _this$props2.disableCloseOnEsc,
          debug = _this$props2.debug,
          run = _this$props2.run,
          steps = _this$props2.steps;
      var start = this.store.start;

      if (validateSteps(steps, debug) && run) {
        start();
      }
      /* istanbul ignore else */


      if (!disableCloseOnEsc) {
        document.body.addEventListener('keydown', this.handleKeyboard, {
          passive: true
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!canUseDOM$1) return;
      var _this$state2 = this.state,
          action = _this$state2.action,
          controlled = _this$state2.controlled,
          index = _this$state2.index,
          lifecycle = _this$state2.lifecycle,
          status = _this$state2.status;
      var _this$props3 = this.props,
          debug = _this$props3.debug,
          run = _this$props3.run,
          stepIndex = _this$props3.stepIndex,
          steps = _this$props3.steps;
      var prevSteps = prevProps.steps,
          prevStepIndex = prevProps.stepIndex;
      var _this$store = this.store,
          reset = _this$store.reset,
          setSteps = _this$store.setSteps,
          start = _this$store.start,
          stop = _this$store.stop,
          update = _this$store.update;

      var _treeChanges = treeChanges(prevProps, this.props),
          changedProps = _treeChanges.changed;

      var _treeChanges2 = treeChanges(prevState, this.state),
          changed = _treeChanges2.changed,
          changedFrom = _treeChanges2.changedFrom;

      var step = getMergedStep(steps[index], this.props);
      var stepsChanged = !isEqual$1(prevSteps, steps);
      var stepIndexChanged = src_default.number(stepIndex) && changedProps('stepIndex');
      var target = getElement(step === null || step === void 0 ? void 0 : step.target);

      if (stepsChanged) {
        if (validateSteps(steps, debug)) {
          setSteps(steps);
        } else {
          console.warn('Steps are not valid', steps); //eslint-disable-line no-console
        }
      }
      /* istanbul ignore else */


      if (changedProps('run')) {
        if (run) {
          start(stepIndex);
        } else {
          stop();
        }
      }
      /* istanbul ignore else */


      if (stepIndexChanged) {
        var nextAction = prevStepIndex < stepIndex ? ACTIONS.NEXT : ACTIONS.PREV;

        if (action === ACTIONS.STOP) {
          nextAction = ACTIONS.START;
        }

        if (!([STATUS.FINISHED, STATUS.SKIPPED].indexOf(status) !== -1)) {
          update({
            action: action === ACTIONS.CLOSE ? ACTIONS.CLOSE : nextAction,
            index: stepIndex,
            lifecycle: LIFECYCLE.INIT
          });
        }
      } // Update the index if the first step is not found


      if (!controlled && status === STATUS.RUNNING && index === 0 && !target) {
        update({
          index: index + 1
        });
        this.callback(_objectSpread2(_objectSpread2({}, this.state), {}, {
          type: EVENTS$1.TARGET_NOT_FOUND,
          step: step
        }));
      }

      var callbackData = _objectSpread2(_objectSpread2({}, this.state), {}, {
        index: index,
        step: step
      });

      var isAfterAction = changed('action', [ACTIONS.NEXT, ACTIONS.PREV, ACTIONS.SKIP, ACTIONS.CLOSE]);

      if (isAfterAction && changed('status', STATUS.PAUSED)) {
        var prevStep = getMergedStep(steps[prevState.index], this.props);
        this.callback(_objectSpread2(_objectSpread2({}, callbackData), {}, {
          index: prevState.index,
          lifecycle: LIFECYCLE.COMPLETE,
          step: prevStep,
          type: EVENTS$1.STEP_AFTER
        }));
      }

      if (changed('status', [STATUS.FINISHED, STATUS.SKIPPED])) {
        var _prevStep = getMergedStep(steps[prevState.index], this.props);

        if (!controlled) {
          this.callback(_objectSpread2(_objectSpread2({}, callbackData), {}, {
            index: prevState.index,
            lifecycle: LIFECYCLE.COMPLETE,
            step: _prevStep,
            type: EVENTS$1.STEP_AFTER
          }));
        }

        this.callback(_objectSpread2(_objectSpread2({}, callbackData), {}, {
          index: prevState.index,
          // Return the last step when the tour is finished
          step: _prevStep,
          type: EVENTS$1.TOUR_END
        }));
        reset();
      } else if (changedFrom('status', [STATUS.IDLE, STATUS.READY], STATUS.RUNNING)) {
        this.callback(_objectSpread2(_objectSpread2({}, callbackData), {}, {
          type: EVENTS$1.TOUR_START
        }));
      } else if (changed('status')) {
        this.callback(_objectSpread2(_objectSpread2({}, callbackData), {}, {
          type: EVENTS$1.TOUR_STATUS
        }));
      } else if (changed('action', ACTIONS.RESET)) {
        this.callback(_objectSpread2(_objectSpread2({}, callbackData), {}, {
          type: EVENTS$1.TOUR_STATUS
        }));
      }

      if (step) {
        this.scrollToStep(prevState);

        if (step.placement === 'center' && status === STATUS.RUNNING && action === ACTIONS.START && lifecycle === LIFECYCLE.INIT) {
          update({
            lifecycle: LIFECYCLE.READY
          });
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var disableCloseOnEsc = this.props.disableCloseOnEsc;
      /* istanbul ignore else */

      if (!disableCloseOnEsc) {
        document.body.removeEventListener('keydown', this.handleKeyboard);
      }
    }
  }, {
    key: "scrollToStep",
    value: function scrollToStep(prevState) {
      var _this$state3 = this.state,
          index = _this$state3.index,
          lifecycle = _this$state3.lifecycle,
          status = _this$state3.status;
      var _this$props4 = this.props,
          debug = _this$props4.debug,
          disableScrolling = _this$props4.disableScrolling,
          disableScrollParentFix = _this$props4.disableScrollParentFix,
          scrollToFirstStep = _this$props4.scrollToFirstStep,
          scrollOffset = _this$props4.scrollOffset,
          scrollDuration = _this$props4.scrollDuration,
          steps = _this$props4.steps;
      var step = getMergedStep(steps[index], this.props);
      /* istanbul ignore else */

      if (step) {
        var target = getElement(step.target);
        var shouldScroll = this.shouldScroll(disableScrolling, index, scrollToFirstStep, lifecycle, step, target, prevState);

        if (status === STATUS.RUNNING && shouldScroll) {
          var hasCustomScroll = hasCustomScrollParent(target, disableScrollParentFix);
          var scrollParent = getScrollParent(target, disableScrollParentFix);
          var scrollY = Math.floor(getScrollTo(target, scrollOffset, disableScrollParentFix)) || 0;
          log({
            title: 'scrollToStep',
            data: [{
              key: 'index',
              value: index
            }, {
              key: 'lifecycle',
              value: lifecycle
            }, {
              key: 'status',
              value: status
            }],
            debug: debug
          });
          /* istanbul ignore else */

          if (lifecycle === LIFECYCLE.BEACON && this.beaconPopper) {
            var _this$beaconPopper = this.beaconPopper,
                placement = _this$beaconPopper.placement,
                popper = _this$beaconPopper.popper;
            /* istanbul ignore else */

            if (!(['bottom'].indexOf(placement) !== -1) && !hasCustomScroll) {
              scrollY = Math.floor(popper.top - scrollOffset);
            }
          } else if (lifecycle === LIFECYCLE.TOOLTIP && this.tooltipPopper) {
            var _this$tooltipPopper = this.tooltipPopper,
                flipped = _this$tooltipPopper.flipped,
                _placement = _this$tooltipPopper.placement,
                _popper = _this$tooltipPopper.popper;

            if (['top', 'right', 'left'].indexOf(_placement) !== -1 && !flipped && !hasCustomScroll) {
              scrollY = Math.floor(_popper.top - scrollOffset);
            } else {
              scrollY -= step.spotlightPadding;
            }
          }

          scrollY = scrollY >= 0 ? scrollY : 0;
          /* istanbul ignore else */

          if (status === STATUS.RUNNING) {
            scrollTo(scrollY, scrollParent, scrollDuration);
          }
        }
      }
    }
    /**
     * Trigger the callback.
     *
     * @private
     * @param {Object} data
     */

  }, {
    key: "render",
    value: function render() {
      if (!canUseDOM$1) return null;
      var _this$state4 = this.state,
          index = _this$state4.index,
          status = _this$state4.status;
      var _this$props5 = this.props,
          continuous = _this$props5.continuous,
          debug = _this$props5.debug,
          nonce = _this$props5.nonce,
          scrollToFirstStep = _this$props5.scrollToFirstStep,
          steps = _this$props5.steps;
      var step = getMergedStep(steps[index], this.props);
      var output;

      if (status === STATUS.RUNNING && step) {
        output = /*#__PURE__*/React.createElement(JoyrideStep, _extends({}, this.state, {
          callback: this.callback,
          continuous: continuous,
          debug: debug,
          setPopper: this.setPopper,
          helpers: this.helpers,
          nonce: nonce,
          shouldScroll: !step.disableScrolling && (index !== 0 || scrollToFirstStep),
          step: step,
          update: this.store.update
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "react-joyride"
      }, output);
    }
  }]);

  return Joyride;
}(React.Component);

_defineProperty(Joyride, "defaultProps", {
  continuous: false,
  debug: false,
  disableCloseOnEsc: false,
  disableOverlay: false,
  disableOverlayClose: false,
  disableScrolling: false,
  disableScrollParentFix: false,
  getHelpers: function getHelpers() {},
  hideBackButton: false,
  run: true,
  scrollOffset: 20,
  scrollDuration: 300,
  scrollToFirstStep: false,
  showSkipButton: false,
  showProgress: false,
  spotlightClicks: false,
  spotlightPadding: 10,
  steps: []
});

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal$3 = function (_React$Component) {
  _inherits$1(Portal, _React$Component);

  function Portal() {
    _classCallCheck$1(this, Portal);

    return _possibleConstructorReturn$1(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass$1(Portal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!canUseDOM) {
        return null;
      }
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }
      return ReactDOM.createPortal(this.props.children, this.props.node || this.defaultNode);
    }
  }]);

  return Portal;
}(React.Component);

Portal$3.propTypes = {
  children: propTypesExports.node.isRequired,
  node: propTypesExports.any
};

var Portalv4 = Portal$3;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal$2 = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.renderPortal();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(props) {
      this.renderPortal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      ReactDOM.unmountComponentAtNode(this.defaultNode || this.props.node);
      if (this.defaultNode) {
        document.body.removeChild(this.defaultNode);
      }
      this.defaultNode = null;
      this.portal = null;
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.props.node && !this.defaultNode) {
        this.defaultNode = document.createElement('div');
        document.body.appendChild(this.defaultNode);
      }

      var children = this.props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof this.props.children.type === 'function') {
        children = React.cloneElement(this.props.children);
      }

      this.portal = ReactDOM.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return Portal;
}(React.Component);

var LegacyPortal = Portal$2;


Portal$2.propTypes = {
  children: propTypesExports.node.isRequired,
  node: propTypesExports.any
};

var Portal = void 0;

if (ReactDOM.createPortal) {
  Portal = Portalv4;
} else {
  Portal = LegacyPortal;
}

var Portal$1 = Portal;

const createMapper = (insertValue, value) => (step) => {
    return { ...step, [value]: insertValue };
};

function elementOnPage(selector, timeout = 10000) {
    if (typeof selector !== 'string') {
        return Promise.resolve(selector);
    }
    return new Promise(function (resolve) {
        const element = document.querySelector(selector);
        if (element) {
            resolve(element);
            return;
        }
        let timer;
        const observer = new MutationObserver((mutations) => {
            mutations.forEach(function (mutation) {
                const nodes = Array.from(mutation.addedNodes);
                for (const node of nodes) {
                    if (node instanceof HTMLElement && (node === null || node === void 0 ? void 0 : node.querySelector(selector))) {
                        resolve(node);
                        clearTimeout(timer);
                        return;
                    }
                }
            });
        });
        timer = setTimeout(() => {
            observer.disconnect();
            resolve(null);
        }, timeout);
        observer.observe(document.documentElement, { childList: true, subtree: true });
    });
}

function pushToGTM$1(event) {
    var _a;
    try {
        if (localStorage.getItem('log_gtm')) {
            console.log({
                event: 'm2_pro_events',
                ...event,
            });
        }
        (_a = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({
            ...event,
        });
    }
    catch (e) {
        console.error('Cannot push to GTM Data Layer');
        captureException(e);
    }
}

const checkBehavior = (behavior) => {
    return behavior === undefined || behavior === "auto" || behavior === "instant" || behavior === "smooth";
};
function elementScrollXY(x, y) {
    this.scrollLeft = x;
    this.scrollTop = y;
}
const failedExecute = (method, object, reason = "cannot convert to dictionary.") => `Failed to execute '${method}' on '${object}': ${reason}`;
const failedExecuteInvalidEnumValue = (method, object, value) => failedExecute(method, object, `The provided value '${value}' is not a valid enum value of type ScrollBehavior.`);
/* eslint-disable */
const backupMethod = (proto, method, fallback) => {
    var _a;
    const backup = `__SEAMLESS.BACKUP$${method}`;
    if (!proto[backup] && proto[method] && !((_a = proto[method]) === null || _a === void 0 ? void 0 : _a.__isPolyfill)) {
        proto[backup] = proto[method];
    }
    return proto[backup] || fallback;
};
/* eslint-enable */
const isObject$5 = (value) => {
    const type = typeof value;
    return value !== null && (type === "object" || type === "function");
};
/**
 * - On Chrome and Firefox, document.scrollingElement will return the <html> element.
 * - Safari, document.scrollingElement will return the <body> element.
 * - On Edge, document.scrollingElement will return the <body> element.
 * - IE11 does not support document.scrollingElement, but you can assume its <html>.
 */
const scrollingElement = (element) => element.ownerDocument.scrollingElement || element.ownerDocument.documentElement;

function scrollEndEvent(bubbles) {
    if (typeof Event === "function") {
        return new Event("scrollend", {
            bubbles,
            cancelable: false,
        });
    }
    const event = document.createEvent("Event");
    event.initEvent("scrollend", bubbles, false);
    return event;
}

const ease = (k) => {
    return 0.5 * (1 - Math.cos(Math.PI * k));
};
/* eslint-disable */
function now$1() {
    var _a;
    let fn;
    if ((_a = window.performance) === null || _a === void 0 ? void 0 : _a.now) {
        fn = () => window.performance.now();
    }
    else {
        fn = () => window.Date.now();
    }
    // @ts-ignore
    now$1 = fn;
    return fn();
}
/* eslint-enable */
const DURATION = 500;
const step = (context) => {
    const currentTime = now$1();
    const elapsed = (currentTime - context.timeStamp) / (context.duration || DURATION);
    if (elapsed > 1) {
        context.method(context.targetX, context.targetY);
        context.callback();
        return;
    }
    const value = (context.timingFunc || ease)(elapsed);
    const currentX = context.startX + (context.targetX - context.startX) * value;
    const currentY = context.startY + (context.targetY - context.startY) * value;
    context.method(currentX, currentY);
    context.rafId = window.requestAnimationFrame(() => {
        step(context);
    });
};

// https://drafts.csswg.org/cssom-view/#normalize-non-finite-values
const nonFinite = (value) => {
    if (!isFinite(value)) {
        return 0;
    }
    return Number(value);
};
const isConnected = (node) => {
    var _a;
    return ((_a = node.isConnected) !== null && _a !== void 0 ? _a : (!node.ownerDocument ||
        // eslint-disable-next-line no-bitwise
        !(node.ownerDocument.compareDocumentPosition(node) & /** DOCUMENT_POSITION_DISCONNECTED */ 1)));
};
const scrollWithOptions = (element, options, config) => {
    var _a, _b;
    if (!isConnected(element)) {
        return;
    }
    const startX = element.scrollLeft;
    const startY = element.scrollTop;
    const targetX = nonFinite((_a = options.left) !== null && _a !== void 0 ? _a : startX);
    const targetY = nonFinite((_b = options.top) !== null && _b !== void 0 ? _b : startY);
    if (targetX === startX && targetY === startY) {
        return;
    }
    const fallback = backupMethod(HTMLElement.prototype, "scroll", elementScrollXY);
    const method = backupMethod(Object.getPrototypeOf(element), "scroll", fallback).bind(element);
    if (options.behavior !== "smooth") {
        method(targetX, targetY);
        return;
    }
    const removeEventListener = () => {
        window.removeEventListener("wheel", cancelScroll);
        window.removeEventListener("touchmove", cancelScroll);
    };
    const callback = () => {
        removeEventListener();
        const isDocument = element.nodeType === /** Node.DOCUMENT_NODE */ 9;
        element.dispatchEvent(scrollEndEvent(isDocument));
    };
    const context = Object.assign(Object.assign({}, config), { timeStamp: now$1(), startX,
        startY,
        targetX,
        targetY, rafId: 0, method,
        callback });
    const cancelScroll = () => {
        window.cancelAnimationFrame(context.rafId);
        removeEventListener();
    };
    window.addEventListener("wheel", cancelScroll, {
        passive: true,
        once: true,
    });
    window.addEventListener("touchmove", cancelScroll, {
        passive: true,
        once: true,
    });
    step(context);
};
const isWindow = (obj) => obj.window === obj;
const createScroll = (scrollName) => (target, scrollOptions, config) => {
    const [element, scrollType] = isWindow(target)
        ? [scrollingElement(target.document.documentElement), "Window"]
        : [target, "Element"];
    const options = scrollOptions !== null && scrollOptions !== void 0 ? scrollOptions : {};
    if (!isObject$5(options)) {
        throw new TypeError(failedExecute(scrollName, scrollType));
    }
    if (!checkBehavior(options.behavior)) {
        throw new TypeError(failedExecuteInvalidEnumValue(scrollName, scrollType, options.behavior));
    }
    if (scrollName === "scrollBy") {
        options.left = nonFinite(options.left) + element.scrollLeft;
        options.top = nonFinite(options.top) + element.scrollTop;
    }
    scrollWithOptions(element, options, config);
};
const scroll = /* #__PURE__ */ createScroll("scroll");
const elementScroll = scroll;

/* eslint-disable no-bitwise */
// https://drafts.csswg.org/css-writing-modes-4/#block-flow
const normalizeWritingMode = (writingMode) => {
    switch (writingMode) {
        case "horizontal-tb":
        case "lr":
        case "lr-tb":
        case "rl":
        case "rl-tb":
            return 0 /* WritingMode.HorizontalTb */;
        case "vertical-rl":
        case "tb":
        case "tb-rl":
            return 1 /* WritingMode.VerticalRl */;
        case "vertical-lr":
        case "tb-lr":
            return 2 /* WritingMode.VerticalLr */;
        case "sideways-rl":
            return 3 /* WritingMode.SidewaysRl */;
        case "sideways-lr":
            return 4 /* WritingMode.SidewaysLr */;
    }
    return 0 /* WritingMode.HorizontalTb */;
};
const calcPhysicalAxis = (writingMode, isLTR, hPos, vPos) => {
    /**  0b{vertical}{horizontal}  0: normal, 1: reverse */
    let layout = 0b00;
    /**
     * WritingMode.VerticalLr: ↓→
     * | 1 | 4 |   |
     * | 2 | 5 |   |
     * | 3 |   |   |
     *
     * RTL: ↑→
     * | 3 |   |   |
     * | 2 | 5 |   |
     * | 1 | 4 |   |
     */
    if (!isLTR) {
        layout ^= 2 /* OP.ReverseVertical */;
    }
    switch (writingMode) {
        /**
         * ↓→
         * | 1 | 2 | 3 |
         * | 4 | 5 |   |
         * |   |   |   |
         *
         * RTL: ↓←
         * | 3 | 2 | 1 |
         * |   | 5 | 4 |
         * |   |   |   |
         */
        case 0 /* WritingMode.HorizontalTb */:
            // swap horizontal and vertical
            layout = (layout >> 1) | ((layout & 1) << 1);
            [hPos, vPos] = [vPos, hPos];
            break;
        /**
         * ↓←
         * |   | 4 | 1 |
         * |   | 5 | 2 |
         * |   |   | 3 |
         *
         * RTL: ↑←
         * |   |   | 3 |
         * |   | 5 | 2 |
         * |   | 4 | 1 |
         */
        case 1 /* WritingMode.VerticalRl */:
        case 3 /* WritingMode.SidewaysRl */:
            //  reverse horizontal
            layout ^= 1 /* OP.ReverseHorizontal */;
            break;
        /**
         * ↑→
         * | 3 |   |   |
         * | 2 | 5 |   |
         * | 1 | 4 |   |
         *
         * RTL: ↓→
         * | 1 | 4 |   |
         * | 2 | 5 |   |
         * | 3 |   |   |
         */
        case 4 /* WritingMode.SidewaysLr */:
            // reverse vertical
            layout ^= 2 /* OP.ReverseVertical */;
            break;
    }
    return [layout, hPos, vPos];
};
const isXReversed = (computedStyle) => {
    const layout = calcPhysicalAxis(normalizeWritingMode(computedStyle.writingMode), computedStyle.direction !== "rtl", undefined, undefined)[0];
    return (layout & 1) === 1;
};
// https://source.chromium.org/chromium/chromium/src/+/main:third_party/blink/renderer/core/dom/element.cc;l=1097-1189;drc=6a7533d4a1e9f2372223a9d912a9e53a6fa35ae0
const toPhysicalAlignment = (options, writingMode, isLTR) => {
    const [layout, hPos, vPos] = calcPhysicalAxis(writingMode, isLTR, options.block || "start", options.inline || "nearest");
    return [hPos, vPos].map((value, index) => {
        switch (value) {
            case "center":
                return 1 /* ScrollAlignment.CenterAlways */;
            case "nearest":
                return 0 /* ScrollAlignment.ToEdgeIfNeeded */;
            default: {
                const reverse = (layout >> index) & 1;
                return (value === "start") === !reverse ? 2 /* ScrollAlignment.LeftOrTop */ : 3 /* ScrollAlignment.RightOrBottom */;
            }
        }
    });
};
// code from stipsan/compute-scroll-into-view
// https://github.com/stipsan/compute-scroll-into-view/blob/5396c6b78af5d0bbce11a7c4e93cc3146546fcd3/src/index.ts
/**
 * Find out which edge to align against when logical scroll position is "nearest"
 * Interesting fact: "nearest" works similarily to "if-needed", if the element is fully visible it will not scroll it
 *
 * Legends:
 * ┌────────┐ ┏ ━ ━ ━ ┓
 * │ target │   frame
 * └────────┘ ┗ ━ ━ ━ ┛
 */
const mapNearest = (align, scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, elementEdgeStart, elementEdgeEnd, elementSize) => {
    if (align !== 0 /* ScrollAlignment.ToEdgeIfNeeded */) {
        return align;
    }
    /**
     * If element edge A and element edge B are both outside scrolling box edge A and scrolling box edge B
     *
     *          ┌──┐
     *        ┏━│━━│━┓
     *          │  │
     *        ┃ │  │ ┃        do nothing
     *          │  │
     *        ┗━│━━│━┛
     *          └──┘
     *
     *  If element edge C and element edge D are both outside scrolling box edge C and scrolling box edge D
     *
     *    ┏ ━ ━ ━ ━ ┓
     *   ┌───────────┐
     *   │┃         ┃│        do nothing
     *   └───────────┘
     *    ┗ ━ ━ ━ ━ ┛
     */
    if ((elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd) ||
        (elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd)) {
        return null;
    }
    /**
     * If element edge A is outside scrolling box edge A and element height is less than scrolling box height
     *
     *          ┌──┐
     *        ┏━│━━│━┓         ┏━┌━━┐━┓
     *          └──┘             │  │
     *  from  ┃      ┃     to  ┃ └──┘ ┃
     *
     *        ┗━ ━━ ━┛         ┗━ ━━ ━┛
     *
     * If element edge B is outside scrolling box edge B and element height is greater than scrolling box height
     *
     *        ┏━ ━━ ━┓         ┏━┌━━┐━┓
     *                           │  │
     *  from  ┃ ┌──┐ ┃     to  ┃ │  │ ┃
     *          │  │             │  │
     *        ┗━│━━│━┛         ┗━│━━│━┛
     *          │  │             └──┘
     *          │  │
     *          └──┘
     *
     * If element edge C is outside scrolling box edge C and element width is less than scrolling box width
     *
     *       from                 to
     *    ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *  ┌───┐                 ┌───┐
     *  │ ┃ │       ┃         ┃   │     ┃
     *  └───┘                 └───┘
     *    ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     *
     * If element edge D is outside scrolling box edge D and element width is greater than scrolling box width
     *
     *       from                 to
     *    ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *        ┌───────────┐   ┌───────────┐
     *    ┃   │     ┃     │   ┃         ┃ │
     *        └───────────┘   └───────────┘
     *    ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     */
    if ((elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize) ||
        (elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize)) {
        return 2 /* ScrollAlignment.LeftOrTop */;
    }
    /**
     * If element edge B is outside scrolling box edge B and element height is less than scrolling box height
     *
     *        ┏━ ━━ ━┓         ┏━ ━━ ━┓
     *
     *  from  ┃      ┃     to  ┃ ┌──┐ ┃
     *          ┌──┐             │  │
     *        ┗━│━━│━┛         ┗━└━━┘━┛
     *          └──┘
     *
     * If element edge A is outside scrolling box edge A and element height is greater than scrolling box height
     *
     *          ┌──┐
     *          │  │
     *          │  │             ┌──┐
     *        ┏━│━━│━┓         ┏━│━━│━┓
     *          │  │             │  │
     *  from  ┃ └──┘ ┃     to  ┃ │  │ ┃
     *                           │  │
     *        ┗━ ━━ ━┛         ┗━└━━┘━┛
     *
     * If element edge C is outside scrolling box edge C and element width is greater than scrolling box width
     *
     *           from                 to
     *        ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *  ┌───────────┐           ┌───────────┐
     *  │     ┃     │   ┃       │ ┃         ┃
     *  └───────────┘           └───────────┘
     *        ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     *
     * If element edge D is outside scrolling box edge D and element width is less than scrolling box width
     *
     *           from                 to
     *        ┏ ━ ━ ━ ━ ┓         ┏ ━ ━ ━ ━ ┓
     *                ┌───┐             ┌───┐
     *        ┃       │ ┃ │       ┃     │   ┃
     *                └───┘             └───┘
     *        ┗ ━ ━ ━ ━ ┛         ┗ ━ ━ ━ ━ ┛
     *
     */
    if ((elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize) ||
        (elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize)) {
        return 3 /* ScrollAlignment.RightOrBottom */;
    }
    return null;
};
const canOverflow = (overflow) => {
    return overflow !== "visible" && overflow !== "clip";
};
const getFrameElement = (element) => {
    var _a;
    try {
        return ((_a = element.ownerDocument.defaultView) === null || _a === void 0 ? void 0 : _a.frameElement) || null;
    }
    catch (_b) {
        return null;
    }
};
const isScrollable = (element, computedStyle) => {
    if (element.clientHeight < element.scrollHeight || element.clientWidth < element.scrollWidth) {
        return (canOverflow(computedStyle.overflowY) ||
            canOverflow(computedStyle.overflowX) ||
            element === scrollingElement(element));
    }
    return false;
};
const parentElement = (element) => {
    const pNode = element.parentNode;
    const pElement = element.parentElement;
    if (pElement === null && pNode !== null) {
        if (pNode.nodeType === /** Node.DOCUMENT_FRAGMENT_NODE */ 11) {
            return pNode.host;
        }
        if (pNode.nodeType === /** Node.DOCUMENT_NODE */ 9) {
            return getFrameElement(element);
        }
    }
    return pElement;
};
const clamp = (value, min, max) => {
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
};
const getSupportedScrollMarginProperty = (ownerDocument) => {
    // Webkit uses "scroll-snap-margin" https://bugs.webkit.org/show_bug.cgi?id=189265.
    return ["scroll-margin", "scroll-snap-margin"].filter((property) => property in ownerDocument.documentElement.style)[0];
};
const getElementScrollSnapArea = (element, elementRect, computedStyle) => {
    const { top, right, bottom, left } = elementRect;
    const scrollProperty = getSupportedScrollMarginProperty(element.ownerDocument);
    if (!scrollProperty) {
        return [top, right, bottom, left];
    }
    const scrollMarginValue = (edge) => {
        const value = computedStyle.getPropertyValue(`${scrollProperty}-${edge}`);
        return parseInt(value, 10) || 0;
    };
    return [
        top - scrollMarginValue("top"),
        right + scrollMarginValue("right"),
        bottom + scrollMarginValue("bottom"),
        left - scrollMarginValue("left"),
    ];
};
const calcAlignEdge = (align, start, end) => {
    switch (align) {
        case 1 /* ScrollAlignment.CenterAlways */:
            return (start + end) / 2;
        case 3 /* ScrollAlignment.RightOrBottom */:
            return end;
        case 2 /* ScrollAlignment.LeftOrTop */:
        case 0 /* ScrollAlignment.ToEdgeIfNeeded */:
            return start;
    }
};
const getFrameViewport = (frame, frameRect) => {
    var _a, _b, _c;
    const visualViewport = (_a = frame.ownerDocument.defaultView) === null || _a === void 0 ? void 0 : _a.visualViewport;
    const [x, y, width, height] = frame === scrollingElement(frame)
        ? [0, 0, (_b = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.width) !== null && _b !== void 0 ? _b : frame.clientWidth, (_c = visualViewport === null || visualViewport === void 0 ? void 0 : visualViewport.height) !== null && _c !== void 0 ? _c : frame.clientHeight]
        : [frameRect.left, frameRect.top, frame.clientWidth, frame.clientHeight];
    const left = x + frame.clientLeft;
    const top = y + frame.clientTop;
    const right = left + width;
    const bottom = top + height;
    return [top, right, bottom, left];
};
const computeScrollIntoView = (element, options) => {
    // Collect all the scrolling boxes, as defined in the spec: https://drafts.csswg.org/cssom-view/#scrolling-box
    const actions = [];
    let ownerDocument = element.ownerDocument;
    let ownerWindow = ownerDocument.defaultView;
    if (!ownerWindow) {
        return actions;
    }
    const computedStyle = window.getComputedStyle(element);
    const isLTR = computedStyle.direction !== "rtl";
    const writingMode = normalizeWritingMode(computedStyle.writingMode ||
        computedStyle.getPropertyValue("-webkit-writing-mode") ||
        computedStyle.getPropertyValue("-ms-writing-mode"));
    const [alignH, alignV] = toPhysicalAlignment(options, writingMode, isLTR);
    let [top, right, bottom, left] = getElementScrollSnapArea(element, element.getBoundingClientRect(), computedStyle);
    for (let frame = parentElement(element); frame !== null; frame = parentElement(frame)) {
        if (ownerDocument !== frame.ownerDocument) {
            ownerDocument = frame.ownerDocument;
            ownerWindow = ownerDocument.defaultView;
            if (!ownerWindow) {
                break;
            }
            const { left: dX, top: dY } = frame.getBoundingClientRect();
            top += dY;
            right += dX;
            bottom += dY;
            left += dX;
        }
        const frameStyle = ownerWindow.getComputedStyle(frame);
        if (frameStyle.position === "fixed") {
            break;
        }
        if (!isScrollable(frame, frameStyle)) {
            continue;
        }
        const frameRect = frame.getBoundingClientRect();
        const [frameTop, frameRight, frameBottom, frameLeft] = getFrameViewport(frame, frameRect);
        const eAlignH = mapNearest(alignH, frameLeft, frameRight, frame.clientWidth, left, right, right - left);
        const eAlignV = mapNearest(alignV, frameTop, frameBottom, frame.clientHeight, top, bottom, bottom - top);
        const diffX = eAlignH === null ? 0 : calcAlignEdge(eAlignH, left, right) - calcAlignEdge(eAlignH, frameLeft, frameRight);
        const diffY = eAlignV === null ? 0 : calcAlignEdge(eAlignV, top, bottom) - calcAlignEdge(eAlignV, frameTop, frameBottom);
        const moveX = isXReversed(frameStyle)
            ? clamp(diffX, -frame.scrollWidth + frame.clientWidth - frame.scrollLeft, -frame.scrollLeft)
            : clamp(diffX, -frame.scrollLeft, frame.scrollWidth - frame.clientWidth - frame.scrollLeft);
        const moveY = clamp(diffY, -frame.scrollTop, frame.scrollHeight - frame.clientHeight - frame.scrollTop);
        actions.push([
            frame,
            { left: frame.scrollLeft + moveX, top: frame.scrollTop + moveY, behavior: options.behavior },
        ]);
        top = Math.max(top - moveY, frameTop);
        right = Math.min(right - moveX, frameRight);
        bottom = Math.min(bottom - moveY, frameBottom);
        left = Math.max(left - moveX, frameLeft);
    }
    return actions;
};
const scrollIntoView = (element, scrollIntoViewOptions, config) => {
    const options = scrollIntoViewOptions || {};
    if (!checkBehavior(options.behavior)) {
        throw new TypeError(failedExecuteInvalidEnumValue("scrollIntoView", "Element", options.behavior));
    }
    const actions = computeScrollIntoView(element, options);
    actions.forEach(([frame, scrollToOptions]) => {
        elementScroll(frame, scrollToOptions, config);
    });
};

const scrollToElement = (target, position = 'center') => {
    const scrollTo = typeof target === 'string' ? document.querySelector(target) : target;
    if (scrollTo) {
        scrollIntoView(scrollTo, {
            behavior: 'auto',
            block: position,
            inline: position,
        });
    }
};

const timeout = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

var css_248z$e = ".styles-module_beacon__YLy2z{-webkit-appearance:none;background-color:transparent;border:0;border-radius:0;color:#555;cursor:pointer;display:inline-block;outline:none;padding:0;position:relative;z-index:999}.styles-module_beaconInner__PZVZB,.styles-module_beaconOuter__6TrA9{animation-iteration-count:infinite;border-radius:50%;display:block;position:absolute}.styles-module_beaconInner__PZVZB{animation:styles-module_joyride-beacon-inner__Epet2 1.2s ease-in-out infinite;background-color:#150949;height:10px;left:50%;opacity:.7;top:50%;transform:translate(-50%,-50%);width:10px;z-index:201}.styles-module_beaconOuter__6TrA9{animation:styles-module_joyride-beacon-outer__GvzaL 1.2s ease-in-out infinite;background-color:rgba(52,22,188,.1);border:1px solid #3416bc;box-sizing:border-box;height:26px;left:-13px;opacity:.9;top:-13px;width:26px}.styles-module_closeButton__IB1OK>button{left:0;position:absolute;top:0}.styles-module_fixBeacon__nPmJX{bottom:32px!important;position:fixed!important;right:24px!important}@media screen and (max-width:959px){.styles-module_fixBeacon__nPmJX{bottom:78px!important}}.styles-module_fixeBeaconInUsedesk__mj-4p{position:absolute!important;right:66px;top:24px}.styles-module_fixBeacon__nPmJX,.styles-module_fixeBeaconInUsedesk__mj-4p{z-index:100!important}@keyframes styles-module_joyride-beacon-inner__Epet2{20%{opacity:.9}90%{opacity:.7}}@keyframes styles-module_joyride-beacon-outer__GvzaL{0%{transform:scale(1)}45%{opacity:.7;transform:scale(.75)}to{opacity:.9;transform:scale(1)}}";
var styles$a = {"beacon":"styles-module_beacon__YLy2z","beaconInner":"styles-module_beaconInner__PZVZB","beaconOuter":"styles-module_beaconOuter__6TrA9","joyride-beacon-inner":"styles-module_joyride-beacon-inner__Epet2","joyride-beacon-outer":"styles-module_joyride-beacon-outer__GvzaL","closeButton":"styles-module_closeButton__IB1OK","fixBeacon":"styles-module_fixBeacon__nPmJX","fixeBeaconInUsedesk":"styles-module_fixeBeaconInUsedesk__mj-4p"};
styleInject(css_248z$e);

const Tooltip = React.memo((props) => {
    const { continuous, index, step, backProps, closeProps, primaryProps, isLastStep, skipProps, tooltipProps, size, gtmPrefix, } = props;
    const { content, hideBackButton, hideCloseButton, hideFooter, showProgress, showSkipButton, title, styles } = step;
    const { back, close, last, next, skip } = step.locale;
    const output = {
        primary: close,
        skip: undefined,
        back: undefined,
        close: undefined,
        counter: undefined,
    };
    const onNextClick = (event) => {
        if (index !== size - 1) {
            pushToGTM$1({ action: `${gtmPrefix}_${step.gtmTag}_nextButton`, event: step.gtmEvent });
        }
        primaryProps.onClick(event);
    };
    const onBackClick = React.useCallback((event) => {
        pushToGTM$1({ action: `${gtmPrefix}_${step.gtmTag}_backButton`, event: step.gtmEvent });
        backProps.onClick(event);
    }, [backProps, step.gtmTag, step.gtmEvent, gtmPrefix]);
    if (continuous) {
        output.primary = isLastStep ? last : next;
        if (showProgress) {
            output.counter = (React.createElement(Typography, { color: 'black-300' },
                "(",
                index + 1,
                "/",
                size,
                ")"));
        }
    }
    if (showSkipButton && !isLastStep) {
        output.skip = (React.createElement("button", { style: styles.buttonSkip, type: "button", "data-test": "onboarding-skip", "aria-live": "off", ...skipProps }, skip));
    }
    if (!hideBackButton && index > 0) {
        output.back = (React.createElement("button", { style: styles.buttonBack, type: "button", "data-test": "onboarding-back", ...backProps, onClick: onBackClick }, back));
    }
    output.close = !hideCloseButton && (React.createElement("div", { style: styles.buttonClose, className: styles$a.closeButton },
        React.createElement(Button$3, { icon: "cross", dataTest: "onboarding-close", size: "s", circle: true, variant: "transparent", ...closeProps })));
    return (React.createElement("div", { key: 'JoyrideTooltip', className: 'react-joyride__tooltip', style: styles.tooltip, ...tooltipProps },
        React.createElement("div", { style: styles.tooltipContainer },
            title && (React.createElement("div", { style: styles.tooltipTitle },
                React.createElement(Typography, { "aria-label": title }, title))),
            React.createElement("div", { style: styles.tooltipContent }, content)),
        !hideFooter && (React.createElement("div", { style: styles.tooltipFooter },
            output.counter,
            React.createElement("div", { style: styles.tooltipFooterSpacer }, output.skip),
            output.back,
            React.createElement("button", { style: styles.buttonNext, type: "button", "data-test": "onboarding-next", ...primaryProps, onClick: onNextClick }, output.primary))),
        output.close));
});

const GTM_ONBOARDING_COMMON = 'm2_pro_onboarding_';
const LS_ONBOARDING_PREFIX = 'm2pro-onboarding';
const LOCALES = {
    back: 'Назад',
    close: 'Закрыть',
    last: 'Завершить',
    next: 'Далее',
    open: 'Обучение',
    skip: 'Пропустить',
};

const Beacon = React.memo(({ onClick, className, isFindeUsedesk, disableUsedeskAttachBeacon }) => {
    const { to, registerControl } = useTooltip();
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: cn(className, 'react-joyride__beacon', styles$a.beacon, {
                [styles$a.fixeBeaconInUsedesk]: isFindeUsedesk && !disableUsedeskAttachBeacon,
                [styles$a.fixBeacon]: !isFindeUsedesk || disableUsedeskAttachBeacon,
            }), type: "button", ref: registerControl, "data-test": 'onboarding-beacon', "aria-label": LOCALES.open, title: LOCALES.open, onClick: onClick },
            React.createElement("span", { className: styles$a.beaconInner }),
            React.createElement("span", { className: styles$a.beaconOuter })),
        React.createElement(Tooltip$1, { to: to }, LOCALES.open)));
});

const defaultFloaterProps = {
    styles: {
        wrapper: {
            zIndex: 999,
        },
    },
    disableAnimation: true,
    options: {
        modifiers: [
            {
                name: 'preventOverflow',
                options: {
                    padding: 0,
                },
            },
        ],
    },
};

const defaultStyles = {
    tooltip: {
        width: 'auto',
    },
    tooltipTitle: {
        font: 'var(--t-h3)',
        margin: '0 0 var(--s-unit)',
        paddingRight: 'var(--s-unit-3x)',
        textAlign: 'left',
    },
    tooltipContent: {
        font: 'var(--t-primary-alone)',
        padding: 'var(--s-unit-1x) var(--s-unit-3x) var(--s-unit-1x) var(--s-unit-1x)',
        textAlign: 'left',
    },
    buttonBack: {
        backgroundColor: 'var(--c-primary-alt-bg)',
        color: 'var(--c-text-primary)',
        padding: '10px 27px',
    },
    buttonNext: {
        backgroundColor: 'var(--c-secondary)',
        color: 'var(--c-text-primary)',
        padding: '10px 27px',
    },
    spotlight: {
        zIndex: 9999,
    },
    overlay: {
        zIndex: 999,
    },
};

var css_248z$d = ".__floater{z-index:999!important}@media screen and (max-width:767px){.__floater{width:96vw!important}}";
var styles$9 = {"tooltip":"styles-module_tooltip__zI-fS"};
styleInject(css_248z$d);

const USEDESK_SELECTOR = '.chatWidget';
const Onboarding = React.memo((props) => {
    var _a;
    const { lsKey = 'default', isFixedBeacon = true, commonGtmTag, commonGtmEvent = 'm2_events', awaitBeforeStart, disableUsedesckAttachBeacon, gtmPrefix = GTM_ONBOARDING_COMMON, lsPrefix = LS_ONBOARDING_PREFIX, disableAutoRun, } = props;
    const steps = React.useRef(props.steps);
    const tooltipRef = React.useRef(null);
    const stepProgress = React.useRef(0);
    const isMounted = useMountedState();
    const [isUiTestEnv] = useCookie$1('is_ui_test_env');
    const [savedStep, setSavedStep] = useLocalStorage$1(`${lsPrefix}_${lsKey}`, '0');
    const [isRunning, setIsRunning] = React.useState(false);
    const [isShowFixedBeacon, setIsShowFixedBeacon] = React.useState(false);
    const [useDeskContainer, setUseDeskContainer] = React.useState(() => disableUsedesckAttachBeacon ? document.body : document.querySelector(USEDESK_SELECTOR));
    React.useEffect(() => {
        if (disableAutoRun) {
            setSavedStep('end');
        }
    }, [disableAutoRun, setSavedStep]);
    React.useEffect(() => {
        setTimeout(() => {
            if (!disableUsedesckAttachBeacon) {
                const useDeskContainer = document.querySelector(USEDESK_SELECTOR);
                if (useDeskContainer && isMounted)
                    setUseDeskContainer(useDeskContainer);
            }
        }, 1000);
    }, [isMounted, disableUsedesckAttachBeacon]);
    const observerCallback = React.useCallback(() => {
        const step = props.steps[savedStep];
        if (!step)
            return;
        window.requestAnimationFrame(async () => {
            var _a;
            if (!isMounted)
                return;
            setIsRunning(false);
            (_a = step === null || step === void 0 ? void 0 : step.beforeStepAction) === null || _a === void 0 ? void 0 : _a.call(step);
            if (awaitBeforeStart && stepProgress.current === 0) {
                await timeout(awaitBeforeStart);
                isMounted && setIsRunning(true);
            }
            else {
                setIsRunning(true);
            }
            stepProgress.current = stepProgress.current + 1;
            step.scrollToTooltip
                ?
                    setTimeout(() => scrollToElement(tooltipRef.current, step.scrollPosition), 0)
                : scrollToElement(step.target, step.scrollPosition);
        });
    }, [isMounted, props.steps, savedStep, awaitBeforeStart]);
    useMutationObserver({ targetEl: (_a = props.steps[savedStep]) === null || _a === void 0 ? void 0 : _a.target, cb: observerCallback, throttleTime: 500 });
    useDisableBodyScroll$1(isRunning);
    React.useEffect(() => {
        let localSteps = [...props.steps];
        if (commonGtmTag) {
            const mapperGtm = createMapper(commonGtmTag, 'gtmTag');
            localSteps = localSteps.map(mapperGtm);
        }
        if (commonGtmEvent) {
            const mapperGtmEvent = createMapper(commonGtmEvent, 'gtmEvent');
            localSteps = localSteps.map(mapperGtmEvent);
        }
        if (isFixedBeacon) {
            const mapperBeacon = createMapper(true, 'disableBeacon');
            localSteps = localSteps.map(mapperBeacon);
            setIsShowFixedBeacon(true);
        }
        steps.current = localSteps;
    }, [commonGtmEvent, commonGtmTag, isFixedBeacon, props.steps]);
    useMount$1(() => {
        var _a;
        (_a = window.__hideCookiesModal) === null || _a === void 0 ? void 0 : _a.call(window);
    });
    const stepChangeGTMAction = React.useCallback((step, index) => {
        if (commonGtmTag)
            pushToGTM$1({
                action: `${gtmPrefix}_${step.gtmTag}_${index + 1}`,
                event: commonGtmEvent,
            });
        else if (step === null || step === void 0 ? void 0 : step.gtmTag)
            pushToGTM$1({ action: `${gtmPrefix}_${step.gtmTag}`, event: commonGtmEvent });
    }, [commonGtmEvent, commonGtmTag, gtmPrefix]);
    const startOnboarding = React.useCallback(() => {
        pushToGTM$1({ action: `${gtmPrefix}_${steps.current[0].gtmTag}_beacon`, event: commonGtmEvent });
        stepProgress.current > 1 && stepChangeGTMAction(steps.current[0], 0);
        setSavedStep('0');
    }, [commonGtmEvent, setSavedStep, stepChangeGTMAction, gtmPrefix]);
    const onCallbackAction = React.useCallback((data) => {
        var _a;
        const { action, index, status, lifecycle, step, type } = data;
        if (ACTIONS.PREV === action) {
            (_a = step.onPrevAction) === null || _a === void 0 ? void 0 : _a.call(step);
        }
        if (ACTIONS.CLOSE === action ||
            (STATUS.FINISHED === status && lifecycle === LIFECYCLE.COMPLETE) ||
            (ACTIONS.PREV !== action && index === steps.current.length - 1 && lifecycle === LIFECYCLE.COMPLETE)) {
            if (step === null || step === void 0 ? void 0 : step.gtmTag) {
                pushToGTM$1({ action: `${gtmPrefix}_${step.gtmTag}_close`, event: commonGtmEvent });
            }
            setSavedStep('end');
            setIsRunning(false);
            return;
        }
        const isClickChangeButton = (ACTIONS.NEXT === action || ACTIONS.PREV === action) && LIFECYCLE.READY === lifecycle;
        if (isClickChangeButton && Number(savedStep) === index) {
            stepChangeGTMAction(step, index);
        }
        if (ACTIONS.START === action && LIFECYCLE.READY === lifecycle && stepProgress.current === 1) {
            stepChangeGTMAction(step, index);
        }
        if (EVENTS$1.STEP_AFTER === type) {
            const newIndex = String(index + (action === ACTIONS.PREV ? -1 : 1));
            setSavedStep(newIndex);
        }
    }, [savedStep, setSavedStep, commonGtmEvent, stepChangeGTMAction, gtmPrefix]);
    useUnmount$1(() => setIsRunning(false));
    if (isUiTestEnv === 'true' || props.steps.length === 0)
        return React.createElement(React.Fragment, null);
    return (React.createElement(React.Fragment, null,
        React.createElement(Joyride, { steps: steps.current, stepIndex: parseInt(savedStep, 10), continuous: true, showProgress: true, disableScrolling: true, run: isRunning, locale: LOCALES, callback: onCallbackAction, styles: defaultStyles, floaterProps: defaultFloaterProps, tooltipComponent: (props) => (React.createElement("div", { className: styles$9.tooltip, ref: tooltipRef },
                React.createElement(Tooltip, { ...props, gtmPrefix: gtmPrefix }))) }),
        isShowFixedBeacon && !isRunning && (React.createElement(Portal$1, { node: useDeskContainer },
            React.createElement(Beacon, { onClick: startOnboarding, className: props.beaconClassname, isFindeUsedesk: !!useDeskContainer, disableUsedeskAttachBeacon: disableUsedesckAttachBeacon })))));
});

const DEFAULT_OPTIONS = { attributes: true, childList: true, subtree: true };
function useMutationObserver({ targetEl, cb, options = DEFAULT_OPTIONS, throttleTime = 0, }) {
    const observer = React.useMemo(() => {
        return new MutationObserver(throttle$1(cb, throttleTime));
    }, [cb, throttleTime]);
    const observe = React.useRef((element, options, observer) => observer.observe(element, options));
    React.useEffect(() => {
        (async function f() {
            const element = await elementOnPage(targetEl);
            if (element) {
                cb();
            }
        })();
    }, [cb, targetEl]);
    React.useEffect(() => {
        if (!observer || !targetEl)
            return;
        (async function f() {
            const element = await elementOnPage(targetEl);
            if (element) {
                observe.current(element, options, observer);
            }
        })();
        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, [observer, targetEl, options]);
}

const MOBILE = '767px';
const TABLET_START = '768px';
const TABLET_END = '1199px';
const DESKTOP = '1200px';
const useDeviceMediaType = () => {
    const isMobile = useMedia$1(`(max-width: ${MOBILE})`);
    const isTablet = useMedia$1(`(min-width: ${TABLET_START}) and (max-width: ${TABLET_END})`);
    const isDesktop = useMedia$1(`(min-width: ${DESKTOP})`);
    return React.useMemo(() => ({
        isMobile,
        isTablet,
        isDesktop,
        deviceType: (isMobile && 'mobile') ||
            (isTablet && 'tablet') ||
            (isDesktop && 'desktop') ||
            'desktop',
    }), [isDesktop, isMobile, isTablet]);
};

var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject$4 = (value) => !isNullOrUndefined(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject$4(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var isPlainObject$2 = (tempObject) => {
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return (isObject$4(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
};

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject$4(data))) {
        copy = isArray ? [] : {};
        if (!Array.isArray(data) && !isPlainObject$2(data)) {
            copy = data;
        }
        else {
            for (const key in data) {
                copy[key] = cloneObject(data[key]);
            }
        }
    }
    else {
        return data;
    }
    return copy;
}

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined$2 = (val) => val === undefined;

var get$2 = (obj, path, defaultValue) => {
    if (!path || !isObject$4(obj)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined(result) ? result : result[key], obj);
    return isUndefined$2(result) || result === obj
        ? isUndefined$2(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};
const INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate',
};

const HookFormContext = React.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => React.useContext(HookFormContext);

var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
    const result = {
        defaultValues: control._defaultValues,
    };
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                    control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject$4(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => exact && signalName
    ? name === signalName
    : !name ||
        !signalName ||
        name === signalName ||
        convertToArrayPayload(name).some((currentName) => currentName &&
            (currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = React.useRef(props);
    _props.current = props;
    React.useEffect(() => {
        const subscription = !props.disabled &&
            _props.current.subject &&
            _props.current.subject.subscribe({
                next: _props.current.next,
            });
        return () => {
            subscription && subscription.unsubscribe();
        };
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = React.useState(control._formState);
    const _mounted = React.useRef(true);
    const _localProxyFormState = React.useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = React.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        next: (value) => _mounted.current &&
            shouldSubscribeByName(_name.current, value.name, exact) &&
            shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) &&
            updateFormState({
                ...control._formState,
                ...value,
            }),
        subject: control._subjects.state,
    });
    React.useEffect(() => {
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return () => {
            _mounted.current = false;
        };
    }, [control]);
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get$2(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get$2(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = React.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.values,
        next: (formState) => {
            if (shouldSubscribeByName(_name.current, formState.name, exact)) {
                updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
            }
        },
    });
    const [value, updateValue] = React.useState(control._getWatch(name, defaultValue));
    React.useEffect(() => control._removeUnmounted());
    return value;
}

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set$2(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject$4(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get$2(control._formValues, name, get$2(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = React.useRef(control.register(name, {
        ...props.rules,
        value,
    }));
    React.useEffect(() => {
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value) => {
            const field = get$2(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value = cloneObject(get$2(control._options.defaultValues, name));
            set$2(control._defaultValues, name, value);
            if (isUndefined$2(get$2(control._formValues, name))) {
                set$2(control._formValues, name, value);
            }
        }
        return () => {
            (isArrayField
                ? _shouldUnregisterField && !control._state.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    return {
        field: {
            name,
            value,
            onChange: React.useCallback((event) => _registerProps.current.onChange({
                target: {
                    value: getEventValue(event),
                    name: name,
                },
                type: EVENTS.CHANGE,
            }), [name]),
            onBlur: React.useCallback(() => _registerProps.current.onBlur({
                target: {
                    value: get$2(control._formValues, name),
                    name: name,
                },
                type: EVENTS.BLUR,
            }), [name, control]),
            ref: (elm) => {
                const field = get$2(control._fields, name);
                if (field && elm) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            },
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: () => !!get$2(formState.errors, name),
            },
            isDirty: {
                enumerable: true,
                get: () => !!get$2(formState.dirtyFields, name),
            },
            isTouched: {
                enumerable: true,
                get: () => !!get$2(formState.touchedFields, name),
            },
            error: {
                enumerable: true,
                get: () => get$2(formState.errors, name),
            },
        }),
    };
}

var appendErrors = (name, validateAllFieldCriteria, errors, type, message) => validateAllFieldCriteria
    ? {
        ...errors[name],
        types: {
            ...(errors[name] && errors[name].types ? errors[name].types : {}),
            [type]: message || true,
        },
    }
    : {};

const focusFieldBy = (fields, callback, fieldsNames) => {
    for (const key of fieldsNames || Object.keys(fields)) {
        const field = get$2(fields, key);
        if (field) {
            const { _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus) {
                    _f.ref.focus();
                    break;
                }
                else if (_f.refs && _f.refs[0].focus) {
                    _f.refs[0].focus();
                    break;
                }
            }
            else if (isObject$4(currentField)) {
                focusFieldBy(currentField, callback);
            }
        }
    }
};

var generateId = () => {
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
};

var getFocusFieldName = (name, index, options = {}) => options.shouldFocus || isUndefined$2(options.shouldFocus)
    ? options.focusName ||
        `${name}.${isUndefined$2(options.focusIndex) ? index : options.focusIndex}.`
    : '';

var getValidationModes = (mode) => ({
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched,
});

var isWatched = (name, _names, isBlurEvent) => !isBlurEvent &&
    (_names.watchAll ||
        _names.watch.has(name) ||
        [..._names.watch].some((watchName) => name.startsWith(watchName) &&
            /^\.\w+/.test(name.slice(watchName.length))));

var updateFieldArrayRootError = (errors, error, name) => {
    const fieldArrayErrors = compact(get$2(errors, name));
    set$2(fieldArrayErrors, 'root', error[name]);
    set$2(errors, name, fieldArrayErrors);
    return errors;
};

var isBoolean = (value) => typeof value === 'boolean';

var isFileInput = (element) => element.type === 'file';

var isFunction = (value) => typeof value === 'function';

var isHTMLElement = (value) => {
    if (!isWeb) {
        return false;
    }
    const owner = value ? value.ownerDocument : 0;
    return (value instanceof
        (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement));
};

var isMessage = (value) => isString(value);

var isRadioInput = (element) => element.type === 'radio';

var isRegex = (value) => value instanceof RegExp;

const defaultResult = {
    value: false,
    isValid: false,
};
const validResult = { value: true, isValid: true };
var getCheckboxValue = (options) => {
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options
                .filter((option) => option && option.checked && !option.disabled)
                .map((option) => option.value);
            return { value: values, isValid: !!values.length };
        }
        return options[0].checked && !options[0].disabled
            ? // @ts-expect-error expected to work in the browser
                options[0].attributes && !isUndefined$2(options[0].attributes.value)
                    ? isUndefined$2(options[0].value) || options[0].value === ''
                        ? validResult
                        : { value: options[0].value, isValid: true }
                    : validResult
            : defaultResult;
    }
    return defaultResult;
};

const defaultReturn = {
    isValid: false,
    value: null,
};
var getRadioValue = (options) => Array.isArray(options)
    ? options.reduce((previous, option) => option && option.checked && !option.disabled
        ? {
            isValid: true,
            value: option.value,
        }
        : previous, defaultReturn)
    : defaultReturn;

function getValidateError(result, ref, type = 'validate') {
    if (isMessage(result) ||
        (Array.isArray(result) && result.every(isMessage)) ||
        (isBoolean(result) && !result)) {
        return {
            type,
            message: isMessage(result) ? result : '',
            ref,
        };
    }
}

var getValueAndMessage = (validationData) => isObject$4(validationData) && !isRegex(validationData)
    ? validationData
    : {
        value: validationData,
        message: '',
    };

var validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray) => {
    const { ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, valueAsNumber, mount, disabled, } = field._f;
    const inputValue = get$2(formValues, name);
    if (!mount || disabled) {
        return {};
    }
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message) => {
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity(isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = isRadioInput(ref);
    const isCheckBox = isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = ((valueAsNumber || isFileInput(ref)) &&
        isUndefined$2(ref.value) &&
        isUndefined$2(inputValue)) ||
        (isHTMLElement(ref) && ref.value === '') ||
        inputValue === '' ||
        (Array.isArray(inputValue) && !inputValue.length);
    const appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = INPUT_VALIDATION_RULES.maxLength, minType = INPUT_VALIDATION_RULES.minLength) => {
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message,
            ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message),
        };
    };
    if (isFieldArray
        ? !Array.isArray(inputValue) || !inputValue.length
        : required &&
            ((!isRadioOrCheckbox && (isEmpty || isNullOrUndefined(inputValue))) ||
                (isBoolean(inputValue) && !inputValue) ||
                (isCheckBox && !getCheckboxValue(refs).isValid) ||
                (isRadio && !getRadioValue(refs).isValid))) {
        const { value, message } = isMessage(required)
            ? { value: !!required, message: required }
            : getValueAndMessage(required);
        if (value) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.required,
                message,
                ref: inputRef,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.required, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!isNullOrUndefined(min) || !isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = getValueAndMessage(max);
        const minOutput = getValueAndMessage(min);
        if (!isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber ||
                (inputValue ? +inputValue : inputValue);
            if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
            }
            if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
            }
        }
        else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time) => new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if (isString(maxOutput.value) && inputValue) {
                exceedMax = isTime
                    ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value)
                    : isWeek
                        ? inputValue > maxOutput.value
                        : valueDate > new Date(maxOutput.value);
            }
            if (isString(minOutput.value) && inputValue) {
                exceedMin = isTime
                    ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value)
                    : isWeek
                        ? inputValue < minOutput.value
                        : valueDate < new Date(minOutput.value);
            }
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) &&
        !isEmpty &&
        (isString(inputValue) || (isFieldArray && Array.isArray(inputValue)))) {
        const maxLengthOutput = getValueAndMessage(maxLength);
        const minLengthOutput = getValueAndMessage(minLength);
        const exceedMax = !isNullOrUndefined(maxLengthOutput.value) &&
            inputValue.length > +maxLengthOutput.value;
        const exceedMin = !isNullOrUndefined(minLengthOutput.value) &&
            inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && isString(inputValue)) {
        const { value: patternValue, message } = getValueAndMessage(pattern);
        if (isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: INPUT_VALIDATION_RULES.pattern,
                message,
                ref,
                ...appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, message),
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if (isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message),
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        }
        else if (isObject$4(validate)) {
            let validationResult = {};
            for (const key in validate) {
                if (!isEmptyObject(validationResult) && !validateAllFieldCriteria) {
                    break;
                }
                const validateError = getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message),
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) {
                        error[name] = validationResult;
                    }
                }
            }
            if (!isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult,
                };
                if (!validateAllFieldCriteria) {
                    return error;
                }
            }
        }
    }
    setCustomValidity(true);
    return error;
};

function append(data, value) {
    return [...data, ...convertToArrayPayload(value)];
}

var fillEmptyArray = (value) => Array.isArray(value) ? value.map(() => undefined) : undefined;

function insert(data, index, value) {
    return [
        ...data.slice(0, index),
        ...convertToArrayPayload(value),
        ...data.slice(index),
    ];
}

var moveArrayAt = (data, from, to) => {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isUndefined$2(data[to])) {
        data[to] = undefined;
    }
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};

function prepend(data, value) {
    return [...convertToArrayPayload(value), ...convertToArrayPayload(data)];
}

function removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [...data];
    for (const index of indexes) {
        temp.splice(index - i, 1);
        i++;
    }
    return compact(temp).length ? temp : [];
}
var removeArrayAt = (data, index) => isUndefined$2(index)
    ? []
    : removeAtIndexes(data, convertToArrayPayload(index).sort((a, b) => a - b));

var swapArrayAt = (data, indexA, indexB) => {
    data[indexA] = [data[indexB], (data[indexB] = data[indexA])][0];
};

function baseGet$2(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while (index < length) {
        object = isUndefined$2(object) ? index++ : object[updatePath[index++]];
    }
    return object;
}
function isEmptyArray(obj) {
    for (const key in obj) {
        if (!isUndefined$2(obj[key])) {
            return false;
        }
    }
    return true;
}
function unset(object, path) {
    const paths = Array.isArray(path)
        ? path
        : isKey(path)
            ? [path]
            : stringToPath(path);
    const childObject = paths.length === 1 ? object : baseGet$2(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) {
        delete childObject[key];
    }
    if (index !== 0 &&
        ((isObject$4(childObject) && isEmptyObject(childObject)) ||
            (Array.isArray(childObject) && isEmptyArray(childObject)))) {
        unset(object, paths.slice(0, -1));
    }
    return object;
}

var updateAt = (fieldValues, index, value) => {
    fieldValues[index] = value;
    return fieldValues;
};

/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFieldArray(props) {
    const methods = useFormContext();
    const { control = methods.control, name, keyName = 'id', shouldUnregister, } = props;
    const [fields, setFields] = React.useState(control._getFieldArray(name));
    const ids = React.useRef(control._getFieldArray(name).map(generateId));
    const _fieldIds = React.useRef(fields);
    const _name = React.useRef(name);
    const _actioned = React.useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules &&
        control.register(name, props.rules);
    useSubscribe({
        next: ({ values, name: fieldArrayName, }) => {
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = get$2(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map(generateId);
                }
            }
        },
        subject: control._subjects.array,
    });
    const updateValues = React.useCallback((updatedFieldArrayValues) => {
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [control, name]);
    const append$1 = (value, options) => {
        const appendValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = append(control._getFieldArray(name), appendValue);
        control._names.focus = getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = append(ids.current, appendValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, append, {
            argA: fillEmptyArray(value),
        });
    };
    const prepend$1 = (value, options) => {
        const prependValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = prepend(control._getFieldArray(name), prependValue);
        control._names.focus = getFocusFieldName(name, 0, options);
        ids.current = prepend(ids.current, prependValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, prepend, {
            argA: fillEmptyArray(value),
        });
    };
    const remove = (index) => {
        const updatedFieldArrayValues = removeArrayAt(control._getFieldArray(name), index);
        ids.current = removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, removeArrayAt, {
            argA: index,
        });
    };
    const insert$1 = (index, value, options) => {
        const insertValue = convertToArrayPayload(cloneObject(value));
        const updatedFieldArrayValues = insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = getFocusFieldName(name, index, options);
        ids.current = insert(ids.current, index, insertValue.map(generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, insert, {
            argA: index,
            argB: fillEmptyArray(value),
        });
    };
    const swap = (indexA, indexB) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, swapArrayAt, {
            argA: indexA,
            argB: indexB,
        }, false);
    };
    const move = (from, to) => {
        const updatedFieldArrayValues = control._getFieldArray(name);
        moveArrayAt(updatedFieldArrayValues, from, to);
        moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, moveArrayAt, {
            argA: from,
            argB: to,
        }, false);
    };
    const update = (index, value) => {
        const updateValue = cloneObject(value);
        const updatedFieldArrayValues = updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [...updatedFieldArrayValues].map((item, i) => !item || i === index ? generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, updatedFieldArrayValues, updateAt, {
            argA: index,
            argB: updateValue,
        }, true, false);
    };
    const replace = (value) => {
        const updatedFieldArrayValues = convertToArrayPayload(cloneObject(value));
        ids.current = updatedFieldArrayValues.map(generateId);
        updateValues([...updatedFieldArrayValues]);
        setFields([...updatedFieldArrayValues]);
        control._updateFieldArray(name, [...updatedFieldArrayValues], (data) => data, {}, true, false);
    };
    React.useEffect(() => {
        control._state.action = false;
        isWatched(name, control._names) &&
            control._subjects.state.next({
                ...control._formState,
            });
        if (_actioned.current &&
            (!getValidationModes(control._options.mode).isOnSubmit ||
                control._formState.isSubmitted)) {
            if (control._options.resolver) {
                control._executeSchema([name]).then((result) => {
                    const error = get$2(result.errors, name);
                    const existingError = get$2(control._formState.errors, name);
                    if (existingError ? !error && existingError.type : error && error.type) {
                        error
                            ? set$2(control._formState.errors, name, error)
                            : unset(control._formState.errors, name);
                        control._subjects.state.next({
                            errors: control._formState.errors,
                        });
                    }
                });
            }
            else {
                const field = get$2(control._fields, name);
                if (field && field._f) {
                    validateField(field, control._formValues, control._options.criteriaMode === VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error) => !isEmptyObject(error) &&
                        control._subjects.state.next({
                            errors: updateFieldArrayRootError(control._formState.errors, error, name),
                        }));
                }
            }
        }
        control._subjects.values.next({
            name,
            values: { ...control._formValues },
        });
        control._names.focus &&
            focusFieldBy(control._fields, (key) => !!key && key.startsWith(control._names.focus || ''));
        control._names.focus = '';
        control._updateValid();
    }, [fields, name, control]);
    React.useEffect(() => {
        !get$2(control._formValues, name) && control._updateFieldArray(name);
        return () => {
            (control._options.shouldUnregister || shouldUnregister) &&
                control.unregister(name);
        };
    }, [name, control, keyName, shouldUnregister]);
    return {
        swap: React.useCallback(swap, [updateValues, name, control]),
        move: React.useCallback(move, [updateValues, name, control]),
        prepend: React.useCallback(prepend$1, [updateValues, name, control]),
        append: React.useCallback(append$1, [updateValues, name, control]),
        remove: React.useCallback(remove, [updateValues, name, control]),
        insert: React.useCallback(insert$1, [updateValues, name, control]),
        update: React.useCallback(update, [updateValues, name, control]),
        replace: React.useCallback(replace, [updateValues, name, control]),
        fields: React.useMemo(() => fields.map((field, index) => ({
            ...field,
            [keyName]: ids.current[index] || generateId(),
        })), [fields, keyName]),
    };
}

function createSubject() {
    let _observers = [];
    const next = (value) => {
        for (const observer of _observers) {
            observer.next && observer.next(value);
        }
    };
    const subscribe = (observer) => {
        _observers.push(observer);
        return {
            unsubscribe: () => {
                _observers = _observers.filter((o) => o !== observer);
            },
        };
    };
    const unsubscribe = () => {
        _observers = [];
    };
    return {
        get observers() {
            return _observers;
        },
        next,
        subscribe,
        unsubscribe,
    };
}

var isPrimitive = (value) => isNullOrUndefined(value) || !isObjectType(value);

function deepEqual(object1, object2) {
    if (isPrimitive(object1) || isPrimitive(object2)) {
        return object1 === object2;
    }
    if (isDateObject(object1) && isDateObject(object2)) {
        return object1.getTime() === object2.getTime();
    }
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        const val1 = object1[key];
        if (!keys2.includes(key)) {
            return false;
        }
        if (key !== 'ref') {
            const val2 = object2[key];
            if ((isDateObject(val1) && isDateObject(val2)) ||
                (isObject$4(val1) && isObject$4(val2)) ||
                (Array.isArray(val1) && Array.isArray(val2))
                ? !deepEqual(val1, val2)
                : val1 !== val2) {
                return false;
            }
        }
    }
    return true;
}

var isMultipleSelect = (element) => element.type === `select-multiple`;

var isRadioOrCheckbox = (ref) => isRadioInput(ref) || isCheckBoxInput(ref);

var live = (ref) => isHTMLElement(ref) && ref.isConnected;

var objectHasFunction = (data) => {
    for (const key in data) {
        if (isFunction(data[key])) {
            return true;
        }
    }
    return false;
};

function markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject$4(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject$4(data[key]) && !objectHasFunction(data[key]))) {
                fields[key] = Array.isArray(data[key]) ? [] : {};
                markFieldsDirty(data[key], fields[key]);
            }
            else if (!isNullOrUndefined(data[key])) {
                fields[key] = true;
            }
        }
    }
    return fields;
}
function getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if (isObject$4(data) || isParentNodeArray) {
        for (const key in data) {
            if (Array.isArray(data[key]) ||
                (isObject$4(data[key]) && !objectHasFunction(data[key]))) {
                if (isUndefined$2(formValues) ||
                    isPrimitive(dirtyFieldsFromValues[key])) {
                    dirtyFieldsFromValues[key] = Array.isArray(data[key])
                        ? markFieldsDirty(data[key], [])
                        : { ...markFieldsDirty(data[key]) };
                }
                else {
                    getDirtyFieldsFromDefaultValues(data[key], isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
                }
            }
            else {
                dirtyFieldsFromValues[key] = !deepEqual(data[key], formValues[key]);
            }
        }
    }
    return dirtyFieldsFromValues;
}
var getDirtyFields = (defaultValues, formValues) => getDirtyFieldsFromDefaultValues(defaultValues, formValues, markFieldsDirty(formValues));

var getFieldValueAs = (value, { valueAsNumber, valueAsDate, setValueAs }) => isUndefined$2(value)
    ? value
    : valueAsNumber
        ? value === ''
            ? NaN
            : value
                ? +value
                : value
        : valueAsDate && isString(value)
            ? new Date(value)
            : setValueAs
                ? setValueAs(value)
                : value;

function getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref) => ref.disabled) : ref.disabled) {
        return;
    }
    if (isFileInput(ref)) {
        return ref.files;
    }
    if (isRadioInput(ref)) {
        return getRadioValue(_f.refs).value;
    }
    if (isMultipleSelect(ref)) {
        return [...ref.selectedOptions].map(({ value }) => value);
    }
    if (isCheckBoxInput(ref)) {
        return getCheckboxValue(_f.refs).value;
    }
    return getFieldValueAs(isUndefined$2(ref.value) ? _f.ref.value : ref.value, _f);
}

var getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation) => {
    const fields = {};
    for (const name of fieldsNames) {
        const field = get$2(_fields, name);
        field && set$2(fields, name, field._f);
    }
    return {
        criteriaMode,
        names: [...fieldsNames],
        fields,
        shouldUseNativeValidation,
    };
};

var getRuleValue = (rule) => isUndefined$2(rule)
    ? rule
    : isRegex(rule)
        ? rule.source
        : isObject$4(rule)
            ? isRegex(rule.value)
                ? rule.value.source
                : rule.value
            : rule;

var hasValidation = (options) => options.mount &&
    (options.required ||
        options.min ||
        options.max ||
        options.maxLength ||
        options.minLength ||
        options.pattern ||
        options.validate);

function schemaErrorLookup(errors, _fields, name) {
    const error = get$2(errors, name);
    if (error || isKey(name)) {
        return {
            error,
            name,
        };
    }
    const names = name.split('.');
    while (names.length) {
        const fieldName = names.join('.');
        const field = get$2(_fields, fieldName);
        const foundError = get$2(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) {
            return { name };
        }
        if (foundError && foundError.type) {
            return {
                name: fieldName,
                error: foundError,
            };
        }
        names.pop();
    }
    return {
        name,
    };
}

var skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode) => {
    if (mode.isOnAll) {
        return false;
    }
    else if (!isSubmitted && mode.isOnTouch) {
        return !(isTouched || isBlurEvent);
    }
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) {
        return !isBlurEvent;
    }
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) {
        return isBlurEvent;
    }
    return true;
};

var unsetEmptyArray = (ref, name) => !compact(get$2(ref, name)).length && unset(ref, name);

const defaultOptions = {
    mode: VALIDATION_MODE.onSubmit,
    reValidateMode: VALIDATION_MODE.onChange,
    shouldFocusError: true,
};
function createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...defaultOptions,
        ...props,
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {},
    };
    let _fields = {};
    let _defaultValues = isObject$4(_options.defaultValues) || isObject$4(_options.values)
        ? cloneObject(_options.defaultValues || _options.values) || {}
        : {};
    let _formValues = _options.shouldUnregister
        ? {}
        : cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false,
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    };
    const _subjects = {
        values: createSubject(),
        array: createSubject(),
        state: createSubject(),
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    const validationModeBeforeSubmit = getValidationModes(_options.mode);
    const validationModeAfterSubmit = getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === VALIDATION_MODE.all;
    const debounce = (callback) => (wait) => {
        clearTimeout(timer);
        timer = setTimeout(callback, wait);
    };
    const _updateValid = async (shouldUpdateValid) => {
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver
                ? isEmptyObject((await _executeSchema()).errors)
                : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) {
                _subjects.state.next({
                    isValid,
                });
            }
        }
    };
    const _updateIsValidating = (value) => _proxyFormState.isValidating &&
        _subjects.state.next({
            isValidating: value,
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true) => {
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray(get$2(_fields, name))) {
                const fieldValues = method(get$2(_fields, name), args.argA, args.argB);
                shouldSetValues && set$2(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState &&
                Array.isArray(get$2(_formState.errors, name))) {
                const errors = method(get$2(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && set$2(_formState.errors, name, errors);
                unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields &&
                shouldUpdateFieldsAndState &&
                Array.isArray(get$2(_formState.touchedFields, name))) {
                const touchedFields = method(get$2(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && set$2(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) {
                _formState.dirtyFields = getDirtyFields(_defaultValues, _formValues);
            }
            _subjects.state.next({
                name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid,
            });
        }
        else {
            set$2(_formValues, name, values);
        }
    };
    const updateErrors = (name, error) => {
        set$2(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors,
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value, ref) => {
        const field = get$2(_fields, name);
        if (field) {
            const defaultValue = get$2(_formValues, name, isUndefined$2(value) ? get$2(_defaultValues, name) : value);
            isUndefined$2(defaultValue) ||
                (ref && ref.defaultChecked) ||
                shouldSkipSetValueAs
                ? set$2(_formValues, name, shouldSkipSetValueAs ? defaultValue : getFieldValue(field._f))
                : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender) => {
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name,
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = deepEqual(get$2(_defaultValues, name), fieldValue);
            isPreviousDirty = get$2(_formState.dirtyFields, name);
            isCurrentFieldPristine
                ? unset(_formState.dirtyFields, name)
                : set$2(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField =
                shouldUpdateField ||
                    (_proxyFormState.dirtyFields &&
                        isPreviousDirty !== !isCurrentFieldPristine);
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = get$2(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                set$2(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField =
                    shouldUpdateField ||
                        (_proxyFormState.touchedFields &&
                            isPreviousFieldTouched !== isBlurEvent);
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState) => {
        const previousFieldError = get$2(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid &&
            isBoolean(isValid) &&
            _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(() => updateErrors(name, error));
            delayErrorCallback(props.delayError);
        }
        else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error
                ? set$2(_formState.errors, name, error)
                : unset(_formState.errors, name);
        }
        if ((error ? !deepEqual(previousFieldError, error) : previousFieldError) ||
            !isEmptyObject(fieldState) ||
            shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...(shouldUpdateValid && isBoolean(isValid) ? { isValid } : {}),
                errors: _formState.errors,
                name,
            };
            _formState = {
                ..._formState,
                ...updatedFormState,
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name) => _options.resolver(_formValues, _options.context, getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names) => {
        const { errors } = await _executeSchema();
        if (names) {
            for (const name of names) {
                const error = get$2(errors, name);
                error
                    ? set$2(_formState.errors, name, error)
                    : unset(_formState.errors, name);
            }
        }
        else {
            _formState.errors = errors;
        }
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true,
    }) => {
        for (const name in fields) {
            const field = fields[name];
            if (field) {
                const { _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) {
                            break;
                        }
                    }
                    !shouldOnlyCheckValid &&
                        (get$2(fieldError, _f.name)
                            ? isFieldArrayRoot
                                ? updateFieldArrayRootError(_formState.errors, fieldError, _f.name)
                                : set$2(_formState.errors, _f.name, fieldError[_f.name])
                            : unset(_formState.errors, _f.name));
                }
                fieldValue &&
                    (await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context));
            }
        }
        return context.valid;
    };
    const _removeUnmounted = () => {
        for (const name of _names.unMount) {
            const field = get$2(_fields, name);
            field &&
                (field._f.refs
                    ? field._f.refs.every((ref) => !live(ref))
                    : !live(field._f.ref)) &&
                unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data) => (name && data && set$2(_formValues, name, data),
        !deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal) => generateWatchOutput(names, _names, {
        ...(_state.mount
            ? _formValues
            : isUndefined$2(defaultValue)
                ? _defaultValues
                : isString(names)
                    ? { [names]: defaultValue }
                    : defaultValue),
    }, isGlobal, defaultValue);
    const _getFieldArray = (name) => compact(get$2(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? get$2(_defaultValues, name, []) : []));
    const setFieldValue = (name, value, options = {}) => {
        const field = get$2(_fields, name);
        let fieldValue = value;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled &&
                    set$2(_formValues, name, getFieldValueAs(value, fieldReference));
                fieldValue =
                    isHTMLElement(fieldReference.ref) && isNullOrUndefined(value)
                        ? ''
                        : value;
                if (isMultipleSelect(fieldReference.ref)) {
                    [...fieldReference.ref.options].forEach((optionRef) => (optionRef.selected = fieldValue.includes(optionRef.value)));
                }
                else if (fieldReference.refs) {
                    if (isCheckBoxInput(fieldReference.ref)) {
                        fieldReference.refs.length > 1
                            ? fieldReference.refs.forEach((checkboxRef) => (!checkboxRef.defaultChecked || !checkboxRef.disabled) &&
                                (checkboxRef.checked = Array.isArray(fieldValue)
                                    ? !!fieldValue.find((data) => data === checkboxRef.value)
                                    : fieldValue === checkboxRef.value))
                            : fieldReference.refs[0] &&
                                (fieldReference.refs[0].checked = !!fieldValue);
                    }
                    else {
                        fieldReference.refs.forEach((radioRef) => (radioRef.checked = radioRef.value === fieldValue));
                    }
                }
                else if (isFileInput(fieldReference.ref)) {
                    fieldReference.ref.value = '';
                }
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) {
                        _subjects.values.next({
                            name,
                            values: { ..._formValues },
                        });
                    }
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) &&
            updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value, options) => {
        for (const fieldKey in value) {
            const fieldValue = value[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = get$2(_fields, fieldName);
            (_names.array.has(name) ||
                !isPrimitive(fieldValue) ||
                (field && !field._f)) &&
                !isDateObject(fieldValue)
                ? setValues(fieldName, fieldValue, options)
                : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value, options = {}) => {
        const field = get$2(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = cloneObject(value);
        set$2(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name,
                values: { ..._formValues },
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) &&
                options.shouldDirty) {
                _subjects.state.next({
                    name,
                    dirtyFields: getDirtyFields(_defaultValues, _formValues),
                    isDirty: _getDirty(name, cloneValue),
                });
            }
        }
        else {
            field && !field._f && !isNullOrUndefined(cloneValue)
                ? setValues(name, cloneValue, options)
                : setFieldValue(name, cloneValue, options);
        }
        isWatched(name, _names) && _subjects.state.next({ ..._formState });
        _subjects.values.next({
            name,
            values: { ..._formValues },
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event) => {
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = get$2(_fields, name);
        const getCurrentFieldValue = () => target.type ? getFieldValue(field._f) : getEventValue(event);
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === EVENTS.BLUR || event.type === EVENTS.FOCUS_OUT;
            const shouldSkipValidation = (!hasValidation(field._f) &&
                !_options.resolver &&
                !get$2(_formState.errors, name) &&
                !field._f.deps) ||
                skipValidation(isBlurEvent, get$2(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = isWatched(name, _names, isBlurEvent);
            set$2(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            }
            else if (field._f.onChange) {
                field._f.onChange(event);
            }
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !isEmptyObject(fieldState) || watched;
            !isBlurEvent &&
                _subjects.values.next({
                    name,
                    type: event.type,
                    values: { ..._formValues },
                });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return (shouldRender &&
                    _subjects.state.next({ name, ...(watched ? {} : fieldState) }));
            }
            !isBlurEvent && watched && _subjects.state.next({ ..._formState });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors } = await _executeSchema([name]);
                const previousErrorLookupResult = schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = isEmptyObject(errors);
            }
            else {
                error = (await validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isFieldValueUpdated =
                    isNaN(fieldValue) ||
                        fieldValue === get$2(_formValues, name, fieldValue);
                if (isFieldValueUpdated) {
                    if (error) {
                        isValid = false;
                    }
                    else if (_proxyFormState.isValid) {
                        isValid = await executeBuiltInValidation(_fields, true);
                    }
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps &&
                    trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const trigger = async (name, options = {}) => {
        let isValid;
        let validationResult;
        const fieldNames = convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState(isUndefined$2(name) ? name : fieldNames);
            isValid = isEmptyObject(errors);
            validationResult = name
                ? !fieldNames.some((name) => get$2(errors, name))
                : isValid;
        }
        else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName) => {
                const field = get$2(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? { [fieldName]: field } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        }
        else {
            validationResult = isValid = await executeBuiltInValidation(_fields);
        }
        _subjects.state.next({
            ...(!isString(name) ||
                (_proxyFormState.isValid && isValid !== _formState.isValid)
                ? {}
                : { name }),
            ...(_options.resolver || !name ? { isValid } : {}),
            errors: _formState.errors,
            isValidating: false,
        });
        options.shouldFocus &&
            !validationResult &&
            focusFieldBy(_fields, (key) => key && get$2(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames) => {
        const values = {
            ..._defaultValues,
            ...(_state.mount ? _formValues : {}),
        };
        return isUndefined$2(fieldNames)
            ? values
            : isString(fieldNames)
                ? get$2(values, fieldNames)
                : fieldNames.map((name) => get$2(values, name));
    };
    const getFieldState = (name, formState) => ({
        invalid: !!get$2((formState || _formState).errors, name),
        isDirty: !!get$2((formState || _formState).dirtyFields, name),
        isTouched: !!get$2((formState || _formState).touchedFields, name),
        error: get$2((formState || _formState).errors, name),
    });
    const clearErrors = (name) => {
        name &&
            convertToArrayPayload(name).forEach((inputName) => unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {},
        });
    };
    const setError = (name, error, options) => {
        const ref = (get$2(_fields, name, { _f: {} })._f || {}).ref;
        set$2(_formState.errors, name, {
            ...error,
            ref,
        });
        _subjects.state.next({
            name,
            errors: _formState.errors,
            isValid: false,
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue) => isFunction(name)
        ? _subjects.values.subscribe({
            next: (payload) => name(_getWatch(undefined, defaultValue), payload),
        })
        : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {}) => {
        for (const fieldName of name ? convertToArrayPayload(name) : _names.mount) {
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                unset(_fields, fieldName);
                unset(_formValues, fieldName);
            }
            !options.keepError && unset(_formState.errors, fieldName);
            !options.keepDirty && unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister &&
                !options.keepDefaultValue &&
                unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: { ..._formValues },
        });
        _subjects.state.next({
            ..._formState,
            ...(!options.keepDirty ? {} : { isDirty: _getDirty() }),
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {}) => {
        let field = get$2(_fields, name);
        const disabledIsDefined = isBoolean(options.disabled);
        set$2(_fields, name, {
            ...(field || {}),
            _f: {
                ...(field && field._f ? field._f : { ref: { name } }),
                name,
                mount: true,
                ...options,
            },
        });
        _names.mount.add(name);
        field
            ? disabledIsDefined &&
                set$2(_formValues, name, options.disabled
                    ? undefined
                    : get$2(_formValues, name, getFieldValue(field._f)))
            : updateValidAndValue(name, true, options.value);
        return {
            ...(disabledIsDefined ? { disabled: options.disabled } : {}),
            ...(_options.shouldUseNativeValidation
                ? {
                    required: !!options.required,
                    min: getRuleValue(options.min),
                    max: getRuleValue(options.max),
                    minLength: getRuleValue(options.minLength),
                    maxLength: getRuleValue(options.maxLength),
                    pattern: getRuleValue(options.pattern),
                }
                : {}),
            name,
            onChange,
            onBlur: onChange,
            ref: (ref) => {
                if (ref) {
                    register(name, options);
                    field = get$2(_fields, name);
                    const fieldRef = isUndefined$2(ref.value)
                        ? ref.querySelectorAll
                            ? ref.querySelectorAll('input,select,textarea')[0] || ref
                            : ref
                        : ref;
                    const radioOrCheckbox = isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox
                        ? refs.find((option) => option === fieldRef)
                        : fieldRef === field._f.ref) {
                        return;
                    }
                    set$2(_fields, name, {
                        _f: {
                            ...field._f,
                            ...(radioOrCheckbox
                                ? {
                                    refs: [
                                        ...refs.filter(live),
                                        fieldRef,
                                        ...(Array.isArray(get$2(_defaultValues, name)) ? [{}] : []),
                                    ],
                                    ref: { type: fieldRef.type, name },
                                }
                                : { ref: fieldRef }),
                        },
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                }
                else {
                    field = get$2(_fields, name, {});
                    if (field._f) {
                        field._f.mount = false;
                    }
                    (_options.shouldUnregister || options.shouldUnregister) &&
                        !(isNameInFieldArray(_names.array, name) && _state.action) &&
                        _names.unMount.add(name);
                }
            },
        };
    };
    const _focusError = () => _options.shouldFocusError &&
        focusFieldBy(_fields, (key) => key && get$2(_formState.errors, key), _names.mount);
    const handleSubmit = (onValid, onInvalid) => async (e) => {
        if (e) {
            e.preventDefault && e.preventDefault();
            e.persist && e.persist();
        }
        let fieldValues = cloneObject(_formValues);
        _subjects.state.next({
            isSubmitting: true,
        });
        if (_options.resolver) {
            const { errors, values } = await _executeSchema();
            _formState.errors = errors;
            fieldValues = values;
        }
        else {
            await executeBuiltInValidation(_fields);
        }
        unset(_formState.errors, 'root');
        if (isEmptyObject(_formState.errors)) {
            _subjects.state.next({
                errors: {},
            });
            await onValid(fieldValues, e);
        }
        else {
            if (onInvalid) {
                await onInvalid({ ..._formState.errors }, e);
            }
            _focusError();
            setTimeout(_focusError);
        }
        _subjects.state.next({
            isSubmitted: true,
            isSubmitting: false,
            isSubmitSuccessful: isEmptyObject(_formState.errors),
            submitCount: _formState.submitCount + 1,
            errors: _formState.errors,
        });
    };
    const resetField = (name, options = {}) => {
        if (get$2(_fields, name)) {
            if (isUndefined$2(options.defaultValue)) {
                setValue(name, get$2(_defaultValues, name));
            }
            else {
                setValue(name, options.defaultValue);
                set$2(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) {
                unset(_formState.touchedFields, name);
            }
            if (!options.keepDirty) {
                unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue
                    ? _getDirty(name, get$2(_defaultValues, name))
                    : _getDirty();
            }
            if (!options.keepError) {
                unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({ ..._formState });
        }
    };
    const _reset = (formValues, keepStateOptions = {}) => {
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = cloneObject(updatedValues);
        const values = formValues && !isEmptyObject(formValues)
            ? cloneUpdatedValues
            : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) {
            _defaultValues = updatedValues;
        }
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) {
                for (const fieldName of _names.mount) {
                    get$2(_formState.dirtyFields, fieldName)
                        ? set$2(values, fieldName, get$2(_formValues, fieldName))
                        : setValue(fieldName, get$2(values, fieldName));
                }
            }
            else {
                if (isWeb && isUndefined$2(formValues)) {
                    for (const name of _names.mount) {
                        const field = get$2(_fields, name);
                        if (field && field._f) {
                            const fieldReference = Array.isArray(field._f.refs)
                                ? field._f.refs[0]
                                : field._f.ref;
                            if (isHTMLElement(fieldReference)) {
                                const form = fieldReference.closest('form');
                                if (form) {
                                    form.reset();
                                    break;
                                }
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister
                ? keepStateOptions.keepDefaultValues
                    ? cloneObject(_defaultValues)
                    : {}
                : cloneUpdatedValues;
            _subjects.array.next({
                values: { ...values },
            });
            _subjects.values.next({
                values: { ...values },
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: '',
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount
                ? _formState.submitCount
                : 0,
            isDirty: keepStateOptions.keepDirty
                ? _formState.isDirty
                : !!(keepStateOptions.keepDefaultValues &&
                    !deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted
                ? _formState.isSubmitted
                : false,
            dirtyFields: keepStateOptions.keepDirtyValues
                ? _formState.dirtyFields
                : keepStateOptions.keepDefaultValues && formValues
                    ? getDirtyFields(_defaultValues, formValues)
                    : {},
            touchedFields: keepStateOptions.keepTouched
                ? _formState.touchedFields
                : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false,
        });
    };
    const reset = (formValues, keepStateOptions) => _reset(isFunction(formValues)
        ? formValues(_formValues)
        : formValues, keepStateOptions);
    const setFocus = (name, options = {}) => {
        const field = get$2(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs
                ? fieldReference.refs[0]
                : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState) => {
        _formState = {
            ..._formState,
            ...updatedFormState,
        };
    };
    const _resetDefaultValues = () => isFunction(_options.defaultValues) &&
        _options.defaultValues().then((values) => {
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false,
            });
        });
    return {
        control: {
            register,
            unregister,
            getFieldState,
            _executeSchema,
            _getWatch,
            _getDirty,
            _updateValid,
            _removeUnmounted,
            _updateFieldArray,
            _getFieldArray,
            _reset,
            _resetDefaultValues,
            _updateFormState,
            _subjects,
            _proxyFormState,
            get _fields() {
                return _fields;
            },
            get _formValues() {
                return _formValues;
            },
            get _state() {
                return _state;
            },
            set _state(value) {
                _state = value;
            },
            get _defaultValues() {
                return _defaultValues;
            },
            get _names() {
                return _names;
            },
            set _names(value) {
                _names = value;
            },
            get _formState() {
                return _formState;
            },
            set _formState(value) {
                _formState = value;
            },
            get _options() {
                return _options;
            },
            set _options(value) {
                _options = {
                    ..._options,
                    ...value,
                };
            },
        },
        trigger,
        register,
        handleSubmit,
        watch,
        setValue,
        getValues,
        reset,
        resetField,
        clearErrors,
        unregister,
        setError,
        setFocus,
        getFieldState,
    };
}

/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useForm(props = {}) {
    const _formControl = React.useRef();
    const [formState, updateFormState] = React.useState({
        isDirty: false,
        isValidating: false,
        isLoading: isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: isFunction(props.defaultValues)
            ? undefined
            : props.defaultValues,
    });
    if (!_formControl.current) {
        _formControl.current = {
            ...createFormControl(props, () => updateFormState((formState) => ({ ...formState }))),
            formState,
        };
    }
    const control = _formControl.current.control;
    control._options = props;
    useSubscribe({
        subject: control._subjects.state,
        next: (value) => {
            if (shouldRenderFormState(value, control._proxyFormState, control._updateFormState, true)) {
                updateFormState({ ...control._formState });
            }
        },
    });
    React.useEffect(() => {
        if (props.values && !deepEqual(props.values, control._defaultValues)) {
            control._reset(props.values, control._options.resetOptions);
        }
        else {
            control._resetDefaultValues();
        }
    }, [props.values, control]);
    React.useEffect(() => {
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({ ...control._formState });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = getProxyFormState(formState, control);
    return _formControl.current;
}

var e=function(i,e,t){if(i&&"reportValidity"in i){var f=get$2(t,e);i.setCustomValidity(f&&f.message||""),i.reportValidity();}},t=function(r,i){var t=function(t){var f=i.fields[t];f&&f.ref&&"reportValidity"in f.ref?e(f.ref,t,r):f.refs&&f.refs.forEach(function(i){return e(i,t,r)});};for(var f in i.fields)t(f);},f$1=function(e,f){f.shouldUseNativeValidation&&t(e,f);var o={};for(var a in e){var n=get$2(f.fields,a);set$2(o,a,Object.assign(e[a],{ref:n&&n.ref}));}return o};

var o=function(o,n,a){return void 0===n&&(n={}),void 0===a&&(a={}),function(s,i,c){try{return Promise.resolve(function(t$1,r){try{var u=(n.context&&"development"===process.env.NODE_ENV&&console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"),Promise.resolve(o["sync"===a.mode?"validateSync":"validate"](s,Object.assign({abortEarly:!1},n,{context:i}))).then(function(t$1){return c.shouldUseNativeValidation&&t({},c),{values:a.rawValues?s:t$1,errors:{}}}));}catch(e){return r(e)}return u&&u.then?u.then(void 0,r):u}(0,function(e){if(!e.inner)throw e;return {values:{},errors:f$1((o=e,n=!c.shouldUseNativeValidation&&"all"===c.criteriaMode,(o.inner||[]).reduce(function(e,t){if(e[t.path]||(e[t.path]={message:t.message,type:t.type}),n){var o=e[t.path].types,a=o&&o[t.type];e[t.path]=appendErrors(t.path,n,e,t.type,a?[].concat(a,t.message):t.message);}return e},{})),c)};var o,n;}))}catch(e){return Promise.reject(e)}}};

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

function u(e){return "number"==typeof e&&!isNaN(e)}function d(e){return "boolean"==typeof e}function p(e){return "string"==typeof e}function m(e){return "function"==typeof e}function f(e){return p(e)||m(e)?e:null}function g(e){return 0===e||e}function y(e){return React.isValidElement(e)||p(e)||m(e)||u(e)}const h={TOP_LEFT:"top-left",TOP_RIGHT:"top-right",TOP_CENTER:"top-center",BOTTOM_LEFT:"bottom-left",BOTTOM_RIGHT:"bottom-right",BOTTOM_CENTER:"bottom-center"},T={INFO:"info",SUCCESS:"success",WARNING:"warning",ERROR:"error",DEFAULT:"default"};function v(e,t,n){void 0===n&&(n=300);const{scrollHeight:o,style:s}=e;requestAnimationFrame(()=>{s.minHeight="initial",s.height=o+"px",s.transition="all "+n+"ms",requestAnimationFrame(()=>{s.height="0",s.padding="0",s.margin="0",setTimeout(t,n);});});}function E(t){let{enter:a,exit:r,appendPosition:i=!1,collapse:c=!0,collapseDuration:l=300}=t;return function(t){let{children:u,position:d,preventExitTransition:p,done:m,nodeRef:f,isIn:g}=t;const y=i?a+"--"+d:a,h=i?r+"--"+d:r,T=React.useRef(),E=React.useRef(0);function b(e){if(e.target!==f.current)return;const t=f.current;t.dispatchEvent(new Event("d")),t.removeEventListener("animationend",b),t.removeEventListener("animationcancel",b),0===E.current&&"animationcancel"!==e.type&&(t.className=T.current);}function C(){const e=f.current;e.removeEventListener("animationend",C),c?v(e,m,l):m();}return React.useLayoutEffect(()=>{!function(){const e=f.current;T.current=e.className,e.className+=" "+y,e.addEventListener("animationend",b),e.addEventListener("animationcancel",b);}();},[]),React.useEffect(()=>{g||(p?C():function(){E.current=1;const e=f.current;e.className+=" "+h,e.addEventListener("animationend",C);}());},[g]),React.createElement(React.Fragment,null,u)}}function b(e,t){return {content:e.content,containerId:e.props.containerId,id:e.props.toastId,theme:e.props.theme,type:e.props.type,data:e.props.data||{},isLoading:e.props.isLoading,icon:e.props.icon,status:t}}const C={list:new Map,emitQueue:new Map,on(e,t){return this.list.has(e)||this.list.set(e,[]),this.list.get(e).push(t),this},off(e,t){if(t){const n=this.list.get(e).filter(e=>e!==t);return this.list.set(e,n),this}return this.list.delete(e),this},cancelEmit(e){const t=this.emitQueue.get(e);return t&&(t.forEach(clearTimeout),this.emitQueue.delete(e)),this},emit(e){this.list.has(e)&&this.list.get(e).forEach(t=>{const n=setTimeout(()=>{t(...[].slice.call(arguments,1));},0);this.emitQueue.has(e)||this.emitQueue.set(e,[]),this.emitQueue.get(e).push(n);});}},_=t=>{let{theme:n,type:o,...s}=t;return React.createElement("svg",{viewBox:"0 0 24 24",width:"100%",height:"100%",fill:"colored"===n?"currentColor":"var(--toastify-icon-color-"+o+")",...s})},I={info:function(t){return React.createElement(_,{...t},React.createElement("path",{d:"M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"}))},warning:function(t){return React.createElement(_,{...t},React.createElement("path",{d:"M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"}))},success:function(t){return React.createElement(_,{...t},React.createElement("path",{d:"M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"}))},error:function(t){return React.createElement(_,{...t},React.createElement("path",{d:"M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"}))},spinner:function(){return React.createElement("div",{className:"Toastify__spinner"})}};function O(e){const[,o]=React.useReducer(e=>e+1,0),[c,l]=React.useState([]),h=React.useRef(null),T=React.useRef(new Map).current,v=e=>-1!==c.indexOf(e),E=React.useRef({toastKey:1,displayedToast:0,count:0,queue:[],props:e,containerId:null,isToastActive:v,getToast:e=>T.get(e)}).current;function _(e){let{containerId:t}=e;const{limit:n}=E.props;!n||t&&E.containerId!==t||(E.count-=E.queue.length,E.queue=[]);}function O(e){l(t=>g(e)?t.filter(t=>t!==e):[]);}function L(){const{toastContent:e,toastProps:t,staleId:n}=E.queue.shift();P(e,t,n);}function N(e,n){let{delay:s,staleId:r,...i}=n;if(!y(e)||function(e){return !h.current||E.props.enableMultiContainer&&e.containerId!==E.props.containerId||T.has(e.toastId)&&null==e.updateId}(i))return;const{toastId:c,updateId:l,data:v}=i,{props:_}=E,N=()=>O(c),x=null==l;x&&E.count++;const R={toastId:c,updateId:l,data:v,containerId:i.containerId,isLoading:i.isLoading,theme:i.theme||_.theme,icon:null!=i.icon?i.icon:_.icon,isIn:!1,key:i.key||E.toastKey++,type:i.type,closeToast:N,closeButton:i.closeButton,rtl:_.rtl,position:i.position||_.position,transition:i.transition||_.transition,className:f(i.className||_.toastClassName),bodyClassName:f(i.bodyClassName||_.bodyClassName),style:i.style||_.toastStyle,bodyStyle:i.bodyStyle||_.bodyStyle,onClick:i.onClick||_.onClick,pauseOnHover:d(i.pauseOnHover)?i.pauseOnHover:_.pauseOnHover,pauseOnFocusLoss:d(i.pauseOnFocusLoss)?i.pauseOnFocusLoss:_.pauseOnFocusLoss,draggable:d(i.draggable)?i.draggable:_.draggable,draggablePercent:i.draggablePercent||_.draggablePercent,draggableDirection:i.draggableDirection||_.draggableDirection,closeOnClick:d(i.closeOnClick)?i.closeOnClick:_.closeOnClick,progressClassName:f(i.progressClassName||_.progressClassName),progressStyle:i.progressStyle||_.progressStyle,autoClose:!i.isLoading&&(k=i.autoClose,B=_.autoClose,!1===k||u(k)&&k>0?k:B),hideProgressBar:d(i.hideProgressBar)?i.hideProgressBar:_.hideProgressBar,progress:i.progress,role:i.role||_.role,deleteToast(){const e=b(T.get(c),"removed");T.delete(c),C.emit(4,e);const t=E.queue.length;if(E.count=g(c)?E.count-1:E.count-E.displayedToast,E.count<0&&(E.count=0),t>0){const e=g(c)?1:E.props.limit;if(1===t||1===e)E.displayedToast++,L();else {const n=e>t?t:e;E.displayedToast=n;for(let e=0;e<n;e++)L();}}else o();}};var k,B;R.iconOut=function(e){let{theme:n,type:o,isLoading:s,icon:r}=e,i=null;const c={theme:n,type:o};return !1===r||(m(r)?i=r(c):React.isValidElement(r)?i=React.cloneElement(r,c):p(r)||u(r)?i=r:s?i=I.spinner():(e=>e in I)(o)&&(i=I[o](c))),i}(R),m(i.onOpen)&&(R.onOpen=i.onOpen),m(i.onClose)&&(R.onClose=i.onClose),R.closeButton=_.closeButton,!1===i.closeButton||y(i.closeButton)?R.closeButton=i.closeButton:!0===i.closeButton&&(R.closeButton=!y(_.closeButton)||_.closeButton);let M=e;React.isValidElement(e)&&!p(e.type)?M=React.cloneElement(e,{closeToast:N,toastProps:R,data:v}):m(e)&&(M=e({closeToast:N,toastProps:R,data:v})),_.limit&&_.limit>0&&E.count>_.limit&&x?E.queue.push({toastContent:M,toastProps:R,staleId:r}):u(s)?setTimeout(()=>{P(M,R,r);},s):P(M,R,r);}function P(e,t,n){const{toastId:o}=t;n&&T.delete(n);const s={content:e,props:t};T.set(o,s),l(e=>[...e,o].filter(e=>e!==n)),C.emit(4,b(s,null==s.props.updateId?"added":"updated"));}return React.useEffect(()=>(E.containerId=e.containerId,C.cancelEmit(3).on(0,N).on(1,e=>h.current&&O(e)).on(5,_).emit(2,E),()=>C.emit(3,E)),[]),React.useEffect(()=>{E.props=e,E.isToastActive=v,E.displayedToast=c.length;}),{getToastToRender:function(t){const n=new Map,o=Array.from(T.values());return e.newestOnTop&&o.reverse(),o.forEach(e=>{const{position:t}=e.props;n.has(t)||n.set(t,[]),n.get(t).push(e);}),Array.from(n,e=>t(e[0],e[1]))},containerRef:h,isToastActive:v}}function L(e){return e.targetTouches&&e.targetTouches.length>=1?e.targetTouches[0].clientX:e.clientX}function N(e){return e.targetTouches&&e.targetTouches.length>=1?e.targetTouches[0].clientY:e.clientY}function P(e){const[o,a]=React.useState(!1),[r,c]=React.useState(!1),l=React.useRef(null),u=React.useRef({start:0,x:0,y:0,delta:0,removalDistance:0,canCloseOnClick:!0,canDrag:!1,boundingRect:null,didMove:!1}).current,d=React.useRef(e),{autoClose:p,pauseOnHover:f,closeToast:g,onClick:y,closeOnClick:h}=e;function T(t){if(e.draggable){u.didMove=!1,document.addEventListener("mousemove",C),document.addEventListener("mouseup",_),document.addEventListener("touchmove",C),document.addEventListener("touchend",_);const n=l.current;u.canCloseOnClick=!0,u.canDrag=!0,u.boundingRect=n.getBoundingClientRect(),n.style.transition="",u.x=L(t.nativeEvent),u.y=N(t.nativeEvent),"x"===e.draggableDirection?(u.start=u.x,u.removalDistance=n.offsetWidth*(e.draggablePercent/100)):(u.start=u.y,u.removalDistance=n.offsetHeight*(80===e.draggablePercent?1.5*e.draggablePercent:e.draggablePercent/100));}}function v(){if(u.boundingRect){const{top:t,bottom:n,left:o,right:s}=u.boundingRect;e.pauseOnHover&&u.x>=o&&u.x<=s&&u.y>=t&&u.y<=n?b():E();}}function E(){a(!0);}function b(){a(!1);}function C(t){const n=l.current;u.canDrag&&n&&(u.didMove=!0,o&&b(),u.x=L(t),u.y=N(t),u.delta="x"===e.draggableDirection?u.x-u.start:u.y-u.start,u.start!==u.x&&(u.canCloseOnClick=!1),n.style.transform="translate"+e.draggableDirection+"("+u.delta+"px)",n.style.opacity=""+(1-Math.abs(u.delta/u.removalDistance)));}function _(){document.removeEventListener("mousemove",C),document.removeEventListener("mouseup",_),document.removeEventListener("touchmove",C),document.removeEventListener("touchend",_);const t=l.current;if(u.canDrag&&u.didMove&&t){if(u.canDrag=!1,Math.abs(u.delta)>u.removalDistance)return c(!0),void e.closeToast();t.style.transition="transform 0.2s, opacity 0.2s",t.style.transform="translate"+e.draggableDirection+"(0)",t.style.opacity="1";}}React.useEffect(()=>{d.current=e;}),React.useEffect(()=>(l.current&&l.current.addEventListener("d",E,{once:!0}),m(e.onOpen)&&e.onOpen(React.isValidElement(e.children)&&e.children.props),()=>{const e=d.current;m(e.onClose)&&e.onClose(React.isValidElement(e.children)&&e.children.props);}),[]),React.useEffect(()=>(e.pauseOnFocusLoss&&(document.hasFocus()||b(),window.addEventListener("focus",E),window.addEventListener("blur",b)),()=>{e.pauseOnFocusLoss&&(window.removeEventListener("focus",E),window.removeEventListener("blur",b));}),[e.pauseOnFocusLoss]);const I={onMouseDown:T,onTouchStart:T,onMouseUp:v,onTouchEnd:v};return p&&f&&(I.onMouseEnter=b,I.onMouseLeave=E),h&&(I.onClick=e=>{y&&y(e),u.canCloseOnClick&&g();}),{playToast:E,pauseToast:b,isRunning:o,preventExitTransition:r,toastRef:l,eventHandlers:I}}function x(t){let{closeToast:n,theme:o,ariaLabel:s="close"}=t;return React.createElement("button",{className:"Toastify__close-button Toastify__close-button--"+o,type:"button",onClick:e=>{e.stopPropagation(),n(e);},"aria-label":s},React.createElement("svg",{"aria-hidden":"true",viewBox:"0 0 14 16"},React.createElement("path",{fillRule:"evenodd",d:"M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"})))}function R(t){let{delay:n,isRunning:o,closeToast:s,type:a,hide:r,className:i,style:c,controlledProgress:u,progress:d,rtl:p,isIn:f,theme:g}=t;const y={...c,animationDuration:n+"ms",animationPlayState:o?"running":"paused",opacity:r?0:1};u&&(y.transform="scaleX("+d+")");const h=clsx("Toastify__progress-bar",u?"Toastify__progress-bar--controlled":"Toastify__progress-bar--animated","Toastify__progress-bar-theme--"+g,"Toastify__progress-bar--"+a,{"Toastify__progress-bar--rtl":p}),T=m(i)?i({rtl:p,type:a,defaultClassName:h}):clsx(h,i);return React.createElement("div",{role:"progressbar","aria-hidden":r?"true":"false","aria-label":"notification timer",className:T,style:y,[u&&d>=1?"onTransitionEnd":"onAnimationEnd"]:u&&d<1?null:()=>{f&&s();}})}R.defaultProps={type:T.DEFAULT,hide:!1};const k=t=>{const{isRunning:n,preventExitTransition:o,toastRef:s,eventHandlers:a}=P(t),{closeButton:r,children:i,autoClose:c,onClick:u,type:d,hideProgressBar:p,closeToast:f,transition:g,position:y,className:h,style:T,bodyClassName:v,bodyStyle:E,progressClassName:b,progressStyle:C,updateId:_,role:I,progress:O,rtl:L,toastId:N,deleteToast:k,isIn:B,isLoading:M,iconOut:D,theme:w}=t,A=clsx("Toastify__toast","Toastify__toast-theme--"+w,"Toastify__toast--"+d,{"Toastify__toast--rtl":L}),F=m(h)?h({rtl:L,position:y,type:d,defaultClassName:A}):clsx(A,h),S=!!O,z={closeToast:f,type:d,theme:w};let H=null;return !1===r||(H=m(r)?r(z):React.isValidElement(r)?React.cloneElement(r,z):x(z)),React.createElement(g,{isIn:B,done:k,position:y,preventExitTransition:o,nodeRef:s},React.createElement("div",{id:N,onClick:u,className:F,...a,style:T,ref:s},React.createElement("div",{...B&&{role:I},className:m(v)?v({type:d}):clsx("Toastify__toast-body",v),style:E},null!=D&&React.createElement("div",{className:clsx("Toastify__toast-icon",{"Toastify--animate-icon Toastify__zoom-enter":!M})},D),React.createElement("div",null,i)),H,(c||S)&&React.createElement(R,{..._&&!S?{key:"pb-"+_}:{},rtl:L,theme:w,delay:c,isRunning:n,isIn:B,closeToast:f,hide:p,type:d,style:C,className:b,controlledProgress:S,progress:O})))},B=E({enter:"Toastify--animate Toastify__bounce-enter",exit:"Toastify--animate Toastify__bounce-exit",appendPosition:!0}),A=React.forwardRef((t,n)=>{const{getToastToRender:o,containerRef:a,isToastActive:r}=O(t),{className:i,style:c,rtl:u,containerId:d}=t;function p(e){const t=clsx("Toastify__toast-container","Toastify__toast-container--"+e,{"Toastify__toast-container--rtl":u});return m(i)?i({position:e,rtl:u,defaultClassName:t}):clsx(t,f(i))}return React.useEffect(()=>{n&&(n.current=a.current);},[]),React.createElement("div",{ref:a,className:"Toastify",id:d},o((t,n)=>{const o=n.length?{...c}:{...c,pointerEvents:"none"};return React.createElement("div",{className:p(t),style:o,key:"container-"+t},n.map((t,o)=>{let{content:s,props:a}=t;return React.createElement(k,{...a,isIn:r(a.toastId),style:{...a.style,"--nth":o+1,"--len":n.length},key:"toast-"+a.key},s)}))}))});A.displayName="ToastContainer",A.defaultProps={position:h.TOP_RIGHT,transition:B,rtl:!1,autoClose:5e3,hideProgressBar:!1,closeButton:x,pauseOnHover:!0,pauseOnFocusLoss:!0,closeOnClick:!0,newestOnTop:!1,draggable:!0,draggablePercent:80,draggableDirection:"x",role:"alert",theme:"light"};let F,S=new Map,z=[];function H(){return Math.random().toString(36).substring(2,9)}function q(e){return e&&(p(e.toastId)||u(e.toastId))?e.toastId:H()}function U(e,t){return S.size>0?C.emit(0,e,t):z.push({content:e,options:t}),t.toastId}function Q(e,t){return {...t,type:t&&t.type||e,toastId:q(t)}}function G(e){return (t,n)=>U(t,Q(e,n))}function W(e,t){return U(e,Q(T.DEFAULT,t))}W.loading=(e,t)=>U(e,Q(T.DEFAULT,{isLoading:!0,autoClose:!1,closeOnClick:!1,closeButton:!1,draggable:!1,...t})),W.promise=function(e,t,n){let o,{pending:s,error:a,success:r}=t;s&&(o=p(s)?W.loading(s,n):W.loading(s.render,{...n,...s}));const i={isLoading:null,autoClose:null,closeOnClick:null,closeButton:null,draggable:null,delay:100},c=(e,t,s)=>{if(null==t)return void W.dismiss(o);const a={type:e,...i,...n,data:s},r=p(t)?{render:t}:t;return o?W.update(o,{...a,...r}):W(r.render,{...a,...r}),s},l=m(e)?e():e;return l.then(e=>c("success",r,e)).catch(e=>c("error",a,e)),l},W.success=G(T.SUCCESS),W.info=G(T.INFO),W.error=G(T.ERROR),W.warning=G(T.WARNING),W.warn=W.warning,W.dark=(e,t)=>U(e,Q(T.DEFAULT,{theme:"dark",...t})),W.dismiss=e=>C.emit(1,e),W.clearWaitingQueue=function(e){return void 0===e&&(e={}),C.emit(5,e)},W.isActive=e=>{let t=!1;return S.forEach(n=>{n.isToastActive&&n.isToastActive(e)&&(t=!0);}),t},W.update=function(e,t){void 0===t&&(t={}),setTimeout(()=>{const n=function(e,t){let{containerId:n}=t;const o=S.get(n||F);return o?o.getToast(e):null}(e,t);if(n){const{props:o,content:s}=n,a={...o,...t,toastId:t.toastId||e,updateId:H()};a.toastId!==e&&(a.staleId=e);const r=a.render||s;delete a.render,U(r,a);}},0);},W.done=e=>{W.update(e,{progress:1});},W.onChange=e=>(C.on(4,e),()=>{C.off(4,e);}),W.POSITION=h,W.TYPE=T,C.on(2,e=>{F=e.containerId||e,S.set(F,e),z.forEach(e=>{C.emit(0,e.content,e.options);}),z=[];}).on(3,e=>{S.delete(e.containerId||e),0===S.size&&C.off(0).off(1).off(5);});

class AssertionError extends Error {
}
function assert(condition, msg) {
    if (!condition) {
        throw new AssertionError('Ошибка валидации' + (msg ? `: ${msg}` : ''));
    }
}

const getUrlForUnsavedFile = (file) => {
    const blob = new Blob([file], { type: file.type || 'application/octet-stream' });
    return window.URL.createObjectURL(blob);
};

const triggerUrlDownload = (url, name = 'default') => {
    if (!url)
        return;
    const tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = url;
    tempLink.setAttribute('download', name);
    if (typeof tempLink.download === 'undefined') {
        tempLink.setAttribute('target', '_blank');
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
    setTimeout(() => {
        window.URL.revokeObjectURL(url);
    }, 100);
};

var css_248z$c = ".error-message-module_errorMessage__WQ8AQ p{margin:0}.error-message-module_title__zMLXh{font-weight:700}";
var style = {"errorMessage":"error-message-module_errorMessage__WQ8AQ","title":"error-message-module_title__zMLXh"};
styleInject(css_248z$c);

const ErrorMessage = (props) => {
    const { title, lines } = props;
    return (React.createElement("div", { className: style.errorMessage },
        React.createElement("div", { className: style.title }, title),
        lines.map((line, i) => (React.createElement("p", { key: i }, line)))));
};

const publishNotification = (data) => {
    const errorNotification = {
        type: 'app:notification',
        data,
        category: 'simple',
    };
    distExports.EventBus.getInstance().publish(errorNotification);
};
const publishErrorNotification = (message) => {
    const data = {
        type: 'error',
        message,
        options: { autoClose: false },
    };
    publishNotification(data);
};
const publishWarningNotification = (message) => {
    const payload = {
        type: 'warning',
        message,
        options: { autoClose: false },
    };
    publishNotification(payload);
};

const getIP = async () => {
    var _a;
    const resp = await fetch('https://ip.seeip.org/jsonip?');
    const data = await resp.json();
    const ip = (_a = data === null || data === void 0 ? void 0 : data.ip) === null || _a === void 0 ? void 0 : _a.trim();
    return /[^\d.]/.test(ip) ? 'not defined' : ip;
};
const getGrpcHeaders = (err) => {
    var _a;
    const headers = (_a = err.response) === null || _a === void 0 ? void 0 : _a.headers;
    const grpcStatus = headers && headers['grpc-status'];
    const grpcMessage = headers && headers['grpc-message'];
    return {
        grpcStatus,
        grpcMessage: grpcMessage && decodeURIComponent(grpcMessage),
    };
};
const getApiErrorType = (err) => {
    const { response } = err;
    if (!response) {
        return 'UNCATEGORIZED';
    }
    const { status, headers } = response;
    const { grpcStatus, grpcMessage = '' } = getGrpcHeaders(err);
    switch (true) {
        case status === 401 || status === 403:
            return 'REQUEST_UNAUTHORIZED';
        case status === 500 && !grpcStatus && !grpcMessage:
        case status === 503:
            return 'SERVICE_UNAVAILABLE';
        case (status === 502 || status === 504) && headers['x-variti-ccr'] && !grpcStatus:
            return 'REQUEST_BLOCKED';
        default:
            return 'UNCATEGORIZED';
    }
};
const getSentryPayloadForApiError = async (err, type) => {
    const { response } = err;
    if (!response) {
        return {
            fingerprint: ['API_ERROR', type],
            contexts: {
                'response headers': {},
            },
            extra: {},
        };
    }
    const { headers } = response;
    if (headers['grpc-message']) {
        headers['grpc-message'] = decodeURIComponent(headers['grpc-message']);
    }
    const payload = {
        fingerprint: ['API_ERROR', type],
        contexts: {
            'response headers': headers,
        },
        extra: {
            'http-status': String(response === null || response === void 0 ? void 0 : response.status),
        },
    };
    switch (type) {
        case 'REQUEST_UNAUTHORIZED': {
            return { ...payload, level: 'info' };
        }
        case 'REQUEST_BLOCKED': {
            const ip = await getIP();
            return { ...payload, user: { ip_address: ip }, tags: { antirobot: 'wrong_block' } };
        }
        default:
            return payload;
    }
};
const getDescriptionForApiError = (err, type) => {
    var _a;
    const { grpcMessage } = getGrpcHeaders(err);
    const httpMessage = ((_a = err.response) === null || _a === void 0 ? void 0 : _a.statusText) || '';
    switch (type) {
        case 'SERVICE_UNAVAILABLE': {
            return {
                title: 'Сервис недоступен',
                hint: err.config.method === 'get'
                    ? 'Подождите несколько минут и перезагрузите страницу.'
                    : 'Не обновляйте страницу, чтобы не потерять несохранённые данные. Подождите несколько минут и попробуйте повторить действие снова.',
            };
        }
        case 'REQUEST_BLOCKED':
            return {
                title: 'Произошла ошибка',
                hint: 'Пожалуйста, сделайте скриншот и отправьте его в службу поддержки.',
            };
        default:
            return {
                title: grpcMessage || httpMessage || 'Ошибка',
            };
    }
};
const changeErrorMessageToGrpc = (err) => {
    const { grpcStatus, grpcMessage } = getGrpcHeaders(err);
    if (grpcStatus && grpcMessage) {
        err.message = `[${grpcStatus}] ${grpcMessage}`;
    }
};
const handleApiError = async (err, options = {}) => {
    var _a;
    const { silent = false } = options;
    const { response } = err;
    if (!response) {
        throw err;
    }
    const errorType = getApiErrorType(err);
    const sentryPayload = await getSentryPayloadForApiError(err, errorType);
    const description = getDescriptionForApiError(err, errorType);
    changeErrorMessageToGrpc(err);
    const sentryEventId = captureException(err, sentryPayload);
    const traceId = response.headers['x-trace-id'];
    const varitiCcr = response.headers['x-variti-ccr'];
    if (!silent) {
        publishErrorNotification(React.createElement(ErrorMessage, { title: `${response.status}: ${description.title}`, lines: [
                description.hint,
                format(new Date(), 'dd.MM.yyyy, HH:mm:ss'),
                traceId && `traceId: ${traceId}`,
                varitiCcr && `varitiCcr: ${varitiCcr}`,
                ((_a = sentryPayload.user) === null || _a === void 0 ? void 0 : _a.ip_address) && `ip: ${sentryPayload.user.ip_address}`,
                `sentry: ${sentryEventId}`,
            ].filter(Boolean) }));
    }
};

const formatTelephone = (telephone) => {
    if (telephone.startsWith('7')) {
        const rightFormat = `+${telephone[0]} (${telephone.substring(1, 4)}) ${telephone.substring(4, 7)}-${telephone.substring(7, 9)}-${telephone.substring(9)}`;
        return rightFormat;
    }
    return telephone;
};

var Feature$1;
(function (Feature) {
    Feature["ApproveByBank"] = "contract-kit-approve-by-bank";
    Feature["BirthCertificate"] = "dc-alternative-birth-certificate";
    Feature["LinkedDealsTab"] = "sbr-linked-deals-tab";
    Feature["DealNavigation"] = "dc-deal-navigation";
    Feature["ElectronicMortgage"] = "alternative-electronic-mortgage-available";
    Feature["SuburbanDeals"] = "alternative-suburban-deals";
})(Feature$1 || (Feature$1 = {}));
React.createContext(null);

const getSourceType = (complex) => {
    var _a;
    return ({
        type: ((_a = complex.source) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'cms' ? 'CMS' : 'NEW_BUILDINGS',
    });
};
const extendDevelopersWithComplex = (formData, apartments) => {
    return {
        ...formData,
        developersWithComplex: formData.developersWithComplex
            .map((complexOrComplexId) => {
            const extendData = typeof complexOrComplexId !== 'string'
                ? complexOrComplexId
                : apartments.find((apartment) => apartment.classifiedId === complexOrComplexId || apartment.id === complexOrComplexId);
            return extendData
                ? {
                    developer: { name: extendData.developer, id: String(extendData.developerId) },
                    apartmentComplex: {
                        name: extendData.text,
                        id: extendData.classifiedId || extendData.id,
                        apartmentComplexId: extendData.id,
                    },
                    source: getSourceType(extendData),
                }
                : null;
        })
            .filter(Boolean),
    };
};

function getIsEdited(realtorContacts, formData) {
    const isPhoneEdited = realtorContacts.phone !== formData.realtorContactData.contacts.phone;
    const isEmailEdited = realtorContacts.email !== formData.realtorContactData.contacts.email;
    return isEmailEdited || isPhoneEdited;
}
const orderToDTO = async ({ formData, defaultValues, apartments, }) => {
    const orderRequest = extendDevelopersWithComplex(formData, apartments);
    return {
        ...orderRequest,
        realtorContactData: {
            ...orderRequest.realtorContactData,
            edited: getIsEdited(orderRequest.realtorContactData.contacts, defaultValues),
        },
    };
};
const allowedLabels = ['m2pro', 'added_by_profile'];
function findLatest(arr) {
    let latest = null;
    arr.forEach((i) => {
        if (!allowedLabels.includes(i.label))
            return;
        if (!latest || !latest.updatedAt) {
            latest = i;
            return;
        }
        const isEarlier = isLatest(i.updatedAt, latest.updatedAt);
        if (isEarlier) {
            latest = i;
            return;
        }
    });
    return latest;
}
const isLatest = (dateA, dateB) => {
    if (!isValid(new Date(dateB)))
        return dateA;
    return new Date(dateA).getTime() > new Date(dateB).getTime();
};
const getLatestProfile = (profile) => {
    if (!profile)
        return { phone: '', email: '' };
    const secondaryPhone = findLatest(profile.contacts.secondaryPhones);
    const secondaryEmail = findLatest(profile.contacts.secondaryEmails);
    const { primaryPhone, primaryEmail } = profile.contacts;
    let phone = (primaryPhone === null || primaryPhone === void 0 ? void 0 : primaryPhone.number) || '';
    let email = (primaryEmail === null || primaryEmail === void 0 ? void 0 : primaryEmail.email) || '';
    if (secondaryPhone && isLatest(secondaryPhone === null || secondaryPhone === void 0 ? void 0 : secondaryPhone.updatedAt, primaryPhone === null || primaryPhone === void 0 ? void 0 : primaryPhone.updatedAt)) {
        phone = secondaryPhone.number;
    }
    if (secondaryEmail && isLatest(secondaryEmail === null || secondaryEmail === void 0 ? void 0 : secondaryEmail.updatedAt, primaryEmail === null || primaryEmail === void 0 ? void 0 : primaryEmail.updatedAt)) {
        email = secondaryEmail.email;
    }
    return {
        phone: phone,
        email: email,
    };
};

const GQ_ENDPOINT = '/search/nb/graphql';
const PROFILE_QUERY = 'profile';
const CLIENTS_WITH_ORDERS_ORDERS_QUERY = 'clients with orders';
const CLIENTS_QUERY = 'clients';
const JSON_FOREIGN_BUILDINGS_URL = `https://cdn.m2.ru/assets/cms-data/json/json-resources/m2pro-novostroyki-foreign.json`;

const URL_PROFILE = '/api/profile/v2/profile';
const loadProfile = (profileId) => () => axios.get(`${URL_PROFILE}/${profileId}`).then((resp) => resp.data);
const useProfile = (profileId) => {
    const { data, isLoading } = reactQuery.useQuery([PROFILE_QUERY], loadProfile(profileId), {
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnMount: 'always',
    });
    return { profile: data === null || data === void 0 ? void 0 : data.profile, isLoading: isLoading };
};

/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */

function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function () {
  this._size = 0;
  this._values = Object.create(null);
};
Cache.prototype.get = function (key) {
  return this._values[key]
};
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values)) this._size++;

  return (this._values[key] = value)
};

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512;

var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE);

var propertyExpr = {
  Cache: Cache,

  split: split,

  normalizePath: normalizePath,

  setter: function (path) {
    var parts = normalizePath(path);

    return (
      setCache.get(path) ||
      setCache.set(path, function setter(obj, value) {
        var index = 0;
        var len = parts.length;
        var data = obj;

        while (index < len - 1) {
          var part = parts[index];
          if (
            part === '__proto__' ||
            part === 'constructor' ||
            part === 'prototype'
          ) {
            return obj
          }

          data = data[parts[index++]];
        }
        data[parts[index]] = value;
      })
    )
  },

  getter: function (path, safe) {
    var parts = normalizePath(path);
    return (
      getCache.get(path) ||
      getCache.set(path, function getter(data) {
        var index = 0,
          len = parts.length;
        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]];
          else return
        }
        return data
      })
    )
  },

  join: function (segments) {
    return segments.reduce(function (path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
  },
};

function normalizePath(path) {
  return (
    pathCache.get(path) ||
    pathCache.set(
      path,
      split(path).map(function (part) {
        return part.replace(CLEAN_QUOTES_REGEX, '$2')
      })
    )
  )
}

function split(path) {
  return path.match(SPLIT_REGEX) || ['']
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket;

  for (idx = 0; idx < len; idx++) {
    part = parts[idx];

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }

      isBracket = isQuoted(part);
      isArray = !isBracket && /^\d+$/.test(part);

      iter.call(thisArg, part, isBracket, isArray, idx, parts);
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}

const reWords = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;

const words = (str) => str.match(reWords) || [];

const upperFirst = (str) => str[0].toUpperCase() + str.slice(1);

const join = (str, d) => words(str).join(d).toLowerCase();

const camelCase = (str) =>
  words(str).reduce(
    (acc, next) =>
      `${acc}${
        !acc
          ? next.toLowerCase()
          : next[0].toUpperCase() + next.slice(1).toLowerCase()
      }`,
    '',
  );

const pascalCase = (str) => upperFirst(camelCase(str));

const snakeCase = (str) => join(str, '_');

const kebabCase = (str) => join(str, '-');

const sentenceCase = (str) => upperFirst(join(str, ' '));

const titleCase = (str) => words(str).map(upperFirst).join(' ');

var tinyCase = {
  words,
  upperFirst,
  camelCase,
  pascalCase,
  snakeCase,
  kebabCase,
  sentenceCase,
  titleCase,
};

var toposortExports = {};
var toposort$1 = {
  get exports(){ return toposortExports; },
  set exports(v){ toposortExports = v; },
};

/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

toposort$1.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
};

toposortExports.array = toposort;

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes);

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  });

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set());
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch(e) {
        nodeRep = "";
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true;

    var outgoing = outgoingEdges.get(node) || new Set();
    outgoing = Array.from(outgoing);

    if (i = outgoing.length) {
      predecessors.add(node);
      do {
        var child = outgoing[--i];
        visit(child, nodesHash.get(child), predecessors);
      } while (i)
      predecessors.delete(node);
    }

    sorted[--cursor] = node;
  }
}

function uniqueNodes(arr){
  var res = new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res
}

const toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}
function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}
function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

function toArray(value) {
  return value == null ? [] : [].concat(value);
}

let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || 'this';
    if (path !== params.path) params = Object.assign({}, params, {
      path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }
  static isError(err) {
    return err && err.name === 'ValidationError';
  }
  constructor(errorOrErrors, value, field, type) {
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.errors = void 0;
    this.params = void 0;
    this.inner = void 0;
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }
}

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  defined: '${path} must be defined',
  notNull: '${path} cannot be null',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    const castMsg = originalValue != null && originalValue !== value ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.';
    return type !== 'mixed' ? `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + castMsg : `${path} must match the configured type. ` + `The validated value was: \`${printValue(value, true)}\`` + castMsg;
  }
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean
});

const isSchema = obj => obj && obj.__isYupSchema__;

class Condition {
  static fromOptions(refs, config) {
    if (!config.then && !config.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = config;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);
    return new Condition(refs, (values, schema) => {
      var _branch;
      let branch = check(...values) ? then : otherwise;
      return (_branch = branch == null ? void 0 : branch(schema)) != null ? _branch : schema;
    });
  }
  constructor(refs, builder) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;
    this.fn = builder;
  }
  resolve(base, options) {
    let values = this.refs.map(ref =>
    // TODO: ? operator here?
    ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn(values, base, options);
    if (schema === undefined ||
    // @ts-ignore this can be base
    schema === base) {
      return base;
    }
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }
}

const prefixes = {
  context: '$',
  value: '.'
};
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options.map;
  }
  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }

  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(value) {
    return value && value.__isYupRef;
  }
}

// @ts-ignore
Reference.prototype.__isYupRef = true;

const isAbsent = value => value == null;

function createValidation(config) {
  function validate({
    value,
    path = '',
    options,
    originalValue,
    schema
  }, panic, next) {
    const {
      name,
      test,
      params,
      message,
      skipAbsent
    } = config;
    let {
      parent,
      context,
      abortEarly = schema.spec.abortEarly
    } = options;
    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }
    function createError(overrides = {}) {
      const nextParams = Object.assign({
        value,
        originalValue,
        label: schema.spec.label,
        path: overrides.path || path,
        spec: schema.spec
      }, params, overrides.params);
      for (const key of Object.keys(nextParams)) nextParams[key] = resolve(nextParams[key]);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }
    const invalid = abortEarly ? panic : next;
    let ctx = {
      path,
      parent,
      type: name,
      from: options.from,
      createError,
      resolve,
      options,
      originalValue,
      schema
    };
    const handleResult = validOrError => {
      if (ValidationError.isError(validOrError)) invalid(validOrError);else if (!validOrError) invalid(createError());else next(null);
    };
    const handleError = err => {
      if (ValidationError.isError(err)) invalid(err);else panic(err);
    };
    const shouldSkip = skipAbsent && isAbsent(value);
    if (!options.sync) {
      try {
        Promise.resolve(!shouldSkip ? test.call(ctx, value, ctx) : true).then(handleResult, handleError);
      } catch (err) {
        handleError(err);
      }
      return;
    }
    let result;
    try {
      var _result;
      result = !shouldSkip ? test.call(ctx, value, ctx) : true;
      if (typeof ((_result = result) == null ? void 0 : _result.then) === 'function') {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
      }
    } catch (err) {
      handleError(err);
      return;
    }
    handleResult(result);
  }
  validate.OPTIONS = config;
  return validate;
}

function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug;

  // root path: ''
  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  propertyExpr.forEach(path, (_part, isBracket, isArray) => {
    let part = isBracket ? _part.slice(1, _part.length - 1) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });
    let isTuple = schema.type === 'tuple';
    let idx = isArray ? parseInt(part, 10) : 0;
    if (schema.innerType || isTuple) {
      if (isTuple && !isArray) throw new Error(`Yup.reach cannot implicitly index into a tuple type. the path part "${lastPartDebug}" must contain an index to the tuple element, e.g. "${lastPartDebug}[0]"`);
      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }
      parent = value;
      value = value && value[idx];
      schema = isTuple ? schema.spec.types[idx] : schema.innerType;
    }

    // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal
    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema.type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }
    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

class ReferenceSet extends Set {
  describe() {
    const description = [];
    for (const item of this.values()) {
      description.push(Reference.isRef(item) ? item.describe() : item);
    }
    return description;
  }
  resolveAll(resolve) {
    let result = [];
    for (const item of this.values()) {
      result.push(resolve(item));
    }
    return result;
  }
  clone() {
    return new ReferenceSet(this.values());
  }
  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.forEach(value => next.add(value));
    removeItems.forEach(value => next.delete(value));
    return next;
  }
}

// tweaked from https://github.com/Kelin2025/nanoclone/blob/0abeb7635bda9b68ef2277093f76dbe3bf3948e1/src/index.js
function clone(src, seen = new Map()) {
  if (isSchema(src) || !src || typeof src !== 'object') return src;
  if (seen.has(src)) return seen.get(src);
  let copy;
  if (src instanceof Date) {
    // Date
    copy = new Date(src.getTime());
    seen.set(src, copy);
  } else if (src instanceof RegExp) {
    // RegExp
    copy = new RegExp(src);
    seen.set(src, copy);
  } else if (Array.isArray(src)) {
    // Array
    copy = new Array(src.length);
    seen.set(src, copy);
    for (let i = 0; i < src.length; i++) copy[i] = clone(src[i], seen);
  } else if (src instanceof Map) {
    // Map
    copy = new Map();
    seen.set(src, copy);
    for (const [k, v] of src.entries()) copy.set(k, clone(v, seen));
  } else if (src instanceof Set) {
    // Set
    copy = new Set();
    seen.set(src, copy);
    for (const v of src) copy.add(clone(v, seen));
  } else if (src instanceof Object) {
    // Object
    copy = {};
    seen.set(src, copy);
    for (const [k, v] of Object.entries(src)) copy[k] = clone(v, seen);
  } else {
    throw Error(`Unable to clone ${src}`);
  }
  return copy;
}

class Schema {
  constructor(options) {
    this.type = void 0;
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this.internalTests = {};
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this._typeCheck = void 0;
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = options.type;
    this._typeCheck = options.check;
    this.spec = Object.assign({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      optional: true,
      coerce: true
    }, options == null ? void 0 : options.spec);
    this.withMutation(s => {
      s.nonNullable();
    });
  }

  // TODO: remove
  get _type() {
    return this.type;
  }
  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    }

    // if the nested value is a schema we can skip cloning, since
    // they are already immutable
    const next = Object.create(Object.getPrototypeOf(this));

    // @ts-expect-error this is readonly
    next.type = this.type;
    next._typeCheck = this._typeCheck;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.internalTests = Object.assign({}, this.internalTests);
    next.exclusiveTests = Object.assign({}, this.exclusiveTests);

    // @ts-expect-error this is readonly
    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(Object.assign({}, this.spec, spec));
    return next;
  }
  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }
  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  }
  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }
  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();
    const mergedSpec = Object.assign({}, base.spec, combined.spec);
    combined.spec = mergedSpec;
    combined.internalTests = Object.assign({}, base.internalTests, combined.internalTests);

    // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)
    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist);

    // start with the current tests
    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests;

    // manually add the new tests to ensure
    // the deduping logic is consistent
    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }
  isType(v) {
    if (v == null) {
      if (this.spec.nullable && v === null) return true;
      if (this.spec.optional && v === undefined) return true;
      return false;
    }
    return this._typeCheck(v);
  }
  resolve(options) {
    let schema = this;
    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((prevSchema, condition) => condition.resolve(prevSchema, options), schema);
      schema = schema.resolve(options);
    }
    return schema;
  }
  resolveOptions(options) {
    var _options$strict, _options$abortEarly, _options$recursive;
    return Object.assign({}, options, {
      from: options.from || [],
      strict: (_options$strict = options.strict) != null ? _options$strict : this.spec.strict,
      abortEarly: (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly,
      recursive: (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive
    });
  }

  /**
   * Run the configured transform pipeline over an input value.
   */

  cast(value, options = {}) {
    let resolvedSchema = this.resolve(Object.assign({
      value
    }, options));
    let allowOptionality = options.assert === 'ignore-optionality';
    let result = resolvedSchema._cast(value, options);
    if (options.assert !== false && !resolvedSchema.isType(result)) {
      if (allowOptionality && isAbsent(result)) {
        return result;
      }
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema.type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }
    return result;
  }
  _cast(rawValue, _options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((prevValue, fn) => fn.call(this, prevValue, rawValue, this), rawValue);
    if (value === undefined) {
      value = this.getDefault();
    }
    return value;
  }
  _validate(_value, options = {}, panic, next) {
    let {
      path,
      originalValue = _value,
      strict = this.spec.strict
    } = options;
    let value = _value;
    if (!strict) {
      value = this._cast(value, Object.assign({
        assert: false
      }, options));
    }
    let initialTests = [];
    for (let test of Object.values(this.internalTests)) {
      if (test) initialTests.push(test);
    }
    this.runTests({
      path,
      value,
      originalValue,
      options,
      tests: initialTests
    }, panic, initialErrors => {
      // even if we aren't ending early we can't proceed further if the types aren't correct
      if (initialErrors.length) {
        return next(initialErrors, value);
      }
      this.runTests({
        path,
        value,
        originalValue,
        options,
        tests: this.tests
      }, panic, next);
    });
  }

  /**
   * Executes a set of validations, either schema, produced Tests or a nested
   * schema validate result.
   */
  runTests(runOptions, panic, next) {
    let fired = false;
    let {
      tests,
      value,
      originalValue,
      path,
      options
    } = runOptions;
    let panicOnce = arg => {
      if (fired) return;
      fired = true;
      panic(arg, value);
    };
    let nextOnce = arg => {
      if (fired) return;
      fired = true;
      next(arg, value);
    };
    let count = tests.length;
    let nestedErrors = [];
    if (!count) return nextOnce([]);
    let args = {
      value,
      originalValue,
      path,
      options,
      schema: this
    };
    for (let i = 0; i < tests.length; i++) {
      const test = tests[i];
      test(args, panicOnce, function finishTestRun(err) {
        if (err) {
          nestedErrors = nestedErrors.concat(err);
        }
        if (--count <= 0) {
          nextOnce(nestedErrors);
        }
      });
    }
  }
  asNestedTest({
    key,
    index,
    parent,
    parentPath,
    originalParent,
    options
  }) {
    const k = key != null ? key : index;
    if (k == null) {
      throw TypeError('Must include `key` or `index` for nested validations');
    }
    const isIndex = typeof k === 'number';
    let value = parent[k];
    const testOptions = Object.assign({}, options, {
      // Nested validations fields are always strict:
      //    1. parent isn't strict so the casting will also have cast inner values
      //    2. parent is strict in which case the nested values weren't cast either
      strict: true,
      parent,
      value,
      originalValue: originalParent[k],
      // FIXME: tests depend on `index` being passed around deeply,
      //   we should not let the options.key/index bleed through
      key: undefined,
      // index: undefined,
      [isIndex ? 'index' : 'key']: k,
      path: isIndex || k.includes('.') ? `${parentPath || ''}[${value ? k : `"${k}"`}]` : (parentPath ? `${parentPath}.` : '') + key
    });
    return (_, panic, next) => this.resolve(testOptions)._validate(value, testOptions, panic, next);
  }
  validate(value, options) {
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    return new Promise((resolve, reject) => schema._validate(value, options, (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      reject(error);
    }, (errors, validated) => {
      if (errors.length) reject(new ValidationError(errors, validated));else resolve(validated);
    }));
  }
  validateSync(value, options) {
    let schema = this.resolve(Object.assign({}, options, {
      value
    }));
    let result;
    schema._validate(value, Object.assign({}, options, {
      sync: true
    }), (error, parsed) => {
      if (ValidationError.isError(error)) error.value = parsed;
      throw error;
    }, (errors, validated) => {
      if (errors.length) throw new ValidationError(errors, value);
      result = validated;
    });
    return result;
  }
  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }
  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }
  _getDefault() {
    let defaultValue = this.spec.default;
    if (defaultValue == null) {
      return defaultValue;
    }
    return typeof defaultValue === 'function' ? defaultValue.call(this) : clone(defaultValue);
  }
  getDefault(options
  // If schema is defaulted we know it's at least not undefined
  ) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }
  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }
    let next = this.clone({
      default: def
    });
    return next;
  }
  strict(isStrict = true) {
    return this.clone({
      strict: isStrict
    });
  }
  nullability(nullable, message) {
    const next = this.clone({
      nullable
    });
    next.internalTests.nullable = createValidation({
      message,
      name: 'nullable',
      test(value) {
        return value === null ? this.schema.spec.nullable : true;
      }
    });
    return next;
  }
  optionality(optional, message) {
    const next = this.clone({
      optional
    });
    next.internalTests.optionality = createValidation({
      message,
      name: 'optionality',
      test(value) {
        return value === undefined ? this.schema.spec.optional : true;
      }
    });
    return next;
  }
  optional() {
    return this.optionality(true);
  }
  defined(message = mixed.defined) {
    return this.optionality(false, message);
  }
  nullable() {
    return this.nullability(true);
  }
  nonNullable(message = mixed.notNull) {
    return this.nullability(false, message);
  }
  required(message = mixed.required) {
    return this.clone().withMutation(next => next.nonNullable(message).defined(message));
  }
  notRequired() {
    return this.clone().withMutation(next => next.nullable().optional());
  }
  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }

  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */

  test(...args) {
    let opts;
    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }
    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;
    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }
    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }
      return true;
    });
    next.tests.push(validate);
    return next;
  }
  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }
    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore readonly array
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(typeof options === 'function' ? new Condition(deps, options) : Condition.fromOptions(deps, options));
    return next;
  }
  typeError(message) {
    let next = this.clone();
    next.internalTests.typeError = createValidation({
      message,
      name: 'typeError',
      test(value) {
        if (!isAbsent(value) && !this.schema._typeCheck(value)) return this.createError({
          params: {
            type: this.schema.type
          }
        });
        return true;
      }
    });
    return next;
  }
  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);
      next._blacklist.delete(val);
    });
    next.internalTests.whiteList = createValidation({
      message,
      name: 'oneOf',
      skipAbsent: true,
      test(value) {
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: Array.from(valids).join(', '),
            resolved
          }
        });
      }
    });
    return next;
  }
  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);
      next._whitelist.delete(val);
    });
    next.internalTests.blacklist = createValidation({
      message,
      name: 'notOneOf',
      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: Array.from(invalids).join(', '),
            resolved
          }
        });
        return true;
      }
    });
    return next;
  }
  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  /**
   * Return a serialized description of the schema including validations, flags, types etc.
   *
   * @param options Provide any needed context for resolving runtime schema alterations (lazy, when conditions, etc).
   */
  describe(options) {
    const next = (options ? this.resolve(options) : this).clone();
    const {
      label,
      meta,
      optional,
      nullable
    } = next.spec;
    const description = {
      meta,
      label,
      optional,
      nullable,
      default: next.getDefault(options),
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }
}
// @ts-expect-error
Schema.prototype.__isYupSchema__ = true;
for (const method of ['validate', 'validateSync']) Schema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], Object.assign({}, options, {
    parent,
    path
  }));
};
for (const alias of ['equals', 'is']) Schema.prototype[alias] = Schema.prototype.oneOf;
for (const alias of ['not', 'nope']) Schema.prototype[alias] = Schema.prototype.notOneOf;

const returnsTrue = () => true;
function create$8(spec) {
  return new MixedSchema(spec);
}
class MixedSchema extends Schema {
  constructor(spec) {
    super(typeof spec === 'function' ? {
      type: 'mixed',
      check: spec
    } : Object.assign({
      type: 'mixed',
      check: returnsTrue
    }, spec));
  }
}
create$8.prototype = MixedSchema.prototype;

function create$7() {
  return new BooleanSchema();
}
class BooleanSchema extends Schema {
  constructor() {
    super({
      type: 'boolean',
      check(v) {
        if (v instanceof Boolean) v = v.valueOf();
        return typeof v === 'boolean';
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (ctx.spec.coerce && !ctx.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }
        return value;
      });
    });
  }
  isTrue(message = boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'true'
      },
      test(value) {
        return isAbsent(value) || value === true;
      }
    });
  }
  isFalse(message = boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'false'
      },
      test(value) {
        return isAbsent(value) || value === false;
      }
    });
  }
  default(def) {
    return super.default(def);
  }
  defined(msg) {
    return super.defined(msg);
  }
  optional() {
    return super.optional();
  }
  required(msg) {
    return super.required(msg);
  }
  notRequired() {
    return super.notRequired();
  }
  nullable() {
    return super.nullable();
  }
  nonNullable(msg) {
    return super.nonNullable(msg);
  }
  strip(v) {
    return super.strip(v);
  }
}
create$7.prototype = BooleanSchema.prototype;

// Taken from HTML spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
let rEmail =
// eslint-disable-next-line
/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
let rUrl =
// eslint-disable-next-line
/^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;

// eslint-disable-next-line
let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
let isTrimmed = value => isAbsent(value) || value === value.trim();
let objStringTag = {}.toString();
function create$6() {
  return new StringSchema();
}
class StringSchema extends Schema {
  constructor() {
    super({
      type: 'string',
      check(value) {
        if (value instanceof String) value = value.valueOf();
        return typeof value === 'string';
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (!ctx.spec.coerce || ctx.isType(value)) return value;

        // don't ever convert arrays
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;

        // no one wants plain objects converted to [Object object]
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }
  required(message) {
    return super.required(message).withMutation(schema => schema.test({
      message: message || mixed.required,
      name: 'required',
      skipAbsent: true,
      test: value => !!value.length
    }));
  }
  notRequired() {
    return super.notRequired().withMutation(schema => {
      schema.tests = schema.tests.filter(t => t.OPTIONS.name !== 'required');
      return schema;
    });
  }
  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },
      skipAbsent: true,
      test(value) {
        return value.length === this.resolve(length);
      }
    });
  }
  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value.length >= this.resolve(min);
      }
    });
  }
  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value.length <= this.resolve(max);
      }
    });
  }
  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;
    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }
    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      skipAbsent: true,
      test: value => value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }
  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }
  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }
  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  }

  //-- transforms --
  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }
  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }
  lowercase(message = string.lowercase) {
    return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      skipAbsent: true,
      test: value => isAbsent(value) || value === value.toLowerCase()
    });
  }
  uppercase(message = string.uppercase) {
    return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      skipAbsent: true,
      test: value => isAbsent(value) || value === value.toUpperCase()
    });
  }
}
create$6.prototype = StringSchema.prototype;

//
// String Interfaces
//

let isNaN$1 = value => value != +value;
function create$5() {
  return new NumberSchema();
}
class NumberSchema extends Schema {
  constructor() {
    super({
      type: 'number',
      check(value) {
        if (value instanceof Number) value = value.valueOf();
        return typeof value === 'number' && !isNaN$1(value);
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (!ctx.spec.coerce) return value;
        let parsed = value;
        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN;
          // don't use parseFloat to avoid positives on alpha-numeric strings
          parsed = +parsed;
        }
        if (ctx.isType(parsed)) return parsed;
        return parseFloat(parsed);
      });
    });
  }
  min(min, message = number.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(min);
      }
    });
  }
  max(max, message = number.max) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(max);
      }
    });
  }
  lessThan(less, message = number.lessThan) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        less
      },
      skipAbsent: true,
      test(value) {
        return value < this.resolve(less);
      }
    });
  }
  moreThan(more, message = number.moreThan) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        more
      },
      skipAbsent: true,
      test(value) {
        return value > this.resolve(more);
      }
    });
  }
  positive(msg = number.positive) {
    return this.moreThan(0, msg);
  }
  negative(msg = number.negative) {
    return this.lessThan(0, msg);
  }
  integer(message = number.integer) {
    return this.test({
      name: 'integer',
      message,
      skipAbsent: true,
      test: val => Number.isInteger(val)
    });
  }
  truncate() {
    return this.transform(value => !isAbsent(value) ? value | 0 : value);
  }
  round(method) {
    var _method;
    let avail = ['ceil', 'floor', 'round', 'trunc'];
    method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round';

    // this exists for symemtry with the new Math.trunc
    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(value => !isAbsent(value) ? Math[method](value) : value);
  }
}
create$5.prototype = NumberSchema.prototype;

//
// Number Interfaces
//

/* eslint-disable */
/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */

//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
    minutesOffset = 0,
    timestamp,
    struct;
  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) struct[k] = +struct[k] || 0;

    // allow undefined days and months
    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1;

    // allow arbitrary sub-second precision beyond milliseconds
    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0;

    // timestamps without timezone identifiers should be considered local time
    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }
      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;
  return timestamp;
}

// @ts-ignore
let invalidDate = new Date('');
let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';
function create$4() {
  return new DateSchema();
}
class DateSchema extends Schema {
  constructor() {
    super({
      type: 'date',
      check(v) {
        return isDate(v) && !isNaN(v.getTime());
      }
    });
    this.withMutation(() => {
      this.transform((value, _raw, ctx) => {
        if (!ctx.spec.coerce || ctx.isType(value)) return value;
        value = parseIsoDate(value);

        // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.
        return !isNaN(value) ? new Date(value) : DateSchema.INVALID_DATE;
      });
    });
  }
  prepareParam(ref, name) {
    let param;
    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }
    return param;
  }
  min(min, message = date.min) {
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      test(value) {
        return value >= this.resolve(limit);
      }
    });
  }
  max(max, message = date.max) {
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value <= this.resolve(limit);
      }
    });
  }
}
DateSchema.INVALID_DATE = invalidDate;
create$4.prototype = DateSchema.prototype;
create$4.INVALID_DATE = invalidDate;

// @ts-expect-error
function sortFields(fields, excludedEdges = []) {
  let edges = [];
  let nodes = new Set();
  let excludes = new Set(excludedEdges.map(([a, b]) => `${a}-${b}`));
  function addNode(depPath, key) {
    let node = propertyExpr.split(depPath)[0];
    nodes.add(node);
    if (!excludes.has(`${key}-${node}`)) edges.push([key, node]);
  }
  for (const key of Object.keys(fields)) {
    let value = fields[key];
    nodes.add(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }
  return toposortExports.array(Array.from(nodes), edges).reverse();
}

function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;
    if ((_err$path = err.path) != null && _err$path.includes(key)) {
      idx = ii;
      return true;
    }
  });
  return idx;
}
function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

const parseJson = (value, _, ctx) => {
  if (typeof value !== 'string') {
    return value;
  }
  let parsed = value;
  try {
    parsed = JSON.parse(value);
  } catch (err) {
    /* */
  }
  return ctx.isType(parsed) ? parsed : value;
};

// @ts-ignore
function deepPartial(schema) {
  if ('fields' in schema) {
    const partial = {};
    for (const [key, fieldSchema] of Object.entries(schema.fields)) {
      partial[key] = deepPartial(fieldSchema);
    }
    return schema.setFields(partial);
  }
  if (schema.type === 'array') {
    const nextArray = schema.optional();
    if (nextArray.innerType) nextArray.innerType = deepPartial(nextArray.innerType);
    return nextArray;
  }
  if (schema.type === 'tuple') {
    return schema.optional().clone({
      types: schema.spec.types.map(deepPartial)
    });
  }
  if ('optional' in schema) {
    return schema.optional();
  }
  return schema;
}
const deepHas = (obj, p) => {
  const path = [...propertyExpr.normalizePath(p)];
  if (path.length === 1) return path[0] in obj;
  let last = path.pop();
  let parent = propertyExpr.getter(propertyExpr.join(path), true)(obj);
  return !!(parent && last in parent);
};
let isObject$3 = obj => Object.prototype.toString.call(obj) === '[object Object]';
function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}
const defaultSort = sortByKeyOrder([]);
function create$3(spec) {
  return new ObjectSchema(spec);
}
class ObjectSchema extends Schema {
  constructor(spec) {
    super({
      type: 'object',
      check(value) {
        return isObject$3(value) || typeof value === 'function';
      }
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      if (spec) {
        this.shape(spec);
      }
    });
  }
  _cast(_value, options = {}) {
    var _options$stripUnknown;
    let value = super._cast(_value, options);

    //should ignore nulls here
    if (value === undefined) return this.getDefault();
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;
    let props = [].concat(this._nodes, Object.keys(value).filter(v => !this._nodes.includes(v)));
    let intermediateValue = {}; // is filled during the transform below
    let innerOptions = Object.assign({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });
    let isChanged = false;
    for (const prop of props) {
      let field = fields[prop];
      let exists = (prop in value);
      if (field) {
        let fieldValue;
        let inputValue = value[prop];

        // safe to mutate since this is fired in sequence
        innerOptions.path = (options.path ? `${options.path}.` : '') + prop;
        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = field instanceof Schema ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;
        if (fieldSpec != null && fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }
        fieldValue = !options.__validating || !strict ?
        // TODO: use _cast, this is double resolving
        field.cast(value[prop], innerOptions) : value[prop];
        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }
      if (exists !== prop in intermediateValue || intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }
    return isChanged ? intermediateValue : value;
  }
  _validate(_value, options = {}, panic, next) {
    let {
      from = [],
      originalValue = _value,
      recursive = this.spec.recursive
    } = options;
    options.from = [{
      schema: this,
      value: originalValue
    }, ...from];
    // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating
    options.__validating = true;
    options.originalValue = originalValue;
    super._validate(_value, options, panic, (objectErrors, value) => {
      if (!recursive || !isObject$3(value)) {
        next(objectErrors, value);
        return;
      }
      originalValue = originalValue || value;
      let tests = [];
      for (let key of this._nodes) {
        let field = this.fields[key];
        if (!field || Reference.isRef(field)) {
          continue;
        }
        tests.push(field.asNestedTest({
          options,
          key,
          parent: value,
          parentPath: options.path,
          originalParent: originalValue
        }));
      }
      this.runTests({
        tests,
        value,
        originalValue,
        options
      }, panic, fieldErrors => {
        next(fieldErrors.sort(this._sortErrors).concat(objectErrors), value);
      });
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    next.fields = Object.assign({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }
  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;
    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];
      nextFields[field] = target === undefined ? schemaOrRef : target;
    }
    return next.withMutation(s => s.setFields(nextFields, this._excludedEdges));
  }
  _getDefault() {
    if ('default' in this.spec) {
      return super._getDefault();
    }

    // if there is no default set invent one
    if (!this._nodes.length) {
      return undefined;
    }
    let dft = {};
    this._nodes.forEach(key => {
      const field = this.fields[key];
      dft[key] = field && 'getDefault' in field ? field.getDefault() : undefined;
    });
    return dft;
  }
  setFields(shape, excludedEdges) {
    let next = this.clone();
    next.fields = shape;
    next._nodes = sortFields(shape, excludedEdges);
    next._sortErrors = sortByKeyOrder(Object.keys(shape));
    // XXX: this carries over edges which may not be what you want
    if (excludedEdges) next._excludedEdges = excludedEdges;
    return next;
  }
  shape(additions, excludes = []) {
    return this.clone().withMutation(next => {
      let edges = next._excludedEdges;
      if (excludes.length) {
        if (!Array.isArray(excludes[0])) excludes = [excludes];
        edges = [...next._excludedEdges, ...excludes];
      }

      // XXX: excludes here is wrong
      return next.setFields(Object.assign(next.fields, additions), edges);
    });
  }
  partial() {
    const partial = {};
    for (const [key, schema] of Object.entries(this.fields)) {
      partial[key] = 'optional' in schema && schema.optional instanceof Function ? schema.optional() : schema;
    }
    return this.setFields(partial);
  }
  deepPartial() {
    const next = deepPartial(this);
    return next;
  }
  pick(keys) {
    const picked = {};
    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }
    return this.setFields(picked);
  }
  omit(keys) {
    const fields = Object.assign({}, this.fields);
    for (const key of keys) {
      delete fields[key];
    }
    return this.setFields(fields);
  }
  from(from, to, alias) {
    let fromGetter = propertyExpr.getter(from, true);
    return this.transform(obj => {
      if (!obj) return obj;
      let newObj = obj;
      if (deepHas(obj, from)) {
        newObj = Object.assign({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }
      return newObj;
    });
  }

  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }
  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow !== 'boolean') {
      message = noAllow;
      noAllow = true;
    }
    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,
      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }
    });
    next.spec.noUnknown = noAllow;
    return next;
  }
  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }
  transformKeys(fn) {
    return this.transform(obj => {
      if (!obj) return obj;
      const result = {};
      for (const key of Object.keys(obj)) result[fn(key)] = obj[key];
      return result;
    });
  }
  camelCase() {
    return this.transformKeys(tinyCase.camelCase);
  }
  snakeCase() {
    return this.transformKeys(tinyCase.snakeCase);
  }
  constantCase() {
    return this.transformKeys(key => tinyCase.snakeCase(key).toUpperCase());
  }
  describe(options) {
    let base = super.describe(options);
    base.fields = {};
    for (const [key, value] of Object.entries(this.fields)) {
      var _innerOptions;
      let innerOptions = options;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[key]
        });
      }
      base.fields[key] = value.describe(innerOptions);
    }
    return base;
  }
}
create$3.prototype = ObjectSchema.prototype;

function create$2(type) {
  return new ArraySchema(type);
}
class ArraySchema extends Schema {
  constructor(type) {
    super({
      type: 'array',
      check(v) {
        return Array.isArray(v);
      }
    });

    // `undefined` specifically means uninitialized, as opposed to "no subtype"
    this.innerType = void 0;
    this.innerType = type;
  }
  _cast(_value, _opts) {
    const value = super._cast(_value, _opts);

    // should ignore nulls here
    if (!this._typeCheck(value) || !this.innerType) {
      return value;
    }
    let isChanged = false;
    const castArray = value.map((v, idx) => {
      const castElement = this.innerType.cast(v, Object.assign({}, _opts, {
        path: `${_opts.path || ''}[${idx}]`
      }));
      if (castElement !== v) {
        isChanged = true;
      }
      return castElement;
    });
    return isChanged ? castArray : value;
  }
  _validate(_value, options = {}, panic, next) {
    var _options$recursive;
    // let sync = options.sync;
    // let path = options.path;
    let innerType = this.innerType;
    // let endEarly = options.abortEarly ?? this.spec.abortEarly;
    let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
    options.originalValue != null ? options.originalValue : _value;
    super._validate(_value, options, panic, (arrayErrors, value) => {
      var _options$originalValu2;
      if (!recursive || !innerType || !this._typeCheck(value)) {
        next(arrayErrors, value);
        return;
      }

      // #950 Ensure that sparse array empty slots are validated
      let tests = new Array(value.length);
      for (let index = 0; index < value.length; index++) {
        var _options$originalValu;
        tests[index] = innerType.asNestedTest({
          options,
          index,
          parent: value,
          parentPath: options.path,
          originalParent: (_options$originalValu = options.originalValue) != null ? _options$originalValu : _value
        });
      }
      this.runTests({
        value,
        tests,
        originalValue: (_options$originalValu2 = options.originalValue) != null ? _options$originalValu2 : _value,
        options
      }, panic, innerTypeErrors => next(innerTypeErrors.concat(arrayErrors), value));
    });
  }
  clone(spec) {
    const next = super.clone(spec);
    // @ts-expect-error readonly
    next.innerType = this.innerType;
    return next;
  }

  /** Parse an input JSON string to an object */
  json() {
    return this.transform(parseJson);
  }
  concat(schema) {
    let next = super.concat(schema);

    // @ts-expect-error readonly
    next.innerType = this.innerType;
    if (schema.innerType)
      // @ts-expect-error readonly
      next.innerType = next.innerType ?
      // @ts-expect-error Lazy doesn't have concat and will break
      next.innerType.concat(schema.innerType) : schema.innerType;
    return next;
  }
  of(schema) {
    // FIXME: this should return a new instance of array without the default to be
    let next = this.clone();
    if (!isSchema(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + printValue(schema));

    // @ts-expect-error readonly
    next.innerType = schema;
    return next;
  }
  length(length, message = array.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },
      skipAbsent: true,
      test(value) {
        return value.length === this.resolve(length);
      }
    });
  }
  min(min, message) {
    message = message || array.min;
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },
      skipAbsent: true,
      // FIXME(ts): Array<typeof T>
      test(value) {
        return value.length >= this.resolve(min);
      }
    });
  }
  max(max, message) {
    message = message || array.max;
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },
      skipAbsent: true,
      test(value) {
        return value.length <= this.resolve(max);
      }
    });
  }
  ensure() {
    return this.default(() => []).transform((val, original) => {
      // We don't want to return `null` for nullable schema
      if (this._typeCheck(val)) return val;
      return original == null ? [] : [].concat(original);
    });
  }
  compact(rejector) {
    let reject = !rejector ? v => !!v : (v, i, a) => !rejector(v, i, a);
    return this.transform(values => values != null ? values.filter(reject) : values);
  }
  describe(options) {
    let base = super.describe(options);
    if (this.innerType) {
      var _innerOptions;
      let innerOptions = options;
      if ((_innerOptions = innerOptions) != null && _innerOptions.value) {
        innerOptions = Object.assign({}, innerOptions, {
          parent: innerOptions.value,
          value: innerOptions.value[0]
        });
      }
      base.innerType = this.innerType.describe(options);
    }
    return base;
  }
}
create$2.prototype = ArraySchema.prototype;

const clientSchema = create$3({
    id: create$6(),
    name: create$3({
        surname: create$6()
            .trim()
            .min(2, 'Не менее 2 символов')
            .max(300, 'Количество символов в поле не может превышать 300')
            .required('Обязательное поле'),
        name: create$6()
            .trim()
            .min(2, 'Не менее 2 символов')
            .max(300, 'Количество символов в поле не может превышать 300')
            .required('Обязательное поле'),
        patronymic: create$6().trim().max(300, 'Количество символов в поле не может превышать 300').default(''),
    }),
    contacts: create$3({
        phone: create$6()
            .test('length', 'Введите мобильный номер', (phone) => !phone || (phone === null || phone === void 0 ? void 0 : phone.length) === 1 || (phone === null || phone === void 0 ? void 0 : phone.length) === 11)
            .required('Обязательное поле'),
        email: create$6().email('Введите корректный email').nullable(),
    }),
    comment: create$6().max(2000, 'Количество символов в поле не может превышать 2000').nullable(),
    consentIsGiven: create$7().required().oneOf([true]),
});

const fioSchema = create$3({
    surname: create$6()
        .trim()
        .min(2, 'Не менее 2 символов')
        .max(300, 'Количество символов в поле не может превышать 300')
        .defined()
        .required('Обязательное поле'),
    name: create$6()
        .trim()
        .min(2, 'Не менее 2 символов')
        .max(300, 'Количество символов в поле не может превышать 300')
        .defined()
        .required('Обязательное поле'),
    patronymic: create$6().trim().max(300, 'Количество символов в поле не может превышать 300'),
});
const priceSchema = create$5()
    .transform((v) => {
    if (isNaN(v))
        return undefined;
    return v;
})
    .positive('Введите число больше 0')
    .required('Обязательно поле')
    .max(Number.MAX_SAFE_INTEGER, `Число не должно превышать ${Number.MAX_SAFE_INTEGER}`);
const commentSchema = create$6().max(2000, 'Количество символов в поле не может превышать 2000');

const documentsSchema = create$2()
    .of(create$3().shape({
    documentStorageId: create$6(),
    type: create$8().oneOf([
        'FIXATION_DOCUMENT',
        'VIEWING_DOCUMENT',
        'COMMISSION_PAYMENT_DOCUMENT',
        'BOOKING_DOCUMENT',
    ]),
    originalName: create$6(),
    size: create$6(),
}))
    .max(50, 'Максимум 50 файлов к одной заявке');

const employmentFormSchema = create$8()
    .transform((v) => {
    if (v === 'UNKNOWN_EMPLOYMENT_FORM')
        return undefined;
    return v;
})
    .oneOf(['LEGAL', 'INDIVIDUAL_ENTREPRENEUR', 'SELF_EMPLOYED'])
    .required('Обязательное поле');
const contractSchema = create$3({
    number: create$6().required('Обязательно поле'),
    buyer: fioSchema,
    date: create$4()
        .transform((v) => (!isNaN(v) && v instanceof Date ? v : undefined))
        .required('Обязательно поле'),
    apartmentPrice: priceSchema,
});
const paymentFloweSchema = create$3({
    flowType: create$8()
        .transform((type) => {
        if (type === 'UNKNOWN_FLOW_TYPE')
            return undefined;
        return type;
    })
        .oneOf(['MANUAL', 'AUTOMATIC'])
        .required('Обязательное поле'),
});
const realtorSendPaymentSchema = create$3({
    location: create$6().required('Обязательно поле'),
    employmentForm: employmentFormSchema,
    contract: contractSchema,
    comment: commentSchema,
    documents: documentsSchema,
});
const middleEditPaymentSchema = create$3({
    location: create$6().required('Обязательно поле'),
    employmentForm: employmentFormSchema,
    contract: contractSchema,
    paymentFlow: paymentFloweSchema,
});
const middleSendPaymentSchema = create$3({
    commissionAmount: priceSchema,
    comment: create$6(),
    commissionPercent: create$5()
        .transform((v) => {
        if (isNaN(v))
            return undefined;
        return v;
    })
        .positive('Введите число больше 0')
        .max(100),
    documents: documentsSchema,
});
const middleDeclinePaymentSchema = create$3({
    comment: create$6().required('Комментарий обязателен при отказе'),
    documents: documentsSchema,
});

const fixationSchema = create$3({
    comment: create$6().max(2000, 'Количество символов в поле не может превышать 2000').nullable(),
    dueDate: create$4()
        .min(new Date(), `Дата фиксации должна быть не ранее ${format(addDays(new Date(), 1), 'dd.MM.yyyy')}`)
        .nullable(),
});
const fixationDeclineSchema = create$3({
    comment: create$6().max(2000, 'Количество символов в поле не может превышать 2000').nullable(),
});

const orderSchema = create$3({
    leadClientId: create$6()
        .when('leadClientData.consentIsGiven', {
        is: false,
        then: (s) => s.required('Обязательное поле'),
    })
        .nullable()
        .default(null),
    realtorContactData: create$3({
        contacts: create$3({
            phone: create$6()
                .test('length', 'Введите мобильный номер', (phone) => !phone || (phone === null || phone === void 0 ? void 0 : phone.length) === 1 || (phone === null || phone === void 0 ? void 0 : phone.length) === 11)
                .required('Обязательное поле'),
            email: create$6().email('Введите корректный email').required('Обязательное поле'),
        }),
        edited: create$7(),
    }),
    developersWithComplex: create$2().of(create$6().required('Обязательное поле')),
    leadClientData: clientSchema
        .shape({
        name: create$3({
            surname: create$6().when('leadClientId', {
                is: (value) => !value,
                then: (s) => s
                    .trim()
                    .min(2, 'Не менее 2 символов')
                    .max(300, 'Количество символов в поле не может превышать 300')
                    .required('Обязательное поле'),
            }),
            name: create$6().when('leadClientId', {
                is: (value) => !value,
                then: (s) => s
                    .trim()
                    .min(2, 'Не менее 2 символов')
                    .max(300, 'Количество символов в поле не может превышать 300')
                    .required('Обязательное поле'),
            }),
            patronymic: create$6().trim().max(300, 'Количество символов в поле не может превышать 300'),
        }).default({ surname: '', name: '', patronymic: '' }),
        contacts: create$3({
            phone: create$6().when('leadClientId', {
                is: (value) => !value,
                then: (s) => s
                    .test('length', 'Введите мобильный номер', (phone) => !phone || (phone === null || phone === void 0 ? void 0 : phone.length) === 1 || (phone === null || phone === void 0 ? void 0 : phone.length) === 11)
                    .required('Обязательное поле'),
            }),
            email: create$6().email('Введите корректный email').nullable(),
        }),
        consentIsGiven: create$7().when('leadClientId', {
            is: (value) => !value,
            then: (s) => s.required().oneOf([true]),
        }),
    })
        .nullable()
        .default(null),
});

const confirmBookingSchema = create$3({
    id: create$6().nullable(),
    buildingNumber: create$6().required('Обязательное поле'),
    flatNumber: create$6().nullable().required('Обязательное поле'),
    comment: create$6().max(2000, 'Количество символов в поле не может превышать 2000').nullable(),
    documents: documentsSchema.min(1, 'Для бронирования загрузите необходимые документы').nullable(),
});
const skipBookingSchema = create$3({
    id: create$6().nullable(),
    comment: create$6()
        .max(2000, 'Количество символов в поле не может превышать 2000')
        .required('Комментарий обязателен при пропуске бронирования'),
    buildingNumber: create$6(),
    flatNumber: create$6(),
    documents: documentsSchema,
});
const middleBookingSchema = create$3({
    id: create$6().nullable(),
    comment: create$6().max(2000, 'Количество символов в поле не может превышать 2000'),
    documents: documentsSchema,
});

const client$7 = axios.create();
client$7.defaults.paramsSerializer = querystring.encode;
client$7.defaults.baseURL = "/api/m2pro";
async function createOrders$1({ data, headers, cancelToken }) {
    const result = await client$7({
        method: "post",
        url: `/realtor/v1/orders`,
        data,
        headers,
        cancelToken
    });
    return result.data;
}

const createOrders = async (requestData) => {
    const requestsCreateQueue = createOrders$1({
        data: objectSanitizer(requestData),
    });
    try {
        const result = await requestsCreateQueue;
        assert(result.orders.length === requestData.developersWithComplex.length, 'Сервер не вернул все запросы при создании');
        return result;
    }
    catch (e) {
        return handleApiError(e);
    }
};

var orders_service = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createOrders: createOrders
});

const client$6 = axios.create();
client$6.defaults.paramsSerializer = querystring.encode;
client$6.defaults.baseURL = "/api/m2pro";
async function listLeadClients({ data, headers, cancelToken }) {
    const result = await client$6({
        method: "post",
        url: `/v1/lead-client/list`,
        data,
        headers,
        cancelToken
    });
    return result.data;
}

const mapClientValuesToDTO = (values) => {
    var _a, _b;
    const toDTOValue = { ...values };
    if (((_b = (_a = toDTOValue.contacts) === null || _a === void 0 ? void 0 : _a.phone) === null || _b === void 0 ? void 0 : _b.length) === 1) {
        toDTOValue.contacts.phone = undefined;
    }
    return objectSanitizer(toDTOValue);
};
const mapClientDTOToValues = (values) => {
    return values;
};

const getClientsList = async (data) => {
    const clients = await listLeadClients({ data });
    const mappedClients = mapClientDTOToValues(clients.leadClients);
    assert(mappedClients, 'Ошибка получения списка клиентов');
    return { clientList: mappedClients || [], page: clients.page };
};

var client_service = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getClientsList: getClientsList
});

const client$5 = axios.create();
client$5.defaults.paramsSerializer = querystring.encode;
client$5.defaults.baseURL = "/api/m2pro";
async function getDownloadUrl({ params, headers, cancelToken }) {
    const result = await client$5({
        method: "get",
        url: `/v1/file/v1/download_url`,
        data: {},
        params,
        headers,
        cancelToken
    });
    return result.data;
}
async function getUploadToken$1({ params, headers, cancelToken }) {
    const result = await client$5({
        method: "get",
        url: `/v1/file/v1/upload_token`,
        data: {},
        params,
        headers,
        cancelToken
    });
    return result.data;
}

const getUploadToken = async (params) => {
    return await getUploadToken$1({ params })
        .then(({ token }) => token)
        .catch(handleApiError);
};
const uploadOrderFile = async ({ file, orderId, type }) => {
    const token = await getUploadToken({ type, orderId });
    if (token) {
        return await uploadFile(file, token).catch(handleApiError);
    }
};
async function getDownloadFileUrl(params) {
    return await getDownloadUrl({ params })
        .then(({ url }) => url)
        .catch(handleApiError);
}

var file_service = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getDownloadFileUrl: getDownloadFileUrl,
  getUploadToken: getUploadToken,
  uploadOrderFile: uploadOrderFile
});

const checkIsForwardRef = ({ allPagesLength, pageIndex, itemsOnPageLength, itemIndex, }) => {
    const isLastPage = allPagesLength === pageIndex + 1;
    const isTriggerClient = itemsOnPageLength === itemIndex + 3;
    const isForwardRef = isLastPage && isTriggerClient;
    return isForwardRef;
};

const getFio = ({ name, patronymic, surname } = {}) => `${surname || ''} ${name || ''} ${patronymic || ''}`;

const getInputName = (event) => { var _a; return (_a = event.currentTarget.parentElement.querySelector('input')) === null || _a === void 0 ? void 0 : _a.name; };

function pushToGTM(event) {
    try {
        const data = {
            event: 'm2_pro_events',
            ...event,
        };
        if (localStorage.getItem('log_gtm')) {
            console.log(data);
        }
        window === null || window === void 0 ? void 0 : window.dataLayer.push(data);
    }
    catch (err) {
        console.error(`Cannot push to GTM Data Layer: ${err}`);
    }
}

const GTMMap = {
    LANDING_PAGE: {
        tariff_card: {
            action: 'm2_pro_tarifs_map_click',
        },
        reglament_card: {
            action: 'm2_pro_reglament_card_click',
        },
        offerta: {
            action: 'm2_pro_offerta_click',
        },
        documents: {
            action: 'm2_pro_doc_list',
        },
        usedesk: {
            action: 'm2_pro_chat_click',
        },
        book_event: {
            action: 'm2_pro_book_event',
        },
        fixation: {
            action: 'm2_pro_serp_fix_click',
        },
        fixation_success: {
            action: 'm2_pro_order_created',
        },
        client_creation_success: {
            action: 'm2_pro_client_created',
        },
        IB_redirect: {
            action: 'm2_pro_IB_send_click',
        },
        novostroyki_link: {
            action: 'm2_pro_events_to_serp',
        },
        verify: {
            action: 'm2_pro_events_click_verify',
        },
        developers_promos: {
            action: 'm2_pro_events_developers_promos',
        },
        foreign_card_click: {
            action: 'm2_pro_events_foreign_card_click',
        },
        remont_banner_click: {
            action: 'm2_pro_events_remont_banner_click',
        },
    },
    CLIENTS: {
        new_order: (value) => ({
            action: 'm2_pro_client_new_order_click',
            value,
        }),
        new_client: (value) => ({
            action: 'm2_pro_client_new_client_click',
            value,
        }),
        click_on_client: {
            action: 'm2_pro_client_client_click',
        },
        order_creation_success: {
            action: 'm2_pro_order_created',
            value: 'clients-page',
        },
        client_creation_success: {
            action: 'm2_pro_client_created',
            value: 'clients-page',
        },
        close_creation: {
            action: 'm2_pro_client_cancel_event',
        },
    },
    ORDERS_PAGE: {
        order_click: {
            action: 'm2_pro_client_order_click',
        },
    },
    COMPLEX: {
        apartment_click: {
            action: 'm2_pro_complex_page_apartment_click',
        },
    },
    SUBURBAN: {
        fixation_click: {
            action: 'm2_pro_serp_suburban_fix_click',
        },
        popup_click: {
            action: 'm2_pro_suburban_popup',
        },
        popup: {
            regulations_download: {
                action: 'm2_pro_modal_suburban_reglament_download',
            },
            regulations_show: {
                action: 'm2_pro_modal_suburban_reglament_show',
            },
            presentation_zk_show: {
                action: 'm2_pro_modal_suburban_presentation_ZK_show',
            },
            presentation_zk_download: {
                action: 'm2_pro_modal_suburban_presentation_ZK_download',
            },
            presentation_developer_show: {
                action: 'm2_pro_modal_suburban_presentation_developer_show',
            },
            presentation_developer_download: {
                action: 'm2_pro_modal_suburban_presentation_developer_download',
            },
        },
        IB_redirect: {
            action: 'm2_pro_suburban_IB',
        },
    },
    SEARCH: {
        vitrina: {
            show_search_result: {
                action: 'm2_pro_serp_search_show',
            },
            fixation_click: {
                action: 'm2_pro_client_new_order_click',
            },
            popup_click: {
                action: 'm2_pro_reglament_presentations',
            },
            IB_redirect: {
                action: 'm2_pro_IB_send_click',
            },
            apartment_name_click: {
                action: 'm2_pro_serp_ZK_name',
            },
        },
        popup: {
            regulations_download: {
                action: 'm2_pro_modal_reglament_download',
            },
            regulations_show: {
                action: 'm2_pro_modal_reglament_show',
            },
            presentation_zk_show: {
                action: 'm2_pro_modal_presentation_ZK_show',
            },
            presentation_zk_download: {
                action: 'm2_pro_modal_presentation_ZK_download',
            },
            presentation_developer_show: {
                action: 'm2_pro_modal_presentation_developer_show',
            },
            presentation_developer_download: {
                action: 'm2_pro_modal_presentation_developer_download',
            },
        },
        apartment: {
            create_presentation_click: {
                action: 'm2_pro_card_ZK_form_presentation',
            },
        },
    },
    ORDER: {
        stage_click: (value) => ({
            action: 'm2_pro_order_stage_click',
            value,
        }),
        viewing_confirm: {
            action: 'm2_pro_order_page_send_click',
        },
        skip_viewing: {
            action: 'm2_pro_order_page_send_skip_viewing_click',
        },
        booking_confirm: {
            action: 'm2_pro_order_page_send_booking_click',
        },
        booking_skip: {
            action: 'm2_pro_order_page_skip_booking_click',
        },
        payment_stage_click: {
            action: 'm2_pro_order_page_reward_click',
        },
        payment_send: {
            action: 'm2_pro_order_page_send_reward_click',
        },
        commission_amount_confirm: {
            action: 'm2_pro_order_page_commission_amount_confirm_click',
        },
        JK_click: {
            action: 'm2_pro_order_page_jk_click',
        },
        regulation_link_click: {
            action: 'm2_pro_order_page_laws_click',
        },
        right_block: {
            support_block: {
                phone: {
                    action: 'm2_pro_order_right_block_support_phone',
                },
                chat: {
                    action: 'm2_pro_order_right_block_support_chat',
                },
            },
        },
        employee: {
            search: {
                action: 'm2_pro_order_employee_search',
            },
            filter: {
                developer: {
                    action: 'm2_pro_order_employee_filter_developer',
                },
                status: {
                    action: 'm2_pro_order_employee_filter_status',
                },
            },
            copy_phone: {
                action: 'm2_pro_order_employee_copy_phone',
            },
            open_order: {
                action: 'm2_pro_order_employee_open_order',
            },
            click_check: {
                action: 'm2_pro_order_employee_checkbox',
            },
            in_work: {
                action: 'm2_pro_order_employee_in_work',
            },
            fixed: {
                action: 'm2_pro_order_employee_fixed',
            },
            not_unique: {
                action: 'm2_pro_order_employee_not_unique',
            },
            viewing_confirm: {
                action: 'm2_pro_order_employee_viewing_confirm',
            },
            payment_confirm: {
                action: 'm2_pro_order_employee_payment_confirm',
            },
            payment_decline: {
                action: 'm2_pro_order_employee_payment_decline',
            },
            commission_paid_confirm: {
                action: 'm2_pro_order_employee_commission_paid_confirm',
            },
            commission_amount_confirm: {
                action: 'm2_pro_order_employee_commission_amount_confirm',
            },
            booking_confirm: {
                action: 'm2_pro_order_employee_send_booking',
            },
        },
    },
};

const CONTAINER_ID = 'm2-pro-create-order';

const getIsSubmitDisable = ({ isCreateClient, isAgreementAccept, isComplexSelect, isLeadSelect, }) => {
    if (isCreateClient) {
        return isAgreementAccept || isComplexSelect;
    }
    else {
        return isLeadSelect || isComplexSelect;
    }
};
const useRequestForm = ({ onClose, isCreateClient, setIsCreateClient, selected, profileId, apartments, toastType = 'toastify', }) => {
    var _a;
    const { profile } = useProfile(profileId);
    const latest = React.useMemo(() => getLatestProfile(profile), [profile]);
    const defaultValues = React.useMemo(() => ({
        developersWithComplex: selected,
        realtorContactData: {
            contacts: {
                phone: latest.phone,
                email: latest.email,
            },
        },
    }), [latest, selected]);
    const { control, handleSubmit, formState: { errors, isSubmitting }, reset, setValue, resetField, watch, } = useForm({
        defaultValues: defaultValues,
        resolver: o(orderSchema),
        shouldUnregister: true,
    });
    const queryRequest = reactQuery.useQueryClient();
    React.useEffect(() => {
        reset(defaultValues);
    }, [defaultValues, reset, selected]);
    const onReset = React.useCallback((event) => {
        reset();
        onClose(event);
    }, [onClose, reset]);
    const onSubmit = React.useCallback(async (formData) => {
        const payload = await orderToDTO({ formData, defaultValues, apartments });
        const res = await createOrders(payload);
        if (res) {
            queryRequest.invalidateQueries([CLIENTS_WITH_ORDERS_ORDERS_QUERY]);
            queryRequest.invalidateQueries([PROFILE_QUERY]);
            setIsCreateClient(false);
            res.orders.map(({ order }) => {
                if (toastType === 'toastify')
                    W(React.createElement(OrderCreatedSuccessNotify, { number: order.number, id: order.id }), {
                        toastId: order.id,
                        containerId: CONTAINER_ID,
                    });
                else {
                    publishNotification({ message: `Заявка № ${order.number} отправлена`, type: 'success' });
                }
            });
            pushToGTM(GTMMap.LANDING_PAGE.fixation_success);
            if (isCreateClient)
                pushToGTM(GTMMap.LANDING_PAGE.client_creation_success);
            reset();
            onClose();
        }
    }, [defaultValues, apartments, queryRequest, setIsCreateClient, isCreateClient, reset, onClose, toastType]);
    const onResetField = React.useCallback((event) => {
        const name = getInputName(event);
        setValue(name, '');
    }, [setValue]);
    const isSubmitDisable = getIsSubmitDisable({
        isCreateClient,
        isAgreementAccept: !watch('leadClientData.consentIsGiven'),
        isLeadSelect: !watch('leadClientId'),
        isComplexSelect: !((_a = watch('developersWithComplex')) === null || _a === void 0 ? void 0 : _a[0]),
    });
    React.useEffect(() => {
        resetField('leadClientData');
        resetField('leadClientId');
    }, [isCreateClient, resetField]);
    const commonOptions = React.useMemo(() => ({ control, onReset: onResetField, selected }), [control, onResetField, selected]);
    return {
        onSubmit: handleSubmit(onSubmit),
        onReset,
        isSubmitting,
        commonOptions,
        control,
        errors,
        isSubmitDisable,
    };
};

const Component$5 = (props, ref) => {
    const { control, defaultValue, Component, useErrorAsHint, onChangeOuter, ...rest } = props;
    const { field, fieldState: { error }, } = useController({ name: props.name, defaultValue, control });
    const errorTooltip = useTooltip();
    const componentError = error ? errorTooltip.registerControl : rest.error;
    const hintError = error && useErrorAsHint ? String(error.message) : null;
    const RenderComponent = Component ? Component : Input$1;
    const inputRef = React.useRef();
    React.useLayoutEffect(() => {
        if (!ref)
            return;
        if (isFunction_1(ref)) {
            return ref(inputRef.current);
        }
        ref.current = inputRef.current;
    }, [inputRef, ref]);
    const onChange = React.useCallback((value, event) => {
        field.onChange(value, event);
        if (typeof onChangeOuter === 'function')
            onChangeOuter(value, event);
    }, [field, onChangeOuter]);
    return (React.createElement("div", null,
        React.createElement(RenderComponent, { ...field, ...rest, defaultValue: defaultValue, inputRef: inputRef, onChange: onChange, ref: ref, hint: rest.hint || hintError, error: componentError, errorMessage: error === null || error === void 0 ? void 0 : error.message, size: rest.size || 'l', dataTest: rest.dataTest }),
        error && !useErrorAsHint && React.createElement(ErrorTooltip, { to: errorTooltip.to, message: error.message })));
};
const FormInputField = React.forwardRef(Component$5);

function createAxios(config, onResult = (response) => response, onReject = (error) => Promise.reject(error), onRequest = (request) => request) {
    const instance = axios.create(config);
    instance.interceptors.request.use(onRequest);
    instance.interceptors.response.use(onResult, onReject);
    return instance;
}

const ADDRESS_URL = '/suggestions/api/4_1/rs/suggest/address';
const FIO_URL = '/suggestions/api/4_1/rs/suggest/fio';
const transport = createAxios({
    baseURL: '/api/dadata',
    headers: {
        'Content-Type': 'application/json',
    },
});
const dataProviderAddress = new DaDataProvider({ transport, url: ADDRESS_URL });
const dataProviderFio = new DaDataProvider({ transport, url: FIO_URL });
const fetchAddressSuggestions = (addressField) => async (text) => {
    const fetchedSuggestions = await dataProviderAddress.fetch(text.slice(0, 300), 10, {
        from_bound: { value: 'city' },
        to_bound: { value: 'city' },
        count: 5,
    });
    return fetchedSuggestions.list.map((option) => option[addressField]);
};
const fetchFIOSuggestions = (fioPart) => async (text) => {
    const fetchedSuggestions = await dataProviderFio.fetch(text.slice(0, 300), 10, {
        parts: [fioPart.toUpperCase()],
        count: 5,
    });
    return fetchedSuggestions.list.map((option) => option.value);
};
const DADATA_FETCHERS = {
    address: fetchAddressSuggestions,
    fio: fetchFIOSuggestions,
};

const Component$4 = (props) => {
    const { control, defaultValue, useErrorAsHint, required, autoFocus, fetcher, ...rest } = props;
    const name = props.name;
    const { field, fieldState: { error }, } = useController({ name, control, defaultValue });
    const [results, setResults] = React.useState([]);
    const queryClient = reactQuery.useQueryClient();
    const onChange = React.useCallback(async (val) => {
        try {
            if (!val) {
                setResults([]);
                return true;
            }
            const fetcherFn = DADATA_FETCHERS[fetcher];
            const results = await queryClient.fetchQuery([`dadataSuggestions-${props.dadataField}`, val], () => fetcherFn(props.dadataField)(val), {
                staleTime: 60000,
                cacheTime: 60000,
            });
            setResults(results);
            return true;
        }
        catch (e) {
            captureException(e, {
                level: 'info',
            });
            publishWarningNotification('Не удалось получить подсказки для адреса');
        }
    }, [fetcher, props.dadataField, queryClient]);
    const errorTooltip = useTooltip();
    const componentError = error ? errorTooltip.registerControl : rest.error;
    const hintError = error && useErrorAsHint ? String(error.message) : null;
    const ref = React.useRef(null);
    const showTooltip = error && !useErrorAsHint;
    return (React.createElement("div", null,
        React.createElement(Select, { onChange: field.onChange, mode: "single" },
            React.createElement(SuggestInput$1, { autoFocus: autoFocus, value: field.value, inputRef: ref, name: name, label: props.label, passRequiredToHTMLInput: required, required: required, debounce: 300, onChange: onChange, onTextChange: field.onChange, size: "l", hint: rest.hint || hintError, error: componentError, dataTest: props.dataTest, disabled: props.disabled, readonly: props.readonly }),
            showTooltip && React.createElement(ErrorTooltip, { to: errorTooltip.to, message: error.message }),
            results.length > 0 && (React.createElement(Select.Content, null, results.map((data) => (React.createElement(Select.Option, { key: data, value: data }, data))))))));
};
const DadataField = React.memo(Component$4);

const RequestModalContext = React__namespace.createContext({});
const useRequestModalCtx = () => {
    const context = React.useContext(RequestModalContext);
    if (!context) {
        throw new Error('useRequestModalCtx must be used within a RequestModalContext.');
    }
    return context;
};

const DEVELOPER_EXCEPTIONS = ['ДОНСТРОЙ'];
const fieldName = 'developersWithComplex';
const CommentField = (props) => {
    const { apartments } = useRequestModalCtx();
    const { field: { value: selectedApartments }, } = useController({ name: fieldName, control: props.control });
    if (!selectedApartments)
        return null;
    const hasExceptions = selectedApartments.some((id) => {
        const currApartment = apartments.find((a) => a.value === id);
        if (!currApartment)
            return false;
        return DEVELOPER_EXCEPTIONS.includes(currApartment.developer);
    });
    const prefix = getPrefix(props.namePrefix);
    if (!hasExceptions) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement(FormInputField, { name: `${prefix}comment`, label: "\u041C\u0435\u0441\u0442\u043E \u043F\u0440\u043E\u043F\u0438\u0441\u043A\u0438 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u043F\u043E \u043F\u0430\u0441\u043F\u043E\u0440\u0442\u0443", placeholder: 'Пожалуйста, укажите прописку', required: true, ...props }),
        React.createElement(Typography, { variant: "small", color: "black-300" }, "\u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F \u043F\u043E \u0414\u043E\u043D\u0441\u0442\u0440\u043E\u0439 \u043D\u0435 \u0432\u044B\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043F\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\u043C \u0441 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C\u0438 \u0438\u0437 \u041C\u043E\u0441\u043A\u0432\u044B \u0438 \u041C\u041E")));
};
const getPrefix = (namePrefix) => (namePrefix ? namePrefix + '.' : '');
const Component$3 = (props) => {
    const { namePrefix } = props;
    const prefix = getPrefix(namePrefix);
    return (React.createElement(React.Fragment, null,
        React.createElement(DadataField, { autoFocus: true, name: `${prefix}name.surname`, label: "\u0424\u0430\u043C\u0438\u043B\u0438\u044F", fetcher: 'fio', dadataField: 'surname', required: true, ...props }),
        React.createElement(DadataField, { name: `${prefix}name.name`, fetcher: 'fio', dataTest: "name.name", label: "\u0418\u043C\u044F", dadataField: 'name', required: true, ...props }),
        React.createElement(DadataField, { name: `${prefix}name.patronymic`, label: "\u041E\u0442\u0447\u0435\u0441\u0442\u0432\u043E", dadataField: 'patronymic', fetcher: 'fio', ...props }),
        React.createElement(FormInputField, { name: `${prefix}contacts.phone`, Component: PhoneInput, label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D", type: "tel", inputMode: "tel", required: true, ...props }),
        React.createElement(FormInputField, { name: `${prefix}contacts.email`, label: "\u042D\u043B. \u043F\u043E\u0447\u0442\u0430", ...props }),
        React.createElement(CommentField, { ...props })));
};
const ClientFields = React.memo(Component$3);

const AgreementCheckbox = ({ control, hasError, dataTest, namePrefix, isDisabled, }) => {
    const prefix = namePrefix ? namePrefix + '.' : '';
    return (React.createElement(FormInputField, { name: `${prefix}consentIsGiven`, control: control, Component: (props) => (React.createElement(Checkbox, { ...props, value: !!props.value, color: hasError ? 'error' : 'primary', dataTest: dataTest, disabled: isDisabled },
            React.createElement(Typography, { variant: "small", color: "black-300" }, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043C\u043D\u043E\u044E \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u044F \u0442\u0440\u0435\u0442\u044C\u0438\u0445 \u043B\u0438\u0446 \u043D\u0430 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 \u0438\u0445 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0434\u0430\u043D\u043D\u044B\u0445 \u043D\u0430 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0443"))) }));
};

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$1(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach$1;

var assignValue$1 = _assignValue,
    baseAssignValue = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$5(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject$5;

var copyObject$4 = _copyObject,
    keys$2 = keys_1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign$1(object, source) {
  return object && copyObject$4(source, keys$2(source), object);
}

var _baseAssign = baseAssign$1;

var copyObject$3 = _copyObject,
    keysIn$1 = keysIn_1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn$1(object, source) {
  return object && copyObject$3(source, keysIn$1(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBufferExports = {};
var _cloneBuffer = {
  get exports(){ return _cloneBufferExports; },
  set exports(v){ _cloneBufferExports = v; },
};

(function (module, exports) {
	var root = _root;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	  buffer.copy(result);
	  return result;
	}

	module.exports = cloneBuffer;
} (_cloneBuffer, _cloneBufferExports));

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$1(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray$1;

var copyObject$2 = _copyObject,
    getSymbols = _getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols$1(source, object) {
  return copyObject$2(source, getSymbols(source), object);
}

var _copySymbols = copySymbols$1;

var copyObject$1 = _copyObject,
    getSymbolsIn = _getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn$1(source, object) {
  return copyObject$1(source, getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

/** Used for built-in method references. */

var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$1.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray$1;

var Uint8Array$1 = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$3;

var cloneArrayBuffer$2 = _cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var Symbol$2 = _Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol$1(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$1 = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$1;

var cloneArrayBuffer = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray = _cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$1:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$2 = isObject_1;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$1 = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$2(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate$1;

var baseCreate = _baseCreate,
    getPrototype$1 = _getPrototype,
    isPrototype = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$1(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype$1(object))
    : {};
}

var _initCloneObject = initCloneObject$1;

var getTag$2 = _getTag,
    isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap$1(value) {
  return isObjectLike$2(value) && getTag$2(value) == mapTag$1;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$2 = _baseUnary,
    nodeUtil$1 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap$1 = nodeIsMap ? baseUnary$2(nodeIsMap) : baseIsMap;

var isMap_1 = isMap$1;

var getTag$1 = _getTag,
    isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet$1(value) {
  return isObjectLike$1(value) && getTag$1(value) == setTag$1;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary$1 = _baseUnary,
    nodeUtil = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet$1 = nodeIsSet ? baseUnary$1(nodeIsSet) : baseIsSet;

var isSet_1 = isSet$1;

var Stack = _Stack,
    arrayEach = _arrayEach,
    assignValue = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer = _cloneBufferExports,
    copyArray = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys = _getAllKeys,
    getAllKeysIn$1 = _getAllKeysIn,
    getTag = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject = _initCloneObject,
    isArray$2 = isArray_1,
    isBuffer = isBufferExports,
    isMap = isMap_1,
    isObject$1 = isObject_1,
    isSet = isSet_1,
    keys$1 = keys_1,
    keysIn = keysIn_1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag$1 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag$1] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG$1,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1(value)) {
    return value;
  }
  var isArr = isArray$2(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag$1 || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn$1 : getAllKeys)
    : (isFlat ? keysIn : keys$1);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$1;

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */

function last$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last$1;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$1(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$1;

var baseGet$1 = _baseGet,
    baseSlice = _baseSlice;

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent$1(object, path) {
  return path.length < 2 ? object : baseGet$1(object, baseSlice(path, 0, -1));
}

var _parent = parent$1;

var castPath$1 = _castPath,
    last = last_1,
    parent = _parent,
    toKey = _toKey;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset$1(object, path) {
  path = castPath$1(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

var _baseUnset = baseUnset$1;

var baseGetTag = _baseGetTag,
    getPrototype = _getPrototype,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$1(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject$1;

var isPlainObject = isPlainObject_1;

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone$1(value) {
  return isPlainObject(value) ? undefined : value;
}

var _customOmitClone = customOmitClone$1;

var Symbol$1 = _Symbol,
    isArguments = isArguments_1,
    isArray$1 = isArray_1;

/** Built-in value references. */
var spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$1(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable$1;

var arrayPush = _arrayPush,
    isFlattenable = _isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$2(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$2(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten$2;

var baseFlatten$1 = _baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten$1(array, 1) : [];
}

var flatten_1 = flatten$1;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply$1;

var apply = _apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$2(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

var _overRest = overRest$2;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant$1(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant$1;

var constant = constant_1,
    defineProperty = _defineProperty$2,
    identity$2 = identity_1;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$1 = !defineProperty ? identity$2 : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString$1;

/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut$1;

var baseSetToString = _baseSetToString,
    shortOut = _shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$2 = shortOut(baseSetToString);

var _setToString = setToString$2;

var flatten = flatten_1,
    overRest$1 = _overRest,
    setToString$1 = _setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest$1(func) {
  return setToString$1(overRest$1(func, undefined, flatten), func + '');
}

var _flatRest = flatRest$1;

var arrayMap$1 = _arrayMap,
    baseClone = _baseClone,
    baseUnset = _baseUnset,
    castPath = _castPath,
    copyObject = _copyObject,
    customOmitClone = _customOmitClone,
    flatRest = _flatRest,
    getAllKeysIn = _getAllKeysIn;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap$1(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

var omit_1 = omit;

const RHFTextAreaField = React.memo((props) => {
    const { autoHeight = true } = props;
    return (React.createElement(FormInputField, { ...omit_1(props, ['maxRows', 'minRows']), rows: 1, Component: Textarea, autoHeight: autoHeight }));
});

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$1 = createBaseFor();

var _baseFor = baseFor$1;

var baseFor = _baseFor,
    keys = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$1(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

var _baseForOwn = baseForOwn$1;

var isArrayLike$2 = isArrayLike_1;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$2(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach$1;

var baseForOwn = _baseForOwn,
    createBaseEach = _createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$1 = createBaseEach(baseForOwn);

var _baseEach = baseEach$1;

var baseEach = _baseEach,
    isArrayLike$1 = isArrayLike_1;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap$1(collection, iteratee) {
  var index = -1,
      result = isArrayLike$1(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap$1;

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */

function baseSortBy$1(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

var _baseSortBy = baseSortBy$1;

var isSymbol = isSymbol_1;

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

var _compareAscending = compareAscending$1;

var compareAscending = _compareAscending;

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple$1(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

var _compareMultiple = compareMultiple$1;

var arrayMap = _arrayMap,
    baseGet = _baseGet,
    baseIteratee = _baseIteratee,
    baseMap = _baseMap,
    baseSortBy = _baseSortBy,
    baseUnary = _baseUnary,
    compareMultiple = _compareMultiple,
    identity$1 = identity_1,
    isArray = isArray_1;

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity$1];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

var _baseOrderBy = baseOrderBy$1;

var identity = identity_1,
    overRest = _overRest,
    setToString = _setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest$1(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

var _baseRest = baseRest$1;

var eq = eq_1,
    isArrayLike = isArrayLike_1,
    isIndex = _isIndex,
    isObject = isObject_1;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall$1(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall$1;

var baseFlatten = _baseFlatten,
    baseOrderBy = _baseOrderBy,
    baseRest = _baseRest,
    isIterateeCall = _isIterateeCall;

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

var sortBy_1 = sortBy;

const filterApartments = (filter, apartmentsRaw) => {
    const searchValue = filter.trim().toLowerCase();
    return apartmentsRaw === null || apartmentsRaw === void 0 ? void 0 : apartmentsRaw.filter((apartment) => (apartment === null || apartment === void 0 ? void 0 : apartment.text.toLowerCase().includes(searchValue)) ||
        (apartment === null || apartment === void 0 ? void 0 : apartment.city.toLowerCase().includes(searchValue)) ||
        (apartment === null || apartment === void 0 ? void 0 : apartment.developer.toLowerCase().includes(searchValue)));
};

const splitApartments = (apartments) => apartments.split(/, (?=\D)/).filter((text) => !!text);
const useApartmentComplex = ({ onChange, resortToggle, selected }) => {
    const { apartments: apartmentsRaw } = useRequestModalCtx();
    const { is, handleChange, selectedText } = useMultipleSelect(onChange, {
        texts: apartmentsRaw,
        selected: selected,
    });
    const [filter, updateFilter] = React.useState('');
    const [apartments, setApartments] = React.useState(apartmentsRaw);
    const [firstSelectApartment, setFirstSelectApartment] = React.useState(splitApartments(selectedText)[0] || '');
    React.useEffect(() => {
        const filteredApartments = filter ? filterApartments(filter, apartmentsRaw) : apartmentsRaw;
        setApartments(filteredApartments);
    }, [filter, apartmentsRaw]);
    React.useEffect(() => {
        if (resortToggle) {
            setApartments((apartments) => sortBy_1(apartments, (apartment) => !is(apartment.value)));
        }
    }, [setApartments, resortToggle, is]);
    const displayText = React.useMemo(() => {
        const selectedArray = splitApartments(selectedText);
        const textToDisplay = selectedArray.includes(firstSelectApartment)
            ? firstSelectApartment
            : selectedArray[0] || '';
        const numberOfPlusComplex = selectedArray.length - 1;
        if (textToDisplay !== firstSelectApartment)
            setFirstSelectApartment(textToDisplay);
        if (numberOfPlusComplex > 0)
            return `${textToDisplay}, +${numberOfPlusComplex} ЖК`;
        return textToDisplay;
    }, [firstSelectApartment, selectedText]);
    return { filter, updateFilter, apartments, is, handleChange, displayText };
};

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var now = hasNativePerformanceNow ? function () {
  return performance.now();
} : function () {
  return Date.now();
};
function cancelTimeout(timeoutID) {
  cancelAnimationFrame(timeoutID.id);
}
function requestTimeout(callback, delay) {
  var start = now();

  function tick() {
    if (now() - start >= delay) {
      callback.call(null);
    } else {
      timeoutID.id = requestAnimationFrame(tick);
    }
  }

  var timeoutID = {
    id: requestAnimationFrame(tick)
  };
  return timeoutID;
}

var size = -1; // This utility copied from "dom-helpers" package.

function getScrollbarSize(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (size === -1 || recalculate) {
    var div = document.createElement('div');
    var style = div.style;
    style.width = '50px';
    style.height = '50px';
    style.overflow = 'scroll';
    document.body.appendChild(div);
    size = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  }

  return size;
}
var cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.

function getRTLOffsetType(recalculate) {
  if (recalculate === void 0) {
    recalculate = false;
  }

  if (cachedRTLResult === null || recalculate) {
    var outerDiv = document.createElement('div');
    var outerStyle = outerDiv.style;
    outerStyle.width = '50px';
    outerStyle.height = '50px';
    outerStyle.overflow = 'scroll';
    outerStyle.direction = 'rtl';
    var innerDiv = document.createElement('div');
    var innerStyle = innerDiv.style;
    innerStyle.width = '100px';
    innerStyle.height = '100px';
    outerDiv.appendChild(innerDiv);
    document.body.appendChild(outerDiv);

    if (outerDiv.scrollLeft > 0) {
      cachedRTLResult = 'positive-descending';
    } else {
      outerDiv.scrollLeft = 1;

      if (outerDiv.scrollLeft === 0) {
        cachedRTLResult = 'negative';
      } else {
        cachedRTLResult = 'positive-ascending';
      }
    }

    document.body.removeChild(outerDiv);
    return cachedRTLResult;
  }

  return cachedRTLResult;
}

if (process.env.NODE_ENV !== 'production') ;

var IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;

var defaultItemKey$1 = function defaultItemKey(index, data) {
  return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.


var devWarningsDirection = null;
var devWarningsTagName$1 = null;

if (process.env.NODE_ENV !== 'production') {
  if (typeof window !== 'undefined' && typeof window.WeakSet !== 'undefined') {
    devWarningsDirection = /*#__PURE__*/new WeakSet();
    devWarningsTagName$1 = /*#__PURE__*/new WeakSet();
  }
}

function createListComponent(_ref) {
  var _class;

  var getItemOffset = _ref.getItemOffset,
      getEstimatedTotalSize = _ref.getEstimatedTotalSize,
      getItemSize = _ref.getItemSize,
      getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment,
      getStartIndexForOffset = _ref.getStartIndexForOffset,
      getStopIndexForStartIndex = _ref.getStopIndexForStartIndex,
      initInstanceProps = _ref.initInstanceProps,
      shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange,
      validateProps = _ref.validateProps;
  return _class = /*#__PURE__*/function (_PureComponent) {
    _inheritsLoose(List, _PureComponent);

    // Always use explicit constructor for React components.
    // It produces less code after transpilation. (#26)
    // eslint-disable-next-line no-useless-constructor
    function List(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      _this._instanceProps = initInstanceProps(_this.props, _assertThisInitialized(_this));
      _this._outerRef = void 0;
      _this._resetIsScrollingTimeoutId = null;
      _this.state = {
        instance: _assertThisInitialized(_this),
        isScrolling: false,
        scrollDirection: 'forward',
        scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
        scrollUpdateWasRequested: false
      };
      _this._callOnItemsRendered = void 0;
      _this._callOnItemsRendered = memoizeOne(function (overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
        return _this.props.onItemsRendered({
          overscanStartIndex: overscanStartIndex,
          overscanStopIndex: overscanStopIndex,
          visibleStartIndex: visibleStartIndex,
          visibleStopIndex: visibleStopIndex
        });
      });
      _this._callOnScroll = void 0;
      _this._callOnScroll = memoizeOne(function (scrollDirection, scrollOffset, scrollUpdateWasRequested) {
        return _this.props.onScroll({
          scrollDirection: scrollDirection,
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: scrollUpdateWasRequested
        });
      });
      _this._getItemStyle = void 0;

      _this._getItemStyle = function (index) {
        var _this$props = _this.props,
            direction = _this$props.direction,
            itemSize = _this$props.itemSize,
            layout = _this$props.layout;

        var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);

        var style;

        if (itemStyleCache.hasOwnProperty(index)) {
          style = itemStyleCache[index];
        } else {
          var _offset = getItemOffset(_this.props, index, _this._instanceProps);

          var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"

          var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
          var isRtl = direction === 'rtl';
          var offsetHorizontal = isHorizontal ? _offset : 0;
          itemStyleCache[index] = style = {
            position: 'absolute',
            left: isRtl ? undefined : offsetHorizontal,
            right: isRtl ? offsetHorizontal : undefined,
            top: !isHorizontal ? _offset : 0,
            height: !isHorizontal ? size : '100%',
            width: isHorizontal ? size : '100%'
          };
        }

        return style;
      };

      _this._getItemStyleCache = void 0;
      _this._getItemStyleCache = memoizeOne(function (_, __, ___) {
        return {};
      });

      _this._onScrollHorizontal = function (event) {
        var _event$currentTarget = event.currentTarget,
            clientWidth = _event$currentTarget.clientWidth,
            scrollLeft = _event$currentTarget.scrollLeft,
            scrollWidth = _event$currentTarget.scrollWidth;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollLeft) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          }

          var direction = _this.props.direction;
          var scrollOffset = scrollLeft;

          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
            // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
            switch (getRTLOffsetType()) {
              case 'negative':
                scrollOffset = -scrollLeft;
                break;

              case 'positive-descending':
                scrollOffset = scrollWidth - clientWidth - scrollLeft;
                break;
            }
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollLeft ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._onScrollVertical = function (event) {
        var _event$currentTarget2 = event.currentTarget,
            clientHeight = _event$currentTarget2.clientHeight,
            scrollHeight = _event$currentTarget2.scrollHeight,
            scrollTop = _event$currentTarget2.scrollTop;

        _this.setState(function (prevState) {
          if (prevState.scrollOffset === scrollTop) {
            // Scroll position may have been updated by cDM/cDU,
            // In which case we don't need to trigger another render,
            // And we don't want to update state.isScrolling.
            return null;
          } // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.


          var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
          return {
            isScrolling: true,
            scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
            scrollOffset: scrollOffset,
            scrollUpdateWasRequested: false
          };
        }, _this._resetIsScrollingDebounced);
      };

      _this._outerRefSetter = function (ref) {
        var outerRef = _this.props.outerRef;
        _this._outerRef = ref;

        if (typeof outerRef === 'function') {
          outerRef(ref);
        } else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) {
          outerRef.current = ref;
        }
      };

      _this._resetIsScrollingDebounced = function () {
        if (_this._resetIsScrollingTimeoutId !== null) {
          cancelTimeout(_this._resetIsScrollingTimeoutId);
        }

        _this._resetIsScrollingTimeoutId = requestTimeout(_this._resetIsScrolling, IS_SCROLLING_DEBOUNCE_INTERVAL$1);
      };

      _this._resetIsScrolling = function () {
        _this._resetIsScrollingTimeoutId = null;

        _this.setState({
          isScrolling: false
        }, function () {
          // Clear style cache after state update has been committed.
          // This way we don't break pure sCU for items that don't use isScrolling param.
          _this._getItemStyleCache(-1, null);
        });
      };

      return _this;
    }

    List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
      validateSharedProps$1(nextProps, prevState);
      validateProps(nextProps);
      return null;
    };

    var _proto = List.prototype;

    _proto.scrollTo = function scrollTo(scrollOffset) {
      scrollOffset = Math.max(0, scrollOffset);
      this.setState(function (prevState) {
        if (prevState.scrollOffset === scrollOffset) {
          return null;
        }

        return {
          scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
          scrollOffset: scrollOffset,
          scrollUpdateWasRequested: true
        };
      }, this._resetIsScrollingDebounced);
    };

    _proto.scrollToItem = function scrollToItem(index, align) {
      if (align === void 0) {
        align = 'auto';
      }

      var _this$props2 = this.props,
          itemCount = _this$props2.itemCount,
          layout = _this$props2.layout;
      var scrollOffset = this.state.scrollOffset;
      index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
      // But we only need to account for its size when it's actually visible.
      // This is an edge case for lists; normally they only scroll in the dominant direction.

      var scrollbarSize = 0;

      if (this._outerRef) {
        var outerRef = this._outerRef;

        if (layout === 'vertical') {
          scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? getScrollbarSize() : 0;
        } else {
          scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? getScrollbarSize() : 0;
        }
      }

      this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
    };

    _proto.componentDidMount = function componentDidMount() {
      var _this$props3 = this.props,
          direction = _this$props3.direction,
          initialScrollOffset = _this$props3.initialScrollOffset,
          layout = _this$props3.layout;

      if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          outerRef.scrollLeft = initialScrollOffset;
        } else {
          outerRef.scrollTop = initialScrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var _this$props4 = this.props,
          direction = _this$props4.direction,
          layout = _this$props4.layout;
      var _this$state = this.state,
          scrollOffset = _this$state.scrollOffset,
          scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;

      if (scrollUpdateWasRequested && this._outerRef != null) {
        var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"

        if (direction === 'horizontal' || layout === 'horizontal') {
          if (direction === 'rtl') {
            // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
            // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
            // So we need to determine which browser behavior we're dealing with, and mimic it.
            switch (getRTLOffsetType()) {
              case 'negative':
                outerRef.scrollLeft = -scrollOffset;
                break;

              case 'positive-ascending':
                outerRef.scrollLeft = scrollOffset;
                break;

              default:
                var clientWidth = outerRef.clientWidth,
                    scrollWidth = outerRef.scrollWidth;
                outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                break;
            }
          } else {
            outerRef.scrollLeft = scrollOffset;
          }
        } else {
          outerRef.scrollTop = scrollOffset;
        }
      }

      this._callPropsCallbacks();
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      if (this._resetIsScrollingTimeoutId !== null) {
        cancelTimeout(this._resetIsScrollingTimeoutId);
      }
    };

    _proto.render = function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          className = _this$props5.className,
          direction = _this$props5.direction,
          height = _this$props5.height,
          innerRef = _this$props5.innerRef,
          innerElementType = _this$props5.innerElementType,
          innerTagName = _this$props5.innerTagName,
          itemCount = _this$props5.itemCount,
          itemData = _this$props5.itemData,
          _this$props5$itemKey = _this$props5.itemKey,
          itemKey = _this$props5$itemKey === void 0 ? defaultItemKey$1 : _this$props5$itemKey,
          layout = _this$props5.layout,
          outerElementType = _this$props5.outerElementType,
          outerTagName = _this$props5.outerTagName,
          style = _this$props5.style,
          useIsScrolling = _this$props5.useIsScrolling,
          width = _this$props5.width;
      var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"

      var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
      var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;

      var _this$_getRangeToRend = this._getRangeToRender(),
          startIndex = _this$_getRangeToRend[0],
          stopIndex = _this$_getRangeToRend[1];

      var items = [];

      if (itemCount > 0) {
        for (var _index = startIndex; _index <= stopIndex; _index++) {
          items.push(React.createElement(children, {
            data: itemData,
            key: itemKey(_index, itemData),
            index: _index,
            isScrolling: useIsScrolling ? isScrolling : undefined,
            style: this._getItemStyle(_index)
          }));
        }
      } // Read this value AFTER items have been created,
      // So their actual sizes (if variable) are taken into consideration.


      var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
      return React.createElement(outerElementType || outerTagName || 'div', {
        className: className,
        onScroll: onScroll,
        ref: this._outerRefSetter,
        style: _extends$4({
          position: 'relative',
          height: height,
          width: width,
          overflow: 'auto',
          WebkitOverflowScrolling: 'touch',
          willChange: 'transform',
          direction: direction
        }, style)
      }, React.createElement(innerElementType || innerTagName || 'div', {
        children: items,
        ref: innerRef,
        style: {
          height: isHorizontal ? '100%' : estimatedTotalSize,
          pointerEvents: isScrolling ? 'none' : undefined,
          width: isHorizontal ? estimatedTotalSize : '100%'
        }
      }));
    };

    _proto._callPropsCallbacks = function _callPropsCallbacks() {
      if (typeof this.props.onItemsRendered === 'function') {
        var itemCount = this.props.itemCount;

        if (itemCount > 0) {
          var _this$_getRangeToRend2 = this._getRangeToRender(),
              _overscanStartIndex = _this$_getRangeToRend2[0],
              _overscanStopIndex = _this$_getRangeToRend2[1],
              _visibleStartIndex = _this$_getRangeToRend2[2],
              _visibleStopIndex = _this$_getRangeToRend2[3];

          this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
        }
      }

      if (typeof this.props.onScroll === 'function') {
        var _this$state2 = this.state,
            _scrollDirection = _this$state2.scrollDirection,
            _scrollOffset = _this$state2.scrollOffset,
            _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;

        this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
      }
    } // Lazily create and cache item styles while scrolling,
    // So that pure component sCU will prevent re-renders.
    // We maintain this cache, and pass a style prop rather than index,
    // So that List can clear cached styles and force item re-render if necessary.
    ;

    _proto._getRangeToRender = function _getRangeToRender() {
      var _this$props6 = this.props,
          itemCount = _this$props6.itemCount,
          overscanCount = _this$props6.overscanCount;
      var _this$state3 = this.state,
          isScrolling = _this$state3.isScrolling,
          scrollDirection = _this$state3.scrollDirection,
          scrollOffset = _this$state3.scrollOffset;

      if (itemCount === 0) {
        return [0, 0, 0, 0];
      }

      var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
      var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
      // If there isn't at least one extra item, tab loops back around.

      var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
      var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
      return [Math.max(0, startIndex - overscanBackward), Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)), startIndex, stopIndex];
    };

    return List;
  }(React.PureComponent), _class.defaultProps = {
    direction: 'ltr',
    itemData: undefined,
    layout: 'vertical',
    overscanCount: 2,
    useIsScrolling: false
  }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.

var validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
  var children = _ref2.children,
      direction = _ref2.direction,
      height = _ref2.height,
      layout = _ref2.layout,
      innerTagName = _ref2.innerTagName,
      outerTagName = _ref2.outerTagName,
      width = _ref2.width;
  var instance = _ref3.instance;

  if (process.env.NODE_ENV !== 'production') {
    if (innerTagName != null || outerTagName != null) {
      if (devWarningsTagName$1 && !devWarningsTagName$1.has(instance)) {
        devWarningsTagName$1.add(instance);
        console.warn('The innerTagName and outerTagName props have been deprecated. ' + 'Please use the innerElementType and outerElementType props instead.');
      }
    } // TODO Deprecate direction "horizontal"


    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';

    switch (direction) {
      case 'horizontal':
      case 'vertical':
        if (devWarningsDirection && !devWarningsDirection.has(instance)) {
          devWarningsDirection.add(instance);
          console.warn('The direction prop should be either "ltr" (default) or "rtl". ' + 'Please use the layout prop to specify "vertical" (default) or "horizontal" orientation.');
        }

        break;

      case 'ltr':
      case 'rtl':
        // Valid values
        break;

      default:
        throw Error('An invalid "direction" prop has been specified. ' + 'Value should be either "ltr" or "rtl". ' + ("\"" + direction + "\" was specified."));
    }

    switch (layout) {
      case 'horizontal':
      case 'vertical':
        // Valid values
        break;

      default:
        throw Error('An invalid "layout" prop has been specified. ' + 'Value should be either "horizontal" or "vertical". ' + ("\"" + layout + "\" was specified."));
    }

    if (children == null) {
      throw Error('An invalid "children" prop has been specified. ' + 'Value should be a React component. ' + ("\"" + (children === null ? 'null' : typeof children) + "\" was specified."));
    }

    if (isHorizontal && typeof width !== 'number') {
      throw Error('An invalid "width" prop has been specified. ' + 'Horizontal lists must specify a number for width. ' + ("\"" + (width === null ? 'null' : typeof width) + "\" was specified."));
    } else if (!isHorizontal && typeof height !== 'number') {
      throw Error('An invalid "height" prop has been specified. ' + 'Vertical lists must specify a number for height. ' + ("\"" + (height === null ? 'null' : typeof height) + "\" was specified."));
    }
  }
};

var FixedSizeList = /*#__PURE__*/createListComponent({
  getItemOffset: function getItemOffset(_ref, index) {
    var itemSize = _ref.itemSize;
    return index * itemSize;
  },
  getItemSize: function getItemSize(_ref2, index) {
    var itemSize = _ref2.itemSize;
    return itemSize;
  },
  getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
    var itemCount = _ref3.itemCount,
        itemSize = _ref3.itemSize;
    return itemSize * itemCount;
  },
  getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var direction = _ref4.direction,
        height = _ref4.height,
        itemCount = _ref4.itemCount,
        itemSize = _ref4.itemSize,
        layout = _ref4.layout,
        width = _ref4.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var size = isHorizontal ? width : height;
    var lastItemOffset = Math.max(0, itemCount * itemSize - size);
    var maxOffset = Math.min(lastItemOffset, index * itemSize);
    var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);

    if (align === 'smart') {
      if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) {
        align = 'auto';
      } else {
        align = 'center';
      }
    }

    switch (align) {
      case 'start':
        return maxOffset;

      case 'end':
        return minOffset;

      case 'center':
        {
          // "Centered" offset is usually the average of the min and max.
          // But near the edges of the list, this doesn't hold true.
          var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);

          if (middleOffset < Math.ceil(size / 2)) {
            return 0; // near the beginning
          } else if (middleOffset > lastItemOffset + Math.floor(size / 2)) {
            return lastItemOffset; // near the end
          } else {
            return middleOffset;
          }
        }

      case 'auto':
      default:
        if (scrollOffset >= minOffset && scrollOffset <= maxOffset) {
          return scrollOffset;
        } else if (scrollOffset < minOffset) {
          return minOffset;
        } else {
          return maxOffset;
        }

    }
  },
  getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
    var itemCount = _ref5.itemCount,
        itemSize = _ref5.itemSize;
    return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
  },
  getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
    var direction = _ref6.direction,
        height = _ref6.height,
        itemCount = _ref6.itemCount,
        itemSize = _ref6.itemSize,
        layout = _ref6.layout,
        width = _ref6.width;
    // TODO Deprecate direction "horizontal"
    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
    var offset = startIndex * itemSize;
    var size = isHorizontal ? width : height;
    var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
    return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
    ));
  },
  initInstanceProps: function initInstanceProps(props) {// Noop
  },
  shouldResetStyleCacheOnItemSizeChange: true,
  validateProps: function validateProps(_ref7) {
    var itemSize = _ref7.itemSize;

    if (process.env.NODE_ENV !== 'production') {
      if (typeof itemSize !== 'number') {
        throw Error('An invalid "itemSize" prop has been specified. ' + 'Value should be a number. ' + ("\"" + (itemSize === null ? 'null' : typeof itemSize) + "\" was specified."));
      }
    }
  }
});

var css_248z$b = ".styles-module_selectWrapper__O9gZW{max-width:100%;overflow:hidden}.styles-module_selectWrapper__O9gZW div{overflow:hidden}.styles-module_wrapper__BZtLR{margin-bottom:0;max-height:42px;max-width:100%}.styles-module_wrapper__BZtLR .styles-module_complex__wJiuT{text-overflow:ellipsis;white-space:nowrap}.styles-module_name__Ywh0G{color:var(--c-text-secondary);min-height:18px}";
var styles$8 = {"selectWrapper":"styles-module_selectWrapper__O9gZW","wrapper":"styles-module_wrapper__BZtLR","complex":"styles-module_complex__wJiuT","name":"styles-module_name__Ywh0G"};
styleInject(css_248z$b);

const Component$2 = ({ complex }) => {
    return (React.createElement("div", { className: styles$8.wrapper },
        React.createElement(Typography, { className: styles$8.complex, "data-test": 'request-apartment-content-apartment-name', variant: "primary" }, complex.text),
        React.createElement(Typography, { className: styles$8.name, variant: "small-alone", "data-test": 'request-apartment-content-apartment-developer' }, complex.developer)));
};
const ComplexCheckbox = React.memo(Component$2);

const Row = ({ index, style, itemData, is }) => {
    if (!itemData) {
        return null;
    }
    const complex = itemData[index];
    return (React__namespace.createElement("div", { className: styles$8.selectWrapper, style: style, "data-test": `request-apartment-content-row-${index}` },
        React__namespace.createElement(Select.Option, { value: complex.value, key: index, selected: is(complex.value) },
            React__namespace.createElement(ComplexCheckbox, { complex: complex }))));
};
const ITEM_SIZE = 60;
const MAX_HEIGHT = ITEM_SIZE * 4;
const getHeight = (length) => {
    const height = length * ITEM_SIZE;
    return height > MAX_HEIGHT ? MAX_HEIGHT : height;
};
const ApartmentsList = React__namespace.memo((props) => {
    const { apartments = [], is, filter } = props;
    if (apartments.length === 0 && filter === '')
        return React__namespace.createElement(Loader, null);
    return (React__namespace.createElement(FixedSizeList, { height: getHeight(apartments.length), itemCount: apartments.length, itemSize: ITEM_SIZE, itemData: apartments }, ({ index, style, data }) => React__namespace.createElement(Row, { index: index, style: style, is: is, itemData: data })));
});

const ApartmentComplexSelect = (props) => {
    const { dataTest = 'apartment-complex', size = 'l', readOnly, disabled, onChange, selected } = props;
    const [isOpen, setIsOpen] = React.useState(false);
    const { filter, updateFilter, apartments, is, handleChange, displayText } = useApartmentComplex({
        onChange,
        selected,
        resortToggle: !isOpen,
    });
    return (React.createElement(Select, { onChange: handleChange, onToggle: setIsOpen, mode: "multiple", dataTest: dataTest },
        React.createElement(Select.Button, { size: size, empty: !displayText, readonly: readOnly, disabled: disabled, label: displayText ? 'Жилой комплекс' : 'Выбрать жилой комплекс' }, displayText ? React.createElement("span", { "data-test": 'apartment-complex__selected' }, displayText) : displayText),
        React.createElement(Select.Content, { height: 308, bounds: true, container: props.containerRef },
            React.createElement(Select.Search, { value: filter, onChange: updateFilter, dataTest: "apartment-complex__search", placeholder: "\u0417\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A, \u0416\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441, \u0420\u0435\u0433\u0438\u043E\u043D" }),
            React.createElement(ApartmentsList, { apartments: apartments, is: is, filter: filter }))));
};

const mapApartments = (jsonBuildings, isClassified) => jsonBuildings.reduce((acc, building) => {
    var _a, _b, _c, _d;
    if ('complex' in building) {
        const { complex } = building;
        if (!complex.id || !((_a = complex.developer) === null || _a === void 0 ? void 0 : _a.id)) {
            return acc;
        }
        acc.push({
            id: complex.id,
            classifiedId: complex.externalIds['classifiedId'],
            developer: ((_b = complex.developer) === null || _b === void 0 ? void 0 : _b.name) || '',
            text: complex.name,
            city: ((_c = complex.location) === null || _c === void 0 ? void 0 : _c.regionName) || '',
            value: isClassified ? String(complex.externalIds.classifiedId) : String(complex.id),
            title: '',
            developerId: ((_d = complex.developer) === null || _d === void 0 ? void 0 : _d.id) || '',
            fullAddress: complex.address,
            source: complex.source,
        });
        return acc;
    }
    if (!building.id) {
        return acc;
    }
    acc.push({
        id: building.id,
        developer: building.developer,
        text: building.residentialComplexName,
        city: building.city,
        value: String(building.id),
        title: '',
        developerId: building.developerId,
        fullAddress: '',
        source: building.source,
    });
    return acc;
}, []);

const mapUsers = (user) => {
    var _a;
    const name = getFio(user.name);
    return { value: user.id, text: name, phone: (_a = user.contacts) === null || _a === void 0 ? void 0 : _a.phone, disabled: false };
};

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _state$entry;

  const [ref, setRef] = React__namespace.useState(null);
  const callback = React__namespace.useRef();
  const [state, setState] = React__namespace.useState({
    inView: !!initialInView,
    entry: undefined
  }); // Store the onChange callback in a `ref`, so we can access the latest instance
  // inside the `useEffect`, but without triggering a rerender.

  callback.current = onChange;
  React__namespace.useEffect(() => {
    // Ensure we have node ref, and that we shouldn't skip observing
    if (skip || !ref) return;
    let unobserve;
    unobserve = observe(ref, (inView, entry) => {
      setState({
        inView,
        entry
      });
      if (callback.current) callback.current(inView, entry);

      if (entry.isIntersecting && triggerOnce && unobserve) {
        // If it should only trigger once, unobserve the element after it's inView
        unobserve();
        unobserve = undefined;
      }
    }, {
      root,
      rootMargin,
      threshold,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
    return () => {
      if (unobserve) {
        unobserve();
      }
    };
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string, so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, ref, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  const entryTarget = (_state$entry = state.entry) == null ? void 0 : _state$entry.target;
  const previousEntryTarget = React__namespace.useRef();

  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    // If we don't have a node ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
    // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: undefined
    });
  }

  const result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

const useInfinityQuery = ({ listParams, intersectParams, queryAction, queryKey, filterParams, }) => {
    const { ref, inView } = useInView({ triggerOnce: true, ...intersectParams });
    const query = (params) => queryAction((params === null || params === void 0 ? void 0 : params.pageParam) || {
        pageRequest: listParams,
        searchCriteria: filterParams,
    });
    const queryConfig = React.useMemo(() => ({
        refetchOnWindowFocus: false,
        keepPreviousData: true,
        getNextPageParam: (lastPage) => {
            if (lastPage.page.hasNext)
                return {
                    pageRequest: { ...listParams, page: lastPage.page.number + 1 },
                    searchCriteria: filterParams,
                };
        },
    }), [listParams, filterParams]);
    const { data, error, fetchNextPage, hasNextPage, isFetching } = reactQuery.useInfiniteQuery([queryKey, listParams, filterParams], query, queryConfig);
    React.useEffect(() => {
        if (inView && hasNextPage) {
            fetchNextPage();
        }
    }, [inView, fetchNextPage, hasNextPage]);
    return { data, isLoading: isFetching, error, ref };
};

const useClientsList = (listParams, intersectParams) => {
    const { data, isLoading, error, ref } = useInfinityQuery({
        listParams,
        intersectParams,
        queryAction: getClientsList,
        queryKey: CLIENTS_QUERY,
    });
    return { data, isLoading, error, ref };
};

const useDisableBodyScroll = (condition) => {
    React.useEffect(() => {
        if (condition && (document === null || document === void 0 ? void 0 : document.documentElement)) {
            document.documentElement.style.overflow = 'hidden';
            return () => {
                document.documentElement.style.overflow = 'unset';
            };
        }
    }, [condition]);
};

const loadJSON$1 = (url) => () => axios.get(url).then((resp) => resp.data);
const useJsonBuildings = (params = {}) => {
    const { isForeignEnabled = true } = params || {};
    const { data: dataForeign, isLoading: isLoadingForeign } = reactQuery.useQuery(['jsonBuildingsForeign'], loadJSON$1(JSON_FOREIGN_BUILDINGS_URL), {
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        enabled: isForeignEnabled,
    });
    return { res: dataForeign, isLoading: isLoadingForeign };
};
const useGetJsonBuildingByIdOrName = ({ apartComplex, isForeignEnabled = true, }) => {
    const { residentialComplexName, id } = apartComplex;
    const { res } = useJsonBuildings({ isForeignEnabled });
    return React.useMemo(() => {
        if (!res)
            return null;
        if (id)
            return res.items.find((building) => building.id == id);
        if (residentialComplexName)
            return res.items.find((building) => (building === null || building === void 0 ? void 0 : building.residentialComplexName) === residentialComplexName);
        return null;
    }, [id, residentialComplexName, res]);
};
const useGetForeignJsonBuildingByIdOrName = ({ residentialComplexName, id, enabled = true, }) => {
    const { data: dataForeign, isLoading: isLoadingForeign } = reactQuery.useQuery(['jsonBuildingsForeign'], loadJSON$1(JSON_FOREIGN_BUILDINGS_URL), {
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        enabled: enabled,
    });
    const building = React.useMemo(() => {
        if (!dataForeign)
            return null;
        if (id)
            return dataForeign.items.find((building) => building.id == id);
        if (residentialComplexName)
            return dataForeign.items.find((building) => (building === null || building === void 0 ? void 0 : building.residentialComplexName) === residentialComplexName);
        return null;
    }, [dataForeign, id, residentialComplexName]);
    return { building, isLoading: isLoadingForeign };
};

const client$4 = axios.create();
client$4.defaults.paramsSerializer = querystring.encode;
client$4.defaults.baseURL = "/api/apartment-complex";

const mapMoneyToNumber = (money = {}) => {
    const { value, fraction = 100 } = money;
    if (!value) {
        return;
    }
    const normalizeValue = typeof value === 'string' ? Number.parseInt(value, 10) : value;
    return normalizeValue / fraction;
};

const isUndefined$1 = (value) => value == undefined;

const has$1 = (object, path) => {
	const subPaths = path.split('.');
	let hasPath = true;
	let obj = Object.assign({}, object);
	subPaths.forEach(subPath => {
		hasPath = obj && hasPath && Object.keys(obj).indexOf(subPath) > -1;
		obj = obj[subPath];
	});
	return hasPath;
};

const get$1 = (object, path) => {
	const subPaths = path.split('.');
	let value = Object.assign({}, object);
	subPaths.forEach(subPath => {
		value = (value && !isUndefined$1(value[subPath])) ? value[subPath] : undefined;
	});
	return value;
};


const set$1 =(object, path, value) => {
	let objectCopy = object;
	const subPaths = path.split('.');

	subPaths.forEach((subPath, index) => {
		if( !objectCopy[subPath] ) {
			objectCopy[subPath] = (index == subPaths.length -1) ? value : {};
		}
		objectCopy = objectCopy[subPath];
	});

	return object;
};

var objectHandler = {
	has: has$1,
	get: get$1,
	set: set$1,
	isUndefined: isUndefined$1
};

const get = objectHandler.get;
const set = objectHandler.set;
const has = objectHandler.has;
const isUndefined = objectHandler.isUndefined;

const setObjectValue = (template, key, value, transformedObject, originalObject) => {
	const defaultValue = template[key].default;
	const transform = template[key].transform;
	const omitValues = template[key].omitValues || [];
	let transformedValue = transform ? transform(value, transformedObject, originalObject) : value;

	if (isUndefined(transformedValue) && !isUndefined(defaultValue)) {
		transformedValue = defaultValue;
	}

	if(omitValues.indexOf(transformedValue) == -1) {
		return set(Object.assign({}, transformedObject), key, transformedValue);
	}

	return transformedObject;
};

const transformJson = (originalObject, template, afterTransform) => {
	const transformedObject = Object.keys(template).reduce((transformedJson, key) => {
		const path = Array.isArray(template[key].path) ?
			template[key].path.filter(path => has(originalObject, path))[0] : template[key].path;

		const value = path ? get(originalObject, path) : undefined;

		return setObjectValue(template, key, value, transformedJson, originalObject);
	}, {});
	return afterTransform ? afterTransform(transformedObject, originalObject) : transformedObject;
};

const mapTransform = (jsonArray, template, afterTransform) => jsonArray.map(originalObject => {
	const transformedObject = transform$1(originalObject, template);
	return afterTransform ? afterTransform(transformedObject, originalObject) : transformedObject;
});

const transform$1 = (json, template, afterTransform) =>
	Array.isArray(json) ? mapTransform(json, template, afterTransform) : transformJson(json, template, afterTransform);

var jsonMapTransform$1 = transform$1;

const transform = jsonMapTransform$1;

var jsonMapTransform = transform;

const roomTypeSetter = (flatRanges) => {
    if (!flatRanges || (flatRanges === null || flatRanges === void 0 ? void 0 : flatRanges.length) === 0)
        return [];
    const getReturnValue = (type, flat) => ({
        ...flat,
        rooms: { type: type, ...((flat === null || flat === void 0 ? void 0 : flat.rooms) ? flat.rooms : {}) },
    });
    return flatRanges.map((flat) => {
        var _a, _b, _c;
        if (typeof ((_a = flat.rooms) === null || _a === void 0 ? void 0 : _a.rooms) === 'number')
            return getReturnValue('room', flat);
        if (((_b = flat.rooms) === null || _b === void 0 ? void 0 : _b.free) !== undefined)
            return getReturnValue('free', flat);
        if (((_c = flat.rooms) === null || _c === void 0 ? void 0 : _c.studio) !== undefined)
            return getReturnValue('studio', flat);
        return flat;
    });
};
const tempalteRooms = {
    roomNumber: {
        path: 'rooms.rooms',
    },
    roomType: {
        path: 'rooms.type',
    },
    saleStatus: {
        path: 'saleStatus',
    },
    areaRange: {
        path: 'areaRange.range',
    },
    areaRangeUnit: {
        path: 'areaRange.unit',
        default: 'SQUARE_METER',
        omitValues: ['UNKNOWN'],
    },
    priceRange: {
        path: 'priceRange.range',
    },
    priceRangeCurrency: {
        path: 'priceRange.currency',
        default: 'RUB',
        omitValues: ['UNKNOWN_CURRENCY'],
    },
    unitPriceRange: {
        path: 'unitPriceRange.range',
    },
    unitPriceCurrency: {
        path: 'unitPriceRange.currency',
        default: 'RUB',
        omitValues: ['UNKNOWN_CURRENCY'],
    },
    unitPriceUnitType: {
        path: 'unitPriceRange.areaUnit',
        default: 'SQUARE_METER',
        omitValues: ['UNKNOWN'],
    },
};
const mapFlatsToView = (flatRanges) => {
    return jsonMapTransform(roomTypeSetter(flatRanges), tempalteRooms);
};

function transformPremisesInfoToInputs(premises) {
    if (premises === null || premises === void 0 ? void 0 : premises.present) {
        return {
            present: {
                count: premises.present.count,
            },
            absent: 'TRUE',
        };
    }
    if (!(premises === null || premises === void 0 ? void 0 : premises.present) && (premises === null || premises === void 0 ? void 0 : premises.absent)) {
        return {
            absent: 'FALSE',
        };
    }
    return {
        absent: 'UNKNOWN',
    };
}
function transformFlatRangesIntoInputs(flatRanges) {
    const res = [];
    if (!flatRanges || (flatRanges === null || flatRanges === void 0 ? void 0 : flatRanges.length) === 0)
        return [];
    flatRanges.forEach((flat) => {
        const { rooms, priceRange, areaRange, unitPriceRange, ...rest } = flat;
        const roomsTransformed = {
            type: 'rooms',
        };
        if (rooms === null || rooms === void 0 ? void 0 : rooms.rooms) {
            roomsTransformed['type'] = 'rooms';
            roomsTransformed['rooms'] = rooms.rooms;
        }
        else if (rooms === null || rooms === void 0 ? void 0 : rooms.studio) {
            roomsTransformed['type'] = 'studio';
        }
        else if (rooms === null || rooms === void 0 ? void 0 : rooms.free) {
            roomsTransformed['type'] = 'free';
        }
        res.push({
            ...rest,
            priceRange: priceRange
                ? {
                    ...priceRange,
                    currency: priceRange.currency,
                    range: {
                        from: {
                            value: mapMoneyToNumber(priceRange.range.from),
                        },
                        to: {
                            value: mapMoneyToNumber(priceRange.range.to),
                        },
                    },
                }
                : undefined,
            areaRange: areaRange
                ? {
                    ...areaRange,
                    unit: areaRange.unit,
                    range: {
                        from: areaRange.range.from,
                        to: areaRange.range.to,
                    },
                }
                : undefined,
            unitPriceRange: priceRange && (unitPriceRange === null || unitPriceRange === void 0 ? void 0 : unitPriceRange.range)
                ? {
                    ...unitPriceRange,
                    currency: priceRange.currency,
                    range: {
                        from: {
                            value: mapMoneyToNumber(unitPriceRange.range.from),
                        },
                        to: {
                            value: mapMoneyToNumber(unitPriceRange.range.to),
                        },
                    },
                }
                : undefined,
            rooms: roomsTransformed,
        });
    });
    return res;
}
function transformFlatAggregationDTOToInputs(flatAggregation = {}) {
    const { saleStatus, flatRanges } = flatAggregation;
    return {
        saleStatus,
        flatRanges: transformFlatRangesIntoInputs(flatRanges),
        flatRangesAsFlatsView: mapFlatsToView(flatRanges),
    };
}

var pluralRuExports = {};
var pluralRu = {
  get exports(){ return pluralRuExports; },
  set exports(v){ pluralRuExports = v; },
};

var slice = Array.prototype.slice;

function getPluralNoun(num) {
    var forms = slice.call(arguments, 1);

    var str;

    switch (forms.length) {
        case 1:
            throw new Error('Not enough forms');

        case 2:
            str = num > 1 ? forms[1] : forms[0];
            break;

        default:
            str = forms[getNounPluralForm(num)];
            break;
    }

    return str.replace(/%d/g, num);
}

function getPluralVerb(num) {
    var forms = slice.call(arguments, 1);
    var str = forms[getVerbPluralForm(num)];

    return str.replace(/%d/g, num);
}

function getVerbPluralForm(a) {
    if (a > 1000000) {
        return 2;
    }

    if (a > 1000 && a < 1000000 && /000$/.test(a)) {
        a /= 1000;
    }

    if (a % 10 === 1 && a % 100 !== 11 || /1000$/.test((a).toString())) {
        return 0;
    } else if (a % 10 >= 2 && a % 10 <= 4 && (a % 100 < 10 || a % 100 >= 20)) {
        return 1;
    } else {
        return 2;
    }
}

function getNounPluralForm(a) {
    if (a % 10 === 1 && a % 100 !== 11) {
        return 0;
    } else if (a % 10 >= 2 && a % 10 <= 4 && (a % 100 < 10 || a % 100 >= 20)) {
        return 1;
    } else {
        return 2;
    }
}

pluralRu.exports = getPluralNoun;
pluralRuExports.noun = getPluralNoun;
pluralRuExports.verb = getPluralVerb;

function convertToSelectOptions(dict) {
    const values = Object.keys(dict);
    return values.map((value) => ({ value, label: dict[value] }));
}

var css_248z$a = ".error-message-module_errorMessage__lXLQF p{margin:0}.error-message-module_title__gA8GV{font-weight:700}";
styleInject(css_248z$a);

var Feature;
(function (Feature) {
    Feature["ApproveByBank"] = "contract-kit-approve-by-bank";
    Feature["BirthCertificate"] = "dc-alternative-birth-certificate";
    Feature["LinkedDealsTab"] = "sbr-linked-deals-tab";
    Feature["DealNavigation"] = "dc-deal-navigation";
    Feature["ElectronicMortgage"] = "alternative-electronic-mortgage-available";
    Feature["SuburbanDeals"] = "alternative-suburban-deals";
})(Feature || (Feature = {}));
React.createContext(null);

const checkboxSelectTypeOptions = {
    UNKNOWN: 'Неизвестно',
    FALSE: 'Нет',
    TRUE: 'Да',
};
const checkboxSelectTypeKeys = {
    UNKNOWN: 'UNKNOWN',
    FALSE: 'FALSE',
    TRUE: 'TRUE',
};
convertToSelectOptions(checkboxSelectTypeOptions);
const commonSaleStatusOptions = {
    UNKNOWN_SALE_STATUS: 'Неизвестный',
    SOON: 'Скоро в продаже',
    ON_SALE: 'Продается',
    SOLD_OUT: 'Все продано',
    TEMPORARY_NOT_ON_SALE: 'Временно не в продаже',
};
const currencyOptions = {
    RUB: 'RUB',
    USD: 'USD',
    EUR: 'EUR',
};
({
    saleStatus: convertToSelectOptions(commonSaleStatusOptions),
    currency: convertToSelectOptions(currencyOptions),
});

const transformBoolIntoSelect = (bool) => {
    switch (bool) {
        case true: {
            return 'TRUE';
        }
        case false: {
            return 'FALSE';
        }
        default: {
            return 'UNKNOWN';
        }
    }
};

const getParkingsInitValues = () => [
    { openParking: { select: checkboxSelectTypeKeys.FALSE } },
    { closedParking: { select: checkboxSelectTypeKeys.FALSE } },
    { undergroundParking: { select: checkboxSelectTypeKeys.FALSE } },
];

const mapRealtyObjectsFromDTO = (realtyObjects, complex) => {
    let isAlreadyUsedForApartmentAddress = false;
    return realtyObjects.map(({ id, realEstateId, address, cadastral, area }) => {
        const isUsedForApartmentAddress = complex.address && !isAlreadyUsedForApartmentAddress && complex.address === address ? true : false;
        if (isUsedForApartmentAddress) {
            isAlreadyUsedForApartmentAddress = true;
        }
        return { id, realEstateId, address, cadastral, area, isUsedForApartmentAddress };
    });
};
const mapDetailsFromDTO = (details = {}) => {
    const { livingFlatsInfo = {}, apartmentsInfo = {}, ...rest } = details;
    return {
        livingFlatsInfo: transformPremisesInfoToInputs(livingFlatsInfo),
        apartmentsInfo: transformPremisesInfoToInputs(apartmentsInfo),
        ...rest,
    };
};
const mapBooleanToEnum = (obj) => {
    const entries = Object.entries(obj);
    return entries.reduce((acc, [key, val]) => {
        acc[key] = transformBoolIntoSelect(val);
        return acc;
    }, {});
};
const transformParkingsIntoSelect = (parkings = []) => {
    const res = getParkingsInitValues();
    parkings.forEach((parking) => {
        const entries = Object.entries(parking);
        for (const [parking, value] of entries) {
            if (value === null || value === void 0 ? void 0 : value.places) {
                const idx = res.findIndex((p) => Object.keys(p)[0] === parking);
                if (idx !== -1) {
                    res[idx][parking] = { select: 'TRUE', places: value.places };
                }
            }
        }
    });
    return res;
};
const mapIfrastructureFromDTO = (infrastructure = {}) => {
    const { parkings = [], carFreeCourtyard, closedArea, concierge, guardedArea, schoolInProject, kindergartenInProject, barrierFreeEnv, subway, busStop, shop, pharmacy, hospital, fitness, school, kindergarten, } = infrastructure;
    return {
        parkings: transformParkingsIntoSelect(parkings),
        ...mapBooleanToEnum({
            carFreeCourtyard,
            closedArea,
            concierge,
            guardedArea,
            schoolInProject,
            kindergartenInProject,
            barrierFreeEnv,
            subway,
            busStop,
            shop,
            pharmacy,
            hospital,
            fitness,
            school,
            kindergarten,
        }),
    };
};
const mapSellConditionsFromDTO = (sellConditions = {}) => {
    const { law214, mortgageTypes = {}, contractTypes = {}, paymentType = {}, escrow } = sellConditions;
    const { itMortgage, promotion, armyMortgage, stateProgram, mortgageWithoutDownPayment, oneRubleMortgage, countyMortgage, familyMortgage, developerSubsidy, } = mortgageTypes;
    const { ddu, dkp, dupt } = contractTypes;
    const { mortgage, installment, subsidy } = paymentType;
    return {
        law214: transformBoolIntoSelect(law214),
        escrow: transformBoolIntoSelect(escrow),
        mortgageTypes: mapBooleanToEnum({
            itMortgage,
            promotion,
            armyMortgage,
            stateProgram,
            mortgageWithoutDownPayment,
            oneRubleMortgage,
            countyMortgage,
            familyMortgage,
            developerSubsidy,
        }),
        contractTypes: mapBooleanToEnum({ ddu, dkp, dupt }),
        paymentType: mapBooleanToEnum({ mortgage, installment, subsidy }),
    };
};
const mapFeaturesFromDTO = (features = {}) => {
    const { waterfront, panoramicWindows, nearPark, terraces, twoStoreyFlats, waterside } = features;
    return mapBooleanToEnum({
        waterfront,
        panoramicWindows,
        nearPark,
        terraces,
        twoStoreyFlats,
        waterside,
    });
};
const mapRealtorCommissionFromDTO = (commission = {}) => {
    const { commissionRange, advancePayment } = commission;
    return {
        advancePayment: transformBoolIntoSelect(advancePayment),
        commissionRange,
    };
};
const mapGalleryFromDTO = (gallery) => {
    if (!gallery)
        return [];
    const images = [];
    if (gallery) {
        if (gallery.main) {
            images.push({
                ...gallery.main,
                type: 'MAIN',
            });
        }
    }
    gallery === null || gallery === void 0 ? void 0 : gallery.photo.forEach((photo) => {
        photo.image.forEach((typeImage) => {
            images.push({
                type: photo.type,
                ...typeImage,
            });
        });
    });
    return images;
};
const mapSubwayRoutesFromDTO = (subwayRoutes) => {
    if (!(subwayRoutes === null || subwayRoutes === void 0 ? void 0 : subwayRoutes.routes)) {
        return { routes: [] };
    }
    return {
        routes: subwayRoutes.routes.sort((a, b) => {
            return a.minutes - b.minutes;
        }),
    };
};
const mapApartmentComplexFromDTO = (complex) => {
    const { id, name, comment, externalIds, type, aliases, location, subwayRoutes, realtyObjects, details, sellConditions, address, documents = [], infrastructure, features, realtorCommission, developerLegalCompany, flatsAggregation, developer, gallery, } = complex;
    return {
        id,
        name,
        comment,
        externalIds,
        type,
        aliases,
        subwayRoutes: mapSubwayRoutesFromDTO(subwayRoutes),
        realtyObjects: mapRealtyObjectsFromDTO(realtyObjects, complex),
        details: mapDetailsFromDTO(details),
        sellConditions: mapSellConditionsFromDTO(sellConditions),
        infrastructure: mapIfrastructureFromDTO(infrastructure),
        features: mapFeaturesFromDTO(features),
        realtorCommission: mapRealtorCommissionFromDTO(realtorCommission),
        address,
        documents,
        developerLegalCompany,
        flatsAggregation: transformFlatAggregationDTOToInputs(flatsAggregation),
        developer,
        images: mapGalleryFromDTO(gallery),
        location,
    };
};

const mapApartmentComplexesListFromDTO = (list) => {
    const result = {
        page: list.page,
        complexes: list.data.map(mapApartmentComplexWithActionsFromDTO),
    };
    return {
        ...result,
        data: result.complexes,
    };
};
const mapApartmentComplexWithActionsFromDTO = (developerWithActions) => {
    const { apartmentComplex, actions } = developerWithActions;
    return {
        actions,
        complex: mapApartmentComplexFromDTO(apartmentComplex),
    };
};

const COMPLEXES_PER_PAGE = 10;
const mapRoomsToRoomCount = (rooms) => {
    return {
        studio: rooms.includes('STUDIO') ? {} : undefined,
        openPlan: rooms.includes('OPEN_PLAN') ? {} : undefined,
        roomCountIn: {
            counts: rooms.flatMap((item) => {
                switch (item) {
                    case '1_RM':
                        return [1];
                    case '2_RM':
                        return [2];
                    case '3_RM':
                        return [3];
                    case '4_RM':
                        return [4];
                    case '5+_RM':
                        return [5, 6, 7, 8, 9, 10];
                    default:
                        return [];
                }
            }),
        },
    };
};
const mapComplexesListQueryToDTO = (query) => {
    const { page = 0, size = COMPLEXES_PER_PAGE, searchText = '', classifiedIds = [], developerIds = [], regionIds = [], complexTypes = [], rooms = [], } = query;
    const searchQuery = {
        searchText,
        classifiedIdIn: classifiedIds.length
            ? {
                classifiedIds,
            }
            : undefined,
        developerIdIn: developerIds.length
            ? {
                developerIds,
            }
            : undefined,
        regionIdIn: regionIds.length
            ? {
                regionIds,
            }
            : undefined,
        complexTypeIn: complexTypes.length
            ? {
                types: complexTypes,
            }
            : undefined,
        roomCount: mapRoomsToRoomCount(rooms),
    };
    return {
        pageRequest: {
            page,
            size,
        },
        searchQuery,
    };
};

const client$3 = axios.create();
client$3.defaults.paramsSerializer = querystring.encode;
client$3.defaults.baseURL = "/api/apartment-complex";
async function list({ data, headers, cancelToken }) {
    const result = await client$3({
        method: "post",
        url: `/v1/apartment-complexes/list`,
        data,
        headers,
        cancelToken
    });
    return result.data;
}

const client$2 = axios.create();
client$2.defaults.paramsSerializer = querystring.encode;
client$2.defaults.baseURL = "/api/apartment-complex";

const getComplexesList = async (query) => {
    const complexes = await list({
        data: mapComplexesListQueryToDTO(query),
    });
    return mapApartmentComplexesListFromDTO(complexes);
};

const client$1 = axios.create();
client$1.defaults.paramsSerializer = querystring.encode;
client$1.defaults.baseURL = "/api/apartment-complex";

const client = axios.create();
client.defaults.paramsSerializer = querystring.encode;
client.defaults.baseURL = "/api/apartment-complex";

var root = _root;

/* Built-in method references for those with the same name as other `lodash` methods. */
root.isFinite;

const loadJSON = (url) => () => axios.get(url).then((resp) => mapApartments(resp.data.items));
const useApartments = (isForeignEnabled, isClassified) => {
    const { data = [], isLoading } = reactQuery.useQuery({
        queryKey: ['AcApartments'],
        queryFn: async () => {
            const list = await getComplexesList({ page: 0, size: 1000 });
            assert(list, 'Ошибка получения списка строящихся объектов');
            return mapApartments(list.complexes, isClassified);
        },
        staleTime: Infinity,
    });
    const { data: dataForeign = [], isLoading: isLoadingForeign } = reactQuery.useQuery({
        queryKey: ['jsonBuildingsForeignApartment'],
        queryFn: loadJSON(JSON_FOREIGN_BUILDINGS_URL),
        staleTime: Infinity,
    });
    const resp = React.useMemo(() => [...(dataForeign || []), ...(data || [])], [dataForeign, data]);
    if (isForeignEnabled)
        return { data: resp, isLoading: isLoading && isLoadingForeign };
    return { data, isLoading };
};

const useUsers = ({ onChange }) => {
    const { data, isLoading, error, ref } = useClientsList({ page: 0, size: 10 });
    const selectOptions = React.useMemo(() => {
        var _a;
        return data ? flatten_1((_a = data.pages) === null || _a === void 0 ? void 0 : _a.map((user) => user === null || user === void 0 ? void 0 : user.clientList.map(mapUsers))) : [];
    }, [data]);
    const { is, handleChange, selectedText } = useSelect(onChange, { texts: selectOptions });
    const handleChangeWithGTM = React.useCallback((value, _, evt) => {
        pushToGTM(GTMMap.CLIENTS.click_on_client);
        handleChange(value, _, evt);
    }, [handleChange]);
    return {
        selectedText,
        handleChange: handleChangeWithGTM,
        is,
        users: selectOptions,
        ref,
        pages: data === null || data === void 0 ? void 0 : data.pages,
        error,
        isLoading,
    };
};

var css_248z$9 = ".styles-module_wrapper__CFyho{margin-bottom:0}.styles-module_phone__1-vxh{color:var(--c-text-secondary);margin-top:var(--padding-xxs)}";
var styles$7 = {"wrapper":"styles-module_wrapper__CFyho","phone":"styles-module_phone__1-vxh"};
styleInject(css_248z$9);

const SelectOption = ({ user, triggerElementRef }) => {
    return (React.createElement("div", { className: styles$7.wrapper, ref: triggerElementRef },
        React.createElement(Typography, { variant: "primary" }, user.text),
        React.createElement(Typography, { className: styles$7.phone, variant: "small-alone" }, user.phone && formatTelephone(user.phone))));
};

const Wrapper = ({ children, handleChange, dataTest, size, selectedText }) => {
    return (React.createElement(Select, { onChange: handleChange, mode: "single", dataTest: dataTest || 'user-select-test' },
        React.createElement(Select.Button, { size: size || 'l', empty: !selectedText, label: selectedText ? 'ФИО клиента' : 'Выбрать клиента' }, selectedText),
        React.createElement(Select.Content, { height: 320, bounds: true }, children)));
};

const emptyMessage = 'Список клинтов пока пуст';
const emptyList = { value: emptyMessage, text: emptyMessage, disabled: true, phone: '' };
const errorMessage = 'Не удалось загрузить список';
const errorList = { value: errorMessage, text: errorMessage, disabled: true, phone: '' };

const UserSelect = (props) => {
    const { users, selectedText, handleChange, is, ref, pages, error, isLoading } = useUsers({
        onChange: props.onChange,
    });
    const isDataEmpty = !(pages === null || pages === void 0 ? void 0 : pages[0].clientList.length);
    if (error || (!isLoading && isDataEmpty)) {
        const message = error ? errorList : emptyList;
        return (React.createElement(Wrapper, { handleChange: handleChange, dataTest: props.dataTest, size: props.size, selectedText: selectedText },
            React.createElement(Select.Option, { value: message.value, key: message.value, selected: is(message.value), disabled: message.disabled },
                React.createElement(SelectOption, { user: message }))));
    }
    return (React.createElement(Wrapper, { handleChange: handleChange, dataTest: props.dataTest, size: props.size, selectedText: selectedText }, pages === null || pages === void 0 ? void 0 : pages.map((page, pageIndex) => {
        var _a;
        return (_a = page === null || page === void 0 ? void 0 : page.clientList) === null || _a === void 0 ? void 0 : _a.map((userRaw, index) => {
            const user = mapUsers(userRaw);
            const userIndex = (index + 1) * (pageIndex + 1);
            const isTargetRef = users.length === userIndex;
            return (React.createElement(Select.Option, { value: user.value, key: user.value, selected: is(user.value), disabled: user.disabled },
                React.createElement(SelectOption, { user: user, triggerElementRef: isTargetRef ? ref : null })));
        });
    })));
};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return stringify(rnds);
}

const DEFAULT_ACCEPTED_FILE_FORMATS = ['.pdf', '.doc', '.docx', '.png', '.jpg', '.jpeg', '.zip', '.rar'];
const DEFAULT_MAX_FILE_SIZE = 15 * 1024 * 1024;
const RHFFileUploadField = (props) => {
    var _a;
    const { disabled = false, className, maxFileSize = DEFAULT_MAX_FILE_SIZE, acceptedFileFormats = DEFAULT_ACCEPTED_FILE_FORMATS, orderId, control, name, fileType, isReverse, size, } = props;
    const { fields, remove, append, update } = useFieldArray({
        control,
        name,
    });
    const { errors } = useFormState({
        control,
        name,
    });
    const handleDrop = React.useCallback(async (uploadingFiles) => {
        if (uploadingFiles.length === 0)
            return;
        uploadingFiles.forEach(async (file, indexItem) => {
            const index = fields.length + indexItem;
            const fileData = {
                id: 'initial_id_' + v4(),
                status: 'LOADING',
                type: fileType,
                name: file.name,
                file: file,
                orderId,
            };
            append(fileData);
            try {
                const response = await uploadOrderFile({ file, orderId, type: fileType });
                if (response)
                    update(index, {
                        ...fileData,
                        documentStorageId: response.id,
                        originalName: response.originalFileName,
                        status: 'UPLOADED',
                    });
                else
                    remove(index);
            }
            catch (_e) {
                update(index, {
                    ...fileData,
                    status: 'ERROR',
                });
            }
        });
    }, [fields, update, append, remove, fileType, orderId]);
    const handleDownload = React.useCallback(async (fileData) => {
        let url;
        if (fileData.file) {
            url = getUrlForUnsavedFile(fileData.file);
        }
        else {
            url = await getDownloadFileUrl({ fileId: fileData.id, orderId: orderId });
        }
        if (url) {
            triggerUrlDownload(url, fileData.name);
        }
    }, [orderId]);
    const handleDelete = React.useCallback((index) => {
        remove(index);
    }, [remove]);
    return (React.createElement(FileUploader, { size: size, maxSize: maxFileSize, accept: acceptedFileFormats, noDragEventsBubbling: true, onDropAccepted: handleDrop, showUploadArea: true, multiple: true, isReverse: isReverse, values: fields, onDelete: handleDelete, onDownload: handleDownload, disabled: disabled, className: className, errorMessage: (_a = errors[name]) === null || _a === void 0 ? void 0 : _a.message.toString(), withDivider: true, withoutContextMenu: true, withoutDownloadOnClick: true, withFileSize: true }));
};

const SelectSingleField = (props) => {
    return React.createElement(FormInputField, { Component: SingleSelect, ...props });
};

const Field$2 = (commonOptions) => {
    return (React.createElement(FormInputField, { name: "developersWithComplex", Component: ApartmentComplexSelect, label: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0436\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441", dataTest: "request-apartment", ...commonOptions }));
};
const ApartmentSelectField = React.memo(Field$2);

var css_248z$8 = ".styles-module_mobileWrapper__-ug5a{margin-bottom:16px}.styles-module_mobileWrapper__-ug5a>div{padding:12px}.styles-module_mobileWrapperHeader__i3CdY{margin-bottom:8px}";
var styles$6 = {"mobileWrapper":"styles-module_mobileWrapper__-ug5a","mobileWrapperHeader":"styles-module_mobileWrapperHeader__i3CdY"};
styleInject(css_248z$8);

const Field$1 = (commonOptions) => {
    return (React.createElement("div", { className: styles$6.mobileWrapper },
        React.createElement(Paper, { isShaded: false, roundLevel: 1, isRounded: true },
            React.createElement("div", { className: styles$6.mobileWrapperHeader },
                React.createElement(Typography, { variant: "h4" }, "\u0416\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441")),
            React.createElement(FormInputField, { name: "developersWithComplex", Component: (props) => (React.createElement(ApartmentComplexSelect, { ...props, containerRef: commonOptions.containerRef })), label: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0436\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441", dataTest: "request-apartment", ...commonOptions }))));
};
const ApartmentSelectFieldMobile = React.memo(Field$1);

const Component$1 = ({ isSubmitDisable, isSubmitting, onReset }) => {
    return (React.createElement(Modal.Actions, null,
        React.createElement(Button$3, { "data-test": `request-modal-cancel`, variant: "secondary", type: "reset", onClick: onReset, disabled: isSubmitting, block: true }, "\u041E\u0442\u043C\u0435\u043D\u0430"),
        React.createElement(SubmitButton, { "data-test": `request-modal-submit`, dataTest: "requestModalSubmit", disabled: isSubmitDisable, isSubmitting: isSubmitting }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C")));
};
const ActionSection = React.memo(Component$1);

const Field = (commonOptions) => {
    return (React.createElement(FormInputField, { name: "leadClientId", Component: UserSelect, dataTest: "request-client-select", ...commonOptions }));
};
const ClientSelectField = React.memo(Field);

var css_248z$7 = ".styles-module_modal__VUkw0{max-width:480px}.styles-module_fieldsWrapper__CLM7z>div{margin-bottom:12px}.styles-module_actionButtonsWrapper__JUyKz{margin-top:24px}.styles-module_agree__-zU-H{margin-bottom:16px}@media screen and (max-width:767px){.styles-module_agree__-zU-H{margin-bottom:5vh}}.styles-module_link__lhD5J{color:#3416b6;cursor:pointer;margin-bottom:8px;margin-top:-8px;width:-moz-max-content;width:max-content}@media screen and (max-width:959px){.styles-module_link__lhD5J{margin-bottom:0}}.styles-module_subTitle__Y-XPj{margin-bottom:24px}.styles-module_mobileWrapper__qJO2j{margin-bottom:16px}.styles-module_mobileWrapper__qJO2j>div{padding:12px}.styles-module_mobileWrapperHeader__-hhZy{margin-bottom:8px}.styles-module_formContentWrapper__utC4w,.styles-module_form__43Rb1{height:100%}@media screen and (max-width:767px){div[data-test=requestModal]{background-color:#f8f8fc}div[data-test=requestModal-header]{background-color:#fff}div[data-test=requestModal-actions]{background-color:#f8f8fc;bottom:0;display:flex;padding:8px 0;position:fixed;width:calc(100vw - 32px);z-index:5}}div[data-test=requestModal-content]{overflow-y:auto!important}@media screen and (max-width:767px){div[data-test=requestModal-content]{height:100%;max-height:calc(95vh - 130px)!important;padding-bottom:5vh;padding-top:16px}}.styles-module_realtorWrapper__FvYyY{margin-bottom:24px}.styles-module_realtorInputs__PzxoS{display:flex;flex-direction:column;gap:12px;margin-top:12px}.styles-module_notion__daJVU{background-color:#fee7a9;border-radius:4px;font:400 16px/24px ALS Hauss,Tahoma,Helvetica Neue,Arial,sans-serif;margin-bottom:12px;padding:8px}.styles-module_beacon__MS-9l{z-index:102!important}[class*=modal-module-scrollable]{overflow-x:hidden!important;overflow-y:auto!important}";
var styles$5 = {"modal":"styles-module_modal__VUkw0","fieldsWrapper":"styles-module_fieldsWrapper__CLM7z","actionButtonsWrapper":"styles-module_actionButtonsWrapper__JUyKz","agree":"styles-module_agree__-zU-H","link":"styles-module_link__lhD5J","subTitle":"styles-module_subTitle__Y-XPj","mobileWrapper":"styles-module_mobileWrapper__qJO2j","mobileWrapperHeader":"styles-module_mobileWrapperHeader__-hhZy","form":"styles-module_form__43Rb1","formContentWrapper":"styles-module_formContentWrapper__utC4w","realtorWrapper":"styles-module_realtorWrapper__FvYyY","realtorInputs":"styles-module_realtorInputs__PzxoS","notion":"styles-module_notion__daJVU","beacon":"styles-module_beacon__MS-9l"};
styleInject(css_248z$7);

const Component = ({ isCreateClient, commonOptions, setIsCreateClient, isMobile, GTMPrefix, }) => {
    const toggle = React.useCallback(() => {
        !isCreateClient && pushToGTM(GTMMap.CLIENTS.new_client(GTMPrefix));
        setIsCreateClient((state) => !state);
    }, [GTMPrefix, isCreateClient, setIsCreateClient]);
    const description = isCreateClient ? 'Выбрать клиента из списка' : 'Создать нового клиента';
    const MainContent = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles$5.link, "data-test": 'create_or_select_client_modal', onClick: toggle }, description),
        React.createElement("div", { className: styles$5.fieldsWrapper, "data-test": isCreateClient ? 'select-customer' : 'create-customer-fields' }, isCreateClient ? (React.createElement(ClientFields, { ...commonOptions, namePrefix: "leadClientData" })) : (React.createElement(ClientSelectField, { ...commonOptions })))));
    if (!isMobile)
        return MainContent;
    return (React.createElement("div", { className: styles$5.mobileWrapper },
        React.createElement(Paper, { isShaded: false, roundLevel: 1, isRounded: true },
            React.createElement("div", { className: styles$5.mobileWrapperHeader },
                React.createElement(Typography, { variant: "h4" }, "\u041A\u043B\u0438\u0435\u043D\u0442")),
            MainContent)));
};
const ClientSection = React.memo(Component);

const RealtorForm = (props) => {
    return (React.createElement("div", { className: styles$5.realtorWrapper, "data-test": 'realty-contacts' },
        React.createElement(Typography, { bold: true, variant: 'h4' }, "\u0412\u0430\u0448\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u044B\u0435 \u0434\u0430\u043D\u043D\u044B\u0435"),
        React.createElement(Typography, { color: 'secondary' }, "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0438\u0445 \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C"),
        React.createElement("div", { className: styles$5.realtorInputs },
            React.createElement(FormInputField, { name: `realtorContactData.contacts.phone`, Component: PhoneInput, label: "\u0422\u0435\u043B\u0435\u0444\u043E\u043D", required: true, ...props }),
            React.createElement(FormInputField, { name: `realtorContactData.contacts.email`, label: "\u042D\u043B. \u043F\u043E\u0447\u0442\u0430", required: true, ...props }))));
};

const useSteps = (isCreateClient) => {
    return React.useMemo(() => [
        !isCreateClient && {
            target: '[data-test="create_or_select_client_modal"]',
            content: (React.createElement("span", null,
                "\u0415\u0441\u043B\u0438 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0435\u0449\u0451 \u043D\u0435\u0442 \u0432 \u0432\u0430\u0448\u0435\u0439 \u0431\u0430\u0437\u0435, \u0441\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u043E\u0433\u043E.",
                React.createElement("br", null),
                React.createElement("b", null, "\u0412\u0430\u0436\u043D\u043E:"),
                " \u0443\u043A\u0430\u0436\u0438\u0442\u0435 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430.")),
            title: 'Создание клиента',
        },
        !isCreateClient && {
            target: '[data-test="request-client-select-button"]',
            content: 'Если вы уже вносили данные клиента, выберите его из списка.',
            title: 'Выбор клиента',
        },
        {
            target: '[data-test="request-apartment-button"]',
            content: 'Не нужно выбирать все ЖК — в основном застройщики фиксируют клиента сразу на все свои объекты.',
            title: 'Выбор ЖК',
        },
        {
            target: '[data-test="realty-contacts"]',
            content: 'Проверьте актуальность данных — так менеджер М2 сможет связаться с вами по важным вопросам.',
            title: 'Контактные данные',
        },
    ].filter(Boolean), [isCreateClient]);
};

const OrdersModal = (props) => {
    var _a, _b;
    const { opened, onClose, selectedApartments, profileId, GTMPrefix, toastType, showOnboarding, isClassified } = props;
    const [isCreateClient, setIsCreateClient] = React__namespace.useState(false);
    const formContentRef = React__namespace.useRef(null);
    const { data: apartments } = useApartments(props.isForeignEnabled, isClassified);
    const { isMobile } = useDeviceMediaType();
    const { onSubmit, onReset, commonOptions, control, errors, isSubmitDisable, isSubmitting } = useRequestForm({
        onClose,
        isCreateClient,
        setIsCreateClient,
        selected: selectedApartments,
        profileId,
        apartments,
        toastType,
    });
    const steps = useSteps(isCreateClient);
    const onCloseAction = React__namespace.useCallback((event) => {
        pushToGTM(GTMMap.CLIENTS.close_creation);
        setIsCreateClient(false);
        onReset(event);
    }, [onReset, setIsCreateClient]);
    const isApartmentsDisabled = ((_a = commonOptions.selected) === null || _a === void 0 ? void 0 : _a[0]) && props.isSingleApartment;
    return (React__namespace.createElement(Modal, { opened: opened, onClose: onCloseAction, size: "s", closable: true, mobile: true, overflow: false, dataTest: "requestModal", "data-scroll-lock-ignore": true },
        React__namespace.createElement(RequestModalContext.Provider, { value: { apartments: apartments } },
            React__namespace.createElement("form", { onSubmit: onSubmit, "data-test": "requestForm", className: styles$5.form },
                isMobile ? (React__namespace.createElement(Modal.Header, null, "\u0417\u0430\u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043B\u0438\u0435\u043D\u0442\u0430")) : (React__namespace.createElement(Modal.Title, null, "\u041D\u043E\u0432\u0430\u044F \u0437\u0430\u044F\u0432\u043A\u0430")),
                React__namespace.createElement("div", { ref: formContentRef, className: styles$5.formContentWrapper },
                    React__namespace.createElement(Modal.Content, { scrollable: true },
                        !isMobile && (React__namespace.createElement(Typography, { className: styles$5.subTitle }, "\u041E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043D\u043E\u0432\u0443\u044E \u0437\u0430\u044F\u0432\u043A\u0443 \u043D\u0430 \u0444\u0438\u043A\u0441\u0430\u0446\u0438\u044E \u043A\u043B\u0438\u0435\u043D\u0442\u0430")),
                        React__namespace.createElement(ClientSection, { isMobile: isMobile, isCreateClient: isCreateClient, commonOptions: commonOptions, setIsCreateClient: setIsCreateClient, GTMPrefix: GTMPrefix }),
                        React__namespace.createElement("div", { className: styles$5.notion }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0443\u0436\u043D\u044B\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0443 \u0416\u041A, \u0430 \u043C\u044B \u0437\u0430\u00AD\u0444\u0438\u043A\u00AD\u0441\u0438\u00AD\u0440\u0443\u00AD\u0435\u043C \u0435\u0433\u043E \u043D\u0430 \u0432\u0441\u0435 \u043E\u0431\u044A\u00AD\u0435\u043A\u00AD\u0442\u044B \u0437\u0430\u0441\u00AD\u0442\u0440\u043E\u0439\u00AD\u0449\u0438\u00AD\u043A\u0430 \u0438\u0437 \u043A\u0430\u00AD\u0442\u0430\u00AD\u043B\u043E\u00AD\u0433\u0430 M2Pro \u041D\u043E\u0432\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0438"),
                        isMobile ? (React__namespace.createElement(ApartmentSelectFieldMobile, { ...commonOptions, readOnly: isApartmentsDisabled, containerRef: formContentRef })) : (React__namespace.createElement(ApartmentSelectField, { ...commonOptions, readOnly: isApartmentsDisabled })),
                        React__namespace.createElement("div", { className: styles$5.actionButtonsWrapper }, isCreateClient && (React__namespace.createElement("div", { className: styles$5.agree },
                            React__namespace.createElement(AgreementCheckbox, { namePrefix: "leadClientData", dataTest: "clientAgreement", control: control, hasError: !!((_b = errors === null || errors === void 0 ? void 0 : errors.leadClientData) === null || _b === void 0 ? void 0 : _b.consentIsGiven) })))),
                        React__namespace.createElement(RealtorForm, { ...commonOptions }))),
                React__namespace.createElement(ActionSection, { isSubmitDisable: isSubmitDisable, isSubmitting: isSubmitting, onReset: onCloseAction })),
            showOnboarding && (React__namespace.createElement(Onboarding, { steps: steps, commonGtmTag: 'request-modal', lsKey: 'request-modal', commonGtmEvent: 'm2_pro_events', beaconClassname: styles$5.beacon, awaitBeforeStart: 500, disableUsedesckAttachBeacon: isMobile })))));
};

var css_248z$6 = ".styles-module_wrapper__pqAgB button>div>div:first-of-type{color:var(--c-text-minor)}.styles-module_error__86ICV span:first-of-type>i>svg{color:var(--c-error)!important}.styles-module_error__86ICV span>div,.styles-module_error__86ICV span>div>div:before{background-color:var(--c-error)!important}.styles-module_error__86ICV button{border-color:var(--c-error)}.styles-module_error__86ICV button:hover{border-color:var(--c-error)!important}";
var styles$4 = {"wrapper":"styles-module_wrapper__pqAgB","error":"styles-module_error__86ICV"};
styleInject(css_248z$6);

const SingleSelect = (props) => {
    const { label, options, size, defaultText = '', dataTest } = props;
    const { isMobile } = useDeviceMediaType();
    const { is, handleChange, selectedText } = useSelect(props.onChange, { selected: props.defaultValue, texts: options });
    return (React.createElement("div", { className: cn(styles$4.wrapper, { [styles$4.error]: !!props.errorMessage }) },
        React.createElement(Select, { mode: "single", onChange: handleChange, native: isMobile, dataTest: dataTest },
            props.errorMessage && !props.hint && (React.createElement(Select.Info, { container: props.containerRef }, props.errorMessage)),
            props.infoMessage && React.createElement(Select.Info, { container: props.containerRef }, props.infoMessage),
            React.createElement(Select.Button, { empty: !selectedText, size: size || 'l', label: label }, selectedText || defaultText),
            React.createElement(Select.Content, { height: 320, bounds: true, container: props.containerRef }, options.map(({ value, text }) => (React.createElement(Select.Option, { key: value, value: value, selected: is(value) }, text)))))));
};

const QueriesProvider = (props) => {
    return React.createElement(reactQuery.QueryClientProvider, { client: RQClient }, props.children);
};

const TOAST_CONTAINER_CONFIG = {
    limit: 4,
    newestOnTop: false,
    position: W.POSITION.BOTTOM_RIGHT,
    draggable: false,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    icon: false,
    closeButton: true,
    autoClose: 10000,
};
const TOAST_CONTAINER_CONFIG_CLASSIFIED = {
    limit: 4,
    newestOnTop: false,
    position: W.POSITION.BOTTOM_RIGHT,
    draggable: true,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: false,
    icon: false,
    closeButton: false,
    autoClose: 5000,
};

const useToastOnPage = () => {
    const [toasts, setToasts] = React.useState(new Set());
    React.useEffect(() => {
        const unsubscribe = W.onChange((payload) => {
            switch (payload.status) {
                case 'added':
                    setToasts((s) => new Set(s.add(payload.id)));
                    break;
                case 'removed':
                    setToasts((s) => {
                        if (s.has(payload.id))
                            s.delete(payload.id);
                        return new Set(s);
                    });
                    break;
            }
        });
        return unsubscribe;
    }, []);
    return toasts;
};

var css_248z$5 = ".icon-module_box__wkPIX{align-items:center;display:inline-flex;font-size:inherit;vertical-align:middle}.icon-module_box__wkPIX:before{content:\"\\a0\";display:inline-block;width:0}.icon-module_svg__Fsxd2{height:1em;position:relative;width:1em}";
var s = {"box":"icon-module_box__wkPIX","svg":"icon-module_svg__Fsxd2"};
styleInject(css_248z$5);

var meta = {
	"arrow-circle-16": "0 0 16 16",
	"arrow-circle-24": "0 0 16 16",
	"arrow-down-24": "0 0 24 24",
	"arrow-left-24": "0 0 24 24",
	"arrow-right-24": "0 0 24 24",
	"arrow-right-circle-24": "0 0 24 24",
	"arrow-thick-right-16": "0 0 16 16",
	"arrow-up-24": "0 0 24 24",
	"arrow-uturn-24": "0 0 24 24",
	"arrows-apart-16": "0 0 16 16",
	"arrows-expand-24": "0 0 24 24",
	"arrows-expand-40": "0 0 40 40",
	"arrows-left-right-24": "0 0 24 24",
	"arrows-round-24": "0 0 24 24",
	"arrows-squares-16": "0 0 16 16",
	"arrows-up-down-24": "0 0 24 24",
	"bars-horizontal-asc-16": "0 0 16 16",
	"bars-horizontal-asc-24": "0 0 24 24",
	"bars-horizontal-asc-arrow-16": "0 0 16 16",
	"bars-horizontal-asc-arrow-24": "0 0 24 24",
	"bars-horizontal-desc-16": "0 0 16 16",
	"bars-horizontal-desc-24": "0 0 24 24",
	"bars-horizontal-desc-arrow-16": "0 0 16 16",
	"bars-horizontal-desc-arrow-24": "0 0 24 24",
	"bars-horizontal-thick-24": "0 0 24 24",
	"bars-vertical-asc-arrow-16": "0 0 16 16",
	"bars-vertical-asc-arrow-24": "0 0 24 24",
	"bars-vertical-desc-arrow-16": "0 0 16 16",
	"bars-vertical-desc-arrow-24": "0 0 24 24",
	"bars-vertical-thick-24": "0 0 24 24",
	"bars-vertical-thick-32": "0 0 32 32",
	"bell-16": "0 0 16 16",
	"bell-24": "0 0 24 24",
	"bell-32": "0 0 32 32",
	"bell-crossed-24": "0 0 24 24",
	"blueprint-24": "0 0 24 24",
	"blueprint-40": "0 0 40 40",
	"blueprint-crossed-24": "0 0 24 24",
	"blueprint-crossed-40": "0 0 40 40",
	"book-24": "0 0 24 24",
	"bookmark-24": "0 0 24 24",
	"briefcase-16": "0 0 16 16",
	"building-16": "0 0 16 16",
	"bus-12": "0 0 12 12",
	"bus-16": "0 0 16 16",
	"calculator-16": "0 0 16 16",
	"calculator-24": "0 0 24 24",
	"calculator-32": "0 0 32 32",
	"calendar-24": "0 0 24 24",
	"calendar-32": "0 0 32 32",
	"camera-24": "0 0 24 24",
	"camera-40": "0 0 40 40",
	"camera-crossed-24": "0 0 24 24",
	"camera-crossed-40": "0 0 40 40",
	"car-12": "0 0 12 12",
	"car-16": "0 0 16 16",
	"card-24": "0 0 24 24",
	"card-32": "0 0 32 32",
	"check-16": "0 0 16 16",
	"check-24": "0 0 24 24",
	"check-32": "0 0 32 32",
	"check-circle-12": "0 0 12 12",
	"check-circle-16": "0 0 16 16",
	"check-circle-24": "0 0 24 24",
	"check-circle-32": "0 0 32 32",
	"chevron-double-down-24": "0 0 24 24",
	"chevron-double-left-24": "0 0 24 24",
	"chevron-double-right-24": "0 0 24 24",
	"chevron-double-up-24": "0 0 24 24",
	"chevron-down-12": "0 0 12 12",
	"chevron-down-16": "0 0 16 16",
	"chevron-down-24": "0 0 24 24",
	"chevron-down-circle-24": "0 0 24 24",
	"chevron-left-12": "0 0 12 12",
	"chevron-left-16": "0 0 16 16",
	"chevron-left-24": "0 0 24 24",
	"chevron-left-40": "0 0 40 40",
	"chevron-left-circle-24": "0 0 24 24",
	"chevron-right-12": "0 0 12 12",
	"chevron-right-16": "0 0 16 16",
	"chevron-right-24": "0 0 24 24",
	"chevron-right-40": "0 0 40 40",
	"chevron-right-circle-24": "0 0 24 24",
	"chevron-up-12": "0 0 12 12",
	"chevron-up-16": "0 0 16 16",
	"chevron-up-24": "0 0 24 24",
	"chevron-up-circle-24": "0 0 24 24",
	"circle-crossed-24": "0 0 24 24",
	"circle-crossed-32": "0 0 32 32",
	"clip-24": "0 0 24 24",
	"clip-32": "0 0 32 32",
	"clipboard-24": "0 0 24 24",
	"clipboard-32": "0 0 32 32",
	"clock-24": "0 0 24 24",
	"clock-arrowed-16": "0 0 16 16",
	"clock-arrowed-24": "0 0 24 24",
	"clock-arrowed-32": "0 0 32 32",
	"compass-circle-24": "0 0 24 24",
	"compass-circle-32": "0 0 32 32",
	"copy-24": "0 0 24 24",
	"crown-circle-16": "0 0 16 16",
	"crown-circle-24": "0 0 24 24",
	"custom-deal-16": "0 0 16 16",
	"custom-deal-24": "0 0 24 24",
	"dashed-frame-24": "0 0 24 24",
	"desktop-24": "0 0 24 24",
	"document-16": "0 0 16 16",
	"document-24": "0 0 24 24",
	"document-32": "0 0 32 32",
	"document-arrow-24": "0 0 24 24",
	"document-arrow-32": "0 0 32 32",
	"document-arrow-down-24": "0 0 24 24",
	"document-check-24": "0 0 24 24",
	"document-check-32": "0 0 32 32",
	"document-clock-24": "0 0 24 24",
	"document-clock-32": "0 0 32 32",
	"document-copy-24": "0 0 24 24",
	"document-copy-32": "0 0 32 32",
	"document-doc-24": "0 0 24 24",
	"document-empty-24": "0 0 24 24",
	"document-empty-32": "0 0 32 32",
	"document-jpg-24": "0 0 24 24",
	"document-lock-32": "0 0 32 32",
	"document-minus-24": "0 0 24 24",
	"document-minus-32": "0 0 32 32",
	"document-pdf-24": "0 0 24 24",
	"document-pdf-arrow-24": "0 0 24 24",
	"document-plus-24": "0 0 24 24",
	"document-plus-32": "0 0 32 32",
	"document-png-24": "0 0 24 24",
	"document-times-24": "0 0 24 24",
	"document-times-32": "0 0 32 32",
	"document-xls-24": "0 0 24 24",
	"document-zigzag-24": "0 0 24 24",
	"document-zigzag-32": "0 0 32 32",
	"door-in-24": "0 0 24 24",
	"door-out-16": "0 0 16 16",
	"door-out-24": "0 0 24 24",
	"dots-horizontal-16": "0 0 16 16",
	"dots-horizontal-24": "0 0 24 24",
	"dots-horizontal-32": "0 0 32 32",
	"download-24": "0 0 24 24",
	"envelope-24": "0 0 24 24",
	"envelope-32": "0 0 32 32",
	"excel-24": "0 0 24 24",
	"excel-32": "0 0 32 32",
	"exclamation-circle-16": "0 0 16 16",
	"exclamation-circle-24": "0 0 24 24",
	"exclamation-triangle-16": "0 0 16 16",
	"exclamation-triangle-24": "0 0 24 24",
	"exclamation-triangle-32": "0 0 32 32",
	"eye-16": "0 0 16 16",
	"eye-24": "0 0 24 24",
	"eye-crossed-24": "0 0 24 24",
	"facebook-16": "0 0 16 16",
	"facebook-24": "0 0 24 24",
	"finger-draw-24": "0 0 24 24",
	"folder-16": "0 0 16 16",
	"folder-24": "0 0 24 24",
	"folder-32": "0 0 32 32",
	"gear-24": "0 0 24 24",
	"globe-24": "0 0 24 24",
	"grid-24": "0 0 24 24",
	"heart-16": "0 0 16 16",
	"heart-24": "0 0 24 24",
	"heart-32": "0 0 32 32",
	"heart-hollow-16": "0 0 16 16",
	"heart-hollow-24": "0 0 24 24",
	"heart-hollow-32": "0 0 32 32",
	"helmet-16": "0 0 16 16",
	"house-24": "0 0 24 24",
	"house-checked-empty-24": "0 0 24 24",
	"house-copy-24": "0 0 24 24",
	"house-copy-32": "0 0 32 32",
	"house-heart-24": "0 0 24 24",
	"house-living-24": "0 0 24 24",
	"house-lock-16": "0 0 16 16",
	"house-lock-24": "0 0 24 24",
	"house-magnifier-24": "0 0 24 24",
	"house-one-24": "0 0 24 24",
	"house-persent-24": "0 0 24 24",
	"house-plus-24": "0 0 24 24",
	"image-24": "0 0 24 24",
	"in-construction-24": "0 0 24 24",
	"information-circle-16": "0 0 16 16",
	"information-circle-24": "0 0 24 24",
	"information-circle-32": "0 0 32 32",
	"instagram-16": "0 0 16 16",
	"instagram-24": "0 0 24 24",
	"key-16": "0 0 16 16",
	"key-32": "0 0 32 32",
	"layers-24": "0 0 24 24",
	"letter-range-asc-16": "0 0 16 16",
	"letter-range-asc-24": "0 0 24 24",
	"letter-range-desc-16": "0 0 16 16",
	"letter-range-desc-24": "0 0 24 24",
	"lightbulb-24": "0 0 24 24",
	"lightbulb-32": "0 0 32 32",
	"lightning-circle-16": "0 0 24 24",
	"lightning-circle-24": "0 0 24 24",
	"link-16": "0 0 16 16",
	"link-24": "0 0 24 24",
	"link-32": "0 0 32 32",
	"list-24": "0 0 24 24",
	"lock-closed-16": "0 0 16 16",
	"lock-closed-24": "0 0 24 24",
	"lock-closed-32": "0 0 32 32",
	"lock-opened-16": "0 0 16 16",
	"lock-opened-24": "0 0 24 24",
	"lock-opened-32": "0 0 32 32",
	"m2-bookmark-24": "0 0 24 24",
	"m2-bookmark-32": "0 0 32 32",
	"m2-bookmark-circle-24": "0 0 24 24",
	"m2-building-24": "0 0 24 24",
	"m2-building-multiple-24": "0 0 24 24",
	"m2-building-multiple-32": "0 0 32 32",
	"m2-building-wing-24": "0 0 24 24",
	"m2-calendar-24": "0 0 24 24",
	"m2-calendar-32": "0 0 32 32",
	"m2-chair-24": "0 0 24 24",
	"m2-chart-asc-24": "0 0 24 24",
	"m2-chat-24": "0 0 24 24",
	"m2-chat-32": "0 0 32 32",
	"m2-chat-notified-24": "0 0 24 24",
	"m2-chat-notified-32": "0 0 32 32",
	"m2-document-check-24": "0 0 24 24",
	"m2-document-pen-16": "0 0 16 16",
	"m2-document-pen-24": "0 0 24 24",
	"m2-document-pen-32": "0 0 32 32",
	"m2-folder-clip-16": "0 0 16 16",
	"m2-folder-clip-24": "0 0 24 24",
	"m2-folder-clip-32": "0 0 32 32",
	"m2-gear-24": "0 0 24 24",
	"m2-gear-32": "0 0 32 32",
	"m2-heart-24": "0 0 24 24",
	"m2-heart-32": "0 0 32 32",
	"m2-heart-circle-24": "0 0 24 24",
	"m2-house-checked-24": "0 0 25 24",
	"m2-house-checked-32": "0 0 32 32",
	"m2-house-stroked-24": "0 0 24 24",
	"m2-house-stroked-32": "0 0 32 32",
	"m2-houses-24": "0 0 24 24",
	"m2-houses-32": "0 0 32 32",
	"m2-lock-16": "0 0 16 16",
	"m2-lock-24": "0 0 24 24",
	"m2-lock-32": "0 0 32 32",
	"m2-magnifier-24": "0 0 24 24",
	"m2-magnifier-32": "0 0 32 32",
	"m2-note-pen-24": "0 0 24 24",
	"m2-note-pen-32": "0 0 32 32",
	"m2-paintroller-24": "0 0 24 24",
	"m2-paintroller-32": "0 0 32 32",
	"m2-percentage-circle-16": "0 0 16 16",
	"m2-percentage-circle-24": "0 0 24 24",
	"m2-percentage-circle-32": "0 0 32 32",
	"m2-person-16": "0 0 16 16",
	"m2-person-24": "0 0 24 24",
	"m2-person-32": "0 0 32 32",
	"m2-person-circle-24": "0 0 24 24",
	"m2-person-circle-32": "0 0 32 32",
	"m2-person-tie-16": "0 0 16 16",
	"m2-person-tie-24": "0 0 24 24",
	"m2-person-tie-32": "0 0 32 32",
	"m2-piechart-24": "0 0 24 24",
	"m2-piechart-32": "0 0 32 32",
	"m2-receipt-24": "0 0 24 24",
	"m2-squares-24": "0 0 24 24",
	"m2-squares-32": "0 0 32 32",
	"m2-squares-quad-24": "0 0 24 24",
	"m2-squares-quad-32": "0 0 32 32",
	"m2-star-16": "0 0 16 16",
	"m2-star-24": "0 0 24 24",
	"m2-star-32": "0 0 32 32",
	"m2-tags-percent-24": "0 0 24 24",
	"m2-tags-percent-32": "0 0 32 32",
	"m2-tree-24": "0 0 24 24",
	"m2-wallet-24": "0 0 24 24",
	"magnifier-16": "0 0 16 16",
	"magnifier-24": "0 0 24 24",
	"magnifier-32": "0 0 32 32",
	"magnifier-heart-24": "0 0 24 24",
	"magnifier-minus-24": "0 0 24 24",
	"magnifier-plus-24": "0 0 24 24",
	"magnifier-plus-32": "0 0 32 32",
	"map-16": "0 0 16 16",
	"map-24": "0 0 24 24",
	"map-32": "0 0 32 32",
	"megaphone-24": "0 0 24 24",
	"menu-24": "0 0 24 24",
	"message-16": "0 0 16 16",
	"message-24": "0 0 24 24",
	"message-32": "0 0 32 32",
	"microphone-16": "0 0 16 16",
	"microphone-24": "0 0 24 24",
	"microphone-32": "0 0 32 32",
	"minus-16": "0 0 16 16",
	"minus-24": "0 0 24 24",
	"minus-circle-16": "0 0 16 16",
	"minus-circle-24": "0 0 24 24",
	"notes-24": "0 0 24 24",
	"number-range-asc-16": "0 0 16 16",
	"number-range-asc-24": "0 0 24 24",
	"number-range-desc-16": "0 0 16 16",
	"number-range-desc-24": "0 0 24 24",
	"ok-24": "0 0 24 24",
	"panorama-24": "0 0 24 24",
	"panorama-32": "0 0 32 32",
	"pedestrian-12": "0 0 12 12",
	"pedestrian-16": "0 0 16 16",
	"pencil-16": "0 0 16 16",
	"pencil-24": "0 0 24 24",
	"pencil-32": "0 0 32 32",
	"person-16": "0 0 16 16",
	"person-circle-24": "0 0 24 24",
	"person-rounded-16": "0 0 16 16",
	"person-tie-circle-24": "0 0 24 24",
	"persons-24": "0 0 24 24",
	"phone-16": "0 0 16 16",
	"phone-24": "0 0 24 24",
	"phone-32": "0 0 32 32",
	"phone-circle-16": "0 0 16 16",
	"phone-circle-24": "0 0 24 24",
	"phone-circle-32": "0 0 32 32",
	"phone-eye-16": "0 0 16 16",
	"phone-incoming-24": "0 0 24 24",
	"piechart-24": "0 0 24 24",
	"piechart-32": "0 0 32 32",
	"placemark-16": "0 0 16 16",
	"placemark-24": "0 0 24 24",
	"placemark-32": "0 0 32 32",
	"plus-16": "0 0 16 16",
	"plus-24": "0 0 24 24",
	"plus-circle-16": "0 0 16 16",
	"plus-circle-24": "0 0 24 24",
	"plus-circle-32": "0 0 32 32",
	"power-switch-24": "0 0 24 24",
	"presentation-24": "0 0 24 24",
	"printer-24": "0 0 24 24",
	"question-24": "0 0 24 24",
	"question-circle-16": "0 0 16 16",
	"question-circle-24": "0 0 24 24",
	"rgr-16": "0 0 16 16",
	"rocket-16": "0 0 16 16",
	"rouble-24": "0 0 24 24",
	"rouble-32": "0 0 32 32",
	"ruler-24": "0 0 24 24",
	"safe-16": "0 0 16 16",
	"safe-24": "0 0 24 24",
	"safe-32": "0 0 32 32",
	"send-16": "0 0 16 16",
	"send-24": "0 0 24 24",
	"send-32": "0 0 32 32",
	"settings-16": "0 0 16 16",
	"settings-24": "0 0 24 24",
	"settings-32": "0 0 32 32",
	"share-16": "0 0 16 16",
	"share-24": "0 0 24 24",
	"share-32": "0 0 32 32",
	"shield-24": "0 0 24 24",
	"shield-check-24": "0 0 24 24",
	"shield-check-32": "0 0 32 32",
	"signal-24": "0 0 24 24",
	"smartphone-24": "0 0 24 24",
	"square-arrow-16": "0 0 16 16",
	"square-arrow-24": "0 0 24 24",
	"square-arrow-32": "0 0 32 32",
	"star-circle-24": "0 0 24 24",
	"tag-24": "0 0 24 24",
	"tag-32": "0 0 32 32",
	"target-24": "0 0 24 24",
	"telegram-16": "0 0 16 16",
	"telegram-24": "0 0 24 24",
	"thumb-up-24": "0 0 24 24",
	"timelapse-16": "0 0 16 16",
	"timelapse-24": "0 0 24 24",
	"times-16": "0 0 16 16",
	"times-24": "0 0 24 24",
	"times-32": "0 0 32 32",
	"times-circle-16": "0 0 16 16",
	"times-circle-24": "0 0 24 24",
	"times-circle-32": "0 0 32 32",
	"traffic-light-24": "0 0 24 24",
	"trashbin-16": "0 0 16 16",
	"trashbin-24": "0 0 24 24",
	"trashbin-32": "0 0 32 32",
	"triangle-arrow-16": "0 0 16 16",
	"triangle-arrow-24": "0 0 24 24",
	"triangle-arrow-32": "0 0 32 32",
	"triangle-down-16": "0 0 16 16",
	"triangle-up-16": "0 0 16 16",
	"twitter-24": "0 0 24 24",
	"undo-16": "0 0 16 16",
	"undo-24": "0 0 24 24",
	"undo-32": "0 0 32 32",
	"upload-24": "0 0 24 24",
	"video-24": "0 0 24 24",
	"vk-16": "0 0 16 16",
	"vk-24": "0 0 24 24",
	"whatsapp-24": "0 0 24 24"
};

// will be migrated to TS in [CMS-1704]
var aliases_1 = {
    close: 'times',
    cross: 'times',
};

const registry = meta;
const sizes = {
    xs: 12,
    s: 16,
    m: 24,
    l: 32,
    xl: 40,
};
const Icon = ({ name: externalName, size: externalSize = 'm', color }) => {
    const size = sizes[externalSize];
    const name = aliases_1[externalName] || externalName;
    const id = `${name}-${size}`;
    if (!registry[id]) {
        return null;
    }
    return (React.createElement("i", { className: s.box, style: Object.assign({ fontSize: `${size}px`, lineHeight: `${size}px` }, (color && { color })) },
        React.createElement("svg", { width: size, height: size, className: s.svg, viewBox: registry[id] },
            React.createElement("use", { xlinkHref: `#${id}` }))));
};

var css_248z$4 = ".styles-module_icon__5imRv{cursor:pointer;padding:10px;position:absolute;right:5px;top:10px}";
var styles$3 = {"icon":"styles-module_icon__5imRv"};
styleInject(css_248z$4);

const CloseButton = ({ closeToast }) => {
    return (React.createElement("div", { className: styles$3.icon, onClick: closeToast },
        React.createElement(Icon, { size: "s", name: "close", color: "#fff" })));
};

var css_248z$3 = "@keyframes styles-global_simple-animate-in-fwd__QwlXR{0%{opacity:0}to{opacity:1}}.styles-global_simple-animate-in-fwd__QwlXR{animation:styles-global_simple-animate-in-fwd__QwlXR .2s ease-out both}@keyframes styles-global_simple-animate-in-bck__uX0mc{0%{opacity:1}to{opacity:0}}.styles-global_simple-animate-in-bck__uX0mc{animation:styles-global_simple-animate-in-bck__uX0mc .2s ease-in both}";
styleInject(css_248z$3);

var css_248z$2 = ".styles-module_mobile__3VR7W{display:grid;grid-auto-rows:max-content;height:100vh;overflow:scroll}@media screen and (max-width:767px){.styles-module_multi__oKE5V{background:var(--c-overlay)}}.styles-module_Toastify__toast__hQHDR{padding:0}@media screen and (max-width:767px){.styles-module_Toastify__toast__hQHDR{background:transparent;margin-bottom:1rem;padding:0 var(--padding-m)}}.styles-module_Toastify__toast-body__PBDAM{background:#3216b5;padding:0}.styles-module_Toastify__toast-container__mFC-i{box-shadow:none!important;max-width:100%}@media screen and (max-width:767px){.styles-module_Toastify__toast-container__mFC-i{left:50%;top:52px;transform:translateX(-50%);width:100vw!important}}";
var styles$2 = {"mobile":"styles-module_mobile__3VR7W","multi":"styles-module_multi__oKE5V","Toastify__toast":"styles-module_Toastify__toast__hQHDR","Toastify__toast-body":"styles-module_Toastify__toast-body__PBDAM","Toastify__toast-container":"styles-module_Toastify__toast-container__mFC-i"};
styleInject(css_248z$2);

const ToastNotifications = React.memo(({ isClassified, containerId = 'm2-pro' }) => {
    const { isMobile } = useDeviceMediaType();
    const toasts = useToastOnPage();
    const limit = isMobile ? 0 : TOAST_CONTAINER_CONFIG['limit'];
    const isMulti = toasts.size > 1;
    const isMultiMobile = isMobile && isMulti;
    useDisableBodyScroll(isMultiMobile);
    return (React.createElement(React.Fragment, null,
        React.createElement(A, { ...(isClassified ? TOAST_CONTAINER_CONFIG_CLASSIFIED : TOAST_CONTAINER_CONFIG), limit: limit, enableMultiContainer: true, containerId: containerId, transition: B, className: cn({ [styles$2.mobile]: isMobile, [styles$2.multi]: isMulti }, styles$2['Toastify__toast-container']), bodyClassName: styles$2['Toastify__toast-body'], toastClassName: styles$2.Toastify__toast, closeButton: !isClassified && CloseButton }),
        isMultiMobile && React.createElement(CloseAllToastsButton, null)));
});

var css_248z$1 = ".styles-module_wrapper__ecx89{background:#3216b5;border-radius:4px;box-shadow:0 8px 32px rgba(34,31,46,.16);cursor:default;display:flex;flex-direction:column;justify-content:space-between;padding:16px;width:418px}@media screen and (max-width:1199px){.styles-module_wrapper__ecx89{padding:8px;width:auto}.styles-module_wrapper__ecx89 button{font:400 14px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif;padding:4px 16px}}.styles-module_block__kxE6Z{display:flex;justify-content:space-between;margin-bottom:16px}.styles-module_block__kxE6Z i{align-self:flex-start}@media screen and (max-width:1199px){.styles-module_block__kxE6Z{margin-bottom:8px}.styles-module_block__kxE6Z div[data-test=toast-header]{font:400 16px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}}.styles-module_textBlock__QMtvn{display:flex;flex-direction:column}.styles-module_textBlock__QMtvn div:first-of-type{margin-bottom:4px}@media screen and (max-width:1199px){.styles-module_textBlock__QMtvn>div[data-test=toast-body]{font:400 14px/24px ALS Hauss,Helvetica Neue,Tahoma,Arial,sans-serif}}.styles-module_icon__lQPA-{cursor:pointer}";
var styles$1 = {"wrapper":"styles-module_wrapper__ecx89","block":"styles-module_block__kxE6Z","textBlock":"styles-module_textBlock__QMtvn","icon":"styles-module_icon__lQPA-"};
styleInject(css_248z$1);

const nav = { basePath: '/m2-pro' };
const OrderCreatedSuccessNotify = ({ id, number }) => {
    return (React.createElement("div", { className: styles$1.wrapper },
        React.createElement("div", { className: styles$1.block },
            React.createElement("div", { className: styles$1.textBlock },
                React.createElement(Typography, { "data-test": 'toast-header', color: "white-500", variant: "h4" },
                    "\u0417\u0430\u044F\u0432\u043A\u0430 \u2116 ",
                    number,
                    " \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430"),
                React.createElement(Typography, { "data-test": 'toast-body', color: "white-500" }, "\u0421\u043B\u0435\u0434\u0438\u0442\u044C \u0437\u0430 \u0437\u0430\u044F\u0432\u043A\u0430\u043C\u0438 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u00AB\u0417\u0430\u044F\u0432\u043A\u0438\u00BB"))),
        React.createElement(ErrorBoundary, { fallback: React.createElement(Button$3, { href: `${nav.basePath}/orders/${id}`, fullWidth: true, variant: "primary-alt-bg", size: "s" }, "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0437\u0430\u044F\u0432\u043A\u0435") },
            React.createElement(RRLinkButton$1, { href: `${nav.basePath}/orders/${id}`, fullWidth: true, variant: "primary-alt-bg", size: "s" }, "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0437\u0430\u044F\u0432\u043A\u0435"))));
};

var css_248z = ".style-module_button__YZa-k{bottom:var(--padding-m);left:var(--padding-m);position:fixed;right:var(--padding-m);z-index:999999}";
var styles = {"button":"style-module_button__YZa-k"};
styleInject(css_248z);

const onClick = () => {
    W.dismiss();
};
const CloseAllToastsButton = () => {
    return (React.createElement("div", { className: styles.button },
        React.createElement(Button$3, { onClick: onClick, fullWidth: true, variant: "primary-alt-bg", size: "m" }, "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0432\u0441\u0435")));
};

const WidgetContext = React__namespace.createContext({
    openModal: () => void 0,
    changeLocalSelectedApartments: () => void 0,
});

const Action = ({ children, text, isDesktop, selectedApartments, gtmEvent }) => {
    const { openModal, changeLocalSelectedApartments, GTMPrefix } = React__namespace.useContext(WidgetContext);
    const handleOpenModal = React.useCallback(() => {
        pushToGTM(gtmEvent || GTMMap.CLIENTS.new_order(GTMPrefix));
        openModal();
    }, [GTMPrefix, gtmEvent, openModal]);
    const onClickAction = React.useCallback(() => {
        if (selectedApartments)
            changeLocalSelectedApartments(selectedApartments);
        handleOpenModal();
    }, [selectedApartments, changeLocalSelectedApartments, handleOpenModal]);
    if (text)
        return (React__namespace.createElement(Button$3, { onClick: handleOpenModal, size: isDesktop ? Size.Small : Size.Medium, dataTest: "m2pro-order-action-button", fullWidth: true }, text));
    return (React__namespace.createElement("div", { onClick: onClickAction, "data-test": "m2.pro order widget" }, children));
};

const M2ProModalOrderCreation = ({ children, withToasts = true, opened = false, onClose, profileId, selectedApartments, GTMPrefix, isForeignEnabled = true, toastType, isClassified, isSingleApartment, showOnboarding, }) => {
    const [isModalOpened, openModal, closeModal] = useModal(opened);
    const onCloseAction = React.useCallback((event) => {
        if (typeof onClose === 'function')
            onClose(event);
        closeModal();
    }, [onClose, closeModal]);
    const [localSelectedApartments, changeLocalSelectedApartments] = React.useState(selectedApartments);
    const Component = (React.createElement(React.Fragment, null,
        React.createElement(WidgetContext.Provider, { value: { openModal, changeLocalSelectedApartments, GTMPrefix } },
            children,
            profileId && (React.createElement(OrdersModal, { opened: isModalOpened, onClose: onCloseAction, profileId: profileId, isSingleApartment: isSingleApartment, selectedApartments: localSelectedApartments, GTMPrefix: GTMPrefix, isForeignEnabled: isForeignEnabled, toastType: toastType, showOnboarding: showOnboarding, isClassified: isClassified }))),
        withToasts && React.createElement(ToastNotifications, { isClassified: isClassified, containerId: CONTAINER_ID })));
    return React.createElement(QueriesProvider, null, Component);
};
M2ProModalOrderCreation.Action = Action;

const useM2ProOrderWidget = ({ selectedApartments, withToasts = true, opened = false, onClose, isSingleApartment, profileId, GTMPrefix, isForeignEnabled = true, toastType, isClassified, showOnboarding, }) => {
    const [isModalOpened, openModal, closeModal] = useModal(opened);
    const onCloseAction = React__namespace.useCallback((event) => {
        if (typeof onClose === 'function')
            onClose(event);
        closeModal();
    }, [onClose, closeModal]);
    const [localSelectedApartments, changeLocalSelectedApartments] = React__namespace.useState(selectedApartments);
    const Modal = React__namespace.useMemo(() => {
        const Component = profileId ? (React__namespace.createElement(OrdersModal, { opened: isModalOpened, onClose: onCloseAction, selectedApartments: localSelectedApartments, isSingleApartment: isSingleApartment, profileId: profileId, GTMPrefix: GTMPrefix, isForeignEnabled: isForeignEnabled, toastType: toastType, showOnboarding: showOnboarding })) : null;
        const OrderModalWithQueryProvider = (React__namespace.createElement(React__namespace.Fragment, null,
            React__namespace.createElement(WidgetContext.Provider, { value: { GTMPrefix, openModal, changeLocalSelectedApartments } },
                React__namespace.createElement(QueriesProvider, null, Component)),
            withToasts && React__namespace.createElement(ToastNotifications, { isClassified: isClassified, containerId: CONTAINER_ID })));
        return OrderModalWithQueryProvider;
    }, [
        isModalOpened,
        onCloseAction,
        localSelectedApartments,
        isSingleApartment,
        profileId,
        GTMPrefix,
        isForeignEnabled,
        toastType,
        showOnboarding,
        openModal,
        withToasts,
        isClassified,
    ]);
    return React__namespace.useMemo(() => ({
        Modal: Modal,
        openModal: openModal,
    }), [Modal, openModal]);
};

exports.AgreementCheckbox = AgreementCheckbox;
exports.ApartmentComplexSelect = ApartmentComplexSelect;
exports.CLIENTS_QUERY = CLIENTS_QUERY;
exports.CLIENTS_WITH_ORDERS_ORDERS_QUERY = CLIENTS_WITH_ORDERS_ORDERS_QUERY;
exports.ClientFields = ClientFields;
exports.CloseAllToastsButton = CloseAllToastsButton;
exports.CommentField = CommentField;
exports.DadataField = DadataField;
exports.DropdownControl = DropdownControl;
exports.ErrorTooltip = ErrorTooltip;
exports.FormInputField = FormInputField;
exports.GQ_ENDPOINT = GQ_ENDPOINT;
exports.GTMMap = GTMMap;
exports.JSON_FOREIGN_BUILDINGS_URL = JSON_FOREIGN_BUILDINGS_URL;
exports.M2ProModalOrderCreation = M2ProModalOrderCreation;
exports.OrderCreatedSuccessNotify = OrderCreatedSuccessNotify;
exports.OrdersModal = OrdersModal;
exports.PROFILE_QUERY = PROFILE_QUERY;
exports.RHFFileUploadField = RHFFileUploadField;
exports.RHFTextAreaField = RHFTextAreaField;
exports.SelectSingleField = SelectSingleField;
exports.SingleSelect = SingleSelect;
exports.ToastNotifications = ToastNotifications;
exports.UserSelect = UserSelect;
exports.checkIsForwardRef = checkIsForwardRef;
exports.clientSchema = clientSchema;
exports.clientService = client_service;
exports.commentSchema = commentSchema;
exports.confirmBookingSchema = confirmBookingSchema;
exports.documentsSchema = documentsSchema;
exports.fileService = file_service;
exports.fioSchema = fioSchema;
exports.fixationDeclineSchema = fixationDeclineSchema;
exports.fixationSchema = fixationSchema;
exports.getFio = getFio;
exports.getInputName = getInputName;
exports.mapApartments = mapApartments;
exports.mapClientDTOToValues = mapClientDTOToValues;
exports.mapClientValuesToDTO = mapClientValuesToDTO;
exports.middleBookingSchema = middleBookingSchema;
exports.middleDeclinePaymentSchema = middleDeclinePaymentSchema;
exports.middleEditPaymentSchema = middleEditPaymentSchema;
exports.middleSendPaymentSchema = middleSendPaymentSchema;
exports.orderSchema = orderSchema;
exports.orderService = orders_service;
exports.priceSchema = priceSchema;
exports.pushToGTM = pushToGTM;
exports.realtorSendPaymentSchema = realtorSendPaymentSchema;
exports.skipBookingSchema = skipBookingSchema;
exports.useApartments = useApartments;
exports.useClientsList = useClientsList;
exports.useDisableBodyScroll = useDisableBodyScroll;
exports.useGetForeignJsonBuildingByIdOrName = useGetForeignJsonBuildingByIdOrName;
exports.useGetJsonBuildingByIdOrName = useGetJsonBuildingByIdOrName;
exports.useInfinityQuery = useInfinityQuery;
exports.useJsonBuildings = useJsonBuildings;
exports.useM2ProOrderWidget = useM2ProOrderWidget;
